import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule, ViewEncapsulation, ChangeDetectionStrategy, HostListener, Directive, Pipe, Inject, Self, ElementRef, ViewChildren, ViewContainerRef, CUSTOM_ELEMENTS_SCHEMA, Optional } from '@angular/core';
import * as i1 from '@xpo-ltl-2.0/sdk-appmetadata';
import { PerformAppGlobalSearchPath, PerformAppGlobalSearchQuery, PnDSearchResult } from '@xpo-ltl-2.0/sdk-appmetadata';
import { map, switchMap, tap, takeUntil, take, filter, debounceTime, distinctUntilChanged, retryWhen, delay, mapTo, catchError, share, pluck, switchMapTo, scan, finalize, shareReplay, defaultIfEmpty, startWith, first as first$1, withLatestFrom, toArray, throttleTime, concatMap, exhaustMap, skip, skipWhile, mergeMap } from 'rxjs/operators';
import * as _ from 'lodash';
import { map as map$1, find, remove, size, forEach, get, findKey, endsWith, uniqBy, first, castArray, set, forOwn, isEqual, reduce, unset, isEmpty, hasIn, partialRight, toString, trim, cloneDeep, uniqWith, defaultTo, startCase, values, upperFirst, sortBy, sortedUniqBy, toUpper, filter as filter$1, isInteger, isString, isDate, isUndefined, padStart, has, split, indexOf, includes, padEnd, keyBy, isNull, slice, findIndex, concat as concat$1, nth, some, flatten, isObject, countBy, parseInt as parseInt$1 } from 'lodash';
import { Subject, of, BehaviorSubject, pipe, timer, Observable, ReplaySubject, AsyncSubject, forkJoin, combineLatest, from, throwError, concat, merge, fromEvent } from 'rxjs';
import * as i2 from '@xpo-ltl/ngx-ltl-core/popover';
import { XpoPopoverModule } from '@xpo-ltl/ngx-ltl-core/popover';
import * as i4 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i11 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i5 from '@angular/common';
import { CommonModule, CurrencyPipe, TitleCasePipe } from '@angular/common';
import * as i2$2 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, FormControl, FormArray, FormGroup, Validators, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i11$1 from '@angular/material/core';
import { MatNativeDateModule, ErrorStateMatcher, MatOptionModule } from '@angular/material/core';
import * as i21 from '@angular/material/input';
import { MatInputModule, MatInput } from '@angular/material/input';
import * as i1$7 from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import * as i4$1 from '@angular/cdk/drag-drop';
import { CdkDrag, DragDropModule } from '@angular/cdk/drag-drop';
import * as i2$1 from '@angular/cdk/overlay';
import * as i1$1 from '@angular/material/dialog';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as i3 from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import { CountryCd, DisputeTypeCd, GlobalSearchDetailCd, BillClassCd, MovementExceptionTypeCd, MovementStatusCd, ShipmentPnDStatusCd, ShipmentSpecialServiceCd, DeliveryQualifierCd, ChargeToCd, ExemptReasonCd, InvoiceTypeCd, ClaimInternalStatusCd, MiscLineItemPaymentMethodCd, DeliveryQualifierReasonCd, RefusedReasonCd, UndeliveredReasonCd, User, ShipmentDetailCd, DocumentFormTypeCd, BillStatusCd, FbdsVersionCd, PrintFBDSDocumentsTypeCd, CarrierDetailCd, XrtAttributeFilter, DeliveryInfoRequiredCd, HandlingUnit, HandlingUnitTypeCd, TripNodeStatusCd, AdvanceBeyondTypeCd, MatchedPartyTypeCd, PaymentStatusInternalCd, MiscLineItemCd, RouteTypeCd, RouteStatusCd, ZoneIndicatorCd, RouteCategoryCd, AppointmentStatusCd } from '@xpo-ltl/sdk-common';
import { parsePhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
import { SdkDmsModule } from '@xpo-ltl/sdk-dms';
import * as i2$4 from '@xpo-ltl/sdk-documentmanagement';
import { SearchDmsDocumentRqst, GetDocumentPath, SdkDocumentManagementModule } from '@xpo-ltl/sdk-documentmanagement';
import * as i4$3 from '@xpo-ltl/ngx-ltl-core/responsive-loading-spinner';
import { XpoResponsiveLoadingSpinnerModule } from '@xpo-ltl/ngx-ltl-core/responsive-loading-spinner';
import * as i4$2 from 'ng2-pdf-viewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import * as i6$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2$3 from '@xpo-ltl/config-manager';
import { ConfigManagerModule, CONFIG_MANAGER_SERVICE_CONFIGURATION } from '@xpo-ltl/config-manager';
import { encode, decode } from 'typescript-base64-arraybuffer';
import * as i3$1 from '@xpo-ltl/common-services';
import * as i6$3 from '@xpo-ltl/data-api';
import { ApiRequest, ErrorMessageParser } from '@xpo-ltl/data-api';
import * as i2$5 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import printJS from 'print-js';
import * as i6 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i7 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i4$4 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i13 from '@angular/material/autocomplete';
import { MatAutocomplete, MatAutocompleteTrigger, MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i9 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import moment$2 from 'moment';
import * as i1$2 from '@angular/platform-browser';
import * as i1$3 from '@xpo-ltl-2.0/sdk-location';
import { ListOperationalServiceCentersQuery, ListLocationsRqst, ListLocationsQuery, GetLocReferenceDetailsBySicPath, GetLocReferenceDetailsBySicQuery, ListLocationFeatureValuesByFeatureQuery, LocationReference, ServiceCenter, LocationAddress } from '@xpo-ltl-2.0/sdk-location';
import moment$3 from 'moment-timezone';
import * as i6$4 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i1$4 from 'ngx-clipboard';
import { detect } from 'detect-browser';
import * as i1$5 from '@angular/common/http';
import * as i4$6 from '@xpo-ltl-2.0/sdk-infrastructure';
import * as i3$2 from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { XpoSnackBarModule } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { __awaiter } from 'tslib';
import * as i2$6 from '@xpo-ltl-2.0/sdk-shipment';
import { GetShipmentQuery, CreateFBDSDocumentsRqst, PrintFBDSDocumentsRqst, GetShipmentResp, ListShipmentsRqst } from '@xpo-ltl-2.0/sdk-shipment';
import * as i5$1 from '@xpo-ltl/sdk-cityoperations';
import { DeliverySetPrint, StartPrintDocumentEnsembleRqst, PrintRequest, SearchUnpurgedShipmentsRqst, DeliveryShipmentSearchFilter, DeliveryHandlingUnit, DeliveryQualifierShipmentStatusChange, UpdatePnDDeliveryStatusForShipmentsRqst, UpdatePnDRouteStatusForShipmentsRqst, AssignShipmentsToRouteRqst, AssignShipmentsToRoutePath, CreateNewRouteRqst, Route, GeoArea } from '@xpo-ltl/sdk-cityoperations';
import { PDFDocument } from 'pdf-lib';
import * as i1$6 from '@xpo-ltl/sdk-userpreference';
import { UpsertUserPreferenceRqst, UpsertUserPreferenceQuery, GetUserPreferenceQuery } from '@xpo-ltl/sdk-userpreference';
import * as i7$1 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i2$7 from '@xpo-ltl/ngx-ltl-core/status-indicator';
import { XpoStatusIndicatorModule } from '@xpo-ltl/ngx-ltl-core/status-indicator';
import * as i4$5 from '@xpo-ltl/ngx-ltl-board';
import { XpoBoardDataSource, XpoBoardData, XpoStringFilterComponent, XpoAccordionGroupCellRendererComponent, XpoNumberFilterComponent, XpoBoardModule } from '@xpo-ltl/ngx-ltl-board';
import * as i5$2 from '@xpo-ltl/ngx-ltl-board-grid';
import { XpoAgGridBoardViewTemplate, XpoAgGridBoardModule } from '@xpo-ltl/ngx-ltl-board-grid';
import * as i11$2 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i13$1 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i7$2 from '@xpo-ltl/ngx-ltl-core/busy-loader';
import { XpoBusyLoaderModule } from '@xpo-ltl/ngx-ltl-core/busy-loader';
import * as i20 from '@xpo-ltl/ngx-ltl-core/chips';
import { XpoChipsModule } from '@xpo-ltl/ngx-ltl-core/chips';
import * as i16 from '@xpo-ltl/ngx-ltl-core/select';
import { XpoSelectModule } from '@xpo-ltl/ngx-ltl-core/select';
import * as i3$3 from '@xpo-ltl/ngx-ltl-core/empty-state';
import { XpoEmptyStateModule } from '@xpo-ltl/ngx-ltl-core/empty-state';
import * as i7$3 from '@angular/material/expansion';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import * as i20$1 from '@angular/cdk/scrolling';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTreeModule } from '@angular/material/tree';
import * as i1$8 from 'ag-grid-angular';
import { AgGridModule } from 'ag-grid-angular';
import { XpoBadgeModule } from '@xpo-ltl/ngx-ltl-core/badge';
import { XpoCheckboxModule } from '@xpo-ltl/ngx-ltl-core/checkbox';
import * as i5$3 from '@xpo-ltl/ngx-ltl-core/button';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import * as i11$3 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i7$4 from '@xpo-ltl/sdk-carriermanagement';
import { ListCarriersQuery, SdkCarrierManagementModule } from '@xpo-ltl/sdk-carriermanagement';
import * as i6$2 from '@xpo-ltl/ngx-ltl-core/special-service-indicators';
import { XpoSsiModule } from '@xpo-ltl/ngx-ltl-core/special-service-indicators';
import * as i4$7 from '@xpo-ltl/ngx-grid';
import { XpoNgxGridColumns, XpoGridCellEditor, XPO_GRID_SETTINGS, XpoGridCellRenderer, XpoNgxGridModule, XpoGridToolbarModule } from '@xpo-ltl/ngx-grid';
import * as i1$9 from '@xpo-ltl/ngx-ltl-core/card';
import { XpoCardModule } from '@xpo-ltl/ngx-ltl-core/card';
import * as i4$8 from '@xpo-ltl/ngx-ltl-core/confirm-dialog';
import { XpoConfirmDialogModule } from '@xpo-ltl/ngx-ltl-core/confirm-dialog';
import * as i1$a from '@xpo-ltl/sdk-infrastructure';
import * as i1$b from '@xpo-ltl/sdk-humanresource';
import { GetEmployeeDetailsByEmpIdPath, GetEmployeeDetailsByEmpIdQuery } from '@xpo-ltl/sdk-humanresource';
import * as i3$4 from '@xpo-ltl/sdk-pricing';
import { ListPricingAgreementDocHdrsQuery, GetPricingAgreementDocumentQuery, GetPricingAgreementDocumentPath } from '@xpo-ltl/sdk-pricing';
import * as i2$8 from '@xpo-ltl/sdk-accountsreceivable';
import { ListArPaymentSummaryByProQuery, ListArPaymentDetailsByProQuery } from '@xpo-ltl/sdk-accountsreceivable';
import * as i5$4 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import * as i3$5 from '@xpo-ltl/sdk-shipmentods';
import { ListOdsShipmentsRqst, ListOdsShipmentHistTraceEventsRqst, GetOdsShipmentQuery } from '@xpo-ltl/sdk-shipmentods';
import * as i6$5 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i2$9 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { XpoAgGridColumns } from '@xpo-ltl/ngx-ltl-grid';
import * as i1$c from '@xpo-ltl/sdk-dockoperations';
import { GetTrailerManifestPath, GetTrailerManifestQuery, DockOperationsApiService } from '@xpo-ltl/sdk-dockoperations';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i1$d from '@xpo-ltl/sdk-geolocation';
import { ListGeoPostalCodesByCityQuery } from '@xpo-ltl/sdk-geolocation';
import * as i1$e from '@xpo-ltl/sdk-location';
import { GetCustomerServiceCenterDetailsRqst } from '@xpo-ltl/sdk-location';
import * as i9$1 from '@xpo-ltl/ngx-ltl-core/tabs';
import { XpoTabsModule } from '@xpo-ltl/ngx-ltl-core/tabs';
import * as i2$a from '@angular/material/button-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

class XpoLtlAppSwitcherService {
    constructor(appMetadataApi) {
        this.appMetadataApi = appMetadataApi;
    }
    getAppList() {
        return this.appMetadataApi.listApplications().pipe(map((resp) => {
            return map$1(resp.applications, (app) => {
                const xpoApp = {};
                xpoApp.name = app.applName;
                xpoApp.url = app.url;
                return xpoApp;
            });
        }));
    }
}
XpoLtlAppSwitcherService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlAppSwitcherService, deps: [{ token: i1.AppMetadataApiService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlAppSwitcherService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlAppSwitcherService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlAppSwitcherService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.AppMetadataApiService }]; } });

/**
 * Automate completion of Subscriptions using takeUntil
 * Ex:
 * class SomeComponent: OnDestroy {
 *   private unsubscriber = new Unsubscriber();
 *
 *   contructor(private someService: SomeService) {
 *     this.someService.event$
 *        .pipe(
 *          // will unsubscribe when done$ is triggered
 *          takeUnitl(this.unsubscriber.done$)
 *        )
 *        .subscribe( () => console.log('EVENT!') )
 *   }
 *
 *   ngOnDestroy() {
 *     // triggers done$ to emit
 *     this.unsubscriber.complete();
 *   }
 * }
 *
 */
class Unsubscriber {
    constructor() {
        this._done = new Subject();
        /**
         * Emits when complete() is called.  Use this with takeUntil()
         * to automatically unsubscribe from Observables
         */
        this.done$ = this._done.asObservable();
    }
    /**
     * Emits when complete() is called.  Use this with takeUntil()
     * to automatically unsubscribe from Observables
     * @deprecated use done$ instead
     */
    get done() {
        return this._done;
    }
    /**
     * Trigger completion of the done$ Observable.  In general, this
     * should occur in the ngOnDestroy() Angular method, or whenever
     * the owner of the Unsubscriber is destroyed.
     */
    complete() {
        this._done.next();
        this._done.complete();
    }
}

class XpoLtlDateSelectorComponent {
    constructor() {
        this.position = 'below';
        this.color = 'primary';
        this.caretPosition = 'start';
        this.minDate = undefined;
        this.maxDate = undefined;
        this.selectedDateChange = new EventEmitter();
    }
    ngOnInit() { }
    onCalendarChanged(value) {
        if (value) {
            value.setSeconds(0, 0);
        }
        if (this.selectedDate !== value) {
            this.selectedDate = value;
            this.selectedDateChange.emit(value);
            this.popover.handleKeydown(Object.assign(Object.assign({}, new KeyboardEvent('')), { code: 'Escape', keyCode: 27 /* Escape */ }));
        }
    }
}
XpoLtlDateSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDateSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
XpoLtlDateSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlDateSelectorComponent, selector: "xpo-ltl-date-selector", inputs: { position: "position", color: "color", caretPosition: "caretPosition", minDate: "minDate", maxDate: "maxDate", selectedDate: "selectedDate" }, outputs: { selectedDateChange: "selectedDateChange" }, viewQueries: [{ propertyName: "popover", first: true, predicate: ["popover"], descendants: true }], ngImport: i0, template: "<div class=\"xpo-LtlDatePicker\">\n  <span>{{ selectedDate | date: 'M/d/yyyy' }}</span>\n  <mat-icon [xpoPopoverTriggerFor]=\"popover\">arrow_drop_down</mat-icon>\n\n  <xpo-popover #popover=\"xpoPopover\" [position]=\"position\" [color]=\"color\" [caretPosition]=\"caretPosition\">\n    <mat-calendar\n      [selected]=\"selectedDate\"\n      [minDate]=\"minDate\"\n      [maxDate]=\"maxDate\"\n      (selectedChange)=\"onCalendarChanged($event)\"\n    >\n    </mat-calendar>\n  </xpo-popover>\n</div>\n", styles: [".flex--stretch{flex:1}.xpo-LtlDatePicker{display:flex;font-size:1.143rem}.xpo-LtlDatePicker mat-icon{color:#0868ac}.xpo-LtlDatePicker mat-icon:active,.xpo-LtlDatePicker mat-icon:hover{cursor:pointer}"], components: [{ type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i2.XpoPopover, selector: "xpo-popover", inputs: ["backdropClass", "hideCloseButton", "position", "caretPosition", "color", "hasBackdrop", "class", "triggerOn"], outputs: ["closed", "mouseLeaveEmitter"], exportAs: ["xpoPopover"] }, { type: i11.MatCalendar, selector: "mat-calendar", inputs: ["startView", "startAt", "selected", "minDate", "maxDate", "headerComponent", "dateFilter", "dateClass", "comparisonStart", "comparisonEnd"], outputs: ["selectedChange", "yearSelected", "monthSelected", "viewChanged", "_userSelection"], exportAs: ["matCalendar"] }], directives: [{ type: i2.XpoPopoverTrigger, selector: "[xpoPopoverTriggerFor]", inputs: ["xpoPopoverTriggerFor", "xpoMenuTriggerData", "xpoPopoverDisabled"], outputs: ["menuOpened", "onMenuOpen", "menuClosed", "onMenuClose"], exportAs: ["xpoPopoverTrigger"] }], pipes: { "date": i5.DatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDateSelectorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-date-selector',
                    templateUrl: './date-selector.component.html',
                    styleUrls: ['./date-selector.component.scss'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { position: [{
                type: Input
            }], color: [{
                type: Input
            }], caretPosition: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], selectedDate: [{
                type: Input
            }], selectedDateChange: [{
                type: Output
            }], popover: [{
                type: ViewChild,
                args: ['popover']
            }] } });

class XpoLtlDateSelectorModule {
}
XpoLtlDateSelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDateSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlDateSelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDateSelectorModule, declarations: [XpoLtlDateSelectorComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatIconModule,
        MatDatepickerModule,
        MatNativeDateModule,
        XpoPopoverModule,
        XpoIconModule], exports: [XpoLtlDateSelectorComponent] });
XpoLtlDateSelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDateSelectorModule, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatInputModule,
            MatIconModule,
            MatDatepickerModule,
            MatNativeDateModule,
            XpoPopoverModule,
            XpoIconModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDateSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [XpoLtlDateSelectorComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatInputModule,
                        MatIconModule,
                        MatDatepickerModule,
                        MatNativeDateModule,
                        XpoPopoverModule,
                        XpoIconModule,
                    ],
                    exports: [XpoLtlDateSelectorComponent],
                }]
        }] });

class XpoLtlDialogTitleService {
    constructor(matDialog, overlayContainer) {
        this.matDialog = matDialog;
        this.overlayContainer = overlayContainer;
        this.dialogStack = [];
        this.matDialog.afterOpened.subscribe((newDialog) => {
            newDialog.afterOpened().subscribe(() => {
                // register this dialog with the stack after it is created
                this.addDialog(newDialog);
            });
        });
    }
    /**
     * Returns the overlay Element that contains the item with the passed targetId
     */
    findContainerWithId(targetId) {
        if (targetId) {
            const overlays = this.overlayContainer.getContainerElement().querySelectorAll('.cdk-global-overlay-wrapper');
            const targetOverlay = find(overlays, (overlay) => !!overlay.querySelector(`#${targetId}`));
            return targetOverlay;
        }
        else {
            return undefined;
        }
    }
    /**
     * Add the dialog to the stack of focusable dialogs
     * @param dialog dialog to add
     */
    addDialog(dialog) {
        if (dialog) {
            const container = this.findContainerWithId(dialog.id);
            const dialogInfo = { dialog, container };
            this.dialogStack.push(dialogInfo);
            this.updateLayers();
            dialog.beforeClosed().subscribe(() => {
                // remove the dialog from the stack when it is closed
                this.removeDialog(dialog.id);
            });
            dialog.keydownEvents().subscribe((keyEvent) => {
                if (keyEvent.code === 'Escape') {
                    // close the currently focused dialog
                    const dialogToClose = this.dialogStack.pop();
                    dialogToClose.dialog.close();
                }
            });
        }
    }
    /**
     * Remove the specified dialog from the stack and rebuild layers
     * @param dialogId id of the dialog to remove
     */
    removeDialog(dialogId) {
        remove(this.dialogStack, (dialogInfo) => dialogInfo.dialog.id === dialogId);
        this.updateLayers();
    }
    /**
     * Set the specified dialog as focused and bring to the top of the stack
     * @param dialogId id of dialog to set as focused
     */
    focusDialog(dialogId) {
        if (size(dialogId) > 0) {
            const focused = remove(this.dialogStack, (dialogInfo) => !!dialogInfo.container.querySelector(`#${dialogId}`));
            if (size(focused)) {
                this.dialogStack.push(focused[0]);
                this.updateLayers();
            }
        }
    }
    /**
     * Update the layers so that the focused dialog is on top of all others
     */
    updateLayers() {
        const baseZ = 2000;
        forEach(this.dialogStack, (di, index) => {
            di.container.classList.remove('xpo-ltlDialogFocused');
            di.container['style'].zIndex = `${baseZ + index} !important`;
            if (index === size(this.dialogStack) - 1) {
                di.container.classList.add('xpo-ltlDialogFocused');
            }
        });
    }
}
XpoLtlDialogTitleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDialogTitleService, deps: [{ token: i1$1.MatDialog }, { token: i2$1.OverlayContainer }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlDialogTitleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDialogTitleService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDialogTitleService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: i2$1.OverlayContainer }]; } });

/**
 * Implement Dialog title that allows dragging the dialog within the container, and
 * bringing the selected dialog to the front of other dialogs.
 */
class XpoLtlDialogTitleComponent {
    constructor(xpoLtlDialogTitleService) {
        this.xpoLtlDialogTitleService = xpoLtlDialogTitleService;
        this.defaultOptions = {
            closeButton: true,
            dragRootElement: '.cdk-overlay-pane',
            dragBoundaryElement: '.cdk-overlay-container',
            headerClass: '',
            raiseOnClick: true,
            moveable: true,
        };
    }
    handleMouseDown(event) {
        if (this.options.raiseOnClick) {
            this.xpoLtlDialogTitleService.focusDialog(get(event.target, 'id'));
        }
    }
    ngOnInit() {
        this.options = Object.assign(Object.assign({}, this.defaultOptions), this.options);
    }
    setFreeDragPosition(freeDragPosition) {
        var _a, _b;
        (_b = (_a = this.cdkDrag) === null || _a === void 0 ? void 0 : _a._dragRef) === null || _b === void 0 ? void 0 : _b.setFreeDragPosition(freeDragPosition);
    }
    getFreeDragPosition() {
        var _a, _b;
        return (_b = (_a = this.cdkDrag) === null || _a === void 0 ? void 0 : _a._dragRef) === null || _b === void 0 ? void 0 : _b.getFreeDragPosition();
    }
    dragReset() {
        var _a, _b;
        (_b = (_a = this.cdkDrag) === null || _a === void 0 ? void 0 : _a._dragRef) === null || _b === void 0 ? void 0 : _b.reset();
    }
}
XpoLtlDialogTitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDialogTitleComponent, deps: [{ token: XpoLtlDialogTitleService }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlDialogTitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlDialogTitleComponent, selector: "xpo-ltl-dialog-title", inputs: { options: "options" }, host: { listeners: { "mousedown": "handleMouseDown($event)" } }, viewQueries: [{ propertyName: "cdkDrag", first: true, predicate: CdkDrag, descendants: true }], ngImport: i0, template: "<h1\n  mat-dialog-title\n  cdkDrag\n  [cdkDragRootElement]=\"options.dragRootElement\"\n  [cdkDragBoundary]=\"options.dragBoundaryElement\"\n  cdkDragHandle\n  [cdkDragDisabled]=\"!options.moveable\"\n  [class.moveable]=\"!!options.moveable\"\n  [class]=\"options.headerClass\"\n>\n  <ng-content></ng-content>\n  <xpo-dialog-close-button *ngIf=\"options.closeButton\"></xpo-dialog-close-button>\n</h1>\n", styles: [".flex--stretch{flex:1}.xpo-ltlDialogTitle,xpo-ltl-dialog-title{width:100%}.xpo-ltlDialogTitle__header-container{display:flex;flex:1 1 auto;width:100%}.xpo-ltlDialogTitle.moveable.cdk-drag-handle{cursor:move}.xpo-ltlDialogFocused mat-dialog-container.mat-dialog-container{border:1px solid #000}"], components: [{ type: i3.XpoDialogCloseButtonComponent, selector: "xpo-dialog-close-button" }], directives: [{ type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i4$1.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragDisabled", "cdkDragStartDelay", "cdkDragLockAxis", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragBoundary", "cdkDragRootElement", "cdkDragPreviewContainer", "cdkDragData", "cdkDragFreeDragPosition"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: i4$1.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDialogTitleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-dialog-title',
                    templateUrl: './dialog-title.component.html',
                    styleUrls: ['./dialog-title.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlDialogTitleService }]; }, propDecorators: { cdkDrag: [{
                type: ViewChild,
                args: [CdkDrag]
            }], options: [{
                type: Input
            }], handleMouseDown: [{
                type: HostListener,
                args: ['mousedown', ['$event']]
            }] } });

const components$3 = [XpoLtlDialogTitleComponent];
class XpoLtlDialogTitleModule {
}
XpoLtlDialogTitleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDialogTitleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlDialogTitleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDialogTitleModule, declarations: [XpoLtlDialogTitleComponent], imports: [CommonModule, MatDialogModule, XpoDialogModule, DragDropModule], exports: [XpoLtlDialogTitleComponent] });
XpoLtlDialogTitleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDialogTitleModule, imports: [[CommonModule, MatDialogModule, XpoDialogModule, DragDropModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDialogTitleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...components$3],
                    exports: [...components$3],
                    imports: [CommonModule, MatDialogModule, XpoDialogModule, DragDropModule],
                }]
        }] });

var XpoEventKeyCode;
(function (XpoEventKeyCode) {
    XpoEventKeyCode[XpoEventKeyCode["Delete"] = 46] = "Delete";
    XpoEventKeyCode[XpoEventKeyCode["DeleteSafari"] = 63272] = "DeleteSafari";
    XpoEventKeyCode[XpoEventKeyCode["Backspace"] = 8] = "Backspace";
    XpoEventKeyCode[XpoEventKeyCode["Control"] = 17] = "Control";
    XpoEventKeyCode[XpoEventKeyCode["C"] = 67] = "C";
    XpoEventKeyCode[XpoEventKeyCode["S"] = 83] = "S";
    XpoEventKeyCode[XpoEventKeyCode["V"] = 86] = "V";
    XpoEventKeyCode[XpoEventKeyCode["Zero"] = 48] = "Zero";
    XpoEventKeyCode[XpoEventKeyCode["Nine"] = 57] = "Nine";
    XpoEventKeyCode[XpoEventKeyCode["Minus"] = 189] = "Minus";
    XpoEventKeyCode[XpoEventKeyCode["Subtract"] = 109] = "Subtract";
    XpoEventKeyCode[XpoEventKeyCode["Enter"] = 13] = "Enter";
    XpoEventKeyCode[XpoEventKeyCode["Tab"] = 9] = "Tab";
    XpoEventKeyCode[XpoEventKeyCode["LeftArrow"] = 37] = "LeftArrow";
    XpoEventKeyCode[XpoEventKeyCode["RightArrow"] = 39] = "RightArrow";
    XpoEventKeyCode[XpoEventKeyCode["Alt"] = 18] = "Alt";
})(XpoEventKeyCode || (XpoEventKeyCode = {}));

var XpoLtlValidationRegexPatterns;
(function (XpoLtlValidationRegexPatterns) {
    XpoLtlValidationRegexPatterns["tractorPattern"] = "^[0-9]{3}[-]{1}[0-9]{1,7}$";
    XpoLtlValidationRegexPatterns["numberTrailerPattern"] = "^[0-9]{3}[-]{1}[0-9]{1,7}$";
    XpoLtlValidationRegexPatterns["letterTrailerPattern"] = "^[a-zA-Z]{1,4}[-]{1}[0-9]{0,6}$";
    XpoLtlValidationRegexPatterns["claimNumber"] = "^CC\\d{7}$";
    XpoLtlValidationRegexPatterns["disputePattern"] = "^^(DS\\d{1,6}|DSP\\d{7})$";
    XpoLtlValidationRegexPatterns["numberCheck"] = "^[0-9]+$";
    XpoLtlValidationRegexPatterns["validProCharacterCheck"] = "^[\\d\\-]+$";
    XpoLtlValidationRegexPatterns["doorPattern"] = "^[0-9]{1,4}$";
    XpoLtlValidationRegexPatterns["nineDigitPro"] = "^[0-9]{9}$";
    XpoLtlValidationRegexPatterns["tenDigitPro"] = "^[0-9]{3}[-][0-9]{6}$";
    XpoLtlValidationRegexPatterns["elevenDigitPro"] = "^[0][0-9]{3}[0][0-9]{6}$";
    XpoLtlValidationRegexPatterns["emailValidationPattern"] = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$";
    XpoLtlValidationRegexPatterns["phoneNumberPattern"] = "^\\(?([0-9]{0,3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$";
    XpoLtlValidationRegexPatterns["multiEmailsPattern"] = "^(\\s*,?\\s*[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\\w]*[0-9a-zA-Z]\\.)+[a-zA-Z]{2,9})+\\s*$";
    XpoLtlValidationRegexPatterns["usZipCode"] = "^(\\d{5}-\\d{4}|\\d{5}|\\d{9})$";
    XpoLtlValidationRegexPatterns["caPostalCode"] = "^([a-zA-Z]\\d[a-zA-Z]( )?\\d[a-zA-Z]\\d)$";
    XpoLtlValidationRegexPatterns["mxPostalCode"] = "^\\d{5}$";
    XpoLtlValidationRegexPatterns["madCodeValidationPattern"] = "^[A-Za-z]{3}[A-Za-z\\s]{2}([A-Za-z]{3}|[0-9]{3})[0-9]{3}$";
    XpoLtlValidationRegexPatterns["billToMadCodeValidationPattern"] = "^[A-Za-z]{3}[A-Za-z\\s]{2}(991)[0-9]{3}$";
    XpoLtlValidationRegexPatterns["sicValidationPattern"] = "^[A-Za-z]{3}$";
    XpoLtlValidationRegexPatterns["nmfcValidationPattern"] = "^[0-9]{4,6}?(-[0-9]{1,2})?$";
    XpoLtlValidationRegexPatterns["callNumber"] = "^([0]?[1-9]|[12]\\d|3[01])[-][0-9]{1,4}$";
    XpoLtlValidationRegexPatterns["validCallNumber"] = "^[A-Z]{3}[-]([0]?[1-9]|[12]\\d|3[01])[-][0-9]{3}$";
    XpoLtlValidationRegexPatterns["routeName"] = "^[0-9a-zA-Z]{1,5}[-][0-9a-zA-Z]{1,5}$";
    XpoLtlValidationRegexPatterns["tractorInputValidatorPattern"] = "^[0-9-]$";
    XpoLtlValidationRegexPatterns["trailerInputValidatorPattern"] = "^[0-9a-zA-Z-]$";
    XpoLtlValidationRegexPatterns["dollyInputValidatorPattern"] = "^[0-9-]$";
    XpoLtlValidationRegexPatterns["loadReleaseNumberInputValidatorPattern"] = "^[0-9]$";
    XpoLtlValidationRegexPatterns["dateInputValidatorPattern"] = "^[0-9/]$";
    XpoLtlValidationRegexPatterns["timeInputValidatorPattern"] = "^[0-9:]$";
})(XpoLtlValidationRegexPatterns || (XpoLtlValidationRegexPatterns = {}));

var YesNoEnum;
(function (YesNoEnum) {
    YesNoEnum["Yes"] = "Yes";
    YesNoEnum["No"] = "No";
})(YesNoEnum || (YesNoEnum = {}));

class XpoAllowCharactersDirective {
    constructor() {
        // Key values taken from: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
        this.navigationKeys = [
            'ArrowDown',
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'End',
            'Home',
            'PageDown',
            'PageUp',
            'Up',
            'Down',
            'Right',
            'Left',
        ];
        this.editingKeys = [
            'Backspace',
            'Clear',
            'Copy',
            'CrSel',
            'Cut',
            'Delete',
            'EraseEof',
            'ExSel',
            'Insert',
            'Paste',
            'Redo',
            'Undo',
            'Del',
        ];
        this.whiteSpaceKeys = ['Enter', 'Tab'];
        this.modifierKeys = [
            'Alt',
            'AltGraph',
            'CapsLock',
            'Control',
            'Fn',
            'FnLock',
            'Hyper',
            'Meta',
            'ScrollLock',
            'Shift',
            'Super',
            'Symbol',
            'SymbolLock',
            'OS',
            'Scroll',
        ];
        this.functionKeys = ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12'];
    }
    handleClickEvent(event) {
        const keyCode = event.which || event.charCode || event.keyCode;
        if (event.key && this.isSpecialKey(event)) {
            return true;
        }
        if (keyCode === XpoEventKeyCode.V && !!event.ctrlKey) {
            return true;
        }
        return this.xpoAllowCharacters instanceof RegExp
            ? this.xpoAllowCharacters.test(event.key)
            : this.xpoAllowCharacters.indexOf(event.key) >= 0;
    }
    handlePasteEvent(event) {
        const data = event.clipboardData.getData('text');
        let shouldPaste = true;
        if (this.xpoAllowCharacters instanceof RegExp) {
            data.split('').forEach((char) => {
                if (shouldPaste && !this.xpoAllowCharacters.test(char)) {
                    shouldPaste = false;
                }
            });
        }
        else {
            this.xpoAllowCharacters.split('').forEach((char) => {
                if (shouldPaste && data.indexOf(char) >= 0) {
                    shouldPaste = false;
                }
            });
        }
        if (!shouldPaste) {
            event.preventDefault();
        }
        return shouldPaste;
    }
    isSpecialKey(keyboardEvent) {
        return (this.navigationKeys.some((item) => item.toUpperCase() === keyboardEvent.key.toUpperCase()) ||
            this.editingKeys.some((item) => item.toUpperCase() === keyboardEvent.key.toUpperCase()) ||
            this.whiteSpaceKeys.some((item) => item.toUpperCase() === keyboardEvent.key.toUpperCase()) ||
            this.modifierKeys.some((item) => item.toUpperCase() === keyboardEvent.key.toUpperCase()) ||
            this.functionKeys.some((item) => item.toUpperCase() === keyboardEvent.key.toUpperCase()));
    }
}
XpoAllowCharactersDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoAllowCharactersDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
XpoAllowCharactersDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: XpoAllowCharactersDirective, selector: "[xpo-allow-characters]", inputs: { xpoAllowCharacters: ["xpo-allow-characters", "xpoAllowCharacters"] }, host: { listeners: { "keydown": "handleClickEvent($event)", "paste": "handlePasteEvent($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoAllowCharactersDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[xpo-allow-characters]',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { xpoAllowCharacters: [{
                type: Input,
                args: ['xpo-allow-characters']
            }], handleClickEvent: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], handlePasteEvent: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }] } });

const directives$4 = [XpoAllowCharactersDirective];
class XpoAllowCharactersModule {
}
XpoAllowCharactersModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoAllowCharactersModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoAllowCharactersModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoAllowCharactersModule, declarations: [XpoAllowCharactersDirective], imports: [CommonModule], exports: [XpoAllowCharactersDirective] });
XpoAllowCharactersModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoAllowCharactersModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoAllowCharactersModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: directives$4,
                    exports: directives$4,
                }]
        }] });

class XpoMaxNumberLengthDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    onPaste($event) {
        const data = $event.clipboardData.getData('text');
        if ((data && data.length > this.xpoMaxLength) ||
            data.length + this.elementRef.nativeElement.value.length > this.xpoMaxLength) {
            return false;
        }
    }
    onKeyPress($event) {
        if ($event.target.value && $event.target.value.length >= this.xpoMaxLength) {
            return false;
        }
    }
}
XpoMaxNumberLengthDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoMaxNumberLengthDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
XpoMaxNumberLengthDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: XpoMaxNumberLengthDirective, selector: "[xpo-max-number-length]", inputs: { xpoMaxLength: ["xpo-max-number-length", "xpoMaxLength"] }, host: { listeners: { "paste": "onPaste($event)", "keypress": "onKeyPress($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoMaxNumberLengthDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[xpo-max-number-length]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { xpoMaxLength: [{
                type: Input,
                args: ['xpo-max-number-length']
            }], onPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }], onKeyPress: [{
                type: HostListener,
                args: ['keypress', ['$event']]
            }] } });

const directives$3 = [XpoMaxNumberLengthDirective];
class XpoMaxNumberLengthModule {
}
XpoMaxNumberLengthModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoMaxNumberLengthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoMaxNumberLengthModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoMaxNumberLengthModule, declarations: [XpoMaxNumberLengthDirective], imports: [CommonModule], exports: [XpoMaxNumberLengthDirective] });
XpoMaxNumberLengthModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoMaxNumberLengthModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoMaxNumberLengthModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: directives$3,
                    exports: directives$3,
                }]
        }] });

class XpoPreventCharactersDirective {
    constructor() { }
    handleClickEvent(event) {
        return !this.xpoPreventCharacters.some((char) => char === event.key);
    }
}
XpoPreventCharactersDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoPreventCharactersDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
XpoPreventCharactersDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: XpoPreventCharactersDirective, selector: "[xpo-prevent-characters]", inputs: { xpoPreventCharacters: ["xpo-prevent-characters", "xpoPreventCharacters"] }, host: { listeners: { "keydown": "handleClickEvent($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoPreventCharactersDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[xpo-prevent-characters]',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { xpoPreventCharacters: [{
                type: Input,
                args: ['xpo-prevent-characters']
            }], handleClickEvent: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

const directives$2 = [XpoPreventCharactersDirective];
class XpoPreventCharactersModule {
}
XpoPreventCharactersModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoPreventCharactersModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoPreventCharactersModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoPreventCharactersModule, declarations: [XpoPreventCharactersDirective], imports: [CommonModule], exports: [XpoPreventCharactersDirective] });
XpoPreventCharactersModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoPreventCharactersModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoPreventCharactersModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: directives$2,
                    exports: directives$2,
                }]
        }] });

/**
 * Force input to be Uppercase
 */
class XpoUppercaseDirective {
    constructor(ref) {
        this.ref = ref;
    }
    ngOnInit() {
        this.ref.nativeElement.value = this.ref.nativeElement.value ? this.ref.nativeElement.value.toUpperCase() : '';
    }
    onInput(event) {
        this.ref.nativeElement.value = event.target.value.toUpperCase();
    }
}
XpoUppercaseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoUppercaseDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
XpoUppercaseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: XpoUppercaseDirective, selector: "[xpo-uppercase]", host: { listeners: { "input": "onInput($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoUppercaseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[xpo-uppercase]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { onInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }] } });

const directives$1 = [XpoUppercaseDirective];
class XpoUppercaseModule {
}
XpoUppercaseModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoUppercaseModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoUppercaseModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoUppercaseModule, declarations: [XpoUppercaseDirective], imports: [CommonModule], exports: [XpoUppercaseDirective] });
XpoUppercaseModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoUppercaseModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoUppercaseModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: directives$1,
                    exports: directives$1,
                }]
        }] });

const CountryCdMap = {
    [CountryCd.CANADA]: 'CA',
    [CountryCd.UNITED_STATES]: 'US',
    [CountryCd.MEXICO]: 'MX',
};
class PhoneFormatterDirective {
    constructor(ngControl) {
        this.ngControl = ngControl;
        this.countryCode = CountryCd.UNITED_STATES;
    }
    ngOnInit() {
        var _a, _b;
        const initialValue = (_b = (_a = this.ngControl) === null || _a === void 0 ? void 0 : _a.control) === null || _b === void 0 ? void 0 : _b.value;
        if (initialValue) {
            this.parsePhoneNbr(initialValue);
        }
    }
    onModelChange(event) {
        this.parsePhoneNbr(event);
    }
    parsePhoneNbr(value) {
        const countryShortCd = this.getCountryCd();
        if (countryShortCd &&
            value &&
            this.replaceNonDigitChars(value).length >= 3 &&
            this.replaceNonDigitChars(value).length <= 15) {
            const number = parsePhoneNumber(value, countryShortCd);
            if (number && number.country !== countryShortCd) {
                this.parsePhoneNbr(number.nationalNumber);
                return;
            }
            if (number && number.nationalNumber !== this.previousValue) {
                this.previousValue = number.nationalNumber;
                const input = number.nationalNumber;
                this.ngControl.control.setValue(input, { emitEvent: true });
            }
        }
    }
    getCountryCd() {
        const countrycd = CountryCdMap[this.countryCode];
        return countrycd;
    }
    /**
     * Replace non-dig characters in the entered string
     */
    replaceNonDigitChars(input) {
        return input.replace(/\D/g, '');
    }
}
PhoneFormatterDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PhoneFormatterDirective, deps: [{ token: i2$2.NgControl }], target: i0.ɵɵFactoryTarget.Directive });
PhoneFormatterDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: PhoneFormatterDirective, selector: "[libPhoneFormatter]", inputs: { countryCode: "countryCode" }, host: { listeners: { "ngModelChange": "onModelChange($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PhoneFormatterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[libPhoneFormatter]',
                }]
        }], ctorParameters: function () { return [{ type: i2$2.NgControl }]; }, propDecorators: { countryCode: [{
                type: Input,
                args: ['countryCode']
            }], onModelChange: [{
                type: HostListener,
                args: ['ngModelChange', ['$event']]
            }] } });

const directives = [PhoneFormatterDirective];
class XpoPhoneFormatterModule {
}
XpoPhoneFormatterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoPhoneFormatterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoPhoneFormatterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoPhoneFormatterModule, declarations: [PhoneFormatterDirective], imports: [CommonModule], exports: [PhoneFormatterDirective] });
XpoPhoneFormatterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoPhoneFormatterModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoPhoneFormatterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: directives,
                    exports: directives,
                }]
        }] });

var XpoLtlDocType;
(function (XpoLtlDocType) {
    XpoLtlDocType["ActivityLogHistory"] = "ACTL";
    XpoLtlDocType["All"] = "ALL";
    XpoLtlDocType["BillOfLading"] = "BL";
    XpoLtlDocType["BillOfLadingAttachment"] = "BLAT";
    XpoLtlDocType["CheckSheet"] = "CHKS";
    XpoLtlDocType["ClaimForm"] = "CLM";
    XpoLtlDocType["ClaimNotes"] = "CLMN";
    XpoLtlDocType["ClaimsAttachment"] = "CLAT";
    XpoLtlDocType["ClaimsProductionUnknown"] = "PXFC";
    XpoLtlDocType["ClosedClaimFolder"] = "CLMH";
    XpoLtlDocType["CrossDockExceptionPhotos"] = "DXCF";
    XpoLtlDocType["CustomerUpload"] = "CUPD";
    XpoLtlDocType["CustomsDocuments"] = "CUST";
    XpoLtlDocType["DeliveryExceptionPhoto"] = "DXFO";
    XpoLtlDocType["DeliveryReceipt"] = "DR";
    XpoLtlDocType["DeliveryReceiptAttachment"] = "DRAT";
    XpoLtlDocType["DeliveryReturnReceipt"] = "DRRR";
    XpoLtlDocType["FlySheet"] = "FLYS";
    XpoLtlDocType["InMotionDimensionerPhoto"] = "DMNR";
    XpoLtlDocType["InspectionReport"] = "IR";
    XpoLtlDocType["InspectionReportPhoto"] = "IRFO";
    XpoLtlDocType["InvoicePdf"] = "ARIN";
    XpoLtlDocType["LetterOfAuthority"] = "LOA";
    XpoLtlDocType["MatchMailAcknowledgement"] = "MMAK";
    XpoLtlDocType["PickupPhotos"] = "PUFO";
    XpoLtlDocType["NmfcClassInspectionCertificate"] = "NCIC";
    XpoLtlDocType["OSDPhoto"] = "OSDF";
    XpoLtlDocType["PoorlyPackagedOnDock"] = "DXPP";
    XpoLtlDocType["PoorlyPackagedPickUp"] = "PPPP";
    XpoLtlDocType["TrailerPhotoClose"] = "TLFO";
    XpoLtlDocType["TrailerPhotoOpen"] = "TOFO";
    XpoLtlDocType["TrailerPhotoProgressive"] = "TPFO";
    XpoLtlDocType["WeightAndResearchPhotos"] = "WRFO";
    XpoLtlDocType["WeightInspectionCertificate"] = "WI";
    XpoLtlDocType["MobileDimensionerPhoto"] = "PDFO";
})(XpoLtlDocType || (XpoLtlDocType = {}));

class XpoLtlDocTypePipe {
    transform(value, args) {
        let convertedValue = '';
        switch (value) {
            case XpoLtlDocType.ActivityLogHistory:
                convertedValue = 'Activity Log History';
                break;
            case XpoLtlDocType.BillOfLading:
                convertedValue = 'Bill of Lading';
                break;
            case XpoLtlDocType.BillOfLadingAttachment:
                convertedValue = 'Bill Of Lading Attachment';
                break;
            case XpoLtlDocType.CheckSheet:
                convertedValue = 'Check Sheet';
                break;
            case XpoLtlDocType.ClaimForm:
                convertedValue = 'Claim Form';
                break;
            case XpoLtlDocType.ClaimNotes:
                convertedValue = 'Claim Notes';
                break;
            case XpoLtlDocType.ClaimsAttachment:
                convertedValue = 'Claims Attachment';
                break;
            case XpoLtlDocType.ClaimsProductionUnknown:
                convertedValue = 'Claims Production Unknown';
                break;
            case XpoLtlDocType.ClosedClaimFolder:
                convertedValue = 'Closed Claim Folder';
                break;
            case XpoLtlDocType.CustomerUpload:
                convertedValue = 'Customer Upload';
                break;
            case XpoLtlDocType.CustomsDocuments:
                convertedValue = 'Customs Document';
                break;
            case XpoLtlDocType.CrossDockExceptionPhotos:
                convertedValue = 'Cross Dock Damage';
                break;
            case XpoLtlDocType.DeliveryExceptionPhoto:
                convertedValue = 'Delivery Exception Photo';
                break;
            case XpoLtlDocType.DeliveryReceipt:
                convertedValue = 'Delivery Receipt';
                break;
            case XpoLtlDocType.DeliveryReceiptAttachment:
                convertedValue = 'Delivery Receipt Attachment';
                break;
            case XpoLtlDocType.DeliveryReturnReceipt:
                convertedValue = 'Delivery Return Receipt';
                break;
            case XpoLtlDocType.FlySheet:
                convertedValue = 'Fly Sheet';
                break;
            case XpoLtlDocType.InMotionDimensionerPhoto:
                convertedValue = 'In-Motion Dimensioner Photo';
                break;
            case XpoLtlDocType.InspectionReport:
                convertedValue = 'Inspection Report';
                break;
            case XpoLtlDocType.InspectionReportPhoto:
                convertedValue = 'Inspection Report Photo';
                break;
            case XpoLtlDocType.InvoicePdf:
                convertedValue = 'Invoice';
                break;
            case XpoLtlDocType.LetterOfAuthority:
                convertedValue = 'Letter of Authority';
                break;
            case XpoLtlDocType.MatchMailAcknowledgement:
                convertedValue = 'Match Mail Acknowledgment';
                break;
            case XpoLtlDocType.MobileDimensionerPhoto:
                convertedValue = 'Mobile Dimensioner Photo';
                break;
            case XpoLtlDocType.NmfcClassInspectionCertificate:
                convertedValue = 'NMFC Class Inspection Certificate';
                break;
            case XpoLtlDocType.OSDPhoto:
                convertedValue = 'OS&D Photo';
                break;
            case XpoLtlDocType.PoorlyPackagedOnDock:
                convertedValue = 'Poorly Packaged on Dock';
                break;
            case XpoLtlDocType.PickupPhotos:
                convertedValue = 'Pickup Photos';
                break;
            case XpoLtlDocType.PoorlyPackagedPickUp:
                convertedValue = 'Poorly Packaged at Pickup';
                break;
            case XpoLtlDocType.WeightInspectionCertificate:
                convertedValue = 'Weight Inspection Certificate';
                break;
            case XpoLtlDocType.WeightAndResearchPhotos:
                convertedValue = 'Weight and Research Photos';
                break;
            case XpoLtlDocType.TrailerPhotoOpen:
                convertedValue = 'Trailer Photo Open';
                break;
            case XpoLtlDocType.TrailerPhotoClose:
                convertedValue = 'Trailer Photo Close';
                break;
            case XpoLtlDocType.TrailerPhotoProgressive:
                convertedValue = 'Trailer Photo Progressive';
                break;
            case XpoLtlDocType.All:
                convertedValue = 'All Documents';
                break;
        }
        return convertedValue;
    }
    transformBack(value, args) {
        let convertedValue;
        switch (value) {
            case 'Bill of Lading':
                convertedValue = XpoLtlDocType.BillOfLading;
                break;
            case 'Delivery Receipt':
                convertedValue = XpoLtlDocType.DeliveryReceipt;
                break;
            case 'Delivery Return Receipt':
                convertedValue = XpoLtlDocType.DeliveryReturnReceipt;
                break;
            case 'Customs Document':
                convertedValue = XpoLtlDocType.CustomsDocuments;
                break;
            case 'Customer Upload':
                convertedValue = XpoLtlDocType.CustomerUpload;
                break;
            case 'Inspection Report':
                convertedValue = XpoLtlDocType.InspectionReport;
                break;
            case 'Letter of Authority':
                convertedValue = XpoLtlDocType.LetterOfAuthority;
                break;
            case 'NMFC Class Inspection Certificate':
                convertedValue = XpoLtlDocType.NmfcClassInspectionCertificate;
                break;
            case 'Weight Inspection Certificate':
                convertedValue = XpoLtlDocType.WeightInspectionCertificate;
                break;
            case 'Weight and Research Photos':
                convertedValue = XpoLtlDocType.WeightAndResearchPhotos;
                break;
            case 'In-Motion Dimensioner Photo':
                convertedValue = XpoLtlDocType.InMotionDimensionerPhoto;
                break;
            case 'Invoice':
                convertedValue = XpoLtlDocType.InvoicePdf;
                break;
            case 'Claims Attachment':
                convertedValue = XpoLtlDocType.ClaimsAttachment;
                break;
            case 'DR Attachment':
                convertedValue = XpoLtlDocType.DeliveryReceiptAttachment;
                break;
            case 'BL Attachment':
                convertedValue = XpoLtlDocType.BillOfLadingAttachment;
                break;
            case 'OS&D Photo':
                convertedValue = XpoLtlDocType.OSDPhoto;
                break;
            case 'All Documents':
                convertedValue = XpoLtlDocType.All;
                break;
        }
        return convertedValue;
    }
}
XpoLtlDocTypePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
XpoLtlDocTypePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocTypePipe, name: "xpoLtlDocType" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'xpoLtlDocType',
                }]
        }] });

var ConfigManagerProperties$1;
(function (ConfigManagerProperties) {
    ConfigManagerProperties["appName"] = "appName";
    ConfigManagerProperties["production"] = "production";
    ConfigManagerProperties["buildVersion"] = "buildVersion";
    ConfigManagerProperties["apiUrl"] = "apiUrl";
    ConfigManagerProperties["loggedInUserRoot"] = "loggedInUserRoot";
    ConfigManagerProperties["feedbackToAddress"] = "feedbackToAddress";
    ConfigManagerProperties["feedbackSubject"] = "feedbackSubject";
    ConfigManagerProperties["region"] = "region";
    ConfigManagerProperties["imageCorpCode"] = "imageCorpCode";
    ConfigManagerProperties["docViewWebContext"] = "docViewWebContext";
})(ConfigManagerProperties$1 || (ConfigManagerProperties$1 = {}));

/**
 * Injectable access to browser Window object
 */
class XpoLtlWindowService {
    constructor() { }
    get nativeWindow() {
        return window;
    }
    get nativeDocument() {
        return document;
    }
    // Utilities to make accessing native methods easier
    openWindow(url, target) {
        if (url) {
            return this.nativeWindow.open(url, target || '_blank');
        }
    }
    generateDownloadFile(mimeType, data, fileName) {
        const blob = new Blob([data], { type: mimeType });
        if (this.nativeWindow.navigator && this.nativeWindow.navigator.msSaveOrOpenBlob) {
            this.nativeWindow.navigator.msSaveOrOpenBlob(blob, fileName);
        }
        else {
            const a = this.nativeDocument.createElement('a');
            this.nativeDocument.body.appendChild(a);
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.click();
            a.remove();
        }
    }
}
XpoLtlWindowService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlWindowService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlWindowService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlWindowService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlWindowService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class DocumentDetails {
    constructor() {
        this.currentPage = 1;
        this.totalPages = 1;
        this.zoomLevel = 1;
        this.pageRotation = 0;
    }
    get showNavigation() {
        return this.totalPages > 1;
    }
}

var DisplayState$1;
(function (DisplayState) {
    DisplayState[DisplayState["loading"] = 0] = "loading";
    DisplayState[DisplayState["error"] = 1] = "error";
    DisplayState[DisplayState["unsupportedFormat"] = 2] = "unsupportedFormat";
    DisplayState[DisplayState["showPdf"] = 3] = "showPdf";
})(DisplayState$1 || (DisplayState$1 = {}));

class XpoLtlDocumentBaseService {
    constructor(configManager, documentManagementService, conditioningService, formatValidationService, windowRef) {
        this.configManager = configManager;
        this.documentManagementService = documentManagementService;
        this.conditioningService = conditioningService;
        this.formatValidationService = formatValidationService;
        this.windowRef = windowRef;
    }
    /**
     * Return list of all document that match the proNbr or trailerNbr and search criteria
     */
    listAvailableDocuments(searchString, minDate, maxDate, searchTags, isTrailerNbr = false) {
        if (!isTrailerNbr && (!searchString || !this.formatValidationService.isValidProNumber(searchString))) {
            throw new Error(`A valid PRO is required: ${searchString}`);
        }
        else if (isTrailerNbr && (!searchString || !this.formatValidationService.isValidTrailerNumber(searchString))) {
            throw new Error(`A valid trailer number is required: ${searchString}`);
        }
        return this.getDmsAuthToken().pipe(switchMap((token) => {
            const request = new SearchDmsDocumentRqst();
            request.corpCode = this.configManager.getSetting(ConfigManagerProperties$1.imageCorpCode);
            request.dmsAuth = get(token, 'access_token');
            if (minDate) {
                request.minDateTime = minDate.toISOString();
            }
            if (maxDate) {
                request.maxDateTime = maxDate.toISOString();
            }
            if (searchTags) {
                request.searchTags = searchTags;
            }
            request.searchString = !isTrailerNbr
                ? this.conditioningService.conditionProNumber(searchString, 9)
                : searchString.trim();
            return this.documentManagementService
                .searchDmsDocument(request, ApiRequest.concealedCall, { headers: { DMSAuth: request.dmsAuth } })
                .pipe(map((value) => (value['searchDmsDocumentResp'] ? value['searchDmsDocumentResp'] : value)), map((value) => {
                if (value) {
                    value.documentInfo = value.documentInfo.filter((docInfo) => {
                        if (docInfo && docInfo.cdt && docInfo.cdt.docClass) {
                            const en = findKey(XpoLtlDocType, (v) => v === docInfo.cdt.docClass);
                            return !!en;
                        }
                    });
                }
                return value;
            }));
        }));
    }
    getDocument(docTimestamp, docClass, corpCode, docFormat = 'pdf') {
        return this.getDmsAuthToken().pipe(switchMap((token) => {
            const params = new GetDocumentPath();
            params.docArchiveTimestamp = docTimestamp;
            params.docClass = docClass;
            params.docFormat = docFormat;
            params.corpCode = corpCode;
            return this.documentManagementService.getDocument(params, undefined, { loadingOverlayEnabled: false }, {
                headers: {
                    dmsAuth: token.access_token,
                },
            });
        }));
    }
    /**
     * Open Document(s) in a new DocView browser tab
     * @param pro
     * @param referenceNumber
     * @param docType
     * @param minDate
     * @param menuUpAllDocs
     * @param windowTarget
     */
    navigateToDocViewApp(pro, referenceNumber, docType, minDate, menuUpAllDocs, windowTarget) {
        const context = this.webContextRoot();
        const nativeWindow = this.windowRef.nativeWindow;
        const protocol = nativeWindow.location.protocol;
        const host = nativeWindow.location.hostname;
        const port = nativeWindow.location.port;
        const url = `${this.appendUrlParts(`${protocol}//${host}:${port}`, context, docType, pro, referenceNumber)}?minDate=${minDate}?menuUpAllDocs=${menuUpAllDocs}`;
        nativeWindow.open(url, windowTarget || '_blank');
    }
    _appendUrlParts(part1, part2) {
        if (!part1) {
            return !!part2 ? part2 : '';
        }
        if (!part2) {
            return !!part1 ? part1 : '';
        }
        const conditionedPart1 = `${part1}${part1.endsWith('/') ? '' : '/'}`;
        const conditionedPart2 = `${part2.startsWith('/') ? part2.substring(1) : part2}`;
        return `${conditionedPart1}${conditionedPart2}`;
    }
    appendUrlParts(...parts) {
        let stitched = '';
        if (parts && parts.length > 0) {
            parts.forEach((part) => {
                stitched = this._appendUrlParts(stitched, part);
            });
        }
        return stitched;
    }
    webContextRoot() {
        const context = this.configManager.getSetting(ConfigManagerProperties$1.docViewWebContext);
        return context || '/appjs/docview/';
    }
    getDmsAuthToken() {
        return this.cachedToken && this.cachedToken.expires.getTime() > Date.now()
            ? of(this.cachedToken.tokenResponse)
            : this.documentManagementService
                .retrieveDmsAuthToken({}, { loadingOverlayEnabled: false })
                .pipe(tap((resp) => {
                this.cachedToken = {
                    tokenResponse: resp,
                    expires: new Date(Date.now() + get(resp, 'expires_in', 0) * 1000),
                };
            }));
    }
}
XpoLtlDocumentBaseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentBaseService, deps: [{ token: i2$3.ConfigManagerService }, { token: i2$4.DocumentManagementApiService }, { token: i3$1.ConditioningService }, { token: i3$1.FormatValidationService }, { token: XpoLtlWindowService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlDocumentBaseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentBaseService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentBaseService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i2$3.ConfigManagerService }, { type: i2$4.DocumentManagementApiService }, { type: i3$1.ConditioningService }, { type: i3$1.FormatValidationService }, { type: XpoLtlWindowService }]; } });

class XpoLtlPdfViewerComponent {
    constructor(windowService) {
        this.windowService = windowService;
        this.DisplayState = DisplayState$1;
        this.errorMessage = undefined;
        this.showPrint = true;
        this.state$ = new BehaviorSubject(DisplayState$1.showPdf);
    }
    afterPdfLoadComplete(event) {
        this.documentDetails.currentPage = 1;
        this.documentDetails.totalPages = event.numPages;
    }
    onPdfError(error) {
        this.errorMessage = error;
        this.state$.next(DisplayState$1.error);
    }
    zoom(direction) {
        this.documentDetails.zoomLevel += direction / 10;
    }
    rotate(direction) {
        this.documentDetails.pageRotation += direction * 90;
    }
    navigate(direction) {
        if ((this.documentDetails.currentPage > 1 && direction < 0) ||
            (this.documentDetails.currentPage < this.documentDetails.totalPages && direction > 0)) {
            this.documentDetails.currentPage += direction;
        }
    }
    handleDownloadClicked() {
        this.windowService.generateDownloadFile('application/pdf', this.documentDetails.document, this.documentDetails.filename);
    }
    handlePrintClicked() {
        printJS({ printable: encode(this.documentDetails.document), type: 'pdf', base64: true });
    }
}
XpoLtlPdfViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPdfViewerComponent, deps: [{ token: XpoLtlWindowService }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlPdfViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlPdfViewerComponent, selector: "xpo-ltl-pdf-viewer", inputs: { documentDetails: "documentDetails", showPrint: "showPrint" }, host: { classAttribute: "xpo-LtlPdfViewer" }, ngImport: i0, template: "<ng-container [ngSwitch]=\"state$ | async\">\n  <ng-container *ngSwitchCase=\"DisplayState.error\" [ngTemplateOutlet]=\"showError\"></ng-container>\n  <ng-container *ngSwitchCase=\"DisplayState.showPdf\" [ngTemplateOutlet]=\"showPdf\"></ng-container>\n</ng-container>\n\n<ng-template #showError>\n  <div class=\"xpo-LtlPdfViewer__centered\">\n    <div>{{ errorMessage }}</div>\n  </div>\n</ng-template>\n\n<ng-template #showPdf>\n  <div class=\"xpo-LtlPdfViewer__actions\" *ngIf=\"documentDetails?.document\">\n    <div class=\"xpo-LtlPdfViewer__controls image-controls\">\n      <button mat-icon-button matTooltip=\"Zoom Out\" (click)=\"zoom(-1)\">\n        <mat-icon matSuffix class=\"xpo-LtlPdfViewer__navigation-button\">zoom_out</mat-icon>\n      </button>\n      <button mat-icon-button matTooltip=\"Zoom In\" (click)=\"zoom(1)\">\n        <mat-icon matSuffix class=\"xpo-LtlPdfViewer__navigation-button\">zoom_in</mat-icon>\n      </button>\n      <button mat-icon-button matTooltip=\"Rotate Left\" (click)=\"rotate(-1)\">\n        <mat-icon matSuffix class=\"xpo-LtlPdfViewer__navigation-button\">rotate_left</mat-icon>\n      </button>\n      <button mat-icon-button matTooltip=\"Rotate Right\" (click)=\"rotate(1)\">\n        <mat-icon matSuffix class=\"xpo-LtlPdfViewer__navigation-button\">rotate_right</mat-icon>\n      </button>\n    </div>\n\n    <div class=\"xpo-LtlPdfViewer__controls page-controls\">\n      <button mat-icon-button matTooltip=\"Previous Page\" (click)=\"navigate(-1)\">\n        <mat-icon matSuffix class=\"xpo-LtlPdfViewer__navigation-button\">navigate_before</mat-icon>\n      </button>\n      <div class=\"xpo-LtlPdfViewer__navigation-counts\">\n        {{ documentDetails?.currentPage }} of {{ documentDetails?.totalPages }}\n      </div>\n      <button mat-icon-button matTooltip=\"Next Page\" (click)=\"navigate(1)\">\n        <mat-icon matSuffix class=\"xpo-LtlPdfViewer__navigation-button\">navigate_next</mat-icon>\n      </button>\n    </div>\n\n    <div class=\"xpo-LtlPdfViewer__controls download-controls\">\n      <button\n        mat-icon-button\n        matTooltip=\"Print Document\"\n        (click)=\"handlePrintClicked()\"\n        *ngIf=\"documentDetails?.document && !!showPrint\"\n      >\n        <mat-icon matSuffix class=\"xpo-LtlPdfViewer__navigation-button\">print</mat-icon>\n      </button>\n      <button\n        mat-icon-button\n        matTooltip=\"Download Document\"\n        (click)=\"handleDownloadClicked()\"\n        *ngIf=\"documentDetails?.document\"\n      >\n        <mat-icon matSuffix class=\"xpo-LtlPdfViewer__navigation-button\">file_download</mat-icon>\n      </button>\n    </div>\n  </div>\n  <div class=\"xpo-LtlPdfViewer__document\">\n    <pdf-viewer\n      [show-all]=\"false\"\n      [src]=\"documentDetails?.document\"\n      (after-load-complete)=\"afterPdfLoadComplete($event)\"\n      (error)=\"onPdfError($event)\"\n      [rotation]=\"documentDetails?.pageRotation\"\n      [page]=\"documentDetails?.currentPage\"\n      [render-text]=\"true\"\n      [fit-to-page]=\"false\"\n      [original-size]=\"true\"\n      [zoom]=\"documentDetails?.zoomLevel\"\n    >\n    </pdf-viewer>\n  </div>\n</ng-template>\n", styles: [":host{margin-bottom:32px;overflow:scroll}.xpo-LtlPdfViewer__centered,:host{display:flex;flex:1 1 auto;flex-direction:column}.xpo-LtlPdfViewer__centered{justify-content:center;align-items:center;height:100%}.xpo-LtlPdfViewer__unsupported .mat-icon-button{width:4rem;height:4rem;font-size:4rem}.xpo-LtlPdfViewer__title{display:flex;flex:0 0 auto}.xpo-LtlPdfViewer__actions{display:flex;flex-direction:row;flex:0 1 auto;justify-content:center}.xpo-LtlPdfViewer__controls{display:flex;flex-direction:row;width:33%;align-items:center}.xpo-LtlPdfViewer__controls.image-controls{justify-content:flex-start}.xpo-LtlPdfViewer__controls.page-controls{justify-content:center}.xpo-LtlPdfViewer__controls.download-controls{justify-content:flex-end}.xpo-LtlPdfViewer__document{display:block;overflow:scroll}"], components: [{ type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i4$2.PdfViewerComponent, selector: "pdf-viewer", inputs: ["c-maps-url", "page", "render-text", "render-text-mode", "original-size", "show-all", "stick-to-page", "zoom", "zoom-scale", "rotation", "external-link-target", "autoresize", "fit-to-page", "show-borders", "src"], outputs: ["after-load-complete", "page-rendered", "pages-initialized", "text-layer-rendered", "error", "on-progress", "pageChange"] }], directives: [{ type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i7.MatSuffix, selector: "[matSuffix]" }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPdfViewerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-pdf-viewer',
                    templateUrl: './pdf-viewer.component.html',
                    styleUrls: ['./pdf-viewer.component.scss'],
                    host: { class: 'xpo-LtlPdfViewer' },
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlWindowService }]; }, propDecorators: { documentDetails: [{
                type: Input
            }], showPrint: [{
                type: Input
            }] } });

/**
 * Display a single DMS Document
 */
class XpoLtlDocumentViewerComponent {
    constructor(documentService, windowService, configManagerService) {
        this.documentService = documentService;
        this.windowService = windowService;
        this.configManagerService = configManagerService;
        this.showPrint = true;
        this.documentSubject = new BehaviorSubject(undefined);
        this.document$ = this.documentSubject.asObservable();
        this.DisplayState = DisplayState$1;
        this.stateSubject = new BehaviorSubject(DisplayState$1.loading);
        this.state$ = this.stateSubject.asObservable();
        this.errorMessage = undefined;
        this.unsubscriber = new Unsubscriber();
    }
    set document(document) {
        this.documentSubject.next(document);
    }
    get document() {
        return this.documentSubject.value;
    }
    set state(value) {
        this.stateSubject.next(value);
    }
    ngOnInit() {
        this.initWatchers();
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    initWatchers() {
        this.document$.pipe(takeUntil(this.unsubscriber.done$)).subscribe(() => {
            this.loadDocument();
        });
    }
    decodeData(data) {
        return decode(data);
    }
    loadDocument() {
        this.state = DisplayState$1.loading;
        this.documentDetails = new DocumentDetails();
        // use the provided corpCode, or if none, use the one from the config
        let corpCode = this.document.corpCode;
        if (size(corpCode) === 0) {
            corpCode = this.configManagerService.getSetting(ConfigManagerProperties$1.imageCorpCode);
        }
        this.documentService.getDocument(this.document.timestamp, this.document.docClass, corpCode).subscribe((result) => {
            try {
                this.documentDetails.document = this.decodeData(result.documentData);
                this.documentDetails.filename = result.fileName;
                this.documentDetails.contentType = result.contentType;
                if (!this.documentDetails.document) {
                    // failed to decode document, so can't show anything
                    throw new Error();
                }
                else if (!endsWith(this.documentDetails.contentType, 'pdf')) {
                    this.state = DisplayState$1.unsupportedFormat;
                }
                else {
                    this.state = DisplayState$1.showPdf;
                }
            }
            catch (_a) {
                this.state = DisplayState$1.error;
                this.errorMessage = 'There Was A Problem Loading This Document';
            }
        }, (error) => {
            this.state = DisplayState$1.error;
            this.errorMessage = 'Document Not Found';
        });
    }
    handleDownloadClicked() {
        this.windowService.generateDownloadFile(this.document.docClass, this.documentDetails.document, this.documentDetails.filename);
    }
}
XpoLtlDocumentViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentViewerComponent, deps: [{ token: XpoLtlDocumentBaseService }, { token: XpoLtlWindowService }, { token: i2$3.ConfigManagerService }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlDocumentViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlDocumentViewerComponent, selector: "xpo-ltl-document-viewer", inputs: { document: "document", showPrint: "showPrint" }, ngImport: i0, template: "<div class=\"xpo-LtlDocumentViewer\">\n  <ng-container [ngSwitch]=\"state$ | async\">\n    <ng-container *ngSwitchCase=\"DisplayState.loading\" [ngTemplateOutlet]=\"showLoading\"></ng-container>\n    <ng-container *ngSwitchCase=\"DisplayState.error\" [ngTemplateOutlet]=\"showError\"></ng-container>\n    <ng-container *ngSwitchCase=\"DisplayState.unsupportedFormat\" [ngTemplateOutlet]=\"showUnsupported\"></ng-container>\n    <ng-container *ngSwitchCase=\"DisplayState.showPdf\" [ngTemplateOutlet]=\"showPdf\"></ng-container>\n  </ng-container>\n</div>\n\n<ng-template #showLoading>\n  <div class=\"xpo-LtlDocumentViewer__centered\">\n    <div>\n      <xpo-responsive-loading-spinner></xpo-responsive-loading-spinner>\n      <h2>Loading document...</h2>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #showError>\n  <div class=\"xpo-LtlDocumentViewer__centered\">\n    <div>{{ errorMessage }}</div>\n  </div>\n</ng-template>\n\n<ng-template #showUnsupported>\n  <div class=\"xpo-LtlDocumentViewer__centered xpo-LtlDocumentViewer__unsupported\">\n    <p>Unsupported File Type. Download to View</p>\n    <button mat-icon-button matTooltip=\"Download Document\" (click)=\"handleDownloadClicked()\">\n      <mat-icon inline=\"true\">file_download</mat-icon>\n    </button>\n  </div>\n</ng-template>\n\n<ng-template #showPdf>\n  <xpo-ltl-pdf-viewer [showPrint]=\"showPrint\" [documentDetails]=\"documentDetails\"></xpo-ltl-pdf-viewer>\n</ng-template>\n", styles: [".xpo-LtlDocumentViewer,.xpo-LtlDocumentViewer__centered{display:flex;flex:1 1 auto;height:100%;flex-direction:column}.xpo-LtlDocumentViewer__centered{justify-content:center;align-items:center}.xpo-LtlDocumentViewer__unsupported .mat-icon-button{width:4rem;height:4rem;font-size:4rem}"], components: [{ type: i4$3.XpoResponsiveLoadingSpinner, selector: "xpo-responsive-loading-spinner", inputs: ["diameter"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: XpoLtlPdfViewerComponent, selector: "xpo-ltl-pdf-viewer", inputs: ["documentDetails", "showPrint"] }], directives: [{ type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }], pipes: { "async": i5.AsyncPipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentViewerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-document-viewer',
                    templateUrl: './document-viewer.component.html',
                    styleUrls: ['./document-viewer.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlDocumentBaseService }, { type: XpoLtlWindowService }, { type: i2$3.ConfigManagerService }]; }, propDecorators: { document: [{
                type: Input
            }], showPrint: [{
                type: Input
            }] } });

class XpoLtlDocViewPageComponent {
    constructor(route) {
        this.route = route;
        this.route.params.pipe(take(1)).subscribe((params) => {
            this.documentCdt = {
                corpCode: '',
                docClass: get(params, 'doc-class'),
                timestamp: get(params, 'timestamp'),
            };
        });
    }
}
XpoLtlDocViewPageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocViewPageComponent, deps: [{ token: i6$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlDocViewPageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlDocViewPageComponent, selector: "xpo-ltl-doc-view-page", ngImport: i0, template: "<xpo-ltl-document-viewer [document]=\"documentCdt\"></xpo-ltl-document-viewer>\n", styles: ["xpo-ltl-doc-view-page{display:block;width:100%;height:100%}"], components: [{ type: XpoLtlDocumentViewerComponent, selector: "xpo-ltl-document-viewer", inputs: ["document", "showPrint"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocViewPageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-doc-view-page',
                    templateUrl: './doc-view-page.component.html',
                    styleUrls: ['./doc-view-page.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i6$1.ActivatedRoute }]; } });

class XpoLtlDocumentViewerDialogComponent {
    constructor(data, docTypePipe) {
        this.data = data;
        this.docTypePipe = docTypePipe;
        this.unsubscriber = new Unsubscriber();
        this.opened = false;
        this.selectedDocumentSubject = new BehaviorSubject(undefined);
        this.selectedDocument$ = this.selectedDocumentSubject.asObservable();
        this.dialogTitleSubject = new BehaviorSubject('Shipment');
        this.dialogTitle$ = this.dialogTitleSubject.asObservable();
        this.dialogData = data;
        this.documentDescs = uniqBy(this.dialogData.shipmentDescriptors, 'proNbr');
        this.opened = get(this.dialogData, 'config.showShipmentSelector', false);
        this.dialogTitle$ = this.selectedDocument$.pipe(filter((selectedDocument) => !!selectedDocument), map((selectedDocument) => {
            const title = this.docTypePipe.transform(selectedDocument.docClass);
            return title;
        }));
    }
    get documentDescriptors() {
        return this.documentDescs;
    }
    get moveable() {
        return !!get(this.dialogData, 'config.moveable');
    }
    get searchable() {
        return !!get(this.dialogData, 'config.searchable');
    }
    get showDocumentsListPanel() {
        return size(this.documentDescriptors) > 1 || this.searchable;
    }
    get selectedDocument() {
        return this.selectedDocumentSubject.value;
    }
    ngAfterViewInit() {
        if (size(this.documentDescriptors) === 1) {
            this.selectedDocumentSubject.next(first(this.documentDescriptors));
        }
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    onKeydownHandler(event) {
        this.closeClicked();
    }
    closeClicked() {
        if (!!this.dialogRef) {
            this.dialogRef.close();
        }
    }
}
XpoLtlDocumentViewerDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentViewerDialogComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: XpoLtlDocTypePipe }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlDocumentViewerDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlDocumentViewerDialogComponent, selector: "xpo-ltl-document-viewer-dialog", host: { listeners: { "document:keydown.escape": "onKeydownHandler($event)" } }, ngImport: i0, template: "<div class=\"xpo-LtlDocumentViewerDialog\" #dialogContents>\n  <div class=\"xpo-LtlDocumentViewerDialog__header\">\n    <xpo-ltl-dialog-title\n      [options]=\"{\n        moveable: moveable\n      }\"\n    >\n      <ng-container [ngTemplateOutlet]=\"headerContent\"></ng-container>\n    </xpo-ltl-dialog-title>\n  </div>\n  <mat-dialog-content class=\"xpo-LtlDocumentViewerDialog__content\">\n    <ng-container *ngIf=\"showDocumentsListPanel; then multipleDocuments; else singleDocument\"></ng-container>\n  </mat-dialog-content>\n</div>\n\n<ng-template #headerContent>\n  <span class=\"xpo-LtlDocumentViewerDialog__header\">\n    <button\n      mat-icon-button\n      *ngIf=\"showDocumentsListPanel\"\n      (click)=\"opened = !opened\"\n      matTooltip=\"Toggle Document Selection\"\n    >\n      <mat-icon>menu</mat-icon>\n    </button>\n    {{ dialogTitle$ | async }}\n  </span>\n</ng-template>\n\n<ng-template #multipleDocuments> </ng-template>\n\n<ng-template #singleDocument>\n  <xpo-ltl-document-viewer\n    *ngIf=\"selectedDocument$ | async as document\"\n    [document]=\"document\"\n  ></xpo-ltl-document-viewer>\n</ng-template>\n", styles: [".flex--stretch{flex:1}.xpo-LtlDocumentViewerDialog{display:flex;flex:1 1 auto;flex-direction:column;height:100%;width:100%}.xpo-LtlDocumentViewerDialog .mat-dialog-container{display:flex;flex:1 1 auto;overflow:hidden;padding:16px 0}.xpo-LtlDocumentViewerDialog .mat-dialog-content{display:flex;flex:1 1 auto;flex-direction:row;margin:0;padding:0;max-height:inherit;overflow:auto}.xpo-LtlDocumentViewerDialog .mat-dialog-content .mat-sidenav-container{width:100%}.xpo-LtlDocumentViewerDialog .mat-dialog-content .mat-sidenav-container .mat-sidenav-content{overflow:hidden}.xpo-LtlDocumentViewerDialog__header h1{display:flex;height:6rem;flex:0 0 auto;flex-direction:row;align-items:center;margin:-18px 0 0}.xpo-LtlDocumentViewerDialog__header h1 .mat-dialog-title{flex:1 1 auto;margin:0}.xpo-LtlDocumentViewerDialog__header h1 .mat-dialog-title .mat-icon-button{color:#9b9b9b}.xpo-LtlDocumentViewerDialog__header h1-close{justify-self:flex-end;color:rgba(0,0,0,.54);flex:0 0 auto;align-items:center}.xpo-LtlDocumentViewerDialog__content{width:100%;justify-content:center}.xpo-LtlDocumentViewerDialog__content-tab{display:flex;position:relative;flex:1 1 auto;flex-direction:column}.xpo-LtlDocumentViewerDialog__header{display:flex;align-items:center}.xpo-LtlDocumentViewerDialog xpo-ltl-document-viewer{width:100%}"], components: [{ type: XpoLtlDialogTitleComponent, selector: "xpo-ltl-dialog-title", inputs: ["options"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: XpoLtlDocumentViewerComponent, selector: "xpo-ltl-document-viewer", inputs: ["document", "showPrint"] }], directives: [{ type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentViewerDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-document-viewer-dialog',
                    templateUrl: './document-viewer-dialog.component.html',
                    styleUrls: ['./document-viewer-dialog.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: XpoLtlDocTypePipe }]; }, propDecorators: { onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown.escape', ['$event']]
            }] } });

class XpoLtlDocumentService extends XpoLtlDocumentBaseService {
    constructor(configManager, documentManagementService, conditioningService, formatValidationService, windowRef, dialog) {
        super(configManager, documentManagementService, conditioningService, formatValidationService, windowRef);
        this.configManager = configManager;
        this.documentManagementService = documentManagementService;
        this.conditioningService = conditioningService;
        this.formatValidationService = formatValidationService;
        this.windowRef = windowRef;
        this.dialog = dialog;
    }
    showDocumentsDialog(documentDesc, config, dialogConfig) {
        const subject = new Subject();
        const matDialogConfig = Object.assign(Object.assign({ width: '1232px', height: '98%', panelClass: 'xpo-LtlDocumentViewerDialog__panel', disableClose: true, hasBackdrop: !get(config, 'moveable') }, (dialogConfig || {})), { data: {
                shipmentDescriptors: castArray(documentDesc),
                config,
            } });
        const dialogRef = this.dialog.open(XpoLtlDocumentViewerDialogComponent, matDialogConfig);
        dialogRef.afterClosed().subscribe(() => {
            subject.next();
            subject.complete();
        });
        return subject.asObservable();
    }
}
XpoLtlDocumentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentService, deps: [{ token: i2$3.ConfigManagerService }, { token: i2$4.DocumentManagementApiService }, { token: i3$1.ConditioningService }, { token: i3$1.FormatValidationService }, { token: XpoLtlWindowService }, { token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlDocumentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i2$3.ConfigManagerService }, { type: i2$4.DocumentManagementApiService }, { type: i3$1.ConditioningService }, { type: i3$1.FormatValidationService }, { type: XpoLtlWindowService }, { type: i1$1.MatDialog }]; } });

class XpoLtlDocumentSelectorComponent {
    constructor(doccumentService, configManager) {
        this.doccumentService = doccumentService;
        this.configManager = configManager;
        this.tooltip = 'Select Documents to Display';
        this.matIcon = 'link';
        this.selectionChange = new EventEmitter();
        this.documentListSubject = new BehaviorSubject([]);
        this.documentList$ = this.documentListSubject.asObservable();
        this.XpoLtlDocType = XpoLtlDocType;
        this.defaultAll = {
            cdt: {
                corpCode: this.configManager.getSetting(ConfigManagerProperties$1.imageCorpCode),
                docClass: XpoLtlDocType.All,
                timestamp: `${new Date().valueOf()}`,
            },
            timestampISO: new Date().toISOString(),
            relevanceValue: 0,
        };
    }
    set proNbr(value) {
        this._proNbr = value;
        this.fetchDocuments(this._proNbr);
    }
    ngAfterViewInit() {
        // this.documentSelect.trigger = this.documentSelectTrigger;
    }
    fetchDocuments(proNbr, minDate, maxDate, searchTags) {
        this.doccumentService
            .listAvailableDocuments(proNbr, minDate, maxDate, searchTags)
            .pipe(take(1))
            .subscribe((response) => {
            this.documentListSubject.next(get(response, 'documentInfo', []));
        });
    }
    selectionChanged(selection) {
        if (selection.value.cdt.docClass === XpoLtlDocType.All) {
            // return all documents
            this.selectionChange.emit(this.documentListSubject.value);
        }
        else {
            // return only selected document
            this.selectionChange.emit([selection.value]);
        }
        // if we don't clear value here, we can't select the same document twice in a row
        this.documentSelect.value = undefined;
    }
}
XpoLtlDocumentSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentSelectorComponent, deps: [{ token: XpoLtlDocumentService }, { token: i2$3.ConfigManagerService }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlDocumentSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlDocumentSelectorComponent, selector: "xpo-ltl-document-selector", inputs: { proNbr: "proNbr", tooltip: "tooltip", matIcon: "matIcon" }, outputs: { selectionChange: "selectionChange" }, viewQueries: [{ propertyName: "documentSelect", first: true, predicate: ["documentSelect"], descendants: true }], ngImport: i0, template: "<div class=\"xpo-LtlDocumentSelector\">\n  <button\n    mat-icon-button\n    class=\"xpo-LtlDocumentSelector__trigger\"\n    disableRipple=\"true\"\n    [matTooltip]=\"tooltip\"\n    [disabled]=\"!(documentList$ | async)?.length\"\n    (click)=\"documentSelect.toggle()\"\n  >\n    <mat-icon>{{ matIcon }}</mat-icon>\n  </button>\n  <mat-select\n    #documentSelect\n    disableOptionCentering\n    panelClass=\"xpo-LtlDocumentSelector__panel\"\n    (selectionChange)=\"selectionChanged($event)\"\n  >\n    <mat-option *ngIf=\"(documentList$ | async)?.length > 1\" [value]=\"defaultAll\">\n      <div class=\"xpo-LtlDocumentSelector__option\">\n        <div>All Documents</div>\n      </div>\n    </mat-option>\n    <mat-option *ngFor=\"let doc of documentList$ | async\" [value]=\"doc\">\n      <div class=\"xpo-LtlDocumentSelector__option\">\n        <div>{{ doc.cdt.docClass | xpoLtlDocType }}</div>\n        <div>{{ doc.timestampISO | date: 'MM/dd/yyyy HH:mm' }}</div>\n      </div>\n    </mat-option>\n  </mat-select>\n</div>\n", styles: [".flex--stretch{flex:1}xpo-ltl-document-selector{display:flex}.xpo-LtlDocumentSelector{display:flex;flex:1 1 auto;justify-content:center;align-content:center}.xpo-LtlDocumentSelector .mat-select .mat-select-trigger div{display:none}.xpo-LtlDocumentSelector__trigger{display:flex;flex:0 0 auto;padding:0;border:none;width:auto}.xpo-LtlDocumentSelector__panel .mat-option{margin:0;overflow:visible;line-height:normal;word-wrap:break-word;white-space:pre-wrap;height:auto!important}.xpo-LtlDocumentSelector__option{margin:.5rem 0}.xpo-LtlDocumentSelector__option div{line-height:1rem}"], components: [{ type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i4$4.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }], directives: [{ type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i5.AsyncPipe, "xpoLtlDocType": XpoLtlDocTypePipe, "date": i5.DatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDocumentSelectorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-document-selector',
                    templateUrl: './document-selector.component.html',
                    styleUrls: ['./document-selector.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlDocumentService }, { type: i2$3.ConfigManagerService }]; }, propDecorators: { documentSelect: [{
                type: ViewChild,
                args: ['documentSelect']
            }], proNbr: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], matIcon: [{
                type: Input
            }], selectionChange: [{
                type: Output
            }] } });

const components$2 = [
    XpoLtlDocumentSelectorComponent,
    XpoLtlDocViewPageComponent,
    XpoLtlDocumentViewerComponent,
    XpoLtlPdfViewerComponent,
];
const pipes$2 = [XpoLtlDocTypePipe];
const dialogs = [XpoLtlDocumentViewerDialogComponent];
class XpoLtlDmsUtilsModule {
}
XpoLtlDmsUtilsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDmsUtilsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlDmsUtilsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDmsUtilsModule, declarations: [XpoLtlDocumentSelectorComponent,
        XpoLtlDocViewPageComponent,
        XpoLtlDocumentViewerComponent,
        XpoLtlPdfViewerComponent, XpoLtlDocTypePipe, XpoLtlDocumentViewerDialogComponent, XpoLtlDocViewPageComponent], imports: [CommonModule,
        SdkDocumentManagementModule,
        SdkDmsModule,
        PdfViewerModule,
        MatTooltipModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        XpoLtlDialogTitleModule,
        XpoResponsiveLoadingSpinnerModule], exports: [XpoLtlDocumentSelectorComponent,
        XpoLtlDocViewPageComponent,
        XpoLtlDocumentViewerComponent,
        XpoLtlPdfViewerComponent, XpoLtlDocumentViewerDialogComponent, XpoLtlDocTypePipe] });
XpoLtlDmsUtilsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDmsUtilsModule, providers: [...pipes$2], imports: [[
            CommonModule,
            SdkDocumentManagementModule,
            SdkDmsModule,
            PdfViewerModule,
            MatTooltipModule,
            MatSelectModule,
            MatIconModule,
            MatButtonModule,
            MatDialogModule,
            XpoLtlDialogTitleModule,
            XpoResponsiveLoadingSpinnerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDmsUtilsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        SdkDocumentManagementModule,
                        SdkDmsModule,
                        PdfViewerModule,
                        MatTooltipModule,
                        MatSelectModule,
                        MatIconModule,
                        MatButtonModule,
                        MatDialogModule,
                        XpoLtlDialogTitleModule,
                        XpoResponsiveLoadingSpinnerModule,
                    ],
                    declarations: [...components$2, ...pipes$2, ...dialogs, XpoLtlDocViewPageComponent],
                    exports: [...components$2, ...dialogs, ...pipes$2],
                    providers: [...pipes$2],
                    entryComponents: [...dialogs],
                }]
        }] });

const routes = [
    {
        path: 'docview/:doc-class/:timestamp',
        component: XpoLtlDocViewPageComponent,
    },
];
class XpoLtlDmsUtilsRoutingModule {
}
XpoLtlDmsUtilsRoutingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDmsUtilsRoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlDmsUtilsRoutingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDmsUtilsRoutingModule, imports: [i6$1.RouterModule], exports: [RouterModule] });
XpoLtlDmsUtilsRoutingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDmsUtilsRoutingModule, imports: [[RouterModule.forChild(routes)], RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlDmsUtilsRoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule.forChild(routes)],
                    exports: [RouterModule],
                }]
        }] });

/**
 * Enum mapping to list of form statuses on statusChange emit
 */
var FormStatus;
(function (FormStatus) {
    FormStatus["Valid"] = "VALID";
    FormStatus["Invalid"] = "INVALID";
    FormStatus["Pending"] = "PENDING";
    FormStatus["Disabled"] = "DISABLED";
})(FormStatus || (FormStatus = {}));
/**
 * Utilities for interacting with Angular Reactive Forms
 */
class FormUtils {
    /**
     * Returns object representing the control's state
     * Note: This is mostly useful for debugging
     */
    static getControlState(control, controlName = null, recursive = false) {
        const result = {
            name: controlName,
            status: control.status,
            value: undefined,
            valid: control.valid,
            pending: control.pending,
            enabled: control.enabled,
            errors: control.errors,
            warnings: control['warnings'],
            dirty: control.dirty,
            touched: control.touched,
        };
        if (control instanceof FormControl) {
            set(result, 'value', control.value);
        }
        if (recursive) {
            set(result, 'children', map$1(get(control, 'controls', []), (c, name) => this.getControlState(c, name, recursive)));
        }
        return result;
    }
    /**
     * Attempt to get the name of the control as it is registered in its parent.
     * For a FormArray, this will be the index in the array. If the control does not
     * have a parent, then the name is 'root'.
     */
    static getControlName(control) {
        const parent = control.parent;
        if (parent instanceof FormArray) {
            const index = parent.controls.findIndex((c) => c === control);
            return `${index}`;
        }
        else if (parent instanceof FormGroup) {
            for (const [key, value] of Object.entries(parent.controls)) {
                if (value === control) {
                    return key;
                }
            }
        }
    }
    /**
     * Sets the specified control in the group to enabled/disabled without emitting events
     */
    static setEnabled(group, field, isEnabled = true) {
        if (group) {
            const control = group.get(field);
            if (control) {
                if (isEnabled) {
                    FormUtils.enable(control);
                }
                else {
                    FormUtils.disable(control);
                }
            }
        }
    }
    static setControlEnabled(control, isEnabled = true) {
        if (isEnabled) {
            FormUtils.enable(control);
        }
        else {
            FormUtils.disable(control);
        }
    }
    static enable(control) {
        if (control && control.disabled) {
            control.enable({ onlySelf: true, emitEvent: false });
        }
    }
    static disable(control) {
        if (control && control.enabled) {
            control.disable({ onlySelf: true, emitEvent: false });
        }
    }
    /**
     * rxjs pipe which will return a boolean result comparing the passed in status value
     * to the current form status value
     */
    static isFormStatus$(status) {
        const result$ = pipe(map(function (formStatus) {
            return formStatus === status;
        }));
        return result$;
    }
    /**
     * Set the values for the named controls if it is different, without emitting statusChanges
     * and valueChanges events
     */
    static setValues(form, values, options = {}) {
        if (form) {
            forOwn(values, (value, controlKey) => {
                const control = form.get(controlKey);
                FormUtils.setValue(control, value, options);
            });
        }
    }
    /**
     * Set the value for the control if it is different, without emitting statusChanges
     * and valueChanges events
     */
    static setValue(control, value, options = {}) {
        if (control) {
            if (!isEqual(control.value, value)) {
                control.patchValue(value, Object.assign({ emitEvent: false }, options)); // don't emit change events
                control.markAsDirty();
            }
            control.markAsTouched();
        }
    }
    static getNestedControl(rootControl, ...nestedControlNames) {
        if (rootControl) {
            return reduce(nestedControlNames, (target, name) => {
                return target ? target.get(name) : undefined;
            }, rootControl);
        }
        else {
            return undefined;
        }
    }
    /**
     * Set the value of the nested control specified.
     */
    static setNestedValue(value, rootControl, ...nestedControlNames) {
        const control = FormUtils.getNestedControl(rootControl, ...nestedControlNames);
        FormUtils.setValue(control, value);
    }
    /**
     * Get the value of the nested control specified.
     */
    static getNestedValue(rootControl, ...nestedControlNames) {
        const control = FormUtils.getNestedControl(rootControl, ...nestedControlNames);
        return control ? control.value : undefined;
    }
    /**
     * Mark the passed control as touched. If recursive, mark all of its children as touched
     */
    static markAsTouched(control, recursive = true) {
        if (control) {
            control.markAsTouched();
            if (recursive) {
                forEach(get(control, 'controls', []), (c) => FormUtils.markAsTouched(c, recursive));
            }
        }
    }
    /**
     * Mark the passed control as dirty. If recursive, mark all of its children as touched
     */
    static markAsDirty(control, recursive = true) {
        if (control) {
            control.markAsDirty();
            if (recursive) {
                forEach(get(control, 'controls', []), (c) => FormUtils.markAsDirty(c, recursive));
            }
        }
    }
    /**
     * Mark the passed control as dirty. If recursive, mark all of its children as touched
     */
    static markAsTouchedAndDirty(control, recursive = true) {
        if (control) {
            control.markAsDirty();
            control.markAsTouched();
            if (recursive) {
                forEach(get(control, 'controls', []), (c) => FormUtils.markAsTouchedAndDirty(c, recursive));
            }
        }
    }
    /**
     * Touch all controls and update value and validity
     * */
    static touchAllControls(control, onlyPristine = false) {
        if (control) {
            if (onlyPristine) {
                if (!control.touched) {
                    control.markAsTouched();
                    control.updateValueAndValidity();
                }
            }
            else {
                control.markAsTouched();
                control.updateValueAndValidity();
            }
            forEach(get(control, 'controls', []), (c) => FormUtils.touchAllControls(c, onlyPristine));
        }
    }
    /**
     * Untouch all conttrols, clear warnings and errors, and set all as Pristine
     */
    static untouchAllControls(control) {
        if (control) {
            control.markAsUntouched();
            control.markAsPristine();
            unset(control, 'warnings');
            forEach(get(control, 'controls', []), (c) => FormUtils.untouchAllControls(c));
        }
    }
    /** touch all controls and update value and validity*/
    static updateDescendantControlsValueAndValidity(control, options = {}) {
        if (control) {
            control.updateValueAndValidity(Object.assign({ onlySelf: true }, options));
            forEach(get(control, 'controls', []), (c) => FormUtils.updateDescendantControlsValueAndValidity(c, options));
        }
    }
    /**
     * Return true if the passed control or named control in the passed group has warnings
     * @param group control or group to test
     * @param field name of control in group to test. If not provided, returns if group has warnings
     */
    static hasWarnings(group, field) {
        if (group && group.enabled) {
            const control = field ? group.get(field) : group;
            return !!control && control.enabled && !isEmpty(get(control, 'warnings'));
        }
        return false;
    }
    static hasWarning(warning, control, field) {
        if (control && control.enabled) {
            control = field ? control.get(field) : control;
            return control && control.enabled && !!get(control, `warnings[${warning}]`);
        }
        return false;
    }
    static getWarning(group, field, warning) {
        if (group) {
            const control = field ? group.get(field) : group;
            return get(control, `warnings[${warning}]`);
        }
    }
    static setWarning(control, warning) {
        set(control, `warnings`, Object.assign(Object.assign({}, control['warnings']), { [warning]: true }));
    }
    static removeWarning(control, warning) {
        unset(control, `warnings['${warning}']`);
    }
    static clearWarnings(control, warnings = null) {
        if (control && hasIn(control, 'warnings')) {
            if (warnings) {
                forEach(castArray(warnings), (warning) => {
                    delete control['warnings'][warning];
                });
            }
            else {
                delete control['warnings'];
            }
        }
    }
    static resetControl(control, defaultValue) {
        control.reset(defaultValue);
        this.clearWarnings(control);
    }
    static hasErrors(group, field) {
        if (group && group.enabled) {
            const control = group.get(field);
            return control && control.enabled && control.invalid;
        }
        return false;
    }
    static hasError(error, group, field) {
        if (group && group.enabled) {
            const control = field ? group.get(field) : group;
            return control && control.enabled && control.hasError(error);
        }
        return false;
    }
    static getError(error, group, field) {
        if (group) {
            const control = field ? group.get(field) : group;
            return get(control, `errors[${error}]`);
        }
        else {
            return undefined;
        }
    }
    /**
     * Returns list of all controls that have errors starting with the passed control and
     * traversing all its children.
     */
    static getControlsWithErrors(control) {
        let errors = [];
        if (control.errors) {
            errors.push(control);
        }
        // add child controls with errors
        if ('controls' in control) {
            const children = Object.values(control.controls);
            children.forEach((child) => {
                const childErrors = FormUtils.getControlsWithErrors(child);
                errors = errors.concat(childErrors);
            });
        }
        return errors.filter((e) => !!e);
    }
    /**
     * Returns reactive form error state matcher
     * traversing all its children.
     */
    static getErrorStateMatcher(validatorFn) {
        const errorStateMatcher = new ErrorStateMatcher();
        errorStateMatcher.isErrorState = validatorFn;
        return errorStateMatcher;
    }
}

var GlobalSearchResultType$1;
(function (GlobalSearchResultType) {
    GlobalSearchResultType["InvoiceSearchResults"] = "invoiceSearchResults";
    GlobalSearchResultType["ShipmentSearchResults"] = "shipmentSearchResults";
    GlobalSearchResultType["DisputeSearchResults"] = "disputeSearchResults";
    GlobalSearchResultType["ClaimSearchResults"] = "claimSearchResults";
})(GlobalSearchResultType$1 || (GlobalSearchResultType$1 = {}));

var GlobalSearchAppURI;
(function (GlobalSearchAppURI) {
    GlobalSearchAppURI["CLAIMS_APP"] = "claims/claim-details/{{0}}";
    GlobalSearchAppURI["DISPUTES_APP"] = "disputes/disputes/view-dispute/{{0}}/{{1}}";
    GlobalSearchAppURI["INVOICE_APP"] = "invoice-auditor/invoicing/{{0}}";
    GlobalSearchAppURI["SHIPMENT_DETAILS_APP"] = "disputes/shipment-detail/{{0}}";
})(GlobalSearchAppURI || (GlobalSearchAppURI = {}));

class XpoLtlConditioningService {
    constructor() {
        this._emailSplitPattern = '[\\s,;]';
    }
    /**
     * condition time to two digit time
     */
    padTime(value) {
        if (value !== undefined && value !== null && value % 1 === 0 && value < 60 && value >= 0) {
            const retValue = '0' + value;
            return retValue.slice(-2);
        }
        return undefined;
    }
    /**
     * splits a zip-zipext into their component parts.
     * @param input
     */
    parseZipParts(input) {
        if (!input) {
            input = '';
        }
        const ret = { zip: '', zip4: '' };
        const index = input.indexOf('-');
        if (index >= 0) {
            ret.zip = input.substr(0, index);
            ret.zip4 = input.substr(index + 1);
            // tslint:disable-next-line:radix
        }
        else if (input.length > 5 && Number.isInteger(Number.parseInt(input))) {
            ret.zip = input.substr(0, 5);
            ret.zip4 = input.substr(5);
        }
        else {
            ret.zip = input;
        }
        return ret;
    }
    /**
     * splits a name by spaces returning the first element as the first name
     * and the reset of the elements merged back together as the last name.
     * @param name
     */
    parseNames(name) {
        if (!name) {
            name = '';
        }
        const nameParts = { firstName: '', lastName: '' };
        const names = name.split(' ');
        if (names && names.length > 0) {
            nameParts.firstName = names[0];
            delete names[0];
            nameParts.lastName = names.join(' ').trim();
        }
        else {
            nameParts.firstName = name;
        }
        return nameParts;
    }
    conditionProNumber(proNumber = '', digits = 9) {
        if (proNumber === '' || proNumber === null) {
            return '';
        }
        proNumber = this.clean(proNumber);
        proNumber = this.convert(proNumber, digits);
        return proNumber;
    }
    conditionCallNumber(callNumber = '', sicCd) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const arr = callNumber === null || callNumber === void 0 ? void 0 : callNumber.split('-');
        if (arr.length === 3 && ((_a = arr[0]) === null || _a === void 0 ? void 0 : _a.length) === 3) {
            if (((_b = arr[1]) === null || _b === void 0 ? void 0 : _b.length) === 1) {
                arr[1] = '0' + arr[1];
            }
            if (((_c = arr[2]) === null || _c === void 0 ? void 0 : _c.length) === 1) {
                arr[2] = '00' + arr[2];
            }
            if (((_d = arr[2]) === null || _d === void 0 ? void 0 : _d.length) === 2) {
                arr[2] = '0' + arr[2];
            }
            callNumber = arr[0] + '-' + arr[1] + '-' + arr[2];
        }
        else if (arr.length === 2 && ((_e = arr[0]) === null || _e === void 0 ? void 0 : _e.match(/^[0-9]+$/)) !== null && ((_f = arr[1]) === null || _f === void 0 ? void 0 : _f.match(/^[0-9]+$/)) !== null) {
            if (((_g = arr[0]) === null || _g === void 0 ? void 0 : _g.length) === 1) {
                arr[0] = '0' + arr[0];
            }
            if (((_h = arr[1]) === null || _h === void 0 ? void 0 : _h.length) === 1) {
                arr[1] = '00' + arr[1];
            }
            if (((_j = arr[1]) === null || _j === void 0 ? void 0 : _j.length) === 2) {
                arr[1] = '0' + arr[1];
            }
            callNumber = arr[0] + '-' + arr[1];
        }
        const callNumberDigits = this.clean(callNumber);
        if ((callNumber === null || callNumber === void 0 ? void 0 : callNumber.length) < 4 ||
            (callNumber === null || callNumber === void 0 ? void 0 : callNumber.length) > 10 ||
            callNumberDigits.length < 3 ||
            callNumberDigits.length > 5) {
            return '';
        }
        const callNumberSic = callNumber === null || callNumber === void 0 ? void 0 : callNumber.substring(0, 3).toUpperCase();
        const containSicCd = new RegExp(XpoLtlValidationRegexPatterns.sicValidationPattern).test(callNumberSic);
        const sicPart = containSicCd ? callNumberSic : sicCd.toUpperCase();
        let part2 = containSicCd ? callNumber.substring(3) : callNumber;
        part2 = part2.substring(0, 1) === '-' ? part2.slice(1) : part2;
        if (!new RegExp('^(\\d{1,2}[-]\\d{1,3}|\\d{4,5})$').test(part2)) {
            return '';
        }
        const validCallNumber = this.convertToValidCallNumber(part2);
        if (!new RegExp(XpoLtlValidationRegexPatterns.validCallNumber).test(`${sicPart}-${validCallNumber}`)) {
            return '';
        }
        return `${sicPart}-${validCallNumber}`;
    }
    convertToValidCallNumber(callNumber) {
        let datePart, sequenceNbr;
        if (callNumber.includes('-')) {
            const callNumberSplit = callNumber.split('-');
            datePart = callNumberSplit[0].padStart(2, '0');
            sequenceNbr = callNumberSplit[1].padStart(3, '0');
        }
        else {
            if (callNumber.length > 4) {
                datePart = callNumber.substring(0, 2);
                sequenceNbr = callNumber.substring(2);
            }
            else {
                datePart = `0${callNumber.substring(0, 1)}`;
                sequenceNbr = callNumber.substring(1);
            }
        }
        return `${datePart}-${sequenceNbr}`;
    }
    conditionChildProNumber(proNumber) {
        proNumber = proNumber.replace(/\D/g, ''); // clean signs
        const part1 = proNumber.slice(0, 3).padStart(4, '0'); // fill out with zeros at left
        const part2 = proNumber.slice(3).padStart(7, '0'); // fill out with zeros at left
        return `${part1}${part2}`; // total proNumber length is 11, 4 from first part and 7 from second one
    }
    removeHtmlFromString(input, tagExceptions) {
        let exceptionString = '[^<>]{1,}';
        if (tagExceptions) {
            tagExceptions.forEach((tag) => {
                let modifiedTag = tag;
                if (!modifiedTag.startsWith('<')) {
                    modifiedTag = `<${modifiedTag}`;
                }
                if (!modifiedTag.endsWith('>')) {
                    modifiedTag = `${modifiedTag}>`;
                }
                exceptionString = `${exceptionString}[^${modifiedTag}]{1,}`;
            });
        }
        const regexp = new RegExp(`<{1}${exceptionString}>{1}`, 'g');
        return input.replace(regexp, '');
    }
    conditionEmailGroup(inputValue) {
        if (!inputValue) {
            return undefined;
        }
        return inputValue
            .split(new RegExp(this._emailSplitPattern, 'g'))
            .map((item) => item.trim())
            .filter((item) => !!item);
    }
    clean(proNumber) {
        return proNumber === null || proNumber === void 0 ? void 0 : proNumber.replace(/\D/g, '');
    }
    convert(proNumber = '', digits = 9) {
        let part1, part2, trim, trimmed;
        trim = partialRight(this.trim.bind(this), '0', 'g', digits);
        trimmed = trim(proNumber);
        if (trimmed.length < 9) {
            // if it had a leading 0 as part of the real number
            if (trimmed.length < 8) {
                trimmed = `00${trimmed}`;
            }
            else {
                trimmed = `0${trimmed}`;
            }
        }
        part1 = trimmed.slice(0, 3);
        part2 = trimmed.slice(3);
        part2 = part2.length > 6 ? trim(part2) : part2;
        let retValue = '';
        if (digits === 11) {
            retValue = `0${part1}0${part2}`;
        }
        else if (digits === 10) {
            retValue = `${part1}-${part2}`;
        }
        else {
            retValue = part1.concat(part2);
        }
        return retValue;
    }
    trim(string = '', what = ',', flags = 'g') {
        let escaped, find;
        escaped = what.replace(/[\[\](){}?*+\^$\\.|\-]/g, '\\$&');
        find = new RegExp('^[' + escaped + ']', flags);
        return string.replace(find, '');
    }
    sliceError(errorMsg) {
        if (typeof errorMsg === 'string') {
            return errorMsg
                .replace(/.*?:/, '')
                .slice(0, -1)
                .trim();
        }
        else {
            return '';
        }
    }
}
XpoLtlConditioningService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlConditioningService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlConditioningService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlConditioningService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlConditioningService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class XpoLtlFormatValidationService {
    constructor(conditioningService) {
        this.conditioningService = conditioningService;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.numberTrailerPattern = XpoLtlValidationRegexPatterns.numberTrailerPattern;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.letterTrailerPattern = XpoLtlValidationRegexPatterns.letterTrailerPattern;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.numberCheck = XpoLtlValidationRegexPatterns.numberCheck;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.doorPattern = XpoLtlValidationRegexPatterns.doorPattern;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.nineDigitPro = XpoLtlValidationRegexPatterns.nineDigitPro;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.tenDigitPro = XpoLtlValidationRegexPatterns.tenDigitPro;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.elevenDigitPro = XpoLtlValidationRegexPatterns.elevenDigitPro;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.emailValidationPattern = XpoLtlValidationRegexPatterns.emailValidationPattern;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.phoneNumberPattern = XpoLtlValidationRegexPatterns.phoneNumberPattern;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.multiEmailsPattern = XpoLtlValidationRegexPatterns.multiEmailsPattern;
        /**
         * This expression matches three different formats of postal codes: 5 digit US ZIP code,
         * 5 digit US ZIP code + 4, and 6 digit alphanumeric Canadian Postal Code. The first one
         * must be 5 numeric digits. The ZIP+4 must be 5 numeric digits, a hyphen, and then 4
         * numeric digits. The Canadian postal code must be of the form ANA NAN where A is any
         * uppercase alphabetic character and N is a numeric digit from 0 to 9.
         */
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.usZipCode = XpoLtlValidationRegexPatterns.usZipCode;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.caPostalCode = XpoLtlValidationRegexPatterns.caPostalCode;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.mxPostalCode = XpoLtlValidationRegexPatterns.mxPostalCode;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.madCodeValidationPattern = XpoLtlValidationRegexPatterns.madCodeValidationPattern;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.billToMadCodeValidationPattern = XpoLtlValidationRegexPatterns.billToMadCodeValidationPattern;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.sicValidationPattern = XpoLtlValidationRegexPatterns.sicValidationPattern;
        /**
         * @deprecated Use XpoLtlValidationRegexPatterns instead
         */
        this.nmfcValidationPattern = XpoLtlValidationRegexPatterns.nmfcValidationPattern;
        this._emailSplitPattern = '[\\s,;]';
    }
    isValidEmail(inputValue) {
        if (!inputValue) {
            return false;
        }
        const regExp = new RegExp(XpoLtlValidationRegexPatterns.emailValidationPattern, 'i');
        return regExp.test(inputValue);
    }
    isValidEmails(inputValue) {
        if (Array.isArray(inputValue)) {
            return inputValue.every((value) => this.isValidEmail(value));
        }
        return this.isValidEmails(this.splitEmailGroup(inputValue));
    }
    splitEmailGroup(inputValue) {
        if (!inputValue) {
            return undefined;
        }
        return inputValue
            .split(new RegExp(this._emailSplitPattern, 'g'))
            .map((item) => item.trim())
            .filter((item) => !!item);
    }
    isCallNumber(inputValue, defaultSicCd) {
        const isValidCallNumber = new RegExp(XpoLtlValidationRegexPatterns.validCallNumber).test(inputValue);
        if (isValidCallNumber) {
            return true;
        }
        else {
            return this.conditioningService.conditionCallNumber(inputValue, defaultSicCd) !== '';
        }
    }
    isValidProNumber(inputValue) {
        return this.isValidProNumberCheckDigit(inputValue);
    }
    isValidChildProNumber(inputValue) {
        return this.isValidChildProNumberCheckDigit(inputValue) || this.canBeValidChidlPLTPro(inputValue);
    }
    canBeValidChidlPLTPro(inputValue) {
        let value = false;
        if (inputValue.indexOf('-') > -1 && inputValue.length === 11) {
            let newSearchKey = '';
            const arr = inputValue.split('-');
            newSearchKey += arr[0];
            newSearchKey += arr[1];
            value = this.isValidChildProNumberCheckDigit(newSearchKey);
        }
        // if pro start with zero and it is of length 11, it may be plt child pro
        if (!value) {
            if (inputValue.charAt(0) === '0' && inputValue.length === 11) {
                return true;
            }
        }
        return value;
    }
    isValidCallNumber(inputValue) {
        return new RegExp(XpoLtlValidationRegexPatterns.callNumber).test(inputValue);
    }
    isValidClaimNumber(inputValue) {
        return new RegExp(XpoLtlValidationRegexPatterns.claimNumber, 'i').test(inputValue);
    }
    isValidDisputeNumber(inputValue) {
        return new RegExp(XpoLtlValidationRegexPatterns.disputePattern, 'i').test(inputValue);
    }
    isValidRouteName(inputValue) {
        return new RegExp(XpoLtlValidationRegexPatterns.routeName).test(inputValue);
    }
    isValidDoorNumber(inputValue) {
        const regExp = new RegExp(XpoLtlValidationRegexPatterns.doorPattern);
        return regExp.test(inputValue);
    }
    isValidMexicoPostalCode(inputValue) {
        return new RegExp(XpoLtlValidationRegexPatterns.mxPostalCode).test(inputValue);
    }
    isValidUsZipCode(inputValue) {
        return new RegExp(XpoLtlValidationRegexPatterns.usZipCode).test(inputValue);
    }
    isValidCanadianPostalCode(inputValue) {
        return new RegExp(XpoLtlValidationRegexPatterns.caPostalCode).test(inputValue);
    }
    isValidTrailerNumber(inputValue) {
        const numberTrailerRegExp = new RegExp(XpoLtlValidationRegexPatterns.numberTrailerPattern).test(inputValue);
        const letterTrailerRegExp = new RegExp(XpoLtlValidationRegexPatterns.letterTrailerPattern).test(inputValue);
        return numberTrailerRegExp || letterTrailerRegExp;
    }
    isValidTractorNumber(inputValue) {
        return new RegExp(XpoLtlValidationRegexPatterns.tractorPattern).test(inputValue);
    }
    isValidProNumberCheckDigit(inputValue) {
        if (!new RegExp(XpoLtlValidationRegexPatterns.validProCharacterCheck).test(toString(inputValue))) {
            return false;
        }
        const proNumber = this.conditioningService.conditionProNumber(inputValue);
        if (proNumber === '' || proNumber.length < 9 || proNumber.length > 11) {
            return false;
        }
        // divide first 8 chars by 7 multiple remainder by 7
        const checkDigit = Number(proNumber.substring(8));
        // tslint:disable-next-line:radix
        const number = Number.parseInt(proNumber.substring(0, 8));
        const mod = number % 7;
        return mod === checkDigit;
    }
    isValidChildProNumberCheckDigit(inputValue) {
        if (!new RegExp(XpoLtlValidationRegexPatterns.validProCharacterCheck).test(toString(inputValue))) {
            return false;
        }
        const proNumber = inputValue;
        if (proNumber === '' || proNumber.length !== 10) {
            return false;
        }
        const checkDigit = Number(proNumber.substring(9));
        // tslint:disable-next-line:radix
        const number = Number.parseInt(proNumber.substring(0, 9));
        const mod = number % 7;
        return mod === checkDigit;
    }
    // Added New function to verify entered Pro is of 9 or 11 digit
    proNumberCheckDigit(inputValue) {
        const proNumber = this.conditioningService.conditionProNumber(inputValue);
        if (proNumber === '' || proNumber.length < 9 || proNumber.length > 11) {
            return false;
        }
        return true;
    }
    isSicValid(value) {
        return (value != null && value.length === 3 && new RegExp(XpoLtlValidationRegexPatterns.sicValidationPattern).test(value));
    }
    isMadCodeValid(value) {
        return (value != null &&
            value.length === 11 &&
            new RegExp(XpoLtlValidationRegexPatterns.madCodeValidationPattern).test(value));
    }
    isBillToMadCodeValid(value) {
        return (value != null &&
            value.length === 11 &&
            new RegExp(XpoLtlValidationRegexPatterns.billToMadCodeValidationPattern).test(value));
    }
    isValidNumeric(value) {
        return value != null && trim(value).length > 0 && !isNaN(value);
    }
    isValidAlphaNumeric(value) {
        return value != null && /^[a-z0-9]+$/i.test(value);
    }
    containsLetters(value) {
        return value != null && /[a-z]/i.test(value);
    }
    isNmfcValid(value) {
        return (value != null && value.length >= 4 && new RegExp(XpoLtlValidationRegexPatterns.nmfcValidationPattern).test(value));
    }
}
XpoLtlFormatValidationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlFormatValidationService, deps: [{ token: XpoLtlConditioningService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlFormatValidationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlFormatValidationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlFormatValidationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: XpoLtlConditioningService }]; } });

var GlobalSearchAppName$1;
(function (GlobalSearchAppName) {
    GlobalSearchAppName["CLAIMS_APP"] = "claims";
    GlobalSearchAppName["DISPUTES_APP"] = "disputes";
    GlobalSearchAppName["INVOICE_APP"] = "invoicing-workbench";
    GlobalSearchAppName["SHIPMENTS_APP"] = "disputes";
    GlobalSearchAppName["PND_APP"] = "pnd";
})(GlobalSearchAppName$1 || (GlobalSearchAppName$1 = {}));

class GlobalSearchResponseTypePipe {
    transform(resultType, count = 0, isProSearch) {
        if (!resultType) {
            return '';
        }
        let typeString = `${count} `;
        switch (resultType) {
            case GlobalSearchResultType$1.ClaimSearchResults: {
                typeString += 'Claim';
                break;
            }
            case GlobalSearchResultType$1.DisputeSearchResults: {
                typeString += 'Dispute';
                break;
            }
            case GlobalSearchResultType$1.InvoiceSearchResults: {
                typeString += 'Invoice';
                break;
            }
            case GlobalSearchResultType$1.ShipmentSearchResults: {
                typeString += 'Shipment';
                break;
            }
            default: {
                typeString += resultType;
                break;
            }
        }
        if (count > 1) {
            typeString += 's';
        }
        if (isProSearch &&
            (resultType === GlobalSearchResultType$1.ClaimSearchResults ||
                resultType === GlobalSearchResultType$1.DisputeSearchResults)) {
            typeString = `PRO in ${typeString}`;
        }
        return typeString;
    }
}
GlobalSearchResponseTypePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: GlobalSearchResponseTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
GlobalSearchResponseTypePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: GlobalSearchResponseTypePipe, name: "globalSearchResponseType" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: GlobalSearchResponseTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'globalSearchResponseType',
                }]
        }] });

class ProFormatterPipe {
    constructor(formatService, conditioningService) {
        this.formatService = formatService;
        this.conditioningService = conditioningService;
    }
    transform(pro, digits) {
        if (!pro || !digits) {
            return undefined;
        }
        if (this.formatService.isValidProNumber(pro)) {
            return this.conditioningService.conditionProNumber(pro, digits);
        }
        return pro;
    }
}
ProFormatterPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ProFormatterPipe, deps: [{ token: XpoLtlFormatValidationService }, { token: XpoLtlConditioningService }], target: i0.ɵɵFactoryTarget.Pipe });
ProFormatterPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ProFormatterPipe, name: "proFormatter" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ProFormatterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'proFormatter',
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlFormatValidationService }, { type: XpoLtlConditioningService }]; } });

class EmptyValuePipe {
    transform(value, emptyValue = '-') {
        return value || emptyValue;
    }
}
EmptyValuePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EmptyValuePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
EmptyValuePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EmptyValuePipe, name: "emptyValue" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EmptyValuePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'emptyValue',
                }]
        }] });

/**
 * Returns string split into words at Capital letter boundaries.
 *
 * Ex:
 *  'ThisIsATest' => 'This Is A Test'
 */
class AsWordsPipe {
    transform(value, overrides) {
        return _.get(overrides, value, _.words(_.trim(value)).join(' '));
    }
}
AsWordsPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AsWordsPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
AsWordsPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AsWordsPipe, name: "asWords" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AsWordsPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'asWords',
                }]
        }] });

var GlobalSearchLocalStorageDataType;
(function (GlobalSearchLocalStorageDataType) {
    GlobalSearchLocalStorageDataType["RecentSearchList"] = "LTLGlobalSearch.RecentSearchList";
})(GlobalSearchLocalStorageDataType || (GlobalSearchLocalStorageDataType = {}));
class XpoLtlGlobalSearchComponent {
    constructor(formatService, conditioningService, windowService, configManagerService, appMetadataApiService, elRef, router) {
        this.formatService = formatService;
        this.conditioningService = conditioningService;
        this.windowService = windowService;
        this.configManagerService = configManagerService;
        this.appMetadataApiService = appMetadataApiService;
        this.elRef = elRef;
        this.router = router;
        this.activateGlobalSearchKeyCode = 's';
        this.unsubscriber = new Unsubscriber();
        this.OPEN_PANEL_OVERLAY_WIDTH = 600;
        this.lastAutocompletePanleScrollPosition = 0;
        this.resetInputTimer$ = new Subject();
        this.GlobalSearchResultType = GlobalSearchResultType$1;
        this.DisputeTypeCd = DisputeTypeCd;
        this.isProSearch = false;
        this.openExternalPageOnClick = false;
        this.isFocusedSubject = new BehaviorSubject(false);
        this.isFocused$ = this.isFocusedSubject.asObservable();
        this.globalSearchResponseSubject = new BehaviorSubject(undefined);
        this.globalSearchResponse$ = this.globalSearchResponseSubject.asObservable();
        this.isPerformingGlobalSearchSubject = new BehaviorSubject(false);
        this.isPerformingGlobalSearch$ = this.isPerformingGlobalSearchSubject.asObservable();
        this.showInvalidSearchSubject = new BehaviorSubject(false);
        this.showInvalidSearch$ = this.showInvalidSearchSubject.asObservable();
        this.recentGlobalSearchListSubject = new BehaviorSubject([]);
        this.recentGlobalSearchList$ = this.recentGlobalSearchListSubject.asObservable();
    }
    get activateGlobalSearchKeyCodeString() {
        return this.activateGlobalSearchKeyCode.toUpperCase();
    }
    get isFocused() {
        return this.isFocusedSubject.value;
    }
    set isFocused(focused) {
        this.isFocusedSubject.next(focused);
    }
    get globalSearchResponse() {
        return this.globalSearchResponseSubject.value;
    }
    set globalSearchResponse(searchResponse) {
        this.globalSearchResponseSubject.next(searchResponse);
    }
    get isPerformingGlobalSearch() {
        return this.isPerformingGlobalSearchSubject.value;
    }
    get recentGlobalSearchList() {
        return this.recentGlobalSearchListSubject.value;
    }
    ngOnInit() {
        this.currentAppName = (this.configManagerService.getSetting(ConfigManagerProperties$1.appName) || '').toLowerCase();
        this._initializeSearchControl();
        this._setRecentSearchList();
        console.warn('The global search component has been deprecated. Please use component from xpo-ltl/ngx-ltl-global-search.');
    }
    ngAfterViewInit() {
        this._setOverlayWidth();
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    onKeydownHandler(event) {
        if (event.altKey && event.code === `Key${this.activateGlobalSearchKeyCode.toUpperCase()}`) {
            event.preventDefault();
            this.focus();
        }
        if (event.ctrlKey && this.isFocused) {
            this.openExternalPageOnClick = true;
        }
    }
    onKeyupHandler(event) {
        if (event.key && event.key.toLowerCase() === 'control' && this.isFocused) {
            this.openExternalPageOnClick = false;
        }
    }
    onClickHandler($event) {
        if (this.isFocused &&
            !this.elRef.nativeElement.contains($event.target) &&
            !get($event.target, 'className', '').includes('xpo-LtlGlobalSearch')) {
            this.blur();
            this._resetLastScrollPosition();
        }
    }
    // #region PUBLIC API
    /**
     * Set the focus to the input control
     */
    focus() {
        this.searchInput.focus();
        this.searchInputElement.nativeElement.setSelectionRange(0, this.searchInput.value.length);
    }
    /**
     * Blurs the focus to the input control
     */
    blur() {
        if (this.isFocused) {
            this.isFocused = false;
            this.searchInputElement.nativeElement.blur();
        }
    }
    /**
     * Sets the search input value to the global search input control
     */
    setGlobalSearchInputValue(inputValue) {
        this.searchControl.setValue(inputValue);
    }
    // #endregion PUBLIC AIP
    // #region PRIVATE API
    _initializeSearchControl() {
        this.searchControl = new FormControl('');
        this._setControlWatcher();
        this._setInputDelayTimer();
    }
    _setScrollWatcher() {
        this.searchAutocomplete.opened.pipe(debounceTime(25), takeUntil(this.searchAutocomplete.closed)).subscribe(() => {
            if (this.searchAutocomplete.panel &&
                this.searchAutocomplete.panel.nativeElement.scrollTop !== this.lastAutocompletePanleScrollPosition) {
                this.searchAutocomplete.panel.nativeElement.scrollTop = this.lastAutocompletePanleScrollPosition;
            }
        });
    }
    _setControlWatcher() {
        this.searchControl.valueChanges
            .pipe(distinctUntilChanged(), tap(() => this.showInvalidSearchSubject.next(false)), debounceTime(100), filter((val) => typeof val === 'string'), takeUntil(this.unsubscriber.done$))
            .subscribe((searchKey) => {
            const normalizedSearchKey = this._normalizeSearchKey(searchKey);
            if (this._matchesPreviousSearchKey(normalizedSearchKey)) {
                return;
            }
            if (this._canPerformGlobalSearch(normalizedSearchKey)) {
                this._performGlobalSearch(normalizedSearchKey)
                    .pipe(take(1))
                    .subscribe(() => { });
            }
            else {
                this.globalSearchResponse = undefined;
                this.previousSearchKey = undefined;
                this._resetLastScrollPosition();
                this._resetInputTimer();
            }
        });
    }
    _setInputDelayTimer() {
        this.resetInputTimer$
            .pipe(filter(() => !!this.searchInput.value), switchMap(() => timer(1500)))
            .subscribe(() => {
            this.showInvalidSearchSubject.next(!this.isPerformingGlobalSearch && !this.globalSearchResponse && !!this.searchControl.value);
        });
    }
    _resetInputTimer() {
        this.resetInputTimer$.next();
    }
    _performGlobalSearch(searchTxt) {
        this.isPerformingGlobalSearchSubject.next(true);
        this.isProSearch = this.formatService.isValidProNumber(searchTxt);
        if (this.previousSearchKey !== searchTxt) {
            this.globalSearchResponse = undefined;
            this.previousSearchKey = searchTxt;
        }
        if (this.isProSearch) {
            searchTxt = this.conditioningService.conditionProNumber(searchTxt, 11);
        }
        return new Observable((observer) => {
            const pathParams = new PerformAppGlobalSearchPath();
            pathParams.searchTxt = searchTxt;
            const queryParams = new PerformAppGlobalSearchQuery();
            queryParams.globalSearchDetailCds = [
                GlobalSearchDetailCd.CLAIM_RESULT,
                GlobalSearchDetailCd.SHIPMENT_RESULT,
                GlobalSearchDetailCd.DISPUTE_RESULT,
                GlobalSearchDetailCd.INVOICE_RESULT,
            ];
            this.appMetadataApiService
                .performAppGlobalSearch(pathParams, queryParams, { loadingOverlayEnabled: false, toastOnError: true })
                .pipe(map((globalSearchResp) => this._removeEmptyGlobalSearchResultItems(globalSearchResp)), map((globalSearchResp) => this._transformToLocalPerformAppGlobalSearchResponse(globalSearchResp)))
                .subscribe((globalSearchResp) => {
                this.showInvalidSearchSubject.next(!get(globalSearchResp, 'listInfo.totalRowCount', 0));
                this.globalSearchResponse = globalSearchResp;
                observer.next();
                observer.complete();
            }, (error) => {
                this.globalSearchResponse = undefined;
                this.isPerformingGlobalSearchSubject.next(false);
                this.showInvalidSearchSubject.next(true);
                observer.next(error);
                observer.complete();
            }, () => this.isPerformingGlobalSearchSubject.next(false));
        });
    }
    _removeEmptyGlobalSearchResultItems(globalSearchResp) {
        if (size(get(globalSearchResp, 'globalSearchResult', []))) {
            // remove empty return result object from globalSearchResult to prevent empty mat optgroup display
            Object.keys(globalSearchResp.globalSearchResult).forEach((currentKey) => {
                if (!size(globalSearchResp.globalSearchResult[currentKey])) {
                    delete globalSearchResp.globalSearchResult[currentKey];
                }
            });
        }
        return globalSearchResp;
    }
    _transformToLocalPerformAppGlobalSearchResponse(globalSearchResp) {
        const localGlobalSearchResp = cloneDeep(globalSearchResp);
        switch (this.currentAppName) {
            case GlobalSearchAppName$1.CLAIMS_APP: {
                if (size(get(localGlobalSearchResp, 'globalSearchResult.claimSearchResults', []))) {
                    localGlobalSearchResp.primaryAppGlobalSearchResult = {
                        searchResult: localGlobalSearchResp.globalSearchResult.claimSearchResults,
                        key: 'claimSearchResults',
                    };
                    delete localGlobalSearchResp.globalSearchResult.claimSearchResults;
                }
                break;
            }
            case GlobalSearchAppName$1.DISPUTES_APP: {
                if (size(get(localGlobalSearchResp, 'globalSearchResult.disputeSearchResults', []))) {
                    localGlobalSearchResp.primaryAppGlobalSearchResult = {
                        searchResult: localGlobalSearchResp.globalSearchResult.disputeSearchResults,
                        key: 'disputeSearchResults',
                    };
                    delete localGlobalSearchResp.globalSearchResult.disputeSearchResults;
                }
                break;
            }
            case GlobalSearchAppName$1.INVOICE_APP: {
                if (size(get(localGlobalSearchResp, 'globalSearchResult.invoiceSearchResults', []))) {
                    localGlobalSearchResp.primaryAppGlobalSearchResult = {
                        searchResult: localGlobalSearchResp.globalSearchResult.invoiceSearchResults,
                        key: 'invoiceSearchResults',
                    };
                    delete localGlobalSearchResp.globalSearchResult.invoiceSearchResults;
                }
                break;
            }
            case GlobalSearchAppName$1.SHIPMENTS_APP: {
                if (size(get(localGlobalSearchResp, 'globalSearchResult.invoiceSearchResults', []))) {
                    localGlobalSearchResp.primaryAppGlobalSearchResult = {
                        searchResult: localGlobalSearchResp.globalSearchResult.shipmentSearchResults,
                        key: 'shipmentSearchResults',
                    };
                    delete localGlobalSearchResp.globalSearchResult.shipmentSearchResults;
                }
                break;
            }
        }
        return localGlobalSearchResp;
    }
    _canPerformGlobalSearch(searchKey) {
        if (typeof searchKey !== 'string') {
            return false;
        }
        return (this.formatService.isValidProNumber(searchKey) ||
            this.formatService.isValidClaimNumber(searchKey) ||
            this.formatService.isValidDisputeNumber(searchKey));
    }
    _setOverlayWidth() {
        this.searchAutocomplete.panelWidth = this.OPEN_PANEL_OVERLAY_WIDTH;
    }
    _isLocalBuild() {
        return this.configManagerService.getSetting(ConfigManagerProperties$1.buildVersion) === 'local-version';
    }
    _setRecentSearchList() {
        this.recentGlobalSearchListSubject.next(this._getRecentSearchesFromLocalStorage());
    }
    _getRecentSearchesFromLocalStorage() {
        const recentSearchList = localStorage.getItem(GlobalSearchLocalStorageDataType.RecentSearchList);
        return recentSearchList ? JSON.parse(recentSearchList) : [];
    }
    _setSelectedGlobalSearchItemToLocalStorage() {
        const localStorageList = uniqWith([this.selectedGlobalSearchItem, ...this._getRecentSearchesFromLocalStorage()], isEqual).slice(0, 5);
        localStorage.setItem(GlobalSearchLocalStorageDataType.RecentSearchList, JSON.stringify(localStorageList));
    }
    _navigateToSelectedItem() {
        const navigationLink = this._generateGlobalSearchLink();
        if (!this.openExternalPageOnClick) {
            if (this._isNavigatingToLocalPath()) {
                this.router.navigateByUrl(navigationLink);
            }
            else {
                this.windowService.nativeWindow.location.href = navigationLink;
            }
        }
        else {
            this.openExternalPageOnClick = false;
            this.windowService.nativeWindow.open(navigationLink, '_blank', 'noopener');
        }
        this.selectedGlobalSearchItem = undefined;
    }
    // Need to manually mapping untiol app metadata api is developed to return application data
    _isNavigatingToLocalPath() {
        switch (this.selectedGlobalSearchItem.globalSearchResultType) {
            case GlobalSearchResultType$1.ClaimSearchResults: {
                return this.currentAppName.includes(GlobalSearchAppName$1.CLAIMS_APP);
            }
            case GlobalSearchResultType$1.ShipmentSearchResults:
            case GlobalSearchResultType$1.DisputeSearchResults: {
                return this.currentAppName.includes(GlobalSearchAppName$1.DISPUTES_APP);
            }
            case GlobalSearchResultType$1.InvoiceSearchResults: {
                return this.currentAppName.includes(GlobalSearchAppName$1.INVOICE_APP);
            }
            default: {
                return false;
            }
        }
    }
    _generateGlobalSearchLink() {
        const originURL = document.location.origin;
        const searchResult = this.selectedGlobalSearchItem.searchResult;
        let primaryKey;
        let secondaryKey;
        let appURI;
        let appPathURL = '';
        if (!this._isLocalBuild()) {
            appPathURL += 'appjs/';
        }
        switch (get(this.selectedGlobalSearchItem, 'globalSearchResultType')) {
            case GlobalSearchResultType$1.ClaimSearchResults: {
                appURI = GlobalSearchAppURI.CLAIMS_APP;
                primaryKey = searchResult.claimId;
                break;
            }
            case GlobalSearchResultType$1.DisputeSearchResults: {
                appURI = GlobalSearchAppURI.DISPUTES_APP;
                primaryKey = searchResult.disputeId;
                secondaryKey = searchResult.workflowItemInstId;
                break;
            }
            case GlobalSearchResultType$1.ShipmentSearchResults: {
                appURI = GlobalSearchAppURI.SHIPMENT_DETAILS_APP;
                primaryKey = searchResult.shipmentInstId;
                break;
            }
            case GlobalSearchResultType$1.InvoiceSearchResults: {
                appURI = GlobalSearchAppURI.INVOICE_APP;
                primaryKey = this.conditioningService.conditionProNumber(searchResult.proNbr, 11);
                break;
            }
        }
        appURI = appURI.replace('{{0}}', `${primaryKey}`).replace('{{1}}', `${secondaryKey}`);
        if (this._isNavigatingToLocalPath()) {
            return appURI
                .split('/')
                .slice(1)
                .join('/');
        }
        appPathURL += appURI;
        return `${originURL}/${appPathURL}`;
    }
    _matchesPreviousSearchKey(searchKey) {
        let prevKey = defaultTo(this.previousSearchKey, '').trim();
        if (this.formatService.isValidProNumber(searchKey)) {
            searchKey = this.conditioningService.conditionProNumber(searchKey, 11);
        }
        if (this.formatService.isValidProNumber(prevKey)) {
            prevKey = this.conditioningService.conditionProNumber(prevKey, 11);
        }
        return prevKey === searchKey;
    }
    _normalizeSearchKey(searchKey) {
        const trimmedSearchKey = defaultTo(searchKey, '').trim();
        return trimmedSearchKey;
    }
    _resetLastScrollPosition() {
        this.lastAutocompletePanleScrollPosition = 0;
    }
    _setLastScrollPosition(panelElRef) {
        this.lastAutocompletePanleScrollPosition = get(panelElRef, 'nativeElement.scrollTop', 0);
    }
    selectItem($event) {
        this.selectedGlobalSearchItem = $event.option.value;
        this._setSelectedGlobalSearchItemToLocalStorage();
        this._setLastScrollPosition($event.source.panel);
        if (!this.openExternalPageOnClick) {
            this.searchControl.setValue('', { emitEvent: false });
            this.globalSearchResponse = undefined;
            this.blur();
        }
        else {
            this.searchControl.setValue(this.previousSearchKey, { emitEvent: false });
            timer().subscribe(() => {
                this.focus();
            });
        }
        this._navigateToSelectedItem();
    }
    handleFilterFocus() {
        const normalizedSearchInputVal = this._normalizeSearchKey(this.searchInput.value);
        this._setScrollWatcher();
        this._setRecentSearchList();
        this.isFocused = true;
        if (this._canPerformGlobalSearch(normalizedSearchInputVal) &&
            (!this._matchesPreviousSearchKey(normalizedSearchInputVal) || !this.globalSearchResponse)) {
            this._performGlobalSearch(normalizedSearchInputVal)
                .pipe(take(1))
                .subscribe(() => { });
        }
        else if (this._matchesPreviousSearchKey(normalizedSearchInputVal) &&
            (!!this.globalSearchResponse || !!size(this.recentGlobalSearchList)) &&
            !this.searchAutocompleteTrigger.panelOpen) {
            this.searchAutocompleteTrigger.openPanel();
        }
    }
}
XpoLtlGlobalSearchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlGlobalSearchComponent, deps: [{ token: XpoLtlFormatValidationService }, { token: i3$1.ConditioningService }, { token: XpoLtlWindowService }, { token: i2$3.ConfigManagerService }, { token: i1.AppMetadataApiService }, { token: i0.ElementRef }, { token: i6$1.Router }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlGlobalSearchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlGlobalSearchComponent, selector: "xpo-ltl-global-search", inputs: { activateGlobalSearchKeyCode: "activateGlobalSearchKeyCode" }, host: { listeners: { "document:keydown": "onKeydownHandler($event)", "document:keyup": "onKeyupHandler($event)", "document:click": "onClickHandler($event)" } }, viewQueries: [{ propertyName: "searchInput", first: true, predicate: MatInput, descendants: true }, { propertyName: "searchInputElement", first: true, predicate: ["searchInput"], descendants: true }, { propertyName: "searchAutocomplete", first: true, predicate: MatAutocomplete, descendants: true }, { propertyName: "searchAutocompleteTrigger", first: true, predicate: MatAutocompleteTrigger, descendants: true }], ngImport: i0, template: "<div [class.xpo-LtlGlobalSearch--focused]=\"isFocused$ | async\" class=\"xpo-LtlGlobalSearch\">\n  <mat-form-field floatLabel=\"never\" class=\"xpo-LtlGlobalSearch--form-field\">\n    <mat-label\n      >Search (ALT+<span class=\"xpo-LtlGlobalSearch--underline\">{{ activateGlobalSearchKeyCodeString }}</span\n      >)</mat-label\n    >\n    <mat-icon class=\"xpo-LtlGlobalSearch--form-field-icon\" matPrefix>search</mat-icon>\n    <mat-progress-spinner\n      *ngIf=\"isPerformingGlobalSearch$ | async\"\n      mode=\"indeterminate\"\n      [diameter]=\"22\"\n      matSuffix\n    ></mat-progress-spinner>\n    <input\n      [formControl]=\"searchControl\"\n      #searchInput\n      matInput\n      matAutocompleteTrigger\n      [matAutocomplete]=\"auto\"\n      type=\"text\"\n      class=\"xpo-LtlGlobalSearch--form-field-input\"\n      (focus)=\"handleFilterFocus()\"\n    />\n    <mat-autocomplete\n      #searchAutocomplete\n      #auto=\"matAutocomplete\"\n      class=\"xpo-LtlGlobalSearch--autocomplete\"\n      (optionSelected)=\"selectItem($event)\"\n    >\n      <div *ngIf=\"(globalSearchResponse$ | async)?.listInfo?.totalRowCount > 0\">\n        <mat-optgroup\n          class=\"xpo-LtlGlobalSearch--autocomplete-optgroup\"\n          *ngIf=\"globalSearchResponse?.primaryAppGlobalSearchResult\"\n        >\n          <mat-label class=\"xpo-LtlGlobalSearch--autocomplete-label\">{{\n            globalSearchResponse?.primaryAppGlobalSearchResult?.key\n              | globalSearchResponseType\n                : globalSearchResponse?.primaryAppGlobalSearchResult?.searchResult?.length\n                : isProSearch\n          }}</mat-label>\n          <mat-option\n            *ngFor=\"let option of $any(globalSearchResponse?.primaryAppGlobalSearchResult?.searchResult)\"\n            class=\"xpo-LtlGlobalSearch--autocomplete-option\"\n            [value]=\"{\n              searchResult: option,\n              globalSearchResultType: globalSearchResponse?.primaryAppGlobalSearchResult?.key\n            }\"\n          >\n            <ng-container\n              *ngTemplateOutlet=\"\n                searchListItem;\n                context: { listItem: option, key: globalSearchResponse?.primaryAppGlobalSearchResult?.key }\n              \"\n            ></ng-container>\n          </mat-option>\n        </mat-optgroup>\n        <mat-optgroup\n          class=\"xpo-LtlGlobalSearch--autocomplete-optgroup\"\n          *ngFor=\"let group of (globalSearchResponse$ | async)?.globalSearchResult | keyvalue\"\n        >\n          <mat-label class=\"xpo-LtlGlobalSearch--autocomplete-label\">{{\n            group.key | globalSearchResponseType: group?.value?.length:isProSearch\n          }}</mat-label>\n          <mat-option\n            *ngFor=\"let option of $any(group.value)\"\n            class=\"xpo-LtlGlobalSearch--autocomplete-option\"\n            [value]=\"{ searchResult: option, globalSearchResultType: group.key }\"\n          >\n            <ng-container\n              *ngTemplateOutlet=\"searchListItem; context: { listItem: option, key: group.key }\"\n            ></ng-container>\n          </mat-option>\n        </mat-optgroup>\n      </div>\n      <mat-optgroup\n        *ngIf=\"\n          !!(recentGlobalSearchList$ | async)?.length && !(isPerformingGlobalSearch$ | async) && !searchControl.value\n        \"\n        class=\"xpo-LtlGlobalSearch--autocomplete-optgroup\"\n      >\n        <mat-label class=\"xpo-LtlGlobalSearch--autocomplete-label\">Recently Viewed</mat-label>\n        <mat-option\n          *ngFor=\"let option of recentGlobalSearchList$ | async\"\n          class=\"xpo-LtlGlobalSearch--autocomplete-option\"\n          [value]=\"option\"\n        >\n          <ng-container\n            *ngTemplateOutlet=\"\n              searchListItem;\n              context: { listItem: option?.searchResult, key: option?.globalSearchResultType }\n            \"\n          ></ng-container>\n        </mat-option>\n      </mat-optgroup>\n      <div\n        class=\"xpo-LtlGlobalSearch--noResults\"\n        *ngIf=\"(isFocused$ | async) && (showInvalidSearch$ | async) && !(isPerformingGlobalSearch$ | async)\"\n      >\n        <mat-option class=\"xpo-LtlGlobalSearch--noResults-option\" [disabled]=\"true\">\n          No search results found.\n        </mat-option>\n        <div class=\"xpo-LtlGlobalSearch--helpText\">\n          You can only search using ID numbers from Disputes, Claims, Invoices and Shipments\n        </div>\n      </div>\n    </mat-autocomplete>\n  </mat-form-field>\n</div>\n\n<ng-template #searchListItem let-listItem=\"listItem\" let-key=\"key\">\n  <span [ngSwitch]=\"key\">\n    <span *ngSwitchCase=\"GlobalSearchResultType.ShipmentSearchResults\">\n      <span class=\"xpo-LtlGlobalSearch-option--primaryKey\">{{ listItem?.proNbr | proFormatter: 10 }}</span>\n      <span class=\"xpo-LtlGlobalSearch-option--secondaryKey\"\n        >&nbsp;\u00B7 Shipper: {{ listItem?.shipperName | emptyValue }} \u00B7 Pickup Date:\n        {{ listItem?.pickupDt | emptyValue }}</span\n      >\n    </span>\n    <span *ngSwitchCase=\"GlobalSearchResultType.ClaimSearchResults\">\n      <span class=\"xpo-LtlGlobalSearch-option--primaryKey\">{{ listItem?.claimId }}</span>\n      <span class=\"xpo-LtlGlobalSearch-option--secondaryKey\"\n        >&nbsp;\u00B7 Claimant: {{ listItem?.claimantName | emptyValue }} \u00B7 Pickup Date:\n        {{ listItem?.pickupDt | emptyValue }}</span\n      >\n    </span>\n    <span *ngSwitchCase=\"GlobalSearchResultType.DisputeSearchResults\">\n      <span class=\"xpo-LtlGlobalSearch-option--primaryKey\">{{ listItem?.disputeId }}</span>\n      <span [ngSwitch]=\"listItem?.disputeType\">\n        <span *ngSwitchCase=\"DisputeTypeCd.INSPECTION_APPEALS\" class=\"xpo-LtlGlobalSearch-option--secondaryKey\"\n          >&nbsp;\u00B7 {{ listItem?.disputeStatus | asWords | emptyValue }} \u00B7\n          {{ listItem?.disputeType | asWords | emptyValue }} \u00B7 Inspector Name:\n          {{ listItem?.inspectorName | emptyValue }}</span\n        >\n        <span *ngSwitchCase=\"DisputeTypeCd.MASS_RE_RATE\" class=\"xpo-LtlGlobalSearch-option--secondaryKey\"\n          >&nbsp;\u00B7 {{ listItem?.disputeStatus | asWords | emptyValue }} \u00B7\n          {{ listItem?.disputeType | asWords | emptyValue }} \u00B7 Debtor: {{ listItem?.debtorName | emptyValue }}</span\n        >\n        <span *ngSwitchCase=\"DisputeTypeCd.DISPUTE_RESOLUTION_PROCESS\" class=\"xpo-LtlGlobalSearch-option--secondaryKey\"\n          >&nbsp;\u00B7 {{ listItem?.disputeStatus | asWords | emptyValue }} \u00B7\n          {{ listItem?.disputeType | asWords | emptyValue }} \u00B7 Debtor: {{ listItem?.debtorName | emptyValue }}</span\n        >\n        <span *ngSwitchCase=\"DisputeTypeCd.OVERCHARGE_CLAIMS\" class=\"xpo-LtlGlobalSearch-option--secondaryKey\"\n          >&nbsp;\u00B7 {{ listItem?.disputeStatus | asWords | emptyValue }} \u00B7\n          {{ listItem?.disputeType | asWords | emptyValue }} \u00B7 Claimant: {{ listItem?.claimantName | emptyValue }}</span\n        >\n      </span>\n    </span>\n    <span *ngSwitchCase=\"GlobalSearchResultType.InvoiceSearchResults\">\n      <span class=\"xpo-LtlGlobalSearch-option--primaryKey\">{{ listItem?.proNbr | emptyValue | proFormatter: 10 }}</span>\n      <span class=\"xpo-LtlGlobalSearch-option--secondaryKey\"\n        >&nbsp;\u00B7 Invoice Type: {{ listItem?.invoiceType | asWords | emptyValue }} \u00B7 Invoice Date:\n        {{ listItem?.invoiceDt | emptyValue }}</span\n      >\n    </span>\n  </span>\n  <mat-icon\n    class=\"xpo-LtlGlobalSearch--autocomplete-option-icon\"\n    (mouseenter)=\"openExternalPageOnClick = true\"\n    (mouseleave)=\"openExternalPageOnClick = false\"\n    >launch</mat-icon\n  >\n</ng-template>\n", styles: [".flex--stretch{flex:1}.xpo-LtlGlobalSearch{width:162px}.xpo-LtlGlobalSearch--focused{width:600px}.xpo-LtlGlobalSearch--underline{text-decoration:underline}.xpo-LtlGlobalSearch--form-field{width:100%}.xpo-LtlGlobalSearch--form-field-icon{color:#9b9b9b}.xpo-LtlGlobalSearch-option--primaryKey{font-weight:500;font-size:.875rem;color:#4a4a4a}.xpo-LtlGlobalSearch-option--secondaryKey{font-size:.714rem;color:#4a4a4a}.xpo-LtlGlobalSearch--autocomplete{margin-bottom:32px}.xpo-LtlGlobalSearch--autocomplete-optgroup .mat-optgroup-label{line-height:16px;height:16px;font-size:.714rem;font-weight:500;padding-left:28px;margin:16px auto 8px}.xpo-LtlGlobalSearch--autocomplete-optgroup .mat-option{padding-left:28px!important;height:32px!important;line-height:16px!important}.xpo-LtlGlobalSearch--autocomplete-optgroup .mat-option.mat-active,.xpo-LtlGlobalSearch--autocomplete-optgroup .mat-option:hover,.xpo-LtlGlobalSearch--autocomplete-optgroup .mat-option:hover.mat-option.mat-active{background:#e8f5fe!important}.xpo-LtlGlobalSearch--autocomplete-optgroup .mat-option:last-of-type{border-bottom:1px solid #d8d8d8}.xpo-LtlGlobalSearch--autocomplete-optgroup:last-of-type{margin-bottom:32px}.xpo-LtlGlobalSearch--autocomplete-option span.mat-option-text{margin-right:32px}.xpo-LtlGlobalSearch--autocomplete-option mat-icon{color:#9b9b9b;font-size:1rem;line-height:16px;position:absolute;right:0}.xpo-LtlGlobalSearch--autocomplete-option mat-icon:hover{color:#0868ac}.xpo-LtlGlobalSearch--noResults{line-height:16px}.xpo-LtlGlobalSearch--noResults .mat-option{padding-left:28px!important;height:40px!important;font-size:.875rem!important;line-height:16px!important;color:#4a4a4a!important}.xpo-LtlGlobalSearch--noResults .mat-option .mat-option-text{color:#000}.xpo-LtlGlobalSearch--noResults .mat-option.mat-active{background:none}.xpo-LtlGlobalSearch--noResults mat-divider{height:1px;color:#d8d8d8;margin-left:28px}.xpo-LtlGlobalSearch--helpText{position:sticky;bottom:0;width:100%;height:32px;line-height:16px;padding:8px 0 8px 28px;font-size:.714rem;background:#f3f3f3;border-top:1px solid #d8d8d8;box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14)}"], components: [{ type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i9.MatProgressSpinner, selector: "mat-progress-spinner", inputs: ["color", "mode", "diameter", "strokeWidth", "value"], exportAs: ["matProgressSpinner"] }, { type: i13.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i11$1.MatOptgroup, selector: "mat-optgroup", inputs: ["disabled"], exportAs: ["matOptgroup"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }], directives: [{ type: i7.MatLabel, selector: "mat-label" }, { type: i7.MatPrefix, selector: "[matPrefix]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.MatSuffix, selector: "[matSuffix]" }, { type: i21.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i13.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], pipes: { "async": i5.AsyncPipe, "globalSearchResponseType": GlobalSearchResponseTypePipe, "keyvalue": i5.KeyValuePipe, "proFormatter": ProFormatterPipe, "emptyValue": EmptyValuePipe, "asWords": AsWordsPipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlGlobalSearchComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-global-search',
                    templateUrl: './global-search.component.html',
                    styleUrls: ['./global-search.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlFormatValidationService }, { type: i3$1.ConditioningService }, { type: XpoLtlWindowService }, { type: i2$3.ConfigManagerService }, { type: i1.AppMetadataApiService }, { type: i0.ElementRef }, { type: i6$1.Router }]; }, propDecorators: { searchInput: [{
                type: ViewChild,
                args: [MatInput]
            }], searchInputElement: [{
                type: ViewChild,
                args: ['searchInput']
            }], searchAutocomplete: [{
                type: ViewChild,
                args: [MatAutocomplete]
            }], searchAutocompleteTrigger: [{
                type: ViewChild,
                args: [MatAutocompleteTrigger]
            }], activateGlobalSearchKeyCode: [{
                type: Input
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }], onKeyupHandler: [{
                type: HostListener,
                args: ['document:keyup', ['$event']]
            }], onClickHandler: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class BillClassPipe {
    transform(value) {
        switch (value) {
            case BillClassCd.ACCESSORIAL_ONLY:
                return 'Accessorial Only';
            case BillClassCd.ASTRAY_FRT_SEGMENT:
                return 'Astray Freight Segment';
            case BillClassCd.CLAIMS_OVRG_RPTG_BILL:
                return 'Claims Overage Reporting Bill';
            case BillClassCd.CO_BUS_SHPMT:
                return 'Company Business Shipment';
            case BillClassCd.EXPEDITE:
                return 'Expedite';
            case BillClassCd.GENERAL_CLAIMS_BUS_SHPMT:
                return 'General Claims Business Shipment';
            case BillClassCd.MASTER_SEGMENT:
                return 'Master Segment';
            case BillClassCd.MASTER_SHPMT:
                return 'Master Shipment';
            case BillClassCd.NORMAL_MVMT:
                return 'Normal Movement';
            case BillClassCd.PARTIAL_SEGMENT:
                return 'Partial Segment';
            case BillClassCd.SPLIT_SEGMENT:
                return 'Split Segment';
            default:
                return value;
        }
    }
}
BillClassPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BillClassPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
BillClassPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BillClassPipe, name: "billClass" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BillClassPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'billClass',
                }]
        }] });

class CamelCaseToHyphenPipe {
    transform(value) {
        if (value) {
            return startCase(value).replace(/\s+/g, '-');
        }
        return null;
    }
}
CamelCaseToHyphenPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CamelCaseToHyphenPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CamelCaseToHyphenPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CamelCaseToHyphenPipe, name: "camelCaseToHyphen" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CamelCaseToHyphenPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'camelCaseToHyphen'
                }]
        }] });

class CommodityClassCdPipe {
    transform(value, args) {
        let displayValue = '';
        if (value && value.toLowerCase().startsWith('clss')) {
            displayValue = value.substring(4);
        }
        return displayValue;
    }
}
CommodityClassCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommodityClassCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CommodityClassCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommodityClassCdPipe, name: "commodityClassCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CommodityClassCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'commodityClassCd',
                }]
        }] });

class CurrencyCodePipe {
    transform(value, args) {
        if (!value || value.toLowerCase().startsWith('usdollar')) {
            return 'USD';
        }
        else if (value.toLowerCase().startsWith('canadiandollar')) {
            return 'CAD';
        }
        return value;
    }
}
CurrencyCodePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CurrencyCodePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CurrencyCodePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CurrencyCodePipe, name: "currencyCode" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CurrencyCodePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'currencyCode'
                }]
        }] });

class EmptyCurrencyPipe extends CurrencyPipe {
    transform(value, args) {
        const placeholder = args ? args : '-';
        if (value === placeholder || !value) {
            return placeholder;
        }
        if (Number.isNaN(Number.parseFloat(value))) {
            return value;
        }
        const convertedValue = Number.parseFloat(value);
        if (convertedValue === Number.NaN || convertedValue === 0) {
            return placeholder;
        }
        return super.transform(`${convertedValue}`);
    }
}
EmptyCurrencyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EmptyCurrencyPipe, deps: null, target: i0.ɵɵFactoryTarget.Pipe });
EmptyCurrencyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EmptyCurrencyPipe, name: "emptyCurrency" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EmptyCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'emptyCurrency',
                }]
        }] });

class EnumToArrayPipe {
    transform(data) {
        const keys = values(data);
        return keys;
    }
}
EnumToArrayPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EnumToArrayPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
EnumToArrayPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EnumToArrayPipe, name: "enumToArray" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EnumToArrayPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'enumToArray',
                }]
        }] });

class MillisToDaysPipe {
    transform(value, args) {
        let displayValue = ' ';
        if (value && !isNaN(value)) {
            displayValue = String(Math.floor((Number(value)) / MillisToDaysPipe.millisInDay));
        }
        return displayValue;
    }
}
MillisToDaysPipe.millisInDay = (1000 * 24 * 60 * 60);
MillisToDaysPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MillisToDaysPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
MillisToDaysPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MillisToDaysPipe, name: "millisToDays" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MillisToDaysPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'millisToDays'
                }]
        }] });

class NegativeCurrencyParensPipe {
    transform(value, args) {
        if (!value || Number.parseInt(value, 10) === Number.NaN || value === '-') {
            return value || '';
        }
        const valueAsString = `${value}`;
        return valueAsString.charAt(0) === '-' ? `(${valueAsString.substring(1, valueAsString.length)})` : valueAsString;
    }
}
NegativeCurrencyParensPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: NegativeCurrencyParensPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
NegativeCurrencyParensPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: NegativeCurrencyParensPipe, name: "negativeCurrencyParens" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: NegativeCurrencyParensPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'negativeCurrencyParens',
                }]
        }] });

class PastPresentFuturePipe {
    transform(value, pastLabel, presentLabel, futureLabel) {
        const startOfDay = moment$2()
            .startOf('day')
            .toDate();
        const endOfDay = moment$2()
            .endOf('day')
            .toDate();
        if (value < startOfDay) {
            return pastLabel;
        }
        else if (value > endOfDay) {
            return futureLabel;
        }
        else {
            return presentLabel;
        }
    }
}
PastPresentFuturePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PastPresentFuturePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PastPresentFuturePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PastPresentFuturePipe, name: "pastPresentFuture" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PastPresentFuturePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'pastPresentFuture',
                }]
        }] });

class PhoneNumberPipe {
    /**
     * Formats 10 digit phone number to contain dashes
     * @param number 10 digit phone number
     */
    transform(number) {
        if (!number) {
            return '';
        }
        let nakedPhoneNumber = number.replace(/\D/g, '');
        if (nakedPhoneNumber) {
            if (nakedPhoneNumber.length > 3) {
                nakedPhoneNumber = `${nakedPhoneNumber.slice(0, 3)}-${nakedPhoneNumber.slice(3)}`;
            }
            if (nakedPhoneNumber.length > 8) {
                nakedPhoneNumber = `${nakedPhoneNumber.slice(0, 7)}-${nakedPhoneNumber.slice(7)}`;
            }
        }
        return nakedPhoneNumber;
    }
}
PhoneNumberPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PhoneNumberPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PhoneNumberPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PhoneNumberPipe, name: "phoneNumber", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PhoneNumberPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'phoneNumber',
                    pure: false
                }]
        }] });

class PluralPipe {
    transform(count, singular, plural) {
        return count === 1 ? singular : plural;
    }
}
PluralPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PluralPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PluralPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PluralPipe, name: "plural" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PluralPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'plural'
                }]
        }] });

class RoundPipe {
    transform(value, precision = 2) {
        const factor = Math.pow(10, precision);
        const tempNumber = value * factor;
        const roundedTempNumber = Math.round(tempNumber);
        return roundedTempNumber / factor;
    }
}
RoundPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: RoundPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
RoundPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: RoundPipe, name: "round" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: RoundPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'round'
                }]
        }] });

class SafeHtmlPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value, args) {
        if (value) {
            return this.sanitized.bypassSecurityTrustHtml(value);
        }
        else {
            return 'Undefined HTML';
        }
    }
}
SafeHtmlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SafeHtmlPipe, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafeHtmlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SafeHtmlPipe, name: "safeHtml" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SafeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safeHtml'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }]; } });

class SentenceCasePipe {
    constructor() {
        this.sentenceCaseRegex = new RegExp('(?<=\\.|!|\\?)[\\s]+', 'gm');
    }
    transform(value, args) {
        return value ? this.toSentenceCase(value) : '';
    }
    toSentenceCase(value) {
        return value
            .toLowerCase()
            .split(this.sentenceCaseRegex)
            .map((str) => upperFirst(str))
            .join(' ');
    }
}
SentenceCasePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SentenceCasePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SentenceCasePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SentenceCasePipe, name: "sentenceCase" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SentenceCasePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sentenceCase',
                }]
        }] });

class XpoLtlServiceCentersService {
    constructor(locationApiService, configService) {
        this.locationApiService = locationApiService;
        this.configService = configService;
        this.cachedServiceCenters = undefined;
        this.serviceCentersSubject = new ReplaySubject(1);
        this.serviceCenters$ = this.serviceCentersSubject.asObservable();
        this.configService.configured$
            .pipe(filter((config) => config), take(1), switchMap(() => this.getServiceCenters()))
            .subscribe((centers) => {
            this.cachedServiceCenters = centers; // save a cache to use with getSicByCd
            this.serviceCentersSubject.next(centers);
        });
    }
    // get the list of ServiceCenters from the server
    getServiceCenters() {
        const query = new ListOperationalServiceCentersQuery();
        return this.locationApiService.listOperationalServiceCenters(query).pipe(retryWhen((errors) => 
        // retry getting list if we get an error. Might be waiting for authentication to complete
        errors.pipe(delay(1000), take(5))), map((resp) => {
            const centers = sortBy(resp.serviceCenters, (center) => center.sicCd);
            const uniqCenters = sortedUniqBy(centers, (center) => center.sicCd);
            return uniqCenters;
        }), take(1));
    }
    /**
     * Filters the passed list of SICs to those that match the passed filter term
     * Filtering is based on the sicCd and the city name
     *
     * @param filterTerm string used to filter the list of SICs
     */
    filterSicsBy(sicList, filterTerm) {
        if (!filterTerm || filterTerm === '') {
            // nothing to filter by, so return full list
            return sicList;
        }
        else {
            const term = toUpper(filterTerm);
            return filter$1(sicList, (sic) => {
                var _a, _b, _c, _d;
                return toUpper((_a = sic === null || sic === void 0 ? void 0 : sic.sicCd) !== null && _a !== void 0 ? _a : '').includes(term) ||
                    toUpper((_c = (_b = sic === null || sic === void 0 ? void 0 : sic.locAddress) === null || _b === void 0 ? void 0 : _b.cityName) !== null && _c !== void 0 ? _c : '').includes(term) ||
                    toUpper((_d = sic === null || sic === void 0 ? void 0 : sic.reference.sicName) !== null && _d !== void 0 ? _d : '').includes(term)
                    ? true
                    : false;
            }).sort((prev, curr) => (curr.sicCd.includes(term) ? 1 : -1));
        }
    }
    /**
     * Finds and returns the first SIC with the passed SicCd. Returns undefined if not found
     * Assumes that serviceCenters has already been populated!  Otherwise, use getSicByCd$!
     * @param sicCd SIC code to search for
     * @deprecated Use getSicByCd$ instead.
     */
    getSicByCd(sicCd) {
        const term = toUpper(sicCd);
        return find(this.cachedServiceCenters, (sic) => toUpper(sic.sicCd) === term);
    }
    /**
     * Async Finds and returns the first SIC with the passed SicCd. Returns undefined if not found
     * @param sicCd SIC code to search for
     */
    getSicByCd$(sicCd) {
        return this.serviceCenters$.pipe(take(1), map((centers) => {
            const term = toUpper(sicCd);
            return find(centers, (sic) => toUpper(sic.sicCd) === term);
        }));
    }
}
XpoLtlServiceCentersService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlServiceCentersService, deps: [{ token: i1$3.LocationApiService }, { token: i2$3.ConfigManagerService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlServiceCentersService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlServiceCentersService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlServiceCentersService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$3.LocationApiService }, { type: i2$3.ConfigManagerService }]; } });

/**
 * Handle converting time for various timezones and sics.
 */
class XpoLtlTimeService {
    constructor(serviceCentersService, locationService, configService) {
        this.serviceCentersService = serviceCentersService;
        this.locationService = locationService;
        this.configService = configService;
        this.sicTimezones = new Map();
        this.timezonesLoadedSubject = new AsyncSubject();
        /**
         * Resolves after the service center timezone data has been loaded
         * @deprecated use timeDataLoaded$ instead
         */
        this.timezonesLoaded$ = this.timezonesLoadedSubject.asObservable();
        this.locationSics = new Map();
        this.locationSicsLoadedSubject = new AsyncSubject();
        /**
         * Resolves after the sic locations data has been loaded
         */
        this.locationSicsLoaded$ = this.locationSicsLoadedSubject.asObservable();
        /**
         * Resolves after all data has been loaded in timezone service
         */
        this.timeDataLoaded$ = forkJoin([this.timezonesLoaded$, this.locationSicsLoaded$]).pipe(mapTo(undefined));
        this.configService.configured$
            .pipe(filter((config) => config), take(1))
            .subscribe((config) => {
            this.loadServiceCenters();
            this.loadLocations();
        });
    }
    loadServiceCenters() {
        this.serviceCentersService.serviceCenters$.pipe(take(1)).subscribe((centers) => {
            forEach(centers, (ss) => {
                this.sicTimezones.set(toUpper(ss.sicCd), ss.reference.timezoneName);
            });
            this.timezonesLoadedSubject.next();
            this.timezonesLoadedSubject.complete();
        });
    }
    loadLocations() {
        const request = Object.assign({}, new ListLocationsRqst());
        const query = Object.assign(Object.assign({}, new ListLocationsQuery()), { activeInd: true, meetAndTurnDesiredInd: true });
        this.locationService
            .listLocations(request, query)
            .pipe(retryWhen((errors) => 
        // retry getting list if we get an error. Might be waiting for authentication to complete
        errors.pipe(delay(1000), take(5))), catchError((err) => {
            console.error('Unable To Load Sic Location Information: ', err);
            return of({ locationSic: [] });
        }))
            .subscribe((resp) => {
            forEach(resp.locationSic, (loc) => {
                this.locationSics.set(toUpper(loc.sicCd), loc);
            });
            this.locationSicsLoadedSubject.next();
            this.locationSicsLoadedSubject.complete();
        });
    }
    /**
     * Return an Observable that resolves to the Timezone for the specified SIC, or undefined if not found.
     *
     * NOTE: Each call with the same sicCd returns a NEW Observable! Do NOT call this using the
     * Angular `async` pipe.  Instead, save the returned Observable and async with that.
     *
     * @param sicCd - SIC to get timezone for. If not found, defaults to America/Los_Angeles
     */
    timezoneForSicCd$(sicCd) {
        return new Observable((observer) => {
            this.timezonesLoadedSubject.pipe(take(1)).subscribe(() => {
                const tzone = this.timezoneForSicCd(sicCd);
                observer.next(tzone);
                observer.complete();
            });
        });
    }
    /**
     * Return the Timezone for the specified SIC, or undefined if not found
     * @param sicCd - SIC to get timezone for. If not found, defaults to America/Los_Angeles
     * @deprecated use timezoneForSicCd$ instead
     */
    timezoneForSicCd(sicCd) {
        // NOTE: We are rolling the dice here that sicTimezones has been populated. There is still a chance
        // that if we call this method on app startup that the sics haven't finished loading
        const timezone = defaultTo(this.sicTimezones.get(toUpper(sicCd)), 'America/Los_Angeles');
        return timezone;
    }
    /**
     * Convert the passed date/time into a Date object
     * @param date 	The date to convert, as a Date, or a number (milliseconds since UTC epoch) or an ISO date-time string.
     */
    toDate(value) {
        if (isInteger(value)) {
            // date encoded as ms
            return new Date(value);
        }
        else if (isString(value)) {
            // date encoded in a string
            return new Date(value);
        }
        else if (isDate(value)) {
            // already a date
            return new Date(value);
        }
        else {
            // don't know how to make this a Date
            return undefined;
        }
    }
    /**
     * return Date as a string in the form 'HH:mm' (24 hour time)
     * @param date the date to display in 24-hour format
     */
    to24Time(value, sicCd) {
        return this.formatDate(this.toDate(value), 'HH:mm', sicCd);
    }
    /**
     * Format the passed DateTime using the passed format string and sic for timezone.
     * @param value date value
     * @param format (optional) the format string to use - moment format
     * @param sicCd (optional) the sicCd for the service center to base timezone on
     */
    formatDate(value, format, sicCd) {
        var _a, _b;
        const date = this.toDate(value);
        if (isUndefined(date)) {
            return undefined;
        }
        format = defaultTo(format, 'llll');
        // serviceCenterOffset is in relative to Portland time, so everything in PST will be 0
        const timezone = this.timezoneForSicCd(sicCd);
        const offsetFactor = moment$3.tz(value, timezone).isDST() ? 7 : 8;
        const utcOffset = Number((_b = (_a = this.locationSics.get(sicCd)) === null || _a === void 0 ? void 0 : _a.serviceCenterOffset) !== null && _b !== void 0 ? _b : 0) - 60 * offsetFactor;
        const result = moment$3(value)
            .utcOffset(utcOffset)
            .format(format);
        return result;
    }
}
XpoLtlTimeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlTimeService, deps: [{ token: XpoLtlServiceCentersService }, { token: i1$3.LocationApiService }, { token: i2$3.ConfigManagerService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlTimeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlTimeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlTimeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlServiceCentersService }, { type: i1$3.LocationApiService }, { type: i2$3.ConfigManagerService }]; } });

/**
 * Display Date based on the requested SIC
 */
class SicDatePipe {
    constructor(timeService) {
        this.timeService = timeService;
    }
    transform(value, format, sicCd) {
        return this.timeService.formatDate(value, format, sicCd);
    }
}
SicDatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SicDatePipe, deps: [{ token: XpoLtlTimeService }], target: i0.ɵɵFactoryTarget.Pipe });
SicDatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SicDatePipe, name: "sicDate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SicDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sicDate',
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlTimeService }]; } });

/**
 * Convert the passed string into a RegEx expression
 */
class ToRegexPipe {
    transform(regExString) {
        return new RegExp(regExString);
    }
}
ToRegexPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ToRegexPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ToRegexPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ToRegexPipe, name: "toRegex" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ToRegexPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'toRegex',
                }]
        }] });

class MovementExceptionTypePipe {
    transform(value) {
        switch (value) {
            case MovementExceptionTypeCd.AD_HOC:
                return 'Other';
            case MovementExceptionTypeCd.DAMAGED:
                return 'Damaged';
            case MovementExceptionTypeCd.DAMAGED_BUT_ACCEPTED:
                return 'Damaged But Accepted';
            case MovementExceptionTypeCd.EXCP_NOTED:
                return 'Exception Noted';
            case MovementExceptionTypeCd.OVER:
                return 'Over';
            case MovementExceptionTypeCd.OVER_BUT_ACCEPTED:
                return 'Over But Accepted';
            case MovementExceptionTypeCd.REFUSED:
                return 'Refused';
            case MovementExceptionTypeCd.SHORT:
                return 'Short';
            case MovementExceptionTypeCd.UNDELIVERABLE:
                return 'Undeliverable';
            default:
                return value;
        }
    }
}
MovementExceptionTypePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MovementExceptionTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
MovementExceptionTypePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MovementExceptionTypePipe, name: "movementExceptionType" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MovementExceptionTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'movementExceptionType',
                }]
        }] });

class MovementStatusPipe {
    transform(value) {
        switch (value) {
            case MovementStatusCd.CANCELLED:
                return 'Cancelled';
            case MovementStatusCd.FINAL_DLVD:
                return 'Final Delivered';
            case MovementStatusCd.INTERIM_DLVRY:
                return 'Interim Delivery';
            case MovementStatusCd.NO_MVMT_ALLOWED:
                return 'No Movement Allowed';
            case MovementStatusCd.ON_DOCK:
                return 'On Dock';
            case MovementStatusCd.NOT_APPLICABLE:
                return 'Not Applicable';
            case MovementStatusCd.ON_TRAILER:
                return 'On Trailer';
            case MovementStatusCd.OUT_FOR_DLVRY:
                return 'Out For Delivery';
            default:
                return value;
        }
    }
}
MovementStatusPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MovementStatusPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
MovementStatusPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MovementStatusPipe, name: "movementStatus" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MovementStatusPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'movementStatus',
                }]
        }] });

class ShipmentPnDStatusPipe {
    transform(value) {
        switch (value) {
            case ShipmentPnDStatusCd.ASSIGNED:
                return 'Assigned';
            case ShipmentPnDStatusCd.COMPLETE:
                return 'Complete';
            case ShipmentPnDStatusCd.DISPATCHED:
                return 'Dispatched';
            case ShipmentPnDStatusCd.EXCEPTION:
                return 'Exception';
            case ShipmentPnDStatusCd.LOADED:
                return 'Loaded';
            case ShipmentPnDStatusCd.RETURNING:
                return 'Returning';
            case ShipmentPnDStatusCd.NOT_APPLICABLE:
                return 'Not Applicable';
            case ShipmentPnDStatusCd.UNASSIGNED:
                return 'Unassigned';
            default:
                return value;
        }
    }
}
ShipmentPnDStatusPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentPnDStatusPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ShipmentPnDStatusPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentPnDStatusPipe, name: "pndStatus" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentPnDStatusPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'pndStatus',
                }]
        }] });

class ShipmentSpecialServiceCdPipe {
    transform(value) {
        switch (value) {
            case ShipmentSpecialServiceCd.APPOINTMENT:
                return 'Appointment';
            case ShipmentSpecialServiceCd.BULK_LIQUID:
                return 'Bulk Liquid';
            case ShipmentSpecialServiceCd.BYPASS:
                return 'Bypass';
            case ShipmentSpecialServiceCd.CASH_ON_DELIVERY:
                return 'Cash On Delivery';
            case ShipmentSpecialServiceCd.CUSTOMS_IN_BOND:
                return 'Customs In Bond';
            case ShipmentSpecialServiceCd.DRIVER_COLLECT:
                return 'Driver Collect';
            case ShipmentSpecialServiceCd.EXCESSIVE_LENGTH:
                return 'Excessive Length';
            case ShipmentSpecialServiceCd.EXPEDITE:
                return 'Expedite';
            case ShipmentSpecialServiceCd.FOOD:
                return 'Food';
            case ShipmentSpecialServiceCd.FORK_LIFT:
                return 'Fork Lift';
            case ShipmentSpecialServiceCd.FREEZABLE:
                return 'Freezable';
            case ShipmentSpecialServiceCd.GUARANTEED:
                return 'Guaranteed';
            case ShipmentSpecialServiceCd.GUARANTEED_BY_NOON:
                return 'Guaranteed By Noon';
            case ShipmentSpecialServiceCd.HAZMAT:
                return 'Hazmat';
            case ShipmentSpecialServiceCd.HEADLOAD:
                return 'Headload';
            case ShipmentSpecialServiceCd.HIGHWAY_SUB_SERVICE:
                return 'Highway Subservice';
            case ShipmentSpecialServiceCd.LIFT_GATE:
                return 'Lift Gate';
            case ShipmentSpecialServiceCd.LINEHAUL:
                return 'Linehaul';
            case ShipmentSpecialServiceCd.MISLOAD:
                return 'Misload';
            case ShipmentSpecialServiceCd.NOTIFY_ON_ARRIVAL:
                return 'Notify On Arrival';
            case ShipmentSpecialServiceCd.PALLET_JACK:
                return 'Pallet Jack';
            case ShipmentSpecialServiceCd.PARTIAL_BYPASS:
                return 'Partial Bypass';
            case ShipmentSpecialServiceCd.PUP_ONLY:
                return 'Pup Only';
            case ShipmentSpecialServiceCd.RAPID_REMOTE_SERVICE:
                return 'Rapid Remote Service';
            case ShipmentSpecialServiceCd.RESIDENTIAL_DELIVERY:
                return 'Residential Delivery';
            case ShipmentSpecialServiceCd.SUPPLEMENTAL:
                return 'Supplemental';
            case ShipmentSpecialServiceCd.TIME_DATE_CRITICAL:
                return 'Time Date Critical';
            case ShipmentSpecialServiceCd.TRAP_SERVICE:
                return 'Trap Service';
            case ShipmentSpecialServiceCd.UNMAPPED:
                return 'Unmapped';
            default:
                return value;
        }
    }
}
ShipmentSpecialServiceCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentSpecialServiceCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ShipmentSpecialServiceCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentSpecialServiceCdPipe, name: "shipmentSpecialServiceCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentSpecialServiceCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'shipmentSpecialServiceCd',
                }]
        }] });

class DeliveryQualifierCdPipe {
    transform(value, useAbbrv = false) {
        const deliveryQualifierCdMap = new Map([
            [DeliveryQualifierCd.ALL_SHORT, { full: 'All Short', abbrv: 'SHRT' }],
            [DeliveryQualifierCd.APPT, { full: 'Hold For Appointment', abbrv: 'APPT' }],
            [DeliveryQualifierCd.ATTEMPTED, { full: 'Attempted', abbrv: 'ATMP' }],
            [DeliveryQualifierCd.CARTAGE, { full: 'Cartage', abbrv: 'CRTG' }],
            [DeliveryQualifierCd.DAMAGED, { full: 'Damaged Shipment', abbrv: 'RDMG' }],
            [DeliveryQualifierCd.FINAL, { full: 'Final Delivery', abbrv: 'FINL' }],
            [DeliveryQualifierCd.HOLD_FOR_CUSTOMS, { full: 'Hold For Customs', abbrv: 'CSTM' }],
            [DeliveryQualifierCd.OVER_SHPMT, { full: 'Over Shipment', abbrv: 'OVER' }],
            [DeliveryQualifierCd.PARTIAL_SHORT, { full: 'Partial Short', abbrv: 'PSRT' }],
            [DeliveryQualifierCd.PRG_BLOCKED, { full: 'Purge Blocked', abbrv: 'PBLK' }],
            [DeliveryQualifierCd.REFUSED, { full: 'Refused', abbrv: 'RFSD' }],
            [DeliveryQualifierCd.NOT_APPLICABLE, { full: 'Not Applicable', abbrv: 'N/A' }],
            [DeliveryQualifierCd.RETURNED, { full: 'Return Status', abbrv: 'RTRN' }],
            [DeliveryQualifierCd.SPOTTED, { full: 'On Spotted Trailer', abbrv: 'SPOT' }],
            [DeliveryQualifierCd.SUSPENSE, { full: 'Suspense', abbrv: 'SUSP' }],
            [DeliveryQualifierCd.TRANSFER, { full: 'Transfer', abbrv: 'TSFR' }],
            [DeliveryQualifierCd.TRAPPED, { full: 'Trapped', abbrv: 'TRAP' }],
            [DeliveryQualifierCd.UNDELIVERED, { full: 'Undelivered', abbrv: 'UNDL' }],
            [DeliveryQualifierCd.WAIT, { full: 'Wait', abbrv: 'WAIT' }],
        ]);
        let deliveryQualifierCdMappedValue = value;
        const qualifierCdMapValue = deliveryQualifierCdMap.get(value);
        if (!qualifierCdMapValue) {
            deliveryQualifierCdMappedValue = value;
        }
        else if (useAbbrv) {
            deliveryQualifierCdMappedValue = qualifierCdMapValue.abbrv;
        }
        else {
            deliveryQualifierCdMappedValue = qualifierCdMapValue.full;
        }
        return deliveryQualifierCdMappedValue;
    }
}
DeliveryQualifierCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DeliveryQualifierCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DeliveryQualifierCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DeliveryQualifierCdPipe, name: "deliveryQualifierCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DeliveryQualifierCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'deliveryQualifierCd',
                }]
        }] });

class ChargeToCdPipe {
    transform(value) {
        switch (value) {
            case ChargeToCd.BOTH:
                return 'Both';
            case ChargeToCd.COLL:
                return 'Collect';
            case ChargeToCd.PPD:
                return 'Prepaid';
            case ChargeToCd.VALID_ONLY_FOR_NON_REV_BILLS:
                return 'Valid only for Non-Revenue bills';
            default:
                return value;
        }
    }
}
ChargeToCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ChargeToCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ChargeToCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ChargeToCdPipe, name: "chargeToCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ChargeToCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'chargeToCd',
                }]
        }] });

/**
 * A moment timezone pipe to support parsing based on time zone abbreviations
 * covers all cases of offset variation due to daylight saving.
 *
 * Same API as DatePipe with additional timezone abbreviation support
 * Official date pipe dropped support for abbreviations names from Angular V5
 */
class MomentDatePipe {
    transform(value, format = 'MM/DD/YYYY hh:mm z') {
        return moment$3(value)
            .tz(moment$3.tz.guess(true))
            .format(format);
    }
}
MomentDatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MomentDatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
MomentDatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MomentDatePipe, name: "momentDate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MomentDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'momentDate',
                }]
        }] });

class ExemptReasonCdPipe {
    transform(value) {
        let displayValue = '';
        switch (value) {
            case ExemptReasonCd.ACCIDENT:
                displayValue = 'Accident';
                break;
            case ExemptReasonCd.CUSTOMS:
                displayValue = 'Customs';
                break;
            case ExemptReasonCd.DEFERRED:
                displayValue = 'Deferred';
                break;
            case ExemptReasonCd.NOT_EXEMPT:
                displayValue = 'Not Exempt';
                break;
            case ExemptReasonCd.OTHER:
                displayValue = 'Other';
                break;
            case ExemptReasonCd.PREFER_VOL_SHPMT:
                displayValue = 'Preferred Volume Shipment';
                break;
            case ExemptReasonCd.ROAD_CLOSURE:
                displayValue = 'Road Closure';
                break;
            case ExemptReasonCd.TORNADO:
                displayValue = 'Tornado';
                break;
            case ExemptReasonCd.WEATHER:
                displayValue = 'Weather';
                break;
            default:
                displayValue = value;
        }
        return displayValue;
    }
}
ExemptReasonCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ExemptReasonCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ExemptReasonCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ExemptReasonCdPipe, name: "exemptReasonCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ExemptReasonCdPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'exemptReasonCd' }]
        }] });

class EquipmentPipe {
    transform(pfx, sfx) {
        if (!pfx) {
            return '';
        }
        if (pfx.startsWith('0')) {
            pfx = pfx.substring(1, pfx.length);
        }
        const sfxStr = padStart(`${sfx}`, 4, '0');
        return `${pfx}-${sfxStr}`;
    }
}
EquipmentPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EquipmentPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
EquipmentPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EquipmentPipe, name: "equipment" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EquipmentPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'equipment' }]
        }] });

/**
 * Return a full name built from the passed data with either fullName or firstName and lastName properties
 */
class EmployeeNamePipe {
    /**
     * Transforms an employee object to a string
     * @param value employee to transform
     * @param ignoreFullName transforms using firstName and lastName properties
     */
    transform(value, ignoreFullName = false) {
        if (value) {
            if (has(value, 'fullName') && !ignoreFullName) {
                return get(value, 'fullName');
            }
            else {
                const fullName = [get(value, 'firstName') || get(value, 'givenName'), get(value, 'lastName')]
                    .join(' ')
                    .trim();
                return size(fullName) > 0 ? fullName : null;
            }
        }
        return null;
    }
}
EmployeeNamePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EmployeeNamePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
EmployeeNamePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EmployeeNamePipe, name: "employeeName" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: EmployeeNamePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'employeeName',
                }]
        }] });

class InvoiceTypeCdPipe {
    transform(value, args) {
        let displayValue = '';
        switch (value) {
            case 'BOTH': // key as a string
            case InvoiceTypeCd.ORIGINAL:
                displayValue = 'Original';
                break;
            case 'COLL': // key as a string
            case InvoiceTypeCd.BAL_DUE:
                displayValue = 'Balance Due';
                break;
            case 'PPD': // key as a string
            case InvoiceTypeCd.CORRECTED:
                displayValue = 'Corrected';
                break;
            default:
                displayValue = value;
        }
        return displayValue;
    }
}
InvoiceTypeCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: InvoiceTypeCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
InvoiceTypeCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: InvoiceTypeCdPipe, name: "invoiceTypeCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: InvoiceTypeCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'invoiceTypeCd',
                }]
        }] });

class ClaimInternalStatusCdPipe {
    transform(value) {
        switch (value) {
            case ClaimInternalStatusCd.APPROVED:
                return 'Approved';
            case ClaimInternalStatusCd.CEO_PENDING_APPROVAL:
                return 'Pending CEO Approval';
            case ClaimInternalStatusCd.CUSTOMER_CANCELLED:
                return 'Customer Cancelled';
            case ClaimInternalStatusCd.DECLINED:
                return 'Declined';
            case ClaimInternalStatusCd.DIRECTOR_PENDING_APPROVAL:
                return 'Pending Director Approval';
            case ClaimInternalStatusCd.MANAGER_PENDING_APPROVAL:
                return 'Pending Manager Approval';
            case ClaimInternalStatusCd.PRESIDENT_PENDING_APPROVAL:
                return 'Pending President Approval';
            case ClaimInternalStatusCd.SUBMITTED:
                return 'Submitted';
            case ClaimInternalStatusCd.SVP_OF_OPS_PENDING_APPROVAL:
                return 'Pending SVP of OPS Approval';
            case ClaimInternalStatusCd.SVP_SALES_PENDING_APPROVAL:
                return 'Pending SVP of Sales Approval';
            case ClaimInternalStatusCd.UNDER_REVIEW:
                return 'Under Review';
            case ClaimInternalStatusCd.UNSUBMITTED:
                return 'Unsubmitted';
            case ClaimInternalStatusCd.RVP_PENDING_APPROVAL:
                return 'Pending RVP Approval';
            case ClaimInternalStatusCd.RVP_SALES_PENDING_APPROVAL:
                return 'Pending RVP of Sales Approval';
            default:
                return value || 'UNKNOWN';
        }
    }
}
ClaimInternalStatusCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ClaimInternalStatusCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ClaimInternalStatusCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ClaimInternalStatusCdPipe, name: "claimInternalStatusCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ClaimInternalStatusCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'claimInternalStatusCd',
                }]
        }] });

class MiscLineItemPaymentMethodCdPipe {
    transform(value) {
        switch (value) {
            case MiscLineItemPaymentMethodCd.CERTIFIED_FUND:
                return 'Cashiers Check';
            case MiscLineItemPaymentMethodCd.COMPANY_CHECK:
                return 'Company Check';
            case MiscLineItemPaymentMethodCd.CUSTOMER_CHECK:
                return 'Cash';
            case MiscLineItemPaymentMethodCd.DEMAND_DRAFT:
                return 'Demand Draft';
            case MiscLineItemPaymentMethodCd.MONEY_ORDER:
                return 'Money Order';
            default:
                return value;
        }
    }
}
MiscLineItemPaymentMethodCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MiscLineItemPaymentMethodCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
MiscLineItemPaymentMethodCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MiscLineItemPaymentMethodCdPipe, name: "miscLineItemPaymentMethod" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: MiscLineItemPaymentMethodCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'miscLineItemPaymentMethod',
                }]
        }] });

class DeliveryQualifierReasonCdPipe {
    transform(value) {
        switch (value) {
            case DeliveryQualifierReasonCd.ATTEMPT_CONSIGNEE_RELATED:
                return 'Consignee related';
            case DeliveryQualifierReasonCd.ATTEMPT_SHIPPER_RELATED:
                return 'Shipper related';
            case DeliveryQualifierReasonCd.BROKER_CLOSED:
                return 'Broker closed';
            case DeliveryQualifierReasonCd.CASH_NOT_AVAILABLE:
                return 'Cash not available';
            case DeliveryQualifierReasonCd.CLIENT_CLEAR:
                return 'Client will clear shipment';
            case DeliveryQualifierReasonCd.CLIENT_CREDIT:
                return 'Client has credit issues';
            case DeliveryQualifierReasonCd.CLOSED_HOLIDAY:
                return 'Closed for holiday';
            case DeliveryQualifierReasonCd.CLOSED_INVENTORY:
                return 'Closed for inventory';
            case DeliveryQualifierReasonCd.COD_REQUIRED:
                return 'COD required';
            case DeliveryQualifierReasonCd.CREDIT_HOLD:
                return 'Credit hold';
            case DeliveryQualifierReasonCd.CUSTOMER_REQUESTED_CONSOLIDATION:
                return 'Customer requested consolidation';
            case DeliveryQualifierReasonCd.CUSTOMER_REQUEST_FUTURE_DELIVERY:
                return 'Customer requested future delivery';
            case DeliveryQualifierReasonCd.CUSTOMER_SHUTDOWN:
                return 'Customer shutdown';
            case DeliveryQualifierReasonCd.CUSTOMER_STRIKE:
                return 'Customer strike';
            case DeliveryQualifierReasonCd.CUSTOMS_IMPORT_EXPORT:
                return 'Customs import/export';
            case DeliveryQualifierReasonCd.DRIVER_RELATED:
                return 'Driver related';
            case DeliveryQualifierReasonCd.FAILED_PARS:
                return 'Failed PARS';
            case DeliveryQualifierReasonCd.FINAL_CONSIGNEE_RELATED:
                return 'Consignee related';
            case DeliveryQualifierReasonCd.FINAL_SHIPPER_RELATED:
                return 'Shipper related';
            case DeliveryQualifierReasonCd.GOVERNMENT_DOCS_REQUIRED:
                return 'Government docs required';
            case DeliveryQualifierReasonCd.HELD_FOR_PROTECTIVE_SERVICE:
                return 'Held for protective service';
            case DeliveryQualifierReasonCd.IMPROPER_UNLOAD_EQUIPMENT:
                return 'Improper unload equipment';
            case DeliveryQualifierReasonCd.INCORRECT_BROKER:
                return 'Incorrect broker';
            case DeliveryQualifierReasonCd.INFO_MISSING:
                return 'Info missing';
            case DeliveryQualifierReasonCd.INSUFFICIENT_DELIVERY_TIME:
                return 'Insufficient delivery time';
            case DeliveryQualifierReasonCd.INSUFFICIENT_TIME_TO_COMPLETE_DELIVERY:
                return 'Insufficient time to complete delivery';
            case DeliveryQualifierReasonCd.INT_NON_CARRIER_DELIVERY:
                return 'International non carrier delivery';
            case DeliveryQualifierReasonCd.MECHANICAL_BREAKDOWN:
                return 'Mechanical breakdown';
            case DeliveryQualifierReasonCd.MISSED_DELIVERY:
                return 'Missed delivery';
            case DeliveryQualifierReasonCd.NO_BROKER:
                return 'No Broker';
            case DeliveryQualifierReasonCd.OTHER:
                return 'Other';
            case DeliveryQualifierReasonCd.OTHER_CARRIER_RELATED_REASON:
                return 'Other carrier related reason';
            case DeliveryQualifierReasonCd.PACKAGE_MIS_SORTED:
                return 'Package mis-sorted';
            case DeliveryQualifierReasonCd.PAPERWORK_ISSUE:
                return 'Paperwork issue';
            case DeliveryQualifierReasonCd.PREVIOUS_STOP_CAUSED_DELAY:
                return 'Previous stop caused delay';
            case DeliveryQualifierReasonCd.RECEIVING_TIMES_RESTRICTED:
                return 'Receiving times restricted';
            case DeliveryQualifierReasonCd.RECIPIENT_UNAVAILABLE:
                return 'Recipient unavailable';
            case DeliveryQualifierReasonCd.RESIDENTIAL_NOT_HOME:
                return 'Residential consignee not at home';
            case DeliveryQualifierReasonCd.RETURN_SHIPPER_RELATED:
                return 'Return shipper related';
            case DeliveryQualifierReasonCd.WAITING_INSPECTION:
                return 'Waiting inspection';
            case DeliveryQualifierReasonCd.WRONG_PRO:
                return 'Wrong PRO';
            case DeliveryQualifierReasonCd.XPO_RELATED:
                return 'XPO related';
        }
    }
}
DeliveryQualifierReasonCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DeliveryQualifierReasonCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DeliveryQualifierReasonCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DeliveryQualifierReasonCdPipe, name: "deliveryQualifierReasonCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DeliveryQualifierReasonCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'deliveryQualifierReasonCd',
                }]
        }] });
class AttemptReasonCdPipe {
    transform(value) {
        switch (value) {
            case '1':
                return 'Residential consignee not at home';
            case '2':
                return 'Closed for holiday';
            case '3':
                return 'Closed for inventory';
            case '4':
                return 'Customer requested future delivery';
            case '5':
                return 'Consignee related';
            case '6':
                return 'Shipper related';
            case '7':
                return 'Recipient unavailable — delivery delayed';
            case '8':
                return 'Improper unloading facility or equipment';
            case '9':
                return 'Credit hold';
            case 'A':
                return 'Customer on shutdown';
            case 'B':
                return 'Customer strike';
            case 'C':
                return 'COD required';
            case 'D':
                return 'Cash not available from consignee';
        }
    }
}
AttemptReasonCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AttemptReasonCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
AttemptReasonCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AttemptReasonCdPipe, name: "attemptReasonCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AttemptReasonCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'attemptReasonCd',
                }]
        }] });
class ReturnReasonCdPipe {
    transform(value) {
        switch (value) {
            case '1':
                return 'Driver related';
            case '2':
                return 'Insufficient time to complete delivery';
            case '3':
                return 'Mechanical breakdown';
            case '4':
                return 'Missed delivery';
            case '5':
                return 'Other carrier-related reason';
            case '6':
                return 'Package mis-sorted';
            case '7':
                return 'Previous stop caused delay';
            case '8':
                return 'Shipper related';
        }
    }
}
ReturnReasonCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ReturnReasonCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ReturnReasonCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ReturnReasonCdPipe, name: "returnReasonCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ReturnReasonCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'returnReasonCd',
                }]
        }] });
class RefusedReasonCdPipe {
    transform(value) {
        switch (value) {
            case '1':
            case RefusedReasonCd.UNAUTHORIZED_RETURN:
                return 'Unauthorized return';
            case '2':
            case RefusedReasonCd.CONSIGNEE_REFUSED_COLLED:
                return `Consignee won't accept freight collect`;
            case '3':
            case RefusedReasonCd.ARRIVED_TOO_LATE:
                return 'Arrived too late';
            case 'A':
            case RefusedReasonCd.ARRIVED_TOO_EARLY:
                return 'Arrived too early';
            case '4':
            case RefusedReasonCd.ORDER_CANCELLED:
                return 'Order cancelled';
            case '5':
            case RefusedReasonCd.DID_NOT_ORDER:
                return 'Did not order';
            case '6':
            case RefusedReasonCd.WRONG_ORDER:
                return 'Wrong order';
            case 'B':
            case RefusedReasonCd.DUPLICATE_ORDER:
                return 'Duplicate order';
            case '7':
            case RefusedReasonCd.CUSTOMER_WANTED_EARLIER:
                return 'Customer wanted earlier';
            case '8':
            case RefusedReasonCd.INSUFFICIENT_DELIVERY_TIME:
                return 'Insufficient delivery time';
            case '9':
            case RefusedReasonCd.MANUFACTURERS_DEFECT:
                return `Manufacturer's defect`;
            case 'C':
            case RefusedReasonCd.SENT_TO_WRONG_LOCATION:
                return `Sent to wrong location`;
            default: {
                return value;
            }
        }
    }
}
RefusedReasonCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: RefusedReasonCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
RefusedReasonCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: RefusedReasonCdPipe, name: "refusedReasonCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: RefusedReasonCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'refusedReasonCd',
                }]
        }] });
class UndeliveredReasonCdPipe {
    transform(value) {
        switch (value) {
            case '1':
            case UndeliveredReasonCd.CONSTRUCTION_SITE:
                return 'Construction site, not deliverable within 2 days';
            case '2':
            case UndeliveredReasonCd.NO_RSPNS_TO_ARRIVAL_NTFICTN:
                return 'No response to arrival notification after 2 working days';
            case '3':
            case UndeliveredReasonCd.CONS_IN_LABOR_DISPUTE:
                return 'Consignee involved in labor dispute';
            case '4':
            case UndeliveredReasonCd.CONS_NOT_FOUND_AT_ADDR_OR_PHON:
                return 'Consignee cannot be located at address or phone number shown';
            case '5':
            case UndeliveredReasonCd.CONS_MOVED:
                return 'Consignee has moved';
            case '6':
            case UndeliveredReasonCd.CREDIT_HOLD:
                return 'Credit Hold';
            case '7':
            case UndeliveredReasonCd.SUSPENDED_AT_CUST_RQST:
                return 'Suspended at Customer Request';
            case '8':
            case UndeliveredReasonCd.INSUFFICIENT_DLVRY_TM:
                return 'Insufficient Delivery Time';
            case 'Z':
            case UndeliveredReasonCd.OTHER:
                return 'Other';
        }
    }
}
UndeliveredReasonCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UndeliveredReasonCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
UndeliveredReasonCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UndeliveredReasonCdPipe, name: "undeliveredReasonCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UndeliveredReasonCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'undeliveredReasonCd',
                }]
        }] });

const pipes$1 = [
    AsWordsPipe,
    BillClassPipe,
    CamelCaseToHyphenPipe,
    ChargeToCdPipe,
    CommodityClassCdPipe,
    CurrencyCodePipe,
    DeliveryQualifierCdPipe,
    EmptyCurrencyPipe,
    EmptyValuePipe,
    EnumToArrayPipe,
    MillisToDaysPipe,
    MiscLineItemPaymentMethodCdPipe,
    MovementExceptionTypePipe,
    MovementStatusPipe,
    NegativeCurrencyParensPipe,
    PastPresentFuturePipe,
    PhoneNumberPipe,
    PluralPipe,
    ProFormatterPipe,
    RoundPipe,
    SafeHtmlPipe,
    SentenceCasePipe,
    ShipmentPnDStatusPipe,
    ShipmentSpecialServiceCdPipe,
    SicDatePipe,
    MomentDatePipe,
    ExemptReasonCdPipe,
    ClaimInternalStatusCdPipe,
    EquipmentPipe,
    EmployeeNamePipe,
    InvoiceTypeCdPipe,
    ToRegexPipe,
    DeliveryQualifierReasonCdPipe,
    AttemptReasonCdPipe,
    ReturnReasonCdPipe,
    RefusedReasonCdPipe,
    UndeliveredReasonCdPipe,
];
class XpoLtlPipeModule {
}
XpoLtlPipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlPipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPipeModule, declarations: [AsWordsPipe,
        BillClassPipe,
        CamelCaseToHyphenPipe,
        ChargeToCdPipe,
        CommodityClassCdPipe,
        CurrencyCodePipe,
        DeliveryQualifierCdPipe,
        EmptyCurrencyPipe,
        EmptyValuePipe,
        EnumToArrayPipe,
        MillisToDaysPipe,
        MiscLineItemPaymentMethodCdPipe,
        MovementExceptionTypePipe,
        MovementStatusPipe,
        NegativeCurrencyParensPipe,
        PastPresentFuturePipe,
        PhoneNumberPipe,
        PluralPipe,
        ProFormatterPipe,
        RoundPipe,
        SafeHtmlPipe,
        SentenceCasePipe,
        ShipmentPnDStatusPipe,
        ShipmentSpecialServiceCdPipe,
        SicDatePipe,
        MomentDatePipe,
        ExemptReasonCdPipe,
        ClaimInternalStatusCdPipe,
        EquipmentPipe,
        EmployeeNamePipe,
        InvoiceTypeCdPipe,
        ToRegexPipe,
        DeliveryQualifierReasonCdPipe,
        AttemptReasonCdPipe,
        ReturnReasonCdPipe,
        RefusedReasonCdPipe,
        UndeliveredReasonCdPipe], imports: [CommonModule], exports: [AsWordsPipe,
        BillClassPipe,
        CamelCaseToHyphenPipe,
        ChargeToCdPipe,
        CommodityClassCdPipe,
        CurrencyCodePipe,
        DeliveryQualifierCdPipe,
        EmptyCurrencyPipe,
        EmptyValuePipe,
        EnumToArrayPipe,
        MillisToDaysPipe,
        MiscLineItemPaymentMethodCdPipe,
        MovementExceptionTypePipe,
        MovementStatusPipe,
        NegativeCurrencyParensPipe,
        PastPresentFuturePipe,
        PhoneNumberPipe,
        PluralPipe,
        ProFormatterPipe,
        RoundPipe,
        SafeHtmlPipe,
        SentenceCasePipe,
        ShipmentPnDStatusPipe,
        ShipmentSpecialServiceCdPipe,
        SicDatePipe,
        MomentDatePipe,
        ExemptReasonCdPipe,
        ClaimInternalStatusCdPipe,
        EquipmentPipe,
        EmployeeNamePipe,
        InvoiceTypeCdPipe,
        ToRegexPipe,
        DeliveryQualifierReasonCdPipe,
        AttemptReasonCdPipe,
        ReturnReasonCdPipe,
        RefusedReasonCdPipe,
        UndeliveredReasonCdPipe] });
XpoLtlPipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPipeModule, providers: pipes$1, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: pipes$1,
                    imports: [CommonModule],
                    exports: pipes$1,
                    providers: pipes$1,
                }]
        }] });

class XpoLtlGlobalSearchModule {
}
XpoLtlGlobalSearchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlGlobalSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlGlobalSearchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlGlobalSearchModule, declarations: [XpoLtlGlobalSearchComponent, GlobalSearchResponseTypePipe], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatIconModule,
        MatListModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        ConfigManagerModule,
        XpoLtlPipeModule], exports: [XpoLtlGlobalSearchComponent, GlobalSearchResponseTypePipe] });
XpoLtlGlobalSearchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlGlobalSearchModule, providers: [
        {
            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
            useValue: { configFileUrl: './assets/config.json' },
        },
    ], imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatInputModule,
            MatIconModule,
            MatListModule,
            MatAutocompleteModule,
            MatProgressSpinnerModule,
            MatTooltipModule,
            ConfigManagerModule,
            XpoLtlPipeModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlGlobalSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [XpoLtlGlobalSearchComponent, GlobalSearchResponseTypePipe],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatInputModule,
                        MatIconModule,
                        MatListModule,
                        MatAutocompleteModule,
                        MatProgressSpinnerModule,
                        MatTooltipModule,
                        ConfigManagerModule,
                        XpoLtlPipeModule,
                    ],
                    exports: [XpoLtlGlobalSearchComponent, GlobalSearchResponseTypePipe],
                    providers: [
                        {
                            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
                            useValue: { configFileUrl: './assets/config.json' },
                        },
                    ],
                }]
        }] });

class BrowserGuardDialogComponent {
    constructor(data, clipboardService) {
        this.data = data;
        this.clipboardService = clipboardService;
        this.appUrl = '';
        this.appUrl = data.appRedirectUrl ? data.appRedirectUrl : window.location.href;
    }
    getHref(browser) {
        if (browser === 'CHROME') {
            return 'http://www.google.com/chrome';
        }
        else if (browser === 'IE' || browser === 'EDGE') {
            return 'https://www.microsoft.com/en-us/windows/microsoft-edge';
        }
        else {
            return 'https://www.google.com/search?q=browser';
        }
    }
    saveClicked() {
        this.clipboardService.copyFromContent(this.appUrl);
    }
}
BrowserGuardDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BrowserGuardDialogComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$4.ClipboardService }], target: i0.ɵɵFactoryTarget.Component });
BrowserGuardDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: BrowserGuardDialogComponent, selector: "xpo-browser-guard-dialog", ngImport: i0, template: "<div class=\"xpo-LtlBrowserGuardDialog\">\n  <div class=\"xpo-LtlBrowserGuardDialog__header\">Incompatible Browser Detected</div>\n  <div class=\"xpo-LtlBrowserGuardDialog__content\">\n    <div>The browser you are using is not supported by {{ data.appName }}.</div>\n    <div>Please copy the following URL and paste it in {{ data.compatibleBrowsers }}.</div>\n    <div class=\"xpo-LtlBrowserGuardDialog__content-aligned\">\n      {{ appUrl }}\n    </div>\n    <mat-icon (click)=\"saveClicked()\">file_copy</mat-icon>\n  </div>\n</div>\n", styles: [".xpo-LtlBrowserGuardDialog__header{color:#4a4a4a;font-size:18px;font-weight:500;margin:8px}.xpo-LtlBrowserGuardDialog__content{color:#4a4a4a;font-size:14px;margin:8px}.xpo-LtlBrowserGuardDialog__content-aligned{display:flex;align-items:center}.xpo-LtlBrowserGuardDialog__content .mat-icon{margin-left:4px;cursor:pointer}"], components: [{ type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BrowserGuardDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-browser-guard-dialog',
                    templateUrl: './browser-guard-dialog.component.html',
                    styleUrls: ['./browser-guard-dialog.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$4.ClipboardService }]; } });

class XpoBrowserGuardModule {
}
XpoBrowserGuardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoBrowserGuardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoBrowserGuardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoBrowserGuardModule, declarations: [BrowserGuardDialogComponent], imports: [CommonModule, MatIconModule, MatDialogModule] });
XpoBrowserGuardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoBrowserGuardModule, providers: [
        {
            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
            useValue: { configFileUrl: './assets/config.json' },
        },
    ], imports: [[CommonModule, MatIconModule, MatDialogModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoBrowserGuardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BrowserGuardDialogComponent],
                    imports: [CommonModule, MatIconModule, MatDialogModule],
                    providers: [
                        {
                            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
                            useValue: { configFileUrl: './assets/config.json' },
                        },
                    ],
                    entryComponents: [BrowserGuardDialogComponent],
                }]
        }] });

class BrowserGuard {
    constructor(dialog, config) {
        this.dialog = dialog;
        this.config = config;
    }
    canActivate() {
        const browserInfo = detect();
        const setting = this.config.getSetting('compatibleBrowsers');
        const compatibleBrowsers = setting ? split((setting || '').toUpperCase(), ',') : undefined;
        const appRedirectUrl = this.config.getSetting('appRedirectUrl');
        const url = appRedirectUrl ? appRedirectUrl : '';
        if (browserInfo.name &&
            compatibleBrowsers &&
            compatibleBrowsers.length > 0 &&
            indexOf(compatibleBrowsers, browserInfo.name.toUpperCase()) < 0) {
            this.dialog.open(BrowserGuardDialogComponent, {
                data: {
                    appName: this.config.getSetting('appName'),
                    compatibleBrowsers: compatibleBrowsers,
                    appRedirectUrl: url,
                },
                disableClose: true,
            });
            return of(false);
        }
        return of(true);
    }
}
BrowserGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BrowserGuard, deps: [{ token: i1$1.MatDialog }, { token: i2$3.ConfigManagerService }], target: i0.ɵɵFactoryTarget.Injectable });
BrowserGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BrowserGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: BrowserGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }, { type: i2$3.ConfigManagerService }]; } });

class XpoLtlConfirmEnvironmentComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    ngOnInit() {
        const { environment } = this.data;
        this.environment = environment;
        this.environmentFriendlyName = this.environment.toUpperCase() === 'PROD' ? 'Production' : 'Test';
    }
    checkInputValue(event) {
        this.enableConfirmButton = this.inputValue.toUpperCase() === this.environment;
        if (event.key === 'Enter' && this.enableConfirmButton) {
            this.dialogRef.close(true);
        }
    }
}
XpoLtlConfirmEnvironmentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlConfirmEnvironmentComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlConfirmEnvironmentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlConfirmEnvironmentComponent, selector: "xpo-ltl-confirm-environment", ngImport: i0, template: "<div class=\"xpo-LtlConfirmEnvironmentDialog\">\n  <h1 mat-dialog-title>Confirm environment</h1>\n\n  <div mat-dialog-content>\n    <p data-test=\"xpo-LtlConfirmEnvironmentDialog__msg-line-1\">\n      You are in the {{ environmentFriendlyName }} environment, which is not the primary environment for your job role.\n    </p>\n    <p data-test=\"xpo-LtlConfirmEnvironmentDialog__msg-line-2\">\n      Please type \"{{ environment }}\" below to confirm that you really want to access {{ environmentFriendlyName }}.\n    </p>\n    <br />\n    <input\n      matInput\n      [(ngModel)]=\"inputValue\"\n      (keyup)=\"checkInputValue($event)\"\n      maxlength=\"4\"\n      placeholder=\"Type {{ environment }} here to continue\"\n    />\n  </div>\n\n  <div mat-dialog-actions>\n    <button\n      type=\"button\"\n      mat-button\n      color=\"primary\"\n      [disabled]=\"!enableConfirmButton\"\n      [mat-dialog-close]=\"true\"\n      data-test=\"xpo-LtlConfirmEnvironmentDialog__continue-button\"\n    >\n      Continue\n    </button>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}.xpo-LtlConfirmEnvironmentDialog input{text-transform:uppercase}"], components: [{ type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i21.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i2$2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["type", "mat-dialog-close", "aria-label", "matDialogClose"], exportAs: ["matDialogClose"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlConfirmEnvironmentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-confirm-environment',
                    templateUrl: './confirm-environment.component.html',
                    styleUrls: ['./confirm-environment.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class XpoLtlEnvironmentAndRoleGuardModule {
}
XpoLtlEnvironmentAndRoleGuardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEnvironmentAndRoleGuardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlEnvironmentAndRoleGuardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEnvironmentAndRoleGuardModule, declarations: [XpoLtlConfirmEnvironmentComponent], imports: [CommonModule, MatButtonModule, MatDialogModule, MatInputModule, FormsModule] });
XpoLtlEnvironmentAndRoleGuardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEnvironmentAndRoleGuardModule, providers: [
        {
            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
            useValue: { configFileUrl: './assets/config.json' },
        },
    ], imports: [[CommonModule, MatButtonModule, MatDialogModule, MatInputModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEnvironmentAndRoleGuardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [XpoLtlConfirmEnvironmentComponent],
                    imports: [CommonModule, MatButtonModule, MatDialogModule, MatInputModule, FormsModule],
                    providers: [
                        {
                            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
                            useValue: { configFileUrl: './assets/config.json' },
                        },
                    ],
                    entryComponents: [XpoLtlConfirmEnvironmentComponent],
                }]
        }] });

/**
 * Provides access to the currently logged-in User
 */
class XpoLtlLoggedInUserService {
    constructor(http, configManagerService) {
        this.http = http;
        this.configManagerService = configManagerService;
        this.userLoggedInSubject = new Subject();
        /**
         * emits when the user is logged in
         */
        this.userLoggedIn$ = this.userLoggedInSubject.asObservable();
    }
    /**
     * Get the logged in user detail
     * @param loggedInUserEndpoint End point i.e. 'shipment/1.0/appusers/logged-in-user'
     */
    getLoggedInUser(loggedInUserEndpoint) {
        if (this._cachedUser) {
            return of(this._cachedUser);
        }
        if (!this._runningGetLoggedInUser$) {
            this._runningGetLoggedInUser$ = this.http.get(`${this.getUrl(loggedInUserEndpoint)}`).pipe(share(), pluck('data'), tap((user) => {
                this._cachedUser = user;
                this._runningGetLoggedInUser$ = undefined;
                this.userLoggedInSubject.next();
            }));
        }
        return this._runningGetLoggedInUser$;
    }
    /**
     * Clears the previously cached User
     */
    clear() {
        this._cachedUser = undefined;
    }
    appendUrlParts(part1, part2) {
        const conditionedPart1 = `${part1}${part1.endsWith('/') ? '' : '/'}`;
        const conditionedPart2 = `${part2.startsWith('/') ? part2.substring(1) : part2}`;
        return `${conditionedPart1}${conditionedPart2}`;
    }
    getUrl(uri) {
        const url = this.configManagerService.getSetting(ConfigManagerProperties$1.apiUrl);
        return this.appendUrlParts(url, uri);
    }
}
XpoLtlLoggedInUserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlLoggedInUserService, deps: [{ token: i1$5.HttpClient }, { token: i2$3.ConfigManagerService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlLoggedInUserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlLoggedInUserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlLoggedInUserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$5.HttpClient }, { type: i2$3.ConfigManagerService }]; } });

/**
 * Config properties used by this service
 */
var ConfigManagerProperties;
(function (ConfigManagerProperties) {
    ConfigManagerProperties["production"] = "production";
    ConfigManagerProperties["loggedInUserRoot"] = "loggedInUserRoot";
})(ConfigManagerProperties || (ConfigManagerProperties = {}));
const ENVIRONMENT_PROD = 'PROD';
const ENVIRONMENT_TEST = 'TEST';
const DEFAULT_ACCESS = 'LTL_DEFAULT_ACCESS_PROD';
/**
 * Block user from continuing if they do not have access rights for the specified environment.
 * User can continue if they specifically type in the environment name, forcing them to understand
 * which environment they are operating in.
 */
class XpoLtlEnvironmentAndRoleGuard {
    constructor(loggedInUserService, configManagerService, dialog) {
        this.loggedInUserService = loggedInUserService;
        this.configManagerService = configManagerService;
        this.dialog = dialog;
        this.isProduction = false;
        this.isProduction = this.configManagerService.getSetting(ConfigManagerProperties.production);
        this.environment = this.isProduction ? ENVIRONMENT_PROD : ENVIRONMENT_TEST;
    }
    canActivate() {
        return new Observable((observer) => {
            this.loggedInUserService
                .getLoggedInUser(this.configManagerService.getSetting(ConfigManagerProperties.loggedInUserRoot))
                .pipe(retryWhen((errors) => errors.pipe(delay(1000), take(5))), catchError((error) => {
                console.error('XpoLtlEnvironmentAndRoleGuard error retrieving logged in user: ', error);
                return of(Object.assign(Object.assign({}, new User()), { roles: [] }));
            }))
                .subscribe((user) => {
                const roles = get(user, 'roles', []);
                const hasProdAccess = roles.findIndex((r) => includes(r.toUpperCase(), DEFAULT_ACCESS)) >= 0;
                if ((!this.isProduction && hasProdAccess) || (this.isProduction && !hasProdAccess)) {
                    // user either is in PROD and does not have PROD access, or in TEST but has PROD access.
                    this.displayWarning(this.environment).subscribe((confirm) => {
                        observer.next(confirm);
                        observer.complete();
                    });
                }
                else {
                    // valid environment for the user
                    observer.next(true);
                    observer.complete();
                }
            });
        });
    }
    displayWarning(environment) {
        return new Observable((observer) => {
            const dialogRef = this.dialog.open(XpoLtlConfirmEnvironmentComponent, {
                data: { environment },
                disableClose: true,
            });
            dialogRef.afterClosed().subscribe((confirm) => {
                observer.next(true);
                observer.complete();
            });
        });
    }
}
XpoLtlEnvironmentAndRoleGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEnvironmentAndRoleGuard, deps: [{ token: XpoLtlLoggedInUserService }, { token: i2$3.ConfigManagerService }, { token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlEnvironmentAndRoleGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEnvironmentAndRoleGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEnvironmentAndRoleGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlLoggedInUserService }, { type: i2$3.ConfigManagerService }, { type: i1$1.MatDialog }]; } });

var FBDSDocumentType;
(function (FBDSDocumentType) {
    FBDSDocumentType["FBDS"] = "FBDS";
    FBDSDocumentType["DOCK_COPY"] = "DockCopy";
})(FBDSDocumentType || (FBDSDocumentType = {}));

const legacyPrintersList = [
    'CAC',
    'CAC9',
    'CASPLESF',
    'CBO211',
    'CBO213',
    'CBO215',
    'CDC',
    'CDE',
    'CDE1',
    'CEA1',
    'CEA2',
    'CEA3',
    'CFP',
    'CFP2',
    'CGO1',
    'CGO2',
    'CGO3',
    'CGO4',
    'CGO5',
    'CGO6',
    'CII',
    'CII1',
    'CII2',
    'CII3',
    'CII4',
    'CII5',
    'CII6',
    'CII7',
    'CII8',
    'CII9',
    'CIJ',
    'CIJ2',
    'CIP',
    'CIU',
    'CIV',
    'CIV1',
    'CIV2',
    'CMM',
    'CMN',
    'CNFEMAIL',
    'CTS1',
    'CTS2',
    'CTS3',
    'CTS4',
    'CTS5',
    'CTS6',
    'CTT',
    'CW11',
    'CW12',
    'CW35',
    'CW36',
    'CWIAFP1',
    'CWY',
    'CWY1',
    'CWY2',
    'CWY3',
    'CWY35',
    'CWY36',
    'CWY4',
    'CWY5',
    'CWY6',
    'CWY7',
    'CWY8',
    'DS9B',
    'DSJ',
    'DSJ2',
    'DSJ3',
    'DSJ4',
    'DSJ5',
    'DSJ6',
    'DSJ7',
    'DSN',
    'DSS',
    'DSTEST',
    'DTC1',
    'DTC2',
    'FAX',
    'GAH',
    'GMV',
    'HQF01',
    'HQU',
    'HQU1',
    'HQU2',
    'IAP',
    'IBX',
    'ICF',
    'ICF1',
    'ICF1101',
    'ICI',
    'ICM1101',
    'IFC231',
    'IHR',
    'IHR1101',
    'III',
    'III1',
    'III1101',
    'IIX',
    'IIX1',
    'ILC',
    'ILC1402',
    'ILF211',
    'ILJ211',
    'IMA1',
    'IMA2',
    'IMA3',
    'IOL',
    'IOL221',
    'IOL6',
    'IOL7',
    'IPC',
    'IPC1207',
    'IPE',
    'IPM211',
    'IPM213',
    'IPR',
    'IPV',
    'IPV1',
    'IPV2',
    'ISF',
    'ISFX',
    'ISJ1',
    'ISR',
    'ISS',
    'ISS322',
    'ISZ201',
    'ITA',
    'ITA1',
    'ITA1403',
    'ITA1404',
    'ITA2001',
    'ITA221',
    'ITA2402',
    'ITA2403',
    'ITA2503',
    'ITA2504',
    'ITA2505',
    'ITA2508',
    'ITA2514',
    'ITA2517',
    'ITA3',
    'ITAXX',
    'ITCAP',
    'ITJ',
    'ITK',
    'ITK1',
    'ITK2',
    'ITU',
    'ITW',
    'ITW1',
    'IUC',
    'IUC1',
    'IUE',
    'IUH1',
    'IUP',
    'IUPQS001',
    'IUS1',
    'KHY1',
    'KIR',
    'KMG',
    'KRD1',
    'KRR1',
    'KTS',
    'KTS1',
    'KTS2',
    'LAA',
    'LAA1',
    'LAA2',
    'LAB',
    'LAB1',
    'LAB2',
    'LAB3',
    'LAB4',
    'LAB5',
    'LAB6',
    'LAB7',
    'LAO',
    'LAO1',
    'LAO2',
    'LAT',
    'LAT1',
    'LAT2',
    'LAT3',
    'LAT4',
    'LAT5',
    'LAT6',
    'LBL',
    'LBL1',
    'LBL2',
    'LBL3',
    'LBL4',
    'LBL5',
    'LBM',
    'LBM1',
    'LBM2',
    'LBY',
    'LBY1',
    'LBY2',
    'LCX',
    'LCX1',
    'LCX2',
    'LCX3',
    'LCX4',
    'LCY',
    'LCY1',
    'LD4',
    'LD41',
    'LD42',
    'LDA',
    'LDA0',
    'LDA1',
    'LDA2',
    'LDA3',
    'LDA4',
    'LDA5',
    'LDA6',
    'LDA7',
    'LDA8',
    'LDA9',
    'LDE',
    'LDE1',
    'LDE2',
    'LDE3',
    'LDE4',
    'LDE5',
    'LDP',
    'LDZ',
    'LDZ0',
    'LDZ1',
    'LDZ2',
    'LDZ4',
    'LDZ5',
    'LEP',
    'LEP1',
    'LEP2',
    'LEP3',
    'LEP4',
    'LEP5',
    'LEP6',
    'LEP7',
    'LEP8',
    'LEY',
    'LFS',
    'LFS1',
    'LFS2',
    'LFS3',
    'LFW',
    'LFW1',
    'LFW2',
    'LFW3',
    'LFW4',
    'LFW5',
    'LFW6',
    'LFW7',
    'LFW8',
    'LFY',
    'LFY1',
    'LFY2',
    'LFY3',
    'LFY4',
    'LGA',
    'LGA1',
    'LGA2',
    'LGA3',
    'LGA4',
    'LGA5',
    'LGA6',
    'LGA7',
    'LGA8',
    'LGO',
    'LGO0',
    'LGO1',
    'LGO2',
    'LGO3',
    'LGO4',
    'LGO5',
    'LGO6',
    'LGO7',
    'LGO8',
    'LGO9',
    'LGP',
    'LGP1',
    'LGT',
    'LGT1',
    'LGT2',
    'LGT3',
    'LGT4',
    'LGT5',
    'LGT6',
    'LGT7',
    'LGT8',
    'LGV',
    'LGV1',
    'LGV2',
    'LH10',
    'LH11',
    'LH12',
    'LH13',
    'LH14',
    'LH15',
    'LH21',
    'LH7',
    'LHG',
    'LHG1',
    'LHG2',
    'LHG3',
    'LHG4',
    'LHG5',
    'LHG6',
    'LHO',
    'LHO0',
    'LHO1',
    'LHO2',
    'LHO3',
    'LHO4',
    'LHO5',
    'LHO6',
    'LHO7',
    'LHO8',
    'LHO9',
    'LHW',
    'LHW1',
    'LHW2',
    'LHW3',
    'LHW4',
    'LHW5',
    'LHW6',
    'LHW7',
    'LHW8',
    'LHZ',
    'LHZ1',
    'LHZ2',
    'LHZ3',
    'LHZ4',
    'LIC',
    'LJB',
    'LJB1',
    'LJB2',
    'LJB3',
    'LJB4',
    'LJC',
    'LJC1',
    'LJC2',
    'LJC3',
    'LJS',
    'LJS1',
    'LJS2',
    'LJS3',
    'LJS4',
    'LJS5',
    'LJS6',
    'LJS7',
    'LJS8',
    'LJZ',
    'LL10',
    'LL11',
    'LL12',
    'LL1A',
    'LL1B',
    'LLA',
    'LLA0',
    'LLA1',
    'LLA2',
    'LLA3',
    'LLA4',
    'LLA5',
    'LLA6',
    'LLA7',
    'LLA8',
    'LLA9',
    'LLB',
    'LLB1',
    'LLB2',
    'LLB5',
    'LLH4',
    'LLH5',
    'LLH6',
    'LLH7',
    'LLH9',
    'LLK',
    'LLK1',
    'LLK2',
    'LLL',
    'LLL1',
    'LLL2',
    'LLL3',
    'LLR',
    'LLR1',
    'LLR2',
    'LLR3',
    'LLR4',
    'LLR5',
    'LLR6',
    'LMD1',
    'LMD2',
    'LMD5',
    'LMH',
    'LMN',
    'LMO',
    'LMO1',
    'LMO2',
    'LMO4',
    'LMY',
    'LNO',
    'LNO1',
    'LNO2',
    'LNO3',
    'LNO4',
    'LNO5',
    'LNO6',
    'LNY',
    'LOK',
    'LOK1',
    'LOK2',
    'LOO',
    'LOO1',
    'LOO2',
    'LOO3',
    'LOO4',
    'LRZ3',
    'LS10',
    'LS11',
    'LS12',
    'LS13',
    'LS14',
    'LS15',
    'LS16',
    'LS17',
    'LS18',
    'LS19',
    'LS20',
    'LSD',
    'LSD1',
    'LSD2',
    'LSH',
    'LSH1',
    'LSH2',
    'LSL',
    'LSL1',
    'LSL2',
    'LSL3',
    'LSL4',
    'LSL5',
    'LSL6',
    'LSL7',
    'LSL8',
    'LSL9',
    'LSO',
    'LSW',
    'LSW3',
    'LSX',
    'LSX1',
    'LSX2',
    'LSX3',
    'LSX4',
    'LSX5',
    'LSX6',
    'LSX7',
    'LSX8',
    'LSX9',
    'LSZ',
    'LSZ2',
    'LTA',
    'LTA1',
    'LTA2',
    'LTA3',
    'LTA4',
    'LTE',
    'LTE1',
    'LTE2',
    'LTE3',
    'LTM',
    'LTM1',
    'LTU',
    'LTU1',
    'LTU2',
    'LTU3',
    'LTU4',
    'LTU5',
    'LTU6',
    'LTX',
    'LTX1',
    'LTX2',
    'LTX3',
    'LTX4',
    'LTX5',
    'LTX6',
    'LTX7',
    'LTY',
    'LTY1',
    'LTY2',
    'LTY3',
    'LTY4',
    'LTZ',
    'LTZ2',
    'LUZ',
    'LUZ2',
    'LUZ3',
    'LVC1',
    'LVC2',
    'LWA',
    'LWA1',
    'LWA2',
    'LWA3',
    'LWA4',
    'LWF',
    'LWF1',
    'LWF2',
    'LWF3',
    'LWY',
    'LWY1',
    'LWY2',
    'LWY3',
    'LWY4',
    'LWY5',
    'LWY7',
    'MCMS',
    'MLG',
    'MLG1',
    'MWC1',
    'N100',
    'NA10',
    'NA11',
    'NAA',
    'NAA1',
    'NAA3',
    'NAG',
    'NAG1',
    'NAG2',
    'NAG3',
    'NAL',
    'NAL1',
    'NAL2',
    'NAL3',
    'NAM1',
    'NAM2',
    'NAM3',
    'NAM4',
    'NAM7',
    'NAN',
    'NAN1',
    'NAN2',
    'NAT',
    'NAT0',
    'NAT1',
    'NAT2',
    'NAT3',
    'NAT4',
    'NAT5',
    'NAT6',
    'NAT7',
    'NAT8',
    'NAT9',
    'NAV',
    'NAV1',
    'NAV2',
    'NAV3',
    'NBM',
    'NBM1',
    'NBM2',
    'NBM3',
    'NBM4',
    'NBM5',
    'NBM6',
    'NBM7',
    'NBM8',
    'NBV',
    'NCB',
    'NCB1',
    'NCB2',
    'NCC',
    'NCH',
    'NCH0',
    'NCH1',
    'NCH10',
    'NCH2',
    'NCH3',
    'NCH4',
    'NCH5',
    'NCH6',
    'NCH7',
    'NCH8',
    'NCH9',
    'NCK',
    'NCK1',
    'NCK2',
    'NCO',
    'NCO1',
    'NCO2',
    'NCO3',
    'NCO4',
    'NCO5',
    'NCO6',
    'NCS',
    'NCS1',
    'NCS2',
    'NCS3',
    'NCT',
    'NCT1',
    'NCT2',
    'NCT3',
    'NCT4',
    'NCT5',
    'NCT6',
    'NCV',
    'NCV1',
    'NCV2',
    'NCZ',
    'NCZ2',
    'NCZ3',
    'NDE',
    'NDE1',
    'NDE2',
    'NDE3',
    'NDE4',
    'NDN',
    'NDN1',
    'NDN2',
    'NDN3',
    'NDO',
    'NDO1',
    'NDO2',
    'NEZ',
    'NEZ2',
    'NFC',
    'NFC1',
    'NFC2',
    'NFC3',
    'NFM',
    'NFM1',
    'NFM2',
    'NFM3',
    'NFM4',
    'NFY',
    'NFY1',
    'NFY2',
    'NFY3',
    'NFZ',
    'NFZ2',
    'NGA',
    'NGA1',
    'NGA2',
    'NGS',
    'NGS1',
    'NGS2',
    'NGS3',
    'NGS4',
    'NGS5',
    'NGV',
    'NGV0',
    'NGV1',
    'NGV2',
    'NGV3',
    'NGV4',
    'NGV5',
    'NGV6',
    'NGV7',
    'NGV8',
    'NGV9',
    'NHB',
    'NHB1',
    'NHB2',
    'NHB3',
    'NHB4',
    'NHB5',
    'NHN',
    'NHN1',
    'NHN2',
    'NHN3',
    'NHN4',
    'NHN5',
    'NHN6',
    'NHN7',
    'NIL',
    'NIL1',
    'NIL3',
    'NIL4',
    'NIL5',
    'NJV',
    'NJV1',
    'NJV2',
    'NJV3',
    'NJV4',
    'NJV5',
    'NJV6',
    'NJV7',
    'NKX',
    'NKX0',
    'NKX1',
    'NKX2',
    'NKX3',
    'NKX4',
    'NKX5',
    'NKX6',
    'NKX7',
    'NKX8',
    'NKX9',
    'NKZ',
    'NLB',
    'NLB1',
    'NLB2',
    'NLB3',
    'NLB4',
    'NLB5',
    'NLB6',
    'NLB7',
    'NLB8',
    'NLW',
    'NLW1',
    'NLW2',
    'NM10',
    'NM11',
    'NM14',
    'NM20',
    'NMA',
    'NMA1',
    'NMA2',
    'NMA3',
    'NMF',
    'NMF0',
    'NMF1',
    'NMF2',
    'NMF3',
    'NMF4',
    'NMF5',
    'NMF6',
    'NMF7',
    'NMF8',
    'NMF9',
    'NML',
    'NML1',
    'NML2',
    'NML3',
    'NML4',
    'NMO',
    'NMO1',
    'NMO2',
    'NMO3',
    'NMO4',
    'NMP',
    'NMP0',
    'NMP1',
    'NMP2',
    'NMP3',
    'NMP4',
    'NMP5',
    'NMP6',
    'NMP7',
    'NMP8',
    'NMP9',
    'NMT',
    'NMT1',
    'NMT5',
    'NN1',
    'NNA',
    'NNA0',
    'NNA1',
    'NNA2',
    'NNA3',
    'NNA5',
    'NNA6',
    'NNA7',
    'NNA8',
    'NNA9',
    'NNC',
    'NNC0',
    'NNC1',
    'NNC2',
    'NNC3',
    'NNC4',
    'NNC5',
    'NNC6',
    'NNC7',
    'NNC8',
    'NNC9',
    'NNF',
    'NNF1',
    'NNF2',
    'NNF3',
    'NNF4',
    'NNF5',
    'NNF6',
    'NNW',
    'NNW1',
    'NNW2',
    'NNW3',
    'NNW4',
    'NNW5',
    'NNZ',
    'NNZ1',
    'NNZ2',
    'NNZ3',
    'NNZ4',
    'NOF',
    'NOF1',
    'NOF2',
    'NOF3',
    'NOF5',
    'NOF6',
    'NOF7',
    'NOF8',
    'NOF9',
    'NPB',
    'NPB1',
    'NPB2',
    'NPB3',
    'NPB4',
    'NPB5',
    'NPB6',
    'NPR',
    'NPR1',
    'NPR2',
    'NPR3',
    'NPR4',
    'NPR6',
    'NPS',
    'NPS1',
    'NPS2',
    'NPS3',
    'NR10',
    'NRD',
    'NRD1',
    'NRD2',
    'NRD3',
    'NRD4',
    'NRD5',
    'NRD6',
    'NRD7',
    'NRD8',
    'NRD9',
    'NRG',
    'NRG1',
    'NRG2',
    'NRG3',
    'NRG4',
    'NRG5',
    'NRM0',
    'NRM1',
    'NRM2',
    'NRM3',
    'NRM4',
    'NRM5',
    'NRM6',
    'NRM7',
    'NRM8',
    'NRM9',
    'NRO',
    'NRO1',
    'NRO2',
    'NRO3',
    'NRO4',
    'NRO5',
    'NRO6',
    'NRZ',
    'NRZ1',
    'NRZ3',
    'NSA',
    'NSA1',
    'NSA2',
    'NSA3',
    'NSA4',
    'NSA5',
    'NSY',
    'NSY1',
    'NSY2',
    'NSY3',
    'NSY4',
    'NTA0',
    'NTH',
    'NTH1',
    'NTH2',
    'NTH3',
    'NTH4',
    'NTP',
    'NTP0',
    'NTP1',
    'NTP2',
    'NTP3',
    'NTP4',
    'NTP5',
    'NTP6',
    'NTP7',
    'NTP8',
    'NTP9',
    'NTR',
    'NTR1',
    'NTR2',
    'NTR3',
    'NVZ',
    'NW11',
    'NW12',
    'NW13',
    'NWB',
    'NWB1',
    'NWB2',
    'NWF',
    'NWF1',
    'NWF2',
    'NWF3',
    'NWL',
    'NWL1',
    'NWL2',
    'NWL3',
    'NWN',
    'NWN0',
    'NWN1',
    'NWN2',
    'NWN3',
    'NWN4',
    'NWN5',
    'NWN6',
    'NWN7',
    'NWN8',
    'NWN9',
    'NWR',
    'NWR1',
    'NWR2',
    'NWR3',
    'NWR4',
    'NWR5',
    'NWY',
    'NWY1',
    'NWY2',
    'NWY3',
    'NWZ',
    'NXZ',
    'NZY',
    'NZY1',
    'NZY2',
    'NZY3',
    'NZY4',
    'NZY5',
    'NZY6',
    'NZY7',
    'NZY8',
    'NZY9',
    'PC1P',
    'PCC',
    'PCC1',
    'PCC2',
    'PCN',
    'PCN2',
    'PND1',
    'QAL',
    'QCG',
    'QGA',
    'QGO',
    'QLO',
    'QRR',
    'QSCHP01',
    'QSCHP02',
    'QSCHP03',
    'RDA',
    'TGO1',
    'TP02',
    'TST',
    'TST1',
    'TST2',
    'TST3',
    'TSTEMAIL',
    'UAQ',
    'UAQ1',
    'UAQ2',
    'UAT',
    'UAT1',
    'UAT2',
    'UBA',
    'UBA1',
    'UBA2',
    'UBF',
    'UBF1',
    'UBF2',
    'UBG',
    'UBG1',
    'UBG2',
    'UBG3',
    'UBG4',
    'UBI',
    'UBI1',
    'UBI2',
    'UBI3',
    'UBI4',
    'UBI5',
    'UBU',
    'UBU1',
    'UBU2',
    'UBU3',
    'UBY',
    'UBY1',
    'UBY2',
    'UBY3',
    'UBY4',
    'UBY5',
    'UBY6',
    'UBY7',
    'UCC',
    'UCC1',
    'UCH',
    'UCO',
    'UCO1',
    'UCO2',
    'UCP',
    'UCP1',
    'UCP2',
    'UCP3',
    'UCQ',
    'UCQ1',
    'UCQ2',
    'UCQ3',
    'UCT',
    'UCT1',
    'UCT2',
    'UCT3',
    'UCU0',
    'UCU1',
    'UD10',
    'UD11',
    'UD12',
    'UD13',
    'UD14',
    'UDJ',
    'UDJ1',
    'UDJ2',
    'UDJ3',
    'UDJ4',
    'UDJ5',
    'UDS',
    'UDV',
    'UDV0',
    'UDV1',
    'UDV2',
    'UDV3',
    'UDV4',
    'UDV5',
    'UDV6',
    'UDV7',
    'UDV8',
    'UDV9',
    'UEH',
    'UEK',
    'UEK1',
    'UEO',
    'UEO1',
    'UEO2',
    'UEV',
    'UEV1',
    'UEV2',
    'UEV3',
    'UFA',
    'UFA1',
    'UFC',
    'UFN',
    'UFN1',
    'UFN2',
    'UFN3',
    'UFN4',
    'UFN5',
    'UFN6',
    'UFS',
    'UFS2',
    'UFS3',
    'UFV',
    'UFV1',
    'UFV2',
    'UFV3',
    'UGJ',
    'UGJ1',
    'UGJ2',
    'UGJ3',
    'UGO0',
    'UGO1',
    'UGO2',
    'UGO3',
    'UGO4',
    'UGO5',
    'UGO6',
    'UGO7',
    'UGO8',
    'UGO9',
    'UHH',
    'UHO1',
    'UIV',
    'UIV1',
    'UIV2',
    'UIV3',
    'UIV4',
    'UKA',
    'UKA1',
    'UKC',
    'UKC2',
    'UKC3',
    'UKC4',
    'UKC5',
    'UKC6',
    'UKC7',
    'ULA',
    'ULA0',
    'ULA1',
    'ULA2',
    'ULA3',
    'ULA4',
    'ULA5',
    'ULA6',
    'ULA7',
    'ULA8',
    'ULA9',
    'ULB',
    'ULB1',
    'ULB2',
    'ULB4',
    'ULB5',
    'ULB6',
    'ULB7',
    'ULH',
    'ULH1',
    'ULH2',
    'ULH3',
    'ULS',
    'ULS2',
    'ULS3',
    'ULS4',
    'ULS5',
    'ULV',
    'ULV1',
    'ULV2',
    'ULV3',
    'ULV4',
    'ULV5',
    'ULV6',
    'ULX',
    'ULX1',
    'ULX2',
    'ULX3',
    'ULX4',
    'ULX5',
    'ULX7',
    'ULX8',
    'ULX9',
    'ULZ',
    'UMM',
    'UMM1',
    'UMM2',
    'UMM3',
    'UMO',
    'UMO1',
    'UMO2',
    'UMO3',
    'UMV',
    'UMV1',
    'UMV2',
    'UNH',
    'UOA0',
    'UOA1',
    'UOA2',
    'UOA3',
    'UOA4',
    'UOA5',
    'UOA6',
    'UOA7',
    'UOA8',
    'UOA9',
    'UOD',
    'UOD1',
    'UOR',
    'UOR1',
    'UOR2',
    'UOR3',
    'UOR4',
    'UOR5',
    'UOR6',
    'UOS',
    'UOS2',
    'UP10',
    'UP11',
    'UP12',
    'UP2',
    'UP21',
    'UP22',
    'UP23',
    'UP24',
    'UPH',
    'UPH0',
    'UPH1',
    'UPH2',
    'UPH3',
    'UPH4',
    'UPH5',
    'UPH6',
    'UPH7',
    'UPH8',
    'UPH9',
    'UPI',
    'UPI1',
    'UPI2',
    'UPI3',
    'UPO',
    'UPO0',
    'UPO1',
    'UPO2',
    'UPO3',
    'UPO4',
    'UPO5',
    'UPO6',
    'UPO7',
    'UPO8',
    'UPO9',
    'UPP1',
    'UPP3',
    'UPS',
    'UPS2',
    'UPS3',
    'UPT',
    'UPT1',
    'UPW',
    'UPW1',
    'UPW2',
    'UPW3',
    'UPW4',
    'UPW5',
    'UPW6',
    'URD',
    'URD1',
    'URD2',
    'URE',
    'URE1',
    'URE2',
    'URE3',
    'URE4',
    'URE5',
    'URE6',
    'URE7',
    'URE8',
    'US10',
    'US20',
    'US21',
    'USA',
    'USA1',
    'USA2',
    'USA3',
    'USA4',
    'USA5',
    'USA6',
    'USA7',
    'USA8',
    'USA9',
    'USB',
    'USB0',
    'USB1',
    'USB2',
    'USB3',
    'USB4',
    'USB5',
    'USB6',
    'USB7',
    'USB8',
    'USB9',
    'USD',
    'USD1',
    'USD2',
    'USD3',
    'USD4',
    'USD5',
    'USD6',
    'USD8',
    'USD9',
    'USE',
    'USE0',
    'USE1',
    'USE2',
    'USE3',
    'USE4',
    'USE5',
    'USE6',
    'USE7',
    'USE8',
    'USE9',
    'USH',
    'USH001',
    'USJ',
    'USJ1',
    'USJ2',
    'USJ3',
    'USJ4',
    'USJ5',
    'USJ6',
    'USJ7',
    'USJ8',
    'USJ9',
    'USK',
    'USK1',
    'USK2',
    'USK9',
    'USL',
    'USL1',
    'USL2',
    'USL3',
    'USM',
    'USM1',
    'USM2',
    'USM3',
    'USR',
    'USR1',
    'USR2',
    'USR3',
    'USS',
    'USS2',
    'USS3',
    'UST',
    'UST1',
    'UST2',
    'UST3',
    'UST4',
    'UST5',
    'UST6',
    'UST7',
    'UST8',
    'UST9',
    'USU',
    'USU0',
    'USU1',
    'USU2',
    'USU3',
    'USU4',
    'USU5',
    'USU6',
    'USU7',
    'USU8',
    'USU9',
    'UTA',
    'UTA1',
    'UTA2',
    'UTA3',
    'UTA4',
    'UTA5',
    'UTA6',
    'UTA7',
    'UTF',
    'UTU',
    'UTU1',
    'UTU2',
    'UTU3',
    'UTU4',
    'UUH',
    'UUH1',
    'UUS',
    'UUS2',
    'UVC',
    'UVC1',
    'UVC2',
    'UVC3',
    'UVC5',
    'UVC6',
    'UWP',
    'UWS',
    'UWS2',
    'UWS3',
    'UWS4',
    'UWS5',
    'UWY',
    'UWY1',
    'UWY2',
    'UWY3',
    'UWY4',
    'UWY5',
    'UXB',
    'UXB1',
    'UXL',
    'UXL1',
    'UXL2',
    'UXL3',
    'UXP',
    'UYM',
    'UYM1',
    'UYM2',
    'UZO',
    'UZO2',
    'UZO3',
    'UZT',
    'UZT1',
    'VCO',
    'VOID',
    'VPS',
    'VSC',
    'VSX',
    'VTX',
    'VTX1',
    'VTX2',
    'WAT',
    'WCG',
    'WKC',
    'WNO',
    'WPA',
    'WRO',
    'WSC',
    'WTC',
    'XAB',
    'XAB1',
    'XAB2',
    'XAB3',
    'XAB4',
    'XAB5',
    'XAC',
    'XAC1',
    'XAC2',
    'XAC3',
    'XAC4',
    'XAC5',
    'XAC6',
    'XAE',
    'XAE1',
    'XAE2',
    'XAE3',
    'XAE5',
    'XAE6',
    'XAG',
    'XAG1',
    'XAG2',
    'XAG3',
    'XAG4',
    'XAH',
    'XAH1',
    'XAH2',
    'XAH3',
    'XAH4',
    'XAH5',
    'XAK',
    'XAK1',
    'XAK2',
    'XAK3',
    'XAM',
    'XAM1',
    'XAM2',
    'XAM3',
    'XAN',
    'XAN1',
    'XAN2',
    'XAN3',
    'XAN4',
    'XAN5',
    'XAN6',
    'XAN7',
    'XAQ',
    'XAQ1',
    'XAQ2',
    'XAQ3',
    'XAQ4',
    'XAQ5',
    'XAS',
    'XAS2',
    'XAS3',
    'XAS4',
    'XAS5',
    'XAT',
    'XAU',
    'XAU0',
    'XAU1',
    'XAU2',
    'XAU3',
    'XAU4',
    'XAU5',
    'XAU6',
    'XAU7',
    'XAU8',
    'XAU9',
    'XAX',
    'XAX1',
    'XAY',
    'XAY1',
    'XAY2',
    'XAY3',
    'XAY4',
    'XAY5',
    'XAY6',
    'XAY7',
    'XAY8',
    'XAY9',
    'XBA',
    'XBA1',
    'XBA2',
    'XBB',
    'XBB1',
    'XBB2',
    'XBB3',
    'XBD',
    'XBD1',
    'XBD2',
    'XBD3',
    'XBH',
    'XBH1',
    'XBH2',
    'XBH3',
    'XBI',
    'XBJ',
    'XBJ1',
    'XBN',
    'XBN1',
    'XBN2',
    'XBN3',
    'XBN4',
    'XBN5',
    'XBN6',
    'XBN7',
    'XBO',
    'XBO1',
    'XBO2',
    'XBO3',
    'XBO4',
    'XBO5',
    'XBO6',
    'XBO7',
    'XBO8',
    'XBO9',
    'XBP',
    'XBP1',
    'XBP2',
    'XBP3',
    'XBP4',
    'XBR',
    'XBR1',
    'XBR2',
    'XBR3',
    'XBV',
    'XBV0',
    'XBV1',
    'XBV2',
    'XBV3',
    'XBV4',
    'XBV5',
    'XBV6',
    'XBV7',
    'XBV8',
    'XBV9',
    'XBW',
    'XBW1',
    'XBW2',
    'XBX',
    'XBX1',
    'XBX2',
    'XBX3',
    'XBX4',
    'XBY',
    'XBY1',
    'XBY2',
    'XBY3',
    'XBY4',
    'XBY5',
    'XC10',
    'XC12',
    'XC15',
    'XC16',
    'XC17',
    'XC2',
    'XC22',
    'XC30',
    'XC40',
    'XC50',
    'XCA',
    'XCA1',
    'XCA2',
    'XCA3',
    'XCA4',
    'XCA5',
    'XCA6',
    'XCA7',
    'XCA8',
    'XCA9',
    'XCC',
    'XCC1',
    'XCC2',
    'XCD',
    'XCD1',
    'XCD2',
    'XCD3',
    'XCD4',
    'XCF',
    'XCF1',
    'XCF2',
    'XCF3',
    'XCF4',
    'XCF5',
    'XCF6',
    'XCF7',
    'XCF8',
    'XCF9',
    'XCG',
    'XCG1',
    'XCG2',
    'XCG3',
    'XCG4',
    'XCG5',
    'XCG6',
    'XCG7',
    'XCG8',
    'XCG9',
    'XCJ',
    'XCJ1',
    'XCJ2',
    'XCJ3',
    'XCL',
    'XCL0',
    'XCL1',
    'XCL2',
    'XCL3',
    'XCL4',
    'XCL5',
    'XCL6',
    'XCL7',
    'XCL8',
    'XCL9',
    'XCLA',
    'XCM',
    'XCM1',
    'XCM2',
    'XCM3',
    'XCM5',
    'XCN',
    'XCN0',
    'XCN1',
    'XCN2',
    'XCN3',
    'XCN4',
    'XCN5',
    'XCN6',
    'XCN7',
    'XCN8',
    'XCN9',
    'XCO',
    'XCO0',
    'XCO1',
    'XCO2',
    'XCO3',
    'XCO4',
    'XCO5',
    'XCO6',
    'XCO7',
    'XCO8',
    'XCO9',
    'XCR',
    'XCR1',
    'XCR2',
    'XCR3',
    'XCR4',
    'XCR5',
    'XCR6',
    'XCR7',
    'XCR8',
    'XCS',
    'XCS2',
    'XCU',
    'XCU1',
    'XCU2',
    'XCU3',
    'XCV',
    'XCV0',
    'XCV1',
    'XCV2',
    'XCV3',
    'XCV4',
    'XCV5',
    'XCV6',
    'XCV7',
    'XCV8',
    'XCV9',
    'XCW',
    'XCW0',
    'XCW1',
    'XCW2',
    'XCW3',
    'XCW4',
    'XCW5',
    'XCW6',
    'XCW7',
    'XCW8',
    'XCW9',
    'XCWA',
    'XCY',
    'XCY1',
    'XCY2',
    'XCY3',
    'XD10',
    'XD11',
    'XD12',
    'XD13',
    'XD20',
    'XD21',
    'XD22',
    'XDC',
    'XDC2',
    'XDC3',
    'XDE',
    'XDE0',
    'XDE1',
    'XDE2',
    'XDE3',
    'XDE4',
    'XDE5',
    'XDE6',
    'XDE7',
    'XDE8',
    'XDE9',
    'XDM',
    'XDM1',
    'XDM2',
    'XDM3',
    'XDM4',
    'XDM5',
    'XDM6',
    'XDM7',
    'XDM8',
    'XDM9',
    'XDP',
    'XDP0',
    'XDP1',
    'XDP2',
    'XDP3',
    'XDP4',
    'XDP5',
    'XDP6',
    'XDP7',
    'XDP8',
    'XDP9',
    'XDR',
    'XDR1',
    'XDR2',
    'XDR3',
    'XDR4',
    'XDR5',
    'XDR6',
    'XDR7',
    'XDR8',
    'XDR9',
    'XDS',
    'XDS1',
    'XDU',
    'XDU1',
    'XDU2',
    'XDU3',
    'XDV',
    'XDV1',
    'XDV2',
    'XDV3',
    'XDV4',
    'XDV6',
    'XDV7',
    'XDX',
    'XDX1',
    'XDY',
    'XDY1',
    'XDY2',
    'XDY3',
    'XDY4',
    'XDY5',
    'XEB',
    'XEB1',
    'XEB2',
    'XEB3',
    'XEE',
    'XEE1',
    'XEE2',
    'XEE3',
    'XEE4',
    'XEE5',
    'XEF',
    'XEF1',
    'XEF2',
    'XEF3',
    'XEG',
    'XEG1',
    'XEG2',
    'XEG3',
    'XEG4',
    'XEJ',
    'XEJ1',
    'XEJ2',
    'XEJ3',
    'XEJ4',
    'XEL',
    'XEL1',
    'XEL2',
    'XEL3',
    'XEL4',
    'XEM',
    'XEM1',
    'XEM2',
    'XEM3',
    'XEM4',
    'XEM5',
    'XEM6',
    'XEN',
    'XEN1',
    'XEN2',
    'XEN3',
    'XEN4',
    'XEN5',
    'XEN6',
    'XEN7',
    'XEN8',
    'XEN9',
    'XER',
    'XER1',
    'XER2',
    'XER3',
    'XES',
    'XES1',
    'XES3',
    'XEV',
    'XEV1',
    'XEV2',
    'XEV3',
    'XEV4',
    'XFD',
    'XFD1',
    'XFD2',
    'XFD3',
    'XFD4',
    'XFD5',
    'XFD6',
    'XFD7',
    'XFD8',
    'XFG',
    'XFG1',
    'XFG2',
    'XFG3',
    'XFG4',
    'XFG5',
    'XFK',
    'XFK1',
    'XFK2',
    'XFK3',
    'XFL',
    'XFL1',
    'XFL2',
    'XFL3',
    'XFM',
    'XFM1',
    'XFM2',
    'XFM3',
    'XFM4',
    'XFO',
    'XFO1',
    'XFO2',
    'XFR',
    'XFR1',
    'XFR2',
    'XFR3',
    'XFR4',
    'XFS',
    'XFS1',
    'XFS3',
    'XFV',
    'XFV1',
    'XFV2',
    'XFV3',
    'XFW',
    'XFW1',
    'XFW2',
    'XFW3',
    'XFW4',
    'XFW5',
    'XFW6',
    'XFW7',
    'XFW8',
    'XFW9',
    'XFY',
    'XFY1',
    'XFY2',
    'XFY3',
    'XFY4',
    'XGB',
    'XGB1',
    'XGB2',
    'XGB3',
    'XGB4',
    'XGB5',
    'XGH',
    'XGH1',
    'XGH2',
    'XGH3',
    'XGH4',
    'XGH5',
    'XGH6',
    'XGH7',
    'XGH8',
    'XGN',
    'XGN1',
    'XGN2',
    'XGN3',
    'XGN5',
    'XGO',
    'XGO0',
    'XGO2',
    'XGO3',
    'XGO4',
    'XGO5',
    'XGO6',
    'XGO8',
    'XGO9',
    'XGOTS001',
    'XGR',
    'XGR1',
    'XGR2',
    'XGR3',
    'XGR4',
    'XGS',
    'XGS1',
    'XGS3',
    'XGY',
    'XGY1',
    'XGY2',
    'XGY3',
    'XH10',
    'XHA',
    'XHA1',
    'XHA2',
    'XHB',
    'XHB1',
    'XHB2',
    'XHB3',
    'XHB4',
    'XHC',
    'XHC1',
    'XHC2',
    'XHC3',
    'XHC4',
    'XHG',
    'XHG0',
    'XHG1',
    'XHG2',
    'XHG3',
    'XHG4',
    'XHG5',
    'XHG6',
    'XHG7',
    'XHG8',
    'XHG9',
    'XHL',
    'XHL1',
    'XHL2',
    'XHL3',
    'XHL4',
    'XHM',
    'XHM1',
    'XHM2',
    'XHM3',
    'XHP',
    'XHP1',
    'XHP2',
    'XHP3',
    'XHP4',
    'XHP5',
    'XHR',
    'XHR1',
    'XHR2',
    'XHR3',
    'XHR4',
    'XHS2',
    'XHS4',
    'XHS5',
    'XHS6',
    'XHT',
    'XHT4',
    'XID',
    'XID1',
    'XID2',
    'XID3',
    'XID4',
    'XID5',
    'XID6',
    'XIM',
    'XIM1',
    'XIM2',
    'XIM3',
    'XIM4',
    'XIN',
    'XIN0',
    'XIN1',
    'XIN2',
    'XIN3',
    'XIN4',
    'XIN5',
    'XIN6',
    'XIN7',
    'XIN8',
    'XIN9',
    'XIS',
    'XIS1',
    'XIS3',
    'XIS4',
    'XIS5',
    'XIS6',
    'XIS7',
    'XIS8',
    'XIS9',
    'XIX',
    'XIX1',
    'XIX2',
    'XIX3',
    'XIX4',
    'XIY',
    'XIY1',
    'XIY2',
    'XIY3',
    'XIY4',
    'XIY5',
    'XIZ',
    'XIZ1',
    'XJA',
    'XJA1',
    'XJA2',
    'XJA3',
    'XJA4',
    'XJA5',
    'XJB',
    'XJB1',
    'XJB2',
    'XJN',
    'XJN1',
    'XJN2',
    'XJN3',
    'XJN4',
    'XJN5',
    'XJN6',
    'XJN9',
    'XJO',
    'XJO1',
    'XJO2',
    'XJO3',
    'XJO4',
    'XJO5',
    'XJO7',
    'XJP',
    'XJP1',
    'XJP2',
    'XJP3',
    'XJP4',
    'XJS',
    'XJS1',
    'XJV',
    'XJV1',
    'XJV2',
    'XJV3',
    'XJX',
    'XJX1',
    'XK10',
    'XK11',
    'XKC',
    'XKC0',
    'XKC1',
    'XKC2',
    'XKC3',
    'XKC4',
    'XKC5',
    'XKC6',
    'XKC7',
    'XKC8',
    'XKC9',
    'XKK',
    'XKK1',
    'XKK2',
    'XKK3',
    'XKK4',
    'XKK5',
    'XKL',
    'XKL1',
    'XKL2',
    'XKL3',
    'XKN',
    'XKN1',
    'XKN2',
    'XKN3',
    'XKO',
    'XKO1',
    'XKO2',
    'XKO3',
    'XKO4',
    'XKO5',
    'XKO6',
    'XKO7',
    'XKR',
    'XKR1',
    'XKR2',
    'XKR3',
    'XKR4',
    'XKS',
    'XKS2',
    'XKS3',
    'XL1',
    'XL2',
    'XL3',
    'XL4CREPL',
    'XLA0',
    'XLA1',
    'XLA2',
    'XLA3',
    'XLA4',
    'XLA5',
    'XLA6',
    'XLA7',
    'XLA8',
    'XLA9',
    'XLC',
    'XLC1',
    'XLC2',
    'XLC3',
    'XLC4',
    'XLF',
    'XLF1',
    'XLF2',
    'XLF3',
    'XLF4',
    'XLF5',
    'XLF6',
    'XLH',
    'XLH1',
    'XLH2',
    'XLH3',
    'XLH4',
    'XLH5',
    'XLH6',
    'XLH7',
    'XLH8',
    'XLH9',
    'XLL',
    'XLL1',
    'XLL2',
    'XLM',
    'XLM1',
    'XLM2',
    'XLM3',
    'XLO',
    'XLO1',
    'XLO2',
    'XLO3',
    'XLQ',
    'XLQ1',
    'XLQ2',
    'XLQ3',
    'XLS',
    'XLS1',
    'XLU',
    'XLU1',
    'XLU2',
    'XLU3',
    'XLU4',
    'XLU5',
    'XLU6',
    'XLU7',
    'XLU8',
    'XLU9',
    'XLW',
    'XLW1',
    'XLW2',
    'XLW3',
    'XLW4',
    'XLX',
    'XLX1',
    'XLX2',
    'XLX3',
    'XLX4',
    'XLX5',
    'XM10',
    'XM11',
    'XM12',
    'XM13',
    'XM14',
    'XM20',
    'XM21',
    'XM30',
    'XMA',
    'XMA1',
    'XMA2',
    'XMA3',
    'XMA4',
    'XMA5',
    'XMC',
    'XMC1',
    'XMC2',
    'XMC3',
    'XMD',
    'XMD1',
    'XMD2',
    'XMD3',
    'XMD4',
    'XMD5',
    'XMD6',
    'XMD7',
    'XMD8',
    'XMD9',
    'XME',
    'XME1',
    'XME2',
    'XME3',
    'XME4',
    'XME5',
    'XME6',
    'XMF',
    'XMF1',
    'XMF2',
    'XMF3',
    'XMI',
    'XMI0',
    'XMI1',
    'XMI2',
    'XMI3',
    'XMI4',
    'XMI5',
    'XMI6',
    'XMI7',
    'XMI8',
    'XMI9',
    'XMJ',
    'XMJ1',
    'XMJ2',
    'XMJ3',
    'XMJ4',
    'XMJ5',
    'XML',
    'XML0',
    'XML1',
    'XML2',
    'XML3',
    'XML4',
    'XML5',
    'XML6',
    'XML7',
    'XML8',
    'XML9',
    'XMN',
    'XMN1',
    'XMN2',
    'XMP',
    'XMP0',
    'XMP1',
    'XMP2',
    'XMP3',
    'XMP4',
    'XMP5',
    'XMP6',
    'XMP7',
    'XMP8',
    'XMP9',
    'XMR',
    'XMR1',
    'XMR2',
    'XMR3',
    'XMR4',
    'XMS',
    'XMS1',
    'XMS3',
    'XMW',
    'XMW1',
    'XMZ',
    'XMZ1',
    'XMZ2',
    'XNB',
    'XNB1',
    'XNB2',
    'XNB3',
    'XNB4',
    'XNB5',
    'XNH',
    'XNH1',
    'XNH2',
    'XNH3',
    'XNH4',
    'XNH5',
    'XNH6',
    'XNH7',
    'XNJ',
    'XNJ1',
    'XNJ2',
    'XNJ3',
    'XNJ4',
    'XNJ5',
    'XNJ6',
    'XNJ7',
    'XNJ8',
    'XNJ9',
    'XNS',
    'XNS2',
    'XNW',
    'XNW1',
    'XNW2',
    'XNW3',
    'XNW4',
    'XNW5',
    'XNW6',
    'XNW7',
    'XNW8',
    'XNW9',
    'XNX',
    'XNX2',
    'XNX3',
    'XOM',
    'XOM1',
    'XOM2',
    'XOM3',
    'XON',
    'XON1',
    'XON2',
    'XON3',
    'XOS',
    'XOS3',
    'XOW',
    'XOW1',
    'XOW2',
    'XOW3',
    'XPA',
    'XPA1',
    'XPA2',
    'XPA3',
    'XPB',
    'XPB1',
    'XPB2',
    'XPB3',
    'XPB4',
    'XPB5',
    'XPB6',
    'XPB7',
    'XPB8',
    'XPB9',
    'XPD1',
    'XPD2',
    'XPF',
    'XPF1',
    'XPF2',
    'XPF3',
    'XPH',
    'XPH1',
    'XPH2',
    'XPH3',
    'XPH4',
    'XPH5',
    'XPH6',
    'XPH7',
    'XPI',
    'XPI1',
    'XPI2',
    'XPI3',
    'XPI4',
    'XPI5',
    'XPI6',
    'XPK',
    'XPK1',
    'XPK2',
    'XPK3',
    'XPL',
    'XPL1',
    'XPL2',
    'XPN',
    'XPN1',
    'XPN2',
    'XPN3',
    'XPN4',
    'XPN5',
    'XPN6',
    'XPN7',
    'XPN8',
    'XPN9',
    'XPP',
    'XPP1',
    'XPP2',
    'XPR',
    'XPR1',
    'XPR2',
    'XPR3',
    'XPS',
    'XPS1',
    'XPS3',
    'XQB',
    'XQB1',
    'XQC',
    'XQC1',
    'XQC2',
    'XQC3',
    'XQC4',
    'XQC5',
    'XQC6',
    'XQC7',
    'XQC8',
    'XQC9',
    'XQQ',
    'XQS',
    'XQS1',
    'XQS3',
    'XR10',
    'XRC',
    'XRC1',
    'XRC2',
    'XRC3',
    'XRC4',
    'XRC5',
    'XRD',
    'XRD1',
    'XRD2',
    'XRD3',
    'XRD4',
    'XRF',
    'XRF0',
    'XRF1',
    'XRF2',
    'XRF3',
    'XRF4',
    'XRF5',
    'XRF6',
    'XRF7',
    'XRF8',
    'XRF9',
    'XRK',
    'XRK1',
    'XRK2',
    'XRK3',
    'XRL',
    'XRL1',
    'XRL2',
    'XRN',
    'XRN1',
    'XRN2',
    'XRN3',
    'XRN4',
    'XRO',
    'XRO1',
    'XRO2',
    'XRO3',
    'XRQ',
    'XRQ1',
    'XRS',
    'XRS2',
    'XRY',
    'XRY1',
    'XRZ',
    'XRZ1',
    'XRZ2',
    'XRZ3',
    'XRZ4',
    'XS10',
    'XS20',
    'XSA',
    'XSA1',
    'XSA2',
    'XSA3',
    'XSB',
    'XSB0',
    'XSB1',
    'XSB2',
    'XSB3',
    'XSB4',
    'XSB5',
    'XSB6',
    'XSB7',
    'XSB8',
    'XSB9',
    'XSC',
    'XSC1',
    'XSC2',
    'XSC3',
    'XSC4',
    'XSC5',
    'XSD',
    'XSD1',
    'XSD2',
    'XSD3',
    'XSD4',
    'XSD5',
    'XSD6',
    'XSD7',
    'XSD8',
    'XSF',
    'XSF1',
    'XSF2',
    'XSF3',
    'XSG',
    'XSG1',
    'XSG2',
    'XSG3',
    'XSG4',
    'XSH',
    'XSH1',
    'XSH2',
    'XSH3',
    'XSH4',
    'XSJ',
    'XSJ1',
    'XSJ2',
    'XSJ3',
    'XSJ4',
    'XSJ5',
    'XSJ6',
    'XSJ7',
    'XSL',
    'XSL0',
    'XSL1',
    'XSL2',
    'XSL3',
    'XSL4',
    'XSL5',
    'XSL6',
    'XSL7',
    'XSL8',
    'XSL9',
    'XSLA',
    'XSM',
    'XSM1',
    'XSM2',
    'XSM3',
    'XSM4',
    'XSM5',
    'XSN',
    'XSN1',
    'XSN2',
    'XSN3',
    'XSN4',
    'XSN5',
    'XSN6',
    'XSO',
    'XSO1',
    'XSO2',
    'XSO3',
    'XSO5',
    'XSO6',
    'XSO7',
    'XSP',
    'XSP1',
    'XSP2',
    'XSP3',
    'XSP4',
    'XSQ',
    'XSQ1',
    'XSQ2',
    'XSQ3',
    'XSS',
    'XSS1',
    'XSW',
    'XSW0',
    'XSW1',
    'XSW2',
    'XSW3',
    'XSW4',
    'XSW5',
    'XSW6',
    'XSW7',
    'XSW8',
    'XSW9',
    'XSX',
    'XSX0',
    'XSX1',
    'XSX2',
    'XSX3',
    'XSX4',
    'XSX5',
    'XSX6',
    'XSX7',
    'XSX8',
    'XSX9',
    'XSY',
    'XSY1',
    'XSY2',
    'XSY3',
    'XSY4',
    'XSY5',
    'XT10',
    'XT11',
    'XTH',
    'XTH1',
    'XTH2',
    'XTH3',
    'XTH4',
    'XTJ',
    'XTJ1',
    'XTJ2',
    'XTJ3',
    'XTJ4',
    'XTM',
    'XTM0',
    'XTM1',
    'XTM2',
    'XTM3',
    'XTM4',
    'XTM5',
    'XTM6',
    'XTM7',
    'XTM8',
    'XTM9',
    'XTN',
    'XTN1',
    'XTN2',
    'XTN3',
    'XTN4',
    'XTN5',
    'XTN6',
    'XTN7',
    'XTN8',
    'XTN9',
    'XTO',
    'XTO1',
    'XTO2',
    'XTO3',
    'XTO4',
    'XTO5',
    'XTS',
    'XTS1',
    'XTS3',
    'XTS4',
    'XUC',
    'XUC1',
    'XUC2',
    'XUC3',
    'XUD',
    'XUK',
    'XUK1',
    'XUK2',
    'XUK3',
    'XUR',
    'XUR1',
    'XUR2',
    'XUR3',
    'XUS',
    'XUS2',
    'XUS3',
    'XUX',
    'XUX2',
    'XUX3',
    'XVC',
    'XVC1',
    'XVC2',
    'XVL',
    'XVL1',
    'XVL2',
    'XVL3',
    'XVL4',
    'XVN',
    'XVN1',
    'XVN2',
    'XVN3',
    'XVS',
    'XVS1',
    'XWB',
    'XWB1',
    'XWB2',
    'XWB3',
    'XWB4',
    'XWB5',
    'XWC',
    'XWC1',
    'XWC2',
    'XWE',
    'XWE1',
    'XWE2',
    'XWG',
    'XWG1',
    'XWG2',
    'XWG3',
    'XWG4',
    'XWK',
    'XWK1',
    'XWK2',
    'XWK3',
    'XWK4',
    'XWK5',
    'XWN',
    'XWN1',
    'XWN2',
    'XWO',
    'XWO1',
    'XWO3',
    'XWO4',
    'XWO5',
    'XWS',
    'XWS3',
    'XWW',
    'XWW1',
    'XWW2',
    'XWW3',
    'XXD',
    'XXD1',
    'XXD2',
    'XXD3',
    'XYH',
    'XYH1',
    'XYH2',
    'XYH3',
    'XYH4',
    'XYH5',
    'XYS',
    'XYS2',
    'XYS3',
    'XYZ',
    'XYZ1',
    'XZH',
    'XZO',
    'XZO1',
    'XZO2',
    'XZQ',
    'XZQ1',
    'XZS',
    'XZS2',
    'XZS3',
    'YGA',
    'YGA1',
    'YGA2',
];

class XpoLtlPrintData {
}

class XpoLtlUserPreferencesService {
    constructor(userPreferenceApiService) {
        this.userPreferenceApiService = userPreferenceApiService;
    }
    /**
     * Update the preferences for the named component
     */
    updatePreferencesFor(componentName, preferences) {
        const upsertPreferencesRequest = new UpsertUserPreferenceRqst();
        upsertPreferencesRequest.uiComponentName = componentName;
        upsertPreferencesRequest.preferences = JSON.stringify(preferences);
        const upsertPreferencesQuery = new UpsertUserPreferenceQuery();
        return this.userPreferenceApiService
            .upsertUserPreference(upsertPreferencesRequest, upsertPreferencesQuery)
            .pipe(switchMapTo(of(preferences)));
    }
    /**
     * Get the user preferences stored for the named component
     * @param componentName name of the component to fetch stored preferences
     */
    getPreferencesFor(componentName) {
        const getPreferencesQuery = new GetUserPreferenceQuery();
        getPreferencesQuery.uiComponentName = componentName;
        return this.userPreferenceApiService.getUserPreference(getPreferencesQuery, { loadingOverlayEnabled: false }).pipe(retryWhen((errors) => 
        // retry getting list if we get an error. Might be waiting for authentication to complete
        errors.pipe(delay(1000), take(5))), map((response) => {
            let rawPreferences = '';
            if (response === null || response === void 0 ? void 0 : response.preferences) {
                if (!isString(response.preferences)) {
                    rawPreferences = response.preferences;
                }
                else if (!isEmpty(response.preferences)) {
                    rawPreferences = response.preferences;
                }
            }
            try {
                const preference = (isString(rawPreferences)
                    ? JSON.parse(rawPreferences)
                    : rawPreferences);
                return preference;
            }
            catch (err) {
                return undefined;
            }
        }), catchError((error) => of(undefined)));
    }
    /**
     * Clear preferences for the named component by writing an empty object
     * @param componentName name of component to clear preferences for
     */
    clearPreferencesFor(componentName) {
        return this.updatePreferencesFor(componentName, []).pipe(switchMapTo(of(undefined)));
    }
    /**
     * Ask the user if they wish to delete all of there saved preferences, and
     * if so, deletes them and reloads the default layout
     */
    resetUserPreferences(componentNames) {
        const clearPreferenceCalls = componentNames.map((componentName) => {
            return this.clearPreferencesFor(componentName);
        });
        return forkJoin(clearPreferenceCalls).pipe(mapTo(undefined));
    }
}
XpoLtlUserPreferencesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUserPreferencesService, deps: [{ token: i1$6.UserPreferenceApiService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlUserPreferencesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUserPreferencesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUserPreferencesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$6.UserPreferenceApiService }]; } });

var FBDSPreferenceKey;
(function (FBDSPreferenceKey) {
    FBDSPreferenceKey["DocumentType"] = "saved-printer-preference-key-docType";
    FBDSPreferenceKey["PaperType"] = "saved-printer-preference-key-paperType";
    FBDSPreferenceKey["PrinterPerforated"] = "saved-printer-preference-key-FBDS";
    FBDSPreferenceKey["PrinterTwoPart"] = "saved-printer-preference-key-DOCK";
    FBDSPreferenceKey["Reprint"] = "saved-service-center-preference-key";
    FBDSPreferenceKey["ServiceCenter"] = "saved-reprint-preference-key";
    FBDSPreferenceKey["Tray"] = "saved-tray-preference-key";
    FBDSPreferenceKey["Language"] = "saved-language-preference-key";
})(FBDSPreferenceKey || (FBDSPreferenceKey = {}));

/**
 * Abstract class for managing a Cache fo data.  Automatically fetches data from
 * the backing data sourcee if the item is not in the cache, or if it has been in
 * the cache longer than the max age.
 */
class XpoLtlBaseCacheService {
    constructor(maxRetries = XpoLtlBaseCacheService.MAX_RETRIES, retryDelay = XpoLtlBaseCacheService.RETRY_DELAY, maxAge = XpoLtlBaseCacheService.MAX_AGE) {
        this.maxRetries = maxRetries;
        this.retryDelay = retryDelay;
        this.maxAge = maxAge;
        this.cache = new Map();
    }
    /**
     * The keys for all items in the cache
     */
    get keys() {
        return Array.from(this.cache.keys());
    }
    /**
     * Return the number of items currently in the cache
     */
    get size() {
        return this.cache.size;
    }
    /**
     * Request data from the cache, fetching it from data source if not found or if it is stale
     * @param params used to request data
     * @returns Observable that resolves with the requested data
     */
    request(params) {
        const key = this.getKeyFromParams(params);
        const cachedData = this.cache.get(key);
        if (!cachedData || (this.maxAge > 0 && Date.now() - cachedData.timestamp > this.maxAge)) {
            const result$ = new Observable((observer) => {
                this.requestData(params)
                    .pipe(retryWhen((errors) => errors.pipe(delay(this.retryDelay), scan((tries, err) => {
                    if (tries >= this.maxRetries) {
                        throw err;
                    }
                    return tries + 1;
                }, 0))), finalize(() => {
                    observer.complete();
                }))
                    .subscribe((data) => {
                    observer.next(data);
                }, (err) => {
                    const errorCode = get(err, 'error.errorCode');
                    const errorMessage = get(err, 'error.message');
                    console.error(`Cache failed to get ${JSON.stringify(params)} with error: ${errorCode}: ${errorMessage}`);
                    observer.next(undefined);
                });
            }).pipe(shareReplay(1));
            this.cache.set(key, { timestamp: Date.now(), data$: result$ });
        }
        return this.cache.get(key).data$;
    }
    /**
     * Clear everything from cache
     */
    clear() {
        this.cache.clear();
    }
    /**
     * Delete the specified items from the cache
     * @param key key or list of keys that should be deleted from cache
     */
    delete(key) {
        let keysToDelete;
        if (typeof key === 'string') {
            keysToDelete = [key];
        }
        else {
            keysToDelete = key;
        }
        for (const keyToDelete of keysToDelete) {
            if (keyToDelete) {
                this.cache.delete(keyToDelete);
            }
        }
    }
}
XpoLtlBaseCacheService.MAX_RETRIES = 5; // how many time to retry fetching data before giving up
XpoLtlBaseCacheService.RETRY_DELAY = 500; // how long (in ms) between retries when fetching data
XpoLtlBaseCacheService.MAX_AGE = 0; // how long (in ms) to keep data before forcing a refresh. 0 means forever

class ShipmentCacheService extends XpoLtlBaseCacheService {
    constructor(conditioningService, shipmentApiService) {
        super();
        this.conditioningService = conditioningService;
        this.shipmentApiService = shipmentApiService;
        this.maxRetries = 1;
        this.retryDelay = 200;
    }
    getKeyFromParams({ shipmentId: { pickupDate, proNbr, shipmentInstId } }) {
        return `${shipmentInstId}_${proNbr}_${pickupDate}`;
    }
    requestData({ shipmentId: { pickupDate, proNbr, shipmentInstId }, }) {
        const queryShipmentId = shipmentInstId ? +shipmentInstId : undefined;
        let queryPro;
        let queryPickupDate;
        if (!queryShipmentId) {
            queryPro = this.conditioningService.conditionProNumber(proNbr, 10);
            queryPickupDate = moment$3(pickupDate).format('YYYY-MM-DD');
        }
        const queryParams = Object.assign(Object.assign({}, new GetShipmentQuery()), { shipmentInstId: queryShipmentId, proNbr: queryPro, pickupDate: queryPickupDate, shipmentDetailCd: [
                // will return both shipment object and child shipments
                ShipmentDetailCd.CHILD_SHIPMENT,
            ] });
        return this.shipmentApiService.getShipment(queryParams, { loadingOverlayEnabled: false });
    }
}
ShipmentCacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentCacheService, deps: [{ token: i3$1.ConditioningService }, { token: i2$6.ShipmentApiService }], target: i0.ɵɵFactoryTarget.Injectable });
ShipmentCacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentCacheService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentCacheService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i3$1.ConditioningService }, { type: i2$6.ShipmentApiService }]; } });

var FBDSDocType;
(function (FBDSDocType) {
    FBDSDocType["FBDS"] = "FBDS";
    FBDSDocType["DockCopy"] = "DockCopy";
    FBDSDocType["CopyBill"] = "CopyBill";
})(FBDSDocType || (FBDSDocType = {}));
var ShipmentInfo;
(function (ShipmentInfo) {
    ShipmentInfo["ShipmentGridInfo"] = "Shipment Information";
})(ShipmentInfo || (ShipmentInfo = {}));
const XpoLtlPrintDocType = Object.assign(Object.assign(Object.assign(Object.assign({}, XpoLtlDocType), FBDSDocType), ShipmentInfo), DocumentFormTypeCd);

var DocumentCategory;
(function (DocumentCategory) {
    DocumentCategory["Shipment"] = "Shipment";
    DocumentCategory["WeightAndInspection"] = "Weight & Inspection";
    DocumentCategory["GeneralClaims"] = "General Claims Inspection Report";
    DocumentCategory["FBDS"] = "FBDS";
    DocumentCategory["CopyBill"] = "Copy Bill";
})(DocumentCategory || (DocumentCategory = {}));

function printDocToIPrintDocMapper(doc, xpoLtlDocTypePipe) {
    return {
        isSelected: false,
        docType: doc.docType,
        description: doc.description,
        corpCode: doc.data.cdt.corpCode,
        docClass: doc.data.cdt.docClass,
        docClassLabel: xpoLtlDocTypePipe.transform(doc.data.cdt.docClass),
        timestamp: doc.data.cdt.timestamp,
        timestampISO: doc.data.timestampISO,
        tiemstampLabel: moment$3(doc.data.timestampISO).format('MM/DD/YYYY HH:mm'),
    };
}
const docTypeCatMap = {
    // Shipment
    [XpoLtlDocType.BillOfLading]: DocumentCategory.Shipment,
    [XpoLtlDocType.BillOfLadingAttachment]: DocumentCategory.Shipment,
    [XpoLtlDocType.DeliveryReceipt]: DocumentCategory.Shipment,
    [XpoLtlDocType.DeliveryReceiptAttachment]: DocumentCategory.Shipment,
    [XpoLtlDocType.LetterOfAuthority]: DocumentCategory.Shipment,
    [XpoLtlDocType.CustomsDocuments]: DocumentCategory.Shipment,
    // WeightAndInspection
    [XpoLtlDocType.NmfcClassInspectionCertificate]: DocumentCategory.WeightAndInspection,
    [XpoLtlDocType.WeightInspectionCertificate]: DocumentCategory.WeightAndInspection,
    [XpoLtlDocType.WeightAndResearchPhotos]: DocumentCategory.WeightAndInspection,
    [XpoLtlDocType.InspectionReportPhoto]: DocumentCategory.WeightAndInspection,
    [XpoLtlDocType.InMotionDimensionerPhoto]: DocumentCategory.WeightAndInspection,
    // GeneralClaims
    [XpoLtlDocType.InspectionReport]: DocumentCategory.GeneralClaims,
    [XpoLtlDocType.OSDPhoto]: DocumentCategory.GeneralClaims,
    [XpoLtlDocType.DeliveryExceptionPhoto]: DocumentCategory.GeneralClaims,
};
const hiddenPrintDocsMap = {
    [XpoLtlPrintDocType.DockCopy]: {
        [BillStatusCd.UNBILLED]: (shipmentResp) => `Unbilled PROs don't have this document type`,
    },
    [DocumentFormTypeCd.COPY_BILL]: {
        [BillStatusCd.UNBILLED]: (shipmentResp) => `Unbilled PROs don't have this document type`,
        [BillStatusCd.IN_FBES_SUSPENSE_QUEUE]: (shipmentResp) => `Unbilled PROs don't have this document type`,
    },
    [DocumentFormTypeCd.FBDS]: {
        [BillClassCd.EXPEDITE]: (shipmentResp) => `Expedited PROs don't have this document type`,
        [BillClassCd.SPLIT_SEGMENT]: (shipmentResp) => {
            var _a;
            const childShipments = (_a = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.childShipmentIds) !== null && _a !== void 0 ? _a : [];
            return childShipments ? `Part Lot PROs don't have this document type` : undefined;
        },
        [BillStatusCd.BILLED]: (shipmentResp) => {
            const shipment = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment;
            const revenueBillInd = shipment === null || shipment === void 0 ? void 0 : shipment.revenueBillInd;
            return revenueBillInd ? `Unrated PROs don't have this document type` : undefined;
        },
        [BillStatusCd.UNBILLED]: (shipmentResp) => `Unbilled PROs don't have this document type`,
    },
};

var LanguageEnum;
(function (LanguageEnum) {
    LanguageEnum["DEFAULT"] = "DEFAULT";
    LanguageEnum["BILINGUAL"] = "BILINGUAL";
    LanguageEnum["FRENCH"] = "FRENCH";
})(LanguageEnum || (LanguageEnum = {}));

class PrintService {
    constructor(userPreferencesService, shipmentApiService, configManagerService, loggedInUserService, cityOperationsService, conditioningService, shipmentCacheService, documentService) {
        this.userPreferencesService = userPreferencesService;
        this.shipmentApiService = shipmentApiService;
        this.configManagerService = configManagerService;
        this.loggedInUserService = loggedInUserService;
        this.cityOperationsService = cityOperationsService;
        this.conditioningService = conditioningService;
        this.shipmentCacheService = shipmentCacheService;
        this.documentService = documentService;
        this.shipmentDocumentsMapSubject = new BehaviorSubject({});
        this.shipmentDocumentsMap$ = this.shipmentDocumentsMapSubject.asObservable();
        this.showShipmentStatusGridSubject = new BehaviorSubject(false);
        this.showShipmentStatusGrid$ = this.showShipmentStatusGridSubject.asObservable();
        this.shipmentDocumentsNotAvailableSubject = new BehaviorSubject([]);
        this.shipmentDocumentsNotAvailable$ = this.shipmentDocumentsNotAvailableSubject.asObservable();
        this.fbdsDocumentsSubject = new BehaviorSubject([]);
        this.fbdsDocuments$ = this.fbdsDocumentsSubject.asObservable();
        this.currentlySelectedDocTypeSubject = new BehaviorSubject(undefined);
        this.currentlySelectedDocType$ = this.currentlySelectedDocTypeSubject.asObservable();
        this.isLoadingSubject = new BehaviorSubject(false);
        this.isLoading$ = this.isLoadingSubject.asObservable();
        this.selectedShipmentsSubject = new BehaviorSubject(undefined);
        this.selectedShipments$ = this.selectedShipmentsSubject.asObservable();
        this.selectedShipmentRespSubject = new BehaviorSubject(undefined);
        this.selectedShipmentResp$ = this.selectedShipmentRespSubject.asObservable();
        this.unsubscriber = new Unsubscriber();
    }
    get shipmentDocumentsMap() {
        return this.shipmentDocumentsMapSubject.value;
    }
    set selectedShipments(shipments) {
        this.selectedShipmentsSubject.next(shipments);
    }
    get selectedShipments() {
        return this.selectedShipmentsSubject.value;
    }
    loadDocumentsForShipments$(shipmentIds, docTypes) {
        this.isLoadingSubject.next(true);
        const dmsDocumentRequests$ = [];
        const fbdsDocumentRequests$ = [];
        const validDocTypes = docTypes.reduce((docTypeMap, docType) => {
            docTypeMap[docType] = true;
            return docTypeMap;
        }, {});
        const getValidDocTypes = (documentsList) => {
            return documentsList.filter((doc) => !!validDocTypes[doc.docType]);
        };
        shipmentIds.forEach((shipmentId) => {
            const { shipmentInstId, proNbr, trailerNbr, pickupDate } = shipmentId;
            let shipmentPro = this.conditioningService.conditionProNumber(proNbr, 11);
            if (shipmentInstId) {
                dmsDocumentRequests$.push(this.shipmentCacheService.request({ shipmentId }).pipe(takeUntil(this.unsubscriber.done$), switchMap((shipmentResp) => {
                    shipmentPro = this.conditioningService.conditionProNumber(shipmentResp.shipment.proNbr, 11);
                    return this.loadDmsPrintDocumentData$(shipmentPro, trailerNbr, pickupDate, shipmentResp);
                })));
            }
            else {
                dmsDocumentRequests$.push(this.loadDmsPrintDocumentData$(shipmentPro, trailerNbr, pickupDate));
            }
        });
        const nonTrailerIds = shipmentIds.filter((id) => {
            return !id.trailerNbr;
        });
        return forkJoin(dmsDocumentRequests$).pipe(takeUntil(this.unsubscriber.done$), switchMap((response) => {
            return forkJoin([
                of(response),
                this.loadFBDSDocumentData$(nonTrailerIds, DocumentFormTypeCd.FBDS),
                this.loadFBDSDocumentData$(nonTrailerIds, DocumentFormTypeCd.COPY_BILL),
            ]);
        }), map((responses) => {
            const shipmentDocumentsMap = {};
            responses.forEach((docResponse) => {
                const docResponseMap = docResponse.reduce((docMap, proKeyResponse) => {
                    var _a;
                    const proKey = (_a = Object.keys(proKeyResponse)) === null || _a === void 0 ? void 0 : _a[0];
                    if (proKey) {
                        if (!docMap[proKey]) {
                            const shipmentInfo = proKeyResponse[proKey].shipmentInfo;
                            const isCopyBillHidden = this.isDocHidden(shipmentInfo, DocumentFormTypeCd.COPY_BILL);
                            const isFBDSHidden = this.isDocHidden(shipmentInfo, DocumentFormTypeCd.FBDS);
                            const isDockCopyHidden = this.isDocHidden(shipmentInfo, XpoLtlPrintDocType.DockCopy);
                            const fbdsReprintInd = this.isDocReprint(shipmentInfo, DocumentFormTypeCd.FBDS);
                            docMap[proKey] = {
                                shipmentInfo: shipmentInfo,
                                documents: getValidDocTypes(proKeyResponse[proKey].documents),
                                isCopyBillHidden: isCopyBillHidden[0],
                                copyBillExclusionReason: isCopyBillHidden[1],
                                isFBDSHidden: isFBDSHidden[0],
                                fbdsExclusionReason: isFBDSHidden[1],
                                fbdsReprint: fbdsReprintInd,
                                isDockCopyHidden: isDockCopyHidden[0],
                                dockCopyExclusionReason: isDockCopyHidden[1],
                            };
                        }
                        else {
                            docMap[proKey].documents.push(...getValidDocTypes(proKeyResponse[proKey].documents));
                        }
                    }
                    return docMap;
                }, {});
                const selectedPro = Object.keys(docResponseMap);
                selectedPro.forEach((pro) => {
                    var _a, _b;
                    if (shipmentDocumentsMap.hasOwnProperty(pro)) {
                        const value = Object.values(docResponseMap[pro].documents);
                        const shipmentMap = Object.values(shipmentDocumentsMap[pro].documents);
                        shipmentDocumentsMap[pro].documents = [...value, ...shipmentMap];
                    }
                    else {
                        shipmentDocumentsMap[pro] = Object.assign(Object.assign({}, docResponseMap[pro]), { documents: [...((_b = (_a = docResponseMap[pro]) === null || _a === void 0 ? void 0 : _a.documents) !== null && _b !== void 0 ? _b : [])] });
                    }
                });
            });
            return shipmentDocumentsMap;
        }), tap((shipmentDocumentsMap) => {
            // console.log({ shipmentDocumentsMap });
            this.shipmentDocumentsMapSubject.next(shipmentDocumentsMap);
        }), finalize(() => {
            this.isLoadingSubject.next(false);
        }));
    }
    mapDmsDocumentToPrintDocument(document) {
        return {
            docType: document.cdt.docClass,
            description: document.cdt.timestamp,
            data: document,
        };
    }
    loadDmsPrintDocumentData$(proNbr, trailerNbr, pickupDate, shipmentResp) {
        return this.documentService
            .listAvailableDocuments(trailerNbr || proNbr, pickupDate, undefined, undefined, !!trailerNbr)
            .pipe(takeUntil(this.unsubscriber.done$), map((resp) => {
            return {
                [proNbr]: {
                    shipmentInfo: shipmentResp,
                    documents: resp.documentInfo.map((doc) => this.mapDmsDocumentToPrintDocument(doc)),
                    isCopyBillHidden: false,
                    copyBillExclusionReason: '',
                    isFBDSHidden: false,
                    fbdsExclusionReason: '',
                    fbdsReprint: false,
                    isDockCopyHidden: false,
                    dockCopyExclusionReason: '',
                },
            };
        }), catchError(() => {
            return of({});
        }));
    }
    loadFBDSDocumentData$(shipmentIds, docType) {
        const fbdsDocType = docType === DocumentFormTypeCd.FBDS ? XpoLtlPrintDocType.FBDS : XpoLtlPrintDocType.CopyBill;
        const requests$ = shipmentIds.reduce((reqArr, shipmentId) => {
            const request$ = this.shipmentCacheService.request({ shipmentId }).pipe(takeUntil(this.unsubscriber.done$), map((shipmentResp) => {
                const printValidation = this.validatePrintFbdsOrCopyBillForShipment(shipmentResp, docType);
                const printDocument = {
                    docType: fbdsDocType,
                    data: undefined,
                };
                const fbdsPrintItem = {
                    proNbr: this.conditioningService.conditionProNumber(shipmentResp.shipment.proNbr, 11),
                    fbdsPrintCount: 0,
                };
                if (printValidation.canPrint) {
                    fbdsPrintItem.fbdsPrintCount = +(shipmentResp.shipment.fbdsPrintCount || 0);
                }
                else {
                    printDocument.excludedInd = true;
                    printDocument.exclusionReason = printValidation.exclusionReason;
                }
                printDocument.data = fbdsPrintItem;
                return { [fbdsPrintItem.proNbr]: { documents: [printDocument] } };
            }), catchError((err) => {
                var _a, _b;
                const id = this.conditioningService.conditionProNumber(shipmentId.proNbr, 11);
                const errorMessage = (_b = (_a = err === null || err === void 0 ? void 0 : err.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : `Unable to load shipment.`;
                return of({
                    [id]: [
                        {
                            docType: fbdsDocType,
                            proNbr: id,
                            data: undefined,
                            excludedInd: true,
                            exclusionReason: errorMessage,
                        },
                    ],
                });
            }));
            reqArr.push(request$);
            return reqArr;
        }, []);
        return forkJoin(requests$);
    }
    loadFBDSUserPreferences$() {
        const getPreferenceValue = (preference) => (Array.isArray(preference) ? '' : preference);
        // Its a temporary fix CCS-6554
        const getPreferenceCustomValue = (preference) => {
            if (preference === LanguageEnum.FRENCH) {
                return FbdsVersionCd.FRENCH;
            }
            else if (preference === LanguageEnum.BILINGUAL) {
                return FbdsVersionCd.BILINGUAL;
            }
            else if (preference === LanguageEnum.DEFAULT) {
                return FbdsVersionCd.DEFAULT;
            }
            else {
                return Array.isArray(preference) ? '' : preference;
            }
        };
        return forkJoin([
            this.userPreferencesService.getPreferencesFor(FBDSPreferenceKey.DocumentType),
            this.userPreferencesService.getPreferencesFor(FBDSPreferenceKey.ServiceCenter),
            this.userPreferencesService.getPreferencesFor(FBDSPreferenceKey.PaperType),
            this.userPreferencesService.getPreferencesFor(FBDSPreferenceKey.PrinterPerforated),
            this.userPreferencesService.getPreferencesFor(FBDSPreferenceKey.PrinterTwoPart),
            this.userPreferencesService.getPreferencesFor(FBDSPreferenceKey.Tray),
            this.userPreferencesService.getPreferencesFor(FBDSPreferenceKey.Language),
        ]).pipe(takeUntil(this.unsubscriber.done$), map(([documentType, serviceCenter, paperType, perforatedPrinter, twoPartPrinter, tray, language]) => {
            return {
                [FBDSPreferenceKey.DocumentType]: getPreferenceValue(documentType),
                [FBDSPreferenceKey.ServiceCenter]: getPreferenceValue(serviceCenter),
                [FBDSPreferenceKey.PaperType]: getPreferenceValue(paperType),
                [FBDSPreferenceKey.PrinterPerforated]: getPreferenceValue(perforatedPrinter),
                [FBDSPreferenceKey.PrinterTwoPart]: getPreferenceValue(twoPartPrinter),
                [FBDSPreferenceKey.Tray]: getPreferenceValue(tray),
                [FBDSPreferenceKey.Language]: getPreferenceCustomValue(language),
            };
        }), tap((preferences) => {
            this.savedPreferences = preferences;
        }));
    }
    updateUserPreferences$(updatedPreferences) {
        const requests$ = [];
        for (const preferenceKey in updatedPreferences) {
            if (updatedPreferences[preferenceKey] !== undefined) {
                requests$.push(this.userPreferencesService.updatePreferencesFor(preferenceKey, updatedPreferences[preferenceKey]));
            }
        }
        return forkJoin(requests$).pipe(takeUntil(this.unsubscriber.done$), tap(() => {
            this.savedPreferences = updatedPreferences;
        }), mapTo(undefined));
    }
    getFBDSShipmentPros() {
        return this.fbdsDocumentsSubject.value.map((fbdsDocument) => fbdsDocument.proNbr);
    }
    printDocuments$(selectedDocuments) {
        const dmsDocTypeMap = Object.values(XpoLtlPrintDocType).reduce((docMap, docType) => {
            docMap[docType] = true;
            return docMap;
        }, {});
        const selectedDMSDocuments = selectedDocuments.filter((docType) => !!dmsDocTypeMap[docType]);
        this.isLoadingSubject.next(true);
        return this.printDocumentsFromDMS$(selectedDMSDocuments).pipe(takeUntil(this.unsubscriber.done$), finalize(() => this.isLoadingSubject.next(false)));
    }
    printDocumentsFromDMS$(selectedDocuments) {
        const selectedDocumentsMap = selectedDocuments.reduce((docMap, doc) => {
            docMap[doc] = true;
            return docMap;
        }, {});
        const dmsDocumentsRequests$ = [];
        for (const [_, info] of Object.entries(this.shipmentDocumentsMap)) {
            const documents = info.documents;
            documents === null || documents === void 0 ? void 0 : documents.forEach((document) => {
                var _a;
                if (selectedDocumentsMap[document.docType]) {
                    const { corpCode, docClass, timestamp } = (_a = document.data) === null || _a === void 0 ? void 0 : _a.cdt;
                    dmsDocumentsRequests$.push(this.documentService.getDocument(timestamp, docClass, corpCode).pipe(takeUntil(this.unsubscriber.done$), map((resp) => resp.documentData), catchError(() => of(''))));
                }
            });
        }
        return forkJoin(dmsDocumentsRequests$).pipe(takeUntil(this.unsubscriber.done$), defaultIfEmpty([]));
    }
    printShipmentGridInfo(renderedData) {
        const printWindow = window.open('');
        printWindow.document.write(renderedData);
        printWindow.print();
        printWindow.close();
    }
    printFBDSPerforated$(shipmentIds, printerId, paperSource, languageInd) {
        this.isLoadingSubject.next(true);
        return this.getLoggedInUser$().pipe(take(1), switchMap((user) => {
            var _a, _b;
            const deliverySetPrint = new DeliverySetPrint();
            deliverySetPrint.shipmentIds = shipmentIds;
            deliverySetPrint.sicCd = user.sicCode;
            deliverySetPrint.reprintInd = true;
            const request = Object.assign(Object.assign({}, new StartPrintDocumentEnsembleRqst()), { ensembleName: 'start-printdocument', businessKey1: deliverySetPrint.sicCd, businessKey2: '', businessKey3: (_b = (_a = deliverySetPrint === null || deliverySetPrint === void 0 ? void 0 : deliverySetPrint.shipmentIds) === null || _a === void 0 ? void 0 : _a.map((shipment) => shipment.proNumber)) === null || _b === void 0 ? void 0 : _b.toString(), businessKey4: printerId, businessKey5: paperSource, payload: {
                    printRequests: [
                        Object.assign(Object.assign({}, new PrintRequest()), { printerId,
                            paperSource,
                            deliverySetPrint, includeWarningsPageInd: true, language: languageInd }),
                    ],
                } });
            return this.cityOperationsService.startPrintDocumentEnsemble(request, { loadingOverlayEnabled: false });
        }), mapTo(undefined), finalize(() => {
            this.isLoadingSubject.next(false);
        }));
    }
    showUnmappedShipmentDocuments(selectedDocType) {
        this.shipmentDocumentsMap$
            .pipe(takeUntil(this.unsubscriber.done$), map((availableDocument) => {
            return this.mapGridData(availableDocument, selectedDocType);
        }))
            .subscribe((values) => {
            // console.log({values});
            this.shipmentDocumentsNotAvailableSubject.next(values);
        });
    }
    mapGridData(document, selectedDocType) {
        const selectedProKeys = Object.keys(document);
        const dataGrid = [];
        selectedProKeys.forEach((proNbr, index) => {
            const proAvailableInfo = document[proNbr];
            const isSelectedDocsAvailable = proAvailableInfo.documents.some((doc) => {
                if (doc.docType === XpoLtlPrintDocType.BillOfLading || doc.docType === XpoLtlPrintDocType.DeliveryReceipt) {
                    return true;
                }
            });
            if (selectedDocType === XpoLtlPrintDocType.FBDS) {
                if (proAvailableInfo.fbdsReprint || proAvailableInfo.isFBDSHidden) {
                    dataGrid.push({
                        id: `${index}${proNbr}`,
                        proNbr: proNbr,
                        docType: selectedDocType,
                        exclusionInd: proAvailableInfo.isFBDSHidden,
                        exclusionReason: proAvailableInfo.fbdsReprint ? 'Reprint' : proAvailableInfo.fbdsExclusionReason,
                        reprintInd: proAvailableInfo.fbdsReprint,
                    });
                }
            }
            if (selectedDocType === XpoLtlPrintDocType.CopyBill) {
                if (proAvailableInfo.isCopyBillHidden) {
                    dataGrid.push({
                        id: `${index}${proNbr}`,
                        proNbr: proNbr,
                        docType: selectedDocType,
                        exclusionInd: proAvailableInfo.isCopyBillHidden,
                        exclusionReason: proAvailableInfo.copyBillExclusionReason,
                        reprintInd: false,
                    });
                }
            }
            if (selectedDocType === XpoLtlPrintDocType.DockCopy) {
                if (proAvailableInfo.isDockCopyHidden) {
                    dataGrid.push({
                        id: `${index}${proNbr}`,
                        proNbr: proNbr,
                        docType: selectedDocType,
                        exclusionInd: proAvailableInfo.isDockCopyHidden,
                        exclusionReason: proAvailableInfo.dockCopyExclusionReason,
                        reprintInd: false,
                    });
                }
            }
            if (!isSelectedDocsAvailable) {
                const data = this.mapReasonWithDoc(proNbr, selectedDocType, index);
                if (!isEmpty(data)) {
                    dataGrid.push(data);
                }
            }
        });
        return dataGrid;
    }
    mapReasonWithDoc(proNbr, selectedDocType, index) {
        if (selectedDocType === XpoLtlPrintDocType.DeliveryReceipt || selectedDocType === XpoLtlPrintDocType.BillOfLading) {
            const printD = {
                id: `${index}${proNbr}`,
                proNbr: proNbr,
                docType: selectedDocType,
                exclusionInd: true,
                exclusionReason: selectedDocType === XpoLtlPrintDocType.DeliveryReceipt
                    ? `Undelivered PROs don't have this document type`
                    : 'This document type is not available.',
                reprintInd: false,
            };
            return printD;
        }
    }
    printFBDSDocumentFromLocal$(shipmentIds, languageInd) {
        const request = Object.assign(Object.assign({}, new CreateFBDSDocumentsRqst()), { shipmentIds: shipmentIds !== null && shipmentIds !== void 0 ? shipmentIds : [], formType: DocumentFormTypeCd.FBDS, generateSingleDocInd: true, includeWarningsPageInd: true, reprintInd: true, language: languageInd });
        this.isLoadingSubject.next(true);
        return this.shipmentApiService
            .createFBDSDocuments(request, { loadingOverlayEnabled: false })
            .pipe(takeUntil(this.unsubscriber.done$), finalize(() => {
            this.isLoadingSubject.next(false);
        }));
    }
    showLoader() {
        this.isLoadingSubject.next(true);
    }
    hideLoader() {
        this.isLoadingSubject.next(false);
    }
    downloadDocuments(documents) {
        const observables = documents.map((document) => {
            const { timestamp, docClass, corpCode } = document;
            return this.documentService.getDocument(timestamp, docClass, corpCode).pipe(map((doc) => [doc.documentData]));
        });
        return observables;
    }
    printFBDSTwoPartAndCopyBill$(proNbrs, docType, docFormType, paperType, printerCd) {
        let formType = docFormType;
        let reportType = docFormType;
        if (docFormType === DocumentFormTypeCd.FBDS && docType === FBDSDocumentType.DOCK_COPY) {
            formType = 'PAPER';
            reportType = 'DOCK';
        }
        const request = Object.assign(Object.assign({}, new PrintFBDSDocumentsRqst()), { proNbrs: proNbrs.map((proNbr) => this.conditioningService.conditionProNumber(proNbr, 11)), printFBDSDocumentsTypeCd: paperType, reprintInd: true, validateInd: true, includeProsNotDestinedInd: true, includeProsDestinedInd: true, includeClosedTrailersInd: true, reportType,
            formType });
        if (paperType === PrintFBDSDocumentsTypeCd.DOT_MATRIX) {
            request.printerCd = printerCd;
        }
        this.isLoadingSubject.next(true);
        return this.getLoggedInUser$().pipe(take(1), switchMap((user) => {
            request.domicileSicCd = user.sicCode;
            return this.shipmentApiService.printFBDSDocuments(request, { loadingOverlayEnabled: false });
        }), finalize(() => {
            this.isLoadingSubject.next(false);
        }));
    }
    getLoggedInUser$() {
        return this.loggedInUserService.getLoggedInUser(this.configManagerService.getSetting(ConfigManagerProperties$1.loggedInUserRoot));
    }
    removeFBDSDocumentForPro(proNbr) {
        const conditionedProToCompare = this.conditioningService.conditionProNumber(proNbr, 10);
        const updatedFBDSDocuments = this.fbdsDocumentsSubject.value.filter((fbdsDoc) => {
            return this.conditioningService.conditionProNumber(fbdsDoc.proNbr, 10) !== conditionedProToCompare;
        });
        this.fbdsDocumentsSubject.next(updatedFBDSDocuments);
    }
    mergePDFDocuments(documents) {
        return __awaiter(this, void 0, void 0, function* () {
            const mergedPdf = yield PDFDocument.create();
            for (const document of documents) {
                const pdfDocument = yield PDFDocument.load(document);
                const copiedPages = yield mergedPdf.copyPages(pdfDocument, pdfDocument.getPageIndices());
                copiedPages.forEach((page) => mergedPdf.addPage(page));
            }
            return yield mergedPdf.save();
        });
    }
    isDocHidden(shipmentResp, docType) {
        var _a, _b, _c, _d, _e;
        const billStatusCd = (_a = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _a === void 0 ? void 0 : _a.billStatusCd;
        const billClassCd = (_b = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _b === void 0 ? void 0 : _b.billClassCd;
        const exclusionFn = (_d = (_c = hiddenPrintDocsMap[docType]) === null || _c === void 0 ? void 0 : _c[billStatusCd]) !== null && _d !== void 0 ? _d : (_e = hiddenPrintDocsMap[docType]) === null || _e === void 0 ? void 0 : _e[billClassCd];
        const exclusionReason = exclusionFn === null || exclusionFn === void 0 ? void 0 : exclusionFn(shipmentResp);
        return [!!exclusionReason, exclusionReason];
    }
    isDocReprint(shipmentResp, docType) {
        var _a, _b, _c, _d;
        if (docType === DocumentFormTypeCd.FBDS) {
            const billClassCd = (_a = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _a === void 0 ? void 0 : _a.billClassCd;
            const billStatusCd = (_b = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _b === void 0 ? void 0 : _b.billStatusCd;
            if (billClassCd === BillClassCd.EXPEDITE || billClassCd === BillClassCd.SPLIT_SEGMENT) {
                return false;
            }
            if (billStatusCd === BillStatusCd.UNBILLED && !((_c = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _c === void 0 ? void 0 : _c.revenueBillInd)) {
                return false;
            }
            if (billStatusCd === BillStatusCd.BILLED && !((_d = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _d === void 0 ? void 0 : _d.revenueBillInd)) {
                return false;
            }
            return true;
        }
        else {
            return false;
        }
    }
    validatePrintFbdsOrCopyBillForShipment(shipmentResp, docType) {
        const printValidation = { canPrint: true };
        const shipment = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment;
        if (!shipment) {
            printValidation.canPrint = false;
            printValidation.exclusionReason = 'Unable to load shipment.';
            return printValidation;
        }
        const hiddenValidation = this.isDocHidden(shipmentResp, docType);
        printValidation.canPrint = !hiddenValidation[0];
        printValidation.exclusionReason = hiddenValidation[1];
        return printValidation;
    }
    reset() {
        this.fbdsDocumentsSubject.next([]);
        this.shipmentDocumentsMapSubject.next({});
        this.isLoadingSubject.next(false);
        this.shipmentCacheService.clear();
        this.savedPreferences = {};
    }
}
PrintService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintService, deps: [{ token: XpoLtlUserPreferencesService }, { token: i2$6.ShipmentApiService }, { token: i2$3.ConfigManagerService }, { token: XpoLtlLoggedInUserService }, { token: i5$1.CityOperationsApiService }, { token: XpoLtlConditioningService }, { token: ShipmentCacheService }, { token: XpoLtlDocumentService }], target: i0.ɵɵFactoryTarget.Injectable });
PrintService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlUserPreferencesService }, { type: i2$6.ShipmentApiService }, { type: i2$3.ConfigManagerService }, { type: XpoLtlLoggedInUserService }, { type: i5$1.CityOperationsApiService }, { type: XpoLtlConditioningService }, { type: ShipmentCacheService }, { type: XpoLtlDocumentService }]; } });

class FBDSPrintBaseComponent {
    constructor(printService) {
        this.printService = printService;
        this.unsubscriber = new Unsubscriber();
        this.legacyPrinterMap = {};
    }
    ngOnInit() {
        this.isLoading$ = this.printService.isLoading$;
        this.setLegacyPrinterMap();
    }
    setLegacyPrinterMap() {
        this.legacyPrinterMap = legacyPrintersList.reduce((printerMap, printerName) => {
            printerMap[printerName] = true;
            return printerMap;
        }, {});
    }
    filterSimpleAutocomplete(filterValue, itemList) {
        return filterValue
            ? itemList.filter((printerItem) => printerItem.toLowerCase().includes(filterValue.toLowerCase()))
            : itemList;
    }
}
FBDSPrintBaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FBDSPrintBaseComponent, deps: [{ token: PrintService }], target: i0.ɵɵFactoryTarget.Component });
FBDSPrintBaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FBDSPrintBaseComponent, selector: "ng-component", inputs: { data: "data", form: "form" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FBDSPrintBaseComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: function () { return [{ type: PrintService }]; }, propDecorators: { data: [{
                type: Input
            }], form: [{
                type: Input
            }] } });

var PrintFormFields;
(function (PrintFormFields) {
    PrintFormFields["ServiceCenter"] = "ServiceCenter";
    PrintFormFields["Printer"] = "Printer";
    PrintFormFields["Tray"] = "Tray";
    PrintFormFields["DocumentType"] = "DocumentType";
    PrintFormFields["PaperType"] = "PaperType";
    PrintFormFields["PrintFBDSFromLocal"] = "PrintFBDSFromLocal";
    PrintFormFields["FBDS"] = "FBDS";
    PrintFormFields["DockCopy"] = "DockCopy";
    PrintFormFields["SelectedDocuments"] = "SelectedDocuments";
    PrintFormFields["isPrintingUsingSystemDialog"] = "isPrintingUsingSystemDialog";
    PrintFormFields["Language"] = "Language";
})(PrintFormFields || (PrintFormFields = {}));

var PrintComponentState;
(function (PrintComponentState) {
    PrintComponentState["InitData"] = "INIT";
    PrintComponentState["Error"] = "ERROR";
    PrintComponentState["ShowPrint"] = "SHOW_PRINT";
})(PrintComponentState || (PrintComponentState = {}));

var PrintSource;
(function (PrintSource) {
    PrintSource["ShipmentGrid"] = "shipmentGrid";
    PrintSource["ShipmentDetails"] = "ShipmentDetails"; // When source is ShipmentDetails
})(PrintSource || (PrintSource = {}));

var LanguageType;
(function (LanguageType) {
    LanguageType["ENGLISH_ONLY"] = "Print in English only";
    LanguageType["FRENCH_ONLY"] = "Print in French only";
    LanguageType["ENGLISH_FRENCH_BOTH"] = "Print in French with English translations";
})(LanguageType || (LanguageType = {}));

class DocumentsStatusService extends XpoBoardDataSource {
    constructor(printService) {
        super();
        this.printService = printService;
    }
    fetchData(state) {
        return this.printService.shipmentDocumentsNotAvailable$.pipe(map((docsNotAvailableForPro) => {
            return new XpoBoardData(state, docsNotAvailableForPro, docsNotAvailableForPro.length, this.pageSize);
        }));
    }
}
DocumentsStatusService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DocumentsStatusService, deps: [{ token: PrintService }], target: i0.ɵɵFactoryTarget.Injectable });
DocumentsStatusService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DocumentsStatusService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DocumentsStatusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: PrintService }]; } });

class ActionIconCellRendererComponent {
    constructor() { }
    agInit(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        return true;
    }
}
ActionIconCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ActionIconCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ActionIconCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ActionIconCellRendererComponent, selector: "xpo-ltl-action-icon-cell-renderer", ngImport: i0, template: "<xpo-icon iconName=\"delete\"></xpo-icon>\n", styles: [""], components: [{ type: i1$7.XpoIcon, selector: "xpo-icon", inputs: ["iconName"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ActionIconCellRendererComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-action-icon-cell-renderer',
                    templateUrl: './action-icon-cell-renderer.component.html',
                    styleUrls: ['./action-icon-cell-renderer.component.scss']
                }]
        }], ctorParameters: function () { return []; } });

class StatusIndicatorCellRendererComponent {
    constructor() { }
    agInit(params) {
        var _a;
        this.statusText = params === null || params === void 0 ? void 0 : params.getStatusText(params);
        this.statusColor = params === null || params === void 0 ? void 0 : params.getStatusColor(params);
        this.isLabel = (_a = params === null || params === void 0 ? void 0 : params.isLabel) !== null && _a !== void 0 ? _a : false;
    }
    refresh() {
        return false;
    }
}
StatusIndicatorCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StatusIndicatorCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StatusIndicatorCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: StatusIndicatorCellRendererComponent, selector: "xpo-ltl-status-indicator-cell-renderer", ngImport: i0, template: "<ng-container *ngIf=\"statusText || statusColor\">\n  <xpo-status-indicator\n    [statusText]=\"statusText\"\n    [statusColor]=\"statusColor\"\n    [isLabel]=\"isLabel\"\n  ></xpo-status-indicator>\n</ng-container>\n", styles: [""], components: [{ type: i2$7.XpoStatusIndicator, selector: "xpo-status-indicator", inputs: ["isLabel", "statusText", "statusColor"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StatusIndicatorCellRendererComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-status-indicator-cell-renderer',
                    templateUrl: './status-indicator-cell-renderer.component.html',
                    styleUrls: ['./status-indicator-cell-renderer.component.scss'],
                }]
        }], ctorParameters: function () { return []; } });

class DocumentsStatusGridComponent {
    constructor(dataSource, conditioningService, printService) {
        this.dataSource = dataSource;
        this.conditioningService = conditioningService;
        this.printService = printService;
        this.customGridOptions = {
            suppressCsvExport: true,
            suppressExcelExport: true,
            deltaRowDataMode: true,
            getRowNodeId: function (data) {
                return data.id;
            },
            defaultColDef: {
                filter: true,
                sortable: false,
                suppressMenu: true,
            },
            enableBrowserTooltips: true,
            enableRangeSelection: true,
            frameworkComponents: [
                XpoStringFilterComponent,
                ActionIconCellRendererComponent,
                StatusIndicatorCellRendererComponent,
            ],
        };
        this.boardOptions = {
            suppressViewSwitcher: true,
            suppressGridSettingsPopover: true,
        };
    }
    ngOnInit() {
        this.viewTemplates = this.getViewTemplates();
        this.views = this.getViews(this.viewTemplates[0]);
    }
    removeSelectedShipment(data) {
        const selectedShipment = data.data;
        const totalAvailableShipment = this.printService.shipmentDocumentsMap;
        if (totalAvailableShipment[selectedShipment.proNbr]) {
            delete totalAvailableShipment[selectedShipment.proNbr];
            this.printService.shipmentDocumentsMapSubject.next(Object.assign({}, totalAvailableShipment));
            this.dataSource.refresh();
        }
    }
    getViewTemplates() {
        return [
            new XpoAgGridBoardViewTemplate({
                id: 'documentsStatusGridTemplate',
                name: 'documentsStatusGridTemplate',
                keyField: 'id',
                availableColumns: [
                    {
                        width: 50,
                        lockPosition: true,
                        pinned: 'left',
                        cellRendererFramework: ActionIconCellRendererComponent,
                        resizable: false,
                        onCellClicked: (data) => this.removeSelectedShipment(data),
                    },
                    {
                        headerName: 'PRO',
                        field: 'PRO',
                        width: 100,
                        suppressMenu: false,
                        resizable: false,
                        sortable: true,
                        filter: 'agTextColumnFilter',
                        floatingFilter: true,
                        floatingFilterComponentParams: {
                            suppressFilterButton: true,
                        },
                        valueGetter: (params) => {
                            return this.conditioningService.conditionProNumber(params.data.proNbr, 10);
                        },
                    },
                    {
                        headerName: 'Documents Status',
                        field: 'Documents Status',
                        sortable: true,
                        width: 300,
                        suppressMenu: false,
                        resizable: true,
                        filter: 'agTextColumnFilter',
                        floatingFilter: true,
                        cellRendererFramework: StatusIndicatorCellRendererComponent,
                        cellRendererParams: {
                            isLabel: false,
                            getStatusText: (params) => this.getRouteStatusText(params),
                            getStatusColor: (params) => this.getRouteStatusColor(params),
                        },
                        valueGetter: (params) => {
                            var _a;
                            return (_a = params.data) === null || _a === void 0 ? void 0 : _a.exclusionReason;
                        },
                        comparator: (valueA, valueB, nodeA, nodeB) => {
                            const itemA = nodeA.data.exclusionReason;
                            const itemB = nodeB.data.exclusionReason;
                            return itemA.localeCompare(itemB);
                        },
                    },
                ],
            }),
        ];
    }
    onGridReady(gridEvent) {
        this.gridApiEvent = gridEvent;
        this.gridApi = gridEvent.api;
    }
    getViews(viewTemplate) {
        return [
            viewTemplate.createView({
                id: 'default',
                name: 'default',
                systemDefined: true,
            }),
        ];
    }
    getRouteStatusText(params) {
        var _a;
        return (_a = params.data) === null || _a === void 0 ? void 0 : _a.exclusionReason;
    }
    getRouteStatusColor(params) {
        var _a;
        if (((_a = params.data) === null || _a === void 0 ? void 0 : _a.reprintInd) > 0) {
            return 'yellow';
        }
        return 'red';
    }
}
DocumentsStatusGridComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DocumentsStatusGridComponent, deps: [{ token: DocumentsStatusService }, { token: XpoLtlConditioningService }, { token: PrintService }], target: i0.ɵɵFactoryTarget.Component });
DocumentsStatusGridComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: DocumentsStatusGridComponent, selector: "xpo-ltl-documents-status-grid", ngImport: i0, template: "<div class=\"documentGrid\">\n  <xpo-board\n    class=\"documentGrid__board--height\"\n    [dataSource]=\"dataSource\"\n    [viewTemplates]=\"viewTemplates\"\n    [views]=\"views\"\n    [boardOptions]=\"boardOptions\"\n  >\n    <xpo-applied-filters [conditionalFiltersOnly]=\"true\"></xpo-applied-filters>\n    <xpo-ag-grid-board\n      rowModelType=\"client-side\"\n      rowSelection=\"single\"\n      [sizeColumnsToFit]=\"true\"\n      (gridReady)=\"onGridReady($event)\"\n      [customGridOptions]=\"customGridOptions\"\n    >\n    </xpo-ag-grid-board>\n  </xpo-board>\n</div>\n", styles: [":host ::ng-deep xpo-grid-bar{display:none}.documentGrid__board--height{height:25vh}"], components: [{ type: i4$5.XpoBoard, selector: "xpo-board", inputs: ["id", "dataSource", "views", "viewTemplates", "viewDataStore", "boardOptions", "addBoardViewLabel", "enableFilterReset", "enableQueryParamStatePersistance", "hideViewSwitcher", "hideViewSettingsMenu", "preloadViewData", "applyFilterStrategy", "showRecordCounts", "persistFiltersBetweenViews"], outputs: ["boardReady", "selectionChange"] }, { type: i4$5.XpoAppliedFilters, selector: "xpo-applied-filters", inputs: ["conditionalFiltersOnly"] }, { type: i5$2.XpoAgGridBoard, selector: "xpo-ag-grid-board", inputs: ["autoSelectFirstRow", "autoSizeColumns", "enableMovableColumns", "enableCellSelection", "enableRowSelection", "enableSorting", "groupUseEntireRow", "sizeColumnsToFit", "customGridOptions", "rowSelection", "rowModelType", "selectionMode", "suppressUsingRecordCount", "columnFilters", "pagination", "paginationPageSizes", "paginationPageSizeStart", "highlightMode"], outputs: ["cellSelected", "gridReady", "gridBoardReady", "refreshPagination"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DocumentsStatusGridComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-documents-status-grid',
                    templateUrl: './documents-status-grid.component.html',
                    styleUrls: ['./documents-status-grid.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: DocumentsStatusService }, { type: XpoLtlConditioningService }, { type: PrintService }]; } });

class FbdsPrintComponent extends FBDSPrintBaseComponent {
    constructor(dialogRef, conditioningService, serviceCenterCacheService, infrastructureApiService, xpoSnackBar, printService, changeDetectorRef) {
        super(printService);
        this.dialogRef = dialogRef;
        this.conditioningService = conditioningService;
        this.serviceCenterCacheService = serviceCenterCacheService;
        this.infrastructureApiService = infrastructureApiService;
        this.xpoSnackBar = xpoSnackBar;
        this.printService = printService;
        this.changeDetectorRef = changeDetectorRef;
        this.docTypeSubject = new BehaviorSubject(XpoLtlPrintDocType.FBDS);
        this.docType$ = this.docTypeSubject.asObservable();
        this.documentNotAvailableCountSubject = new BehaviorSubject(undefined);
        this.documentNotAvailableCount$ = this.documentNotAvailableCountSubject.asObservable();
        this.DocumentFormTypeCd = DocumentFormTypeCd;
        this.PrintFBDSDocumentsTypeCd = PrintFBDSDocumentsTypeCd;
        this.FBDSDocumentType = FBDSDocumentType;
        this.FBDSPrintFormFields = PrintFormFields;
        this.FBDSComponentState = PrintComponentState;
        this.XpoLtlPrintDocType = XpoLtlPrintDocType;
        this.PrintSource = PrintSource;
        this.LanguageType = LanguageType;
        this.FbdsVersionCd = FbdsVersionCd;
        this.printerTrayMap = {};
        this.isLoadingPrinterListSubject = new BehaviorSubject(false);
        this.isLoadingPrinterList$ = this.isLoadingPrinterListSubject.asObservable();
        this.showReprintedProsSubject = new BehaviorSubject(false);
        this.isFBDSPerforatedPrintSubject = new BehaviorSubject(false);
        this.isFBDSPerforatedPaperSelected$ = this.isFBDSPerforatedPrintSubject.asObservable();
        this.showShipments = false;
        this.isLocalPrintForm$ = new BehaviorSubject(false);
        this.printerPlaceHolder = 'Select Printer';
        this.printerPlaceHolderSubject = new BehaviorSubject(this.printerPlaceHolder);
    }
    set isLocalPrintForm(value) {
        this.isLocalPrintForm$.next(value);
    }
    set docType(type) {
        this.docTypeSubject.next(type);
        this.changeDetectorRef.detectChanges();
    }
    get docType() {
        return this.docTypeSubject.value;
    }
    get isFBDSMode() {
        var _a, _b;
        return ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.docTypes) === null || _b === void 0 ? void 0 : _b[0]) === XpoLtlPrintDocType.FBDS;
    }
    get isFBDSDocType() {
        return this.docType === XpoLtlPrintDocType.FBDS;
    }
    get isDockCopyType() {
        return this.docType === XpoLtlPrintDocType.DockCopy;
    }
    ngOnInit() {
        super.ngOnInit();
        this.addFormListeners();
        this.isSourceShipmentDetails = this.data.printSource === PrintSource.ShipmentDetails;
        this.isLoadingServiceCenters$ = this.serviceCenterCacheService.serviceCenters$.pipe(map((serviceCenters) => !(serviceCenters === null || serviceCenters === void 0 ? void 0 : serviceCenters.length)));
        // this.initTitleContent();
        this.initFormGroup();
        this.initData();
        this.initReprintItemsWatchers();
        this.showShipmentStatusGrid();
        this.initFBDSDocumentExcludedItemsWatcher();
        this.subscribeToPerforatedPrinterUpdates();
        this.updateShipmentSelectedAttentionText();
    }
    ngOnChanges(changes) {
        if (changes.docType &&
            !changes.docType.firstChange &&
            changes.docType.previousValue !== changes.docType.currentValue) {
            this.docTypeSubject.next(this.docType);
        }
    }
    // private initTitleContent(): void {
    //   this.titleHeading$ = this.printService.fbdsDocuments$.pipe(
    //     map((fbdsDocuments: FBDSPrintItem[]) => {
    //       let titleText: string = 'Freight Bill Delivery Set For';
    //       if (fbdsDocuments.length > 1) {
    //         titleText += ` ${fbdsDocuments.length} Selected Shipments`;
    //       }
    //       return titleText;
    //     })
    //   );
    //   this.titleContent$ = this.printService.fbdsDocuments$.pipe(
    //     map((fbdsDocuments: FBDSPrintItem[]) => {
    //       return fbdsDocuments
    //         .map((fbdsDocument: FBDSPrintItem) => this.conditioningService.conditionProNumber(fbdsDocument.proNbr, 10))
    //         .join(', ');
    //     })
    //   );
    // }
    addFormListeners() {
        const documentTypeControl = this.form.get(this.FBDSPrintFormFields.DocumentType);
        this.documentTypeSubject = documentTypeControl.valueChanges;
        this.documentTypeSubject
            .pipe(tap(() => {
            const isPrintingUsingSystemDialogCtrl = this.form.get(this.FBDSPrintFormFields.isPrintingUsingSystemDialog);
            isPrintingUsingSystemDialogCtrl.setValue(false);
            isPrintingUsingSystemDialogCtrl.updateValueAndValidity();
        }), takeUntil(this.unsubscriber.done$))
            .subscribe();
    }
    initData() {
        this.printService.showLoader();
        forkJoin([
            this.printService.loadFBDSUserPreferences$(),
            this.printService.loadFBDSDocumentData$(this.data.shipmentIds, DocumentFormTypeCd.FBDS),
        ]).subscribe({
            next: ([preferences, fbdsDocuments]) => {
                this.printService.hideLoader();
                const validFBDSPrintItems = fbdsDocuments === null || fbdsDocuments === void 0 ? void 0 : fbdsDocuments.filter((fbdsItem) => !fbdsItem.excludedInd);
                if (validFBDSPrintItems === null || validFBDSPrintItems === void 0 ? void 0 : validFBDSPrintItems.length) {
                    this.setFormDataFromUserPreferences(preferences);
                }
            },
            error: () => {
                this.printService.hideLoader();
                // this.componentStateSubject.next(PrintComponentState.Error);
            },
        });
    }
    initFBDSDocumentExcludedItemsWatcher() {
        this.fbdsExcludedItems$ = this.printService.fbdsDocuments$.pipe(map((fbdsItems) => {
            return fbdsItems.filter((fbdsItem) => {
                return !!fbdsItem.excludedInd;
            });
        }));
    }
    initReprintItemsWatchers() {
        this.fbdsReprintInfo$ = this.printService.fbdsDocuments$.pipe(map((fbdsDocumentData) => {
            const reprintedItems = fbdsDocumentData === null || fbdsDocumentData === void 0 ? void 0 : fbdsDocumentData.filter((item) => {
                return !!item['fbdsPrintCount'];
            });
            return reprintedItems;
        }), shareReplay(1));
        this.showReprintNotification$ = this.printService.shipmentDocumentsMap$.pipe(map((fbdsDocumentData) => {
            var _a;
            if (this.isSourceShipmentDetails) {
                const proKeys = Object.keys(fbdsDocumentData);
                const isReprintAvailable = (_a = fbdsDocumentData[proKeys[0]]) === null || _a === void 0 ? void 0 : _a.fbdsReprint;
                return this.isFBDSDocType && isReprintAvailable;
            }
        }));
        this.reprintMessage$ = this.printService.shipmentDocumentsMap$.pipe(map((fbdsDocumentData) => {
            if (this.isSourceShipmentDetails) {
                let message = '';
                const proKeys = Object.keys(fbdsDocumentData);
                const docInfo = fbdsDocumentData[proKeys[0]];
                if (docInfo === null || docInfo === void 0 ? void 0 : docInfo.fbdsReprint) {
                    message = 'This document will be reprinted.';
                }
                return message;
            }
        }));
        this.showExpandedReprintOptions$ = combineLatest([this.printService.fbdsDocuments$, this.fbdsReprintInfo$]).pipe(map(([_, reprintItems]) => {
            var _a;
            return ((_a = this.printService.getFBDSShipmentPros()) === null || _a === void 0 ? void 0 : _a.length) > 1 && (reprintItems === null || reprintItems === void 0 ? void 0 : reprintItems.length) > 0;
        }));
        this.showReprintedPros$ = combineLatest([
            this.showExpandedReprintOptions$,
            this.showReprintedProsSubject.asObservable(),
        ]).pipe(map(([showExpandedOptions, showReprintedPros]) => {
            return showExpandedOptions && showReprintedPros;
        }));
    }
    initFormGroup() {
        this.paperTypeCtrl = this.form.get(PrintFormFields.PaperType);
        this.serviceCenterCtrl = this.form.get(PrintFormFields.ServiceCenter);
        this.printerCtrl = this.form.get(PrintFormFields.Printer);
        this.trayCtrl = this.form.get(PrintFormFields.Tray);
        this.docTypeCtrl = this.form.get(PrintFormFields.DocumentType);
        this.isPrintingUsingSystemDialogCtrl = this.form.get(PrintFormFields.isPrintingUsingSystemDialog);
        this.LanguageCtrl = this.form.get(PrintFormFields.Language);
        if (this.isDockCopyType) {
            this.docTypeCtrl.setValue(FBDSDocumentType.DOCK_COPY);
            this.docTypeCtrl.updateValueAndValidity();
        }
        this.initFormWatchers();
        this.subscribeToServiceCenterUpdates();
        this.subscribeToPrinterUpdates();
        this.subscribeToPaperTypeUpdates();
        this.subscribeToDocumentTypeChanges();
        this.subscribePrinterChanges();
        this.form.updateValueAndValidity();
    }
    initFormWatchers() {
        var _a;
        this.serviceCenter$ = this.serviceCenterCtrl.valueChanges.pipe(startWith(this.serviceCenterCtrl.value), distinctUntilChanged());
        this.paperType$ = this.paperTypeCtrl.valueChanges;
        this.printer$ = this.printerCtrl.valueChanges.pipe(startWith(this.printerCtrl.value), distinctUntilChanged());
        this.tray$ = this.trayCtrl.valueChanges.pipe(startWith(this.trayCtrl.value), distinctUntilChanged());
        this.docType$ = (_a = this.docTypeCtrl) === null || _a === void 0 ? void 0 : _a.valueChanges;
        this.isPrintingUsingSystemDialog$ = this.isPrintingUsingSystemDialogCtrl.valueChanges;
        combineLatest([this.paperType$, this.docType$])
            .pipe(takeUntil(this.unsubscriber.done$), map(() => {
            return this.isFBDSPerforatedPrint();
        }))
            .subscribe((ans) => {
            this.isFBDSPerforatedPrintSubject.next(ans);
        });
        this.isTwoPartPaperSelected$ = combineLatest([this.paperType$, this.docType$]).pipe(map(() => {
            return this.isTwoPartPaperPrint();
        }));
        this.isFBDSDocType$ = this.docType$.pipe(map((docType) => {
            return this.isFBDSMode && docType === XpoLtlPrintDocType.FBDS;
        }));
        this.filteredServiceCenters$ = combineLatest([
            this.getServiceCenterAutocompleteItems$(),
            this.serviceCenter$.pipe(debounceTime(500), map((value) => typeof value === 'string' ? value : this.getServiceCenterAutocompleteItemDisplay(value))),
        ]).pipe(map(([serviceCenters, ctrlValue]) => {
            return this.filterServiceCenters(ctrlValue !== null && ctrlValue !== void 0 ? ctrlValue : '', serviceCenters);
        }), takeUntil(this.unsubscriber.done$));
        this.perforatedPrinterList$ = this.serviceCenter$.pipe(debounceTime(500), switchMap((sicCd) => {
            return sicCd && typeof sicCd === 'object' ? this.fetchPerforatedPrinters$(sicCd.sicCd) : of([]);
        }), shareReplay(1));
        this.filteredPrinters$ = combineLatest([
            this.printer$.pipe(debounceTime(150)),
            this.isFBDSPerforatedPaperSelected$,
            this.perforatedPrinterList$,
            of(Object.keys(this.legacyPrinterMap)),
        ]).pipe(distinctUntilChanged((a, b) => isEqual(a, b)), map(([printerValue, isPerforatedPaperSelected, perforatedPrinterList, legacyPrinterList]) => {
            const printerList = isPerforatedPaperSelected ? perforatedPrinterList : legacyPrinterList;
            return this.filterSimpleAutocomplete(printerValue, printerList);
        }), shareReplay(1));
        this.filteredTrays$ = combineLatest([this.printer$, this.tray$]).pipe(map(([printerValue, trayValue]) => {
            const trayList = this.printerTrayMap[printerValue];
            return trayList ? this.filterSimpleAutocomplete(trayValue, trayList) : [];
        }), shareReplay(1));
    }
    showShipmentStatusGrid() {
        this.printService.showShipmentStatusGrid$
            .pipe(takeUntil(this.unsubscriber.done$))
            .subscribe((toggle) => (this.showShipments = toggle));
    }
    subscribeToServiceCenterUpdates() {
        this.serviceCenter$.pipe(takeUntil(this.unsubscriber.done$)).subscribe(() => {
            this.printerCtrl.setValue('');
        });
    }
    subscribeToPrinterUpdates() {
        this.printer$.pipe(takeUntil(this.unsubscriber.done$)).subscribe(() => {
            this.trayCtrl.setValue('');
        });
    }
    subscribePrinterChanges() {
        this.printerCtrl.valueChanges.pipe(takeUntil(this.unsubscriber.done$)).subscribe((value) => {
            const placeHolder = value ? '' : this.printerPlaceHolder;
            this.printerPlaceHolderSubject.next(placeHolder);
        });
    }
    subscribeToDocumentTypeChanges() {
        this.docTypeCtrl.valueChanges.pipe(takeUntil(this.unsubscriber.done$)).subscribe((docType) => {
            const paperType = docType === XpoLtlPrintDocType.DockCopy ? PrintFBDSDocumentsTypeCd.DOT_MATRIX : PrintFBDSDocumentsTypeCd.LASER;
            this.paperTypeCtrl.setValue(paperType);
            this.printerCtrl.setValue('');
        });
        this.docTypeSubject.pipe(takeUntil(this.unsubscriber.done$)).subscribe((documentType) => {
            this.docTypeCtrl.setValue(documentType);
        });
    }
    subscribeToPaperTypeUpdates() {
        this.paperType$.pipe(takeUntil(this.unsubscriber.done$)).subscribe(() => {
            this.printerCtrl.setValue('');
        });
    }
    subscribeToPerforatedPrinterUpdates() {
        this.perforatedPrinterList$.pipe(takeUntil(this.unsubscriber.done$)).subscribe((printerList) => {
            const printerValue = this.printerCtrl.value;
            if ((printerList === null || printerList === void 0 ? void 0 : printerList.length) === 1 && !printerValue) {
                this.printerCtrl.setValue(printerList[0]);
            }
        });
    }
    getServiceCenterAutocompleteItems$() {
        return this.serviceCenterCacheService.serviceCenters$.pipe(map((serviceCenters) => {
            return serviceCenters.map((serviceCenter) => {
                return {
                    value: serviceCenter,
                    id: this.getServiceCenterAutocompleteItemDisplay(serviceCenter),
                };
            });
        }));
    }
    getServiceCenterAutocompleteItemDisplay(item) {
        var _a, _b, _c, _d;
        let sicDisplayValue = '';
        if (item) {
            if (typeof item === 'object') {
                const locationAddress = `- ${(_b = (_a = item.reference) === null || _a === void 0 ? void 0 : _a.sicName) !== null && _b !== void 0 ? _b : ''}, ${(_d = (_c = item.locAddress) === null || _c === void 0 ? void 0 : _c.countrySubdivisionCd) !== null && _d !== void 0 ? _d : ''}`;
                sicDisplayValue = `${item.sicCd} ${locationAddress}`.trim();
            }
            else {
                sicDisplayValue = item;
            }
        }
        return sicDisplayValue;
    }
    filterServiceCenters(value, serviceCenters) {
        const compareValue = typeof value === 'string' ? value : this.getServiceCenterAutocompleteItemDisplay(value);
        return serviceCenters === null || serviceCenters === void 0 ? void 0 : serviceCenters.filter((serviceCenterItem) => {
            var _a, _b;
            return (_b = (_a = serviceCenterItem.id) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(compareValue === null || compareValue === void 0 ? void 0 : compareValue.toLowerCase());
        }).sort((_, curr) => { var _a; return (((_a = curr.value.sicCd) === null || _a === void 0 ? void 0 : _a.includes(value)) ? 1 : -1); });
    }
    fetchPerforatedPrinters$(sicCd) {
        const request = {
            sicCds: [sicCd],
        };
        this.isLoadingPrinterListSubject.next(true);
        return this.infrastructureApiService.listPrinters(request, { loadingOverlayEnabled: false }).pipe(tap((resp) => {
            this.printerTrayMap = resp.printers.reduce((printerMap, printer) => {
                var _a, _b;
                printerMap[printer.name] =
                    (_b = (_a = printer.paperSources) === null || _a === void 0 ? void 0 : _a.filter((tray) => tray.toLowerCase().indexOf('tray') === 0)) !== null && _b !== void 0 ? _b : [];
                return printerMap;
            }, {});
        }), map((resp) => {
            return resp === null || resp === void 0 ? void 0 : resp.printers.map((printer) => printer.name);
        }), catchError((err) => {
            var _a, _b;
            const errorMessage = (_b = (_a = err === null || err === void 0 ? void 0 : err.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : `Unable to load printers for SIC: ${sicCd}`;
            this.xpoSnackBar.open({
                message: errorMessage,
                status: 'error',
                matConfig: {
                    verticalPosition: 'bottom',
                },
            });
            return of([]);
        }), finalize(() => {
            this.isLoadingPrinterListSubject.next(false);
        }));
    }
    onToggleShowReprintedProsClicked() {
        this.showReprintedProsSubject.next(!this.showReprintedProsSubject.value);
    }
    onRemoveReprintedPro(proNumber) {
        this.printService.removeFBDSDocumentForPro(proNumber);
    }
    isFBDSPerforatedPrint() {
        const paperType = this.paperTypeCtrl.value;
        return this.docType === XpoLtlPrintDocType.FBDS && paperType === PrintFBDSDocumentsTypeCd.LASER;
    }
    isTwoPartPaperPrint() {
        const paperType = this.paperTypeCtrl.value;
        return paperType === PrintFBDSDocumentsTypeCd.DOT_MATRIX;
    }
    onPrintLocalMachineClicked() {
        var _a;
        const selectedProKeys = Object.keys(this.printService.shipmentDocumentsMap);
        const shipmentIds = [];
        selectedProKeys.forEach((proNbr) => {
            const proDocument = this.printService.shipmentDocumentsMap[proNbr];
            const validPro = [proDocument].filter((document) => !document.isFBDSHidden);
            if (validPro.length > 0) {
                shipmentIds.push({ shipmentInstId: undefined, proNumber: proNbr, pickupDate: undefined });
            }
        });
        if (shipmentIds.length) {
            const printLanguage = (_a = this.LanguageCtrl) === null || _a === void 0 ? void 0 : _a.value;
            this.printService
                .printFBDSDocumentFromLocal$(shipmentIds, printLanguage)
                .pipe(map((response) => response))
                .subscribe({
                next: (response) => {
                    this.openPrintFrameInBrowser(response === null || response === void 0 ? void 0 : response.documentData);
                },
                error: (errorResp) => {
                    var _a;
                    const errorMessage = (_a = errorResp === null || errorResp === void 0 ? void 0 : errorResp.error) === null || _a === void 0 ? void 0 : _a.message;
                    this.xpoSnackBar.open({
                        message: errorMessage,
                        status: 'error',
                        matConfig: {
                            verticalPosition: 'bottom',
                        },
                    });
                },
                complete: () => {
                    this.dialogRef.close();
                },
            });
        }
        else {
            this.showInfoSnackBar();
        }
    }
    showInfoSnackBar() {
        const message = 'No documents available for printing';
        this.xpoSnackBar.open({
            message,
            status: 'info',
            matConfig: {
                verticalPosition: 'bottom',
            },
        });
        this.dialogRef.close();
    }
    openPrintFrameInBrowser(base64Array) {
        from(this.printService.mergePDFDocuments(base64Array)).subscribe((mergedPDF) => {
            const blob = new Blob([mergedPDF], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            printJS({
                printable: url,
                type: 'pdf',
            });
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    setFormDataFromUserPreferences(preferences) {
        combineLatest([
            this.serviceCenterCacheService.serviceCenters$.pipe(filter((s) => !!(s === null || s === void 0 ? void 0 : s.length))),
            this.printService.getLoggedInUser$(),
        ])
            .pipe(take(1))
            .subscribe(([serviceCenters, user]) => {
            var _a, _b;
            const userServiceCenterPreferenceExists = !!preferences[FBDSPreferenceKey.ServiceCenter];
            const preferredServiceCenterKey = (_b = (_a = preferences[FBDSPreferenceKey.ServiceCenter]) !== null && _a !== void 0 ? _a : this.data.sicCd) !== null && _b !== void 0 ? _b : user === null || user === void 0 ? void 0 : user.sicCode;
            const serviceCenter = serviceCenters === null || serviceCenters === void 0 ? void 0 : serviceCenters.find((sic) => {
                return sic.sicCd === preferredServiceCenterKey;
            });
            const isUniqueSicOverride = this.data.sicCd && this.data.sicCd !== preferences[FBDSPreferenceKey.ServiceCenter];
            const paperType = preferences[FBDSPreferenceKey.PaperType];
            const docType = preferences[FBDSPreferenceKey.DocumentType];
            const languageType = preferences[FBDSPreferenceKey.Language];
            if (docType && this.isSourceShipmentDetails) {
                this.docTypeCtrl.setValue(docType);
            }
            if (paperType && !this.isDockCopyType) {
                this.paperTypeCtrl.setValue(paperType);
            }
            if (languageType) {
                this.LanguageCtrl.setValue(languageType);
            }
            this.serviceCenterCtrl.setValue(serviceCenter);
            if (this.isFBDSPerforatedPrint()) {
                // only set printer/tray if sic is not being overridden and a service center has been found
                if (userServiceCenterPreferenceExists && serviceCenter) {
                    // wait until printer list has loaded and populated perforated printers before setting values
                    this.isLoadingPrinterList$
                        .pipe(debounceTime(200), filter((loading) => !loading), take(1))
                        .subscribe(() => {
                        this.printerCtrl.setValue(preferences[this.getPrinterKey()]);
                        this.trayCtrl.setValue(preferences[FBDSPreferenceKey.Tray]);
                    });
                }
            }
            else {
                this.printerCtrl.setValue(preferences[this.getPrinterKey()]);
            }
        });
    }
    getPrinterKey() {
        if (this.docTypeCtrl.value === XpoLtlPrintDocType.DockCopy) {
            return FBDSPreferenceKey.PrinterTwoPart;
        }
        return FBDSPreferenceKey.PrinterPerforated;
    }
    updateShipmentSelectedAttentionText() {
        this.updateShipmentAttentionText$ = this.printService.shipmentDocumentsNotAvailable$.pipe(takeUntil(this.unsubscriber.done$), tap((docsNotAvailable) => this.documentNotAvailableCountSubject.next(docsNotAvailable.length)), map((docsNotAvailable) => {
            const totalCount = docsNotAvailable.reduce((acc, curr) => {
                if (curr.reprintInd) {
                    acc.reprintCount++;
                }
                else if (curr.exclusionInd) {
                    acc.docUnavailable++;
                }
                return acc;
            }, { reprintCount: 0, docUnavailable: 0 });
            if (totalCount.reprintCount === 1 && totalCount.docUnavailable === 0) {
                return `${totalCount.reprintCount} document will be reprinted`;
            }
            else if (totalCount.docUnavailable === 1 && totalCount.reprintCount === 0) {
                return `${totalCount.docUnavailable} document is not available`;
            }
            else if (totalCount.reprintCount === 1 && totalCount.docUnavailable > 1) {
                return `${totalCount.reprintCount} document will be reprinted. ${totalCount.docUnavailable} are not available. `;
            }
            else if (totalCount.docUnavailable > 1 && totalCount.reprintCount === 0) {
                return `${totalCount.docUnavailable} documents are not available.`;
            }
            else if (totalCount.reprintCount > 1 && totalCount.docUnavailable === 0) {
                return `${totalCount.reprintCount} document will be reprinted.`;
            }
            else {
                return `${totalCount.reprintCount} documents will be reprinted. ${totalCount.docUnavailable} are not available.`;
            }
        }));
    }
}
FbdsPrintComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FbdsPrintComponent, deps: [{ token: i1$1.MatDialogRef }, { token: XpoLtlConditioningService }, { token: XpoLtlServiceCentersService }, { token: i4$6.InfrastructureApiService }, { token: i3$2.XpoSnackBar }, { token: PrintService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FbdsPrintComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FbdsPrintComponent, selector: "xpo-ltl-fbds-print", inputs: { isLocalPrintForm: "isLocalPrintForm", docType: "docType" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<ng-container\n  *ngIf=\"{\n    isFBDSPerforatedPaperSelected: isFBDSPerforatedPaperSelected$ | async,\n    isTwoPartPaperSelected: isTwoPartPaperSelected$ | async,\n    filteredServiceCenters: filteredServiceCenters$ | async,\n    filteredPrinters: filteredPrinters$ | async,\n    filteredTrays: filteredTrays$ | async,\n    isLoadingServiceCenters: isLoadingServiceCenters$ | async,\n    isLoadingPrinterList: isLoadingPrinterList$ | async,\n    showReprintNotification: showReprintNotification$ | async,\n    fbdsReprintInfo: fbdsReprintInfo$ | async,\n    fbdsExcludedItems: fbdsExcludedItems$ | async,\n    reprintMessage: reprintMessage$ | async,\n    showExpandedReprintOptions: showExpandedReprintOptions$ | async,\n    showReprintedPros: showReprintedPros$ | async,\n    isPrintingUsingSystemDialog: isPrintingUsingSystemDialog$ | async,\n    updateShipmentAttentionText: updateShipmentAttentionText$ | async,\n    documentNotAvailableCount: documentNotAvailableCount$ | async,\n    isSourceShipmentDetails: isSourceShipmentDetails,\n    docType: docType$ | async,\n    isLocalPrintForm: isLocalPrintForm$ | async,\n    docTypeSubject: docTypeSubject | async\n  } as state\"\n>\n  <ng-container *ngIf=\"form\">\n    <div class=\"FBDSPrint\" [formGroup]=\"form\">\n      <ng-container *ngIf=\"isSourceShipmentDetails\">\n        <div class=\"FBDSPrint__section\">\n          <h3 class=\"FBDSPrint__section--title\">Document Type</h3>\n          <div class=\"FBDSPrint__section--content\">\n            <mat-radio-group class=\"FBDSPrint__controls--radio\" [formControlName]=\"FBDSPrintFormFields.DocumentType\">\n              <mat-radio-button [value]=\"FBDSDocumentType.FBDS\">FBDS (Freight Bill Delivery Set)</mat-radio-button>\n              <mat-radio-button [value]=\"FBDSDocumentType.DOCK_COPY\">Dock Copy</mat-radio-button>\n            </mat-radio-group>\n          </div>\n        </div>\n      </ng-container>\n\n      <ng-container\n        *ngIf=\"state.docType !== XpoLtlPrintDocType.DockCopy && state.docTypeSubject !== XpoLtlPrintDocType.DockCopy\"\n      >\n        <div class=\"FBDSPrint__section\">\n          <h3 class=\"FBDSPrint__section--title\">Paper Type {{ state.isLocalPrintForm ? 'for FBDS' : '' }}</h3>\n          <mat-radio-group class=\"FBDSPrint__controls--radio\" [formControlName]=\"FBDSPrintFormFields.PaperType\">\n            <mat-radio-button [value]=\"PrintFBDSDocumentsTypeCd.LASER\">Perforated Paper</mat-radio-button>\n            <mat-radio-button [value]=\"PrintFBDSDocumentsTypeCd.DOT_MATRIX\">Two Part Paper</mat-radio-button>\n          </mat-radio-group>\n        </div>\n      </ng-container>\n\n      <div *ngIf=\"state.docType !== XpoLtlPrintDocType.DockCopy && state.isFBDSPerforatedPaperSelected\">\n        <h3>Language</h3>\n        <mat-radio-group class=\"FBDSPrint__controls--radio\" [formControlName]=\"FBDSPrintFormFields.Language\">\n          <mat-radio-button [value]=\"FbdsVersionCd.DEFAULT\">{{ LanguageType.ENGLISH_ONLY }}</mat-radio-button>\n          <mat-radio-button [value]=\"FbdsVersionCd.FRENCH\">{{ LanguageType.FRENCH_ONLY }}</mat-radio-button>\n          <mat-radio-button [value]=\"FbdsVersionCd.BILINGUAL\">{{ LanguageType.ENGLISH_FRENCH_BOTH }}</mat-radio-button>\n        </mat-radio-group>\n      </div>\n\n      <ng-container *ngIf=\"data.printSource === PrintSource.ShipmentGrid && state.documentNotAvailableCount\">\n        <div class=\"FBDSPrint__shipment-warning-count\" [ngClass]=\"{ 'single-form': state.isLocalPrintForm }\">\n          <div>\n            <xpo-status-indicator statusText=\"Attention\" statusColor=\"#FFD600\" [isLabel]=\"true\"></xpo-status-indicator>\n            {{ state.updateShipmentAttentionText }}\n          </div>\n        </div>\n      </ng-container>\n      <ng-container *ngIf=\"!state.isLocalPrintForm && state.documentNotAvailableCount\">\n        <xpo-ltl-documents-status-grid></xpo-ltl-documents-status-grid>\n      </ng-container>\n      <ng-container *ngIf=\"state.showReprintNotification && state.docType !== XpoLtlPrintDocType.DockCopy\">\n        <div class=\"FBDSPrint__section FBDSPrint__reprint\">\n          <div class=\"FBDSPrint__section--title FBDSPrint__reprint--title\">\n            <xpo-status-indicator\n              class=\"FBDSPrint__reprint--indicator\"\n              statusText=\"Attention\"\n              statusColor=\"#FFD600\"\n              [isLabel]=\"true\"\n            ></xpo-status-indicator>\n            <b class=\"FBDSPrint__reprint--labelText\">{{ state.reprintMessage }}</b>\n            <ng-container *ngIf=\"state.showExpandedReprintOptions\">\n              <button mat-button class=\"FBDSPrint__link--action\" (click)=\"onToggleShowReprintedProsClicked()\">\n                <span>{{ state.showReprintedPros ? 'Hide' : 'Show' }} Shipments</span>\n              </button>\n            </ng-container>\n          </div>\n          <ng-container *ngIf=\"state.showReprintedPros\">\n            <div class=\"FBDSPrint__section--content\">\n              <mat-chip-list>\n                <mat-chip\n                  *ngFor=\"let reprintedPro of state.fbdsReprintInfo\"\n                  [removable]=\"true\"\n                  (removed)=\"onRemoveReprintedPro(reprintedPro.proNbr)\"\n                  xpoTag\n                >\n                  {{ reprintedPro.proNbr }}\n                  <mat-icon matChipRemove>close</mat-icon>\n                </mat-chip>\n              </mat-chip-list>\n            </div>\n          </ng-container>\n        </div>\n      </ng-container>\n      <ng-container\n        *ngIf=\"state.isLocalPrintForm && state.docType !== XpoLtlPrintDocType.DockCopy && !state.isTwoPartPaperSelected\"\n      >\n        <div class=\"FBDSPrint__section\">\n          <div class=\"FBDSPrint__section--content\">\n            <mat-checkbox class=\"single-form\" formControlName=\"{{ FBDSPrintFormFields.isPrintingUsingSystemDialog }}\">\n              Print using System dialog\n            </mat-checkbox>\n          </div>\n        </div>\n      </ng-container>\n\n      <ng-container *ngIf=\"!state.isPrintingUsingSystemDialog\">\n        <ng-container *ngIf=\"state.isFBDSPerforatedPaperSelected && state.docType !== XpoLtlPrintDocType.DockCopy\">\n          <div class=\"FBDSPrint__section\">\n            <h3 class=\"FBDSPrint__section--title\"><span class=\"required\">*</span>Service Center</h3>\n            <div class=\"FBDSPrint__section--content\">\n              <mat-form-field\n                class=\"FBDSPrint__input--svcCenter ngx-FormField--inline\"\n                [ngClass]=\"{ 'single-form': state.isLocalPrintForm }\"\n                floatLabel=\"never\"\n              >\n                <input\n                  type=\"text\"\n                  matInput\n                  matAutocompleteTrigger\n                  xpoAutocomplete\n                  [formControlName]=\"FBDSPrintFormFields.ServiceCenter\"\n                  [matAutocomplete]=\"serviceCenterAutocomplete\"\n                  placeholder=\"Select Service Center\"\n                />\n                <span matSuffix class=\"FBDSPrint__input--suffix\">\n                  <xpo-busy-loader *ngIf=\"state.isLoadingServiceCenters\"></xpo-busy-loader>\n                  <mat-icon>arrow_drop_down</mat-icon>\n                </span>\n                <mat-autocomplete\n                  #serviceCenterAutocomplete\n                  autoActiveFirstOption=\"true\"\n                  [displayWith]=\"getServiceCenterAutocompleteItemDisplay\"\n                >\n                  <mat-option *ngIf=\"state.isLoadingServiceCenters\" [disabled]=\"true\">\n                    Loading...\n                  </mat-option>\n                  <mat-option *ngFor=\"let serviceCenter of state.filteredServiceCenters\" [value]=\"serviceCenter.value\">\n                    {{ serviceCenter.id }}\n                  </mat-option>\n                </mat-autocomplete>\n              </mat-form-field>\n            </div>\n          </div>\n        </ng-container>\n        <div class=\"FBDSPrint__section\">\n          <h3 class=\"FBDSPrint__section--title\">Printer<span class=\"required\">*</span></h3>\n\n          <div\n            class=\"FBDSPrint__section--content FBDSPrint__printerType\"\n            [ngClass]=\"{ 'single-form': state.isLocalPrintForm }\"\n          >\n            <mat-form-field\n              #printerControl\n              class=\"FBDSPrint__input--printer ngx-FormField--inline\"\n              [ngClass]=\"{ 'single-form': state.isLocalPrintForm }\"\n              floatLabel=\"never\"\n            >\n              <ng-container *ngIf=\"state.isTwoPartPaperSelected; else noMaxLength\">\n                <input\n                  type=\"text\"\n                  matInput\n                  matAutocompleteTrigger\n                  xpoAutocomplete\n                  [formControlName]=\"FBDSPrintFormFields.Printer\"\n                  [matAutocomplete]=\"printerAutoComplete\"\n                  [maxlength]=\"15\"\n                  placeholder=\"{{ printerPlaceHolderSubject | async }}\"\n                />\n              </ng-container>\n              <ng-template #noMaxLength>\n                <input\n                  type=\"text\"\n                  matInput\n                  matAutocompleteTrigger\n                  xpoAutocomplete\n                  [formControlName]=\"FBDSPrintFormFields.Printer\"\n                  [matAutocomplete]=\"printerAutoComplete\"\n                  placeholder=\"{{ printerPlaceHolderSubject | async }}\"\n                />\n              </ng-template>\n\n              <span matSuffix class=\"FBDSPrint__input--suffix\">\n                <xpo-busy-loader *ngIf=\"state.isLoadingPrinterList\"></xpo-busy-loader>\n                <mat-icon>arrow_drop_down</mat-icon>\n              </span>\n\n              <mat-autocomplete autoActiveFirstOption=\"true\" #printerAutoComplete>\n                <mat-option\n                  class=\"autocomplete-item\"\n                  *ngFor=\"let printer of state.filteredPrinters | slice: 0:50\"\n                  [value]=\"printer\"\n                >\n                  {{ printer }}\n                </mat-option>\n              </mat-autocomplete>\n              <mat-error *ngIf=\"printerCtrl?.hasError('required')\">Required</mat-error>\n            </mat-form-field>\n            <ng-container\n              *ngIf=\"\n                state.isFBDSPerforatedPaperSelected &&\n                !state.isLocalPrintForm &&\n                state.docType !== XpoLtlPrintDocType.DockCopy\n              \"\n            >\n              <div class=\"FBDSPrint__localPrint--container\">\n                <div>or</div>\n                <button\n                  mat-button\n                  class=\"FBDSPrint__link--action FBDSPrint__localPrint--button\"\n                  (click)=\"onPrintLocalMachineClicked()\"\n                >\n                  <mat-icon class=\"print-icon\">print</mat-icon>\n                  <span>Print using system dialog</span>\n                </button>\n              </div>\n            </ng-container>\n          </div>\n        </div>\n\n        <ng-container *ngIf=\"state.isFBDSPerforatedPaperSelected && state.docType !== XpoLtlPrintDocType.DockCopy\">\n          <div class=\"FBDSPrint__section\">\n            <h3 class=\"FBDSPrint__section--title\">Tray</h3>\n            <div class=\"FBDSPrint__section--content\">\n              <mat-form-field\n                class=\"FBDSPrint__input--autocomplete ngx-FormField--inline\"\n                [ngClass]=\"{ 'single-form': state.isLocalPrintForm }\"\n                floatLabel=\"never\"\n              >\n                <input\n                  type=\"text\"\n                  matInput\n                  matAutocompleteTrigger\n                  xpoAutocomplete\n                  [formControlName]=\"FBDSPrintFormFields.Tray\"\n                  [matAutocomplete]=\"trayAutoComplete\"\n                  placeholder=\"Select Tray\"\n                />\n                <mat-icon matSuffix>arrow_drop_down</mat-icon>\n                <mat-autocomplete autoActiveFirstOption=\"true\" #trayAutoComplete>\n                  <mat-option class=\"autocomplete-item\" *ngFor=\"let tray of state.filteredTrays\" [value]=\"tray\">\n                    {{ tray }}\n                  </mat-option>\n                </mat-autocomplete>\n              </mat-form-field>\n            </div>\n          </div>\n        </ng-container>\n      </ng-container>\n    </div>\n  </ng-container>\n</ng-container>\n", styles: [".flex--stretch{flex:1}.FBDSPrint__controls--radio{display:flex;flex-direction:column}.FBDSPrint__section{margin-top:16px}.FBDSPrint__section--title{color:#4a4a4a;font-weight:400;margin:0 0 8px}.FBDSPrint__section--title .required{color:#d32f2f;padding-left:2px}.FBDSPrint__shipment-warning-count{display:flex;justify-content:space-between;margin-bottom:24px}.FBDSPrint__shipment-warning-count.single-form{margin-top:16px}.FBDSPrint__input--autocomplete{width:50%}.FBDSPrint__input--autocomplete.single-form{width:300px}.FBDSPrint__input--svcCenter{width:100%}.FBDSPrint__input--svcCenter.single-form{width:300px}.FBDSPrint__input--printer{flex:1 1 auto;padding-right:16px}.FBDSPrint__input--printer.single-form{padding-right:0!important}.FBDSPrint__input--suffix{display:flex;align-items:center}.FBDSPrint__printerType{display:flex;justify-content:space-between;align-items:baseline}.FBDSPrint__printerType.single-form{width:300px}.FBDSPrint__localPrint--container{display:flex;align-items:baseline;justify-content:space-between}.FBDSPrint__localPrint--button{padding-left:8px!important}.FBDSPrint__disabledPanel{position:absolute;top:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.38);z-index:10}.FBDSPrint__reprint--title .FBDSPrintDialog__reprint--indicator span.xpo-StatusIndicator-tag{font-size:.875rem}.FBDSPrint__reprint--labelText{padding:0 8px}.FBDSPrint__link--action{color:#0868ac;font-size:.875rem;font-weight:400;margin:0 4px;padding-left:8px;text-transform:unset!important}.FBDSPrint__link--action:hover{color:#0d94f4;text-decoration:underline}.FBDSPrint__empty-state div.xpo-EmptyState{padding-top:16px}mat-checkbox.single-form{margin:0!important;padding:0!important}"], components: [{ type: i7$1.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { type: i2$7.XpoStatusIndicator, selector: "xpo-status-indicator", inputs: ["isLabel", "statusText", "statusColor"] }, { type: DocumentsStatusGridComponent, selector: "xpo-ltl-documents-status-grid" }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i11$2.MatChipList, selector: "mat-chip-list", inputs: ["aria-orientation", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "selectable", "tabIndex", "errorStateMatcher"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i13$1.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex", "aria-label", "aria-labelledby", "id", "labelPosition", "name", "required", "checked", "disabled", "indeterminate", "aria-describedby", "value"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }, { type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i7$2.XpoBusyLoader, selector: "xpo-busy-loader", inputs: ["slow"] }, { type: i13.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7$1.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i11$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { type: i20.XpoTag, selector: "[xpoTag]" }, { type: i11$2.MatChipRemove, selector: "[matChipRemove]" }, { type: i21.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i13.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i16.XpoAutocompleteInternalActiveNavigation, selector: "[xpoAutocomplete] , [xpo-autocomplete]", inputs: ["xpoOptionHeight", "xpoPanelHeight"] }, { type: i7.MatSuffix, selector: "[matSuffix]" }, { type: i2$2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i7.MatError, selector: "mat-error", inputs: ["id"] }], pipes: { "async": i5.AsyncPipe, "slice": i5.SlicePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FbdsPrintComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-fbds-print',
                    templateUrl: './fbds-print.component.html',
                    styleUrls: ['./fbds-print.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: XpoLtlConditioningService }, { type: XpoLtlServiceCentersService }, { type: i4$6.InfrastructureApiService }, { type: i3$2.XpoSnackBar }, { type: PrintService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { isLocalPrintForm: [{
                type: Input
            }], docType: [{
                type: Input
            }] } });

function isSomeChildSelected(children) {
    if (Array.isArray(children)) {
        const ans = children.some((child) => child.isSelected);
        return ans;
    }
    const answer = Object.keys(children).some((key) => children[key].isSelected);
    return answer;
}
function isAllChildsSelected(childs, parent) {
    let answer = false;
    if (Array.isArray(childs)) {
        answer = childs.some((child) => !child.isSelected);
    }
    else {
        answer = Object.keys(childs).some((key) => !childs[key].isSelected);
    }
    if (parent) {
        parent.isSelected = !answer;
    }
    return !answer;
}
function isAllNoChildSelected(childs) {
    if (Array.isArray(childs)) {
        const ans = childs.some((child) => child.isSelected);
        return !ans;
    }
    const answer = Object.keys(childs).some((key) => childs[key].isSelected);
    return !answer;
}
function setSelectChilds(childs, isSelected, element) {
    if (element) {
        element.isSelected = isSelected;
    }
    if (Array.isArray(childs)) {
        childs.forEach((child) => (child.isSelected = isSelected));
    }
    Object.keys(childs).forEach((key) => (childs[key].isSelected = isSelected));
}

class PrintShipmentComponent {
    constructor(xpoLtlDocTypePipe, proFormatterPipe) {
        this.xpoLtlDocTypePipe = xpoLtlDocTypePipe;
        this.proFormatterPipe = proFormatterPipe;
        this.modelChange = new EventEmitter();
        this.docTypes = [FBDSDocType.FBDS];
        this.documentsSubject = new BehaviorSubject(undefined);
        this.documents$ = this.documentsSubject.asObservable();
        this.proNbrsSubject = new BehaviorSubject(undefined);
        this.proNbrs$ = this.proNbrsSubject.asObservable();
        this.isCopyBillHiddenSubject = new BehaviorSubject(false);
        this.isCopyBillHidden$ = new BehaviorSubject(false);
        this.isFBDSHiddenSubject = new BehaviorSubject(false);
        this.isFBDSHidden$ = this.isFBDSHiddenSubject.asObservable();
        this.isCopyBillSelected = false;
        this.isFBDSSelected = false;
        this.showReprintedProsSubject = new BehaviorSubject(undefined);
        this.showReprintedPros$ = this.showReprintedProsSubject.asObservable();
        this.DocumentCategory = DocumentCategory;
        this.isSomeChildSelected = isSomeChildSelected;
        this.isAllChildsSelected = isAllChildsSelected;
        this.setSelectChilds = setSelectChilds;
        this.Object = Object;
        this.XpoLtlPrintDocType = XpoLtlPrintDocType;
        this.unsubscriber = new Unsubscriber();
        this.model = {
            isSomeDocumentToPrint: this.isCopyBillSelected || this.isFBDSSelected,
            isCopyBillRequiredToPrint: this.isCopyBillSelected,
            isFBDSRequiredToPrint: this.isFBDSSelected,
            isFBDSok: true,
            isPrintingUsingSystemDialog: false,
            documentsToPrint: [],
            proNbrs: [],
        };
    }
    ngOnInit() {
        var _a, _b;
        this.isOnlySingleDocumentSelected = ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.docTypes) === null || _b === void 0 ? void 0 : _b.length) === 1;
        this.isOnlyFBDSOrCopyBillSelected();
        this.fbdsFormGroup = this.formGroup.get(PrintFormFields.FBDS);
        this.loadPRONbrs();
        this.initTree();
        this.errorMessageForFBDS();
        this.errorMessageForCopyBill();
    }
    ngAfterViewInit() {
        this.formGroup
            .get(PrintFormFields.FBDS)
            .valueChanges.pipe(takeUntil(this.unsubscriber.done$))
            .subscribe(this.handleFBDSFormChange.bind(this));
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    errorMessageForFBDS() {
        this.fbdsErrorMessage$ = this.isFBDSHidden$.pipe(takeUntil(this.unsubscriber.done$), map((isFBDS) => {
            if (isFBDS) {
                let errorMessage;
                Object.keys(this.shipmentDocuments).forEach((pro) => {
                    const value = this.shipmentDocuments[pro];
                    errorMessage = value.fbdsExclusionReason;
                });
                return errorMessage;
            }
        }));
    }
    errorMessageForCopyBill() {
        this.copyBillMessage$ = this.isCopyBillHidden$.pipe(takeUntil(this.unsubscriber.done$), map((isCopyBill) => {
            if (isCopyBill) {
                let errorMessage;
                Object.keys(this.shipmentDocuments).forEach((pro) => {
                    const value = this.shipmentDocuments[pro];
                    errorMessage = value.copyBillExclusionReason;
                });
                return errorMessage;
            }
        }));
    }
    handleFBDSFormChange(data) {
        this.updateModel();
    }
    isOnlyFBDSOrCopyBillSelected() {
        if (this.isOnlySingleDocumentSelected) {
            this.isOnlyFBDSSelected = this.data.docTypes[0] === XpoLtlPrintDocType.FBDS;
        }
    }
    loadPRONbrs() {
        this.proNbrs = Object.keys(this.shipmentDocuments);
        const proNbrs = this.proNbrs.map((proNbr) => { var _a; return (_a = this.proFormatterPipe.transform(proNbr, 10)) !== null && _a !== void 0 ? _a : proNbr; }).join(',');
        this.proNbrsSubject.next(proNbrs);
    }
    initTree() {
        const mappedData = this.mapData(this.shipmentDocuments);
        this.documentsSubject.next(mappedData);
    }
    mapData(inputData) {
        const outputData = {};
        Object.keys(inputData)
            .map((key) => {
            this.isFBDSHiddenSubject.next(this.isFBDSHiddenSubject.value || inputData[key].isFBDSHidden);
            this.isCopyBillHidden$.next(this.isCopyBillHiddenSubject.value || inputData[key].isCopyBillHidden);
            return {
                documents: inputData[key].documents,
                shipmentInfo: inputData[key].shipmentInfo,
            };
        })
            .forEach((documents) => {
            const values = documents['documents'];
            values.forEach((doc) => {
                var _a, _b;
                const key = docTypeCatMap[(_b = (_a = doc.data) === null || _a === void 0 ? void 0 : _a.cdt) === null || _b === void 0 ? void 0 : _b.docClass];
                if (key) {
                    if (!outputData[key]) {
                        outputData[key] = { isSelected: false, documents: [] };
                    }
                    const docMapped = printDocToIPrintDocMapper(doc, this.xpoLtlDocTypePipe);
                    outputData[key].documents.push(docMapped);
                }
            });
        });
        return outputData;
    }
    getPrintModel() {
        const documentsToPrint = Object.values(this.documentsSubject.value).reduce((pre, cur) => [...pre, ...cur.documents.filter((doc) => doc.isSelected).map((doc) => doc)], []);
        const isCopyBillRequiredToPrint = this.isCopyBillSelected && !this.isCopyBillHidden$.value;
        const isFBDSRequiredToPrint = this.isFBDSSelected && !this.isFBDSHiddenSubject.value;
        const fbdsForm = this.formGroup.get(PrintFormFields.FBDS);
        const isPrintingUsingSystemDialog = fbdsForm.get(PrintFormFields.isPrintingUsingSystemDialog).value;
        const isPrinterSelected = !!fbdsForm.get(PrintFormFields.Printer).value;
        const isServiceCenterSelected = !!fbdsForm.get(PrintFormFields.ServiceCenter).value;
        const isDocumentTypeDockCopy = fbdsForm.get(PrintFormFields.DocumentType).value === XpoLtlPrintDocType.DockCopy;
        const isTwoPartPaperPrint = fbdsForm.get(PrintFormFields.PaperType).value === PrintFBDSDocumentsTypeCd.DOT_MATRIX;
        // const isTraySelected = !!fbdsForm.get(PrintFormFields.Tray).value;
        const isFBDSok = !isFBDSRequiredToPrint ||
            (isFBDSRequiredToPrint &&
                (isPrintingUsingSystemDialog ||
                    (isPrinterSelected && (isDocumentTypeDockCopy || isServiceCenterSelected || isTwoPartPaperPrint))));
        const model = {
            documentsToPrint,
            isCopyBillRequiredToPrint,
            isFBDSRequiredToPrint,
            isSomeDocumentToPrint: isCopyBillRequiredToPrint || isFBDSRequiredToPrint || !!documentsToPrint.length,
            isFBDSok,
            isPrintingUsingSystemDialog,
            proNbrs: this.proNbrs,
        };
        return model;
    }
    updateModel() {
        const model = this.getPrintModel();
        this.model = model;
        // this.modelDispatcher && this.modelDispatcher.next(this.model);
        this.modelChange.emit(this.model);
    }
    isAllCatsSelected() {
        const isAllChildsSelected_ = isAllChildsSelected(this.documentsSubject.value);
        const answer = this.isCopyBillSelected && this.isFBDSSelected && isAllChildsSelected_;
        return answer;
    }
    isSomeCatsSelected() {
        const answer = this.isCopyBillSelected || this.isFBDSSelected || isSomeChildSelected(this.documentsSubject.value);
        return answer;
    }
    selectAll(isSelected) {
        this.isCopyBillSelected = isSelected;
        this.isFBDSSelected = isSelected;
        Object.values(this.documentsSubject.value).forEach((docCategory) => {
            setSelectChilds(docCategory.documents, isSelected, docCategory);
            docCategory.isSelected = true;
        });
    }
    onSelection(isSelected, element) {
        element.isSelected = isSelected;
    }
    setFlag(isSelected, flagName) {
        this[flagName] = isSelected;
    }
    reportChange() {
        of(null)
            .pipe(takeUntil(this.unsubscriber.done$), delay(50))
            .subscribe(() => this.updateModel());
    }
}
PrintShipmentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintShipmentComponent, deps: [{ token: XpoLtlDocTypePipe }, { token: ProFormatterPipe }], target: i0.ɵɵFactoryTarget.Component });
PrintShipmentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: PrintShipmentComponent, selector: "xpo-ltl-print-shipment", inputs: { formGroup: "formGroup", data: "data", shipmentDocuments: "shipmentDocuments", modelDispatcher: "modelDispatcher" }, outputs: { modelChange: "modelChange" }, ngImport: i0, template: "<div class=\"print-dialog-container\">\n  <div class=\"title-label\">For {{ proNbrs$ | async }}</div>\n  <ng-container *ngIf=\"isOnlySingleDocumentSelected; else printAllDocuments\">\n    <ng-container *ngIf=\"isOnlyFBDSSelected; else onlyCopyBillSelected\">\n      <ng-container *ngIf=\"isFBDSHidden$ | async; else showFbdsTemplate\">\n        <xpo-empty-state class=\"Print__empty-state\">\n          <xpo-empty-state-icon>\n            <mat-icon>insert_drive_file</mat-icon>\n          </xpo-empty-state-icon>\n          <xpo-empty-state-header>No documents found.</xpo-empty-state-header>\n          <xpo-empty-state-description>{{ fbdsErrorMessage$ | async }}</xpo-empty-state-description>\n        </xpo-empty-state>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n</div>\n\n<ng-template #showFbdsTemplate>\n  <xpo-ltl-fbds-print [docType]=\"data.docTypes[0]\" [form]=\"fbdsFormGroup\" [data]=\"data\"></xpo-ltl-fbds-print>\n</ng-template>\n\n<ng-template #onlyCopyBillSelected>\n  <ng-container *ngIf=\"!isOnlyFBDSSelected\">\n    <ng-container *ngIf=\"isCopyBillHidden$ | async; else showCopyBillSelected\">\n      <xpo-empty-state class=\"Print__empty-state\">\n        <xpo-empty-state-icon>\n          <mat-icon>insert_drive_file</mat-icon>\n        </xpo-empty-state-icon>\n        <xpo-empty-state-header>No documents found.</xpo-empty-state-header>\n        <xpo-empty-state-description>{{copyBillMessage$ | async}}</xpo-empty-state-description>\n      </xpo-empty-state>\n    </ng-container>\n  </ng-container>\n</ng-template>\n\n<ng-template #showCopyBillSelected></ng-template>\n\n<ng-template #printAllDocuments>\n  <div *ngIf=\"documents$ | async as docs\">\n    <ng-container *ngIf=\"!(isCopyBillHidden$ | async) || !(isFBDSHidden$ | async); else noAvailableDocuments\">\n      <div>\n        <mat-checkbox\n          [checked]=\"isAllCatsSelected()\"\n          [indeterminate]=\"!isAllCatsSelected() && isSomeCatsSelected()\"\n          (change)=\"selectAll($event.checked)\"\n          (click)=\"reportChange()\"\n        >\n          <span class=\"select-all-label\">Select All</span>\n        </mat-checkbox>\n      </div>\n    </ng-container>\n\n    <div class=\"form-container\">\n      <ng-container *ngFor=\"let documentCat of Object.keys(docs)\">\n        <ng-container\n          *ngTemplateOutlet=\"\n            section;\n            context: {\n              count: docs[documentCat].documents.length,\n              documentCat: documentCat,\n              documents: docs[documentCat].documents,\n              element: docs[documentCat]\n            }\n          \"\n        ></ng-container>\n      </ng-container>\n      <!-- Copy Bill -->\n      <ng-container *ngIf=\"!(isCopyBillHidden$ | async)\">\n        <ng-container\n          *ngTemplateOutlet=\"\n            section;\n            context: {\n              flagName: 'isCopyBillSelected',\n              flag: isCopyBillSelected,\n              documentCat: DocumentCategory.CopyBill\n            }\n          \"\n        ></ng-container>\n      </ng-container>\n      <!-- FBDS -->\n      <ng-container *ngIf=\"!(isFBDSHidden$ | async)\">\n        <ng-container\n          *ngTemplateOutlet=\"\n            section;\n            context: {\n              flagName: 'isFBDSSelected',\n              flag: isFBDSSelected,\n              documentCat: DocumentCategory.FBDS,\n              template: fbdsForm\n            }\n          \"\n        ></ng-container>\n      </ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<!-- FBDS Form -->\n<ng-template #fbdsForm>\n  <xpo-ltl-fbds-print\n    [docType]=\"XpoLtlPrintDocType.FBDS\"\n    [form]=\"fbdsFormGroup\"\n    [data]=\"data\"\n    [isLocalPrintForm]=\"true\"\n  ></xpo-ltl-fbds-print>\n</ng-template>\n\n<!-- Section template -->\n<ng-template\n  #section\n  let-documentCat=\"documentCat\"\n  let-count=\"count\"\n  let-documents=\"documents\"\n  let-template=\"template\"\n  let-flag=\"flag\"\n  let-flagName=\"flagName\"\n  let-element=\"element\"\n>\n  <mat-expansion-panel [expanded]=\"flag && template\">\n    <mat-expansion-panel-header [ngClass]=\"template || count ? '' : 'no-pointer-events title-remove-icon'\">\n      <mat-panel-title>\n        <ng-container *ngIf=\"flagName; else noFlag\">\n          <mat-checkbox\n            class=\"all-pointer-events\"\n            [checked]=\"flag\"\n            (change)=\"setFlag($event.checked, flagName)\"\n            (click)=\"reportChange(); $event.stopPropagation()\"\n          ></mat-checkbox>\n        </ng-container>\n        <ng-template #noFlag>\n          <mat-checkbox\n            [checked]=\"isAllChildsSelected(documents, element)\"\n            [indeterminate]=\"!isAllChildsSelected(documents) && isSomeChildSelected(documents)\"\n            (change)=\"setSelectChilds(documents, $event.checked, element)\"\n            (click)=\"reportChange(); $event.stopPropagation()\"\n          ></mat-checkbox>\n        </ng-template>\n        {{ documentCat }}\n      </mat-panel-title>\n      <mat-chip-list *ngIf=\"count\">\n        <mat-chip xpoBadgeChip color=\"accent\" selected>{{ count }}</mat-chip>\n      </mat-chip-list>\n    </mat-expansion-panel-header>\n    <ng-container *ngIf=\"template || documents\">\n      <ng-container *ngIf=\"documents; else template\">\n        <div class=\"chkbx-grid\">\n          <ng-container *ngFor=\"let document of documents\">\n            <mat-checkbox\n              (change)=\"onSelection($event.checked, document)\"\n              (click)=\"reportChange()\"\n              [checked]=\"document.isSelected\"\n            >\n              <div class=\"chkbx-label\">\n                <div class=\"chkbx-doc-type\">{{ document.docClassLabel }}</div>\n                <div class=\"chkbx-time\">{{ document.tiemstampLabel }}</div>\n              </div>\n            </mat-checkbox>\n          </ng-container>\n        </div>\n      </ng-container>\n    </ng-container>\n  </mat-expansion-panel>\n</ng-template>\n\n<ng-template #noAvailableDocuments>\n  <div class=\"no-documents-message\">\n    <div class=\"message-container\">\n      No documents available\n    </div>\n  </div>\n</ng-template>\n", styles: [".flex--stretch{flex:1}.print-dialog-container{display:flex;flex-direction:column}.print-dialog-header{margin-top:8px;display:grid;grid-template-columns:1fr auto;font-family:Roboto;font-style:normal;font-weight:500;font-size:28px}.print-dialog-spacer{flex-grow:1}.chkbx-grid{margin-left:10px;display:grid;grid-template-columns:repeat(auto-fit,minmax(130px,1fr))}.chkbx-doc-type{font-weight:700;font-size:14px;white-space:break-spaces}.chkbx-label{padding-left:12px}.title-label{color:#4a4a4a;margin-bottom:24px}.close-icon{cursor:pointer}.select-all-label{font-family:Roboto;font-style:normal;font-weight:700;font-size:14px;padding-left:12px}.loading-container{display:flex;align-items:center}.no-pointer-events{pointer-events:none}::ng-deep .mat-expansion-panel mat-expansion-panel-header.title-remove-icon .mat-content:before{content:\"remove\"!important}::ng-deep span.mat-expansion-indicator{display:none!important}.all-pointer-events{pointer-events:all}.no-documents-message{font-size:18px;min-height:85px;vertical-align:middle;display:flex;align-items:center}.no-documents-message .message-container{flex-grow:1;text-align:center}"], components: [{ type: i3$3.XpoEmptyState, selector: "xpo-empty-state" }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: FbdsPrintComponent, selector: "xpo-ltl-fbds-print", inputs: ["isLocalPrintForm", "docType"] }, { type: i13$1.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex", "aria-label", "aria-labelledby", "id", "labelPosition", "name", "required", "checked", "disabled", "indeterminate", "aria-describedby", "value"], outputs: ["change", "indeterminateChange"], exportAs: ["matCheckbox"] }, { type: i7$3.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { type: i7$3.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { type: i11$2.MatChipList, selector: "mat-chip-list", inputs: ["aria-orientation", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "selectable", "tabIndex", "errorStateMatcher"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3$3.XpoEmptyStateIcon, selector: "xpo-empty-state-icon" }, { type: i3$3.XpoEmptyStateHeader, selector: "xpo-empty-state-header" }, { type: i3$3.XpoEmptyStateDescription, selector: "xpo-empty-state-description" }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i7$3.MatExpansionPanelTitle, selector: "mat-panel-title" }, { type: i11$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { type: i20.XpoBadgeChip, selector: "[xpo-badge-chip], [xpoBadgeChip] " }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintShipmentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-print-shipment',
                    templateUrl: './print-shipment.component.html',
                    styleUrls: ['./print-shipment.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlDocTypePipe }, { type: ProFormatterPipe }]; }, propDecorators: { formGroup: [{
                type: Input
            }], data: [{
                type: Input
            }], shipmentDocuments: [{
                type: Input
            }], modelDispatcher: [{
                type: Input
            }], modelChange: [{
                type: Output
            }] } });

class DockCopyPrintComponent {
    constructor(printService) {
        this.printService = printService;
    }
    ngOnInit() {
    }
}
DockCopyPrintComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DockCopyPrintComponent, deps: [{ token: PrintService }], target: i0.ɵɵFactoryTarget.Component });
DockCopyPrintComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: DockCopyPrintComponent, selector: "xpo-ltl-dock-copy-print", ngImport: i0, template: "", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DockCopyPrintComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-dock-copy-print',
                    templateUrl: './dock-copy-print.component.html',
                    styleUrls: ['./dock-copy-print.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: PrintService }]; } });

class PrintDocTypePipe extends XpoLtlDocTypePipe {
    transform(value, args) {
        let convertedValue = super.transform(value, args);
        switch (value) {
            case XpoLtlPrintDocType.BillOfLadingAttachment:
                convertedValue = 'B/L Attachment';
                break;
            case XpoLtlPrintDocType.DeliveryReceiptAttachment:
                convertedValue = 'D/R Attachment';
                break;
            case XpoLtlPrintDocType.FBDS:
                convertedValue = 'FBDS (Freight Bill Delivery Set)';
                break;
            case XpoLtlPrintDocType.DockCopy:
                convertedValue = 'Dock Copy';
                break;
            case XpoLtlPrintDocType.CopyBill:
                convertedValue = 'Copy Bill';
                break;
        }
        return convertedValue || value;
    }
    transformBack(value, args) {
        let convertedValue;
        switch (value) {
            case 'Bill of Lading':
                convertedValue = XpoLtlDocType.BillOfLading;
                break;
            case 'Delivery Receipt':
                convertedValue = XpoLtlDocType.DeliveryReceipt;
                break;
            case 'Delivery Return Receipt':
                convertedValue = XpoLtlDocType.DeliveryReturnReceipt;
                break;
            case 'Customs Document':
                convertedValue = XpoLtlDocType.CustomsDocuments;
                break;
            case 'Customer Upload':
                convertedValue = XpoLtlDocType.CustomerUpload;
                break;
            case 'Inspection Report':
                convertedValue = XpoLtlDocType.InspectionReport;
                break;
            case 'Letter of Authority':
                convertedValue = XpoLtlDocType.LetterOfAuthority;
                break;
            case 'NMFC Class Inspection Certificate':
                convertedValue = XpoLtlDocType.NmfcClassInspectionCertificate;
                break;
            case 'Weight Inspection Certificate':
                convertedValue = XpoLtlDocType.WeightInspectionCertificate;
                break;
            case 'Weight and Research Photos':
                convertedValue = XpoLtlDocType.WeightAndResearchPhotos;
                break;
            case 'In-Motion Dimensioner Photo':
                convertedValue = XpoLtlDocType.InMotionDimensionerPhoto;
                break;
            case 'Mobile Dimensioner Photo':
                convertedValue = XpoLtlDocType.MobileDimensionerPhoto;
                break;
            case 'Invoice':
                convertedValue = XpoLtlDocType.InvoicePdf;
                break;
            case 'Claims Attachment':
                convertedValue = XpoLtlDocType.ClaimsAttachment;
                break;
            case 'DR Attachment':
                convertedValue = XpoLtlDocType.DeliveryReceiptAttachment;
                break;
            case 'BL Attachment':
                convertedValue = XpoLtlDocType.BillOfLadingAttachment;
                break;
            case 'OS&D Photo':
                convertedValue = XpoLtlDocType.OSDPhoto;
                break;
            case 'All Documents':
                convertedValue = XpoLtlDocType.All;
                break;
        }
        return convertedValue;
    }
}
PrintDocTypePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintDocTypePipe, deps: null, target: i0.ɵɵFactoryTarget.Pipe });
PrintDocTypePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintDocTypePipe, name: "printDocType" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintDocTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'printDocType',
                }]
        }] });

class PrintShipmentsComponent {
    constructor(printService) {
        this.printService = printService;
        this.PrintFormFields = PrintFormFields;
        this.unsubscriber = new Unsubscriber();
        this.docTypeSubject = new BehaviorSubject(undefined);
        this.docType$ = this.docTypeSubject.asObservable();
        this.showShipments = false;
    }
    ngOnInit() {
        this.initControls();
        this.initWatchers();
        this.showShipmentStatusGrid();
        this.updateShipmentSelectedCount();
        this.updateShipmentSelectedAttentionCount();
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    // ngAfterViewInit(): void {
    //   this.validateData();
    // }
    initControls() {
        this.fbdsFormGroup = this.formGroup.get(PrintFormFields.FBDS);
        this.docTypeCtrl = this.formGroup.get(PrintFormFields.SelectedDocuments);
    }
    initWatchers() {
        this.docTypeCtrl.valueChanges
            .pipe(takeUntil(this.unsubscriber.done$), startWith(this.docTypeCtrl.value), map((docType) => {
            return docType === null || docType === void 0 ? void 0 : docType[0];
        }))
            .subscribe((value) => {
            this.printService.showUnmappedShipmentDocuments(value);
            this.docTypeSubject.next(value);
        });
        this.showFBDS$ = this.docTypeCtrl.valueChanges.pipe(takeUntil(this.unsubscriber.done$), map((selectedDocType) => {
            return selectedDocType[0] === XpoLtlPrintDocType.FBDS || selectedDocType[0] === XpoLtlPrintDocType.DockCopy;
        }));
    }
    compareSelectedDocuments(doc1, doc2) {
        return (doc1 === null || doc1 === void 0 ? void 0 : doc1[0]) === (doc2 === null || doc2 === void 0 ? void 0 : doc2[0]);
    }
    // validateData(): void {
    //   if (this.docTypes.length === 1) {
    //     this.docTypeCtrl.setValue([this.docTypes[0]]);
    //     this.docTypeCtrl.updateValueAndValidity();
    //   }
    // }
    onSelectionChange(event) {
        this.printService.showShipmentStatusGridSubject.next(false);
    }
    showShipmentStatusGrid() {
        this.printService.showShipmentStatusGrid$
            .pipe(takeUntil(this.unsubscriber.done$))
            .subscribe((toggle) => (this.showShipments = toggle));
    }
    updateShipmentSelectedCount() {
        this.printService.shipmentDocumentsMap$
            .pipe(takeUntil(this.unsubscriber.done$))
            .subscribe((docs) => (this.updateShipmentCount = Object.keys(docs).length));
    }
    updateShipmentSelectedAttentionCount() {
        this.printService.shipmentDocumentsNotAvailable$
            .pipe(takeUntil(this.unsubscriber.done$))
            .subscribe((shipmentCount) => {
            this.updateShipmentAttentionCount = shipmentCount.length;
        });
    }
}
PrintShipmentsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintShipmentsComponent, deps: [{ token: PrintService }], target: i0.ɵɵFactoryTarget.Component });
PrintShipmentsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: PrintShipmentsComponent, selector: "xpo-ltl-print-shipments", inputs: { docTypes: "docTypes", formGroup: "formGroup", data: "data" }, ngImport: i0, template: "<div class=\"PrintShipments\" [formGroup]=\"formGroup\">\n  <div class=\"PrintShipments__form\">\n    <ng-container>\n      <div class=\"PrintShipments__selected-count-info\">\n        {{ updateShipmentCount }} {{ updateShipmentCount > 1 ? 'shipments' : 'shipment' }} selected.\n      </div>\n      <div *ngIf=\"data?.shipmentIds?.length === 50\">\n        <xpo-status-indicator statusText=\"INFO\" [isLabel]=\"true\" statusColor=\"blue\"></xpo-status-indicator>\n        Printing is limited to 50 Shipments at one time.\n      </div>\n\n      <div class=\"PrintShipments__document-type\">\n        <mat-form-field floatLabel=\"always\">\n          <mat-label>Document Type</mat-label>\n          <mat-select\n            placeholder=\"Select document type\"\n            xpoSelect\n            [compareWith]=\"compareSelectedDocuments\"\n            [formControlName]=\"PrintFormFields.SelectedDocuments\"\n            (selectionChange)=\"onSelectionChange($event)\"\n          >\n            <mat-option *ngFor=\"let docTypeOption of docTypes\" [value]=\"[docTypeOption]\">\n              {{ docTypeOption | printDocType }}\n            </mat-option>\n          </mat-select>\n          <mat-error *ngIf=\"docTypeCtrl.errors?.minLength\">Please select a document</mat-error>\n        </mat-form-field>\n      </div>\n    </ng-container>\n  </div>\n\n  <ng-container *ngIf=\"!(showFBDS$ | async) && (docType$ | async) && updateShipmentAttentionCount > 0\">\n    <div class=\"PrintShipments__shipment-warning-count\">\n      <div>\n        <xpo-status-indicator statusText=\"Attention\" statusColor=\"#FFD600\" [isLabel]=\"true\"></xpo-status-indicator>\n        {{ updateShipmentAttentionCount }}\n        documents are not available.\n      </div>\n    </div>\n\n    <div>\n      <xpo-ltl-documents-status-grid></xpo-ltl-documents-status-grid>\n      <xpo-ltl-dock-copy-print></xpo-ltl-dock-copy-print>\n    </div>\n  </ng-container>\n\n  <ng-container *ngIf=\"showFBDS$ | async\">\n    <div class=\"PrintShipments__FBDS\">\n      <xpo-ltl-fbds-print\n        [isLocalPrintForm]=\"docTypes.length === 1\"\n        [form]=\"fbdsFormGroup\"\n        [data]=\"data\"\n        [docType]=\"docType$ | async\"\n      >\n      </xpo-ltl-fbds-print>\n    </div>\n  </ng-container>\n</div>\n", styles: [".PrintShipments__selected-count-info{padding-top:10px}.PrintShipments__document-type{padding-top:25px}.PrintShipments__shipment-warning-count{display:flex;justify-content:space-between;margin-bottom:24px}"], components: [{ type: i2$7.XpoStatusIndicator, selector: "xpo-status-indicator", inputs: ["isLabel", "statusText", "statusColor"] }, { type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i4$4.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: DocumentsStatusGridComponent, selector: "xpo-ltl-documents-status-grid" }, { type: DockCopyPrintComponent, selector: "xpo-ltl-dock-copy-print" }, { type: FbdsPrintComponent, selector: "xpo-ltl-fbds-print", inputs: ["isLocalPrintForm", "docType"] }], directives: [{ type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.MatLabel, selector: "mat-label" }, { type: i16.XpoDisableOptionCenteringDirective, selector: "mat-select" }, { type: i16.XpoSelectDirective, selector: "[xpo-select], [xpoSelect]" }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i7.MatError, selector: "mat-error", inputs: ["id"] }], pipes: { "printDocType": PrintDocTypePipe, "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintShipmentsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-print-shipments',
                    templateUrl: './print-shipments.component.html',
                    styleUrls: ['./print-shipments.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: PrintService }]; }, propDecorators: { docTypes: [{
                type: Input
            }], formGroup: [{
                type: Input
            }], data: [{
                type: Input
            }] } });

function XpoLtlDynamicValidator(shouldExecuteValidator, validatorFn) {
    return (control) => {
        return shouldExecuteValidator() ? validatorFn(control) : undefined;
    };
}

class FBDSPrintUtils {
    static getShipmentIdsFromProNbrs(proNbrs) {
        const shipmentIds = proNbrs === null || proNbrs === void 0 ? void 0 : proNbrs.reduce((shipmentIdAccumulator, proNbr) => {
            const shipmentId = { shipmentInstId: undefined, proNumber: proNbr, pickupDate: undefined };
            shipmentIdAccumulator.push(shipmentId);
            return shipmentIdAccumulator;
        }, []);
        return shipmentIds;
    }
}

class XpoLtlPrintComponent {
    constructor(printService, formBuilder, xpoSnackBar, conditioningService, shipmentApi, dialogRef) {
        this.printService = printService;
        this.formBuilder = formBuilder;
        this.xpoSnackBar = xpoSnackBar;
        this.conditioningService = conditioningService;
        this.shipmentApi = shipmentApi;
        this.dialogRef = dialogRef;
        this.close = new EventEmitter();
        this.PrintComponentState = PrintComponentState;
        this.unsubscriber = new Unsubscriber();
        this.componentStateSubject = new BehaviorSubject(PrintComponentState.InitData);
        this.componentState$ = this.componentStateSubject.asObservable();
        this.singlePrintStateSubject = new BehaviorSubject(undefined);
        this.singlePrintState$ = this.singlePrintStateSubject.asObservable();
        this.isOnlyCopyBill = false;
        this.isOnlyFBDS = false;
        this.docList = [];
        this.defaultSingleProDocList = [
            XpoLtlPrintDocType.FBDS,
            XpoLtlPrintDocType.DockCopy,
            XpoLtlPrintDocType.CopyBill,
            XpoLtlPrintDocType.BillOfLading,
            XpoLtlPrintDocType.BillOfLadingAttachment,
            XpoLtlPrintDocType.DeliveryReceipt,
            XpoLtlPrintDocType.DeliveryReceiptAttachment,
            XpoLtlPrintDocType.LetterOfAuthority,
            XpoLtlPrintDocType.CustomsDocuments,
            XpoLtlPrintDocType.NmfcClassInspectionCertificate,
            XpoLtlPrintDocType.WeightInspectionCertificate,
            XpoLtlPrintDocType.InspectionReport,
        ];
        this.defaultMultiProDocList = [
            XpoLtlPrintDocType.ShipmentGridInfo,
            XpoLtlPrintDocType.BillOfLading,
            XpoLtlPrintDocType.DeliveryReceipt,
            XpoLtlPrintDocType.FBDS,
            XpoLtlPrintDocType.CopyBill,
            XpoLtlPrintDocType.DockCopy,
        ];
        this.requireFormToPtintMap = {
            [XpoLtlPrintDocType.DockCopy]: true,
            [XpoLtlPrintDocType.FBDS]: true,
        };
    }
    ngOnInit() {
        this.initVariables();
        this.initForm();
        this.loadData();
        this.setPrintButtonListeners();
    }
    initVariables() {
        var _a;
        this.isSourceShipmentGrid = this.data.printSource === PrintSource.ShipmentGrid;
        if (((_a = this.data.docTypes) === null || _a === void 0 ? void 0 : _a.length) === 1) {
            this.isOnlyCopyBill = this.data.docTypes[0] === FBDSDocType.CopyBill;
            this.isOnlyFBDS = this.data.docTypes[0] === FBDSDocType.FBDS;
        }
        this.printService.selectedShipments = this.data; // setting the selected shipment data to access everywhere.
        this.docList = this.getDocTypesList();
        this.shipmentDocuments$ = this.printService.shipmentDocumentsMap$;
    }
    loadData() {
        forkJoin([
            this.printService.loadFBDSUserPreferences$(),
            this.printService.loadDocumentsForShipments$(this.data.shipmentIds, this.docList),
        ])
            .pipe(take(1), takeUntil(this.unsubscriber.done$))
            .subscribe((docs) => {
            if (Object.keys(docs).length) {
                this.componentStateSubject.next(PrintComponentState.ShowPrint);
            }
            else {
                this.componentStateSubject.next(PrintComponentState.Error);
            }
        });
        this.isLoading$ = combineLatest([this.printService.isLoading$, this.componentState$]).pipe(takeUntil(this.unsubscriber.done$), map(([loading, componentState]) => {
            return loading || componentState === PrintComponentState.InitData;
        }));
    }
    setPrintButtonListeners() {
        this.canPrint$ = combineLatest([
            this.formGroup.statusChanges.pipe(startWith(this.formGroup.status)),
            this.isLoading$,
            this.componentState$,
            this.singlePrintState$,
            this.printService.shipmentDocumentsNotAvailable$.pipe(map((docs) => docs.filter((doc) => doc.exclusionInd))),
            this.printService.shipmentDocumentsMap$,
        ]).pipe(takeUntil(this.unsubscriber.done$), map(([status, isLoading, componentState, printSingle, notAvailableDocuments, totalShipmentsSelected]) => {
            if (isLoading) {
                return false;
            }
            let isSomeDocumentToPrint = false;
            const fbdsForm = this.formGroup.get(PrintFormFields.FBDS);
            const isPrinterSelected = !!fbdsForm.get(PrintFormFields.Printer).value;
            const isServiceCenterSelected = !!fbdsForm.get(PrintFormFields.ServiceCenter).value;
            const selectedDocuments = this.formGroup.get(PrintFormFields.SelectedDocuments).value;
            const paperType = fbdsForm.get(PrintFormFields.PaperType).value;
            const isTwoPartPaperPrint = paperType === PrintFBDSDocumentsTypeCd.DOT_MATRIX;
            const isDockCopy = fbdsForm.get(PrintFormFields.DocumentType).value === XpoLtlPrintDocType.DockCopy;
            const notAvailableDocCount = notAvailableDocuments ? notAvailableDocuments.length : 0;
            const totalShipmentsDocCount = Object.keys(totalShipmentsSelected).length;
            if (this.isSourceShipmentGrid) {
                return this.isPrintFormGridValid(componentState, selectedDocuments, isPrinterSelected, isServiceCenterSelected, isTwoPartPaperPrint, status, notAvailableDocCount, totalShipmentsDocCount);
            }
            if (this.isOnlyCopyBill) {
                return this.isCopyBillDocAvailable();
            }
            if (this.isOnlyFBDS) {
                if (isTwoPartPaperPrint || isDockCopy) {
                    return isPrinterSelected;
                }
                return isPrinterSelected && isServiceCenterSelected;
            }
            isSomeDocumentToPrint = !!(printSingle === null || printSingle === void 0 ? void 0 : printSingle.isSomeDocumentToPrint);
            const isSingleFBDSOk = !!(printSingle === null || printSingle === void 0 ? void 0 : printSingle.isFBDSok);
            const isAbleToPrintSingle = isSomeDocumentToPrint && isSingleFBDSOk;
            return isAbleToPrintSingle;
        }), distinctUntilChanged());
    }
    isPrintFormGridValid(componentState, selectedDocuments, isPrinterSelected, isServiceCenterSelected, isTwoPartPaperPrint, status, notAvailableDocCount, totalShipmentsDocCount) {
        if (totalShipmentsDocCount === notAvailableDocCount) {
            return false;
        }
        const isShowPrint = componentState === PrintComponentState.ShowPrint;
        const isFormValid = status === FormStatus.Valid;
        const isDocumentSelectedToPrint = selectedDocuments.length === 1;
        if (isShowPrint && isFormValid && isDocumentSelectedToPrint) {
            const isFormRequired = !!this.requireFormToPtintMap[selectedDocuments[0]];
            if (isFormRequired) {
                const isDockCopy = selectedDocuments[0] === XpoLtlPrintDocType.DockCopy;
                const isFBDS = selectedDocuments[0] === XpoLtlPrintDocType.FBDS;
                return ((isDockCopy && isPrinterSelected) ||
                    (isFBDS && ((isPrinterSelected && isServiceCenterSelected) || (isTwoPartPaperPrint && isPrinterSelected))));
            }
            return true;
        }
        return false;
    }
    initForm() {
        this.formGroup = this.formBuilder.group({
            [PrintFormFields.SelectedDocuments]: [[]],
            [PrintFormFields.FBDS]: this.formBuilder.group({
                [PrintFormFields.PaperType]: PrintFBDSDocumentsTypeCd.LASER,
                [PrintFormFields.Printer]: [
                    '',
                    [XpoLtlDynamicValidator(() => this.isPrintDocTypeSelected(XpoLtlPrintDocType.FBDS), Validators.required)],
                ],
                [PrintFormFields.Tray]: '',
                [PrintFormFields.ServiceCenter]: '',
                [PrintFormFields.PrintFBDSFromLocal]: false,
                [PrintFormFields.DocumentType]: FBDSDocumentType.FBDS,
                [PrintFormFields.isPrintingUsingSystemDialog]: false,
                [PrintFormFields.Language]: FbdsVersionCd.DEFAULT,
            }),
            [PrintFormFields.DockCopy]: this.formBuilder.group({
                [PrintFormFields.Printer]: [
                    '',
                    [XpoLtlDynamicValidator(() => this.isPrintDocTypeSelected(XpoLtlPrintDocType.DockCopy), Validators.required)],
                ],
            }),
        });
    }
    isPrintDocTypeSelected(docType) {
        var _a, _b;
        const selectedDocuments = (_b = (_a = this.formGroup) === null || _a === void 0 ? void 0 : _a.get(PrintFormFields.SelectedDocuments)) === null || _b === void 0 ? void 0 : _b.value;
        return !!(selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.includes((doc) => doc === docType));
    }
    getDocTypesList() {
        let docTypes = this.data.docTypes;
        if (!(docTypes === null || docTypes === void 0 ? void 0 : docTypes.length)) {
            if (this.isSourceShipmentGrid) {
                docTypes = this.defaultMultiProDocList;
            }
            else {
                docTypes = this.defaultSingleProDocList;
            }
        }
        return docTypes;
    }
    onCancelClicked() {
        this.close.emit();
    }
    isFBDSPerforatedPrint() {
        const paperType = this.paperTypeCtrl.value;
        const docType = this.docTypeCtrl.value;
        return docType === XpoLtlPrintDocType.FBDS && paperType === PrintFBDSDocumentsTypeCd.LASER;
    }
    onPrintClicked() {
        this.getFormValues();
        if (this.isSourceShipmentGrid) {
            this.printMultiplePRO();
        }
        if (this.isOnlyCopyBill) {
            // TODO: Improve and re use this method
            this.printService.showLoader();
            const shpInstIds = this.getShipmentInstIds();
            this.downloadCopyBill(shpInstIds).subscribe({
                next: (response) => this.handleSinglePrintResponse(response[0]),
                error: this.handleSinglePrintError.bind(this),
            });
        }
        else if (this.isOnlyFBDS) {
            this.printFBDS();
        }
        else {
            this.printSinglePRO();
        }
    }
    getShipmentInstIds() {
        const docMap = this.printService.shipmentDocumentsMapSubject.value;
        const proNbrs = Object.keys(docMap);
        const shipmentInstIds = proNbrs.map((proNbr) => {
            const data = docMap[proNbr];
            const shipmentId = {
                pickupDate: new Date(data.shipmentInfo.shipment.pickupDate),
                proNumber: proNbr,
                shipmentInstId: `${data.shipmentInfo.shipment.shipmentInstId}`,
            };
            return shipmentId;
        });
        return shipmentInstIds;
    }
    handleSinglePrintResponse(response) {
        if (response) {
            this.openPrintFrameInBrowser([response]).subscribe(() => this.dialogRef.close());
        }
        else {
            const message = 'No documents available for printing';
            this.xpoSnackBar.open({
                message,
                status: 'error',
                matConfig: {
                    verticalPosition: 'bottom',
                },
            });
            this.dialogRef.close();
        }
    }
    getFormValues() {
        const fbdsFormGroup = this.formGroup.get(PrintFormFields.FBDS);
        this.docTypeCtrl = fbdsFormGroup.get(PrintFormFields.DocumentType);
        this.selectedDocTypeCtrl = this.formGroup.get(PrintFormFields.SelectedDocuments);
        this.paperTypeCtrl = fbdsFormGroup.get(PrintFormFields.PaperType);
        this.printerCtrl = fbdsFormGroup.get(PrintFormFields.Printer);
        this.trayCtrl = fbdsFormGroup.get(PrintFormFields.Tray);
        this.serviceCenterCtrl = fbdsFormGroup.get(PrintFormFields.ServiceCenter);
        this.languageCtrl = fbdsFormGroup.get(PrintFormFields.Language);
    }
    printMultiplePRO() {
        const selectedDocuments = this.formGroup.get(PrintFormFields.SelectedDocuments).value;
        switch (selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments[0]) {
            case XpoLtlPrintDocType.CopyBill:
                this.printMultipleCopyBill();
                break;
            case XpoLtlPrintDocType.BillOfLading:
            case XpoLtlPrintDocType.DeliveryReceipt:
                {
                    this.printService.printDocuments$(selectedDocuments).subscribe((documents) => {
                        if (documents.length > 0) {
                            this.openPrintFrameInBrowser(documents);
                        }
                        else {
                            const message = 'No documents available for printing';
                            this.xpoSnackBar.open({
                                message,
                                status: 'info',
                                matConfig: {
                                    verticalPosition: 'bottom',
                                },
                            });
                            this.dialogRef.close();
                        }
                    });
                }
                break;
            case XpoLtlPrintDocType.FBDS:
                this.printFBDS();
                break;
            case XpoLtlPrintDocType.DockCopy:
                this.printDockCopy();
                break;
            case XpoLtlPrintDocType.ShipmentGridInfo: {
                this.printService.printShipmentGridInfo(this.data.shipmentInfo);
                this.dialogRef.close();
            }
        }
    }
    printMultipleCopyBill() {
        const proNbrsKey = Object.keys(this.printService.shipmentDocumentsMap);
        const validPro = [];
        proNbrsKey.forEach((pro) => {
            const availableDocs = this.printService.shipmentDocumentsMap[pro].documents;
            availableDocs
                .filter((docs) => docs.docType === XpoLtlPrintDocType.CopyBill && !docs.excludedInd)
                .map((docs) => validPro.push(docs.data.proNbr));
        });
        if (validPro === null || validPro === void 0 ? void 0 : validPro.length) {
            this.printService.showLoader();
            const shipments = this.getShipmentInstIds();
            const shipmentsLst = shipments.filter((shipment) => validPro.some((pro) => pro === shipment.proNumber));
            this.downloadCopyBill(shipmentsLst).subscribe((documents) => {
                this.openPrintFrameInBrowser(documents).subscribe(() => {
                    this.printService.hideLoader();
                    this.dialogRef.close();
                });
            });
        }
        else {
            this.showInfoSnackBar();
        }
    }
    printFBDS() {
        if (this.isFBDSPerforatedPrint()) {
            this.handleFbdsPerforatedPrint();
        }
        else {
            this.handleTwoPartAndCopyBillPrint();
        }
    }
    printDockCopy() {
        const paperType = this.paperTypeCtrl.value;
        const docMap = this.printService.shipmentDocumentsMapSubject.value;
        const proNbrs = Object.keys(docMap);
        const request = Object.assign(Object.assign({}, new PrintFBDSDocumentsRqst()), { proNbrs: proNbrs.map((proNbr) => this.conditioningService.conditionProNumber(proNbr, 11)), printFBDSDocumentsTypeCd: paperType, reprintInd: true, validateInd: true, includeProsNotDestinedInd: true, includeProsDestinedInd: true, includeClosedTrailersInd: true, reportType: 'DOCK', formType: 'PAPER' });
        if (paperType === PrintFBDSDocumentsTypeCd.DOT_MATRIX) {
            request.printerCd = this.printerCtrl.value;
        }
        this.printService.showLoader();
        this.printService
            .getLoggedInUser$()
            .pipe(take(1), switchMap((user) => {
            request.domicileSicCd = user.sicCode;
            return this.shipmentApi.printFBDSDocuments(request, { loadingOverlayEnabled: false });
        }), map((response) => response), finalize(() => {
            this.printService.hideLoader();
        }))
            .subscribe({
            next: (response) => {
                if (paperType === PrintFBDSDocumentsTypeCd.DOT_MATRIX) {
                    this.saveUserPreferences();
                    this.xpoSnackBar.open({
                        message: `Print request sent successfully to printer ${request.printerCd} .`,
                        status: 'success',
                        matConfig: {
                            verticalPosition: 'bottom',
                        },
                    });
                    this.dialogRef.close();
                }
                else if (paperType === PrintFBDSDocumentsTypeCd.LASER) {
                    this.openPrintFrameInBrowser(response.documentData).subscribe(() => this.dialogRef.close());
                }
            },
            error: (errorResp) => {
                var _a;
                const errorMessage = (_a = errorResp === null || errorResp === void 0 ? void 0 : errorResp.error) === null || _a === void 0 ? void 0 : _a.message;
                this.xpoSnackBar.open({
                    message: errorMessage,
                    status: 'error',
                    matConfig: {
                        verticalPosition: 'bottom',
                    },
                });
            },
        });
    }
    printSinglePRO() {
        const model = this.singlePrintStateSubject.value;
        const docsToPrint = model === null || model === void 0 ? void 0 : model.documentsToPrint;
        let observables = [];
        if (docsToPrint === null || docsToPrint === void 0 ? void 0 : docsToPrint.length) {
            observables = [...this.printService.downloadDocuments(docsToPrint)];
        }
        if (model === null || model === void 0 ? void 0 : model.isCopyBillRequiredToPrint) {
            const shpInstIds = this.getShipmentInstIds();
            observables = [...observables, this.downloadCopyBill(shpInstIds)];
        }
        let isRequiredToCallPrintFBDS = false;
        if (model === null || model === void 0 ? void 0 : model.isFBDSRequiredToPrint) {
            if (model === null || model === void 0 ? void 0 : model.isPrintingUsingSystemDialog) {
                const observable = this.getFBDSDocumentsObservable(model.proNbrs);
                observables = [...observables, observable];
            }
            else {
                isRequiredToCallPrintFBDS = true;
            }
        }
        if (observables.length > 0) {
            this.handleSinglePROPrintObservables(observables, isRequiredToCallPrintFBDS);
        }
        else if (isRequiredToCallPrintFBDS) {
            this.printFBDS();
        }
    }
    handleSinglePROPrintObservables(observables, isRequiredToCallPrintFBDS) {
        observables = observables.map((observable) => observable.pipe(catchError((error) => of(undefined))));
        this.printService.showLoader();
        forkJoin(observables)
            .pipe(takeUntil(this.unsubscriber.done$), tap(() => this.printService.hideLoader()), tap(() => this.dialogRef.close()), tap(() => {
            if (isRequiredToCallPrintFBDS) {
                this.printFBDS();
            }
        }))
            .subscribe({
            next: (response) => {
                const processedResponse = response.reduce((pre, cur) => {
                    pre.push(...cur);
                    return pre;
                }, []);
                const filtered = processedResponse.filter((doc) => !!doc);
                if (filtered.length > 0) {
                    this.openPrintFrameInBrowser(filtered);
                    const noPrintendCount = processedResponse.length - filtered.length;
                    if (noPrintendCount > 0) {
                        const error = { error: { message: `${noPrintendCount} documents are not available for printing` } };
                        this.handleSinglePrintError(error);
                    }
                }
                else {
                    const error = { error: { message: 'No documents available for printing' } };
                    this.handleSinglePrintError(error);
                }
            },
            error: this.handleSinglePrintError.bind(this),
        });
    }
    getFBDSDocumentsObservable(proNbrs) {
        var _a;
        const shipmentIds = FBDSPrintUtils.getShipmentIdsFromProNbrs(proNbrs);
        const printLanguage = (_a = this.languageCtrl) === null || _a === void 0 ? void 0 : _a.value;
        if (shipmentIds === null || shipmentIds === void 0 ? void 0 : shipmentIds.length) {
            const observable = this.printService.printFBDSDocumentFromLocal$(shipmentIds, printLanguage).pipe(takeUntil(this.unsubscriber.done$), map((response) => response), map((response) => response.documentData));
            return observable;
        }
        else {
            this.showInfoSnackBar();
        }
    }
    handleSinglePrintError(errorResp) {
        var _a, _b;
        this.printService.hideLoader();
        const errorMessage = (_b = (_a = errorResp === null || errorResp === void 0 ? void 0 : errorResp.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : 'I this moment the documents are not able to be printed';
        this.xpoSnackBar.open({
            message: errorMessage,
            status: 'error',
            matConfig: {
                verticalPosition: 'bottom',
            },
        });
    }
    downloadCopyBill(shipmentInstIds) {
        if (shipmentInstIds) {
            const createRequest = new CreateFBDSDocumentsRqst();
            createRequest.formType = DocumentFormTypeCd.COPY_BILL;
            createRequest.reprintInd = true;
            createRequest.includeWarningsPageInd = true;
            createRequest.shipmentIds = shipmentInstIds;
            const obs = this.shipmentApi.createFBDSDocuments(createRequest, { loadingOverlayEnabled: false }).pipe(takeUntil(this.unsubscriber.done$), map((response) => response), map((data) => {
                return data === null || data === void 0 ? void 0 : data.documentData;
            }));
            return obs;
        }
        return of([]);
    }
    onSinglePROPrintChange(model) {
        this.singlePrintStateSubject.next(model);
    }
    handleFbdsPerforatedPrint() {
        const selectedProKeys = Object.keys(this.printService.shipmentDocumentsMap);
        const selectedValidPro = [];
        selectedProKeys.forEach((proNbr) => {
            const proDocument = this.printService.shipmentDocumentsMap[proNbr];
            const validPro = [proDocument].filter((document) => !document.isFBDSHidden);
            if (validPro.length > 0) {
                selectedValidPro.push({ shipmentInstId: undefined, proNumber: proNbr, pickupDate: undefined });
            }
        });
        const shipmentIds = selectedValidPro;
        const printerId = this.printerCtrl.value;
        const paperSource = this.trayCtrl.value;
        const language = this.languageCtrl.value;
        if (shipmentIds === null || shipmentIds === void 0 ? void 0 : shipmentIds.length) {
            this.printService.printFBDSPerforated$(shipmentIds, printerId, paperSource, language).subscribe({
                next: () => {
                    this.saveUserPreferences();
                    const message = `${selectedValidPro.length} FBDS document printed `;
                    this.xpoSnackBar.open({
                        message,
                        status: 'success',
                        matConfig: {
                            verticalPosition: 'bottom',
                        },
                    });
                },
                error: (errorResp) => {
                    var _a;
                    const errorMessage = (_a = errorResp === null || errorResp === void 0 ? void 0 : errorResp.error) === null || _a === void 0 ? void 0 : _a.message;
                    this.xpoSnackBar.open({
                        message: errorMessage,
                        status: 'error',
                        matConfig: {
                            verticalPosition: 'bottom',
                        },
                    });
                },
                complete: () => {
                    this.dialogRef.close();
                },
            });
        }
        else {
            this.showInfoSnackBar();
        }
    }
    saveUserPreferences() {
        var _a;
        const updatedPreferences = Object.assign({}, this.printService.savedPreferences);
        updatedPreferences[FBDSPreferenceKey.PaperType] = this.paperTypeCtrl.value;
        updatedPreferences[FBDSPreferenceKey.DocumentType] = this.docTypeCtrl.value;
        updatedPreferences[FBDSPreferenceKey.Language] = this.languageCtrl.value;
        const printerKey = this.docTypeCtrl.value === XpoLtlPrintDocType.DockCopy
            ? FBDSPreferenceKey.PrinterTwoPart
            : FBDSPreferenceKey.PrinterPerforated;
        updatedPreferences[printerKey] = this.printerCtrl.value;
        if (this.isFBDSPerforatedPrint()) {
            updatedPreferences[FBDSPreferenceKey.ServiceCenter] = (_a = this.serviceCenterCtrl.value) === null || _a === void 0 ? void 0 : _a.sicCd;
            updatedPreferences[FBDSPreferenceKey.Tray] = this.trayCtrl.value;
        }
        this.printService.updateUserPreferences$(updatedPreferences).subscribe(() => { });
    }
    handleTwoPartAndCopyBillPrint() {
        var _a;
        let documentType;
        const selectedProKeys = Object.keys(this.printService.shipmentDocumentsMap);
        const proNbrs = [];
        selectedProKeys.forEach((proNbr) => {
            const proDocument = this.printService.shipmentDocumentsMap[proNbr];
            const validPro = [proDocument]
                .filter((document) => !document.isFBDSHidden)
                .filter((document) => !document.isCopyBillHidden);
            if (validPro.length > 0) {
                proNbrs.push(proNbr);
            }
        });
        const docFormType = DocumentFormTypeCd.FBDS;
        const paperType = this.paperTypeCtrl.value;
        const printerCd = this.printerCtrl.value;
        if (this.isSourceShipmentGrid) {
            documentType = (_a = this.selectedDocTypeCtrl.value) === null || _a === void 0 ? void 0 : _a[0];
        }
        else {
            documentType = this.docTypeCtrl.value;
        }
        if (proNbrs === null || proNbrs === void 0 ? void 0 : proNbrs.length) {
            this.printService
                .printFBDSTwoPartAndCopyBill$(proNbrs, documentType, docFormType, paperType, printerCd)
                .pipe(map((response) => response))
                .subscribe({
                next: (response) => {
                    if (paperType === PrintFBDSDocumentsTypeCd.DOT_MATRIX) {
                        this.saveUserPreferences();
                        this.xpoSnackBar.open({
                            message: `Print request sent successfully to printer ${printerCd} .`,
                            status: 'success',
                            matConfig: {
                                verticalPosition: 'bottom',
                            },
                        });
                    }
                    else if (paperType === PrintFBDSDocumentsTypeCd.LASER) {
                        this.openPrintFrameInBrowser(response.documentData);
                    }
                },
                error: (errorResp) => {
                    var _a;
                    const errorMessage = (_a = errorResp === null || errorResp === void 0 ? void 0 : errorResp.error) === null || _a === void 0 ? void 0 : _a.message;
                    this.xpoSnackBar.open({
                        message: errorMessage,
                        status: 'error',
                        matConfig: {
                            verticalPosition: 'bottom',
                        },
                    });
                },
                complete: () => {
                    this.dialogRef.close();
                },
            });
        }
        else {
            this.showInfoSnackBar();
        }
    }
    openPrintFrameInBrowser(base64Array) {
        const finishSubject = new Subject();
        from(this.printService.mergePDFDocuments(base64Array))
            .pipe(catchError((error) => {
            const message = 'Invalid documents, failed to create PDF';
            this.xpoSnackBar.open({
                message,
                status: 'error',
                matConfig: {
                    verticalPosition: 'bottom',
                },
            });
            return of(undefined);
        }))
            .subscribe((mergedPDF) => {
            if (mergedPDF) {
                const blob = new Blob([mergedPDF], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                printJS({
                    printable: url,
                    type: 'pdf',
                });
                finishSubject.next(mergedPDF);
                finishSubject.complete();
            }
        });
        return finishSubject;
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
        this.printService.reset();
    }
    showInfoSnackBar() {
        const message = 'No documents available for printing';
        this.xpoSnackBar.open({
            message,
            status: 'info',
            matConfig: {
                verticalPosition: 'bottom',
            },
        });
        this.dialogRef.close();
    }
    isCopyBillDocAvailable() {
        if (this.isOnlyCopyBill) {
            const selectedShipment = this.printService.shipmentDocumentsMap;
            const selectedPro = Object.keys(selectedShipment);
            const isCopyBillDocAvailable = selectedShipment[selectedPro[0]].isCopyBillHidden;
            return !isCopyBillDocAvailable;
        }
    }
}
XpoLtlPrintComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintComponent, deps: [{ token: PrintService }, { token: i2$2.FormBuilder }, { token: i3$2.XpoSnackBar }, { token: i3$1.ConditioningService }, { token: i2$6.ShipmentApiService }, { token: i1$1.MatDialogRef }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlPrintComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlPrintComponent, selector: "xpo-ltl-print", inputs: { data: "data" }, outputs: { close: "close" }, ngImport: i0, template: "<div\n  *ngIf=\"{\n    printSource: isSourceShipmentGrid,\n    canPrint: canPrint$ | async,\n    isLoading: isLoading$ | async,\n    componentState: componentState$ | async,\n    shipmentDocuments: shipmentDocuments$ | async\n  } as state\"\n  class=\"Print\"\n>\n  <h1 mat-dialog-title class=\"Print__header\">\n    Print\n  </h1>\n\n  <div class=\"Print__wrapper\">\n    <ng-container *ngIf=\"state.isLoading\">\n      <div class=\"Print__disabledPanel\"></div>\n      <xpo-busy-loader class=\"Print__loadingSpinner\"></xpo-busy-loader>\n    </ng-container>\n\n    <div mat-dialog-content class=\"Print__content\">\n      <ng-container *ngIf=\"state.componentState === PrintComponentState.ShowPrint\">\n        <ng-container *ngIf=\"state.printSource; else printShipment\">\n          <xpo-ltl-print-shipments [docTypes]=\"docList\" [formGroup]=\"formGroup\" [data]=\"data\"></xpo-ltl-print-shipments>\n        </ng-container>\n        <ng-template #printShipment>\n          <xpo-ltl-print-shipment\n            [formGroup]=\"formGroup\"\n            [data]=\"data\"\n            [shipmentDocuments]=\"state.shipmentDocuments\"\n            (modelChange)=\"onSinglePROPrintChange($event)\"\n          >\n          </xpo-ltl-print-shipment>\n        </ng-template>\n      </ng-container>\n      <ng-container *ngIf=\"state.componentState === PrintComponentState.Error\">\n        <xpo-empty-state class=\"Print__empty-state\">\n          <xpo-empty-state-icon>\n            <mat-icon>insert_drive_file</mat-icon>\n          </xpo-empty-state-icon>\n          <xpo-empty-state-header>No documents found.</xpo-empty-state-header>\n          <xpo-empty-state-description></xpo-empty-state-description>\n        </xpo-empty-state>\n      </ng-container>\n    </div>\n  </div>\n\n  <div mat-dialog-actions class=\"Print__footer\">\n    <button mat-flat-button [disabled]=\"!state.canPrint\" (click)=\"onPrintClicked()\">Print</button>\n\n    <button mat-stroked-button (click)=\"onCancelClicked()\">Cancel</button>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}.Print{height:100%;width:100%}.Print__content,.Print__wrapper{position:relative}.Print__content{min-height:180px}.Print__loadingSpinner{position:absolute;left:50%;top:50%;width:100px;transform:translate(-50%,-50%);z-index:999}.Print__controls--radio{display:flex;flex-direction:column}.Print__section{margin-top:16px}.Print__section--title{color:#4a4a4a;font-weight:400;margin:0 0 8px}.Print__section--title .required{color:#d32f2f;padding-left:2px}.Print__input--autocomplete{width:50%}.Print__input--svcCenter{width:100%}.Print__input--printer{flex:1 1 auto;padding-right:16px}.Print__input--suffix{display:flex;align-items:center}.Print__localPrint--container,.Print__printerType{display:flex;justify-content:space-between;align-items:baseline}.Print__localPrint--button{padding-left:8px!important}.Print__disabledPanel{position:absolute;top:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.38);z-index:10}.Print__reprint--title .FBDSPrintDialog__reprint--indicator span.xpo-StatusIndicator-tag{font-size:.875rem}.Print__reprint--labelText{padding:0 8px}.Print__link--action{color:#0868ac;font-size:.875rem;font-weight:400;margin:0 4px;padding-left:8px;text-transform:unset!important}.Print__link--action:hover{color:#0d94f4;text-decoration:underline}.Print__empty-state div.xpo-EmptyState{padding-top:16px}"], components: [{ type: i7$2.XpoBusyLoader, selector: "xpo-busy-loader", inputs: ["slow"] }, { type: PrintShipmentsComponent, selector: "xpo-ltl-print-shipments", inputs: ["docTypes", "formGroup", "data"] }, { type: PrintShipmentComponent, selector: "xpo-ltl-print-shipment", inputs: ["formGroup", "data", "shipmentDocuments", "modelDispatcher"], outputs: ["modelChange"] }, { type: i3$3.XpoEmptyState, selector: "xpo-empty-state" }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3$3.XpoEmptyStateIcon, selector: "xpo-empty-state-icon" }, { type: i3$3.XpoEmptyStateHeader, selector: "xpo-empty-state-header" }, { type: i3$3.XpoEmptyStateDescription, selector: "xpo-empty-state-description" }, { type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-print',
                    templateUrl: './print.component.html',
                    styleUrls: ['./print.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: PrintService }, { type: i2$2.FormBuilder }, { type: i3$2.XpoSnackBar }, { type: i3$1.ConditioningService }, { type: i2$6.ShipmentApiService }, { type: i1$1.MatDialogRef }]; }, propDecorators: { data: [{
                type: Input
            }], close: [{
                type: Output
            }] } });

class XpoLtlPrintDialogComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
    }
    onCloseClicked() {
        this.dialogRef.close();
    }
}
XpoLtlPrintDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintDialogComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$1.MatDialogRef }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlPrintDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlPrintDialogComponent, selector: "xpo-ltl-print-dialog", ngImport: i0, template: "<xpo-ltl-print [data]=\"data\" (close)=\"onCloseClicked()\"></xpo-ltl-print>\n", styles: [""], components: [{ type: XpoLtlPrintComponent, selector: "xpo-ltl-print", inputs: ["data"], outputs: ["close"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-print-dialog',
                    templateUrl: './print-dialog.component.html',
                    styleUrls: ['./print-dialog.component.scss']
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlPrintData, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$1.MatDialogRef }]; } });

class XpoLtlPrintDialogService {
    constructor(dialog) {
        this.dialog = dialog;
        this.unsubscriber = new Unsubscriber();
    }
    openPrintDialog(dialogData) {
        let dialogRef;
        const subject = new Subject();
        dialogRef = this.dialog.open(XpoLtlPrintDialogComponent, {
            data: dialogData,
            width: '650px',
            disableClose: false,
            hasBackdrop: true,
            restoreFocus: false,
        });
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this.unsubscriber.done$), take(1))
            .subscribe(() => {
            subject.next();
            subject.complete();
        });
        return subject.asObservable();
    }
}
XpoLtlPrintDialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintDialogService, deps: [{ token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlPrintDialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintDialogService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintDialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }]; } });

class PrintShipmentGridInformationComponent {
    constructor() { }
    ngOnInit() {
    }
}
PrintShipmentGridInformationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintShipmentGridInformationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PrintShipmentGridInformationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: PrintShipmentGridInformationComponent, selector: "xpo-ltl-print-shipment-grid-information", ngImport: i0, template: "<p>print-shipment-grid-information works!</p>\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PrintShipmentGridInformationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-print-shipment-grid-information',
                    templateUrl: './print-shipment-grid-information.component.html',
                    styleUrls: ['./print-shipment-grid-information.component.scss']
                }]
        }], ctorParameters: function () { return []; } });

const frameworkComponents$1 = {
    XpoStringFilterComponent,
    ActionIconCellRendererComponent,
    StatusIndicatorCellRendererComponent,
};
class XpoLtlPrintModule {
}
XpoLtlPrintModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlPrintModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintModule, declarations: [XpoLtlPrintComponent,
        FbdsPrintComponent,
        PrintShipmentComponent,
        PrintShipmentsComponent,
        XpoLtlPrintDialogComponent,
        PrintDocTypePipe,
        DockCopyPrintComponent,
        DocumentsStatusGridComponent,
        ActionIconCellRendererComponent,
        PrintShipmentGridInformationComponent,
        StatusIndicatorCellRendererComponent], imports: [CommonModule,
        ScrollingModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatBadgeModule,
        XpoLtlDmsUtilsModule,
        XpoBadgeModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatTreeModule,
        MatExpansionModule,
        ReactiveFormsModule,
        XpoBusyLoaderModule,
        XpoButtonModule,
        XpoCheckboxModule,
        XpoChipsModule,
        XpoDialogModule,
        XpoEmptyStateModule,
        XpoIconModule,
        XpoLtlPipeModule,
        XpoSelectModule,
        XpoSelectModule,
        XpoStatusIndicatorModule,
        XpoAgGridBoardModule, i1$8.AgGridModule], exports: [XpoLtlPrintComponent,
        FbdsPrintComponent,
        PrintShipmentComponent,
        PrintShipmentsComponent,
        XpoLtlPrintDialogComponent,
        DockCopyPrintComponent,
        DocumentsStatusGridComponent,
        ActionIconCellRendererComponent] });
XpoLtlPrintModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintModule, imports: [[
            CommonModule,
            ScrollingModule,
            MatAutocompleteModule,
            MatButtonModule,
            MatBadgeModule,
            XpoLtlDmsUtilsModule,
            XpoBadgeModule,
            MatCheckboxModule,
            MatChipsModule,
            MatDialogModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            MatRadioModule,
            MatSelectModule,
            MatTreeModule,
            MatExpansionModule,
            ReactiveFormsModule,
            XpoBusyLoaderModule,
            XpoButtonModule,
            XpoCheckboxModule,
            XpoChipsModule,
            XpoDialogModule,
            XpoEmptyStateModule,
            XpoIconModule,
            XpoLtlPipeModule,
            XpoSelectModule,
            XpoSelectModule,
            XpoStatusIndicatorModule,
            XpoAgGridBoardModule,
            AgGridModule.withComponents(frameworkComponents$1),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlPrintModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        XpoLtlPrintComponent,
                        FbdsPrintComponent,
                        PrintShipmentComponent,
                        PrintShipmentsComponent,
                        XpoLtlPrintDialogComponent,
                        PrintDocTypePipe,
                        DockCopyPrintComponent,
                        DocumentsStatusGridComponent,
                        ActionIconCellRendererComponent,
                        PrintShipmentGridInformationComponent,
                        StatusIndicatorCellRendererComponent,
                    ],
                    entryComponents: [
                        XpoLtlPrintComponent,
                        FbdsPrintComponent,
                        PrintShipmentComponent,
                        PrintShipmentsComponent,
                        XpoLtlPrintDialogComponent,
                        DockCopyPrintComponent,
                        DocumentsStatusGridComponent,
                        ActionIconCellRendererComponent,
                    ],
                    imports: [
                        CommonModule,
                        ScrollingModule,
                        MatAutocompleteModule,
                        MatButtonModule,
                        MatBadgeModule,
                        XpoLtlDmsUtilsModule,
                        XpoBadgeModule,
                        MatCheckboxModule,
                        MatChipsModule,
                        MatDialogModule,
                        MatFormFieldModule,
                        MatIconModule,
                        MatInputModule,
                        MatRadioModule,
                        MatSelectModule,
                        MatTreeModule,
                        MatExpansionModule,
                        ReactiveFormsModule,
                        XpoBusyLoaderModule,
                        XpoButtonModule,
                        XpoCheckboxModule,
                        XpoChipsModule,
                        XpoDialogModule,
                        XpoEmptyStateModule,
                        XpoIconModule,
                        XpoLtlPipeModule,
                        XpoSelectModule,
                        XpoSelectModule,
                        XpoStatusIndicatorModule,
                        XpoAgGridBoardModule,
                        AgGridModule.withComponents(frameworkComponents$1),
                    ],
                    // TODO: CCS-2579 remove the export to use the common component
                    exports: [
                        XpoLtlPrintComponent,
                        FbdsPrintComponent,
                        PrintShipmentComponent,
                        PrintShipmentsComponent,
                        XpoLtlPrintDialogComponent,
                        DockCopyPrintComponent,
                        DocumentsStatusGridComponent,
                        ActionIconCellRendererComponent,
                    ],
                }]
        }] });

var XpoLtlUpdateShipmentStatusCd;
(function (XpoLtlUpdateShipmentStatusCd) {
    XpoLtlUpdateShipmentStatusCd["ATTEMPTED"] = "Attempted";
    XpoLtlUpdateShipmentStatusCd["CARTAGE"] = "Cartage";
    XpoLtlUpdateShipmentStatusCd["FINAL"] = "Final";
    XpoLtlUpdateShipmentStatusCd["FINAL_WITH_EXCEPTIONS"] = "FinalWithExceptions";
    XpoLtlUpdateShipmentStatusCd["HOLD_FOR_CUSTOMS"] = "HoldForCustoms";
    XpoLtlUpdateShipmentStatusCd["OVER_WITHOUT_BILLED_SHIPMENTS"] = "OverWithoutBilledShipments";
    XpoLtlUpdateShipmentStatusCd["PART_SHORT"] = "PartialShort";
    XpoLtlUpdateShipmentStatusCd["PART_SHORT_WITH_EXCEPTIONS"] = "PartShortWithExceptions";
    XpoLtlUpdateShipmentStatusCd["REFUSED"] = "Refused";
    XpoLtlUpdateShipmentStatusCd["RETURNED_DAMAGED"] = "ReturnedDamaged";
    XpoLtlUpdateShipmentStatusCd["RETURNED"] = "Returned";
    XpoLtlUpdateShipmentStatusCd["ALL_SHORT"] = "AllShort";
    XpoLtlUpdateShipmentStatusCd["ALL_SHORT_WITH_EXCEPTIONS"] = "AllShortWithExceptions";
    XpoLtlUpdateShipmentStatusCd["STAGE"] = "Stage";
    XpoLtlUpdateShipmentStatusCd["TRAP"] = "Trap";
    XpoLtlUpdateShipmentStatusCd["UNDELIVERED"] = "Undelivered";
})(XpoLtlUpdateShipmentStatusCd || (XpoLtlUpdateShipmentStatusCd = {}));

var UpdateShipmentsStatusFormField;
(function (UpdateShipmentsStatusFormField) {
    UpdateShipmentsStatusFormField["Shipments"] = "shipments";
})(UpdateShipmentsStatusFormField || (UpdateShipmentsStatusFormField = {}));
var UpdateShipmentStatusFormField;
(function (UpdateShipmentStatusFormField) {
    UpdateShipmentStatusFormField["ID"] = "id";
    UpdateShipmentStatusFormField["CartageCarrier"] = "cartageCarrier";
    UpdateShipmentStatusFormField["CartageSIC"] = "cartageSIC";
    UpdateShipmentStatusFormField["ReportingSic"] = "reportingSic";
    UpdateShipmentStatusFormField["CashOnDeliveryCheckNbr"] = "cashOnDeliveryCheckNbr";
    UpdateShipmentStatusFormField["CashOnDeliveryDollarAmount"] = "cashOnDeliveryDollarAmount";
    UpdateShipmentStatusFormField["CashOnDeliveryPaymentMethod"] = "cashOnDeliveryPaymentMethod";
    UpdateShipmentStatusFormField["DamagedButAccepted"] = "damagedButAccepted";
    UpdateShipmentStatusFormField["Date"] = "date";
    UpdateShipmentStatusFormField["DeliveryQualifierCd"] = "deliveryQualifierCd";
    UpdateShipmentStatusFormField["ExceptionNote"] = "exceptionNote";
    UpdateShipmentStatusFormField["FreightChargesCheckNbr"] = "freighChargesCheckNbr";
    UpdateShipmentStatusFormField["FreightChargesDollarAmount"] = "freighChargesDollarAmount";
    UpdateShipmentStatusFormField["FreightChargesPaymentMethod"] = "freighChargesPaymentMethod";
    UpdateShipmentStatusFormField["OverButAccepted"] = "overButAccepted";
    UpdateShipmentStatusFormField["PartialRefused"] = "partialRefused";
    UpdateShipmentStatusFormField["StatusCd"] = "statusCd";
    UpdateShipmentStatusFormField["Reason"] = "reason";
    UpdateShipmentStatusFormField["RecipientName"] = "recipientName";
    UpdateShipmentStatusFormField["SCACCode"] = "scacCode";
    UpdateShipmentStatusFormField["ShortPieces"] = "shortPieces";
    UpdateShipmentStatusFormField["Time"] = "time";
    // PLT Shipment Fields
    UpdateShipmentStatusFormField["PLT"] = "plt";
    UpdateShipmentStatusFormField["PLT_PRO"] = "plt_pro";
    UpdateShipmentStatusFormField["PLT_SHIPMENT_INST_ID"] = "plt_shipmentInstId";
    UpdateShipmentStatusFormField["PLT_DELIVERY_QUALIFIER_CODE"] = "plt_deliveryQualifierCode";
    UpdateShipmentStatusFormField["PLT_DELIVERY_QUALIFIER_CODE_READONLY"] = "plt_deliveryQualifierCodeReadOnly";
    UpdateShipmentStatusFormField["PLT_TYPE"] = "plt_type";
    UpdateShipmentStatusFormField["PLT_MM"] = "plt_mm";
    UpdateShipmentStatusFormField["PLT_LP"] = "plt_lp";
    UpdateShipmentStatusFormField["PLT_LENGTH"] = "plt_length";
    UpdateShipmentStatusFormField["PLT_WIDTH"] = "plt_width";
    UpdateShipmentStatusFormField["PLT_HEIGHT"] = "plt_height";
    UpdateShipmentStatusFormField["DELIVERY_INFORMATION_RQ"] = "deliveryInformationRqdCd";
})(UpdateShipmentStatusFormField || (UpdateShipmentStatusFormField = {}));

var UpdateShipmentDeliveryQualifierReasonCd;
(function (UpdateShipmentDeliveryQualifierReasonCd) {
    UpdateShipmentDeliveryQualifierReasonCd["DOCK_PICKUP"] = "DockPickup";
    UpdateShipmentDeliveryQualifierReasonCd["REQUIRES_LIFTGATE_FOR_DELIVERY"] = "RequiresLiftgateForDelivery";
})(UpdateShipmentDeliveryQualifierReasonCd || (UpdateShipmentDeliveryQualifierReasonCd = {}));
const XpoLtlUpdateShipmentDeliveryQualifierReasonCd = Object.assign(Object.assign(Object.assign(Object.assign({}, DeliveryQualifierReasonCd), UpdateShipmentDeliveryQualifierReasonCd), RefusedReasonCd), UndeliveredReasonCd);

class UpdateShipmentStatusDeliveryQualifierReasonCdPipe extends DeliveryQualifierReasonCdPipe {
    transform(value) {
        let transformed = super.transform(value);
        switch (value) {
            case XpoLtlUpdateShipmentDeliveryQualifierReasonCd.DOCK_PICKUP: {
                transformed = 'Dock Pickup';
                break;
            }
            case XpoLtlUpdateShipmentDeliveryQualifierReasonCd.REQUIRES_LIFTGATE_FOR_DELIVERY: {
                transformed = 'Requires Liftgate For Delivery';
                break;
            }
        }
        return transformed;
    }
}
UpdateShipmentStatusDeliveryQualifierReasonCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusDeliveryQualifierReasonCdPipe, deps: null, target: i0.ɵɵFactoryTarget.Pipe });
UpdateShipmentStatusDeliveryQualifierReasonCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusDeliveryQualifierReasonCdPipe, name: "updateShipmentStatusDeliveryQualifierCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusDeliveryQualifierReasonCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'updateShipmentStatusDeliveryQualifierCd',
                }]
        }] });

class UpdateShipmentStatusDisplayConfigService {
    constructor(deliveryQualifierReasonCdPipe) {
        this.deliveryQualifierReasonCdPipe = deliveryQualifierReasonCdPipe;
        this.refusedReasonCdPipe = new RefusedReasonCdPipe();
        this.undeliveredReasonCdPipe = new UndeliveredReasonCdPipe();
        this.codRequiredFields = [
            {
                field: UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr,
                requiredFn: (id, values) => this.isCheckNbrRequired(id, UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod, values),
            },
            {
                field: UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount,
                requiredFn: (id, values) => this.isAmountRequired(id, UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod, values),
            },
        ];
        this.driverCollectRequiredFields = [
            {
                field: UpdateShipmentStatusFormField.FreightChargesCheckNbr,
                requiredFn: (id, values) => this.isCheckNbrRequired(id, UpdateShipmentStatusFormField.FreightChargesPaymentMethod, values),
            },
            {
                field: UpdateShipmentStatusFormField.FreightChargesDollarAmount,
                requiredFn: (id, values) => this.isAmountRequired(id, UpdateShipmentStatusFormField.FreightChargesPaymentMethod, values),
            },
        ];
        this.updateShipmentStatusCdDisplayConfig = {
            [XpoLtlUpdateShipmentStatusCd.FINAL]: {
                deliveryQualifierCd: DeliveryQualifierCd.FINAL,
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Time },
                    ...this.codRequiredFields,
                    ...this.driverCollectRequiredFields,
                ],
                suppressExceptionNote: true,
                suppressPiecesInfo: true,
                suppressReason: true,
                suppressShortPieces: true,
                suppressCartageCarrier: true,
            },
            [XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS]: {
                deliveryQualifierCd: DeliveryQualifierCd.FINAL,
                suppressReason: true,
                suppressShortPieces: true,
                suppressCartageCarrier: true,
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Time },
                    { field: UpdateShipmentStatusFormField.ExceptionNote },
                    ...this.codRequiredFields,
                    ...this.driverCollectRequiredFields,
                ],
            },
            [XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS]: {
                deliveryQualifierCd: DeliveryQualifierCd.HOLD_FOR_CUSTOMS,
                reasonCds: [
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.FAILED_PARS,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.PAPERWORK_ISSUE,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.NO_BROKER,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INCORRECT_BROKER,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.BROKER_CLOSED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INFO_MISSING,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CLIENT_CLEAR,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.GOVERNMENT_DOCS_REQUIRED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.WRONG_PRO,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CLIENT_CREDIT,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.OTHER,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMS_IMPORT_EXPORT,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INT_NON_CARRIER_DELIVERY,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.WAITING_INSPECTION,
                ],
                reasonCdsTransformer: this.deliveryQualifierReasonCdPipe.transform.bind(this),
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Reason },
                    { field: UpdateShipmentStatusFormField.ExceptionNote },
                ],
                suppressDriverCollect: true,
                suppressPiecesInfo: true,
                suppressShortPieces: true,
                suppressRecipientName: true,
                suppressSCAC: true,
                suppressTime: true,
                suppressCartageCarrier: true,
            },
            [XpoLtlUpdateShipmentStatusCd.RETURNED]: {
                deliveryQualifierCd: DeliveryQualifierCd.RETURNED,
                requiredFields: [{ field: UpdateShipmentStatusFormField.Date }, { field: UpdateShipmentStatusFormField.Reason }],
                reasonCds: [
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.DRIVER_RELATED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INSUFFICIENT_TIME_TO_COMPLETE_DELIVERY,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.MECHANICAL_BREAKDOWN,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.MISSED_DELIVERY,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.OTHER_CARRIER_RELATED_REASON,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.PACKAGE_MIS_SORTED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.PREVIOUS_STOP_CAUSED_DELAY,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.RETURN_SHIPPER_RELATED,
                ],
                reasonCdsTransformer: this.deliveryQualifierReasonCdPipe.transform.bind(this),
                suppressDriverCollect: true,
                suppressPiecesInfo: true,
                suppressSCAC: true,
                suppressShortPieces: true,
                suppressRecipientName: true,
                suppressTime: true,
                suppressCartageCarrier: true,
            },
            [XpoLtlUpdateShipmentStatusCd.ATTEMPTED]: {
                deliveryQualifierCd: DeliveryQualifierCd.ATTEMPTED,
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Reason },
                    { field: UpdateShipmentStatusFormField.ExceptionNote },
                ],
                reasonCds: [
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.RESIDENTIAL_NOT_HOME,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CLOSED_HOLIDAY,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CLOSED_INVENTORY,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMER_REQUEST_FUTURE_DELIVERY,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.ATTEMPT_CONSIGNEE_RELATED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.ATTEMPT_SHIPPER_RELATED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.RECIPIENT_UNAVAILABLE,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.IMPROPER_UNLOAD_EQUIPMENT,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CREDIT_HOLD,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMER_SHUTDOWN,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMER_STRIKE,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.COD_REQUIRED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CASH_NOT_AVAILABLE,
                ],
                reasonCdsTransformer: this.deliveryQualifierReasonCdPipe.transform.bind(this),
                suppressDriverCollect: true,
                suppressPiecesInfo: true,
                suppressSCAC: true,
                suppressShortPieces: true,
                suppressRecipientName: true,
                suppressTime: true,
                suppressCartageCarrier: true,
            },
            [XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED]: {
                deliveryQualifierCd: DeliveryQualifierCd.DAMAGED,
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Time },
                    { field: UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod },
                    { field: UpdateShipmentStatusFormField.ExceptionNote },
                ],
                suppressDriverCollect: true,
                suppressPiecesInfo: true,
                suppressReason: true,
                suppressSCAC: true,
                suppressShortPieces: true,
                suppressCartageCarrier: true,
            },
            [XpoLtlUpdateShipmentStatusCd.REFUSED]: {
                deliveryQualifierCd: DeliveryQualifierCd.REFUSED,
                reasonCds: [
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.UNAUTHORIZED_RETURN,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CONSIGNEE_REFUSED_COLLED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.ARRIVED_TOO_LATE,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.ORDER_CANCELLED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.DID_NOT_ORDER,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.WRONG_ORDER,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMER_WANTED_EARLIER,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.MANUFACTURERS_DEFECT,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.ARRIVED_TOO_EARLY,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.DUPLICATE_ORDER,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.SENT_TO_WRONG_LOCATION,
                ],
                reasonCdsTransformer: this.refusedReasonCdPipe.transform.bind(this),
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Time },
                    { field: UpdateShipmentStatusFormField.RecipientName },
                    { field: UpdateShipmentStatusFormField.Reason },
                ],
                suppressDriverCollect: true,
                suppressPiecesInfo: true,
                suppressSCAC: true,
                suppressShortPieces: true,
                suppressCartageCarrier: true,
            },
            [XpoLtlUpdateShipmentStatusCd.PART_SHORT]: {
                deliveryQualifierCd: DeliveryQualifierCd.PARTIAL_SHORT,
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Time },
                    { field: UpdateShipmentStatusFormField.ShortPieces },
                    { field: UpdateShipmentStatusFormField.ExceptionNote },
                    ...this.codRequiredFields,
                    ...this.driverCollectRequiredFields,
                ],
                suppressPiecesInfo: true,
                suppressReason: true,
                suppressCartageCarrier: true,
            },
            [XpoLtlUpdateShipmentStatusCd.PART_SHORT_WITH_EXCEPTIONS]: {
                deliveryQualifierCd: DeliveryQualifierCd.FINAL,
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Time },
                    ...this.codRequiredFields,
                    ...this.driverCollectRequiredFields,
                ],
                suppressExceptionNote: true,
                suppressPiecesInfo: true,
                suppressReason: true,
                suppressShortPieces: true,
                suppressCartageCarrier: true,
                defaultValues: {
                    [UpdateShipmentStatusFormField.SCACCode]: { value: 'PSZZ', disabled: true },
                },
            },
            [XpoLtlUpdateShipmentStatusCd.ALL_SHORT]: {
                deliveryQualifierCd: DeliveryQualifierCd.ALL_SHORT,
                suppressDriverCollect: true,
                suppressPiecesInfo: true,
                suppressReason: true,
                suppressRecipientName: true,
                suppressShortPieces: true,
                suppressCartageCarrier: true,
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Time },
                    { field: UpdateShipmentStatusFormField.ExceptionNote },
                ],
            },
            [XpoLtlUpdateShipmentStatusCd.ALL_SHORT_WITH_EXCEPTIONS]: {
                deliveryQualifierCd: DeliveryQualifierCd.FINAL,
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Time },
                    ...this.codRequiredFields,
                    ...this.driverCollectRequiredFields,
                ],
                suppressExceptionNote: true,
                suppressPiecesInfo: true,
                suppressReason: true,
                suppressShortPieces: true,
                suppressCartageCarrier: true,
                defaultValues: {
                    [UpdateShipmentStatusFormField.SCACCode]: { value: 'ASZZ', disabled: true },
                },
            },
            [XpoLtlUpdateShipmentStatusCd.TRAP]: {
                deliveryQualifierCd: DeliveryQualifierCd.TRAPPED,
                reasonCds: [
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.HELD_FOR_PROTECTIVE_SERVICE,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMER_REQUESTED_CONSOLIDATION,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.RECEIVING_TIMES_RESTRICTED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.DOCK_PICKUP,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.REQUIRES_LIFTGATE_FOR_DELIVERY,
                ],
                reasonCdsTransformer: this.deliveryQualifierReasonCdPipe.transform.bind(this),
                requiredFields: [{ field: UpdateShipmentStatusFormField.Date }, { field: UpdateShipmentStatusFormField.Reason }],
                suppressDriverCollect: true,
                suppressExceptionNote: true,
                suppressPiecesInfo: true,
                suppressRecipientName: true,
                suppressSCAC: true,
                suppressShortPieces: true,
                suppressTime: true,
                suppressCartageCarrier: true,
            },
            [XpoLtlUpdateShipmentStatusCd.UNDELIVERED]: {
                deliveryQualifierCd: DeliveryQualifierCd.UNDELIVERED,
                reasonCds: [
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CONSTRUCTION_SITE,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.NO_RSPNS_TO_ARRIVAL_NTFICTN,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CONS_IN_LABOR_DISPUTE,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CONS_NOT_FOUND_AT_ADDR_OR_PHON,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CONS_MOVED,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CREDIT_HOLD,
                    XpoLtlUpdateShipmentDeliveryQualifierReasonCd.SUSPENDED_AT_CUST_RQST,
                ],
                reasonCdsTransformer: this.undeliveredReasonCdPipe.transform.bind(this),
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Reason },
                    { field: UpdateShipmentStatusFormField.ExceptionNote },
                ],
                suppressPiecesInfo: true,
                suppressRecipientName: true,
                suppressSCAC: true,
                suppressShortPieces: true,
                suppressDriverCollect: true,
                suppressTime: true,
                suppressCartageCarrier: true,
            },
            [XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS]: {
                deliveryQualifierCd: DeliveryQualifierCd.OVER_SHPMT,
                suppressTime: true,
                suppressRecipientName: true,
                suppressSCAC: true,
                suppressDriverCollect: true,
                suppressReason: true,
                suppressPiecesInfo: true,
                suppressExceptionNote: true,
                suppressShortPieces: true,
                suppressCartageCarrier: true,
                requiredFields: [{ field: UpdateShipmentStatusFormField.Date }],
            },
            [XpoLtlUpdateShipmentStatusCd.CARTAGE]: {
                deliveryQualifierCd: DeliveryQualifierCd.CARTAGE,
                suppressRecipientName: true,
                suppressSCAC: true,
                suppressDriverCollect: true,
                suppressReason: true,
                suppressPiecesInfo: true,
                suppressShortPieces: true,
                suppressExceptionNote: true,
                requiredFields: [
                    { field: UpdateShipmentStatusFormField.Date },
                    { field: UpdateShipmentStatusFormField.Time },
                    { field: UpdateShipmentStatusFormField.CartageCarrier },
                    { field: UpdateShipmentStatusFormField.CartageSIC },
                ],
            },
        };
        this.availableStatusesForDeliveryQualifierCd = {
            [DeliveryQualifierCd.APPT]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.ATTEMPTED,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.ATTEMPTED]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.HOLD_FOR_CUSTOMS]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.OVER_SHPMT]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
            ],
            [DeliveryQualifierCd.PARTIAL_SHORT]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT_WITH_EXCEPTIONS,
            ],
            [DeliveryQualifierCd.DAMAGED]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.REFUSED]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.RETURNED]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.ATTEMPTED,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.ALL_SHORT]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.CARTAGE]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ATTEMPTED,
                XpoLtlUpdateShipmentStatusCd.RETURNED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.TRAPPED]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.ATTEMPTED,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.TRANSFER]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.ATTEMPTED,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.UNDELIVERED]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
            [DeliveryQualifierCd.OVER_SHPMT]: [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
            ],
            [DeliveryQualifierCd.NOT_APPLICABLE]: [
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.ATTEMPTED,
                XpoLtlUpdateShipmentStatusCd.CARTAGE,
                XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                XpoLtlUpdateShipmentStatusCd.PART_SHORT,
                XpoLtlUpdateShipmentStatusCd.REFUSED,
                XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
                XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
                XpoLtlUpdateShipmentStatusCd.TRAP,
                XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            ],
        };
    }
    getUpdateShipmentStatusCdForQualifierCd(deliveryQualifierCd) {
        return this.availableStatusesForDeliveryQualifierCd[deliveryQualifierCd];
    }
    containsSpecialServiceCd(id, specialServiceCd) {
        var _a;
        return !!((_a = id === null || id === void 0 ? void 0 : id.specialServiceCds) === null || _a === void 0 ? void 0 : _a.includes(specialServiceCd));
    }
    isFreightChargeable(id) {
        return this.containsSpecialServiceCd(id, ShipmentSpecialServiceCd.DRIVER_COLLECT);
    }
    isCOD(id) {
        return !!id.codInd;
    }
    isCheckNbrRequired(_, paymentMethodFieldName, nextValues) {
        const methodCd = nextValues[paymentMethodFieldName];
        return methodCd && [MiscLineItemPaymentMethodCd.CUSTOMER_CHECK].indexOf(methodCd) < 0;
    }
    isAmountRequired(_, paymentMethodFieldName, nextValues) {
        const methodCd = nextValues[paymentMethodFieldName];
        return (methodCd &&
            [MiscLineItemPaymentMethodCd.CERTIFIED_FUND, MiscLineItemPaymentMethodCd.CUSTOMER_CHECK].indexOf(methodCd) > -1
            && [MiscLineItemPaymentMethodCd.DEMAND_DRAFT].indexOf(methodCd) < 0);
    }
}
UpdateShipmentStatusDisplayConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusDisplayConfigService, deps: [{ token: UpdateShipmentStatusDeliveryQualifierReasonCdPipe }], target: i0.ɵɵFactoryTarget.Injectable });
UpdateShipmentStatusDisplayConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusDisplayConfigService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusDisplayConfigService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: UpdateShipmentStatusDeliveryQualifierReasonCdPipe }]; } });

function XpoLtlSicValidatorFunction(xpoLtlServiceCentersService) {
    return (control) => {
        if (!control || !control.value || control.value.length < 3) {
            return of(null);
        }
        return isSicValidFunction(control.value, xpoLtlServiceCentersService).pipe(first$1(), map((isValid) => (isValid ? null : { invalidLocation: true })), tap(() => control.markAsTouched()));
    };
}
function isSicValidFunction(sicCd, xpoLtlServiceCentersService) {
    return !sicCd || sicCd.length !== 3
        ? of(false)
        : xpoLtlServiceCentersService.getSicByCd$(sicCd).pipe(first$1(), map((response) => {
            return !!response;
        }, (errors) => {
            return false;
        }));
}

function phoneValidator(countryCd) {
    return (control) => {
        if (!control || !control.value) {
            return null;
        }
        const phoneNumber = parsePhoneNumberFromString(control.value, 'US');
        const isValidCountryCode = !countryCd || (phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.country) === countryCd;
        return !phoneNumber || !phoneNumber.isValid() || !isValidCountryCode ? { invalidPhone: true } : undefined;
    };
}

function currencyAmountRequiredValidator(paymentMethodFieldName) {
    return (control) => {
        var _a;
        if (!control || !control.parent) {
            return null;
        }
        const paymentMethodCtrl = (_a = control.parent) === null || _a === void 0 ? void 0 : _a.get(paymentMethodFieldName);
        const isCertifiedFund = (paymentMethodCtrl === null || paymentMethodCtrl === void 0 ? void 0 : paymentMethodCtrl.value) === MiscLineItemPaymentMethodCd.CERTIFIED_FUND;
        const isCompanyCheck = (paymentMethodCtrl === null || paymentMethodCtrl === void 0 ? void 0 : paymentMethodCtrl.value) === MiscLineItemPaymentMethodCd.COMPANY_CHECK;
        const isCustomerCheck = (paymentMethodCtrl === null || paymentMethodCtrl === void 0 ? void 0 : paymentMethodCtrl.value) === MiscLineItemPaymentMethodCd.CUSTOMER_CHECK;
        const isMoneyOrder = (paymentMethodCtrl === null || paymentMethodCtrl === void 0 ? void 0 : paymentMethodCtrl.value) === MiscLineItemPaymentMethodCd.MONEY_ORDER;
        return (isCertifiedFund || isCompanyCheck || isCustomerCheck || isMoneyOrder) &&
            (!control.value || control.value === '0.00')
            ? { amountRequired: true }
            : null;
    };
}

var FinalWithExceptionSubQualifierCodes;
(function (FinalWithExceptionSubQualifierCodes) {
    FinalWithExceptionSubQualifierCodes["ACCEPTED"] = "Accepted";
    FinalWithExceptionSubQualifierCodes["ACCEPTED_DAMAGED"] = "AcceptedDamaged";
    FinalWithExceptionSubQualifierCodes["REFUSED"] = "Refused";
    FinalWithExceptionSubQualifierCodes["REFUSED_DAMAGED"] = "ReturnedDamaged";
    FinalWithExceptionSubQualifierCodes["SHORT"] = "PartialShort";
    FinalWithExceptionSubQualifierCodes["RETURN"] = "Return";
    FinalWithExceptionSubQualifierCodes["ATTEMPTED"] = "Attempted";
    FinalWithExceptionSubQualifierCodes["FINAL"] = "Final";
})(FinalWithExceptionSubQualifierCodes || (FinalWithExceptionSubQualifierCodes = {}));

class UpdateShipmentStatusFormService {
    constructor(formBuilder, configService) {
        this.formBuilder = formBuilder;
        this.configService = configService;
        this.DeliveryQualifierCodes = [
            { code: XpoLtlUpdateShipmentStatusCd.FINAL, description: 'Final' },
            { code: XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS, description: 'Final w/ Exception' },
            { code: XpoLtlUpdateShipmentStatusCd.PART_SHORT, description: 'Part Short' },
            { code: XpoLtlUpdateShipmentStatusCd.REFUSED, description: 'Refused' },
            { code: XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED, description: 'Returned Damaged' },
            { code: XpoLtlUpdateShipmentStatusCd.RETURNED, description: 'Return' },
            { code: XpoLtlUpdateShipmentStatusCd.ATTEMPTED, description: 'Attempt' },
            { code: XpoLtlUpdateShipmentStatusCd.ALL_SHORT, description: 'All Short' },
            { code: XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS, description: 'Hold for Customs' },
            { code: XpoLtlUpdateShipmentStatusCd.TRAP, description: 'Trap' },
            { code: XpoLtlUpdateShipmentStatusCd.UNDELIVERED, description: 'Undelivered' },
            { code: XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS, description: 'Over w/ billed shipments' },
        ];
        this.FinalWithExceptionSubQualifierCodes = [
            { code: FinalWithExceptionSubQualifierCodes.ACCEPTED, description: 'Accepted' },
            { code: FinalWithExceptionSubQualifierCodes.ACCEPTED_DAMAGED, description: 'Accepted Damaged' },
            { code: FinalWithExceptionSubQualifierCodes.REFUSED, description: 'Refused' },
            { code: FinalWithExceptionSubQualifierCodes.REFUSED_DAMAGED, description: 'Returned Damaged' },
            { code: FinalWithExceptionSubQualifierCodes.SHORT, description: 'Short' },
        ];
        this.ChildSubQualifierCodes = [
            { code: XpoLtlUpdateShipmentStatusCd.REFUSED, description: 'Refused' },
            { code: XpoLtlUpdateShipmentStatusCd.CARTAGE, description: 'Cartage' },
            { code: XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED, description: 'Returned Damaged' },
            { code: XpoLtlUpdateShipmentStatusCd.RETURNED, description: 'Return' },
            { code: XpoLtlUpdateShipmentStatusCd.ATTEMPTED, description: 'Attempt' },
            { code: XpoLtlUpdateShipmentStatusCd.ALL_SHORT, description: 'Short' },
            { code: XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS, description: 'Hold for Customs' },
            { code: XpoLtlUpdateShipmentStatusCd.TRAP, description: 'Trap' },
            { code: XpoLtlUpdateShipmentStatusCd.UNDELIVERED, description: 'Undelivered' },
            { code: XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS, description: 'Over w/ billed ship' },
        ];
        this.defaultShipmentStatusFormRowValue = {
            [UpdateShipmentStatusFormField.ID]: undefined,
            [UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr]: undefined,
            [UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount]: 0,
            [UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod]: undefined,
            [UpdateShipmentStatusFormField.DamagedButAccepted]: undefined,
            [UpdateShipmentStatusFormField.Date]: new Date(),
            [UpdateShipmentStatusFormField.DeliveryQualifierCd]: undefined,
            [UpdateShipmentStatusFormField.ExceptionNote]: undefined,
            [UpdateShipmentStatusFormField.FreightChargesCheckNbr]: undefined,
            [UpdateShipmentStatusFormField.FreightChargesDollarAmount]: 0,
            [UpdateShipmentStatusFormField.FreightChargesPaymentMethod]: undefined,
            [UpdateShipmentStatusFormField.OverButAccepted]: undefined,
            [UpdateShipmentStatusFormField.PartialRefused]: undefined,
            [UpdateShipmentStatusFormField.Reason]: undefined,
            [UpdateShipmentStatusFormField.RecipientName]: undefined,
            [UpdateShipmentStatusFormField.SCACCode]: undefined,
            [UpdateShipmentStatusFormField.ShortPieces]: undefined,
            [UpdateShipmentStatusFormField.StatusCd]: undefined,
            [UpdateShipmentStatusFormField.Time]: undefined,
        };
    }
    createForm(shipmentIds) {
        const formGroup = this.formBuilder.group({
            [UpdateShipmentStatusFormField.ReportingSic]: '',
            [UpdateShipmentsStatusFormField.Shipments]: this.formBuilder.array([]),
        });
        shipmentIds === null || shipmentIds === void 0 ? void 0 : shipmentIds.forEach((id) => {
            const shipmentFormGroup = this.createUpdateShipmentStatusForm(id);
            formGroup.get(UpdateShipmentsStatusFormField.Shipments).push(shipmentFormGroup);
        });
        return formGroup;
    }
    createUpdateShipmentStatusForm(id) {
        var _a;
        let form;
        const getDynamicRequiredValidator = (field) => {
            return XpoLtlDynamicValidator(() => {
                var _a;
                const statusCd = form === null || form === void 0 ? void 0 : form.get(UpdateShipmentStatusFormField.StatusCd).value;
                const currentStatusConfig = this.configService.updateShipmentStatusCdDisplayConfig[statusCd];
                const requiredFieldConfig = (_a = currentStatusConfig === null || currentStatusConfig === void 0 ? void 0 : currentStatusConfig.requiredFields) === null || _a === void 0 ? void 0 : _a.find((f) => f.field === field);
                return (requiredFieldConfig &&
                    (!requiredFieldConfig.requiredFn || requiredFieldConfig.requiredFn(id, form.getRawValue())));
            }, Validators.required);
        };
        form = this.formBuilder.group({
            [UpdateShipmentStatusFormField.ID]: id.shipmentInstId,
            [UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr), Validators.maxLength(8)],
            ],
            [UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount],
                [
                    currencyAmountRequiredValidator(UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod),
                    getDynamicRequiredValidator(UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount),
                ],
            ],
            [UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod)],
            ],
            [UpdateShipmentStatusFormField.DamagedButAccepted]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.DamagedButAccepted],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.DamagedButAccepted)],
            ],
            [UpdateShipmentStatusFormField.Date]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.Date],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.Date)],
            ],
            [UpdateShipmentStatusFormField.DeliveryQualifierCd]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.DeliveryQualifierCd],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.DeliveryQualifierCd)],
            ],
            [UpdateShipmentStatusFormField.ExceptionNote]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.ExceptionNote],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.ExceptionNote)],
            ],
            [UpdateShipmentStatusFormField.FreightChargesCheckNbr]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.FreightChargesCheckNbr],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.FreightChargesCheckNbr), Validators.maxLength(8)],
            ],
            [UpdateShipmentStatusFormField.FreightChargesDollarAmount]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.FreightChargesDollarAmount],
                [
                    // TODO: temp commenting out to rely on backend validations for payment info
                    currencyAmountRequiredValidator(UpdateShipmentStatusFormField.FreightChargesPaymentMethod),
                    getDynamicRequiredValidator(UpdateShipmentStatusFormField.FreightChargesDollarAmount),
                ],
            ],
            [UpdateShipmentStatusFormField.FreightChargesPaymentMethod]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.FreightChargesPaymentMethod],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.FreightChargesPaymentMethod)],
            ],
            [UpdateShipmentStatusFormField.OverButAccepted]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.OverButAccepted],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.OverButAccepted)],
            ],
            [UpdateShipmentStatusFormField.PartialRefused]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.PartialRefused],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.PartialRefused)],
            ],
            [UpdateShipmentStatusFormField.Reason]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.Reason],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.Reason)],
            ],
            [UpdateShipmentStatusFormField.CartageCarrier]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.CartageCarrier],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.CartageCarrier)],
            ],
            [UpdateShipmentStatusFormField.CartageSIC]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.CartageSIC],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.CartageSIC)],
            ],
            [UpdateShipmentStatusFormField.RecipientName]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.RecipientName],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.RecipientName)],
            ],
            [UpdateShipmentStatusFormField.SCACCode]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.SCACCode],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.SCACCode), Validators.pattern('.{2,4}')],
            ],
            [UpdateShipmentStatusFormField.ShortPieces]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.ShortPieces],
                [getDynamicRequiredValidator(UpdateShipmentStatusFormField.ShortPieces)],
            ],
            [UpdateShipmentStatusFormField.StatusCd]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.StatusCd],
                Validators.required,
            ],
            [UpdateShipmentStatusFormField.Time]: [
                this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.Time],
                [
                    getDynamicRequiredValidator(UpdateShipmentStatusFormField.Time),
                    Validators.pattern('(([0-2][0-3])|([0-1][0-9]))(:?)([0-5][0-9])'),
                ],
            ],
            [UpdateShipmentStatusFormField.PLT]: new FormArray([
                ...(_a = id === null || id === void 0 ? void 0 : id.handlingUnits) === null || _a === void 0 ? void 0 : _a.map((pltShipmentData) => this.formBuilder.group(this.buildPLTShipment(pltShipmentData))),
            ]),
        });
        return form;
    }
    buildPLTShipment(pltShipmentData) {
        const formattedPro = `${pltShipmentData.childProNbr.substring(1, 5)}-${pltShipmentData.childProNbr.substring(5)}`;
        return {
            [UpdateShipmentStatusFormField.PLT_PRO]: formattedPro,
            [UpdateShipmentStatusFormField.PLT_SHIPMENT_INST_ID]: pltShipmentData.shipmentInstanceId,
            [UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE]: this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.DeliveryQualifierCd],
            [UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE_READONLY]: this.defaultShipmentStatusFormRowValue[UpdateShipmentStatusFormField.DeliveryQualifierCd],
            [UpdateShipmentStatusFormField.PLT_TYPE]: pltShipmentData.typeCd,
            [UpdateShipmentStatusFormField.PLT_MM]: 0,
            [UpdateShipmentStatusFormField.PLT_LP]: 0,
            [UpdateShipmentStatusFormField.PLT_LENGTH]: pltShipmentData.lengthNbr,
            [UpdateShipmentStatusFormField.PLT_WIDTH]: pltShipmentData.widthNbr,
            [UpdateShipmentStatusFormField.PLT_HEIGHT]: pltShipmentData.heightNbr,
        };
    }
    getDefaultFormValue() {
        return this.defaultShipmentStatusFormRowValue;
    }
}
UpdateShipmentStatusFormService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusFormService, deps: [{ token: i2$2.FormBuilder }, { token: UpdateShipmentStatusDisplayConfigService }], target: i0.ɵɵFactoryTarget.Injectable });
UpdateShipmentStatusFormService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusFormService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusFormService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2$2.FormBuilder }, { type: UpdateShipmentStatusDisplayConfigService }]; } });

class UpdateShipmentDeliveryQualifierReasonCdTransformer {
    constructor() {
        this.deliveryQualifierReasonCdMap = {
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.ATTEMPT_CONSIGNEE_RELATED]: '5',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.ATTEMPT_SHIPPER_RELATED]: '6',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.BROKER_CLOSED]: '5',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CASH_NOT_AVAILABLE]: 'D',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CLIENT_CLEAR]: '7',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CLIENT_CREDIT]: 'A',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CLOSED_HOLIDAY]: '2',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CLOSED_INVENTORY]: '3',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.COD_REQUIRED]: 'C',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CREDIT_HOLD]: '9',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMER_REQUESTED_CONSOLIDATION]: '2',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMER_REQUEST_FUTURE_DELIVERY]: '4',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMER_SHUTDOWN]: 'A',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMER_STRIKE]: 'B',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMS_IMPORT_EXPORT]: 'C',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.DRIVER_RELATED]: '1',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.FAILED_PARS]: '1',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.FINAL_CONSIGNEE_RELATED]: '5',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.FINAL_SHIPPER_RELATED]: '6',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.GOVERNMENT_DOCS_REQUIRED]: '8',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.HELD_FOR_PROTECTIVE_SERVICE]: '1',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.IMPROPER_UNLOAD_EQUIPMENT]: '8',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INCORRECT_BROKER]: '4',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INFO_MISSING]: '6',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INSUFFICIENT_DELIVERY_TIME]: 'E',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INSUFFICIENT_TIME_TO_COMPLETE_DELIVERY]: '2',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INT_NON_CARRIER_DELIVERY]: 'D',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.MECHANICAL_BREAKDOWN]: '3',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.MISSED_DELIVERY]: '4',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.NO_BROKER]: '3',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.OTHER]: 'Z',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.OTHER_CARRIER_RELATED_REASON]: '5',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.PACKAGE_MIS_SORTED]: '6',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.PAPERWORK_ISSUE]: '2',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.PREVIOUS_STOP_CAUSED_DELAY]: '7',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.RECEIVING_TIMES_RESTRICTED]: '3',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.RECIPIENT_UNAVAILABLE]: '7',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.RESIDENTIAL_NOT_HOME]: '1',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.RETURN_SHIPPER_RELATED]: '8',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.WAITING_INSPECTION]: 'E',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.WRONG_PRO]: '9',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.XPO_RELATED]: '2',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.DOCK_PICKUP]: '6',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.REQUIRES_LIFTGATE_FOR_DELIVERY]: '5',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.ARRIVED_TOO_LATE]: '3',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CONSIGNEE_REFUSED_COLLED]: '2',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CUSTOMER_WANTED_EARLIER]: '7',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.DID_NOT_ORDER]: '5',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.ARRIVED_TOO_EARLY]: 'A',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.DUPLICATE_ORDER]: 'B',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.SENT_TO_WRONG_LOCATION]: 'C',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INSUFFICIENT_DELIVERY_TIME]: '8',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.MANUFACTURERS_DEFECT]: '9',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.ORDER_CANCELLED]: '4',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.OTHER]: 'Z',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.UNAUTHORIZED_RETURN]: '1',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.WRONG_ORDER]: '6',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CONSTRUCTION_SITE]: '1',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CONS_IN_LABOR_DISPUTE]: '3',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CONS_MOVED]: '5',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CONS_NOT_FOUND_AT_ADDR_OR_PHON]: '4',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.CREDIT_HOLD]: '6',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.INSUFFICIENT_DLVRY_TM]: '9',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.NO_RSPNS_TO_ARRIVAL_NTFICTN]: '2',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.OTHER]: 'Z',
            [XpoLtlUpdateShipmentDeliveryQualifierReasonCd.SUSPENDED_AT_CUST_RQST]: '7',
        };
    }
}

class UpdateShipmentStatusService {
    constructor(shipmentApiService, updateShipmentConfigService, cityOperationsApiService, loggedInUserService, conditioningService, configManagerService, carrierManagementService, xpoLtlTimeService) {
        this.shipmentApiService = shipmentApiService;
        this.updateShipmentConfigService = updateShipmentConfigService;
        this.cityOperationsApiService = cityOperationsApiService;
        this.loggedInUserService = loggedInUserService;
        this.conditioningService = conditioningService;
        this.configManagerService = configManagerService;
        this.carrierManagementService = carrierManagementService;
        this.xpoLtlTimeService = xpoLtlTimeService;
        this.isLoadingSubject = new BehaviorSubject(false);
        this.isLoading$ = this.isLoadingSubject.asObservable();
        this.shipmentsSubject = new BehaviorSubject([]);
        this.shipments$ = this.shipmentsSubject.asObservable();
    }
    loadCarriers(sic) {
        return this.carrierManagementService
            .listCarriers(Object.assign(Object.assign({}, new ListCarriersQuery()), { sicCd: sic, carrierDetailCds: [CarrierDetailCd.CARRIERS, CarrierDetailCd.LOCATION_SIC, CarrierDetailCd.LOCATIONS] }))
            .pipe(map((carrier) => carrier.carrierMasterLocations.map((masterLocation) => ({
            code: masterLocation.carrierMaster.carrierId,
            text: masterLocation.carrierMaster.carrierName,
        }))));
    }
    loadShipments$(shipmentIds) {
        if (!(shipmentIds === null || shipmentIds === void 0 ? void 0 : shipmentIds.length)) {
            return throwError('A valid shipment id is requred.');
        }
        this.isLoadingSubject.next(true);
        const unpurgedShipmentsRequest = Object.assign(Object.assign({}, new SearchUnpurgedShipmentsRqst()), { pageNumber: 1, pageSize: 10000, filter: Object.assign(Object.assign({}, new DeliveryShipmentSearchFilter()), { shipmentInstId: Object.assign(Object.assign({}, new XrtAttributeFilter()), { values: shipmentIds.map((id) => id.shipmentInstId) }) }) });
        return this.cityOperationsApiService
            .searchUnpurgedShipments(unpurgedShipmentsRequest, { loadingOverlayEnabled: false })
            .pipe(switchMap((resp) => {
            var _a;
            const requests$ = (_a = resp.result.reduce((requests, record) => {
                const queryShipmentId = record.shipmentInstId ? +record.shipmentInstId : undefined;
                const queryParams = Object.assign(Object.assign({}, new GetShipmentQuery()), { shipmentInstId: queryShipmentId, shipmentDetailCd: [
                        // will return shipment object, matched parties, and child handling units
                        ShipmentDetailCd.HANDLING_UNIT,
                    ] });
                const request$ = this.shipmentApiService
                    .getShipment(queryParams, { loadingOverlayEnabled: false })
                    .pipe(catchError(() => {
                    return of(new GetShipmentResp());
                }), map((shipmentResp) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                    const { handlingUnits } = shipmentResp;
                    const { consignee } = record;
                    const shipmentIdentifier = {
                        proNbr: record.proNbr,
                        billInd: record.billInd,
                        shipmentInstId: record.shipmentInstId,
                        pickupDate: moment$3(record.pickupDt).toDate(),
                        deliveryQualifierCd: record.deliveryQualifierCd,
                        deliveryInfoRequired: ((_a = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _a === void 0 ? void 0 : _a.deliveryInformationRqdCd) === DeliveryInfoRequiredCd.RQRD,
                        specialServiceCds: (_c = (_b = record.specialServiceSummary) === null || _b === void 0 ? void 0 : _b.map((serviceSummary) => serviceSummary.specialService)) !== null && _c !== void 0 ? _c : [],
                        motorMovesNbr: record.motorizedPiecesCount,
                        loosePiecesCount: record.loosePcsCnt,
                        totalPiecesCount: record.totalPiecesCount,
                        totalWeightLbs: record.totalWeightLbs,
                        codInd: (_d = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _d === void 0 ? void 0 : _d.codInd,
                        customerName: `${(_e = consignee === null || consignee === void 0 ? void 0 : consignee.name1) !== null && _e !== void 0 ? _e : ''} ${(_f = consignee === null || consignee === void 0 ? void 0 : consignee.name2) !== null && _f !== void 0 ? _f : ''}`.trim(),
                        customerAddress: `${(_g = consignee === null || consignee === void 0 ? void 0 : consignee.addressLine1) !== null && _g !== void 0 ? _g : ''} ${(_h = consignee === null || consignee === void 0 ? void 0 : consignee.addressLine2) !== null && _h !== void 0 ? _h : ''}`.trim(),
                        customerCity: consignee === null || consignee === void 0 ? void 0 : consignee.cityName,
                        customerState: consignee === null || consignee === void 0 ? void 0 : consignee.stateCd,
                        customerZip: `${(_j = consignee === null || consignee === void 0 ? void 0 : consignee.postalCd) !== null && _j !== void 0 ? _j : ''}${(consignee === null || consignee === void 0 ? void 0 : consignee.zip4RestUs) ? '-' : ''}${(_k = consignee === null || consignee === void 0 ? void 0 : consignee.zip4RestUs) !== null && _k !== void 0 ? _k : ''}`.trim(),
                        customerMadCd: consignee === null || consignee === void 0 ? void 0 : consignee.acctMadCd,
                        customerId: consignee === null || consignee === void 0 ? void 0 : consignee.acctInstId,
                        handlingUnits: handlingUnits !== null && handlingUnits !== void 0 ? handlingUnits : [],
                        routeInstId: record.routeInstId,
                        deliveryInformationRqdCd: (_l = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _l === void 0 ? void 0 : _l.deliveryInformationRqdCd,
                        sic: ((_m = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _m === void 0 ? void 0 : _m.currentSicCd) || ((_o = shipmentResp === null || shipmentResp === void 0 ? void 0 : shipmentResp.shipment) === null || _o === void 0 ? void 0 : _o.destinationTerminalSicCd),
                    };
                    return shipmentIdentifier;
                }));
                requests.push(request$);
                return requests;
            }, [])) !== null && _a !== void 0 ? _a : [];
            return forkJoin(requests$);
        }), map((shipments) => {
            // TODO: Order returned shipments in same order as input array
            return shipments.filter((r) => !!r);
        }), tap((shipments) => {
            this.shipmentsSubject.next(shipments);
        }), finalize(() => {
            this.isLoadingSubject.next(false);
        }));
    }
    updateShipmentStatuses$(updatedShipmentItems, reportingSicCd, onConfirmChildPro) {
        const getDeliveryInfo = (amt, mthd, check) => {
            const sanitizedAmt = `${amt}`.replace(/\,/g, '');
            const amount = amt && amt !== `0.00` ? +sanitizedAmt : 0;
            const method = mthd;
            const checkNbr = check ? `${check}` : undefined;
            return { amount, method, checkNbr };
        };
        this.isLoadingSubject.next(true);
        return this.getLoggedInUser$().pipe(withLatestFrom(this.shipments$), switchMap(([user, shipmentIds]) => {
            return this.xpoLtlTimeService.timezoneForSicCd$(reportingSicCd).pipe(map((timezone) => {
                return [user, shipmentIds, timezone];
            }));
        }), switchMap(([user, shipmentIds, timezone]) => {
            const requests$ = updatedShipmentItems.reduce((requestArr, shipment) => {
                var _a;
                const shipmentInstId = +shipment[UpdateShipmentStatusFormField.ID];
                const shipmentId = shipmentIds.find((id) => id.shipmentInstId === shipmentInstId);
                const updateShipmentStatusCd = shipment[UpdateShipmentStatusFormField.StatusCd];
                const config = this.updateShipmentConfigService.updateShipmentStatusCdDisplayConfig[updateShipmentStatusCd];
                const movementDateTime = moment$3(shipment[UpdateShipmentStatusFormField.Date]).tz(timezone);
                const time = shipment[UpdateShipmentStatusFormField.Time];
                const reasonCd = shipment[UpdateShipmentStatusFormField.Reason];
                const scacCode = shipment[UpdateShipmentStatusFormField.SCACCode];
                const deliveryQualifierCd = shipment[UpdateShipmentStatusFormField.DeliveryQualifierCd];
                const exceptionNote = shipment[UpdateShipmentStatusFormField.ExceptionNote];
                let forceCodInd;
                let forceCollectInd = false;
                let qualifierReasonCd;
                if (reasonCd) {
                    const transformer = new UpdateShipmentDeliveryQualifierReasonCdTransformer();
                    qualifierReasonCd = transformer.deliveryQualifierReasonCdMap[reasonCd];
                }
                const codInfo = getDeliveryInfo(shipment[UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount], shipment[UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod], shipment[UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr]);
                const freightInfo = getDeliveryInfo(shipment[UpdateShipmentStatusFormField.FreightChargesDollarAmount], shipment[UpdateShipmentStatusFormField.FreightChargesPaymentMethod], shipment[UpdateShipmentStatusFormField.FreightChargesCheckNbr]);
                // if time input, set to input time, otherwise, adjust hours/minutes/seconds to current time
                if (!config.suppressTime) {
                    const timeValues = time.split(':');
                    movementDateTime.hours(+timeValues[0]);
                    movementDateTime.minutes(+timeValues[1]);
                    movementDateTime.seconds(0);
                    movementDateTime.milliseconds(0);
                }
                else {
                    const now = moment$3().tz(timezone);
                    // if the date is today, set to update time hours/min/sec, else set to end of day
                    if (now.isSame(movementDateTime, 'day')) {
                        movementDateTime.hours(now.hours());
                        movementDateTime.minutes(now.minutes());
                        movementDateTime.seconds(now.seconds());
                        movementDateTime.milliseconds(0);
                    }
                    else {
                        movementDateTime.hours(23);
                        movementDateTime.minutes(59);
                        movementDateTime.seconds(59);
                        movementDateTime.milliseconds(0);
                    }
                }
                forceCodInd = !!codInfo.amount;
                const forceCollectSCACCodes = scacCode && ['CNWY', 'ASZZ', 'PSZZ'].every((cd) => cd !== (scacCode === null || scacCode === void 0 ? void 0 : scacCode.toUpperCase()));
                const freightChargesRequired = this.updateShipmentConfigService.containsSpecialServiceCd(shipmentId, ShipmentSpecialServiceCd.DRIVER_COLLECT);
                if (freightChargesRequired && !!freightInfo.amount) {
                    forceCollectInd = true;
                }
                else if (freightChargesRequired && !freightInfo.amount && forceCollectSCACCodes) {
                    forceCollectInd = true;
                }
                const handlingUnits = [];
                if (shipment[UpdateShipmentStatusFormField.PLT].length > 0) {
                    for (const unit of shipment[UpdateShipmentStatusFormField.PLT]) {
                        handlingUnits.push(Object.assign(Object.assign({}, new DeliveryHandlingUnit()), { handlingUnit: Object.assign(Object.assign({}, new HandlingUnit()), { childProNbr: this.conditioningService.conditionChildProNumber(unit.plt_pro), shipmentInstanceId: unit.plt_shipmentInstId, lengthNbr: unit.plt_length, widthNbr: unit.plt_width, heightNbr: unit.plt_height, typeCd: unit.plt_type }), qualifierReasonCd: qualifierReasonCd, refusedInd: this.toDeliveryRefusedInd(deliveryQualifierCd, unit.plt_deliveryQualifierCode), damagedInd: this.toDeliveryDamagedInd(deliveryQualifierCd, unit.plt_deliveryQualifierCode), shortInd: this.toDeliveryShortInd(deliveryQualifierCd, unit.plt_deliveryQualifierCode), exceptionNote: exceptionNote, bypassScanInd: true, bypassScanReason: 'Edge Complete' }));
                    }
                }
                const change = Object.assign(Object.assign({}, new DeliveryQualifierShipmentStatusChange()), { shipmentInstId: shipmentInstId, deliveryQualifierCd: deliveryQualifierCd, reportingSicCd: reportingSicCd !== '' ? reportingSicCd : user.sicCode, deliverySignedName: shipment[UpdateShipmentStatusFormField.RecipientName], deliverySignedDateTime: shipment[UpdateShipmentStatusFormField.RecipientName]
                        ? movementDateTime.toDate()
                        : undefined, codPaymentAmount: codInfo.amount, codPaymentMethodCd: codInfo.method, codPaymentCheckNbr: codInfo.checkNbr, freightPaymentAmount: freightInfo.amount, freightPaymentMethodCd: freightInfo.method, freightPaymentCheckNbr: freightInfo.checkNbr, movementDateTime: movementDateTime.toDate(), carrierScac: shipment[UpdateShipmentStatusFormField.SCACCode], qualifierReasonCd: qualifierReasonCd, piecesShortCount: shipment[UpdateShipmentStatusFormField.ShortPieces], piecesOverCount: shipment[UpdateShipmentStatusFormField.OverButAccepted], piecesDamagedCount: shipment[UpdateShipmentStatusFormField.DamagedButAccepted], piecesRefusedCount: shipment[UpdateShipmentStatusFormField.PartialRefused], exceptionNote: exceptionNote, trackWithHandlingUnitsInd: false, forceLocationInd: true, forceCollectInd: forceCollectInd, forceCodInd: forceCodInd, deliveryHandlingUnits: handlingUnits, carrierId: (_a = shipment[UpdateShipmentStatusFormField.CartageCarrier]) === null || _a === void 0 ? void 0 : _a.code });
                const rqst = Object.assign(Object.assign({}, new UpdatePnDDeliveryStatusForShipmentsRqst()), { dateOverrideInd: true, overrideAllSoftErrorsInd: true, deliveryQualifierShipmentStatusChanges: [change], overrideChildProCountDiscrepancyInd: !!onConfirmChildPro });
                const updateStatusRequest$ = this.cityOperationsApiService
                    .updatePnDDeliveryStatusForShipments(rqst, { loadingOverlayEnabled: false })
                    .pipe(map((res) => {
                    const softWarnings = res === null || res === void 0 ? void 0 : res.softErrorWarnings[0];
                    const softMessage = softWarnings ? softWarnings.message : '';
                    return {
                        shipmentInstId: change.shipmentInstId,
                        softMessage,
                    };
                }), catchError((err) => {
                    var _a, _b, _c, _d;
                    let errorMessage = (_b = (_a = err === null || err === void 0 ? void 0 : err.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : '';
                    if (+(err === null || err === void 0 ? void 0 : err.code) !== 500) {
                        (_d = (_c = err === null || err === void 0 ? void 0 : err.error) === null || _c === void 0 ? void 0 : _c.moreInfo) === null || _d === void 0 ? void 0 : _d.forEach((errInfo) => {
                            var _a;
                            errorMessage += ` ${(_a = errInfo.message) !== null && _a !== void 0 ? _a : ''}`;
                        });
                    }
                    return of({
                        shipmentInstId: change.shipmentInstId,
                        error: errorMessage,
                    });
                }));
                if (deliveryQualifierCd === DeliveryQualifierCd.FINAL && !exceptionNote) {
                    requestArr.finalDeliveredStatus.push(updateStatusRequest$);
                }
                else {
                    requestArr.exceptionStatus.push(updateStatusRequest$);
                }
                return requestArr;
            }, { finalDeliveredStatus: [], exceptionStatus: [] });
            let updateRequests$;
            if (!!requests$.finalDeliveredStatus.length) {
                updateRequests$ = forkJoin(requests$.finalDeliveredStatus).pipe(delay(100), switchMap((resp) => {
                    var _a;
                    const respObsMap$ = (_a = resp === null || resp === void 0 ? void 0 : resp.map((res) => of(res))) !== null && _a !== void 0 ? _a : [];
                    return concat(...respObsMap$, ...requests$.exceptionStatus);
                }));
            }
            else {
                updateRequests$ = concat(...requests$.exceptionStatus);
            }
            return updateRequests$.pipe(toArray(), map((respArr) => {
                return respArr.reduce((changes, res) => {
                    if (res) {
                        if ('error' in res) {
                            changes.errors.push(res);
                        }
                        else {
                            changes.success.push(res);
                        }
                    }
                    return changes;
                }, { success: [], errors: [] });
            }), finalize(() => {
                this.isLoadingSubject.next(false);
            }));
        }));
    }
    getLoggedInUser$() {
        return this.loggedInUserService.getLoggedInUser(this.configManagerService.getSetting(ConfigManagerProperties$1.loggedInUserRoot));
    }
    removeShipment(shipmentInstId) {
        const updatedShipments = this.shipmentsSubject.value.filter((shipmentIdentifier) => shipmentIdentifier.shipmentInstId !== shipmentInstId);
        this.shipmentsSubject.next(updatedShipments);
    }
    toDeliveryQualiferCd(code) {
        switch (code) {
            case XpoLtlUpdateShipmentStatusCd.FINAL:
            case XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS:
                return DeliveryQualifierCd.FINAL;
            case XpoLtlUpdateShipmentStatusCd.PART_SHORT:
                return DeliveryQualifierCd.PARTIAL_SHORT;
            case XpoLtlUpdateShipmentStatusCd.REFUSED:
                return DeliveryQualifierCd.REFUSED;
            case XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED:
                return DeliveryQualifierCd.DAMAGED;
            case XpoLtlUpdateShipmentStatusCd.RETURNED:
                return DeliveryQualifierCd.RETURNED;
            case XpoLtlUpdateShipmentStatusCd.ATTEMPTED:
                return DeliveryQualifierCd.ATTEMPTED;
            case XpoLtlUpdateShipmentStatusCd.ALL_SHORT:
                return DeliveryQualifierCd.ALL_SHORT;
        }
        return undefined;
    }
    toDeliveryRefusedInd(parentQualifier, childQualifier) {
        const quaExceptions = childQualifier &&
            parentQualifier === XpoLtlUpdateShipmentStatusCd.FINAL &&
            [
                FinalWithExceptionSubQualifierCodes.ACCEPTED_DAMAGED,
                FinalWithExceptionSubQualifierCodes.ACCEPTED,
                FinalWithExceptionSubQualifierCodes.SHORT,
            ].indexOf(childQualifier) < 0;
        return (quaExceptions ||
            parentQualifier === XpoLtlUpdateShipmentStatusCd.REFUSED ||
            parentQualifier === XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED);
    }
    toDeliveryDamagedInd(parentQualifier, childQualifier) {
        const quaExceptions = childQualifier &&
            parentQualifier === XpoLtlUpdateShipmentStatusCd.FINAL &&
            [
                FinalWithExceptionSubQualifierCodes.ACCEPTED_DAMAGED,
                FinalWithExceptionSubQualifierCodes.REFUSED_DAMAGED,
            ].indexOf(childQualifier) >= 0;
        const quaReturned = parentQualifier === XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED;
        return quaExceptions || quaReturned;
    }
    toDeliveryShortInd(parentQualifier, childQualifier) {
        const quaExceptions = childQualifier && childQualifier === FinalWithExceptionSubQualifierCodes.SHORT;
        const quaPart = parentQualifier === XpoLtlUpdateShipmentStatusCd.PART_SHORT &&
            childQualifier === FinalWithExceptionSubQualifierCodes.SHORT;
        const quaAll = parentQualifier === XpoLtlUpdateShipmentStatusCd.ALL_SHORT;
        return quaExceptions || quaPart || quaAll;
    }
}
UpdateShipmentStatusService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusService, deps: [{ token: i2$6.ShipmentApiService }, { token: UpdateShipmentStatusDisplayConfigService }, { token: i5$1.CityOperationsApiService }, { token: XpoLtlLoggedInUserService }, { token: XpoLtlConditioningService }, { token: i2$3.ConfigManagerService }, { token: i7$4.CarrierManagementApiService }, { token: XpoLtlTimeService }], target: i0.ɵɵFactoryTarget.Injectable });
UpdateShipmentStatusService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2$6.ShipmentApiService }, { type: UpdateShipmentStatusDisplayConfigService }, { type: i5$1.CityOperationsApiService }, { type: XpoLtlLoggedInUserService }, { type: XpoLtlConditioningService }, { type: i2$3.ConfigManagerService }, { type: i7$4.CarrierManagementApiService }, { type: XpoLtlTimeService }]; } });

/**
 * Possible errors for Time format
 */
var TimeFormatErrorEnum;
(function (TimeFormatErrorEnum) {
    TimeFormatErrorEnum["InvalidFormat"] = "invalidFormat";
    TimeFormatErrorEnum["Required"] = "required";
    TimeFormatErrorEnum["InThePast"] = "inThePast";
})(TimeFormatErrorEnum || (TimeFormatErrorEnum = {}));
class TimeFormatUtil {
    static timeFormatValidatorFunction() {
        return TimeFormatUtil.timeFormatValidation;
    }
    static timeFormatValidation(control) {
        const validTimeRegExp = new RegExp(TimeFormatUtil.TimeFormatValidatorRegExpWithAnchors);
        const val = control.value;
        // validate the control value is in the form "HH:MM",
        // where HH is between [00, 23], and MM is between [00, 59]. Or 24:00
        return !isEmpty(val)
            ? !validTimeRegExp.test(val) && val !== '00:00' && val !== '24:00'
                ? { [TimeFormatErrorEnum.InvalidFormat]: true }
                : null
            : null;
    }
    static formatStringToTimeStringByFillingWithZeros(invalidTime) {
        invalidTime = invalidTime.replace(/:/g, '');
        invalidTime = size(invalidTime) === 3 ? (invalidTime = `0${invalidTime}`) : invalidTime;
        const hours = invalidTime.substr(0, 2);
        const minutes = invalidTime.substr(2, 2);
        return `${padStart(`${hours}`, 2, '0')}:${padEnd(`${minutes}`, 2, '0')}`;
    }
}
TimeFormatUtil.TimeFormatValidatorRegExp = '(([0-1][0-9]|[2][0-3]):([0-5][0-9]))';
TimeFormatUtil.TimeFormatValidatorRegExpWithAnchors = `^${TimeFormatUtil.TimeFormatValidatorRegExp}$`;
TimeFormatUtil.timeInputValidatorPattern = '^[0-9:]$';

class HandlingUnitTypeCdPipe {
    transform(typeCd) {
        if (typeCd === HandlingUnitTypeCd.LOOSE) {
            return 'LP';
        }
        if (typeCd === HandlingUnitTypeCd.MOTOR) {
            return 'MM';
        }
        return null;
    }
}
HandlingUnitTypeCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: HandlingUnitTypeCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
HandlingUnitTypeCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: HandlingUnitTypeCdPipe, name: "handlingUnitTypeCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: HandlingUnitTypeCdPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'handlingUnitTypeCd' }]
        }] });

var PieceLevelTrackingColDefHeaderNames;
(function (PieceLevelTrackingColDefHeaderNames) {
    PieceLevelTrackingColDefHeaderNames["CHLID_PRO"] = "Child PRO";
    PieceLevelTrackingColDefHeaderNames["EXCEPTION"] = "Exception";
    PieceLevelTrackingColDefHeaderNames["TYPE"] = "Type";
    PieceLevelTrackingColDefHeaderNames["LENGTH"] = "L (In.)";
    PieceLevelTrackingColDefHeaderNames["WIDTH"] = "W (In.)";
    PieceLevelTrackingColDefHeaderNames["HEIGHT"] = "H (In.)";
})(PieceLevelTrackingColDefHeaderNames || (PieceLevelTrackingColDefHeaderNames = {}));
class PieceLevelTrackingColDef {
    constructor(updateShipmentStatusFormService, isSelectChildExceptionEnable, getChildDeliveryQualifierCodes, setChildQualifierCodes, handlingUnitTypeCdPipe) {
        this.updateShipmentStatusFormService = updateShipmentStatusFormService;
        this.isSelectChildExceptionEnable = isSelectChildExceptionEnable;
        this.getChildDeliveryQualifierCodes = getChildDeliveryQualifierCodes;
        this.setChildQualifierCodes = setChildQualifierCodes;
        this.handlingUnitTypeCdPipe = handlingUnitTypeCdPipe;
    }
    getColDef() {
        var _a, _b;
        const childQualifier = [
            ...(_a = this.updateShipmentStatusFormService.ChildSubQualifierCodes) === null || _a === void 0 ? void 0 : _a.map((code) => ({
                value: code.code,
                label: code.description,
            })),
            ...(_b = this.updateShipmentStatusFormService.FinalWithExceptionSubQualifierCodes) === null || _b === void 0 ? void 0 : _b.map((code) => ({
                value: code.code,
                label: code.description,
            })),
        ];
        return [
            XpoNgxGridColumns.SELECTION_WITH_SELECT_ALL,
            {
                suppressMenu: true,
                field: 'plt_pro',
                headerName: PieceLevelTrackingColDefHeaderNames.CHLID_PRO,
                width: 100,
            },
            {
                suppressMenu: true,
                field: UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE,
                headerName: PieceLevelTrackingColDefHeaderNames.EXCEPTION,
                width: 120,
                editable: this.isSelectChildExceptionEnable,
                valueGetter: (params) => { var _a; return ((_a = childQualifier.find((code) => { var _a; return ((_a = params.data) === null || _a === void 0 ? void 0 : _a.plt_deliveryQualifierCode) === code.value; })) === null || _a === void 0 ? void 0 : _a.label) || 'Select'; },
                cellEditor: XpoGridCellEditor.Select,
                cellEditorParams: this.getChildDeliveryQualifierCodes,
                valueSetter: (params) => {
                    if (params.oldValue !== params.newValue) {
                        params.data.plt_deliveryQualifierCode = params.newValue;
                    }
                    this.setChildQualifierCodes(params);
                    return true;
                },
                cellStyle: { 'background-color': 'white' },
            },
            {
                suppressMenu: true,
                field: UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE_READONLY,
                headerName: PieceLevelTrackingColDefHeaderNames.EXCEPTION,
                width: 174,
                hide: true,
                valueGetter: (params) => { var _a; return (_a = childQualifier.find((code) => { var _a; return ((_a = params.data) === null || _a === void 0 ? void 0 : _a.plt_deliveryQualifierCode) === code.value; })) === null || _a === void 0 ? void 0 : _a.label; },
            },
            {
                suppressMenu: true,
                field: 'plt_type',
                headerName: PieceLevelTrackingColDefHeaderNames.TYPE,
                width: 60,
                valueGetter: (params) => this.handlingUnitTypeCdPipe.transform(params.data.plt_type),
            },
            {
                suppressMenu: true,
                field: 'plt_length',
                headerName: PieceLevelTrackingColDefHeaderNames.LENGTH,
                width: 60,
                type: 'numericColumn',
                cellStyle: { paddingRight: '0 !important' },
            },
            {
                suppressMenu: true,
                field: 'plt_width',
                headerName: PieceLevelTrackingColDefHeaderNames.WIDTH,
                width: 60,
                type: 'numericColumn',
                cellStyle: { paddingRight: '0 !important' },
            },
            {
                suppressMenu: true,
                field: 'plt_height',
                headerName: PieceLevelTrackingColDefHeaderNames.HEIGHT,
                width: 60,
                type: 'numericColumn',
                cellStyle: { paddingRight: '0 !important' },
            },
        ];
    }
}

class ReasonCodeSelectorComponent {
    constructor() {
        this.updateShipmentStatusFormField = UpdateShipmentStatusFormField;
        this.qualifierCodes = [];
        this.placeholder = 'Select one';
        this.selectedQualifierCode = new EventEmitter();
        this.enabled = true;
        this.selectorValue = null;
    }
    ngOnChanges(changes) {
        var _a, _b, _c;
        switch (this.selectType) {
            case 'bulkQualifierSelector':
                if (!((_a = changes === null || changes === void 0 ? void 0 : changes.enabled) === null || _a === void 0 ? void 0 : _a.currentValue)) {
                    this.selectorValue = null;
                }
                if (((_b = changes === null || changes === void 0 ? void 0 : changes.selectorValue) === null || _b === void 0 ? void 0 : _b.currentValue) !== XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS &&
                    ((_c = changes === null || changes === void 0 ? void 0 : changes.selectorValue) === null || _c === void 0 ? void 0 : _c.currentValue) !== XpoLtlUpdateShipmentStatusCd.PART_SHORT) {
                    this.selectorValue = null;
                }
                break;
        }
    }
    onQualifierCodeChange(selectionChange) {
        this.selectedQualifierCode.emit(this.qualifierCodes.find((qualifierCode) => qualifierCode.code === (selectionChange === null || selectionChange === void 0 ? void 0 : selectionChange.value)));
    }
}
ReasonCodeSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ReasonCodeSelectorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ReasonCodeSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ReasonCodeSelectorComponent, selector: "xpo-reason-code-selector", inputs: { qualifierCodes: "qualifierCodes", formGroup: "formGroup", placeholder: "placeholder", enabled: "enabled", selectType: "selectType", selectorValue: "selectorValue" }, outputs: { selectedQualifierCode: "selectedQualifierCode" }, usesOnChanges: true, ngImport: i0, template: "<form>\n  <mat-form-field [floatLabel]=\"'always'\" id=\"pnd-selector\">\n    <mat-label></mat-label>\n    <mat-select\n      [placeholder]=\"placeholder\"\n      (selectionChange)=\"onQualifierCodeChange($event)\"\n      (click)=\"$event.stopPropagation()\"\n      [disabled]=\"!enabled\"\n      [value]=\"selectorValue\"\n    >\n      <mat-option *ngFor=\"let qualifierCode of qualifierCodes\" [value]=\"qualifierCode.code\">\n        {{ qualifierCode.description }}\n      </mat-option>\n    </mat-select>\n  </mat-form-field>\n</form>\n", styles: [".flex--stretch{flex:1}form{background-color:#f6f6f6}form #pnd-selector{margin-bottom:0;margin-left:10px;margin-top:6px}form #pnd-selector .mat-form-field-infix{font-style:normal}form #pnd-selector .mat-form-field-infix .mat-select-placeholder{color:#757575}"], components: [{ type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i4$4.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }], directives: [{ type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7.MatLabel, selector: "mat-label" }, { type: i16.XpoDisableOptionCenteringDirective, selector: "mat-select" }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ReasonCodeSelectorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-reason-code-selector',
                    templateUrl: './reason-code-selector.component.html',
                    styleUrls: ['./reason-code-selector.component.scss'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { qualifierCodes: [{
                type: Input
            }], formGroup: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], selectedQualifierCode: [{
                type: Output
            }], enabled: [{
                type: Input
            }], selectType: [{
                type: Input
            }], selectorValue: [{
                type: Input
            }] } });

class ChildShipmentsGridComponent {
    constructor(cdr, handlingUnitTypeCdPipe, updateShipmentStatusFormService) {
        this.cdr = cdr;
        this.handlingUnitTypeCdPipe = handlingUnitTypeCdPipe;
        this.updateShipmentStatusFormService = updateShipmentStatusFormService;
        this.panelOpenState = false;
        this.bulkSelectorEnabledState = true;
        this.boardReadySubject = new BehaviorSubject(false);
        this.boardReady$ = this.boardReadySubject.asObservable();
        this.updateShipmentStatusFormField = UpdateShipmentStatusFormField;
        this.QualifierCodes = XpoLtlUpdateShipmentStatusCd;
        this.QualifierCodesAbleToUpdate = [
            XpoLtlUpdateShipmentStatusCd.PART_SHORT,
            XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
            XpoLtlUpdateShipmentStatusCd.FINAL,
        ];
        this.PartShortQualifierCode = [
            FinalWithExceptionSubQualifierCodes.SHORT,
            FinalWithExceptionSubQualifierCodes.ACCEPTED,
        ];
        this.TripNodeStatusCd = TripNodeStatusCd;
        this.highlightsRowPro = [];
        this.columnDefs = undefined;
        this.gridConfig = undefined;
        this.rowData = undefined;
        this.unsubscriber = new Unsubscriber();
        this.qualifierCodes = [];
        this.selectedQualifierCode = {};
    }
    ngOnInit() {
        var _a, _b, _c;
        this.hasChildPro = ((_a = this.formGroup) === null || _a === void 0 ? void 0 : _a.get(UpdateShipmentStatusFormField.PLT).value.length) > 0;
        this.qualifierCodes = this.updateShipmentStatusFormService.DeliveryQualifierCodes;
        this.childQualifierCodes = this.updateShipmentStatusFormService.FinalWithExceptionSubQualifierCodes;
        this.selectedQualifierCode.code = (_c = (_b = this.formGroup) === null || _b === void 0 ? void 0 : _b.get(UpdateShipmentStatusFormField.StatusCd)) === null || _c === void 0 ? void 0 : _c.value;
        this.setGridConfig();
        this.initWatchers();
        this.cdr.markForCheck();
    }
    setGridConfig() {
        const colDef = new PieceLevelTrackingColDef(this.updateShipmentStatusFormService, this.isSelectChildExceptionEnable.bind(this), this.getChildDeliveryQualifierCodes.bind(this), this.setChildQualifierCodes.bind(this), this.handlingUnitTypeCdPipe);
        this.columnDefs = colDef.getColDef();
        this.gridConfig = {
            gridSettings: [XPO_GRID_SETTINGS.selectAll, XPO_GRID_SETTINGS.inlineEditing],
            gridOptions: {
                onGridReady: (params) => {
                    setTimeout(() => {
                        params.api.setDomLayout('autoHeight');
                    });
                },
                defaultColDef: {
                    cellRenderer: XpoGridCellRenderer.Base,
                    cellRendererParams: {
                        allowEmptyValues: false,
                    },
                },
                enableRangeSelection: true,
                rowSelection: 'multiple',
                rowData: this.rowData,
                columnDefs: this.columnDefs,
                singleClickEdit: true,
                getRowStyle: (params) => (this.isRowHighlighted(params) ? { 'background-color': '#a4e59b' } : ''), // getRowClass not working
            },
            gridSettingsParams: {
                keyField: 'OrderId',
            },
        };
        this.boardReadySubject.next(true);
    }
    isSelectChildExceptionEnable() {
        var _a, _b;
        return (this.QualifierCodesAbleToUpdate.some((code) => { var _a, _b; return ((_b = (_a = this.formGroup) === null || _a === void 0 ? void 0 : _a.get(UpdateShipmentStatusFormField.StatusCd)) === null || _b === void 0 ? void 0 : _b.value) === code; }) ||
            ((_a = this.selectedQualifierCode) === null || _a === void 0 ? void 0 : _a.code) === XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS ||
            ((_b = this.selectedQualifierCode) === null || _b === void 0 ? void 0 : _b.code) === XpoLtlUpdateShipmentStatusCd.PART_SHORT);
    }
    getChildDeliveryQualifierCodes() {
        var _a;
        const getCodeByChildCodes = (validCodes) => {
            return this.updateShipmentStatusFormService.FinalWithExceptionSubQualifierCodes.filter((childCode) => validCodes.some((ableCode) => childCode.code === ableCode));
        };
        const codeByQualifierCode = {
            [XpoLtlUpdateShipmentStatusCd.PART_SHORT]: getCodeByChildCodes([
                FinalWithExceptionSubQualifierCodes.SHORT,
                FinalWithExceptionSubQualifierCodes.ACCEPTED,
            ]),
            [XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS]: getCodeByChildCodes([
                FinalWithExceptionSubQualifierCodes.ACCEPTED,
                FinalWithExceptionSubQualifierCodes.ACCEPTED_DAMAGED,
                FinalWithExceptionSubQualifierCodes.REFUSED,
                FinalWithExceptionSubQualifierCodes.REFUSED_DAMAGED,
                FinalWithExceptionSubQualifierCodes.SHORT,
            ]),
        };
        const codes = codeByQualifierCode[(_a = this.selectedQualifierCode) === null || _a === void 0 ? void 0 : _a.code];
        return {
            options: codes === null || codes === void 0 ? void 0 : codes.map((item) => ({
                value: item === null || item === void 0 ? void 0 : item.code,
                label: item === null || item === void 0 ? void 0 : item.description,
            })),
        };
    }
    onQualifierCodeChange(selectedQualifierCode) {
        var _a;
        this.selectedQualifierCode = {
            code: selectedQualifierCode,
            description: selectedQualifierCode,
        };
        const readonlyField = [
            XpoLtlUpdateShipmentStatusCd.FINAL,
            XpoLtlUpdateShipmentStatusCd.RETURNED,
            XpoLtlUpdateShipmentStatusCd.REFUSED,
            XpoLtlUpdateShipmentStatusCd.ALL_SHORT,
            XpoLtlUpdateShipmentStatusCd.ATTEMPTED,
            XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED,
            XpoLtlUpdateShipmentStatusCd.TRAP,
            XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
            XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
            XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
            XpoLtlUpdateShipmentStatusCd.CARTAGE,
        ].includes(selectedQualifierCode);
        this.gridConfig.gridOptions.columnApi.setColumnVisible(UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE, !readonlyField);
        this.gridConfig.gridOptions.columnApi.setColumnVisible(UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE_READONLY, readonlyField);
        if (selectedQualifierCode === XpoLtlUpdateShipmentStatusCd.PART_SHORT) {
            this.childQualifierCodes = (_a = this.childQualifierCodes) === null || _a === void 0 ? void 0 : _a.filter((item) => { var _a; return (_a = this.PartShortQualifierCode) === null || _a === void 0 ? void 0 : _a.find((itemCode) => itemCode === (item === null || item === void 0 ? void 0 : item.code)); });
        }
        else {
            this.childQualifierCodes = this.updateShipmentStatusFormService.FinalWithExceptionSubQualifierCodes;
        }
    }
    onBulkQualifierCodeChange(selectedQualifierCode) {
        if (this.gridAPI.getSelectedNodes().length > 0) {
            this.selectedBulkQualifierCode = selectedQualifierCode;
            this.gridAPI.getSelectedNodes().forEach((node) => {
                node.data.plt_deliveryQualifierCode = selectedQualifierCode.code;
                node.setData(node.data);
                this.setChildQualifierCodes(node, true);
            });
            this.gridAPI.deselectAll();
        }
    }
    setChildQualifierCodes(params, isBulkSelection = false) {
        const proNbr = params.data.plt_pro;
        const setChildQualifierCodes = params.data.plt_deliveryQualifierCode;
        const pltArryForm = this.formGroup.get(UpdateShipmentStatusFormField.PLT);
        const controlToUpdate = pltArryForm.controls.find((control) => control.get(UpdateShipmentStatusFormField.PLT_PRO).value === proNbr);
        controlToUpdate.get(UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE).setValue(setChildQualifierCodes);
        this.updateSummary(isBulkSelection);
    }
    updateSummary(isBulkSelection = false) {
        var _a, _b;
        if ((this.isSelectChildExceptionEnable() && this.hasChildPro) || isBulkSelection) {
            const pltArryForm = this.formGroup.get(UpdateShipmentStatusFormField.PLT);
            const codes = this.updateShipmentStatusFormService.FinalWithExceptionSubQualifierCodes;
            const summary = pltArryForm.controls
                .filter((control) => control.get(UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE).value)
                .reduce((prev, curr) => {
                if (prev[curr.get(UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE).value]) {
                    prev[curr.get(UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE).value] += 1;
                }
                else {
                    prev[curr.get(UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE).value] = 1;
                }
                return prev;
            }, {});
            this.formGroup.get(UpdateShipmentStatusFormField.ShortPieces).setValue(0);
            const summaryKeys = Object.keys(summary);
            if (summaryKeys === null || summaryKeys === void 0 ? void 0 : summaryKeys.length) {
                this.cleanErrorMessage();
                if (((_b = (_a = this.formGroup) === null || _a === void 0 ? void 0 : _a.get(UpdateShipmentStatusFormField.StatusCd)) === null || _b === void 0 ? void 0 : _b.value) === XpoLtlUpdateShipmentStatusCd.FINAL) {
                    this.setInfoMessage('All child PROs are Final');
                }
                else {
                    this.setInfoMessage(`Child PROs with exceptions`);
                    this.setInfoSummary(summaryKeys === null || summaryKeys === void 0 ? void 0 : summaryKeys.map((key) => {
                        var _a;
                        if (key === XpoLtlUpdateShipmentStatusCd.PART_SHORT) {
                            if (this.selectedQualifierCode.code === XpoLtlUpdateShipmentStatusCd.PART_SHORT) {
                                this.formGroup.get(UpdateShipmentStatusFormField.ShortPieces).setValue(summary[key]);
                            }
                        }
                        return {
                            title: (_a = codes === null || codes === void 0 ? void 0 : codes.find((code) => (code === null || code === void 0 ? void 0 : code.code) === key)) === null || _a === void 0 ? void 0 : _a.description,
                            value: summary[key],
                        };
                    }));
                }
            }
            else {
                this.setErrorMessage(`Exceptions must be designated for child PROs`);
            }
        }
        else {
            this.cleanErrorMessage();
            this.cleanInfoSummary();
        }
    }
    initWatchers() {
        var _a, _b;
        (_b = (_a = this.formGroup) === null || _a === void 0 ? void 0 : _a.get(UpdateShipmentStatusFormField.StatusCd)) === null || _b === void 0 ? void 0 : _b.valueChanges.pipe(takeUntil(this.unsubscriber.done$)).subscribe((value) => {
            this.infoSummary = [];
            this.setGridChanges(value);
        });
    }
    setGridChanges(value) {
        var _a, _b, _c;
        this.onQualifierCodeChange(value);
        this.bulkSelectorEnabledState =
            ((_a = this.selectedQualifierCode) === null || _a === void 0 ? void 0 : _a.code) === XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS ||
                ((_b = this.selectedQualifierCode) === null || _b === void 0 ? void 0 : _b.code) === XpoLtlUpdateShipmentStatusCd.PART_SHORT;
        // this.setValidationsByDeliveryQualifierCode(value);
        this.setChildValueByDeliveryQualifierCode(value);
        // this.panel.open();
        this.cdr.detectChanges();
        (_c = this.gridAPI) === null || _c === void 0 ? void 0 : _c.redrawRows();
        this.updateSummary();
        setTimeout(() => { var _a; return (_a = this.gridAPI) === null || _a === void 0 ? void 0 : _a.sizeColumnsToFit(); }, 0); // send this instruction to the end of the queue so fit columns after show scroll on UI
    }
    setChildValueByDeliveryQualifierCode(code) {
        const matchQualifierCode = {
            [XpoLtlUpdateShipmentStatusCd.ALL_SHORT]: { code: XpoLtlUpdateShipmentStatusCd.ALL_SHORT, text: 'Short' },
            [XpoLtlUpdateShipmentStatusCd.PART_SHORT]: { code: FinalWithExceptionSubQualifierCodes.SHORT, text: 'Short' },
            [XpoLtlUpdateShipmentStatusCd.RETURNED]: { code: FinalWithExceptionSubQualifierCodes.RETURN, text: 'Return' },
            [XpoLtlUpdateShipmentStatusCd.ATTEMPTED]: {
                code: FinalWithExceptionSubQualifierCodes.ATTEMPTED,
                text: 'Attempted',
            },
            [XpoLtlUpdateShipmentStatusCd.REFUSED]: { code: FinalWithExceptionSubQualifierCodes.REFUSED, text: 'Refused' },
            [XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED]: {
                code: FinalWithExceptionSubQualifierCodes.REFUSED_DAMAGED,
                text: 'Returned Damaged',
            },
            [XpoLtlUpdateShipmentStatusCd.FINAL]: { code: FinalWithExceptionSubQualifierCodes.ACCEPTED, text: 'Final' },
            [XpoLtlUpdateShipmentStatusCd.UNDELIVERED]: {
                code: XpoLtlUpdateShipmentStatusCd.UNDELIVERED,
                text: 'Undelivered',
            },
            [XpoLtlUpdateShipmentStatusCd.TRAP]: { code: XpoLtlUpdateShipmentStatusCd.TRAP, text: 'Trap' },
            [XpoLtlUpdateShipmentStatusCd.CARTAGE]: { code: XpoLtlUpdateShipmentStatusCd.CARTAGE, text: 'Cartage' },
            [XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS]: {
                code: XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS,
                text: 'Hold for Customs',
            },
            [XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS]: { code: undefined, text: '' },
            [XpoLtlUpdateShipmentStatusCd.PART_SHORT]: { code: undefined, text: '' },
            [XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS]: {
                code: XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS,
                text: 'Over w/ billed ship',
            },
        };
        if (matchQualifierCode[code]) {
            const pltList = this.formGroup.get(UpdateShipmentStatusFormField.PLT);
            for (let index = 0; index < pltList.length; index++) {
                pltList
                    .at(index)
                    .get(UpdateShipmentStatusFormField.PLT_DELIVERY_QUALIFIER_CODE)
                    .patchValue(matchQualifierCode[code].code);
            }
            if (matchQualifierCode[code].text) {
                this.setInfoMessage(`All child PROs are ${matchQualifierCode[code].text}`);
            }
            else {
                this.cleanInfoMessage();
            }
            this.setGridData();
        }
    }
    setErrorMessage(message) {
        this.errorMessage = message;
    }
    cleanErrorMessage() {
        this.errorMessage = undefined;
    }
    setInfoMessage(message) {
        this.infoMessage = message;
    }
    cleanInfoMessage() {
        this.infoMessage = undefined;
    }
    setInfoSummary(summaries) {
        this.infoSummary = summaries;
    }
    cleanInfoSummary() {
        this.infoSummary = undefined;
    }
    cleanHighlightsRow() {
        if (this.highlightsRowPro.length) {
            this.highlightsRowPro = [];
            this.gridAPI.redrawRows();
        }
    }
    highlightsRow(childPro) {
        this.highlightsRowPro = [childPro];
        this.gridAPI.redrawRows();
    }
    isRowHighlighted(param) {
        return this.highlightsRowPro.some((pro) => pro === param.data.plt_pro);
    }
    setGridData() {
        var _a;
        (_a = this.gridAPI) === null || _a === void 0 ? void 0 : _a.setRowData(this.formGroup.get(UpdateShipmentStatusFormField.PLT).value);
    }
    onGridReady(event) {
        if (this.hasChildPro) {
            this.gridAPI = event.gridRef.gridOptions.api;
            this.setGridChanges(this.selectedQualifierCode.code);
            this.setGridData();
            this.inlineEditingApi = this.gridConfig.gridSettingsParams.inlineEditing.api;
        }
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
}
ChildShipmentsGridComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ChildShipmentsGridComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: HandlingUnitTypeCdPipe }, { token: UpdateShipmentStatusFormService }], target: i0.ɵɵFactoryTarget.Component });
ChildShipmentsGridComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ChildShipmentsGridComponent, selector: "xpo-ltl-child-shipments-grid", inputs: { isCartageAgent: "isCartageAgent", tripNodeStatus: "tripNodeStatus", id: "id", formGroup: "formGroup" }, viewQueries: [{ propertyName: "panel", first: true, predicate: MatExpansionPanel, descendants: true }], ngImport: i0, template: "<div class=\"xpo-LtlUpdateShipmentForm__header-left__message__info\" *ngIf=\"hasChildPro && infoMessage\">\n  <mat-icon>info</mat-icon>\n  <span class=\"xpo-LtlUpdateShipmentForm__header-left__message__info--text\">{{ infoMessage }}</span>\n  <div class=\"xpo-LtlUpdateShipmentForm__header-left__message__info__summary\" *ngIf=\"infoSummary?.length\">\n    <span\n      class=\"xpo-LtlUpdateShipmentForm__header-left__message__info__summary--item\"\n      *ngFor=\"let summary of infoSummary\"\n      >{{ summary.title }}: {{ summary.value }}</span\n    >\n  </div>\n</div>\n<ng-container *ngIf=\"hasChildPro && boardReady$ | async\">\n  <xpo-ngx-grid [gridConfig]=\"gridConfig\" (gridReady)=\"onGridReady($event)\" #grid>\n    <xpo-grid-toolbar [gridRef]=\"grid\">\n      <xpo-grid-toolbar-actions-group>\n        <xpo-reason-code-selector\n          class=\"xpo-LtlUpdateShipmentForm-reason-selector\"\n          [placeholder]=\"'Select Bulk Exception'\"\n          [selectType]=\"'bulkQualifierSelector'\"\n          [enabled]=\"bulkSelectorEnabledState\"\n          [formGroup]=\"formGroup\"\n          [qualifierCodes]=\"childQualifierCodes\"\n          (selectedQualifierCode)=\"onBulkQualifierCodeChange($event)\"\n          [selectorValue]=\"formGroup?.get(updateShipmentStatusFormField.StatusCd)?.value\"\n        ></xpo-reason-code-selector>\n      </xpo-grid-toolbar-actions-group>\n    </xpo-grid-toolbar>\n  </xpo-ngx-grid>\n</ng-container>\n", styles: [".flex--stretch{flex:1}.xpo-LtlUpdateShipmentForm-error{border-color:#d32f2f}.xpo-LtlUpdateShipmentForm .ag-header-cell mat-checkbox{margin-left:-2px}.xpo-LtlUpdateShipmentForm__detail{margin-bottom:-5px}.xpo-LtlUpdateShipmentForm #pnd-panel-title{padding:0 10px 0 0}.xpo-LtlUpdateShipmentForm__panel{background-color:#fafafa;border:1px solid rgba(0,0,0,.12)}.xpo-LtlUpdateShipmentForm__panel .mat-expansion-panel-content>.mat-expansion-panel-body{padding:0 12px 8px 36px}.xpo-LtlUpdateShipmentForm__panel .mat-expansion-panel-header.mat-expanded,.xpo-LtlUpdateShipmentForm__panel .mat-expansion-panel-header.mat-expanded:focus,.xpo-LtlUpdateShipmentForm__panel .mat-expansion-panel-header.mat-expanded:hover{background-color:#fafafa}.xpo-LtlUpdateShipmentForm__panel-margin .mat-content:before{margin-top:-27px}.xpo-LtlUpdateShipmentForm__panel-title{display:block;margin-right:-16px;width:100%}.xpo-LtlUpdateShipmentForm__panel-title-content{width:100%}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm{border:1px solid rgba(0,0,0,.12);border-radius:2px;display:flex;flex-grow:1;justify-content:space-between;padding:8px;width:100%}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header{align-items:center;display:flex;justify-content:space-between;margin:-8px 32px 0 0;width:100%}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-right-error{border-color:#d32f2f}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left{align-items:center;display:flex;justify-content:space-between;padding-top:8px;width:100%}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left>pnd-special-services{width:30%}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left>div:nth-child(n+2){font-size:.875rem;text-align:right}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left>div:last-child{margin-right:42px}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left span:first-child{margin-right:8px}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left__message{display:flex;flex-direction:column;font-size:.875rem}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left__message__warning{align-items:center;color:#d32f2f;display:flex}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left__message__warning--text{font-weight:400}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left__message__info{align-items:center;background-color:#fafafa;display:flex}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left__message__info--text{font-weight:400}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left__message__info__summary{display:flex;padding:0 16px}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-left__message__info__summary--item{font-family:Roboto,sans-serif;font-weight:400;padding-right:16px}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-right{margin-right:-24px}.xpo-LtlUpdateShipmentForm .xpo-LtlUpdateShipmentForm__header-right .mat-form-field{display:flex;margin:8px 0 0!important}.xpo-LtlUpdateShipmentForm pnd-driver-collect .mat-expansion-panel{background-color:#fafafa;border:1px solid rgba(0,0,0,.12);border-top:0}.xpo-LtlUpdateShipmentForm .xpo-grid-wrapper{padding-bottom:10px}.xpo-LtlUpdateShipmentForm .ag-grid .xpo-ngxGrid-checkboxColumn{padding-left:11px}.xpo-LtlUpdateShipmentForm .ag-grid .xpo-ngxGrid-checkboxColumn.ag-cell.xpo-renderer-cell{padding-left:10px}"], components: [{ type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i4$7.XpoGridComponent, selector: "xpo-ngx-grid", outputs: ["stateChange"] }, { type: i4$7.XpoGridToolbar, selector: "xpo-grid-toolbar", inputs: ["gridRef"] }, { type: i4$7.XpoGridToolbarActions, selector: "xpo-grid-toolbar-actions-group", inputs: ["dynButtons"] }, { type: ReasonCodeSelectorComponent, selector: "xpo-reason-code-selector", inputs: ["qualifierCodes", "formGroup", "placeholder", "enabled", "selectType", "selectorValue"], outputs: ["selectedQualifierCode"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }], pipes: { "async": i5.AsyncPipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ChildShipmentsGridComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-child-shipments-grid',
                    templateUrl: './child-shipments-grid.component.html',
                    styleUrls: ['./child-shipments-grid.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: HandlingUnitTypeCdPipe }, { type: UpdateShipmentStatusFormService }]; }, propDecorators: { isCartageAgent: [{
                type: Input
            }], tripNodeStatus: [{
                type: Input
            }], id: [{
                type: Input
            }], formGroup: [{
                type: Input
            }], panel: [{
                type: ViewChild,
                args: [MatExpansionPanel, { static: false }]
            }] } });

class TimeFormatterDirective {
    constructor(ngControl) {
        this.ngControl = ngControl;
    }
    onKeyup(event) {
        const control = this.ngControl.control;
        if (event.key !== 'Backspace' &&
            control.value &&
            ((control.value.length === 4 && !control.value.includes(':')) ||
                (control.value.length === 5 && control.value.includes(':')))) {
            control.setValue(TimeFormatUtil.formatStringToTimeStringByFillingWithZeros(control.value));
        }
    }
    onBlur() {
        const control = this.ngControl.control;
        if (control.value) {
            control.setValue(TimeFormatUtil.formatStringToTimeStringByFillingWithZeros(control.value));
        }
    }
}
TimeFormatterDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: TimeFormatterDirective, deps: [{ token: i2$2.NgControl, self: true }], target: i0.ɵɵFactoryTarget.Directive });
TimeFormatterDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: TimeFormatterDirective, selector: "[timeFormatter]", host: { listeners: { "keyup": "onKeyup($event)", "blur": "onBlur()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: TimeFormatterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[timeFormatter]',
                }]
        }], ctorParameters: function () { return [{ type: i2$2.NgControl, decorators: [{
                    type: Self
                }] }]; }, propDecorators: { onKeyup: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

class CurrencyFormatterDirective {
    constructor(ngControl, el) {
        this.ngControl = ngControl;
        this.el = el;
        this.unsubscriber = new Unsubscriber();
        this.formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    ngAfterViewInit() {
        this.setValue(this.formatPrice(this.ngControl.value));
        this.ngControl.control.valueChanges.pipe(takeUntil(this.unsubscriber.done$)).subscribe(this.updateValue.bind(this));
    }
    updateValue(value) {
        const inputVal = value || '';
        this.setValue(!!inputVal ? this.validateDecimalValue(inputVal.replace(/[^0-9.]/g, '')) : '');
    }
    onFocus() {
        this.setValue(this.unformatValue(this.ngControl.value));
    }
    onBlur() {
        const value = this.ngControl.value || '';
        if (value) {
            this.setValue(this.formatPrice(value));
        }
    }
    formatPrice(v) {
        return this.formatter.format(v);
    }
    unformatValue(v) {
        return v.replace(/($|,)/g, '');
    }
    validateDecimalValue(v) {
        // Check to see if the value is a valid number or not
        if (Number.isNaN(Number(v))) {
            // strip out last char as this would have made the value invalid
            const strippedValue = v.slice(0, v.length - 1);
            // if value is still invalid, then this would be copy/paste scenario
            // and in such case we simply set the value to empty
            return Number.isNaN(Number(strippedValue)) ? '' : strippedValue;
        }
        return v;
    }
    setValue(v) {
        this.ngControl.control.setValue(v, { emitEvent: false });
    }
    ngOnDestroy() {
        this.setValue(this.unformatValue(this.ngControl.value));
        this.unsubscriber.complete();
    }
}
CurrencyFormatterDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CurrencyFormatterDirective, deps: [{ token: i2$2.NgControl, self: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
CurrencyFormatterDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: CurrencyFormatterDirective, selector: "[currencyFormatter]", host: { listeners: { "focus": "onFocus()", "blur": "onBlur()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: CurrencyFormatterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[currencyFormatter]',
                }]
        }], ctorParameters: function () { return [{ type: i2$2.NgControl, decorators: [{
                    type: Self
                }] }, { type: i0.ElementRef }]; }, propDecorators: { onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

class UpdateShipmentStatusCdPipe {
    transform(value) {
        let transformed = value;
        switch (value) {
            case XpoLtlUpdateShipmentStatusCd.CARTAGE: {
                transformed = 'Cartage (CRTG)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.FINAL: {
                transformed = 'Final (FINL)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.ATTEMPTED: {
                transformed = 'Attempted (ATMP)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS: {
                transformed = 'Final With Exception (FINL w/Excp)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.HOLD_FOR_CUSTOMS: {
                transformed = 'Hold for Customs (CSTM)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS: {
                transformed = 'Over without Billed Shipments (GOWB)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.PART_SHORT: {
                transformed = 'Part Short (PSRT)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.PART_SHORT_WITH_EXCEPTIONS: {
                transformed = 'Part Short With Exceptions (PSZZ)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.REFUSED: {
                transformed = 'Refused (RFSD)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.RETURNED: {
                transformed = 'Returned (RTRN)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.RETURNED_DAMAGED: {
                transformed = 'Returned Damaged (RDMG)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.ALL_SHORT: {
                transformed = 'All Short (SHRT)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.ALL_SHORT_WITH_EXCEPTIONS: {
                transformed = 'All Short With Exceptions (ASZZ)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.STAGE: {
                transformed = 'Stage';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.TRAP: {
                transformed = 'Trap';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.UNDELIVERED: {
                transformed = 'Undelivered (UNDL)';
                break;
            }
            case XpoLtlUpdateShipmentStatusCd.OVER_WITHOUT_BILLED_SHIPMENTS: {
                transformed = 'Over without Billed Shipments (GOWB)';
                break;
            }
        }
        return transformed;
    }
}
UpdateShipmentStatusCdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusCdPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
UpdateShipmentStatusCdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusCdPipe, name: "updateShipmentStatusCd" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusCdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'updateShipmentStatusCd',
                }]
        }] });

const specialServiceIconOverrideMap = {
    [ShipmentSpecialServiceCd.BULK_LIQUID]: 'ss_bulkliquid',
};
class UpdateShipmentFormComponent {
    constructor(configService, formService, statusService, serviceCentersService) {
        this.configService = configService;
        this.formService = formService;
        this.statusService = statusService;
        this.serviceCentersService = serviceCentersService;
        this.unsubscriber = new Unsubscriber();
        this.panelOpenState = false;
        this.filteredValueOptionsSubject = new BehaviorSubject(undefined);
        this.filteredValueOptions$ = this.filteredValueOptionsSubject.asObservable();
        this.filteredCartageSICOptionsSubject = new BehaviorSubject(undefined);
        this.filteredCartageSICOptions$ = this.filteredCartageSICOptionsSubject.asObservable();
        this.TimeFormatUtil = TimeFormatUtil;
        this.UpdateShipmentStatusFormField = UpdateShipmentStatusFormField;
        this.codChargeMethodCdValues = [
            MiscLineItemPaymentMethodCd.COMPANY_CHECK,
            MiscLineItemPaymentMethodCd.MONEY_ORDER,
            MiscLineItemPaymentMethodCd.CERTIFIED_FUND,
        ];
        this.freightChargeMethodCdValues = [
            MiscLineItemPaymentMethodCd.COMPANY_CHECK,
            MiscLineItemPaymentMethodCd.MONEY_ORDER,
            MiscLineItemPaymentMethodCd.CERTIFIED_FUND,
            MiscLineItemPaymentMethodCd.CUSTOMER_CHECK,
        ];
        this.carrierList = [];
        this.scrollEvent = (event) => {
            if (this.dropdown.panelOpen && event.srcElement.classList[1] !== 'dropDown') {
                this.dropdown.closePanel();
            }
        };
    }
    get hasChildPro() {
        var _a;
        return (_a = this.form.get(UpdateShipmentStatusFormField.PLT).value) === null || _a === void 0 ? void 0 : _a.length;
    }
    ngOnInit() {
        this.initControls();
        this.setDateInputRange();
        this.setSpecialServiceIndicators();
        this.setShipmentStatusCodes();
        this.initDisplayStateWatcher();
        this.initReasonCdsWatcher();
        this.initRequiredFieldsWatcher();
        this.initDriverCollectDisabledFieldsWatcher();
        this.buildCarrierSICList();
        this.buildCarrierList();
        window.addEventListener('scroll', this.scrollEvent, true);
        this.filteredValueOptionsSubject.next(this.filterOptions());
    }
    filterOptions() {
        const hoursAmPm = [];
        const addHours = (suffix) => {
            hoursAmPm.push(`12:00 ${suffix}`);
            for (let i = 1; i <= 11; i++) {
                const hh = i < 10 ? `0${i}` : `${i}`;
                hoursAmPm.push(`${hh}:00 ${suffix}`);
            }
        };
        addHours('AM');
        addHours('PM');
        const options = hoursAmPm.map((amPmHour) => ({
            format12: amPmHour,
            format24: moment$2(amPmHour, ['h:mm A']).format('HH:mm'),
        }));
        return options;
    }
    onChange(event) {
        this.panelOpenState = true;
    }
    carrierDisplayFn(carrier) {
        return (carrier === null || carrier === void 0 ? void 0 : carrier.text) || '';
    }
    onBlurCarrier($event) {
        if (!this.carrierList.some((item) => item.text.toLowerCase().includes($event.target.value.toLowerCase()))) {
            this.cartageCarrier.setValue('');
        }
    }
    configureFilterCarrierList() {
        var _a;
        // Setting up option filtering for items list
        this.filteredItemOptions$ = (_a = this.cartageCarrier) === null || _a === void 0 ? void 0 : _a.valueChanges.pipe(startWith(''), map((value) => this.filterItemOptions((value === null || value === void 0 ? void 0 : value.text) || value)));
    }
    filterItemOptions(value) {
        const filterValue = value === null || value === void 0 ? void 0 : value.toLowerCase();
        return this.carrierList.filter((item) => item.text.toLowerCase().includes(filterValue));
    }
    buildCarrierList() {
        var _a;
        const sic = (_a = this.reportingSic) === null || _a === void 0 ? void 0 : _a.value;
        if (sic) {
            this.statusService.loadCarriers(sic.sicCd.toUpperCase()).subscribe((items) => {
                this.carrierList = items.length ? items : [{ code: 0, text: 'No carrier available' }];
                this.configureFilterCarrierList();
            });
        }
    }
    buildCarrierSICList() {
        var _a;
        (_a = this.reportingSic) === null || _a === void 0 ? void 0 : _a.valueChanges.pipe(takeUntil(this.unsubscriber.done$)).subscribe((newSic) => {
            var _a;
            this.form.get(UpdateShipmentStatusFormField.CartageCarrier).setValue('');
            this.form.get(UpdateShipmentStatusFormField.CartageSIC).setValue((_a = newSic === null || newSic === void 0 ? void 0 : newSic.sicCd) === null || _a === void 0 ? void 0 : _a.toUpperCase());
            this.serviceCentersService.serviceCenters$.pipe(take(1)).subscribe((serviceCenters) => {
                const newList = serviceCenters.map((x) => x.sicCd).filter((x) => { var _a; return x.startsWith((_a = newSic === null || newSic === void 0 ? void 0 : newSic.sicCd) === null || _a === void 0 ? void 0 : _a.toUpperCase()); });
                this.filteredCartageSICOptionsSubject.next(newList);
                if (newList.length === 1) {
                    this.buildCarrierList();
                }
            });
        });
    }
    setDateInputRange() {
        const { pickupDate } = this.shipmentId;
        this.maxDate = new Date();
        this.minDate = pickupDate;
    }
    get recipientNameInput() {
        var _a;
        return (_a = this.form.get(UpdateShipmentStatusFormField.RecipientName)) === null || _a === void 0 ? void 0 : _a.value;
    }
    get exceptionNoteInput() {
        var _a;
        return (_a = this.form.get(UpdateShipmentStatusFormField.ExceptionNote)) === null || _a === void 0 ? void 0 : _a.value;
    }
    initControls() {
        this.statusCtrl = this.form.get(UpdateShipmentStatusFormField.StatusCd);
        this.freightChargesPaymentMethodCtrl = this.form.get(UpdateShipmentStatusFormField.FreightChargesPaymentMethod);
        this.freightChargesDollarAmountCtrl = this.form.get(UpdateShipmentStatusFormField.FreightChargesDollarAmount);
        this.freightChargesCheckNbrCtrl = this.form.get(UpdateShipmentStatusFormField.FreightChargesCheckNbr);
        this.cashOnDeliveryPaymentMethodCtrl = this.form.get(UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod);
        this.cashOnDeliveryDollarAmountCtrl = this.form.get(UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount);
        this.cashOnDeliveryCheckNbrCtrl = this.form.get(UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr);
        this.cartageCarrier = this.form.get(UpdateShipmentStatusFormField.CartageCarrier);
        this.cartageSIC = this.form.get(UpdateShipmentStatusFormField.CartageSIC);
        if (this.shipmentId.deliveryInformationRqdCd === DeliveryInfoRequiredCd.RQRD) {
            this.form.get(UpdateShipmentStatusFormField.RecipientName).setValidators(Validators.required);
        }
        this.form.get(UpdateShipmentStatusFormField.FreightChargesPaymentMethod).valueChanges.subscribe((value) => {
            if (!value) {
                this.form.get(UpdateShipmentStatusFormField.FreightChargesDollarAmount).reset();
                this.form.get(UpdateShipmentStatusFormField.FreightChargesCheckNbr).reset();
            }
        });
        this.form.get(UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod).valueChanges.subscribe((value) => {
            if (!value) {
                this.form.get(UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount).reset();
                this.form.get(UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr).reset();
            }
        });
    }
    initDisplayStateWatcher() {
        this.displayState$ = this.statusCtrl.valueChanges.pipe(distinctUntilChanged(), map((statusCd) => {
            return this.configService.updateShipmentStatusCdDisplayConfig[statusCd];
        }), shareReplay());
        this.displayState$
            .pipe(filter((s) => !!s), takeUntil(this.unsubscriber.done$))
            .subscribe((state) => {
            this.onDisplayStateUpdate(state);
        });
    }
    onDisplayStateUpdate(state) {
        this.resetFormValuesOnStateChange(state);
        this.updateFormEnabledState(state);
        this.setDefaultValuesOnStateChange(state);
    }
    resetFormValuesOnStateChange(state) {
        const defaultFormValues = this.formService.getDefaultFormValue();
        const getFormValue = (field, suppress) => {
            return suppress ? defaultFormValues[field] : this.form.get(field).value;
        };
        // when transitioning state, clear any values that don't display in new state,
        // keep values that aren't suppressed (always reset reason code)
        this.form.patchValue({
            [UpdateShipmentStatusFormField.ID]: this.form.get(UpdateShipmentStatusFormField.ID).value,
            [UpdateShipmentStatusFormField.DeliveryQualifierCd]: state.deliveryQualifierCd,
            [UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr]: getFormValue(UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr, state.suppressDriverCollect),
            [UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount]: getFormValue(UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount, state.suppressDriverCollect),
            [UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod]: getFormValue(UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod, state.suppressDriverCollect),
            [UpdateShipmentStatusFormField.DamagedButAccepted]: getFormValue(UpdateShipmentStatusFormField.DamagedButAccepted, state.suppressPiecesInfo),
            [UpdateShipmentStatusFormField.Date]: getFormValue(UpdateShipmentStatusFormField.Date, this.suppressDate),
            [UpdateShipmentStatusFormField.ExceptionNote]: getFormValue(UpdateShipmentStatusFormField.ExceptionNote, state.suppressExceptionNote),
            [UpdateShipmentStatusFormField.FreightChargesCheckNbr]: getFormValue(UpdateShipmentStatusFormField.FreightChargesCheckNbr, state.suppressDriverCollect),
            [UpdateShipmentStatusFormField.FreightChargesDollarAmount]: getFormValue(UpdateShipmentStatusFormField.FreightChargesDollarAmount, state.suppressDriverCollect),
            [UpdateShipmentStatusFormField.FreightChargesPaymentMethod]: getFormValue(UpdateShipmentStatusFormField.FreightChargesPaymentMethod, state.suppressDriverCollect),
            [UpdateShipmentStatusFormField.OverButAccepted]: getFormValue(UpdateShipmentStatusFormField.OverButAccepted, state.suppressPiecesInfo),
            [UpdateShipmentStatusFormField.PartialRefused]: getFormValue(UpdateShipmentStatusFormField.PartialRefused, state.suppressPiecesInfo),
            [UpdateShipmentStatusFormField.Reason]: undefined,
            [UpdateShipmentStatusFormField.CartageCarrier]: getFormValue(UpdateShipmentStatusFormField.CartageCarrier, state.suppressCartageCarrier),
            [UpdateShipmentStatusFormField.CartageSIC]: getFormValue(UpdateShipmentStatusFormField.CartageSIC, state.suppressCartageCarrier),
            [UpdateShipmentStatusFormField.RecipientName]: getFormValue(UpdateShipmentStatusFormField.RecipientName, state.suppressRecipientName),
            [UpdateShipmentStatusFormField.SCACCode]: getFormValue(UpdateShipmentStatusFormField.SCACCode, state.suppressSCAC),
            [UpdateShipmentStatusFormField.ShortPieces]: getFormValue(UpdateShipmentStatusFormField.ShortPieces, state.suppressShortPieces),
            [UpdateShipmentStatusFormField.StatusCd]: this.form.get(UpdateShipmentStatusFormField.StatusCd).value,
            [UpdateShipmentStatusFormField.Time]: getFormValue(UpdateShipmentStatusFormField.Time, state.suppressTime),
        });
    }
    updateFormEnabledState(state) {
        const setControlEnabled = (field, enable) => {
            FormUtils.setControlEnabled(this.form.get(field), enable);
        };
        setControlEnabled(UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod, !state.suppressDriverCollect);
        setControlEnabled(UpdateShipmentStatusFormField.FreightChargesPaymentMethod, !state.suppressDriverCollect);
        setControlEnabled(UpdateShipmentStatusFormField.ExceptionNote, !state.suppressExceptionNote);
        setControlEnabled(UpdateShipmentStatusFormField.DamagedButAccepted, !state.suppressPiecesInfo);
        setControlEnabled(UpdateShipmentStatusFormField.OverButAccepted, !state.suppressPiecesInfo);
        setControlEnabled(UpdateShipmentStatusFormField.PartialRefused, !state.suppressPiecesInfo);
        setControlEnabled(UpdateShipmentStatusFormField.ShortPieces, !state.suppressShortPieces);
        setControlEnabled(UpdateShipmentStatusFormField.CartageCarrier, !state.suppressCartageCarrier);
        setControlEnabled(UpdateShipmentStatusFormField.CartageSIC, !state.suppressCartageCarrier);
        setControlEnabled(UpdateShipmentStatusFormField.RecipientName, !state.suppressRecipientName);
        setControlEnabled(UpdateShipmentStatusFormField.Reason, !state.suppressReason);
        setControlEnabled(UpdateShipmentStatusFormField.SCACCode, !state.suppressSCAC);
        setControlEnabled(UpdateShipmentStatusFormField.Time, !state.suppressTime);
    }
    setDefaultValuesOnStateChange(state) {
        if (!state.defaultValues) {
            return;
        }
        for (const defaultValueKey in state === null || state === void 0 ? void 0 : state.defaultValues) {
            if (defaultValueKey) {
                const formControl = this.form.get(defaultValueKey);
                const { value, disabled } = state.defaultValues[defaultValueKey];
                FormUtils.setValue(formControl, value, { emitEvent: false });
                FormUtils.setControlEnabled(formControl, !disabled);
            }
        }
        this.form.updateValueAndValidity();
    }
    initReasonCdsWatcher() {
        this.reasonCds$ = this.displayState$.pipe(map((state) => {
            var _a, _b;
            return ((_b = (_a = state.reasonCds) === null || _a === void 0 ? void 0 : _a.map((cd) => {
                return {
                    code: cd,
                    value: state.reasonCdsTransformer(cd),
                };
            })) !== null && _b !== void 0 ? _b : []);
        }));
    }
    initRequiredFieldsWatcher() {
        this.requiredFieldsState$ = combineLatest([
            this.displayState$.pipe(distinctUntilChanged()),
            this.form.valueChanges.pipe(debounceTime(150)),
        ]).pipe(map(([state, _]) => {
            var _a, _b;
            return ((_b = (_a = state === null || state === void 0 ? void 0 : state.requiredFields) === null || _a === void 0 ? void 0 : _a.reduce((requiredFieldsState, requiredField) => {
                const isRequired = !requiredField.requiredFn || (requiredField === null || requiredField === void 0 ? void 0 : requiredField.requiredFn(this.shipmentId, this.form.getRawValue()));
                requiredFieldsState[requiredField.field] = isRequired;
                return requiredFieldsState;
            }, {})) !== null && _b !== void 0 ? _b : {});
        }), startWith({}));
    }
    setShipmentStatusCodes() {
        var _a;
        this.shipmentStatusCdValues = this.configService.getUpdateShipmentStatusCdForQualifierCd(this.shipmentId.deliveryQualifierCd);
        if (!((_a = this.shipmentId) === null || _a === void 0 ? void 0 : _a.billInd)) {
            this.shipmentStatusCdValues = [
                XpoLtlUpdateShipmentStatusCd.FINAL,
                XpoLtlUpdateShipmentStatusCd.FINAL_WITH_EXCEPTIONS,
            ];
        }
        FormUtils.setControlEnabled(this.statusCtrl, true);
    }
    initDriverCollectDisabledFieldsWatcher() {
        const updateControlState = (control, method) => {
            FormUtils.setControlEnabled(control, !!method);
            FormUtils.markAsTouchedAndDirty(control);
            control.updateValueAndValidity();
        };
        this.freightChargesPaymentMethodCtrl.valueChanges
            .pipe(startWith(this.freightChargesPaymentMethodCtrl.value), takeUntil(this.unsubscriber.done$))
            .subscribe((method) => {
            updateControlState(this.freightChargesDollarAmountCtrl, method);
            updateControlState(this.freightChargesCheckNbrCtrl, method);
        });
        this.cashOnDeliveryPaymentMethodCtrl.valueChanges
            .pipe(startWith(this.cashOnDeliveryPaymentMethodCtrl.value), takeUntil(this.unsubscriber.done$))
            .subscribe((method) => {
            updateControlState(this.cashOnDeliveryDollarAmountCtrl, method);
            updateControlState(this.cashOnDeliveryCheckNbrCtrl, method);
        });
    }
    setSpecialServiceIndicators() {
        const getIconMap = (specialService) => {
            const iconName = specialService
                .match(/[A-Z][a-z]+/g)
                .join('_')
                .toLowerCase();
            return specialServiceIconOverrideMap[specialService] || `ss_${iconName}`;
        };
        this.specialServiceIndicatorIcons = this.shipmentId.specialServiceCds.map((serviceCd) => {
            return getIconMap(serviceCd);
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
}
UpdateShipmentFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentFormComponent, deps: [{ token: UpdateShipmentStatusDisplayConfigService }, { token: UpdateShipmentStatusFormService }, { token: UpdateShipmentStatusService }, { token: XpoLtlServiceCentersService }], target: i0.ɵɵFactoryTarget.Component });
UpdateShipmentFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: UpdateShipmentFormComponent, selector: "xpo-ltl-update-shipment-form", inputs: { shipmentId: "shipmentId", suppressDate: "suppressDate", form: "form", reportingSic: "reportingSic" }, viewQueries: [{ propertyName: "dropdown", first: true, predicate: ["timeInputDropDown"], descendants: true, read: MatAutocompleteTrigger }], ngImport: i0, template: "<div\n  *ngIf=\"{\n    displayState: displayState$ | async,\n    requiredFields: requiredFieldsState$ | async,\n    reasonCds: reasonCds$ | async\n  } as state\"\n  class=\"xpo-LtlUpdateShipmentForm\"\n  [formGroup]=\"form\"\n>\n  <mat-expansion-panel\n    hideToggle\n    (opened)=\"panelOpenState = true\"\n    (closed)=\"panelOpenState = false\"\n    [expanded]=\"panelOpenState\"\n    class=\"xpo-LtlUpdateShipmentForm__panel\"\n  >\n    <mat-expansion-panel-header>\n      <mat-panel-title class=\"xpo-LtlUpdateShipmentForm__panel-title\" id=\"ltl-panel-title\">\n        <div class=\"xpo-LtlUpdateShipmentForm__panel-title-content\" (click)=\"$event.stopPropagation()\">\n          <div class=\"xpo-LtlUpdateShipmentForm__heading\">\n            <h3 class=\"xpo-LtlUpdateShipmentForm__heading--proNbr\">{{ shipmentId.proNbr | proFormatter: 10 }}</h3>\n            <div class=\"xpo-LtlUpdateShipmentForm__heading--ss\">\n              <xpo-ssi *ngFor=\"let iconName of specialServiceIndicatorIcons\" [name]=\"iconName\"></xpo-ssi>\n            </div>\n            <div class=\"xpo-LtlUpdateShipmentForm__heading--MmLp\">\n              {{ shipmentId.motorMovesNbr | number }} MM, {{ shipmentId.loosePiecesCount | number }} LP\n            </div>\n            <div class=\"xpo-LtlUpdateShipmentForm__heading--weight\">{{ shipmentId.totalWeightLbs | number }} LBS</div>\n            <div class=\"xpo-LtlUpdateShipmentForm__heading--statusUpdate\">\n              <mat-form-field appearance=\"standard\" class=\"xpo-LtlUpdateShipmentForm__status\">\n                <mat-select\n                  (click)=\"$event.stopPropagation()\"\n                  (selectionChange)=\"onChange($event)\"\n                  placeholder=\"Select Status\"\n                  panelClass=\"xpo-LtlUpdateShipmentForm__selectPanel\"\n                  [formControlName]=\"UpdateShipmentStatusFormField.StatusCd\"\n                  xpoSelect\n                >\n                  <mat-option *ngFor=\"let cd of shipmentStatusCdValues\" [value]=\"cd\">\n                    {{ cd | updateShipmentStatusCd }}\n                  </mat-option>\n                </mat-select>\n              </mat-form-field>\n            </div>\n          </div>\n        </div>\n      </mat-panel-title>\n    </mat-expansion-panel-header>\n    <xpo-ltl-child-shipments-grid [formGroup]=\"form\"></xpo-ltl-child-shipments-grid>\n\n    <ng-container *ngIf=\"!!state.displayState\">\n      <div class=\"xpo-LtlUpdateShipmentForm__form\">\n        <div class=\"xpo-LtlUpdateShipmentForm__form--row\">\n          <ng-container *ngIf=\"!suppressDate\">\n            <mat-form-field\n              class=\"xpo-LtlUpdateShipmentForm__form--field xpo-LtlUpdateShipmentForm__date\"\n              floatLabel=\"always\"\n              xpoDatePicker\n            >\n              <mat-label\n                >Date<span class=\"required\" *ngIf=\"state.requiredFields[UpdateShipmentStatusFormField.Date]\">*</span>\n              </mat-label>\n              <input\n                placeholder=\"MM/DD/YYYY\"\n                matInput\n                [min]=\"minDate\"\n                [max]=\"maxDate\"\n                [matDatepicker]=\"datePicker\"\n                [formControlName]=\"UpdateShipmentStatusFormField.Date\"\n              />\n              <mat-datepicker-toggle matSuffix [for]=\"datePicker\">\n                <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>\n              </mat-datepicker-toggle>\n              <mat-datepicker #datePicker></mat-datepicker>\n              <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.Date).hasError('required')\">\n                <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n              </mat-error>\n              <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.Date).hasError('matDatepickerMin')\">\n                <ng-container *ngTemplateOutlet=\"error; context: { message: 'Cannot be before pickup date' }\">\n                </ng-container>\n              </mat-error>\n              <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.Date).hasError('matDatepickerMax')\">\n                <ng-container *ngTemplateOutlet=\"error; context: { message: 'Invalid Date' }\"></ng-container>\n              </mat-error>\n            </mat-form-field>\n          </ng-container>\n          <ng-container *ngIf=\"!state.displayState.suppressTime\">\n            <mat-form-field\n              class=\"xpo-LtlUpdateShipmentForm__form--field xpo-LtlUpdateShipmentForm__time\"\n              floatLabel=\"always\"\n            >\n              <mat-label\n                >Time<span class=\"required\" *ngIf=\"state.requiredFields[UpdateShipmentStatusFormField.Time]\">*</span>\n              </mat-label>\n              <input\n                #timeInputDropDown\n                type=\"text\"\n                placeholder=\"HH:MM\"\n                aria-label=\"HH:MM\"\n                maxlength=\"5\"\n                autocomplete=\"off\"\n                matInput\n                time-input\n                [formControlName]=\"UpdateShipmentStatusFormField.Time\"\n                timeFormatter\n                [xpo-allow-characters]=\"TimeFormatUtil.timeInputValidatorPattern | toRegex\"\n                [matAutocomplete]=\"autoValue\"\n                #trigger=\"matAutocompleteTrigger\"\n              />\n              <mat-autocomplete class=\"dropDown\" #autoValue=\"matAutocomplete\" cdkScrollable>\n                <mat-option *ngFor=\"let option of filteredValueOptions$ | async\" value=\"{{ option.format24 }}\">\n                  {{ option.format12 }}\n                </mat-option>\n              </mat-autocomplete>\n              <mat-icon matSuffix>access_time</mat-icon>\n              <mat-hint>24hr format</mat-hint>\n              <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.Time).hasError('required')\">\n                <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n              </mat-error>\n              <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.Time).errors?.pattern\">\n                <ng-container *ngTemplateOutlet=\"error; context: { message: 'Invalid' }\"></ng-container>\n              </mat-error>\n            </mat-form-field>\n          </ng-container>\n          <ng-container *ngIf=\"!state.displayState.suppressCartageCarrier\">\n            <mat-form-field\n              floatLabel=\"always\"\n              class=\"xpo-LtlUpdateShipmentForm__form--field xpo-LtlUpdateShipmentForm__carrier\"\n            >\n              <mat-label>Cartage Carrier</mat-label>\n              <input\n                type=\"text\"\n                matInput\n                placeholder=\"Carrier Name\"\n                [formControl]=\"cartageCarrier\"\n                [matAutocomplete]=\"carrierAutocomplete\"\n                (blur)=\"onBlurCarrier($event)\"\n                [required]=\"\n                  state.requiredFields[UpdateShipmentStatusFormField.CartageCarrier] ||\n                  form?.get(UpdateShipmentStatusFormField.CartageCarrier)?.hasError('required')\n                \"\n                xpoAutocomplete\n              />\n              <mat-error\n                class=\"no-margin-top\"\n                *ngIf=\"form?.get(UpdateShipmentStatusFormField.CartageCarrier)?.errors as errors\"\n              >\n                <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n              </mat-error>\n              <mat-icon matSuffix>arrow_drop_down</mat-icon>\n              <mat-autocomplete autoActiveFirstOption #carrierAutocomplete [displayWith]=\"carrierDisplayFn\">\n                <mat-option *ngFor=\"let item of filteredItemOptions$ | async\" [value]=\"item\">\n                  {{ item.text }}\n                </mat-option>\n              </mat-autocomplete>\n            </mat-form-field>\n          </ng-container>\n          <ng-container *ngIf=\"!state.displayState.suppressRecipientName\">\n            <mat-form-field\n              class=\"xpo-LtlUpdateShipmentForm__form--field xpo-LtlUpdateShipmentForm__recipientName\"\n              floatLabel=\"always\"\n            >\n              <mat-label\n                >Recipient Name<span\n                  class=\"required\"\n                  *ngIf=\"\n                    state.requiredFields[UpdateShipmentStatusFormField.RecipientName] ||\n                    form?.get(UpdateShipmentStatusFormField.RecipientName).hasError('required')\n                  \"\n                  >*</span\n                >\n              </mat-label>\n              <input\n                [formControlName]=\"UpdateShipmentStatusFormField.RecipientName\"\n                maxlength=\"30\"\n                placeholder=\"Max 30 characters\"\n                matInput\n              />\n              <mat-hint align=\"start\">{{ recipientNameInput?.length || 0 }}/30</mat-hint>\n              <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.RecipientName).hasError('required')\">\n                <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n              </mat-error>\n            </mat-form-field>\n          </ng-container>\n          <ng-container *ngIf=\"!state.displayState.suppressSCAC\">\n            <mat-form-field\n              class=\"xpo-LtlUpdateShipmentForm__form--field xpo-LtlUpdateShipmentForm__scacCode\"\n              floatLabel=\"always\"\n            >\n              <mat-label\n                >SCAC Code<span class=\"required\" *ngIf=\"state.requiredFields[UpdateShipmentStatusFormField.SCACCode]\"\n                  >*</span\n                >\n              </mat-label>\n              <input [formControlName]=\"UpdateShipmentStatusFormField.SCACCode\" maxlength=\"4\" matInput />\n              <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.SCACCode).hasError('required')\">\n                <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n              </mat-error>\n              <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.SCACCode).errors?.pattern\">\n                <ng-container\n                  *ngTemplateOutlet=\"error; context: { message: 'SCAC must be 2-4 characters' }\"\n                ></ng-container>\n              </mat-error>\n            </mat-form-field>\n          </ng-container>\n        </div>\n\n        <ng-container *ngIf=\"!state.displayState.suppressPiecesInfo && !hasChildPro\">\n          <div class=\"xpo-LtlUpdateShipmentForm__piecesInfo\">\n            <h4 class=\"xpo-LtlUpdateShipmentForm__piecesInfo--title\">Pieces Information</h4>\n            <div class=\"xpo-LtlUpdateShipmentForm__form--row\">\n              <mat-form-field class=\"xpo-LtlUpdateShipmentForm__form--field \" floatLabel=\"always\">\n                <mat-label\n                  >Damaged But Accepted<span\n                    class=\"required\"\n                    *ngIf=\"state.requiredFields[UpdateShipmentStatusFormField.DamagedButAccepted]\"\n                    >*</span\n                  >\n                </mat-label>\n                <input type=\"number\" [formControlName]=\"UpdateShipmentStatusFormField.DamagedButAccepted\" matInput />\n                <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.DamagedButAccepted).hasError('required')\">\n                  <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n                </mat-error>\n              </mat-form-field>\n              <mat-form-field class=\"xpo-LtlUpdateShipmentForm__form--field\" floatLabel=\"always\">\n                <mat-label\n                  >Over But Accepted<span\n                    class=\"required\"\n                    *ngIf=\"state.requiredFields[UpdateShipmentStatusFormField.OverButAccepted]\"\n                    >*</span\n                  >\n                </mat-label>\n                <input type=\"number\" [formControlName]=\"UpdateShipmentStatusFormField.OverButAccepted\" matInput />\n                <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.OverButAccepted).hasError('required')\">\n                  <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n                </mat-error>\n              </mat-form-field>\n              <mat-form-field class=\"xpo-LtlUpdateShipmentForm__form--field\" floatLabel=\"always\">\n                <mat-label\n                  >Partial Refused<span\n                    class=\"required\"\n                    *ngIf=\"state.requiredFields[UpdateShipmentStatusFormField.PartialRefused]\"\n                    >*</span\n                  >\n                </mat-label>\n                <input type=\"number\" [formControlName]=\"UpdateShipmentStatusFormField.PartialRefused\" matInput />\n                <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.PartialRefused).hasError('required')\">\n                  <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n                </mat-error>\n              </mat-form-field>\n            </div>\n          </div>\n        </ng-container>\n        <ng-container *ngIf=\"!state.displayState.suppressReason\">\n          <div\n            class=\"xpo-LtlUpdateShipmentForm__form--row\"\n            [class.xpo-LtlUpdateShipmentForm__spacingTop]=\"\n              !!state.displayState.suppressPiecesInfo && !state.displayState.suppressDriverCollect\n            \"\n          >\n            <mat-form-field\n              class=\"xpo-LtlUpdateShipmentForm__form--field xpo-LtlUpdateShipmentForm__reason\"\n              floatLabel=\"always\"\n            >\n              <mat-label\n                >Reason<span class=\"required\" *ngIf=\"state.requiredFields[UpdateShipmentStatusFormField.Reason]\"\n                  >*</span\n                >\n              </mat-label>\n              <mat-select\n                placeholder=\"Select A Reason\"\n                panelClass=\"xpo-LtlUpdateShipmentForm__selectPanel\"\n                [formControlName]=\"UpdateShipmentStatusFormField.Reason\"\n                xpoSelect\n              >\n                <mat-option [value]=\"undefined\"> - </mat-option>\n                <mat-option *ngFor=\"let cd of state.reasonCds\" [value]=\"cd.code\"> {{ cd.value }} </mat-option>\n              </mat-select>\n              <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.Reason).hasError('required')\">\n                <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n              </mat-error>\n            </mat-form-field>\n          </div>\n        </ng-container>\n        <ng-container *ngIf=\"!state.displayState.suppressExceptionNote || !state.displayState.suppressShortPieces\">\n          <div\n            [class.xpo-LtlUpdateShipmentForm__spacingTop]=\"\n              !!state.displayState.suppressPiecesInfo && !state.displayState.suppressDriverCollect\n            \"\n            class=\"xpo-LtlUpdateShipmentForm__form--row\"\n          >\n            <ng-container *ngIf=\"!state.displayState.suppressExceptionNote\">\n              <mat-form-field\n                floatLabel=\"always\"\n                class=\"xpo-LtlUpdateShipmentForm__form--field xpo-LtlUpdateShipmentForm__exceptionNote\"\n              >\n                <mat-label\n                  >Exception Note<span\n                    class=\"required\"\n                    *ngIf=\"state.requiredFields[UpdateShipmentStatusFormField.ExceptionNote]\"\n                    >*</span\n                  ></mat-label\n                >\n                <textarea\n                  [formControlName]=\"UpdateShipmentStatusFormField.ExceptionNote\"\n                  rows=\"4\"\n                  maxlength=\"250\"\n                  placeholder=\"Max 250 characters\"\n                  matInput\n                ></textarea>\n                <mat-hint align=\"start\">{{ exceptionNoteInput?.length || 0 }}/250</mat-hint>\n                <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.ExceptionNote).hasError('required')\">\n                  <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n                </mat-error>\n              </mat-form-field>\n            </ng-container>\n            <ng-container *ngIf=\"!state.displayState.suppressShortPieces\">\n              <mat-form-field class=\"xpo-LtlUpdateShipmentForm__form--field\" floatLabel=\"always\">\n                <mat-label\n                  >Short Pieces<span\n                    class=\"required\"\n                    *ngIf=\"state.requiredFields[UpdateShipmentStatusFormField.ShortPieces]\"\n                    >*</span\n                  >\n                </mat-label>\n                <input type=\"number\" [formControlName]=\"UpdateShipmentStatusFormField.ShortPieces\" matInput />\n                <mat-error *ngIf=\"form?.get(UpdateShipmentStatusFormField.ShortPieces).hasError('required')\">\n                  <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n                </mat-error>\n              </mat-form-field>\n            </ng-container>\n          </div>\n        </ng-container>\n        <ng-container *ngIf=\"!state.displayState.suppressDriverCollect\">\n          <div class=\"xpo-LtlUpdateShipmentForm__form--row\">\n            <mat-expansion-panel hideToggle expanded class=\"xpo-LtlUpdateShipmentForm__driverCollect\">\n              <mat-expansion-panel-header>\n                <mat-panel-title class=\"xpo-LtlUpdateShipmentForm__driverCollect--title\">\n                  Driver Collect Information\n                </mat-panel-title>\n              </mat-expansion-panel-header>\n              <ng-container\n                *ngTemplateOutlet=\"\n                  driverCollectItemTemplate;\n                  context: {\n                    title: 'Freight Charges',\n                    paymentField: UpdateShipmentStatusFormField.FreightChargesPaymentMethod,\n                    amountField: UpdateShipmentStatusFormField.FreightChargesDollarAmount,\n                    checkNbrField: UpdateShipmentStatusFormField.FreightChargesCheckNbr,\n                    requiredFields: state.requiredFields,\n                    paymentMethodCdValues: freightChargeMethodCdValues\n                  }\n                \"\n              >\n              </ng-container>\n              <ng-container\n                *ngTemplateOutlet=\"\n                  driverCollectItemTemplate;\n                  context: {\n                    title: 'Cash on Delivery',\n                    paymentField: UpdateShipmentStatusFormField.CashOnDeliveryPaymentMethod,\n                    amountField: UpdateShipmentStatusFormField.CashOnDeliveryDollarAmount,\n                    checkNbrField: UpdateShipmentStatusFormField.CashOnDeliveryCheckNbr,\n                    requiredFields: state.requiredFields,\n                    paymentMethodCdValues: codChargeMethodCdValues\n                  }\n                \"\n              >\n              </ng-container>\n            </mat-expansion-panel>\n          </div>\n        </ng-container>\n      </div>\n    </ng-container>\n  </mat-expansion-panel>\n</div>\n\n<ng-template #error let-message=\"message\">\n  <span class=\"xpo-LtlUpdateShipmentForm__error\">\n    <mat-icon>warning</mat-icon><span>{{ message }}</span>\n  </span>\n</ng-template>\n\n<ng-template\n  #driverCollectItemTemplate\n  let-requiredFields=\"requiredFields\"\n  let-title=\"title\"\n  let-paymentField=\"paymentField\"\n  let-amountField=\"amountField\"\n  let-checkNbrField=\"checkNbrField\"\n  let-paymentMethodCdValues=\"paymentMethodCdValues\"\n>\n  <div class=\"xpo-LtlUpdateShipmentForm__driverCollect--row\" [formGroup]=\"form\">\n    <h3 class=\"xpo-LtlUpdateShipmentForm__driverCollect--title\">{{ title }}</h3>\n    <div class=\"xpo-LtlUpdateShipmentForm__driverCollect--fields\">\n      <mat-form-field\n        appearance=\"standard\"\n        class=\"xpo-LtlUpdateShipmentForm__pmtMethod xpo-LtlUpdateShipmentForm__form--field\"\n        floatLabel=\"always\"\n      >\n        <mat-label class=\"xpo-LtlUpdateShipmentForm__driverCollect--label\"\n          >Payment Method<span class=\"required\" *ngIf=\"requiredFields[paymentField]\">*</span></mat-label\n        >\n        <mat-select\n          placeholder=\"Select Method\"\n          panelClass=\"xpo-LtlUpdateShipmentForm__selectPanel\"\n          [formControlName]=\"paymentField\"\n          xpoSelect\n        >\n          <mat-option [value]=\"undefined\"> - </mat-option>\n          <mat-option *ngFor=\"let method of paymentMethodCdValues\" [value]=\"method\">\n            {{ method | miscLineItemPaymentMethod }}</mat-option\n          >\n        </mat-select>\n        <mat-error *ngIf=\"form?.get(paymentField).hasError('required')\">\n          <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n        </mat-error>\n      </mat-form-field>\n      <mat-form-field\n        floatLabel=\"always\"\n        class=\"xpo-LtlUpdateShipmentForm__dollarAmt xpo-LtlUpdateShipmentForm__form--field\"\n      >\n        <span matPrefix>$&nbsp;</span>\n        <mat-label\n          >Dollar Amount<span\n            class=\"required\"\n            *ngIf=\"form?.get(amountField).hasError('required') || form?.get(amountField).hasError('amountRequired')\"\n            >*</span\n          ></mat-label\n        >\n        <input currencyFormatter [formControlName]=\"amountField\" matInput />\n        <mat-error\n          *ngIf=\"form?.get(amountField).hasError('required') || form?.get(amountField).hasError('amountRequired')\"\n        >\n          <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n        </mat-error>\n      </mat-form-field>\n      <mat-form-field\n        floatLabel=\"always\"\n        class=\"xpo-LtlUpdateShipmentForm__checkNbr xpo-LtlUpdateShipmentForm__form--field\"\n      >\n        <mat-label>Check Number<span class=\"required\" *ngIf=\"requiredFields[checkNbrField]\">*</span></mat-label>\n        <input [formControlName]=\"checkNbrField\" matInput />\n        <mat-error *ngIf=\"form?.get(checkNbrField).hasError('required')\">\n          <ng-container *ngTemplateOutlet=\"error; context: { message: 'Required' }\"></ng-container>\n        </mat-error>\n        <mat-error *ngIf=\"form?.get(checkNbrField).hasError('maxlength')\">\n          <ng-container *ngTemplateOutlet=\"error; context: { message: 'Cannot be more than 8 characters' }\">\n          </ng-container>\n        </mat-error>\n      </mat-form-field>\n    </div>\n  </div>\n</ng-template>\n", styles: [".flex--stretch{flex:1}.xpo-LtlUpdateShipmentForm{border:1px solid #d8d8d8;background-color:#fafafa;padding:8px}.xpo-LtlUpdateShipmentForm__panel{border:none;background-color:#fafafa}.xpo-LtlUpdateShipmentForm__panel .mat-expansion-panel-content>.mat-expansion-panel-body{padding:0 12px 8px 36px}.xpo-LtlUpdateShipmentForm__panel .mat-expansion-panel-header.mat-expanded,.xpo-LtlUpdateShipmentForm__panel .mat-expansion-panel-header.mat-expanded:focus,.xpo-LtlUpdateShipmentForm__panel .mat-expansion-panel-header.mat-expanded:hover{background-color:#fafafa}.xpo-LtlUpdateShipmentForm__panel-margin .mat-content:before{margin-top:-27px}.xpo-LtlUpdateShipmentForm__panel-title{display:block;margin-right:-16px;width:100%}.xpo-LtlUpdateShipmentForm__panel-title-content{width:100%}.xpo-LtlUpdateShipmentForm__heading{display:flex;flex:1 1 auto;justify-content:space-between;align-items:center}.xpo-LtlUpdateShipmentForm__heading--ss{display:flex;align-items:center}.xpo-LtlUpdateShipmentForm__heading--statusUpdate{padding-top:8px}.xpo-LtlUpdateShipmentForm__heading--statusUpdate .mat-form-field{margin:0}.xpo-LtlUpdateShipmentForm__heading--proNbr{line-height:24px;letter-spacing:0}.xpo-LtlUpdateShipmentForm__heading--MmLp,.xpo-LtlUpdateShipmentForm__heading--weight{color:#333}.xpo-LtlUpdateShipmentForm__form{border-top:1px solid #d8d8d8;padding-top:16px}.xpo-LtlUpdateShipmentForm__form--field{padding-right:16px}.xpo-LtlUpdateShipmentForm__form--row{display:flex}.xpo-LtlUpdateShipmentForm__status{width:259px}.xpo-LtlUpdateShipmentForm__date{width:156px}.xpo-LtlUpdateShipmentForm__time{width:108px}.xpo-LtlUpdateShipmentForm__carrier,.xpo-LtlUpdateShipmentForm__recipientName{width:296px}.xpo-LtlUpdateShipmentForm__carrier-sic{width:140px}.xpo-LtlUpdateShipmentForm__scacCode{width:110px}.xpo-LtlUpdateShipmentForm__pmtMethod{width:164px}.xpo-LtlUpdateShipmentForm__pmtMethod ::ng-deep .mat-form-field-label-wrapper{font-size:18px;top:-22px}.xpo-LtlUpdateShipmentForm__dollarAmt{width:166px}.xpo-LtlUpdateShipmentForm__dollarAmt input.mat-input-element{text-align:right}.xpo-LtlUpdateShipmentForm__dollarAmt ::ng-deep .mat-form-field-label-wrapper{left:-16px}.xpo-LtlUpdateShipmentForm__chkNbr{width:132px}.xpo-LtlUpdateShipmentForm__exceptionNote{width:100%}.xpo-LtlUpdateShipmentForm__reason{width:350px}.xpo-LtlUpdateShipmentForm__driverCollect{background-color:#fafafa;border:1px solid #d8d8d8;flex:1 1 auto}.xpo-LtlUpdateShipmentForm__driverCollect--title{padding-bottom:16px}.xpo-LtlUpdateShipmentForm__driverCollect--fields{display:flex}.xpo-LtlUpdateShipmentForm ::ng-deep .mat-form-field-required-marker{color:#d32f2f}.xpo-LtlUpdateShipmentForm__spacingTop{padding-top:16px}.xpo-LtlUpdateShipmentForm__error{display:flex}.xpo-LtlUpdateShipmentForm .required{color:#d32f2f}.xpo-LtlUpdateShipmentForm span.required{padding-left:4px}"], components: [{ type: i7$3.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { type: i7$3.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { type: i6$2.XpoSsi, selector: "xpo-ssi", inputs: ["name", "status"] }, { type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i4$4.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: ChildShipmentsGridComponent, selector: "xpo-ltl-child-shipments-grid", inputs: ["isCartageAgent", "tripNodeStatus", "id", "formGroup"] }, { type: i11.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["tabIndex", "disabled", "for", "aria-label", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i11.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { type: i13.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7$3.MatExpansionPanelTitle, selector: "mat-panel-title" }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i16.XpoDisableOptionCenteringDirective, selector: "mat-select" }, { type: i16.XpoSelectDirective, selector: "[xpo-select], [xpoSelect]" }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i7.MatLabel, selector: "mat-label" }, { type: i21.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i11.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i7.MatSuffix, selector: "[matSuffix]" }, { type: i11.MatDatepickerToggleIcon, selector: "[matDatepickerToggleIcon]" }, { type: i7.MatError, selector: "mat-error", inputs: ["id"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i13.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i2$2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: TimeFormatterDirective, selector: "[timeFormatter]" }, { type: XpoAllowCharactersDirective, selector: "[xpo-allow-characters]", inputs: ["xpo-allow-characters"] }, { type: i20$1.CdkScrollable, selector: "[cdk-scrollable], [cdkScrollable]" }, { type: i7.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { type: i16.XpoAutocompleteInternalActiveNavigation, selector: "[xpoAutocomplete] , [xpo-autocomplete]", inputs: ["xpoOptionHeight", "xpoPanelHeight"] }, { type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i2$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i2$2.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { type: i7.MatPrefix, selector: "[matPrefix]" }, { type: CurrencyFormatterDirective, selector: "[currencyFormatter]" }], pipes: { "async": i5.AsyncPipe, "proFormatter": ProFormatterPipe, "number": i5.DecimalPipe, "updateShipmentStatusCd": UpdateShipmentStatusCdPipe, "toRegex": ToRegexPipe, "miscLineItemPaymentMethod": MiscLineItemPaymentMethodCdPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentFormComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-update-shipment-form',
                    templateUrl: './update-shipment-form.component.html',
                    styleUrls: ['./update-shipment-form.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: UpdateShipmentStatusDisplayConfigService }, { type: UpdateShipmentStatusFormService }, { type: UpdateShipmentStatusService }, { type: XpoLtlServiceCentersService }]; }, propDecorators: { dropdown: [{
                type: ViewChild,
                args: ['timeInputDropDown', { read: MatAutocompleteTrigger }]
            }], shipmentId: [{
                type: Input
            }], suppressDate: [{
                type: Input
            }], form: [{
                type: Input
            }], reportingSic: [{
                type: Input
            }] } });

class XpoLtlUpdateShipmentStatusDialogData {
}

var UserPreferenceSicKey;
(function (UserPreferenceSicKey) {
    UserPreferenceSicKey["PREFERECE_SIC"] = "PreferenceSic";
})(UserPreferenceSicKey || (UserPreferenceSicKey = {}));

class XpoLtlUpdateShipmentComponent {
    constructor() {
        this.showRemove = true;
        this.remove = new EventEmitter();
        this.removeChildPro = new EventEmitter();
        this.customerNamePrimary = '';
        this.customerNameSecondary = '';
        this.customerAddressPrimary = '';
        this.customerAddressSecondary = '';
        this.showSoftWarningMessage = false;
    }
    ngOnInit() {
        this.buildCustomerInfo();
        this.initFormErrorsWatcher();
    }
    buildCustomerInfo() {
        const { customerCity, customerState, customerName, customerMadCd, customerAddress, customerZip } = this.shipmentId;
        let customerAddressSecondary = customerCity !== null && customerCity !== void 0 ? customerCity : '';
        if (customerState) {
            customerAddressSecondary += `, ${customerState !== null && customerState !== void 0 ? customerState : ''}`;
        }
        customerAddressSecondary += ` ${customerZip !== null && customerZip !== void 0 ? customerZip : ''}`;
        this.customerNamePrimary = customerName;
        this.customerNameSecondary = customerMadCd;
        this.customerAddressPrimary = customerAddress;
        this.customerAddressSecondary = customerAddressSecondary;
    }
    initFormErrorsWatcher() {
        this.formErrors$ = this.form.statusChanges.pipe(startWith(this.form.status), map(() => {
            var _a;
            const formErrors = (_a = this.form.errors) !== null && _a !== void 0 ? _a : {};
            const apiSoftWarning = formErrors === null || formErrors === void 0 ? void 0 : formErrors.softWarning;
            const softWarningMessage = apiSoftWarning !== null && apiSoftWarning !== void 0 ? apiSoftWarning : '';
            this.showSoftWarningMessage = !!softWarningMessage;
            return Object.keys(formErrors).length ? formErrors : undefined;
        }));
    }
    onRemoveShipment() {
        this.remove.emit(this.shipmentId.shipmentInstId);
    }
    cancelChildPro() {
        this.showSoftWarningMessage = false;
    }
    confirmChildPro() {
        this.showSoftWarningMessage = false;
        this.removeChildPro.emit(this.shipmentId.shipmentInstId);
    }
}
XpoLtlUpdateShipmentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
XpoLtlUpdateShipmentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlUpdateShipmentComponent, selector: "xpo-ltl-update-shipment", inputs: { shipmentId: "shipmentId", form: "form", config: "config", showRemove: "showRemove", reportingSic: "reportingSic" }, outputs: { remove: "remove", removeChildPro: "removeChildPro" }, ngImport: i0, template: "<xpo-card class=\"xpo-LtlUpdateShipment\">\n  <xpo-card-content class=\"xpo-LtlUpdateShipment__content\">\n    <div class=\"xpo-LtlUpdateShipment__content--heading\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          headingItemTemplate;\n          context: { title: 'CUSTOMER', primaryInfo: customerNamePrimary, secondaryInfo: customerNameSecondary }\n        \"\n      >\n      </ng-container>\n      <ng-container\n        *ngTemplateOutlet=\"\n          headingItemTemplate;\n          context: { title: 'ADDRESS', primaryInfo: customerAddressPrimary, secondaryInfo: customerAddressSecondary }\n        \"\n      >\n      </ng-container>\n      <ng-container\n        *ngTemplateOutlet=\"\n          headingItemTemplate;\n          context: {\n            title: 'CURRENT STATUS',\n            primaryInfo: shipmentId?.deliveryQualifierCd | deliveryQualifierCd,\n            secondaryInfo: undefined\n          }\n        \"\n      >\n      </ng-container>\n      <ng-container *ngIf=\"showRemove\">\n        <button (click)=\"onRemoveShipment()\" mat-icon-button>\n          <xpo-icon iconName=\"remove-alt\"></xpo-icon>\n        </button>\n      </ng-container>\n    </div>\n    <ng-container *ngIf=\"formErrors$ | async as formErrors\">\n      <div class=\"xpo-LtlUpdateShipment__content--errors\">\n        <ng-container *ngIf=\"formErrors.softWarning as error\">\n          <div *ngIf=\"error && showSoftWarningMessage\" class=\"xpo-LtlUpdateShipment__content--warning\">\n            <xpo-status-indicator statusColor=\"#FFD700\"></xpo-status-indicator>\n            <span>\n              The number of child PRO(s) do not match to the number of MM and LP. <strong>Okay to continue?</strong>\n            </span>\n            <xpo-button-group>\n              <button mat-flat-button xpoSmallButton xpoButton (click)=\"confirmChildPro()\">YES</button>\n              <button mat-stroked-button xpoSmallButton xpoButton (click)=\"cancelChildPro()\">NO</button>\n            </xpo-button-group>\n          </div>\n        </ng-container>\n        <ng-container *ngIf=\"formErrors.apiUpdateError as error\">\n          <div *ngIf=\"error.error\" class=\"xpo-LtlUpdateShipment__content--error\">\n            <xpo-icon iconName=\"error\"></xpo-icon>{{ error.error }}\n          </div>\n        </ng-container>\n        <ng-container *ngIf=\"formErrors.routedShipment\">\n          <div class=\"xpo-LtlUpdateShipment__content--error\">\n            <xpo-icon iconName=\"error\"></xpo-icon>Unable to update status for shipment currently on a route.\n          </div>\n        </ng-container>\n\n        <ng-container *ngIf=\"formErrors.noStatusUpdate\">\n          <div class=\"xpo-LtlUpdateShipment__content--error\">\n            <xpo-icon iconName=\"error\"></xpo-icon>\n            Unable to update shipment with status\n            {{ shipmentId.deliveryQualifierCd | deliveryQualifierCd }}.\n          </div>\n        </ng-container>\n      </div>\n    </ng-container>\n    <ng-container *ngIf=\"!shipmentId?.billInd\">\n      <div class=\"xpo-LtlUpdateShipment__content--error\">\n        <xpo-icon iconName=\"error\"></xpo-icon>PRO not billed. Use SCAC \"CNWY\" to update this shipment.\n      </div>\n    </ng-container>\n    <div class=\"xpo-LtlUpdateShipment__content--form\">\n      <xpo-ltl-update-shipment-form\n        [form]=\"form\"\n        [shipmentId]=\"shipmentId\"\n        [suppressDate]=\"config?.suppressDate\"\n        [reportingSic]=\"reportingSic\"\n      >\n      </xpo-ltl-update-shipment-form>\n    </div>\n  </xpo-card-content>\n</xpo-card>\n\n<ng-template #headingItemTemplate let-title=\"title\" let-primaryInfo=\"primaryInfo\" let-secondaryInfo=\"secondaryInfo\">\n  <div class=\"xpo-LtlUpdateShipment__headingItem\">\n    <div class=\"xpo-LtlUpdateShipment__headingItem--title\">{{ title }}</div>\n    <ng-container *ngIf=\"primaryInfo\">\n      <div class=\"xpo-LtlUpdateShipment__headingItem--primaryInfo\">{{ primaryInfo }}</div>\n    </ng-container>\n    <ng-container *ngIf=\"secondaryInfo\">\n      <div class=\"xpo-LtlUpdateShipment__headingItem--secondaryInfo\">{{ secondaryInfo }}</div>\n    </ng-container>\n  </div>\n</ng-template>\n", styles: [".flex--stretch{flex:1}.xpo-LtlUpdateShipment__content--heading{display:flex;justify-content:space-evenly;padding-bottom:16px}.xpo-LtlUpdateShipment__content--form{padding-left:8px}.xpo-LtlUpdateShipment__content--errors{color:#d32f2f;padding-bottom:8px}.xpo-LtlUpdateShipment__content--error{color:#d32f2f;display:flex;align-items:center}.xpo-LtlUpdateShipment__content--error xpo-icon{margin-right:8px}.xpo-LtlUpdateShipment__content--warning{color:#000;display:flex;align-items:center;gap:10px}.xpo-LtlUpdateShipment__headingItem{width:30%}.xpo-LtlUpdateShipment__headingItem--title{color:#6f6f6f;font-size:.875rem}.xpo-LtlUpdateShipment__headingItem--primaryInfo{color:#212121}.xpo-LtlUpdateShipment__headingItem--secondaryInfo{color:#212121;font-size:.875rem}"], components: [{ type: i1$9.XpoCard, selector: "xpo-card", inputs: ["status", "type", "color"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i1$7.XpoIcon, selector: "xpo-icon", inputs: ["iconName"] }, { type: i2$7.XpoStatusIndicator, selector: "xpo-status-indicator", inputs: ["isLabel", "statusText", "statusColor"] }, { type: i5$3.XpoButtonGroup, selector: "xpo-button-group" }, { type: UpdateShipmentFormComponent, selector: "xpo-ltl-update-shipment-form", inputs: ["shipmentId", "suppressDate", "form", "reportingSic"] }], directives: [{ type: i1$9.XpoCardContent, selector: "xpo-card-content" }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5$3.XpoSmallButton, selector: "[xpo-small-button], [xpoSmallButton]" }, { type: i5$3.XpoButton, selector: "[xpo-button], [xpoButton]" }], pipes: { "deliveryQualifierCd": DeliveryQualifierCdPipe, "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-update-shipment',
                    templateUrl: './update-shipment.component.html',
                    styleUrls: ['./update-shipment.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { shipmentId: [{
                type: Input
            }], form: [{
                type: Input
            }], config: [{
                type: Input
            }], showRemove: [{
                type: Input
            }], reportingSic: [{
                type: Input
            }], remove: [{
                type: Output
            }], removeChildPro: [{
                type: Output
            }] } });

var DisplayState;
(function (DisplayState) {
    DisplayState["init"] = "init";
    DisplayState["error"] = "error";
    DisplayState["showShipments"] = "showShipments";
})(DisplayState || (DisplayState = {}));
class XpoLtlUpdateShipmentStatusComponent {
    constructor(updateShipmentStatusService, formService, xpoSnackbar, confirmDialog, serviceCenterService, loggedInUserService, configManagerService, userPreferencesService) {
        this.updateShipmentStatusService = updateShipmentStatusService;
        this.formService = formService;
        this.xpoSnackbar = xpoSnackbar;
        this.confirmDialog = confirmDialog;
        this.serviceCenterService = serviceCenterService;
        this.loggedInUserService = loggedInUserService;
        this.configManagerService = configManagerService;
        this.userPreferencesService = userPreferencesService;
        this.UpdateShipmentStatusFormField = UpdateShipmentStatusFormField;
        this.unsubscriber = new Unsubscriber();
        this.DisplayState = DisplayState;
        this.previousFilterTerm = undefined;
        this.selectedShipmentSubject = new BehaviorSubject(undefined);
        this.selectedShipment$ = this.selectedShipmentSubject
            .asObservable()
            .pipe(distinctUntilChanged((a, b) => (a === null || a === void 0 ? void 0 : a.shipmentInstId) === (b === null || b === void 0 ? void 0 : b.shipmentInstId)));
        this.displayStateSubject = new BehaviorSubject(DisplayState.init);
        this.displayState$ = this.displayStateSubject.asObservable();
        this.scrollPositionSubject = new Subject();
        this.scrollPosition$ = this.scrollPositionSubject.asObservable();
        this.updateErrorsSubject = new BehaviorSubject(undefined);
        this.updateErrors$ = this.updateErrorsSubject.asObservable();
        this.close = new EventEmitter();
        this.removeShipment = new EventEmitter();
        this.UpdateShipmentsStatusFormField = UpdateShipmentsStatusFormField;
        this.shipments$ = this.updateShipmentStatusService.shipments$;
        this.canSubmit$ = of(false);
        this.serviceCenterListSubject = new BehaviorSubject([]);
        this.serviceCenterList$ = this.serviceCenterListSubject.asObservable();
    }
    get selectedShipment() {
        return this.selectedShipmentSubject.value;
    }
    onKeydownHandler(event) {
        event.preventDefault();
        this.onClose();
    }
    canClose() {
        const isFormPristine = !!isEqual(this.form.getRawValue(), this.pristineFormValues);
        return isFormPristine;
    }
    ngOnInit() {
        this.loading$ = combineLatest([this.updateShipmentStatusService.isLoading$, this.displayState$]).pipe(map(([loading, state]) => !!loading || state === DisplayState.init));
        this.updateShipmentStatusService.loadShipments$(this.shipmentIds).subscribe({
            next: (shipments) => {
                this.selectedShipmentSubject.next(shipments[0]);
                this.form = this.formService.createForm(shipments);
                this.pristineFormValues = this.form.getRawValue();
                this.shipmentsFormArray = this.form.get(UpdateShipmentsStatusFormField.Shipments);
                this.canSubmit$ = combineLatest([
                    this.updateShipmentStatusService.isLoading$,
                    this.form.statusChanges.pipe(map((status) => status === FormStatus.Valid), startWith(false)),
                ]).pipe(map(([loading, isValid]) => !loading && isValid));
                this.displayStateSubject.next(DisplayState.showShipments);
                this.setServiceCenterList();
            },
            error: () => {
                this.displayStateSubject.next(DisplayState.error);
            },
        });
        this.subscribeToScrollPositionUpdates();
    }
    setServiceCenterList() {
        combineLatest([
            this.serviceCenterService.serviceCenters$,
            this.loggedInUserService.getLoggedInUser(this.configManagerService.getSetting(ConfigManagerProperties$1.loggedInUserRoot)),
            this.userPreferencesService.getPreferencesFor(UserPreferenceSicKey.PREFERECE_SIC),
        ])
            .pipe(take(1), map(([serviceCenters, user, preferenceSic]) => {
            this.serviceCenterListSubject.next(serviceCenters);
            const userPreferenceSic = serviceCenters.find((sic) => sic.sicCd === preferenceSic);
            const userDomicileSic = serviceCenters.find((sic) => sic.sicCd === user.sicCode);
            if (userPreferenceSic) {
                this.form.get(UpdateShipmentStatusFormField.ReportingSic).patchValue(userPreferenceSic);
            }
            else if (userDomicileSic) {
                this.form.get(UpdateShipmentStatusFormField.ReportingSic).patchValue(userPreferenceSic);
            }
            else {
                this.form.get(UpdateShipmentStatusFormField.ReportingSic).setValidators(Validators.required);
                this.form.get(UpdateShipmentStatusFormField.ReportingSic).updateValueAndValidity();
            }
        }), distinctUntilChanged())
            .subscribe();
    }
    onShipmentSelectionChange(shipmentId) {
        var _a;
        const shipmentEl = this.updateShipmentComponents.find((elRef) => {
            return elRef.nativeElement.id === `${shipmentId.shipmentInstId}`;
        });
        this.selectedShipmentSubject.next(shipmentId);
        (_a = shipmentEl === null || shipmentEl === void 0 ? void 0 : shipmentEl.nativeElement) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'end', inline: 'center' });
    }
    onClose() {
        if (this.canClose()) {
            this.close.emit();
        }
        else {
            if (this.openDialogRef$) {
                return;
            }
            this.openDialogRef$ = this.confirmDialog.confirm('All changes will be lost and updates to these Shipment statuses will not be applied.', 'Do you want to discard the changes?', {
                confirmButtonText: 'Discard Changes',
                rejectButtonText: 'Continue Updating',
            });
            this.openDialogRef$.pipe(take(1)).subscribe((confirmClose) => {
                if (confirmClose) {
                    this.close.emit();
                }
                this.openDialogRef$ = undefined;
            });
        }
    }
    onUpdate(onConfirmChildPro) {
        var _a;
        FormUtils.markAsTouchedAndDirty(this.form, true);
        // FormUtils.updateDescendantControlsValueAndValidity(this.form); //TODO commented to avoid invalid behavior on grid, testing what is the side effects on current implementation
        const formErrors = onConfirmChildPro ? [] : FormUtils.getControlsWithErrors(this.form);
        if (!formErrors.length) {
            const shipmentsArray = this.form.get(UpdateShipmentsStatusFormField.Shipments);
            const shipmentValues = shipmentsArray.getRawValue();
            const childProShipment = shipmentValues.find((shipment) => shipment.id === onConfirmChildPro);
            const reportingSicCd = (_a = this.form.get(UpdateShipmentStatusFormField.ReportingSic)) === null || _a === void 0 ? void 0 : _a.value;
            const shipmentsFormArray = onConfirmChildPro ? [childProShipment] : shipmentValues;
            this.updateShipmentStatusService
                .updateShipmentStatuses$(shipmentsFormArray, reportingSicCd.sicCd ? reportingSicCd.sicCd : '', onConfirmChildPro)
                .subscribe((resp) => {
                const { success, errors } = resp;
                const allUpdatesSuccessful = !!success.length && !errors.length;
                const partialUpdatesSuccessful = !!success.length && !!errors.length;
                const errorsMap = keyBy(errors, (error) => error.shipmentInstId);
                const successMap = keyBy(success, (res) => res.shipmentInstId);
                let showSnackBar = true;
                let status;
                let message = '';
                // all success
                if (allUpdatesSuccessful) {
                    const shipmentsCount = this.getSoftWarningsCounts(shipmentsArray, successMap, success);
                    showSnackBar = !!shipmentsCount;
                    status = 'success';
                    message = `Succesfully updated status for ${shipmentsCount} shipment(s).`;
                    this.removeShipmentId(successMap, success, onConfirmChildPro);
                }
                else if (partialUpdatesSuccessful) {
                    const shipmentsCount = this.getSoftWarningsCounts(shipmentsArray, successMap, success);
                    message = shipmentsCount
                        ? `Succesfully updated status for ${shipmentsCount} shipment(s). ${errors.length} shipment(s) were unable to be updated.`
                        : `${errors.length} shipment(s) were unable to be updated.`;
                    status = 'warn';
                    this.removeShipmentId(successMap, success, onConfirmChildPro);
                }
                else {
                    status = 'error';
                    message = `Unable to update status for shipments. Please review errors.`;
                }
                shipmentsArray.controls.forEach((shipmentFormGroup) => {
                    var _a;
                    const shipmentInstId = shipmentFormGroup.get(UpdateShipmentStatusFormField.ID).value;
                    const shipmentIdError = errorsMap[+shipmentInstId];
                    const shipmentIdSoftMessage = (_a = successMap[+shipmentInstId]) === null || _a === void 0 ? void 0 : _a.softMessage;
                    if (shipmentIdError) {
                        const existingErrors = shipmentFormGroup.errors || {};
                        const nextErrorState = Object.assign({ apiUpdateError: shipmentIdError }, existingErrors);
                        shipmentFormGroup.setErrors(nextErrorState);
                    }
                    if (!shipmentIdError && shipmentIdSoftMessage) {
                        const softWarning = { softWarning: shipmentIdSoftMessage };
                        shipmentFormGroup.setErrors(softWarning);
                    }
                    if (reportingSicCd.sicCd !== '') {
                        this.userPreferencesService
                            .updatePreferencesFor(UserPreferenceSicKey.PREFERECE_SIC, reportingSicCd.sicCd)
                            .subscribe();
                    }
                });
                if (showSnackBar) {
                    this.xpoSnackbar.open({
                        message,
                        status,
                        matConfig: {
                            verticalPosition: 'bottom',
                            duration: status === 'error' ? 0 : 5000,
                        },
                    });
                }
                if (allUpdatesSuccessful) {
                    let hasSoftMessage;
                    const formValues = this.form.getRawValue();
                    hasSoftMessage = shipmentsArray.controls.some((element) => {
                        var _a;
                        const shipmentInstId = element.get(UpdateShipmentStatusFormField.ID).value;
                        const shipmentIdSoftMessage = (_a = successMap[+shipmentInstId]) === null || _a === void 0 ? void 0 : _a.softMessage;
                        return !!shipmentIdSoftMessage;
                    });
                    if (!hasSoftMessage && formValues.shipments.length === 0) {
                        this.close.emit(resp);
                    }
                }
            });
        }
        else {
            this.showErrorsOnSave();
        }
    }
    getSoftWarningsCounts(shipmentsArray, successMap, successResponse) {
        const softWarningsCounts = shipmentsArray.controls.reduce((acum, current) => {
            var _a;
            const shipmentInstId = current.get(UpdateShipmentStatusFormField.ID).value;
            const shipmentIdSoftMessage = (_a = successMap[+shipmentInstId]) === null || _a === void 0 ? void 0 : _a.softMessage;
            return shipmentIdSoftMessage ? (acum += 1) : (acum += 0);
        }, 0);
        return successResponse.length - softWarningsCounts;
    }
    removeShipmentId(successMap, successResponse, onConfirmChildPro) {
        successResponse.forEach((successId) => {
            var _a;
            const shipmentId = successId.shipmentInstId;
            const softWarningMessage = (_a = successMap[+shipmentId]) === null || _a === void 0 ? void 0 : _a.softMessage;
            if (!softWarningMessage) {
                this.onRemove(shipmentId);
            }
            else if (softWarningMessage && shipmentId === onConfirmChildPro) {
                this.onRemove(shipmentId);
            }
        });
    }
    onScroll(scrollEvent) {
        this.scrollPositionSubject.next(scrollEvent);
    }
    showErrorsOnSave() {
        this.xpoSnackbar.open({
            message: 'Unable to update. Please check shipments errors',
            status: 'error',
            matConfig: {
                verticalPosition: 'bottom',
                duration: 0,
            },
        });
    }
    subscribeToScrollPositionUpdates() {
        this.scrollPosition$.pipe(debounceTime(200), takeUntil(this.unsubscriber.done$)).subscribe((event) => {
            this.handleScrollUpdates(event);
        });
    }
    handleScrollUpdates(event) {
        const currentScrollPostition = event.target['scrollTop'];
        let activeShipmentId;
        let activeShipmentElement;
        if (currentScrollPostition + event.target['offsetHeight'] >= event.target['scrollHeight']) {
            activeShipmentElement = this.updateShipmentComponents.last;
        }
        else {
            const allShipments = this.updateShipmentComponents.toArray();
            this.updateShipmentComponents.forEach((el, i) => {
                if (allShipments.length > 0) {
                    let nextShipment;
                    if (i + 1 < allShipments.length) {
                        nextShipment = allShipments[i + 1];
                        if (currentScrollPostition >= el.nativeElement.parentElement.offsetTop &&
                            currentScrollPostition < nextShipment.nativeElement.parentElement.offsetTop) {
                            activeShipmentElement = nextShipment;
                        }
                    }
                }
            });
            if (allShipments.length > 0) {
                if (allShipments[0].nativeElement.parentElement.offsetTop >= currentScrollPostition) {
                    activeShipmentElement = allShipments[0];
                }
                else if (allShipments[allShipments.length - 1].nativeElement.parentElement.offsetTop === currentScrollPostition) {
                    activeShipmentElement = allShipments[allShipments.length - 1];
                }
            }
        }
        // if still no element found, assume first id is active
        if (!activeShipmentElement) {
            activeShipmentElement = this.updateShipmentComponents.first;
        }
        this.updateShipmentStatusService.shipments$
            .pipe(take(1))
            .subscribe((shipments) => {
            activeShipmentId = shipments.find((id) => `${id.shipmentInstId}` === activeShipmentElement.nativeElement.id);
            if (activeShipmentId && activeShipmentId !== this.selectedShipment) {
                this.selectedShipmentSubject.next(activeShipmentId);
            }
        });
    }
    onRemove(shipmentInstId) {
        const componentIndex = this.updateShipmentComponents.toArray().findIndex((elRef) => {
            return elRef.nativeElement.id === `${shipmentInstId}`;
        });
        const shipment = this.shipmentIds.find((shipmentId) => +shipmentId.shipmentInstId === shipmentInstId);
        // remove from form array
        this.shipmentsFormArray.removeAt(componentIndex);
        // remove from pristine form values
        this.pristineFormValues[UpdateShipmentsStatusFormField.Shipments].splice(componentIndex, 1);
        // remove from shipments list in service
        this.updateShipmentStatusService.removeShipment(shipmentInstId);
        // emit event
        this.removeShipment.emit(shipment);
    }
    updateFilteredSics(filterTerm) {
        if (filterTerm !== this.previousFilterTerm) {
            this.previousFilterTerm = filterTerm;
            this.serviceCenterService.serviceCenters$
                .pipe(take(1), map((sics) => this.serviceCenterService.filterSicsBy(sics, filterTerm)), tap((serviceCenters) => {
                this.serviceCenterListSubject.next(serviceCenters);
            }))
                .subscribe();
        }
    }
    getText(sic) {
        var _a, _b;
        return sic ? `${sic.sicCd} - ${(_a = sic.reference) === null || _a === void 0 ? void 0 : _a.sicName}, ${(_b = sic.locAddress) === null || _b === void 0 ? void 0 : _b.countrySubdivisionCd}` : '';
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    toFormGroup(index) {
        return this.shipmentsFormArray.at(index);
    }
}
XpoLtlUpdateShipmentStatusComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentStatusComponent, deps: [{ token: UpdateShipmentStatusService }, { token: UpdateShipmentStatusFormService }, { token: i3$2.XpoSnackBar }, { token: i4$8.XpoConfirmDialog }, { token: XpoLtlServiceCentersService }, { token: XpoLtlLoggedInUserService }, { token: i2$3.ConfigManagerService }, { token: XpoLtlUserPreferencesService }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlUpdateShipmentStatusComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlUpdateShipmentStatusComponent, selector: "xpo-ltl-update-shipment-status", inputs: { shipmentIds: "shipmentIds", config: "config" }, outputs: { close: "close", removeShipment: "removeShipment" }, host: { listeners: { "document:keydown.escape": "onKeydownHandler($event)" } }, viewQueries: [{ propertyName: "sicInput", first: true, predicate: MatInput, descendants: true }, { propertyName: "updateShipmentComponents", predicate: XpoLtlUpdateShipmentComponent, descendants: true, read: ElementRef }], ngImport: i0, template: "<div\n  *ngIf=\"{\n    selectedShipment: selectedShipment$ | async,\n    canSubmit: canSubmit$ | async,\n    displayState: displayState$ | async,\n    shipments: shipments$ | async,\n    loading: loading$ | async\n  } as state\"\n  class=\"xpo-LtlUpdateShipmentStatus\"\n>\n  <div class=\"xpo-LtlUpdateShipmentStatus__header\">\n    <div class=\"xpo-LtlUpdateShipmentStatus__header--row\">\n      <h1 class=\"xpo-LtlUpdateShipmentStatus__header--title\">Update Shipment Status</h1>\n      <div class=\"xpo-LtlUpdateShipmentStatus__header--info\">\n        <span><span class=\"xpo-LtlUpdateShipmentStatus__required\">*</span>&nbsp;Indicates Required Fields</span>\n      </div>\n      <div class=\"xpo-LtlUpdateShipmentStatus__header--actions\">\n        <button mat-icon-button (click)=\"onClose()\">\n          <mat-icon>close</mat-icon>\n        </button>\n      </div>\n    </div>\n    <mat-divider class=\"xpo-LtlUpdateShipmentStatus__divider\"></mat-divider>\n  </div>\n  <div class=\"xpo-LtlUpdateShipmentStatus__content\">\n    <ng-container *ngIf=\"state.displayState === DisplayState.showShipments\">\n      <div class=\"xpo-LtlUpdateShipmentStatus__content--container\" [formGroup]=\"form\">\n        <div class=\"xpo-LtlUpdateShipmentStatus__content--sicSelector\">\n          <mat-form-field floatLabel=\"always\">\n            <mat-label>Reporting SIC</mat-label>\n            <input\n              #sicInput\n              matInput\n              matAutocompleteTrigger\n              type=\"text\"\n              placeholder=\"Reporting SIC\"\n              [formControlName]=\"UpdateShipmentStatusFormField.ReportingSic\"\n              [matAutocomplete]=\"reportingSicAutocomplete\"\n              [required]=\"form?.get(UpdateShipmentStatusFormField.ReportingSic)?.hasError('required')\"\n              (input)=\"updateFilteredSics($any($event.target).value)\"\n            />\n            <mat-error\n              class=\"no-margin-top\"\n              *ngIf=\"form?.get(UpdateShipmentStatusFormField.ReportingSic)?.errors as errors\"\n            >\n              <span class=\"xpo-LtlUpdateShipmentStatus__required\">*</span>&nbsp;Required\n            </mat-error>\n            <mat-icon matSuffix>arrow_drop_down</mat-icon>\n            <mat-autocomplete autoActiveFirstOption=\"true\" #reportingSicAutocomplete [displayWith]=\"getText\">\n              <mat-option *ngFor=\"let sic of serviceCenterList$ | async\" [value]=\"sic\">\n                {{ sic.sicCd }} - {{ sic.reference?.sicName }}, {{ sic.locAddress?.countrySubdivisionCd }}\n              </mat-option>\n            </mat-autocomplete>\n          </mat-form-field>\n        </div>\n        <div class=\"xpo-LtlUpdateShipmentStatus__content--heading\">\n          <ng-container *ngIf=\"state.shipments?.length > 1\">\n            <div class=\"xpo-LtlUpdateShipmentStatus__content--shipmentSelector\">\n              <mat-chip-list>\n                <mat-chip\n                  *ngFor=\"let shipmentId of state.shipments\"\n                  [value]=\"shipmentId\"\n                  [selected]=\"state.selectedShipment === shipmentId\"\n                  (click)=\"onShipmentSelectionChange(shipmentId)\"\n                >\n                  {{ shipmentId.proNbr | proFormatter: 10 }}</mat-chip\n                >\n              </mat-chip-list>\n            </div>\n          </ng-container>\n        </div>\n        <div class=\"xpo-LtlUpdateShipmentStatus__updateShipmentStatus--container\" (scroll)=\"onScroll($event)\">\n          <div\n            *ngFor=\"let shipment of state.shipments; index as i\"\n            class=\"xpo-LtlUpdateShipmentStatus__updateShipmentStatus--item\"\n          >\n            <xpo-ltl-update-shipment\n              [id]=\"shipment.shipmentInstId\"\n              class=\"xpo-LtlUpdateShipmentStatus__content--updateShipmentStatus\"\n              [form]=\"toFormGroup(i)\"\n              [shipmentId]=\"shipment\"\n              (remove)=\"onRemove($event)\"\n              (removeChildPro)=\"onUpdate($event)\"\n              [showRemove]=\"state.shipments.length > 1\"\n              [reportingSic]=\"$any(form?.get(UpdateShipmentStatusFormField.ReportingSic))\"\n            >\n            </xpo-ltl-update-shipment>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n    <ng-container *ngIf=\"state.loading\">\n      <div class=\"xpo-LtlUpdateShipmentStatus__disabledPanel\"></div>\n      <xpo-busy-loader class=\"xpo-LtlUpdateShipmentStatus__busyLoader\"></xpo-busy-loader>\n    </ng-container>\n    <ng-container *ngIf=\"state.displayState === DisplayState.error\">\n      <xpo-empty-state class=\"xpo-LtlUpdateShipmentStatus__error\">\n        <xpo-empty-state-icon>\n          <mat-icon>insert_drive_file</mat-icon>\n        </xpo-empty-state-icon>\n        <xpo-empty-state-header>Error loading shipment info.</xpo-empty-state-header>\n      </xpo-empty-state>\n    </ng-container>\n  </div>\n  <div class=\"xpo-LtlUpdateShipmentStatus__footer\">\n    <button\n      class=\"xpo-LtlUpdateShipmentStatus__footer--action\"\n      mat-flat-button\n      [disabled]=\"!state.canSubmit\"\n      (click)=\"onUpdate()\"\n    >\n      UPDATE\n    </button>\n\n    <button class=\"xpo-LtlUpdateShipmentStatus__footer--action\" mat-stroked-button (click)=\"onClose()\">CLOSE</button>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}.xpo-LtlUpdateShipmentStatus{height:100%;width:100%;display:flex;flex-direction:column;padding:8px;position:relative}.xpo-LtlUpdateShipmentStatus__divider{color:#d8d8d8}.xpo-LtlUpdateShipmentStatus__header{display:flex;flex-direction:column;height:48px;margin-bottom:16px}.xpo-LtlUpdateShipmentStatus__header--row{display:flex;align-items:center;width:100%}.xpo-LtlUpdateShipmentStatus__header--action{float:right;text-align:right}.xpo-LtlUpdateShipmentStatus__header--info{text-align:right;float:right;font-style:italic;color:#6f6f6f;width:100%;margin-right:16px}.xpo-LtlUpdateShipmentStatus__header--title{width:100%}.xpo-LtlUpdateShipmentStatus__content{padding-bottom:16px;display:flex;flex:1 1 auto;overflow:auto}.xpo-LtlUpdateShipmentStatus__content--container{flex:1 1 auto;display:flex;flex-direction:column;overflow:hidden;position:relative}.xpo-LtlUpdateShipmentStatus__content--heading{padding-bottom:16px}.xpo-LtlUpdateShipmentStatus__content--sicSelector{text-align:right;float:right}.xpo-LtlUpdateShipmentStatus__content--shipmentSelector{font-weight:400;padding-bottom:16px}.xpo-LtlUpdateShipmentStatus__content--shipmentSelector .mat-chip{padding:6px 16px;background-color:unset;color:#1976d2;font-weight:400;cursor:pointer}.xpo-LtlUpdateShipmentStatus__content--shipmentSelector .mat-chip-selected{background-color:#e4effa;font-weight:400;color:#000}.xpo-LtlUpdateShipmentStatus__content--bulkActions{padding:0 8px;display:flex;justify-content:space-between}.xpo-LtlUpdateShipmentStatus__content--bulkActions .mat-form-field{margin:0}.xpo-LtlUpdateShipmentStatus__updateShipmentStatus--container{flex:1 1 auto;overflow:auto;position:relative}.xpo-LtlUpdateShipmentStatus__updateShipmentStatus--item{padding-bottom:8px}.xpo-LtlUpdateShipmentStatus__footer--action{margin-right:8px}.xpo-LtlUpdateShipmentStatus__required{color:#d32f2f}.xpo-LtlUpdateShipmentStatus__busyLoader{position:absolute;left:50%;top:50%;width:100px;transform:translate(-50%,-50%);z-index:999}.xpo-LtlUpdateShipmentStatus__disabledPanel{position:absolute;top:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.38);z-index:10}"], components: [{ type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i11$3.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i13.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i11$2.MatChipList, selector: "mat-chip-list", inputs: ["aria-orientation", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "selectable", "tabIndex", "errorStateMatcher"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { type: XpoLtlUpdateShipmentComponent, selector: "xpo-ltl-update-shipment", inputs: ["shipmentId", "form", "config", "showRemove", "reportingSic"], outputs: ["remove", "removeChildPro"] }, { type: i7$2.XpoBusyLoader, selector: "xpo-busy-loader", inputs: ["slow"] }, { type: i3$3.XpoEmptyState, selector: "xpo-empty-state" }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7.MatLabel, selector: "mat-label" }, { type: i21.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i13.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i2$2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i7.MatError, selector: "mat-error", inputs: ["id"] }, { type: i7.MatSuffix, selector: "[matSuffix]" }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i11$2.MatChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { type: i3$3.XpoEmptyStateIcon, selector: "xpo-empty-state-icon" }, { type: i3$3.XpoEmptyStateHeader, selector: "xpo-empty-state-header" }], pipes: { "async": i5.AsyncPipe, "proFormatter": ProFormatterPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentStatusComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-update-shipment-status',
                    templateUrl: './update-shipment-status.component.html',
                    styleUrls: ['./update-shipment-status.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: UpdateShipmentStatusService }, { type: UpdateShipmentStatusFormService }, { type: i3$2.XpoSnackBar }, { type: i4$8.XpoConfirmDialog }, { type: XpoLtlServiceCentersService }, { type: XpoLtlLoggedInUserService }, { type: i2$3.ConfigManagerService }, { type: XpoLtlUserPreferencesService }]; }, propDecorators: { sicInput: [{
                type: ViewChild,
                args: [MatInput]
            }], updateShipmentComponents: [{
                type: ViewChildren,
                args: [XpoLtlUpdateShipmentComponent, { read: ElementRef }]
            }], close: [{
                type: Output
            }], removeShipment: [{
                type: Output
            }], shipmentIds: [{
                type: Input
            }], config: [{
                type: Input
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown.escape', ['$event']]
            }] } });

class UpdateShipmentStatusDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    ngOnInit() { }
    onClose() {
        this.dialogRef.close();
    }
}
UpdateShipmentStatusDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusDialogComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
UpdateShipmentStatusDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: UpdateShipmentStatusDialogComponent, selector: "xpo-ltl-update-shipment-status-dialog", ngImport: i0, template: "<div class=\"xpo-LtlUpdateShipmentStatusDialog\">\n  <xpo-ltl-update-shipment-status [shipmentIds]=\"data.shipmentIds\" (close)=\"onClose()\"></xpo-ltl-update-shipment-status>\n</div>\n", styles: [".flex--stretch{flex:1}.xpo-LtlUpdateShipmentStatusDialog{height:100%;padding:16px}"], components: [{ type: XpoLtlUpdateShipmentStatusComponent, selector: "xpo-ltl-update-shipment-status", inputs: ["shipmentIds", "config"], outputs: ["close", "removeShipment"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UpdateShipmentStatusDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-update-shipment-status-dialog',
                    templateUrl: './update-shipment-status-dialog.component.html',
                    styleUrls: ['./update-shipment-status-dialog.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: XpoLtlUpdateShipmentStatusDialogData, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class XpoLtlUpdateShipmentStatusDialogService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    openUpdateShipmentStatusDialog(dialogData) {
        let dialogRef;
        const subject = new Subject();
        dialogRef = this.dialog.open(UpdateShipmentStatusDialogComponent, {
            data: dialogData,
            width: '1100px',
            minWidth: '1100px',
            height: '800px',
            maxHeight: '80vh',
            panelClass: 'xpo-LtlUpdateShipmentStatusDialog__dialog',
            disableClose: true,
            hasBackdrop: true,
            restoreFocus: false,
        });
        dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe(() => {
            subject.next();
            subject.complete();
        });
        return subject.asObservable();
    }
}
XpoLtlUpdateShipmentStatusDialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentStatusDialogService, deps: [{ token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlUpdateShipmentStatusDialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentStatusDialogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentStatusDialogService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }]; } });

const pipes = [UpdateShipmentStatusCdPipe, UpdateShipmentStatusDeliveryQualifierReasonCdPipe, HandlingUnitTypeCdPipe];
const services = [
    UpdateShipmentStatusService,
    UpdateShipmentStatusFormService,
    UpdateShipmentStatusDisplayConfigService,
    XpoLtlUpdateShipmentStatusDialogService,
];
class XpoLtlUpdateShipmentStatusModule {
}
XpoLtlUpdateShipmentStatusModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentStatusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlUpdateShipmentStatusModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentStatusModule, declarations: [XpoLtlUpdateShipmentStatusComponent,
        UpdateShipmentStatusDialogComponent,
        XpoLtlUpdateShipmentComponent,
        UpdateShipmentFormComponent,
        CurrencyFormatterDirective,
        TimeFormatterDirective, UpdateShipmentStatusCdPipe, UpdateShipmentStatusDeliveryQualifierReasonCdPipe, HandlingUnitTypeCdPipe, ChildShipmentsGridComponent,
        ReasonCodeSelectorComponent], imports: [CommonModule,
        ConfigManagerModule,
        FormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatChipsModule,
        MatExpansionModule,
        MatNativeDateModule,
        MatDividerModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        XpoSelectModule,
        ReactiveFormsModule,
        XpoButtonModule,
        XpoCardModule,
        XpoCheckboxModule,
        XpoConfirmDialogModule,
        XpoBusyLoaderModule,
        XpoAllowCharactersModule,
        XpoEmptyStateModule,
        XpoChipsModule,
        XpoIconModule,
        XpoSsiModule,
        XpoStatusIndicatorModule,
        XpoLtlPipeModule,
        XpoNgxGridModule,
        XpoGridToolbarModule,
        SdkCarrierManagementModule, i1$8.AgGridModule], exports: [XpoLtlUpdateShipmentStatusComponent, XpoLtlUpdateShipmentComponent, UpdateShipmentStatusCdPipe, UpdateShipmentStatusDeliveryQualifierReasonCdPipe, HandlingUnitTypeCdPipe] });
XpoLtlUpdateShipmentStatusModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentStatusModule, providers: [
        {
            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
            useValue: { configFileUrl: './assets/config.json' },
        },
        ...pipes,
        ...services,
    ], imports: [[
            CommonModule,
            ConfigManagerModule,
            FormsModule,
            MatAutocompleteModule,
            MatButtonModule,
            MatCheckboxModule,
            MatDatepickerModule,
            MatChipsModule,
            MatExpansionModule,
            MatNativeDateModule,
            MatDividerModule,
            MatIconModule,
            MatInputModule,
            MatSelectModule,
            XpoSelectModule,
            ReactiveFormsModule,
            XpoButtonModule,
            XpoCardModule,
            XpoCheckboxModule,
            XpoConfirmDialogModule,
            XpoBusyLoaderModule,
            XpoAllowCharactersModule,
            XpoEmptyStateModule,
            XpoChipsModule,
            XpoIconModule,
            XpoSsiModule,
            XpoStatusIndicatorModule,
            XpoLtlPipeModule,
            XpoNgxGridModule,
            XpoGridToolbarModule,
            SdkCarrierManagementModule,
            AgGridModule.withComponents([ChildShipmentsGridComponent]),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlUpdateShipmentStatusModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        XpoLtlUpdateShipmentStatusComponent,
                        UpdateShipmentStatusDialogComponent,
                        XpoLtlUpdateShipmentComponent,
                        UpdateShipmentFormComponent,
                        CurrencyFormatterDirective,
                        TimeFormatterDirective,
                        ...pipes,
                        ChildShipmentsGridComponent,
                        ReasonCodeSelectorComponent,
                    ],
                    imports: [
                        CommonModule,
                        ConfigManagerModule,
                        FormsModule,
                        MatAutocompleteModule,
                        MatButtonModule,
                        MatCheckboxModule,
                        MatDatepickerModule,
                        MatChipsModule,
                        MatExpansionModule,
                        MatNativeDateModule,
                        MatDividerModule,
                        MatIconModule,
                        MatInputModule,
                        MatSelectModule,
                        XpoSelectModule,
                        ReactiveFormsModule,
                        XpoButtonModule,
                        XpoCardModule,
                        XpoCheckboxModule,
                        XpoConfirmDialogModule,
                        XpoBusyLoaderModule,
                        XpoAllowCharactersModule,
                        XpoEmptyStateModule,
                        XpoChipsModule,
                        XpoIconModule,
                        XpoSsiModule,
                        XpoStatusIndicatorModule,
                        XpoLtlPipeModule,
                        XpoNgxGridModule,
                        XpoGridToolbarModule,
                        SdkCarrierManagementModule,
                        AgGridModule.withComponents([ChildShipmentsGridComponent]),
                    ],
                    exports: [XpoLtlUpdateShipmentStatusComponent, XpoLtlUpdateShipmentComponent, ...pipes],
                    entryComponents: [
                        UpdateShipmentStatusDialogComponent,
                        XpoLtlUpdateShipmentStatusComponent,
                        XpoLtlUpdateShipmentComponent,
                    ],
                    providers: [
                        {
                            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
                            useValue: { configFileUrl: './assets/config.json' },
                        },
                        ...pipes,
                        ...services,
                    ],
                }]
        }] });

class XpoLtlReleaseNotesComponent {
    constructor(config, http) {
        this.config = config;
        this.http = http;
        this.version = '';
        this.content = '';
        this.version = this.config.getSetting(ConfigManagerProperties$1.buildVersion);
        this.http.get('assets/release-notes.html', { responseType: 'text' }).subscribe((content) => {
            this.content = content;
        });
    }
}
XpoLtlReleaseNotesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlReleaseNotesComponent, deps: [{ token: i2$3.ConfigManagerService }, { token: i1$5.HttpClient }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlReleaseNotesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlReleaseNotesComponent, selector: "xpo-ltl-release-notes", host: { classAttribute: "xpo-LtlReleaseNotes" }, ngImport: i0, template: "<h1 class=\"xpo-LtlReleaseNotes\"\n    mat-dialog-title>Release Notes - {{version}}\n  <xpo-dialog-close-button></xpo-dialog-close-button>\n</h1>\n\n<div mat-dialog-content\n     [innerHTML]=\"content\"></div>\n", styles: [".xpo-LtlReleaseNotes{width:900px}"], components: [{ type: i3.XpoDialogCloseButtonComponent, selector: "xpo-dialog-close-button" }], directives: [{ type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlReleaseNotesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-release-notes',
                    templateUrl: './release-notes.component.html',
                    styleUrls: ['./release-notes.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    host: { class: 'xpo-LtlReleaseNotes' }
                }]
        }], ctorParameters: function () { return [{ type: i2$3.ConfigManagerService }, { type: i1$5.HttpClient }]; } });

class XpoLtlReleaseNotesModule {
}
XpoLtlReleaseNotesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlReleaseNotesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlReleaseNotesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlReleaseNotesModule, declarations: [XpoLtlReleaseNotesComponent], imports: [CommonModule, XpoDialogModule, ConfigManagerModule], exports: [XpoLtlReleaseNotesComponent] });
XpoLtlReleaseNotesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlReleaseNotesModule, providers: [
        {
            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
            useValue: { configFileUrl: './assets/config.json' },
        },
    ], imports: [[CommonModule, XpoDialogModule, ConfigManagerModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlReleaseNotesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [XpoLtlReleaseNotesComponent],
                    imports: [CommonModule, XpoDialogModule, ConfigManagerModule],
                    exports: [XpoLtlReleaseNotesComponent],
                    entryComponents: [XpoLtlReleaseNotesComponent],
                    providers: [
                        {
                            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
                            useValue: { configFileUrl: './assets/config.json' },
                        },
                    ],
                }]
        }] });

class XpoLtlReleaseNotesService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    showReleaseNotes() {
        const subject = new Subject();
        const dialogRef = this.dialog.open(XpoLtlReleaseNotesComponent);
        dialogRef.afterClosed().subscribe(() => {
            subject.next(null);
            subject.complete();
        });
        return subject.asObservable();
    }
}
XpoLtlReleaseNotesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlReleaseNotesService, deps: [{ token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlReleaseNotesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlReleaseNotesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlReleaseNotesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }]; } });

class XpoLtlRoleSwitcherComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    selectRoleClick() {
        this.dialogRef.close(this.selectedRole);
    }
}
XpoLtlRoleSwitcherComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlRoleSwitcherComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlRoleSwitcherComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlRoleSwitcherComponent, selector: "xpo-ltl-role-switcher", ngImport: i0, template: "<h1 class=\"xpo-LtlRoleSwitcher\" mat-dialog-title>\n  Select Role\n  <xpo-dialog-close-button *ngIf=\"data.closeable\"></xpo-dialog-close-button>\n</h1>\n\n<div mat-dialog-content>\n  <mat-form-field floatLabel=\"never\" class=\"xpo-LtlRoleSwitcher-role\">\n    <mat-select [(ngModel)]=\"selectedRole\" placeholder=\"Select from list...\">\n      <mat-option *ngFor=\"let role of data.roles\" [value]=\"role\"> {{ role }} </mat-option>\n    </mat-select>\n  </mat-form-field>\n</div>\n\n<div mat-dialog-actions>\n  <button [disabled]=\"!selectedRole\" mat-flat-button (click)=\"selectRoleClick()\">OK</button>\n</div>\n", styles: [".xpo-LtlRoleSwitcher{width:300px}.xpo-LtlRoleSwitcher-role{width:100%}"], components: [{ type: i3.XpoDialogCloseButtonComponent, selector: "xpo-dialog-close-button" }, { type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i4$4.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlRoleSwitcherComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-role-switcher',
                    templateUrl: './role-switcher.component.html',
                    styleUrls: ['./role-switcher.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class XpoLtlRoleSwitcherModule {
}
XpoLtlRoleSwitcherModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlRoleSwitcherModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlRoleSwitcherModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlRoleSwitcherModule, declarations: [XpoLtlRoleSwitcherComponent], imports: [CommonModule,
        XpoDialogModule,
        ConfigManagerModule,
        FormsModule,
        ReactiveFormsModule,
        MatOptionModule,
        MatSelectModule,
        XpoButtonModule], exports: [XpoLtlRoleSwitcherComponent] });
XpoLtlRoleSwitcherModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlRoleSwitcherModule, imports: [[
            CommonModule,
            XpoDialogModule,
            ConfigManagerModule,
            FormsModule,
            ReactiveFormsModule,
            MatOptionModule,
            MatSelectModule,
            XpoButtonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlRoleSwitcherModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [XpoLtlRoleSwitcherComponent],
                    imports: [
                        CommonModule,
                        XpoDialogModule,
                        ConfigManagerModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatOptionModule,
                        MatSelectModule,
                        XpoButtonModule,
                    ],
                    exports: [XpoLtlRoleSwitcherComponent],
                    entryComponents: [XpoLtlRoleSwitcherComponent],
                }]
        }] });

class XpoLtlRoleSwitcherService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    showRoleSwitcherDialog(roleSwitcherData) {
        return this.dialog.open(XpoLtlRoleSwitcherComponent, { data: roleSwitcherData, disableClose: true }).afterClosed();
    }
}
XpoLtlRoleSwitcherService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlRoleSwitcherService, deps: [{ token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlRoleSwitcherService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlRoleSwitcherService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlRoleSwitcherService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }]; } });

class XpoLtlEmailService {
    constructor(infrastructureApi) {
        this.infrastructureApi = infrastructureApi;
    }
    /**
     * Submits a concealed call to infrastructure api to send email.
     * @param fromName - The name of the person who the email is from
     * @param fromEmail - The email address who the email is from
     * @param toEmail - Who the email is addressed to
     * @param subject - The subject of the email
     * @param messageBody - The message body
     */
    sendEmail(fromName, fromEmail, toEmail, subject, messageBody) {
        return this.infrastructureApi.sendEmail(this.createEmail(fromName, fromEmail, toEmail, subject, messageBody), ApiRequest.concealedCall);
    }
    createEmail(fromName, fromEmail, toEmail, subject, messageBody) {
        // TODO: If we ever allow user to enter in the from field, then we will need to do other validation.
        let from = fromEmail;
        if (fromName && (fromName !== fromEmail)) {
            // I am assuming fromEmail will always exist and valid.
            // Prepend fromName to email address so it will show up as user name instead of user email.
            from = fromName + '<' + fromEmail + '>';
        }
        return {
            emailMessage: {
                from,
                fromName: '',
                to: toEmail,
                subject,
                messageBody
            }
        };
    }
}
XpoLtlEmailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEmailService, deps: [{ token: i1$a.InfrastructureApiService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlEmailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEmailService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEmailService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$a.InfrastructureApiService }]; } });

class XpoLtlFeedbackService {
    constructor(loggedInUserService, configManagerService, emailService, snackBar) {
        this.loggedInUserService = loggedInUserService;
        this.configManagerService = configManagerService;
        this.emailService = emailService;
        this.snackBar = snackBar;
        this.feedbackConfigBehaviorSubject = new BehaviorSubject(undefined);
        this.feedbackConfig$ = this.feedbackConfigBehaviorSubject.asObservable();
        const generateFeedbackConfig = (user) => {
            return {
                disableFromNameInput: true,
                disableSubjectInput: true,
                subject: this.configManagerService.getSetting(ConfigManagerProperties$1.feedbackSubject),
                fromEmail: user.emailAddress,
                fromName: `${user.givenName || user.displayName} ${user.lastName}`,
                onSendCallback: (message) => {
                    return this.sendEmail(message);
                },
            };
        };
        this.loggedInUserService
            .getLoggedInUser(this.configManagerService.getSetting(ConfigManagerProperties$1.loggedInUserRoot))
            .subscribe((user) => {
            if (user) {
                this.feedbackConfigBehaviorSubject.next(generateFeedbackConfig(user));
            }
        });
    }
    sendEmail(message) {
        const subject = new Subject();
        this.emailService
            .sendEmail(this.feedbackConfigBehaviorSubject.value.fromName, this.feedbackConfigBehaviorSubject.value.fromEmail, this.configManagerService.getSetting(ConfigManagerProperties$1.feedbackToAddress), this.configManagerService.getSetting(ConfigManagerProperties$1.feedbackSubject), `${message} - ${this.configManagerService.getSetting(ConfigManagerProperties$1.appName)} - ${this.feedbackConfigBehaviorSubject.value.fromName}`)
            .subscribe(() => {
            this.snackBar.success('Feedback sent.');
            subject.next(true);
            subject.complete();
        }, (error) => {
            this.snackBar.error(`${ErrorMessageParser.parseMessage(error) || error}.`);
            subject.next(false);
            subject.complete();
        });
        return subject;
    }
}
XpoLtlFeedbackService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlFeedbackService, deps: [{ token: XpoLtlLoggedInUserService }, { token: i2$3.ConfigManagerService }, { token: XpoLtlEmailService }, { token: i3$2.XpoSnackBar }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlFeedbackService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlFeedbackService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlFeedbackService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: XpoLtlLoggedInUserService }, { type: i2$3.ConfigManagerService }, { type: XpoLtlEmailService }, { type: i3$2.XpoSnackBar }]; } });

class XpoLtlBrowserCacheService {
    constructor() { }
    /**
     * Uses the browser's "localStorage" to cache a value as a JSON string.
     * When "isSingleSession" is true, then "sessionStorage" will be used instead.
     * (see: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage |
     * https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage)
     */
    setCacheValue(key, value, isSingleSession = false) {
        if (key.trim().length > 0 && value !== null && value !== undefined) {
            if (isSingleSession) {
                window.sessionStorage.setItem(key, JSON.stringify(value));
            }
            else {
                window.localStorage.setItem(key, JSON.stringify(value));
            }
        }
    }
    /**
     * Uses the browser's "localStorage" to retrieve a value from the cache and returns the parsed JSON object
     * If "isSingleSession" is true, then the value is retrieved from "sessionStorage".
     * (see: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage |
     * https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage)
     */
    getCacheValue(key, isSingleSession = false) {
        if (key.trim().length > 0) {
            if (isSingleSession) {
                return JSON.parse(window.sessionStorage.getItem(key));
            }
            else {
                return JSON.parse(window.localStorage.getItem(key));
            }
        }
    }
    /**
     * Removes the value from cache based on the key provided. If "isSingleSession" param is true,
     * then "sessionStorage" will be used. Otherwise
     * "localStorage" is used.
     * (see: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage |
     * https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage)
     */
    purgeCacheValue(key, isSingleSession = false) {
        if (key.trim().length > 0) {
            if (isSingleSession) {
                window.sessionStorage.removeItem(key);
            }
            else {
                window.localStorage.removeItem(key);
            }
        }
    }
}
XpoLtlBrowserCacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlBrowserCacheService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlBrowserCacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlBrowserCacheService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlBrowserCacheService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return []; } });

class XpoLtlEmployeeDetailsCacheService extends XpoLtlBaseCacheService {
    constructor(hrService) {
        super();
        this.hrService = hrService;
        this.invalidCharsRegex = new RegExp(/[^A-Za-z0-9]+/);
    }
    getKeyFromParams(params) {
        return `${params.employeeId.toUpperCase()}:${params.effectiveDate || ''}:${params.requestType || ''}`;
    }
    requestData(params) {
        if (this.isInvalidEmployeeId(params.employeeId)) {
            return throwError({
                error: {
                    errorCode: 400,
                    message: 'Invalid employeeId.',
                },
            });
        }
        const pathParams = new GetEmployeeDetailsByEmpIdPath();
        pathParams.employeeId = params.employeeId.toUpperCase();
        const queryParams = new GetEmployeeDetailsByEmpIdQuery();
        queryParams.effectiveDate = params.effectiveDate;
        queryParams.requestType = params.requestType;
        return this.hrService.getEmployeeDetailsByEmpId(pathParams, queryParams, { toastOnError: false });
    }
    isInvalidEmployeeId(employeeId) {
        return !employeeId || isNull(employeeId) || this.invalidCharsRegex.test(employeeId);
    }
}
XpoLtlEmployeeDetailsCacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEmployeeDetailsCacheService, deps: [{ token: i1$b.HumanResourceApiService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlEmployeeDetailsCacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEmployeeDetailsCacheService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlEmployeeDetailsCacheService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$b.HumanResourceApiService }]; } });

/**
 * Fire an event when the user has been idle for a specified amount of time
 */
class XpoLtlIdleTimeoutService {
    constructor(windowService) {
        this.windowService = windowService;
        this.unsubscriber = new Unsubscriber();
        this.defaultConfig = {
            timeout: 30 * 60, // default timeout after 1/2 hour of inactivity
        };
        this._timerStopped = true;
        this._idleTime = 0;
        /**
         * Observable that is trigged when the timer runs out
         */
        this.idleTimeout$ = new Subject();
        this._config = Object.assign({}, this.defaultConfig);
        // events that define user interaction with the app
        this.activityEvents$ = merge(fromEvent(this.windowService.nativeWindow, 'mousemove'), fromEvent(this.windowService.nativeWindow, 'resize'), fromEvent(this.windowService.nativeDocument, 'keydown'));
        this.activityEvents$.pipe(throttleTime(1000), takeUntil(this.unsubscriber.done$)).subscribe(() => {
            // reset how long we have been idle every time a qualifying event happens
            this._idleTime = 0;
        });
        // start timer
        timer(0, 1000)
            .pipe(filter(() => !this.timerStopped), takeUntil(this.unsubscriber.done$))
            .subscribe(() => {
            this.tick();
        });
    }
    /**
     * current timer configuration
     */
    get config() {
        return this._config;
    }
    /**
     * True if the timer is currently stopped
     */
    get timerStopped() {
        return this._timerStopped;
    }
    /**
     * number of seconds has user been idle
     */
    get idleTime() {
        return this._idleTime;
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
        this.idleTimeout$.unsubscribe();
    }
    /**
     * Start the idle timer
     */
    start(config = {}) {
        this._config = Object.assign(Object.assign({}, this.defaultConfig), config);
        this.reset();
    }
    /**
     * stop the idle timer
     */
    stop() {
        this._timerStopped = true;
    }
    /**
     * Reset the idle timer
     */
    reset() {
        this._idleTime = 0;
        this._timerStopped = false;
    }
    tick() {
        if (!this.timerStopped) {
            this._idleTime += 1; // add 1 second to idle timer
            if (this.idleTime >= this.config.timeout) {
                // user has been idle for longer than our timeout.
                this._timerStopped = true;
                this.idleTimeout$.next();
            }
        }
    }
}
XpoLtlIdleTimeoutService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlIdleTimeoutService, deps: [{ token: XpoLtlWindowService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlIdleTimeoutService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlIdleTimeoutService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlIdleTimeoutService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlWindowService }]; } });

class XpoLtlLocationDetailsCacheService extends XpoLtlBaseCacheService {
    constructor(locationService) {
        super();
        this.locationService = locationService;
    }
    getKeyFromParams(params) {
        return params.sicCd.toUpperCase();
    }
    requestData(params) {
        const request = new GetLocReferenceDetailsBySicPath();
        request.sicCd = params.sicCd.toUpperCase();
        return this.locationService.getLocReferenceDetailsBySic(request, new GetLocReferenceDetailsBySicQuery(), {
            toastOnError: false,
        });
    }
}
XpoLtlLocationDetailsCacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlLocationDetailsCacheService, deps: [{ token: i1$3.LocationApiService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlLocationDetailsCacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlLocationDetailsCacheService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlLocationDetailsCacheService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$3.LocationApiService }]; } });

var XpoLtlShipmentDetailsTabs;
(function (XpoLtlShipmentDetailsTabs) {
    XpoLtlShipmentDetailsTabs["Details"] = "Details";
    XpoLtlShipmentDetailsTabs["History"] = "History";
    XpoLtlShipmentDetailsTabs["Charges"] = "Charges";
})(XpoLtlShipmentDetailsTabs || (XpoLtlShipmentDetailsTabs = {}));

var AgreementTypeCd;
(function (AgreementTypeCd) {
    AgreementTypeCd["PlDoc"] = "PlDoc";
    AgreementTypeCd["Internal"] = "Internal";
})(AgreementTypeCd || (AgreementTypeCd = {}));

class AgreementTypeCdClass {
    constructor() {
        this._values = [];
        this._keys = [];
        for (const obj in AgreementTypeCd) {
            if (!!obj) {
                this._values.push(AgreementTypeCd[obj]);
                this._keys.push(obj);
            }
        }
    }
    values() {
        return this._values;
    }
    keys() {
        return this._keys;
    }
    toEnum(value) {
        for (const obj in AgreementTypeCd) {
            if (AgreementTypeCd[obj] === value) {
                return AgreementTypeCd[obj];
            }
        }
    }
}
const AgreementTypeCdHelper = new AgreementTypeCdClass();

/**
 * Service to share Shipment data within component
 */
class ShipmentReferenceService {
    constructor() {
        this.shipmentBehaviorSubject = new BehaviorSubject(undefined);
        this.shipment$ = this.shipmentBehaviorSubject.asObservable();
    }
    set shipment(value) {
        this.shipmentBehaviorSubject.next(value);
    }
}
ShipmentReferenceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentReferenceService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ShipmentReferenceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentReferenceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentReferenceService, decorators: [{
            type: Injectable
        }] });

var DataDisplayGroupType;
(function (DataDisplayGroupType) {
    DataDisplayGroupType["Default"] = "default";
    DataDisplayGroupType["Currency"] = "currency";
    DataDisplayGroupType["Date"] = "date";
})(DataDisplayGroupType || (DataDisplayGroupType = {}));
/**
 * Render a value underneath a label
 */
class DataDisplayGroupComponent {
    constructor(currencyPipe) {
        this.currencyPipe = currencyPipe;
        this.asCurrency = false;
        this.asDate = false;
        this.DataDisplayGroupType = DataDisplayGroupType;
    }
    renderer(value) {
        if (value) {
            if (this.asCurrency) {
                return this.currencyPipe.transform(value.amt, value.currencyCd);
            }
            else if (this.asDate) {
                return moment$3(value).format('MM/DD/YYYY');
            }
            else {
                return value;
            }
        }
        else {
            return undefined;
        }
    }
}
DataDisplayGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DataDisplayGroupComponent, deps: [{ token: i5.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Component });
DataDisplayGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: DataDisplayGroupComponent, selector: "xpo-ltl-data-display-group", inputs: { label: "label", value: "value", asCurrency: "asCurrency", asDate: "asDate" }, ngImport: i0, template: "<div class=\"xpo-LtlDataDisplayGroup\">\n  <div class=\"xpo-LtlDataDisplayGroup__label\">{{ label }}</div>\n  <div class=\"xpo-LtlDataDisplayGroup__value\">{{ renderer(value) | emptyValue }}</div>\n</div>\n", styles: [".xpo-LtlDataDisplayGroup,xpo-ltl-data-display-group{display:flex;flex:1 1 auto}.xpo-LtlDataDisplayGroup{flex-direction:column}.xpo-LtlDataDisplayGroup__label{color:#4a4a4a;font-size:12px;font-weight:500;letter-spacing:.25px;line-height:24px;height:auto}.xpo-LtlDataDisplayGroup__value{color:#4a4a4a;font-size:14px;letter-spacing:.29px;line-height:20px;height:auto}"], pipes: { "emptyValue": EmptyValuePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DataDisplayGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-data-display-group',
                    templateUrl: './data-display-group.component.html',
                    styleUrls: ['./data-display-group.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i5.CurrencyPipe }]; }, propDecorators: { label: [{
                type: Input
            }], value: [{
                type: Input
            }], asCurrency: [{
                type: Input
            }], asDate: [{
                type: Input
            }] } });

class ShipmentDetailsOverviewComponent {
    constructor(shipmentRefService, conditioningService, pricingApiService, windowService, clipboardService, notificationService) {
        this.shipmentRefService = shipmentRefService;
        this.conditioningService = conditioningService;
        this.pricingApiService = pricingApiService;
        this.windowService = windowService;
        this.clipboardService = clipboardService;
        this.notificationService = notificationService;
        this.toggleSRNs = new EventEmitter();
        this.pricingAgreementDocumentsSubject = new BehaviorSubject(undefined);
        this.pricingAgreementDocuments$ = this.pricingAgreementDocumentsSubject.asObservable();
        this.unsubscriber = new Unsubscriber();
        this.showSpinnerSubject = new BehaviorSubject(false);
        this.showSpinner$ = this.showSpinnerSubject.asObservable();
        this.mimeMap = new Map([
            ['.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
            ['.doc', 'application/msword'],
            ['.pdf', 'application/pdf'],
        ]);
        this.overviewSubject = new BehaviorSubject({
            pro: undefined,
            invoice: undefined,
            origin: undefined,
            destination: undefined,
            parentProNbr: undefined,
            pickupDate: undefined,
            deliveryDate: undefined,
            appliedRuleset: undefined,
            priceAgreementId: undefined,
            custPriceAgreement: undefined,
            billClass: undefined,
            xpoRev: undefined,
            advRev: undefined,
            bydRev: undefined,
            spotQuote: undefined,
            shipperLoadAndCount: false,
            deliveryQualifierCd: undefined,
            shipperPONumber: undefined,
            shipperAddress: undefined,
            consigneeAddress: undefined,
            billToAddress: undefined,
        });
        this.overview$ = this.overviewSubject.asObservable();
        this.showSRNs = false;
        this.isReadOnly = true;
    }
    ngOnInit() {
        this.shipmentRefService.shipment$.pipe(takeUntil(this.unsubscriber.done$)).subscribe((shipment) => {
            this.updateFormFromShipment(shipment);
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    handleToggleSRNs() {
        this.showSRNs = !this.showSRNs;
        this.toggleSRNs.emit(this.showSRNs);
    }
    showAppliedRuleset(pricingAgreementId) {
        this.showSpinnerSubject.next(true);
        const query = new ListPricingAgreementDocHdrsQuery();
        query.pricingAgreementId = pricingAgreementId;
        query.levelOfDetail = 'Pro';
        this.pricingApiService
            .listPricingAgreementDocHdrs(query)
            .pipe(finalize(() => this.showSpinnerSubject.next(false)), take(1), map((response) => {
            const pricingAgreementDocuments = new Array();
            response.pricingAgreementDocHdrDetail.forEach((header) => {
                if (header.agreementDocType && header.agreementDocType.length > 0) {
                    header.agreementDocType.forEach((document) => {
                        pricingAgreementDocuments.push({
                            agreementDocHdrId: header.agreementDocHdrId,
                            agreementDocTypeId: document.agreementDocTypeId,
                            docFile: document.docFile,
                            agreementTypeCd: AgreementTypeCdHelper.toEnum(header.agreementTypeCd),
                        });
                    });
                }
            });
            return pricingAgreementDocuments;
        }))
            .subscribe((documents) => {
            if (documents) {
                if (documents.length === 1) {
                    this.pricingAgreementSelected(documents[0]);
                }
                else {
                    this.pricingAgreementDocumentsSubject.next(documents);
                }
            }
        });
    }
    pricingAgreementSelected(pricingAgreementDocument) {
        if (pricingAgreementDocument.agreementTypeCd === AgreementTypeCd.PlDoc) {
            this.getDocumentFromPlDoc(pricingAgreementDocument);
        }
        else {
            this.getDocumentFromInternal(pricingAgreementDocument);
        }
    }
    getDocumentFromPlDoc(pricingAgreementDocument) {
        const query = new GetPricingAgreementDocumentQuery();
        query.docTypeId = pricingAgreementDocument.agreementDocTypeId;
        const pathParams = new GetPricingAgreementDocumentPath();
        pathParams.agreementDocHdrId = pricingAgreementDocument.agreementDocHdrId;
        this.pricingApiService
            .getPricingAgreementDocument(pathParams, query, ApiRequest.defaultDataOptions, { responseType: 'arraybuffer' })
            .pipe(take(1))
            .subscribe((response) => {
            const type = this.findMimeType(pricingAgreementDocument.docFile);
            // TODO: Update return object when api changes are made
            this.windowService.generateDownloadFile(type, response, pricingAgreementDocument.docFile);
        });
    }
    findMimeType(fileName) {
        const extension = fileName.substring(fileName.lastIndexOf('.'));
        return this.mimeMap.has(extension) ? this.mimeMap.get(extension) : 'application/octet-stream';
    }
    getDocumentFromInternal(pricingAgreementDocument) {
        const query = new GetPricingAgreementDocumentQuery();
        query.oracleDocId = pricingAgreementDocument.agreementDocHdrId;
        const pathParams = new GetPricingAgreementDocumentPath();
        pathParams.agreementDocHdrId = 1;
        this.pricingApiService
            .getPricingAgreementDocument(pathParams, query, ApiRequest.defaultDataOptions, { responseType: 'arraybuffer' })
            .pipe(take(1))
            .subscribe((response) => {
            const type = this.findMimeType(pricingAgreementDocument.docFile);
            // TODO: Update return object when api changes are made
            this.windowService.generateDownloadFile(type, response, pricingAgreementDocument.docFile);
        });
    }
    handleCopyPricingAgreement() {
        if (this.clipboardService.copyFromContent(this.overviewSubject.value.custPriceAgreement)) {
            this.notificationService.showSnackBarMessage('Applied Pricing Agreement # copied to clipboard.', {
                durationInMillis: 3000,
                status: 'SUCCESS',
            });
        }
    }
    updateFormFromShipment(shipment) {
        if (!shipment) {
            return;
        }
        const getParty = (matchedParties, typeCd, typeCd2) => {
            return find(matchedParties, (party) => !!party.typeCd && (party.typeCd === typeCd || party.typeCd === typeCd2));
        };
        // Some pricing agreements are being returned with 4 digits in the last section. Need to convert to
        // 3 digits if this occurs
        const transformCustPricingAgreementId = (id) => {
            if (!id) {
                return;
            }
            const idArray = id.split('-');
            idArray[2] = idArray[2].length === 4 ? slice(idArray[2], 1).join('') : idArray[2];
            return idArray.join('-');
        };
        const getRev = (advanceBeyondCarrier, typeCd) => {
            if (size(advanceBeyondCarrier) > 0) {
                return find(advanceBeyondCarrier, (li) => li.typeCd === typeCd)
                    .chain()
                    .thru((val) => val
                    ? {
                        amt: val.chargeAmount,
                        currencyCd: 'USD', // always in US$
                    }
                    : undefined)
                    ._value();
            }
            else {
                return 0;
            }
        };
        // extract the payment summary data from shipment and populate the this.summary with it
        const overview = {
            pro: this.conditioningService.conditionProNumber(shipment.shipment.proNbr, 11),
            invoice: this.conditioningService.conditionProNumber(shipment.shipment.proNbr, 10),
            origin: shipment.shipment.originTerminalSicCd,
            destination: shipment.shipment.destinationTerminalSicCd,
            parentProNbr: get(shipment.parentShipmentId, 'proNbr'),
            pickupDate: new Date(shipment.shipment.pickupDate),
            deliveryDate: new Date(shipment.shipment.estimatedDeliveryDate),
            appliedRuleset: shipment.shipment.priceRulesetNbr,
            priceAgreementId: shipment.shipment.priceAgreementId,
            custPriceAgreement: transformCustPricingAgreementId(shipment.custPricingAgreementId),
            billClass: shipment.shipment.billClassCd,
            xpoRev: { amt: shipment.xpoRevenueAmt, currencyCd: 'USD' },
            advRev: getRev(shipment.advanceBeyondCarrier, AdvanceBeyondTypeCd.ADV_CARR),
            bydRev: getRev(shipment.advanceBeyondCarrier, AdvanceBeyondTypeCd.BYD_CARR),
            spotQuote: shipment.shipment.spotQuoteId,
            shipperLoadAndCount: shipment.shipperLoadAndCountInd,
            shipperPONumber: {
                shipperNumber: get(find(shipment.suppRefNbr, (srn) => srn.typeCd === 'SN#'), 'refNbr'),
                poNumber: get(find(shipment.suppRefNbr, (srn) => srn.typeCd === 'PO#'), 'refNbr'),
            },
            deliveryQualifierCd: shipment.shipment.deliveryQualifierCd,
            shipperAddress: getParty(shipment.asMatchedParty, MatchedPartyTypeCd.SHPR),
            consigneeAddress: getParty(shipment.asMatchedParty, MatchedPartyTypeCd.CONS),
            billToAddress: getParty(shipment.asMatchedParty, MatchedPartyTypeCd.BILL_TO_OTB, MatchedPartyTypeCd.BILL_TO_INB),
        };
        this.overviewSubject.next(overview);
    }
    combinePostalCode(postal, postalExt) {
        return postalExt ? `${postal}-${postalExt}` : postal;
    }
    combinePhoneNumber(areaCd, phoneNbr) {
        if (phoneNbr) {
            const ac = areaCd ? `${areaCd}-` : '';
            const pn1 = phoneNbr.substring(0, 3);
            const pn2 = phoneNbr.substring(3);
            return `${ac}${pn1}-${pn2}`;
        }
        else {
            return '';
        }
    }
}
ShipmentDetailsOverviewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsOverviewComponent, deps: [{ token: ShipmentReferenceService }, { token: XpoLtlConditioningService }, { token: i3$4.PricingApiService }, { token: XpoLtlWindowService }, { token: i1$4.ClipboardService }, { token: i6$3.NotificationService }], target: i0.ɵɵFactoryTarget.Component });
ShipmentDetailsOverviewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentDetailsOverviewComponent, selector: "xpo-ltl-shipment-details-overview", outputs: { toggleSRNs: "toggleSRNs" }, ngImport: i0, template: "<div class=\"xpo-LtlShipmentDetails-Overview\">\n  <div class=\"xpo-LtlShipmentDetails-Overview__row\">\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"PRO\"\n      [value]=\"(overview$ | async)?.pro | proFormatter: 10\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Invoice\"\n      [value]=\"(overview$ | async)?.invoice\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Origin\"\n      [value]=\"(overview$ | async)?.origin\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Destination\"\n      [value]=\"(overview$ | async)?.destination\"\n    ></xpo-ltl-data-display-group>\n  </div>\n\n  <div class=\"xpo-LtlShipmentDetails-Overview__row\">\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Parent PRO\"\n      [value]=\"(overview$ | async)?.parentProNbr\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Pickup Date\"\n      [value]=\"(overview$ | async)?.pickupDate\"\n      [asDate]=\"true\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Delivery Date\"\n      [value]=\"(overview$ | async)?.deliveryDate\"\n      [asDate]=\"true\"\n    >\n    </xpo-ltl-data-display-group>\n\n    <!-- Pricing Agreement -->\n    <div class=\"xpo-LtlDataDisplayGroup xpo-LtlShipmentDetails-Overview__column\">\n      <div *ngIf=\"pricingAgreementDocuments$ | async; then pricingAgreementSelect; else pricingAgreementNumber\"></div>\n      <ng-template #pricingAgreementSelect>\n        <ng-container\n          *ngTemplateOutlet=\"pricingAgreementLink; context: { pricingAgreement: (overview$ | async)?.priceAgreementId }\"\n        ></ng-container>\n        <mat-divider></mat-divider>\n        <mat-form-field class=\"xpo-LtlShipmentDetails-Overview__select\">\n          <mat-label *ngIf=\"!selectedPricingAgreement\">Select Pricing Agreement</mat-label>\n          <mat-select [(value)]=\"selectedPricingAgreement\" (selectionChange)=\"pricingAgreementSelected($event.value)\">\n            <mat-option *ngFor=\"let agreement of pricingAgreementDocuments$ | async\" [value]=\"agreement\">\n              {{ agreement.docFile }}</mat-option\n            >\n          </mat-select>\n        </mat-form-field>\n      </ng-template>\n      <ng-template #pricingAgreementNumber>\n        <div *ngIf=\"!isReadOnly; then pricingAgreementLink; else pricingAgreementString\"></div>\n      </ng-template>\n      <ng-template #pricingAgreementLink let-pricingAgreement=\"pricingAgreement\">\n        <!-- <xpo-spinner [showSpinner]=\"showSpinner$ | async\"></xpo-spinner> -->\n        <ng-container *ngTemplateOutlet=\"pricingAgreementHeader\"></ng-container>\n        <div\n          *ngIf=\"!(showSpinner$ | async)\"\n          class=\"xpo-LtlDataDisplayGroup__value xpo-LtlShipmentDetails-Overview__link\"\n          (click)=\"showAppliedRuleset(pricingAgreement)\"\n          matTooltip=\"Display Applied Pricing Agreement\"\n        >\n          {{ (overview$ | async)?.custPriceAgreement }}\n        </div>\n      </ng-template>\n      <ng-template #pricingAgreementString>\n        <xpo-ltl-data-display-group label=\"Applied Pricing Agreement\" [value]=\"(overview$ | async)?.custPriceAgreement\">\n        </xpo-ltl-data-display-group>\n      </ng-template>\n      <ng-template #pricingAgreementHeader>\n        <div *ngIf=\"!(showSpinner$ | async)\" class=\"xpo-LtlDataDisplayGroup__label\">\n          Applied Pricing Agreement\n          <span\n            class=\"xpo-LtlShipmentDetails-Overview__copy\"\n            *ngIf=\"!!(overview$ | async)?.custPriceAgreement\"\n            (click)=\"handleCopyPricingAgreement()\"\n            >Copy #</span\n          >\n        </div>\n      </ng-template>\n    </div>\n  </div>\n\n  <div class=\"xpo-LtlShipmentDetails-Overview__row\">\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Bill Class\"\n      [value]=\"(overview$ | async)?.billClass | billClass\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"XPO Rev ($)\"\n      [value]=\"(overview$ | async)?.xpoRev\"\n      [asCurrency]=\"true\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Adv Rev ($)\"\n      [value]=\"(overview$ | async)?.advRev\"\n      [asCurrency]=\"true\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Byd Rev ($)\"\n      [value]=\"(overview$ | async)?.bydRev\"\n      [asCurrency]=\"true\"\n    ></xpo-ltl-data-display-group>\n  </div>\n\n  <div class=\"xpo-LtlShipmentDetails-Overview__row\">\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Spot Quote\"\n      [value]=\"(overview$ | async)?.spotQuote\"\n    ></xpo-ltl-data-display-group>\n\n    <xpo-ltl-data-display-group\n      class=\"xpo-LtlShipmentDetails-Overview__column\"\n      label=\"Shipper Load & Count\"\n      [value]=\"(overview$ | async)?.shipperLoadAndCount ? 'Yes' : 'No'\"\n      [ngClass]=\"{ 'xpo-LtlShipmentDetails-Overview__load-count-yes': (overview$ | async)?.shipperLoadAndCount }\"\n    ></xpo-ltl-data-display-group>\n\n    <ng-container\n      *ngIf=\"(overview$ | async)?.deliveryQualifierCd !== 'Final'; then finalDeliveryException; else emptyDisplayGroup\"\n    >\n    </ng-container>\n\n    <div class=\"xpo-LtlShipmentDetails-Overview__column\"></div>\n  </div>\n\n  <div class=\"xpo-LtlShipmentDetails-Overview__row xpo-LtlShipmentDetails-Overview__row--addresses\">\n    <div class=\"xpo-LtlDataDisplayGroup xpo-LtlShipmentDetails-Overview__column\">\n      <div class=\"xpo-LtlDataDisplayGroup__label\">Shipper's # / PO #</div>\n      <div class=\"xpo-LtlDataDisplayGroup__value\">SN#: {{ (overview$ | async)?.shipperPONumber?.shipperNumber }}</div>\n      <div class=\"xpo-LtlDataDisplayGroup__value\">PO#: {{ (overview$ | async)?.shipperPONumber?.poNumber }}</div>\n    </div>\n    <ng-container\n      [ngTemplateOutletContext]=\"{ label: 'Shipper', value: (overview$ | async)?.shipperAddress }\"\n      [ngTemplateOutlet]=\"xpoLtlShipmentDetailsOverviewGroupAddressTemplate\"\n    ></ng-container>\n    <ng-container\n      [ngTemplateOutletContext]=\"{ label: 'Consignee', value: (overview$ | async)?.consigneeAddress }\"\n      [ngTemplateOutlet]=\"xpoLtlShipmentDetailsOverviewGroupAddressTemplate\"\n    ></ng-container>\n    <ng-container\n      [ngTemplateOutletContext]=\"{ label: 'Bill To', value: (overview$ | async)?.billToAddress }\"\n      [ngTemplateOutlet]=\"xpoLtlShipmentDetailsOverviewGroupAddressTemplate\"\n    ></ng-container>\n  </div>\n\n  <div class=\"xpo-LtlShipmentDetails-Overview__row xpo-LtlShipmentDetails-Overview__more-srns\">\n    <button mat-button (click)=\"handleToggleSRNs()\">\n      <ng-container *ngIf=\"showSRNs; then lessSRNs; else moreSRNs\"></ng-container>\n    </button>\n  </div>\n</div>\n\n<ng-template #emptyDisplayGroup>\n  <div class=\"xpo-LtlShipmentDetails-Overview__column\"></div>\n</ng-template>\n\n<ng-template #finalDeliveryException>\n  <xpo-ltl-data-display-group\n    class=\"xpo-LtlShipmentDetails-Overview__column\"\n    label=\"Final Delivery Exception\"\n    [value]=\"(overview$ | async)?.deliveryQualifierCd | titlecase\"\n  >\n  </xpo-ltl-data-display-group>\n</ng-template>\n\n<ng-template #lessSRNs>\n  <mat-icon>expand_more</mat-icon>\n  <span class=\"xpo-LtlShipmentDetails-Overview__more-srns--label\">Less SRNs</span>\n</ng-template>\n\n<ng-template #moreSRNs>\n  <mat-icon>chevron_right</mat-icon>\n  <span class=\"xpo-LtlShipmentDetails-Overview__more-srns--label\">More SRNs</span>\n</ng-template>\n\n<ng-template #xpoLtlShipmentDetailsOverviewGroupAddressTemplate let-label=\"label\" let-value=\"value\">\n  <div class=\"xpo-LtlDataDisplayGroup xpo-LtlShipmentDetails-Overview__column xpo-LtlDataDisplayGroup-address\">\n    <div class=\"xpo-LtlDataDisplayGroup__label\">{{ label }}</div>\n    <ng-container *ngIf=\"value; else notAvailable\">\n      <div class=\"xpo-LtlDataDisplayGroup__value\">{{ value?.name1 }}</div>\n      <div class=\"xpo-LtlDataDisplayGroup__value\" *ngIf=\"value?.name2\">{{ value?.name2 }}</div>\n      <div class=\"xpo-LtlDataDisplayGroup__value\">{{ value?.address }}</div>\n      <div class=\"xpo-LtlDataDisplayGroup__value\">\n        {{ value?.city }}, {{ value?.stateCd }} {{ combinePostalCode(value?.zip6, value?.zip4RestUs) }}\n        {{ value?.countryCd }}\n      </div>\n      <div class=\"xpo-LtlDataDisplayGroup__value\">\n        <span\n          ><a>{{ combinePhoneNumber(value?.phoneAreaCdNbr, value?.phoneNbr) }}</a></span\n        >\n      </div>\n    </ng-container>\n  </div>\n</ng-template>\n\n<ng-template #notAvailable><span>N/A</span></ng-template>\n", styles: [".flex--stretch{flex:1}xpo-ltl-shipment-details-overview{display:flex;flex:1 1 auto}.xpo-LtlShipmentDetails-Overview{display:flex;flex:1 1 auto;flex-direction:column;font-size:14px;color:#4a4a4a}.xpo-LtlShipmentDetails-Overview__row{display:flex;flex:1 1 auto;flex-direction:row;justify-content:space-between;min-height:64px;margin-bottom:4px}.xpo-LtlShipmentDetails-Overview__column{display:flex;flex:1 1 auto;width:25%;margin-right:1%}.xpo-LtlShipmentDetails-Overview-bigger-font{font-size:16px}.xpo-LtlShipmentDetails-Overview__address{height:178px}.xpo-LtlShipmentDetails-Overview__load-count-yes{color:#d50000}.xpo-LtlShipmentDetails-Overview__select .mat-form-field-infix{border-top:0}.xpo-LtlShipmentDetails-Overview__copy{cursor:pointer;color:#0868ac;padding-left:4px}.xpo-LtlShipmentDetails-Overview__link{color:#0868ac;font-size:12px}.xpo-LtlShipmentDetails-Overview__more-srns{height:32px;min-height:32px}.xpo-LtlShipmentDetails-Overview__more-srns .mat-button{padding-left:0;padding-right:8px}.xpo-LtlShipmentDetails-Overview__more-srns--label{color:#0868ac}"], components: [{ type: DataDisplayGroupComponent, selector: "xpo-ltl-data-display-group", inputs: ["label", "value", "asCurrency", "asDate"] }, { type: i11$3.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i4$4.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i7.MatLabel, selector: "mat-label" }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "proFormatter": ProFormatterPipe, "async": i5.AsyncPipe, "billClass": BillClassPipe, "titlecase": i5.TitleCasePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsOverviewComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-overview',
                    templateUrl: './shipment-details-overview.component.html',
                    styleUrls: ['./shipment-details-overview.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: ShipmentReferenceService }, { type: XpoLtlConditioningService }, { type: i3$4.PricingApiService }, { type: XpoLtlWindowService }, { type: i1$4.ClipboardService }, { type: i6$3.NotificationService }]; }, propDecorators: { toggleSRNs: [{
                type: Output
            }] } });

class ShipmentDetailsPaymentSummaryComponent {
    constructor(shipmentRefService, accountsReceivableApiService) {
        this.shipmentRefService = shipmentRefService;
        this.accountsReceivableApiService = accountsReceivableApiService;
        this.hasFreightChargesTab = false;
        this.openFreightCharges = new EventEmitter();
        this.unsubscriber = new Unsubscriber();
        this.summarySubject = new BehaviorSubject({
            status: 'OPEN',
            payments: 0,
            charges: 0,
            adjustments: 0,
            currentBalance: 0,
        });
        this.summary$ = this.summarySubject.asObservable();
        this.PaymentStatusInternalCd = PaymentStatusInternalCd;
    }
    ngOnInit() {
        this.shipmentRefService.shipment$
            .pipe(takeUntil(this.unsubscriber.done$), distinctUntilChanged())
            .subscribe((shipment) => {
            this.updateFormFromShipment(shipment);
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    openFreightChargesTab() {
        this.openFreightCharges.emit();
    }
    updateFormFromShipment(shipment) {
        if (!shipment) {
            return;
        }
        const request = new ListArPaymentSummaryByProQuery();
        request.proNbr = shipment.shipment.proNbr;
        request.pickupDate = `${shipment.shipment.pickupDate.valueOf()}`;
        this.accountsReceivableApiService
            .listArPaymentSummaryByPro(request, ApiRequest.concealedCall)
            .subscribe((result) => {
            const paymentSummary = first(result.arPaymentSummaries);
            this.summarySubject.next({
                status: get(paymentSummary, 'paymentStatusTxt', 'OPEN'),
                payments: paymentSummary.totalPaymentAmt,
                charges: paymentSummary.totalChargeAmt,
                adjustments: paymentSummary.totalAdjustmentAmt,
                currentBalance: paymentSummary.balanceDueAmt,
            });
        });
    }
}
ShipmentDetailsPaymentSummaryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsPaymentSummaryComponent, deps: [{ token: ShipmentReferenceService }, { token: i2$8.AccountsReceivableApiService }], target: i0.ɵɵFactoryTarget.Component });
ShipmentDetailsPaymentSummaryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentDetailsPaymentSummaryComponent, selector: "xpo-ltl-shipment-details-payment-summary", inputs: { hasFreightChargesTab: "hasFreightChargesTab" }, outputs: { openFreightCharges: "openFreightCharges" }, ngImport: i0, template: "<div class=\"xpo-LtlShipmentDetails-PaymentSummary\">\n  <div class=\"xpo-LtlShipmentDetails-PaymentSummary__title\">Payment Summary</div>\n\n  <div class=\"xpo-LtlShipmentDetails-PaymentSummary__row\">\n    <div class=\"xpo-LtlShipmentDetails-PaymentSummary__group-full\">\n      <div class=\"xpo-LtlShipmentDetails-PaymentSummary__label\">Status</div>\n      <div\n        class=\"xpo-LtlShipmentDetails-PaymentSummary__status\"\n        [class.paid-in-full]=\"(summary$ | async)?.status === 'PAID IN FULL'\"\n        [class.open]=\"(summary$ | async)?.status === 'OPEN'\"\n      >\n        {{ (summary$ | async)?.status | titlecase }}\n      </div>\n    </div>\n  </div>\n\n  <div class=\"xpo-LtlShipmentDetails-PaymentSummary__row\">\n    <xpo-ltl-data-display-group\n      label=\"Payments\"\n      [value]=\"(summary$ | async)?.payments | currency\"\n    ></xpo-ltl-data-display-group>\n  </div>\n\n  <div class=\"xpo-LtlShipmentDetails-PaymentSummary__row\">\n    <xpo-ltl-data-display-group\n      label=\"Charges\"\n      [value]=\"(summary$ | async)?.charges | currency\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      label=\"Adjustments\"\n      [value]=\"(summary$ | async)?.adjustments | currency\"\n    ></xpo-ltl-data-display-group>\n  </div>\n\n  <div class=\"xpo-LtlShipmentDetails-PaymentSummary__row\">\n    <div class=\"xpo-LtlShipmentDetails-PaymentSummary__group-full current-balance\">\n      <div class=\"xpo-LtlShipmentDetails-PaymentSummary__label\">Current Balance</div>\n      <div\n        class=\"xpo-LtlShipmentDetails-PaymentSummary__status\"\n        [class.balance-warning]=\"(summary$ | async)?.currentBalance > 0\"\n      >\n        {{ (summary$ | async)?.currentBalance | currency }}\n      </div>\n    </div>\n  </div>\n\n  <button\n    *ngIf=\"hasFreightChargesTab\"\n    class=\"xpo-LtlShipmentDetails-PaymentSummary__button\"\n    mat-flat-button\n    color=\"primary\"\n    (click)=\"openFreightChargesTab()\"\n  >\n    Freight Charges\n  </button>\n</div>\n", styles: [".flex--stretch{flex:1}xpo-ltl-shipment-details-payment-summary{display:flex;flex:0 0 auto;width:288px;height:368px}.xpo-LtlShipmentDetails-PaymentSummary{display:flex;flex:0 0 auto;flex-direction:column;font-size:12px;color:#4a4a4a;background-color:#f3f3f3;border-radius:8px;padding:16px 24px;width:100%}.xpo-LtlShipmentDetails-PaymentSummary__row{display:flex;flex:1 1 auto;flex-direction:row;margin:4px 0;justify-content:space-between}.xpo-LtlShipmentDetails-PaymentSummary__row .xpo-LtlDataDisplayGroup{width:128px;margin:0}.xpo-LtlShipmentDetails-PaymentSummary__title{font-size:18px;font-weight:500;align-items:center;justify-content:flex-start;margin-bottom:16px;letter-spacing:.37px}.xpo-LtlShipmentDetails-PaymentSummary__group-full{display:flex;flex:0 0 auto;flex-direction:column;width:100%}.xpo-LtlShipmentDetails-PaymentSummary__label{margin-bottom:4px;font-size:12px;font-weight:500;letter-spacing:.25px;line-height:16px}.xpo-LtlShipmentDetails-PaymentSummary__status{font-size:16px;font-weight:500;color:#4a4a4a;letter-spacing:.33px;line-height:24px}.xpo-LtlShipmentDetails-PaymentSummary__status.paid-in-full{color:#00c853}.xpo-LtlShipmentDetails-PaymentSummary__status.balance-warning,.xpo-LtlShipmentDetails-PaymentSummary__status.open{color:#d50000}"], components: [{ type: DataDisplayGroupComponent, selector: "xpo-ltl-data-display-group", inputs: ["label", "value", "asCurrency", "asDate"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i5.AsyncPipe, "titlecase": i5.TitleCasePipe, "currency": i5.CurrencyPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsPaymentSummaryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-payment-summary',
                    templateUrl: './shipment-details-payment-summary.component.html',
                    styleUrls: ['./shipment-details-payment-summary.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: ShipmentReferenceService }, { type: i2$8.AccountsReceivableApiService }]; }, propDecorators: { hasFreightChargesTab: [{
                type: Input
            }], openFreightCharges: [{
                type: Output
            }] } });

class ShipmentDetailsSrnsComponent {
    constructor(shipmentRefService) {
        this.shipmentRefService = shipmentRefService;
        this.unsubscriber = new Unsubscriber();
        this.srnsSubject = new BehaviorSubject([]);
        this.srns$ = this.srnsSubject.asObservable();
    }
    ngOnInit() {
        this.shipmentRefService.shipment$
            .pipe(takeUntil(this.unsubscriber.done$), distinctUntilChanged())
            .subscribe((shipment) => {
            this.updateFormFromShipment(shipment);
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    updateFormFromShipment(shipment) {
        if (!shipment) {
            return;
        }
        const firstPOSrn = find(shipment.suppRefNbr, (srn) => srn.typeCd === 'PO#');
        this.srnsSubject.next(filter$1(shipment.suppRefNbr, (srn) => srn.typeCd !== 'SN#' && srn !== firstPOSrn));
    }
}
ShipmentDetailsSrnsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsSrnsComponent, deps: [{ token: ShipmentReferenceService }], target: i0.ɵɵFactoryTarget.Component });
ShipmentDetailsSrnsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentDetailsSrnsComponent, selector: "xpo-ltl-shipment-details-srns", ngImport: i0, template: "<div class=\"shipment-details-srns\">\n  <div class=\"shipment-details-srns__content\">\n    <div *ngFor=\"let srn of srns$ | async\" class=\"shipment-details-srns__content-number\">\n      {{ srn.typeCd }} {{ srn.refNbr }},\n    </div>\n  </div>\n</div>\n", styles: [".shipment-details-srns,:host{display:flex;flex:1 1 auto}.shipment-details-srns{background-color:#f5f5f5;flex-direction:column;width:100%;margin-bottom:16px}.shipment-details-srns__content{padding:8px;display:flex;flex:1 1 auto;flex-direction:row;flex-wrap:wrap}.shipment-details-srns__content-number{flex:0 0 auto;margin-right:8px}"], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsSrnsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-srns',
                    templateUrl: './shipment-details-srns.component.html',
                    styleUrls: ['./shipment-details-srns.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: ShipmentReferenceService }]; } });

class ShipmentDetailsLineItemsComponent {
    constructor(shipmentRefService, currencyPipe, commodityClassCdPipe, currencyCdPipe) {
        this.shipmentRefService = shipmentRefService;
        this.currencyPipe = currencyPipe;
        this.commodityClassCdPipe = commodityClassCdPipe;
        this.currencyCdPipe = currencyCdPipe;
        this.hideCharges = false;
        this.toggleDimensions = new EventEmitter();
        this.unsubscriber = new Unsubscriber();
        this.columns = [
            { id: 'pieces', label: 'Pieces' },
            { id: 'description', label: 'Description' },
            { id: 'classType', label: 'Class', renderer: (row) => this.commodityClassCdPipe.transform(row.classType) },
            {
                id: 'asRatedClassCd',
                label: 'Rate Class',
                renderer: (row) => this.commodityClassCdPipe.transform(row.asRatedClassCd),
            },
            { id: 'nmfc', label: 'NMFC' },
            { id: 'weight', label: 'Weight' },
        ];
        this.columnsToDisplay = [];
        this.dataSource = new MatTableDataSource(undefined);
        this.showDimensions = false;
    }
    ngOnInit() {
        // add charges to display if we aren't hiding them
        if (!this.hideCharges) {
            this.columns.push({ id: 'rate', label: 'Rate', renderer: (row) => this.currencyPipe.transform(row.rate) });
            this.columns.push({
                id: 'charges',
                label: 'Charges',
                renderer: (row) => `${this.currencyPipe.transform(row.charges)} ${row.currency || ''}`,
            });
        }
        this.columnsToDisplay = map$1(this.columns, (c) => c.id);
        this.shipmentRefService.shipment$
            .pipe(takeUntil(this.unsubscriber.done$), distinctUntilChanged())
            .subscribe((shipment) => {
            this.updateFormFromShipment(shipment);
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    handleToggleDimensions() {
        this.showDimensions = !this.showDimensions;
        this.toggleDimensions.emit(this.showDimensions);
    }
    updateFormFromShipment(shipment) {
        if (!shipment) {
            return;
        }
        let data;
        data = map$1(shipment.commodity, (commodity) => {
            return {
                pieces: commodity.piecesCount,
                description: commodity.description,
                classType: commodity.classType,
                asRatedClassCd: commodity.asRatedClassCd,
                nmfc: commodity.nmfcItemCd,
                weight: commodity.weightLbs,
                rate: commodity.tariffsRate,
                charges: commodity.amount,
                currency: null,
            };
        });
        const accessorials = map$1(shipment.accessorialService, (accessorial) => {
            return {
                description: accessorial.description,
                rate: accessorial.tariffsRate,
                charges: accessorial.amount,
                currency: null,
            };
        });
        const miscLineItems = map$1(shipment.miscLineItem, (miscLineItem) => {
            return {
                description: miscLineItem.description,
                rate: miscLineItem.tariffsRate,
                charges: miscLineItem.amount,
                currency: null,
                lineTypeCd: miscLineItem.lineTypeCd,
            };
        });
        data.push(...accessorials, ...miscLineItems);
        // calculate total and add to end of list
        const totals = reduce(data, (total, value) => {
            const lineTypeCd = get(value, 'lineTypeCd', undefined);
            const hasDiscount = !!lineTypeCd && lineTypeCd === MiscLineItemCd.DISC_LN;
            return {
                pieces: total.pieces + defaultTo(value.pieces, 0),
                charges: total.charges + defaultTo(hasDiscount ? -value.charges : value.charges, 0),
            };
        }, { pieces: 0, charges: 0 });
        data.push({
            pieces: totals.pieces,
            description: 'TOTAL',
            classType: undefined,
            asRatedClassCd: undefined,
            nmfc: undefined,
            weight: undefined,
            rate: undefined,
            charges: totals.charges,
            currency: this.currencyCdPipe.transform(shipment.shipment.invoicingCurrencyCd),
        });
        // update the datasource with the data
        this.dataSource.data = data;
    }
}
ShipmentDetailsLineItemsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsLineItemsComponent, deps: [{ token: ShipmentReferenceService }, { token: i5.CurrencyPipe }, { token: CommodityClassCdPipe }, { token: CurrencyCodePipe }], target: i0.ɵɵFactoryTarget.Component });
ShipmentDetailsLineItemsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentDetailsLineItemsComponent, selector: "xpo-ltl-shipment-details-line-items", inputs: { hideCharges: "hideCharges" }, outputs: { toggleDimensions: "toggleDimensions" }, ngImport: i0, template: "<div class=\"shipment-details-line-items\">\n  <div class=\"shipment-details-line-items__title\">Line Items</div>\n\n  <div class=\"shipment-details-line-items__table\">\n    <table mat-table [dataSource]=\"dataSource\">\n      <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.id\">\n        <th mat-header-cell *matHeaderCellDef>{{ column.label }}</th>\n        <td mat-cell *matCellDef=\"let row\">\n          <span>{{ (column.renderer ? column.renderer(row) : row[column.id]) | emptyValue }}</span>\n        </td>\n      </ng-container>\n\n      <tr mat-header-row *matHeaderRowDef=\"columnsToDisplay\"></tr>\n      <tr mat-row *matRowDef=\"let row; columns: columnsToDisplay\"></tr>\n    </table>\n  </div>\n  <div class=\"xpo-LtlShipmentDetails-Overview__row xpo-LtlShipmentDetails-Overview__more-dimensions\">\n    <button mat-button (click)=\"handleToggleDimensions()\">\n      <ng-container *ngIf=\"showDimensions; then lessDimensions; else moreDimensions\"></ng-container>\n    </button>\n    <ng-template #lessDimensions>\n      <mat-icon>expand_more</mat-icon>\n      <span class=\"xpo-LtlShipmentDetails-Overview__more-dimensions--label\">Dimensions</span>\n    </ng-template>\n\n    <ng-template #moreDimensions>\n      <mat-icon>chevron_right</mat-icon>\n      <span class=\"xpo-LtlShipmentDetails-Overview__more-dimensions--label\">Dimensions</span>\n    </ng-template>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}:host{display:flex;flex:1 1 auto;border-top:thin solid rgba(0,0,0,.12)}.shipment-details-line-items{display:flex;flex:1 1 auto;flex-direction:column}.shipment-details-line-items .xpo-LtlShipmentDetails-Overview__more-dimensions{height:32px;min-height:32px;margin-top:10px;margin-bottom:10px}.shipment-details-line-items .xpo-LtlShipmentDetails-Overview__more-dimensions .mat-button{padding-left:0;padding-right:8px}.shipment-details-line-items .xpo-LtlShipmentDetails-Overview__more-dimensions--label{color:#0868ac}.shipment-details-line-items__title{display:flex;justify-content:flex-start;align-items:center;height:48px}.shipment-details-line-items__table{display:flex;flex:1 1 auto}.shipment-details-line-items__table .mat-table{width:100%}.shipment-details-line-items__table .mat-table .mat-column-pieces{width:56px}.shipment-details-line-items__table .mat-table .mat-column-description{width:276px}.shipment-details-line-items__table .mat-table .mat-row:last-of-type .mat-cell{font-weight:700}"], components: [{ type: i5$4.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { type: i5$4.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { type: i5$4.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$4.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { type: i5$4.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { type: i5$4.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { type: i5$4.MatCellDef, selector: "[matCellDef]" }, { type: i5$4.MatCell, selector: "mat-cell, td[mat-cell]" }, { type: i5$4.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { type: i5$4.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "emptyValue": EmptyValuePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsLineItemsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-line-items',
                    templateUrl: './shipment-details-line-items.component.html',
                    styleUrls: ['./shipment-details-line-items.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: ShipmentReferenceService }, { type: i5.CurrencyPipe }, { type: CommodityClassCdPipe }, { type: CurrencyCodePipe }]; }, propDecorators: { hideCharges: [{
                type: Input
            }], toggleDimensions: [{
                type: Output
            }] } });

class ShipmentDimensionsComponent {
    constructor(shipmentRefService) {
        this.shipmentRefService = shipmentRefService;
        this.unsubscriber = new Unsubscriber();
        this.showDimensions = false;
        this.columns = [
            { id: 'quantity', label: 'Quantity' },
            { id: 'lengthNbr', label: 'Length' },
            { id: 'widthNbr', label: 'Width' },
            { id: 'heightNbr', label: 'Height' },
        ];
        this.columnsToDisplay = map$1(this.columns, (c) => c.id);
        this.dimensionsSubject = new BehaviorSubject({
            Quantity: undefined,
            Length: undefined,
            Width: undefined,
            Height: undefined,
        });
        this.dimensions$ = this.dimensionsSubject.asObservable();
        this.DataDisplayGroupType = DataDisplayGroupType;
    }
    ngOnInit() {
        this.shipmentRefService.shipment$
            .pipe(distinctUntilChanged(), takeUntil(this.unsubscriber.done$))
            .subscribe((shipment) => {
            this.updateFormFromShipment(shipment);
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    setPackageQuantity(dimensionsArray) {
        const strArray = [];
        const resultArray = [];
        forEach(dimensionsArray, function (packageDimension) {
            packageDimension.quantity = 1;
            packageDimension = JSON.stringify(packageDimension);
            const indexPackageInStrArray = findIndex(strArray, (o) => o === packageDimension);
            if (indexPackageInStrArray === -1) {
                strArray.push(packageDimension);
                resultArray.push(JSON.parse(packageDimension));
            }
            else {
                resultArray[indexPackageInStrArray].quantity += 1;
            }
        });
        return resultArray;
    }
    updateFormFromShipment(shipment) {
        const dimensions = get(shipment, 'linehaulDimensions');
        this.packagesDimensionList = this.setPackageQuantity(dimensions);
        this.dataSource = this.packagesDimensionList;
        if (!shipment) {
            return;
        }
        this.noDimensions = !dimensions || !dimensions.length;
    }
}
ShipmentDimensionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDimensionsComponent, deps: [{ token: ShipmentReferenceService }], target: i0.ɵɵFactoryTarget.Component });
ShipmentDimensionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentDimensionsComponent, selector: "xpo-ltl-shipment-details-dimensions", ngImport: i0, template: "<div class=\"shipment-details-dimensions\">\n  <div class=\"shipment-details-dimensions__table\">\n    <table mat-table [dataSource]=\"dataSource\">\n      <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.id\">\n        <th mat-header-cell *matHeaderCellDef>{{ column.label }}</th>\n        <td mat-cell *matCellDef=\"let row\">\n          <span>{{ row[column.id] }}</span>\n        </td>\n      </ng-container>\n      <tr mat-header-row *matHeaderRowDef=\"columnsToDisplay\"></tr>\n      <tr mat-row *matRowDef=\"let row; columns: columnsToDisplay\"></tr>\n    </table>\n  </div>\n  <div class=\"shipment-details-dimensions__row\" *ngIf=\"noDimensions === true\">\n    No data available\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}:host{display:flex;flex:1 1 auto}.shipment-details-dimensions{display:flex;flex:1 1 auto;flex-direction:column}.shipment-details-dimensions table{width:100%;margin-bottom:-1px}"], components: [{ type: i5$4.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { type: i5$4.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { type: i5$4.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$4.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { type: i5$4.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { type: i5$4.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { type: i5$4.MatCellDef, selector: "[matCellDef]" }, { type: i5$4.MatCell, selector: "mat-cell, td[mat-cell]" }, { type: i5$4.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { type: i5$4.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDimensionsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-dimensions',
                    templateUrl: './shipment-details-dimensions.component.html',
                    styleUrls: ['./shipment-details-dimensions.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: ShipmentReferenceService }]; } });

class ShipmentDetailsRemarksComponent {
    constructor(shipmentRefService) {
        this.shipmentRefService = shipmentRefService;
        this.unsubscriber = new Unsubscriber();
        this.remarksSubject = new BehaviorSubject('None');
        this.remarks$ = this.remarksSubject.asObservable();
    }
    ngOnInit() {
        this.shipmentRefService.shipment$
            .pipe(takeUntil(this.unsubscriber.done$), distinctUntilChanged())
            .subscribe((shipment) => {
            this.updateFormFromShipment(shipment);
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    updateFormFromShipment(shipment) {
        if (!shipment) {
            return;
        }
        this.remarksSubject.next(get(shipment, 'remark[0].remark', 'None'));
    }
}
ShipmentDetailsRemarksComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsRemarksComponent, deps: [{ token: ShipmentReferenceService }], target: i0.ɵɵFactoryTarget.Component });
ShipmentDetailsRemarksComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentDetailsRemarksComponent, selector: "xpo-ltl-shipment-details-remarks", ngImport: i0, template: "<div class=\"shipment-details-remarks\">\n  <div class=\"shipment-details-remarks__title\">Remarks</div>\n  <div class=\"shipment-details-remarks__remarks\">{{ remarks$ | async }}</div>\n</div>\n", styles: [":host{display:flex;flex:1 1 auto;border-top:thin solid rgba(0,0,0,.12)}.shipment-details-remarks{display:flex;flex:1 1 auto;flex-direction:column}.shipment-details-remarks__title{justify-content:flex-start;align-items:center;height:48px;display:flex}.shipment-details-remarks__remarks{font-size:14px;color:rgba(0,0,0,.87);padding-bottom:16px;margin-right:16px}"], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsRemarksComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-remarks',
                    templateUrl: './shipment-details-remarks.component.html',
                    styleUrls: ['./shipment-details-remarks.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: ShipmentReferenceService }]; } });

class ShipmentDetailsGeneralInfoComponent {
    constructor(shipmentRefService) {
        this.shipmentRefService = shipmentRefService;
        this.unsubscriber = new Unsubscriber();
        this.generalInfoSubject = new BehaviorSubject({
            codAmount: undefined,
            palletCount: undefined,
            pieceCount: undefined,
            linealFeet: undefined,
            totalWeight: undefined,
        });
        this.generalInfo$ = this.generalInfoSubject.asObservable();
        this.DataDisplayGroupType = DataDisplayGroupType;
    }
    ngOnInit() {
        this.shipmentRefService.shipment$
            .pipe(takeUntil(this.unsubscriber.done$), distinctUntilChanged())
            .subscribe((shipment) => {
            this.updateFormFromShipment(shipment);
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    updateFormFromShipment(shipment) {
        if (!shipment) {
            return;
        }
        const totalPieces = reduce(shipment.commodity, (total, commodity) => total + commodity.piecesCount, 0);
        const codItem = find(shipment.miscLineItem, (li) => li.lineTypeCd === MiscLineItemCd.COD_AMT);
        const codAmount = codItem
            ? {
                amt: codItem.amount,
                currencyCd: 'USD', // always in US$
            }
            : undefined;
        this.generalInfoSubject.next({
            // codAmount: shipment.shipment.codInd ? shipment.chargeInfo.totalChargeAmt : undefined,
            codAmount: codAmount,
            palletCount: shipment.shipment.totalPalletsCount,
            pieceCount: totalPieces,
            linealFeet: shipment.shipment.linealFootTotalNbr,
            totalWeight: shipment.shipment.totalWeightLbs,
        });
    }
}
ShipmentDetailsGeneralInfoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsGeneralInfoComponent, deps: [{ token: ShipmentReferenceService }], target: i0.ɵɵFactoryTarget.Component });
ShipmentDetailsGeneralInfoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentDetailsGeneralInfoComponent, selector: "xpo-ltl-shipment-details-general-info", ngImport: i0, template: "<div class=\"shipment-details-general-info\">\n  <div class=\"shipment-details-general-info__title\">General Information</div>\n  <div class=\"shipment-details-general-info__row\">\n    <xpo-ltl-data-display-group\n      label=\"COD Amount\"\n      [value]=\"(generalInfo$ | async)?.codAmount\"\n      [asCurrency]=\"true\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      label=\"Pallet Count\"\n      [value]=\"(generalInfo$ | async)?.palletCount\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      label=\"Piece Count\"\n      [value]=\"(generalInfo$ | async)?.pieceCount\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      label=\"Lineal Feet\"\n      [value]=\"(generalInfo$ | async)?.linealFeet\"\n    ></xpo-ltl-data-display-group>\n    <xpo-ltl-data-display-group\n      label=\"Total Weight (lbs)\"\n      [value]=\"(generalInfo$ | async)?.totalWeight\"\n    ></xpo-ltl-data-display-group>\n  </div>\n</div>\n", styles: [":host{display:flex;flex:1 1 auto;border-top:thin solid rgba(0,0,0,.12)}.shipment-details-general-info{display:flex;flex:1 1 auto;flex-direction:column}.shipment-details-general-info .xpo-LtlDataDisplayGroup{margin-right:32px;width:150px}.shipment-details-general-info .xpo-LtlDataDisplayGroup__label{margin-bottom:4px}.shipment-details-general-info__title{display:flex;justify-content:flex-start;align-items:center;height:48px}.shipment-details-general-info__info{height:48px}.shipment-details-general-info__row{display:flex;flex:1 1 auto;flex-direction:row;height:auto;max-height:100px;justify-content:space-between}"], components: [{ type: DataDisplayGroupComponent, selector: "xpo-ltl-data-display-group", inputs: ["label", "value", "asCurrency", "asDate"] }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsGeneralInfoComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-general-info',
                    templateUrl: './shipment-details-general-info.component.html',
                    styleUrls: ['./shipment-details-general-info.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: ShipmentReferenceService }]; } });

class ShipmentDetailsDetailsComponent {
    constructor() {
        this.hasFreightChargesTab = false;
        this.hidePaymentSummary = false;
        this.hideCharges = false;
        this.openTab = new EventEmitter();
        this.showSRNsSubject = new BehaviorSubject(false);
        this.showDimensionsSubject = new BehaviorSubject(false);
        this.showSRNs$ = this.showSRNsSubject.asObservable();
        this.showDimensions$ = this.showDimensionsSubject.asObservable();
    }
    set showSRNs(value) {
        this.showSRNsSubject.next(value);
    }
    set showDimensions(value) {
        this.showDimensionsSubject.next(value);
    }
    ngOnInit() { }
    openFreightCharges() {
        this.openTab.emit(XpoLtlShipmentDetailsTabs.Charges);
    }
    toggleSRNs(show) {
        this.showSRNs = show;
    }
    toggleDimensions(show) {
        this.showDimensions = show;
    }
}
ShipmentDetailsDetailsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsDetailsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ShipmentDetailsDetailsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentDetailsDetailsComponent, selector: "xpo-ltl-shipment-details-details", inputs: { hasFreightChargesTab: "hasFreightChargesTab", hidePaymentSummary: "hidePaymentSummary", hideCharges: "hideCharges" }, outputs: { openTab: "openTab" }, ngImport: i0, template: "<div class=\"xpo-LtlShipmentDetails-Details\">\n  <div class=\"xpo-LtlShipmentDetails-Details__row\">\n    <xpo-ltl-shipment-details-overview (toggleSRNs)=\"toggleSRNs($event)\"></xpo-ltl-shipment-details-overview>\n    <xpo-ltl-shipment-details-payment-summary\n      *ngIf=\"!hidePaymentSummary\"\n      [hasFreightChargesTab]=\"hasFreightChargesTab\"\n      (openFreightCharges)=\"openFreightCharges()\"\n    ></xpo-ltl-shipment-details-payment-summary>\n  </div>\n  <div class=\"xpo-LtlShipmentDetails-Details__row xpo-LtlShipmentDetails-Details__srns-panel\">\n    <mat-expansion-panel [expanded]=\"showSRNs$ | async\" class=\"mat-elevation-z0\">\n      <xpo-ltl-shipment-details-srns></xpo-ltl-shipment-details-srns>\n    </mat-expansion-panel>\n  </div>\n  <div class=\"xpo-LtlShipmentDetails-Details__row\">\n    <xpo-ltl-shipment-details-line-items\n      [hideCharges]=\"hideCharges\"\n      (toggleDimensions)=\"toggleDimensions($event)\"\n    ></xpo-ltl-shipment-details-line-items>\n  </div>\n  <div class=\"xpo-LtlShipmentDetails-Details__row xpo-LtlShipmentDetails-Details__dimensions-panel\">\n    <mat-expansion-panel [expanded]=\"showDimensions$ | async\" class=\"mat-elevation-z0\">\n      <xpo-ltl-shipment-details-dimensions></xpo-ltl-shipment-details-dimensions>\n    </mat-expansion-panel>\n  </div>\n  <div class=\"xpo-LtlShipmentDetails-Details__row\">\n    <xpo-ltl-shipment-details-remarks></xpo-ltl-shipment-details-remarks>\n  </div>\n  <div class=\"xpo-LtlShipmentDetails-Details__row\">\n    <xpo-ltl-shipment-details-general-info></xpo-ltl-shipment-details-general-info>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}.xpo-LtlShipmentDetails-Details{display:flex;flex:1 1 auto;margin:16px;flex-direction:column;font-size:12px;color:#4a4a4a}.xpo-LtlShipmentDetails-Details__row{display:flex;flex:1 1 auto;flex-direction:row}.xpo-LtlShipmentDetails-Details__row:first-of-type{margin-bottom:14px}.xpo-LtlShipmentDetails-Details__dimensions-panel,.xpo-LtlShipmentDetails-Details__srns-panel{display:flex;flex:1 1 auto}.xpo-LtlShipmentDetails-Details__dimensions-panel .mat-expansion-panel,.xpo-LtlShipmentDetails-Details__srns-panel .mat-expansion-panel{display:flex;flex:1 1 auto;border-radius:0}.xpo-LtlShipmentDetails-Details__dimensions-panel .mat-expansion-panel .mat-expansion-panel-content,.xpo-LtlShipmentDetails-Details__srns-panel .mat-expansion-panel .mat-expansion-panel-content{flex:1 1 auto}.xpo-LtlShipmentDetails-Details__dimensions-panel .mat-expansion-panel .mat-expansion-panel-content .mat-expansion-panel-body,.xpo-LtlShipmentDetails-Details__srns-panel .mat-expansion-panel .mat-expansion-panel-content .mat-expansion-panel-body{padding:0}"], components: [{ type: ShipmentDetailsOverviewComponent, selector: "xpo-ltl-shipment-details-overview", outputs: ["toggleSRNs"] }, { type: ShipmentDetailsPaymentSummaryComponent, selector: "xpo-ltl-shipment-details-payment-summary", inputs: ["hasFreightChargesTab"], outputs: ["openFreightCharges"] }, { type: i7$3.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { type: ShipmentDetailsSrnsComponent, selector: "xpo-ltl-shipment-details-srns" }, { type: ShipmentDetailsLineItemsComponent, selector: "xpo-ltl-shipment-details-line-items", inputs: ["hideCharges"], outputs: ["toggleDimensions"] }, { type: ShipmentDimensionsComponent, selector: "xpo-ltl-shipment-details-dimensions" }, { type: ShipmentDetailsRemarksComponent, selector: "xpo-ltl-shipment-details-remarks" }, { type: ShipmentDetailsGeneralInfoComponent, selector: "xpo-ltl-shipment-details-general-info" }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsDetailsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-details',
                    templateUrl: './shipment-details-details.component.html',
                    styleUrls: ['./shipment-details-details.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { hasFreightChargesTab: [{
                type: Input
            }], hidePaymentSummary: [{
                type: Input
            }], hideCharges: [{
                type: Input
            }], openTab: [{
                type: Output
            }] } });

class XpoLtlShipmentSelectorComponent {
    constructor(proFormatterPipe, formValidationService, shipmentOdsApiService) {
        this.proFormatterPipe = proFormatterPipe;
        this.formValidationService = formValidationService;
        this.shipmentOdsApiService = shipmentOdsApiService;
        this.searchable = false;
        this.selectionChange = new EventEmitter();
        this.invalidSubject = new BehaviorSubject(false);
        this.invalid$ = this.invalidSubject.asObservable();
        this.shipmentListSubject = new BehaviorSubject([]);
        this.shipmentList$ = this.shipmentListSubject.asObservable();
    }
    ngAfterContentInit() {
        // make sure all ProNbrs are in 10-digit format
        const shipmentList = defaultTo(sortBy(map$1(this.shipments, (s) => {
            return Object.assign(Object.assign({}, s), { proNbr: this.proFormatterPipe.transform(s.proNbr, 10) });
        }), ['proNbr']), []);
        this.shipmentListSubject.next(shipmentList);
        this.selectShipment(first(shipmentList));
        this.clearSearch();
    }
    selectShipment(shipment) {
        if (!isEqual(shipment, this.selectedShipment)) {
            this.selectedShipment = shipment;
            this.selectionChange.emit(this.selectedShipment);
        }
    }
    isSearchValidPro() {
        return true;
    }
    clearSearch() {
        this.proSearchValue = '';
        this.invalidSubject.next(false);
    }
    handleSearchForShipments() {
        const searchForPro = this.proFormatterPipe.transform(this.proSearchValue, 10);
        this.proSearchValue = searchForPro;
        this.invalidSubject.next(!this.formValidationService.isValidProNumber(searchForPro));
        if (!this.invalidSubject.value &&
            !find(this.shipmentListSubject.value, (shipment) => shipment.proNbr === this.proSearchValue)) {
            // search for PRO shipments that have the requested PRO and add those to the list.
            const request = new ListOdsShipmentsRqst();
            request.proNbrs = [this.proSearchValue];
            this.shipmentOdsApiService
                .listOdsShipments(request)
                .pipe(map((resp) => {
                return map$1(resp.odsShipments, (shipment) => {
                    return {
                        proNbr: this.proFormatterPipe.transform(shipment.shipment.proNbr, 10),
                        pickupDate: `${shipment.shipment.pickupDate}`,
                        shipmentInstId: shipment.shipment.shipmentInstId,
                    };
                });
            }))
                .subscribe((newShipments) => {
                const newList = concat$1(this.shipmentListSubject.value, newShipments);
                const shipmentToSelect = first(newShipments);
                const shipmentList = sortBy(newList, ['proNbr']);
                this.shipmentListSubject.next(shipmentList);
                this.clearSearch();
                this.selectShipment(shipmentToSelect);
            });
        }
    }
}
XpoLtlShipmentSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentSelectorComponent, deps: [{ token: ProFormatterPipe }, { token: i3$1.FormatValidationService }, { token: i3$5.ShipmentOdsApiService }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlShipmentSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlShipmentSelectorComponent, selector: "xpo-ltl-shipment-selector", inputs: { shipments: "shipments", searchable: "searchable" }, outputs: { selectionChange: "selectionChange" }, ngImport: i0, template: "<div class=\"xpo-LtlShipmentSelector\">\n  <div class=\"xpo-LtlShipmentSelector__title\">\n    <span>Shipment PROs</span>\n  </div>\n\n  <div *ngIf=\"searchable\" class=\"xpo-LtlShipmentSelector__search\">\n    <mat-icon matPrefix>search</mat-icon>\n    <input\n      matInput\n      type=\"text\"\n      placeholder=\"Search PRO\"\n      [(ngModel)]=\"proSearchValue\"\n      (blur)=\"handleSearchForShipments()\"\n      [class.invalid]=\"invalid$ | async\"\n    />\n    <button mat-button *ngIf=\"proSearchValue\" matSuffix mat-icon-button (click)=\"clearSearch()\">\n      <mat-icon>close</mat-icon>\n    </button>\n  </div>\n\n  <mat-list #availableShipments (selectionChange)=\"selectShipment($event)\">\n    <div class=\"xpo-LtlShipmentSelector__empty\" *ngIf=\"(shipmentList$ | async)?.length == 0\">\n      No Matching Shipments\n    </div>\n    <ng-container\n      *ngFor=\"let shipment of shipmentList$ | async\"\n      [ngTemplateOutlet]=\"shipmentDescription\"\n      [ngTemplateOutletContext]=\"{ shipment: shipment }\"\n    ></ng-container>\n  </mat-list>\n</div>\n\n<ng-template #shipmentDescription let-shipment=\"shipment\">\n  <div\n    class=\"xpo-LtlShipmentSelector__item\"\n    (click)=\"selectShipment(shipment)\"\n    [class.selected]=\"selectedShipment === shipment\"\n  >\n    PRO#: {{ shipment.proNbr | proFormatter: 10 }}\n  </div>\n</ng-template>\n", styles: [".flex--stretch{flex:1}:host{display:flex;flex-direction:column}.xpo-LtlShipmentSelector__title{width:230px;font-size:1.143rem;font-weight:700}.xpo-LtlShipmentSelector__search,.xpo-LtlShipmentSelector__title{display:flex;padding-left:1rem;height:40px;justify-content:flex-start;align-items:center}.xpo-LtlShipmentSelector__search{flex:1 1 auto}.xpo-LtlShipmentSelector__search .mat-icon{color:#4a4a4a}.xpo-LtlShipmentSelector__search input.invalid{color:#f22!important}.xpo-LtlShipmentSelector .mat-list-base{padding-top:0}.xpo-LtlShipmentSelector__empty{color:#4a4a4a;padding:1rem;font-style:italic}.xpo-LtlShipmentSelector__item{border:1px solid #f3f3f3;color:#4a4a4a;padding:1rem}.xpo-LtlShipmentSelector__item:hover{background-color:#f3f3f3;cursor:pointer}.xpo-LtlShipmentSelector__item.selected{border:1px solid #0868ac;background-color:#e8f5fe}"], components: [{ type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i6$4.MatList, selector: "mat-list, mat-action-list", inputs: ["disableRipple", "disabled"], exportAs: ["matList"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.MatPrefix, selector: "[matPrefix]" }, { type: i21.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i7.MatSuffix, selector: "[matSuffix]" }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "async": i5.AsyncPipe, "proFormatter": ProFormatterPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentSelectorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-selector',
                    templateUrl: './shipment-selector.component.html',
                    styleUrls: ['./shipment-selector.component.scss'],
                    encapsulation: ViewEncapsulation.Emulated,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: ProFormatterPipe }, { type: i3$1.FormatValidationService }, { type: i3$5.ShipmentOdsApiService }]; }, propDecorators: { shipments: [{
                type: Input
            }], searchable: [{
                type: Input
            }], selectionChange: [{
                type: Output
            }] } });

class ShipmentDetailsEventsComponent {
    constructor(shipmentRefService, shipmentOdsApiService, sicDatePipe, locationDetailsService, employeeDetailsCacheService) {
        this.shipmentRefService = shipmentRefService;
        this.shipmentOdsApiService = shipmentOdsApiService;
        this.sicDatePipe = sicDatePipe;
        this.locationDetailsService = locationDetailsService;
        this.employeeDetailsCacheService = employeeDetailsCacheService;
        this.unsubscriber = new Unsubscriber();
        this.columns = [
            {
                id: 'occurredTmst',
                label: 'Date/Time (local)',
                rendererAsync: (row) => this.displayTime(row),
            },
            {
                id: 'elapsedTm',
                label: 'Elapsed Time',
                renderer: (row) => (row.elapsedTm ? moment$3(row.elapsedTm).format('HH:mm') : undefined),
            },
            { id: 'occurredSic', label: 'SIC' },
            { id: 'description', label: 'Description' },
            {
                id: 'originDest',
                label: 'Origin - Destination',
                renderer: (row) => this.appendValues(row.originSic, row.destinationSic),
            },
            { id: 'loadReleaseNbr', label: 'Load Release' },
            { id: 'loadDestinationSic', label: 'Load Destination' },
            { id: 'trailerNbr', label: 'Trailer' },
            {
                id: 'weightCubeBls',
                label: 'Weight/Cube/Bls',
                renderer: (row) => this.appendValues(row.trailerWeightLbs, row.trailerCubePct, row.shipmentsOnTrailerCnt),
            },
            { id: 'updtBy', label: 'Updated By', rendererAsync: (row) => this.userNameFromEmplId(row) },
        ];
        this.columnsToDisplay = map$1(this.columns, (c) => c.id);
        this.dataSource = new MatTableDataSource(undefined);
    }
    ngOnInit() {
        this.shipmentRefService.shipment$
            .pipe(takeUntil(this.unsubscriber.done$), distinctUntilChanged())
            .subscribe((shipment) => {
            this.updateFormFromShipment(shipment);
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    appendValues(...args) {
        if (!!args && args.some((arg) => !!arg)) {
            return args.join('/');
        }
        return '';
    }
    updateFormFromShipment(shipment) {
        if (!shipment) {
            return;
        }
        const request = new ListOdsShipmentHistTraceEventsRqst();
        request.odsShipmentId = {
            shipmentInstId: shipment.shipment.shipmentInstId,
            proNbr: shipment.shipment.proNbr,
            pickupDate: `${shipment.shipment.pickupDate.valueOf()}`,
        };
        this.shipmentOdsApiService
            .listOdsShipmentHistTraceEvents(request)
            .subscribe((result) => {
            this.dataSource.data = result.shipmentTraceHistoryEvents;
        });
    }
    displayTime(event) {
        if (!event.occurredTmst) {
            return of('-');
        }
        const fallback = moment$3(event.occurredTmst).format('MM/DD/YYYY HH:mm');
        if (!!event.occurredSic) {
            return this.locationDetailsService.request({ sicCd: event.occurredSic }).pipe(take(1), switchMap((response) => {
                if (!!get(response, 'locReference.timezoneName')) {
                    return of(moment$3(event.occurredTmst)
                        .tz(response.locReference.timezoneName)
                        .format('MM/DD/YYYY HH:mm'));
                }
                return of(fallback);
            }));
        }
        return of(fallback);
    }
    userNameFromEmplId(event) {
        const params = { employeeId: get(event, 'updtBy') };
        if (params.employeeId) {
            return this.employeeDetailsCacheService.request(params).pipe(map((employeeDetails) => {
                const info = get(employeeDetails, 'employee.basicInfo');
                if (info) {
                    return `${info.deptSic}/${info.lastName}, ${size(info.preferredFirstName) > 0 ? info.preferredFirstName : info.firstName}`;
                }
                else {
                    return event.updtBy;
                }
            }));
        }
        else {
            return of('');
        }
    }
}
ShipmentDetailsEventsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsEventsComponent, deps: [{ token: ShipmentReferenceService }, { token: i3$5.ShipmentOdsApiService }, { token: SicDatePipe }, { token: XpoLtlLocationDetailsCacheService }, { token: XpoLtlEmployeeDetailsCacheService }], target: i0.ɵɵFactoryTarget.Component });
ShipmentDetailsEventsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentDetailsEventsComponent, selector: "xpo-ltl-shipment-details-events", ngImport: i0, template: "<div class=\"xpo-LtlShipmentDetails__history\">\n  <table mat-table [dataSource]=\"dataSource\">\n    <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.id\">\n      <th mat-header-cell *matHeaderCellDef>\n        <span>{{ column.label }}</span>\n      </th>\n      <td mat-cell *matCellDef=\"let row\">\n        <span>{{\n          column.rendererAsync\n            ? (column.rendererAsync(row) | async)\n            : column.renderer\n            ? column.renderer(row)\n            : (row[column.id] | emptyValue: '')\n        }}</span>\n      </td>\n    </ng-container>\n\n    <tr mat-header-row *matHeaderRowDef=\"columnsToDisplay; sticky: true\"></tr>\n    <tr mat-row *matRowDef=\"let row; columns: columnsToDisplay\"></tr>\n  </table>\n</div>\n", styles: ["xpo-ltl-shipment-details-events{display:flex;flex:1 1 auto;margin:0}.xpo-LtlShipmentDetails__history{flex:1 1 auto}.xpo-LtlShipmentDetails__history .mat-table{width:100%}.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell>span{display:block;text-align:left}.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell.mat-column-occurredTmst{width:124px}.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell.mat-column-elapsedTm{width:48px}.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell.mat-column-sic{width:40px}.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell.mat-column-description{width:auto}.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell.mat-column-originDest{width:72px}.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell.mat-column-loadDestination,.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell.mat-column-loadRelease{width:64px}.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell.mat-column-trailer{width:108px}.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell.mat-column-weightCubeBls{width:104px}.xpo-LtlShipmentDetails__history .mat-table .mat-header-cell.mat-column-updatedBy{width:120px}"], components: [{ type: i5$4.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { type: i5$4.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { type: i5$4.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$4.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { type: i5$4.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { type: i5$4.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { type: i5$4.MatCellDef, selector: "[matCellDef]" }, { type: i5$4.MatCell, selector: "mat-cell, td[mat-cell]" }, { type: i5$4.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { type: i5$4.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }], pipes: { "async": i5.AsyncPipe, "emptyValue": EmptyValuePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsEventsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-events',
                    templateUrl: './shipment-details-events.component.html',
                    styleUrls: ['./shipment-details-events.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: ShipmentReferenceService }, { type: i3$5.ShipmentOdsApiService }, { type: SicDatePipe }, { type: XpoLtlLocationDetailsCacheService }, { type: XpoLtlEmployeeDetailsCacheService }]; } });

class ShipmentDetailsChargesComponent {
    constructor(shipmentRefService, conditioningService, accountsReceivableApiService, currencyPipe) {
        this.shipmentRefService = shipmentRefService;
        this.conditioningService = conditioningService;
        this.accountsReceivableApiService = accountsReceivableApiService;
        this.currencyPipe = currencyPipe;
        this.unsubscriber = new Unsubscriber();
        this.columns = [
            { id: 'proNbr', label: 'PRO', renderer: (row) => this.conditioningService.conditionProNumber(row.proNbr, 10) },
            {
                id: 'totalChargeAmt',
                label: 'Charges',
                renderer: (row) => this.currencyPipe.transform(row.totalChargeAmt, row.currencyCd),
            },
            { id: 'totalPaymentAmt', label: 'Payments', renderer: (row) => this.currencyPipe.transform(row.totalPaymentAmt) },
            { id: 'creditedAmt', label: 'Credited', renderer: (row) => this.currencyPipe.transform(row.crenditedAmt) },
            {
                id: 'totalAdjustmentAmt',
                label: 'Adjustments',
                renderer: (row) => this.currencyPipe.transform(row.totalAdjustmentAmt),
            },
            { id: 'balanceDueAmt', label: 'Balance Due', renderer: (row) => this.currencyPipe.transform(row.balanceDueAmt) },
            { id: 'paymentDate', label: 'Date', renderer: (row) => moment$3(row.paymentDate).format('MM/DD/YYYY') },
            { id: 'currencyCd', label: 'Currency' },
            { id: 'chargeCd', label: 'Charge CD' },
            { id: 'receiptNbr', label: 'Receipt #' },
        ];
        this.columnsToDisplay = map$1(this.columns, (c) => c.id);
        this.dataSource = new MatTableDataSource(undefined);
    }
    ngOnInit() {
        this.shipmentRefService.shipment$
            .pipe(takeUntil(this.unsubscriber.done$), distinctUntilChanged())
            .subscribe((shipment) => {
            this.updateFormFromShipment(shipment);
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    updateFormFromShipment(shipment) {
        if (!shipment) {
            return;
        }
        const request = new ListArPaymentDetailsByProQuery();
        request.proNbr = shipment.shipment.proNbr;
        request.pickupDate = `${shipment.shipment.pickupDate.valueOf()}`;
        this.accountsReceivableApiService
            .listArPaymentDetailsByPro(request, ApiRequest.concealedCall)
            .subscribe((result) => {
            this.dataSource.data = result.arPaymentDetails;
        });
    }
}
ShipmentDetailsChargesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsChargesComponent, deps: [{ token: ShipmentReferenceService }, { token: XpoLtlConditioningService }, { token: i2$8.AccountsReceivableApiService }, { token: i5.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Component });
ShipmentDetailsChargesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentDetailsChargesComponent, selector: "xpo-ltl-shipment-details-charges", ngImport: i0, template: "<div class=\"shipment-details-charges\">\n  <table mat-table [dataSource]=\"dataSource\">\n    <ng-container *ngFor=\"let column of columns\" [matColumnDef]=\"column.id\">\n      <th mat-header-cell *matHeaderCellDef>{{ column.label }}</th>\n      <td mat-cell *matCellDef=\"let row\">\n        <span>{{ column.renderer ? column.renderer(row) : (row[column.id] | emptyValue) }}</span>\n      </td>\n    </ng-container>\n\n    <tr mat-header-row *matHeaderRowDef=\"columnsToDisplay; sticky: true\"></tr>\n    <tr mat-row *matRowDef=\"let row; columns: columnsToDisplay\"></tr>\n  </table>\n</div>\n", styles: [":host{display:flex;margin:0}.shipment-details-charges,:host{flex:1 1 auto}.shipment-details-charges .mat-table{width:100%}"], components: [{ type: i5$4.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { type: i5$4.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { type: i5$4.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$4.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { type: i5$4.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { type: i5$4.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { type: i5$4.MatCellDef, selector: "[matCellDef]" }, { type: i5$4.MatCell, selector: "mat-cell, td[mat-cell]" }, { type: i5$4.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { type: i5$4.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }], pipes: { "emptyValue": EmptyValuePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentDetailsChargesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-charges',
                    templateUrl: './shipment-details-charges.component.html',
                    styleUrls: ['./shipment-details-charges.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: ShipmentReferenceService }, { type: XpoLtlConditioningService }, { type: i2$8.AccountsReceivableApiService }, { type: i5.CurrencyPipe }]; } });

const defaultShipmentDetailsConfig = {
    tabs: [
        { id: XpoLtlShipmentDetailsTabs.Details, label: 'Details', title: 'Shipment Details' },
        { id: XpoLtlShipmentDetailsTabs.History, label: 'History', title: 'Shipment History' },
        { id: XpoLtlShipmentDetailsTabs.Charges, label: 'Charges', title: 'Freight Charges' },
    ],
};
class XpoLtlShipmentDetailsComponent {
    constructor(shipmentReferenceService, resolver, renderer) {
        this.shipmentReferenceService = shipmentReferenceService;
        this.resolver = resolver;
        this.renderer = renderer;
        this._config = defaultShipmentDetailsConfig;
        this.tabChange = new EventEmitter();
        this._selectedTab = 0;
        this._hasFreightChargesTab = true;
        this.unsubscriber = new Unsubscriber();
        this.XpoLtlShipmentDetailsTabs = XpoLtlShipmentDetailsTabs;
        console.warn('Deprecation Warning: XpoLtlShipmentDetailsComponent has been deprecated. Please use @xpo-ltl/ngx-ltl-shipment-details library');
    }
    set shipment(value) {
        this.shipmentReferenceService.shipment = value;
    }
    get shipment$() {
        return this.shipmentReferenceService.shipment$;
    }
    get config() {
        return this._config;
    }
    set config(value) {
        this._config = Object.assign(Object.assign({}, defaultShipmentDetailsConfig), value);
        // go through the tabs and, if any label/title is missing, add it
        this._config.tabs.forEach((tab) => {
            if (!tab.label) {
                tab.label = get(defaultShipmentDetailsConfig.tabs.find((t) => t.id === tab.id), 'label', tab.id);
            }
            if (!tab.title) {
                tab.title = get(defaultShipmentDetailsConfig.tabs.find((t) => t.id === tab.id), 'title', tab.id);
            }
        });
        this._hasFreightChargesTab = !!this._config.tabs.find((t) => t.id === XpoLtlShipmentDetailsTabs.Charges);
    }
    get selectedTab() {
        return this._selectedTab;
    }
    set selectedTab(value) {
        this._selectedTab = value;
        this.tabChange.emit(nth(this.config.tabs, this.selectedTab));
    }
    get hasFreightChargesTab() {
        return this._hasFreightChargesTab;
    }
    get hideCharges() {
        return this.config.hideCharges;
    }
    ngOnInit() {
        this.selectedTab = this.config.tabs.findIndex((tab) => tab.id === this.config.selectedTab) || 0;
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    ngAfterViewInit() {
        // TODO - this feels like a hack.  Should be a better way to refactor so we don't need this dance
        this.shipment$
            .pipe(delay(1), // delay here to allow UI time to render the tabGroup
        takeUntil(this.unsubscriber.done$))
            .subscribe((shipment) => {
            if (shipment) {
                this.injectComponents();
                this.unsubscriber.complete();
            }
        });
    }
    injectComponents() {
        if (this.config.headerComponent && this.headerContainerRef) {
            this.headerContainerRef.clear();
            const factory = this.resolver.resolveComponentFactory(this.config.headerComponent);
            this.headerContainerRef.createComponent(factory);
        }
        if (this.config.tabInfoComponent && this.tabInfoContainerRef) {
            const factory = this.resolver.resolveComponentFactory(this.config.tabInfoComponent);
            const compRef = this.tabInfoContainerRef.createComponent(factory);
            const matHeaderElem = this.tabInfoContainerRef.element.nativeElement.querySelector('.mat-tab-header');
            const compEl = compRef.location.nativeElement;
            this.renderer.appendChild(matHeaderElem, compEl);
        }
    }
    openTab(tabId) {
        const tabIndex = this.config.tabs.findIndex((tab) => tab.id === tabId);
        if (tabIndex >= 0) {
            this.selectedTab = tabIndex;
        }
    }
}
XpoLtlShipmentDetailsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsComponent, deps: [{ token: ShipmentReferenceService }, { token: i0.ComponentFactoryResolver }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlShipmentDetailsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlShipmentDetailsComponent, selector: "xpo-ltl-shipment-details", inputs: { shipment: "shipment", config: "config" }, outputs: { tabChange: "tabChange" }, providers: [ShipmentReferenceService], viewQueries: [{ propertyName: "headerContainerRef", first: true, predicate: ["headerContainer"], descendants: true, read: ViewContainerRef }, { propertyName: "tabInfoContainerRef", first: true, predicate: ["tabGroup"], descendants: true, read: ViewContainerRef }], ngImport: i0, template: "<div class=\"xpo-LtlShipmentDetails\">\n  <ng-container *ngIf=\"config.headerComponent\" #headerContainer></ng-container>\n  <div class=\"xpo-LtlShipmentDetails__content-tab\" *ngIf=\"shipment$ | async\">\n    <mat-tab-group #tabGroup dynamicHeight=\"true\" [(selectedIndex)]=\"selectedTab\">\n      <mat-tab *ngFor=\"let tab of config.tabs\" [label]=\"tab.label\" [ngSwitch]=\"tab.id\">\n        <xpo-ltl-shipment-details-details\n          *ngSwitchCase=\"XpoLtlShipmentDetailsTabs.Details\"\n          (openTab)=\"openTab($event)\"\n          [hasFreightChargesTab]=\"hasFreightChargesTab\"\n          [hidePaymentSummary]=\"hideCharges\"\n          [hideCharges]=\"hideCharges\"\n        ></xpo-ltl-shipment-details-details>\n        <xpo-ltl-shipment-details-events\n          *ngSwitchCase=\"XpoLtlShipmentDetailsTabs.History\"\n        ></xpo-ltl-shipment-details-events>\n        <xpo-ltl-shipment-details-charges\n          *ngSwitchCase=\"XpoLtlShipmentDetailsTabs.Charges\"\n        ></xpo-ltl-shipment-details-charges>\n      </mat-tab>\n    </mat-tab-group>\n  </div>\n  <div class=\"xpo-LtlShipmentDetails__no-shipment\" *ngIf=\"!(shipment$ | async)\">\n    No Shipment Data\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}xpo-ltl-shipment-details{display:flex;flex:1 1 auto;overflow:hidden;height:100%}.xpo-LtlShipmentDetails{display:flex;flex:1 1 auto;width:100%;flex-direction:column}.xpo-LtlShipmentDetails .mat-tab-group-dynamic-height .mat-tab-body-wrapper{display:block;overflow:scroll;flex:1 1 auto}.xpo-LtlShipmentDetails .mat-tab-labels .mat-tab-label{color:#6f6f6f;width:100px}.xpo-LtlShipmentDetails .mat-tab-labels .mat-tab-label.mat-tab-label-active{color:#4a4a4a}.xpo-LtlShipmentDetails__content-tab{display:flex;flex:1 1 auto;flex-direction:column;width:100%;overflow:hidden}.xpo-LtlShipmentDetails__content-tab .mat-tab-header{border-bottom:1px solid #e6e6e6}.xpo-LtlShipmentDetails__content-tab .mat-tab-group{height:100%}.xpo-LtlShipmentDetails__no-shipment{padding:1rem;font-style:italic}"], components: [{ type: i2$9.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { type: i2$9.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby"], exportAs: ["matTab"] }, { type: ShipmentDetailsDetailsComponent, selector: "xpo-ltl-shipment-details-details", inputs: ["hasFreightChargesTab", "hidePaymentSummary", "hideCharges"], outputs: ["openTab"] }, { type: ShipmentDetailsEventsComponent, selector: "xpo-ltl-shipment-details-events" }, { type: ShipmentDetailsChargesComponent, selector: "xpo-ltl-shipment-details-charges" }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details',
                    templateUrl: './shipment-details.component.html',
                    styleUrls: ['./shipment-details.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [ShipmentReferenceService],
                }]
        }], ctorParameters: function () { return [{ type: ShipmentReferenceService }, { type: i0.ComponentFactoryResolver }, { type: i0.Renderer2 }]; }, propDecorators: { shipment: [{
                type: Input
            }], headerContainerRef: [{
                type: ViewChild,
                args: ['headerContainer', { read: ViewContainerRef }]
            }], tabInfoContainerRef: [{
                type: ViewChild,
                args: ['tabGroup', { read: ViewContainerRef }]
            }], config: [{
                type: Input
            }], tabChange: [{
                type: Output
            }] } });

class XpoLtlShipmentDetailsDialogComponent {
    constructor(shipmentOdsApiService, data, proFormatterPipe) {
        this.shipmentOdsApiService = shipmentOdsApiService;
        this.data = data;
        this.proFormatterPipe = proFormatterPipe;
        this.unsubscriber = new Unsubscriber();
        this.opened = false;
        this.selectedShipmentSubject = new BehaviorSubject(undefined);
        this.selectedShipment$ = this.selectedShipmentSubject.asObservable();
        this.dialogTitleSubject = new BehaviorSubject('Shipment');
        this.dialogTitle$ = this.dialogTitleSubject.asObservable();
        this.selectedTabLabelSubject = new BehaviorSubject(undefined);
        this.selectedTabLabel$ = this.selectedTabLabelSubject.asObservable();
        this.dialogData = data;
        this.shipmentDescs = uniqBy(this.dialogData.shipmentDescriptors, 'proNbr');
        this.opened = get(this.dialogData, 'config.showShipmentSelector', false);
        combineLatest([this.selectedTabLabel$, this.selectedShipment$])
            .pipe(takeUntil(this.unsubscriber.done$))
            .subscribe((values) => {
            let title = `${defaultTo(values[0], '')}`;
            const proNbr = get(values[1], 'shipment.proNbr');
            if (proNbr) {
                title = `${title} - PRO ${this.proFormatterPipe.transform(proNbr, 10)}`;
            }
            this.dialogTitleSubject.next(title);
        });
    }
    get shipmentDescriptors() {
        return this.shipmentDescs;
    }
    get moveable() {
        return !!get(this.dialogData, 'config.moveable');
    }
    get searchable() {
        return !!get(this.dialogData, 'config.searchable');
    }
    get showShipmentListPanel() {
        return size(this.shipmentDescriptors) > 1 || this.searchable;
    }
    get selectedShipment() {
        return this.selectedShipmentSubject.value;
    }
    set selectedTabLabel(value) {
        this.selectedTabLabelSubject.next(value.title);
    }
    ngAfterViewInit() {
        if (size(this.shipmentDescriptors) === 1) {
            this.selectShipment(first(this.shipmentDescriptors));
        }
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    onKeydownHandler(event) {
        this.closeClicked();
    }
    closeClicked() {
        if (!!this.dialogRef) {
            this.dialogRef.close();
        }
    }
    shipmentMatchDescriptor(shipment, desc) {
        if (!shipment && !desc) {
            return true;
        }
        if (desc.shipmentInstId && desc.shipmentInstId === get(shipment, 'shipment.shipmentInstId')) {
            return true;
        }
        if (desc.proNbr &&
            desc.pickupDate &&
            desc.proNbr === get(shipment, 'shipment.proNbr') &&
            new Date(desc.pickupDate) === get(shipment, 'shipment.pickupDate')) {
            return true;
        }
        // does not match
        return false;
    }
    selectShipment(shipmentDesc) {
        if (shipmentDesc) {
            // Load and display the newly selected shipment
            if (!this.shipmentMatchDescriptor(this.selectedShipment, shipmentDesc)) {
                this.loadShipment(shipmentDesc).subscribe((shipment) => {
                    this.selectedShipmentSubject.next(shipment);
                });
            }
        }
        else {
            this.selectedShipmentSubject.next(undefined);
        }
    }
    loadShipment(shipmentDesc) {
        // Load and display the newly selected shipment
        const queryParams = new GetOdsShipmentQuery();
        queryParams.shipmentInstId = shipmentDesc.shipmentInstId ? shipmentDesc.shipmentInstId : undefined;
        queryParams.proNbr = !shipmentDesc.shipmentInstId ? shipmentDesc.proNbr : undefined;
        queryParams.pickupDate = !shipmentDesc.shipmentInstId ? shipmentDesc.pickupDate : undefined;
        queryParams.shipmentDetailCd = shipmentDesc.shipmentDetailCd ? [shipmentDesc.shipmentDetailCd] : undefined;
        return this.shipmentOdsApiService.getOdsShipment(queryParams).pipe(switchMap((resp) => of(resp)));
    }
}
XpoLtlShipmentDetailsDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsDialogComponent, deps: [{ token: i3$5.ShipmentOdsApiService }, { token: MAT_DIALOG_DATA }, { token: ProFormatterPipe }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlShipmentDetailsDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlShipmentDetailsDialogComponent, selector: "xpo-ltl-shipment-details-dialog", host: { listeners: { "document:keydown.escape": "onKeydownHandler($event)" } }, ngImport: i0, template: "<div class=\"xpo-LtlShipmendDetailsDialog\" #dialogContents>\n  <div class=\"xpo-LtlShipmendDetailsDialog__header\">\n    <xpo-ltl-dialog-title\n      [options]=\"{\n        moveable: moveable\n      }\"\n    >\n      <ng-container [ngTemplateOutlet]=\"headerContent\"></ng-container>\n    </xpo-ltl-dialog-title>\n  </div>\n  <mat-dialog-content class=\"xpo-LtlShipmendDetailsDialog__content\">\n    <ng-container *ngIf=\"showShipmentListPanel; then multipleShipments; else singleShipment\"></ng-container>\n  </mat-dialog-content>\n</div>\n\n<ng-template #headerContent>\n  <span class=\"xpo-LtlShipmendDetailsDialog__header\">\n    <button\n      mat-icon-button\n      *ngIf=\"showShipmentListPanel\"\n      (click)=\"opened = !opened\"\n      matTooltip=\"Toggle Shipment Selection\"\n    >\n      <mat-icon>menu</mat-icon>\n    </button>\n    {{ dialogTitle$ | async }}\n  </span>\n</ng-template>\n\n<ng-template #multipleShipments>\n  <mat-sidenav-container>\n    <mat-sidenav #sidenav mode=\"side\" [(opened)]=\"opened\">\n      <xpo-ltl-shipment-selector\n        [shipments]=\"shipmentDescriptors\"\n        [searchable]=\"searchable\"\n        (selectionChange)=\"selectShipment($event)\"\n      >\n      </xpo-ltl-shipment-selector>\n    </mat-sidenav>\n    <mat-sidenav-content>\n      <xpo-ltl-shipment-details\n        [shipment]=\"selectedShipment$ | async\"\n        [config]=\"data?.config\"\n        (tabChange)=\"selectedTabLabel = $event\"\n      ></xpo-ltl-shipment-details>\n    </mat-sidenav-content>\n  </mat-sidenav-container>\n</ng-template>\n\n<ng-template #singleShipment>\n  <xpo-ltl-shipment-details\n    [shipment]=\"selectedShipment$ | async\"\n    [config]=\"data?.config\"\n    (tabChange)=\"selectedTabLabel = $event\"\n  ></xpo-ltl-shipment-details>\n</ng-template>\n", styles: [".flex--stretch{flex:1}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog{display:flex;flex:1 1 auto;flex-direction:column;height:100%;width:100%}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog .mat-dialog-container{display:flex;flex:1 1 auto;overflow:hidden;padding:16px 0}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog .mat-dialog-content{display:flex;flex:1 1 auto;flex-direction:row;margin:0;padding:0;max-height:inherit;overflow:auto}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog .mat-dialog-content .mat-sidenav-container{width:100%}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog .mat-dialog-content .mat-sidenav-container .mat-sidenav-content{overflow:hidden}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog__header h1{display:flex;height:6rem;flex:0 0 auto;flex-direction:row;align-items:center;margin:-18px 0 0}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog__header h1 .mat-dialog-title{flex:1 1 auto;margin:0}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog__header h1 .mat-dialog-title .mat-icon-button{color:#9b9b9b}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog__header h1-close{justify-self:flex-end;color:rgba(0,0,0,.54);flex:0 0 auto;align-items:center}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog__content{width:100%}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog__content-tab{display:flex;position:relative;flex:1 1 auto;flex-direction:column}.xpo-LtlShipmentDetailsDialog__panel .xpo-LtlShipmendDetailsDialog__header{display:flex;align-items:center}"], components: [{ type: XpoLtlDialogTitleComponent, selector: "xpo-ltl-dialog-title", inputs: ["options"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i6$5.MatSidenavContainer, selector: "mat-sidenav-container", exportAs: ["matSidenavContainer"] }, { type: i6$5.MatSidenav, selector: "mat-sidenav", inputs: ["fixedInViewport", "fixedTopGap", "fixedBottomGap"], exportAs: ["matSidenav"] }, { type: XpoLtlShipmentSelectorComponent, selector: "xpo-ltl-shipment-selector", inputs: ["shipments", "searchable"], outputs: ["selectionChange"] }, { type: i6$5.MatSidenavContent, selector: "mat-sidenav-content" }, { type: XpoLtlShipmentDetailsComponent, selector: "xpo-ltl-shipment-details", inputs: ["shipment", "config"], outputs: ["tabChange"] }], directives: [{ type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-details-dialog',
                    templateUrl: './shipment-details-dialog.component.html',
                    styleUrls: ['./shipment-details-dialog.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i3$5.ShipmentOdsApiService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: ProFormatterPipe }]; }, propDecorators: { onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown.escape', ['$event']]
            }] } });

const components$1 = [
    DataDisplayGroupComponent,
    ShipmentDetailsChargesComponent,
    ShipmentDetailsDetailsComponent,
    ShipmentDetailsEventsComponent,
    ShipmentDetailsGeneralInfoComponent,
    ShipmentDetailsLineItemsComponent,
    ShipmentDetailsOverviewComponent,
    ShipmentDetailsPaymentSummaryComponent,
    ShipmentDetailsRemarksComponent,
    ShipmentDetailsSrnsComponent,
    ShipmentDimensionsComponent,
];
const materialModules$1 = [
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatExpansionModule,
    MatInputModule,
    MatListModule,
    MatSelectModule,
    MatTableModule,
    MatTabsModule,
    MatCardModule,
    MatSidenavModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatRadioModule,
];
const exportComponents = [
    XpoLtlShipmentDetailsComponent,
    XpoLtlShipmentDetailsDialogComponent,
    XpoLtlShipmentSelectorComponent,
];
class XpoLtlShipmentDetailsModule {
}
XpoLtlShipmentDetailsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlShipmentDetailsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsModule, declarations: [DataDisplayGroupComponent,
        ShipmentDetailsChargesComponent,
        ShipmentDetailsDetailsComponent,
        ShipmentDetailsEventsComponent,
        ShipmentDetailsGeneralInfoComponent,
        ShipmentDetailsLineItemsComponent,
        ShipmentDetailsOverviewComponent,
        ShipmentDetailsPaymentSummaryComponent,
        ShipmentDetailsRemarksComponent,
        ShipmentDetailsSrnsComponent,
        ShipmentDimensionsComponent, XpoLtlShipmentDetailsComponent,
        XpoLtlShipmentDetailsDialogComponent,
        XpoLtlShipmentSelectorComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule, MatAutocompleteModule,
        MatButtonModule,
        MatDialogModule,
        MatExpansionModule,
        MatInputModule,
        MatListModule,
        MatSelectModule,
        MatTableModule,
        MatTabsModule,
        MatCardModule,
        MatSidenavModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatRadioModule, ConfigManagerModule,
        XpoCardModule,
        XpoDialogModule,
        XpoIconModule,
        XpoLtlPipeModule,
        XpoPopoverModule,
        XpoLtlDialogTitleModule], exports: [XpoLtlShipmentDetailsComponent,
        XpoLtlShipmentDetailsDialogComponent,
        XpoLtlShipmentSelectorComponent] });
XpoLtlShipmentDetailsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsModule, providers: [
        {
            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
            useValue: { configFileUrl: './assets/config.json' },
        },
        CurrencyPipe,
    ], imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            DragDropModule,
            ...materialModules$1,
            ConfigManagerModule,
            XpoCardModule,
            XpoDialogModule,
            XpoIconModule,
            XpoLtlPipeModule,
            XpoPopoverModule,
            XpoLtlDialogTitleModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...components$1, ...exportComponents],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        DragDropModule,
                        ...materialModules$1,
                        ConfigManagerModule,
                        XpoCardModule,
                        XpoDialogModule,
                        XpoIconModule,
                        XpoLtlPipeModule,
                        XpoPopoverModule,
                        XpoLtlDialogTitleModule,
                    ],
                    exports: [...exportComponents],
                    entryComponents: [XpoLtlShipmentDetailsDialogComponent],
                    providers: [
                        {
                            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
                            useValue: { configFileUrl: './assets/config.json' },
                        },
                        CurrencyPipe,
                    ],
                }]
        }] });

class XpoLtlShipmentDetailsService {
    constructor(dialog) {
        this.dialog = dialog;
        this.shipmentBehaviorSubject = new BehaviorSubject(undefined);
        this.shipment$ = this.shipmentBehaviorSubject.asObservable();
    }
    /**
     * Open a dialog to display the Shipment Details
     * @param shipment The GetOdsShipmentResp details to display in the dialog
     */
    showShipmentDetailsDialog(shipmentDesc, config, dialogConfig) {
        const subject = new Subject();
        const matDialogConfig = Object.assign(Object.assign({ width: '1232px', height: '98%', panelClass: 'xpo-LtlShipmentDetailsDialog__panel', disableClose: true, hasBackdrop: !get(config, 'moveable') }, (dialogConfig || {})), { data: {
                shipmentDescriptors: castArray(shipmentDesc),
                config,
            } });
        const dialogRef = this.dialog.open(XpoLtlShipmentDetailsDialogComponent, matDialogConfig);
        dialogRef.afterClosed().subscribe(() => {
            subject.next();
            subject.complete();
        });
        if (!get(matDialogConfig, 'disableClose')) {
            dialogRef
                .keydownEvents()
                .pipe(take(1))
                .subscribe((e) => {
                if (e.code === 'Escape') {
                    e.preventDefault();
                    e.stopPropagation();
                    dialogRef.close();
                }
            });
        }
        return subject.asObservable();
    }
}
XpoLtlShipmentDetailsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsService, deps: [{ token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlShipmentDetailsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentDetailsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }]; } });

class XpoLtlSicSwitcherLabelOptions {
    constructor(props) {
        this.title = get(props, 'title', XpoLtlSicSwitcherLabelOptions.defaultTitle);
        this.floatLabel = get(props, 'floatLabel', XpoLtlSicSwitcherLabelOptions.defaultFloatLabel);
    }
}
XpoLtlSicSwitcherLabelOptions.defaultTitle = 'Select SIC';
XpoLtlSicSwitcherLabelOptions.defaultFloatLabel = 'never';

class XpoLtlSicSwitcherComponent {
    constructor(serviceCentersService) {
        this.serviceCentersService = serviceCentersService;
        this.panelWidth = 'auto';
        this.sicLabel = new XpoLtlSicSwitcherLabelOptions();
        this.sicChange = new EventEmitter();
        this.previousFilterTerm = undefined;
        this.filteredSicListSubject = new BehaviorSubject([]);
        this.filteredSicList$ = this.filteredSicListSubject.asObservable();
    }
    get sicCd() {
        return get(this.selectedSic, 'sicCd', '');
    }
    set sicCd(value) {
        this.selectSicWithCd(value);
    }
    ngOnInit() {
        this.updateFilteredSics('');
    }
    ngAfterViewInit() {
        // ensure that the input is set to the initial value, in case it was set before the input was created
        setTimeout(() => {
            this.sicInput.value = this.getSicDesc(this.selectedSic);
        });
    }
    // #region PUBLIC API
    /**
     * Set the focus to the input control
     */
    focus() {
        this.sicInput.focus();
    }
    // #endregion PUBLIC AIP
    // #region PRIVATE API
    handleFilterFocus() {
        this.previousSic = this.selectedSic;
    }
    handleFilterBlur() {
        if (!this.sicAutocomplete.isOpen) {
            this.selectSicFromFilter();
        }
    }
    handlePanelClosed() {
        if (this.sicInput.value !== get(this.selectedSic, 'sicCd')) {
            this.selectSic(this.selectedSic);
        }
    }
    /**
     * Update the list of ServiceCenters to contain the list that matches the serch term.
     * @param filterTerm term to filter ServiceCenters by
     */
    updateFilteredSics(filterTerm) {
        if (filterTerm !== this.previousFilterTerm) {
            this.previousFilterTerm = filterTerm;
            this.serviceCentersService.serviceCenters$
                .pipe(take(1), map((sics) => this.serviceCentersService.filterSicsBy(sics, filterTerm)), tap((serviceCenters) => {
                this.filteredSicListSubject.next(serviceCenters);
            }))
                .subscribe();
        }
    }
    displayFn(sic) {
        var _a;
        return (_a = sic === null || sic === void 0 ? void 0 : sic.sicCd) !== null && _a !== void 0 ? _a : undefined;
    }
    /**
     * Select the passed ServiceCenter and update UI to reflect it
     * @param newSic ServiceCenter to select
     */
    selectSic(newSic) {
        if (this.selectedSic !== newSic) {
            // only broadcast event if the new sic is different from previous sic
            this.sicChange.emit(newSic);
            this.selectedSic = newSic;
            this.previousSic = newSic;
        }
        // reset the filterTerm to be the selected SicCd
        const sicDesc = this.getSicDesc(this.selectedSic);
        if (this.sicInput) {
            this.sicInput.value = sicDesc;
        }
        this.updateFilteredSics(sicDesc);
    }
    getSicDesc(sic) {
        return sic ? `${sic.sicCd} - ${sic.reference.sicName}` : '';
    }
    /**
     * Select a ServiceCenter that has the passed sicCd
     *
     * @param sicCd sicCd for the ServiceCenter to select
     */
    selectSicWithCd(sicCd) {
        this.serviceCentersService
            .getSicByCd$(sicCd)
            .pipe(take(1))
            .subscribe((sic) => {
            this.selectSic(sic);
        });
    }
    /**
     * If only one sic in the fitler list, select it. Else, clear the selection
     */
    selectSicFromFilter() {
        this.filteredSicList$.pipe(take(1)).subscribe((filteredSics) => {
            if (size(filteredSics) === 1) {
                // auto-select the only option
                this.selectSic(first(filteredSics));
            }
            else {
                // there are more then one option, so can't auto-select from filter list
                this.selectSic(this.previousSic);
            }
        });
    }
}
XpoLtlSicSwitcherComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicSwitcherComponent, deps: [{ token: XpoLtlServiceCentersService }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlSicSwitcherComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlSicSwitcherComponent, selector: "xpo-ltl-sic-switcher", inputs: { sicCd: "sicCd", panelWidth: "panelWidth", sicLabel: "sicLabel" }, outputs: { sicChange: "sicChange" }, viewQueries: [{ propertyName: "sicInput", first: true, predicate: MatInput, descendants: true }, { propertyName: "sicAutocomplete", first: true, predicate: MatAutocomplete, descendants: true }, { propertyName: "sicAutocompleteTrigger", first: true, predicate: MatAutocompleteTrigger, descendants: true }], ngImport: i0, template: "<div class=\"xpo-LtlSicSwitcher\">\n  <mat-form-field [floatLabel]=\"sicLabel.floatLabel\" class=\"xpo-LtlSicSwitcher--form-field\">\n    <mat-label>{{ sicLabel.title }}</mat-label>\n    <input\n      #sicInput\n      matInput\n      matAutocompleteTrigger\n      type=\"text\"\n      class=\"xpo-LtlSicSwitcher--input\"\n      [matAutocomplete]=\"auto\"\n      (input)=\"updateFilteredSics(sicInput.value)\"\n      (focus)=\"handleFilterFocus()\"\n      (blur)=\"handleFilterBlur()\"\n    />\n    <mat-autocomplete\n      #sicAutocomplete\n      #auto=\"matAutocomplete\"\n      autoActiveFirstOption=\"true\"\n      class=\"xpo-LtlSicSwitcher--autocomplete\"\n      [displayWith]=\"displayFn\"\n      (optionSelected)=\"selectSic($event.option.value)\"\n      (closed)=\"handlePanelClosed()\"\n      [panelWidth]=\"panelWidth\"\n    >\n      <mat-option *ngFor=\"let sic of filteredSicList$ | async\" [value]=\"sic\">\n        {{ sic.sicCd }} - {{ sic.reference?.sicName }}, {{ sic.locAddress?.countrySubdivisionCd }}\n      </mat-option>\n    </mat-autocomplete>\n  </mat-form-field>\n</div>\n", styles: [".flex--stretch{flex:1}.xpo-LtlSicSwitcher{display:flex;flex:1 1 auto;width:100%}.xpo-LtlSicSwitcher--form-field.mat-form-field{width:100%}.xpo-LtlSicSwitcher--input.mat-input-element{text-transform:uppercase}"], components: [{ type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i13.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }], directives: [{ type: i7.MatLabel, selector: "mat-label" }, { type: i21.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i13.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i5.AsyncPipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicSwitcherComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-sic-switcher',
                    templateUrl: './sic-switcher.component.html',
                    styleUrls: ['./sic-switcher.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlServiceCentersService }]; }, propDecorators: { sicInput: [{
                type: ViewChild,
                args: [MatInput]
            }], sicAutocomplete: [{
                type: ViewChild,
                args: [MatAutocomplete]
            }], sicAutocompleteTrigger: [{
                type: ViewChild,
                args: [MatAutocompleteTrigger]
            }], sicCd: [{
                type: Input
            }], panelWidth: [{
                type: Input
            }], sicLabel: [{
                type: Input
            }], sicChange: [{
                type: Output
            }] } });

class XpoLtlSicSwitcherModule {
}
XpoLtlSicSwitcherModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicSwitcherModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlSicSwitcherModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicSwitcherModule, declarations: [XpoLtlSicSwitcherComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatListModule,
        MatAutocompleteModule,
        ConfigManagerModule,
        XpoPopoverModule,
        XpoIconModule,
        XpoCardModule], exports: [XpoLtlSicSwitcherComponent] });
XpoLtlSicSwitcherModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicSwitcherModule, providers: [
        {
            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
            useValue: { configFileUrl: './assets/config.json' },
        },
    ], imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatInputModule,
            MatListModule,
            MatAutocompleteModule,
            ConfigManagerModule,
            XpoPopoverModule,
            XpoIconModule,
            XpoCardModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicSwitcherModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [XpoLtlSicSwitcherComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatInputModule,
                        MatListModule,
                        MatAutocompleteModule,
                        ConfigManagerModule,
                        XpoPopoverModule,
                        XpoIconModule,
                        XpoCardModule,
                    ],
                    exports: [XpoLtlSicSwitcherComponent],
                    providers: [
                        {
                            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
                            useValue: { configFileUrl: './assets/config.json' },
                        },
                    ],
                }]
        }] });

/**
 * Collection of utility functions for RxJS
 */
class RxJSUtils {
    /**
     * Retry observable, accepts an array of error codes to short circuit retry logic
     * @param giveUpAfter how long to retry (in ms) before throwing an Errr
     * @param retryInterval how long to wait (in ms) before retrying
     * @param intervalSeed random ms value between [0, intervalSeed] added to interval to help distribute retries
     * @param bypassErrorCodes automatically throw error if any of these error codes are returned (defaults to [404])
     */
    static retry(giveUpAfter, retryInterval, intervalSeed, bypassErrorCodes = [404]) {
        const shouldBypassErrorRetry = (err) => some(bypassErrorCodes, (code) => (err === null || err === void 0 ? void 0 : err.code) && toString(code) === toString(err === null || err === void 0 ? void 0 : err.code));
        return retryWhen((errors) => {
            return errors.pipe(concatMap((error, i) => {
                // Give up condition
                if (shouldBypassErrorRetry(error) || i >= giveUpAfter - 1) {
                    return throwError(Object.assign({}, error));
                }
                // Delay before retrying
                return of(error).pipe(delay(retryInterval + Math.random() * intervalSeed));
            }));
        });
    }
}

/**
 * Service to manage set of FeatureSettings and allow quering if a feature is enabled for
 * particular SICs or Users
 */
class XpoLtlFeaturesService {
    constructor(locationService) {
        this.locationService = locationService;
        /**
         * List of all loaded feature settings
         */
        this.features = [];
    }
    /**
     * Fetch all feature definitions
     */
    loadFeatures$(featureTypes) {
        const getLocationFeatureValues = (featureCd) => {
            const pathParams = { featureCd };
            const queryParams = Object.assign({}, new ListLocationFeatureValuesByFeatureQuery());
            return this.locationService.listLocationFeatureValuesByFeature(pathParams, queryParams).pipe(RxJSUtils.retry(10, 250, 50), catchError(() => of(undefined)), map((response) => {
                var _a;
                return (_a = response === null || response === void 0 ? void 0 : response.locationFeatures) !== null && _a !== void 0 ? _a : [];
            }));
        };
        // for each FeatureType, fetch list of definitions
        const calls$ = Object.values(featureTypes).map((featureCd) => {
            return getLocationFeatureValues(featureCd);
        });
        // wait for all feature calls to complete, then merge results into a single list
        return forkJoin(calls$).pipe(exhaustMap((allFeatures) => {
            this.features = flatten(allFeatures);
            return of(undefined);
        }));
    }
    /**
     * Returns the string value for the requested feature based on the passed SicCd
     * @param sicCdOrEmployeeId Sic to get feature for
     * @param featureType the feature value to get
     * @param defaultValue value to return if feature not defined for sic
     */
    getFeatureValue(sicCdOrEmployeeId, featureType, defaultValue) {
        // first, see if the feature is globally available (no sicCd, deviceId, or employeeId limit)
        let feature = find(this.features, (f) => toUpper(f.featureCd) === toUpper(featureType) &&
            isEmpty(f.sicCd) &&
            isEmpty(f.employeeId) &&
            isEmpty(f.deviceId));
        if (feature) {
            return feature.settingValue;
        }
        // get the feature definition for the employeeId or sicCd
        feature = find(this.features, (f) => toUpper(f.featureCd) === toUpper(featureType) &&
            (isEmpty(f.employeeId)
                ? toUpper(f.sicCd) === toUpper(sicCdOrEmployeeId) // test matching SicCd
                : toUpper(f.employeeId) === toUpper(sicCdOrEmployeeId)) // test matching EmployeeId
        );
        return feature ? feature.settingValue : defaultValue;
    }
    /**
     * Returns true if feature exists and has "truthy" value (ie, 'Y'). else returns false
     * @param sicCd Sic to get feature for
     * @param featureType the feature value to get
     */
    getFeatureFlag(sicCd, featureType) {
        const result = this.getFeatureValue(sicCd, featureType, 'N');
        return result.toUpperCase() === 'Y';
    }
}
XpoLtlFeaturesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlFeaturesService, deps: [{ token: i1$3.LocationApiService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlFeaturesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlFeaturesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlFeaturesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.LocationApiService }]; } });

class XpoLtlCustomPdfViewerComponent {
    constructor(data, dialogRef) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.LoadingMessage = 'Please wait, loading document...';
        this.displayMessageSubject = new BehaviorSubject(this.LoadingMessage);
        this.displayMessage$ = this.displayMessageSubject.asObservable();
        this.pdfContentSubject = new BehaviorSubject([]);
        this.pdfContent$ = this.pdfContentSubject.asObservable();
    }
    ngAfterViewInit() {
        this.data.retrieveContent$.pipe(take(1)).subscribe((content) => {
            this.pdfContentSubject.next(content);
        }, (error) => {
            this.displayMessageSubject.next(`Failed to load document; ${error.message}.`);
        });
    }
    closeDialog() {
        this.dialogRef.close();
    }
}
XpoLtlCustomPdfViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlCustomPdfViewerComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$1.MatDialogRef }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlCustomPdfViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlCustomPdfViewerComponent, selector: "xpo-ltl-custom-pdf-viewer", host: { classAttribute: "custom-PdfViewer" }, ngImport: i0, template: "<div class=\"xpo-custom-PdfViewer\">\n  <div mat-dialog-title class=\"xpo-custom-PdfViewer__title\">\n    <h2></h2>\n    <button mat-icon-button (click)=\"closeDialog()\">\n      <mat-icon>close</mat-icon>\n    </button>\n  </div>\n  <div mat-dialog-content class=\"xpo-custom-PdfViewer__content\">\n    <ng-container *ngIf=\"pdfContent$ | async as pdfContent; else noPdfContent\">\n      <ng-container *ngFor=\"let content of pdfContent\">\n        <pdf-viewer\n          data-test=\"custom-PdfViewer__document\"\n          [src]=\"content\"\n          [render-text]=\"true\"\n          [fit-to-page]=\"true\"\n          [original-size]=\"true\"\n          [show-all]=\"true\"\n        ></pdf-viewer>\n      </ng-container>\n    </ng-container>\n    <ng-template #noPdfContent>\n      <div class=\"xpo-custom-PdfViewer__content__message\" data-test=\"custom-PdfViewer__message\">\n        {{ displayMessage$ | async }}\n      </div>\n    </ng-template>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}.xpo-custom-PdfViewer__title{display:flex;align-items:baseline}.xpo-custom-PdfViewer__content{min-height:400px;min-width:800px}.xpo-custom-PdfViewer__content pdf-viewer{display:block}.xpo-custom-PdfViewer__content__message{display:flex;font-size:1.143rem;justify-content:center;margin-top:16px}"], components: [{ type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i4$2.PdfViewerComponent, selector: "pdf-viewer", inputs: ["c-maps-url", "page", "render-text", "render-text-mode", "original-size", "show-all", "stick-to-page", "zoom", "zoom-scale", "rotation", "external-link-target", "autoresize", "fit-to-page", "show-borders", "src"], outputs: ["after-load-complete", "page-rendered", "pages-initialized", "text-layer-rendered", "error", "on-progress", "pageChange"] }], directives: [{ type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlCustomPdfViewerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-custom-pdf-viewer',
                    templateUrl: './custom-pdf-viewer.component.html',
                    styleUrls: ['./custom-pdf-viewer.component.scss'],
                    host: { class: 'custom-PdfViewer' },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$1.MatDialogRef }]; } });

class XpoLtlCustomPdfViewerModule {
}
XpoLtlCustomPdfViewerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlCustomPdfViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlCustomPdfViewerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlCustomPdfViewerModule, declarations: [XpoLtlCustomPdfViewerComponent], imports: [CommonModule,
        XpoIconModule,
        MatIconModule,
        XpoButtonModule,
        MatButtonModule,
        XpoDialogModule,
        MatDialogModule,
        PdfViewerModule], exports: [XpoLtlCustomPdfViewerComponent] });
XpoLtlCustomPdfViewerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlCustomPdfViewerModule, imports: [[
            CommonModule,
            XpoIconModule,
            MatIconModule,
            XpoButtonModule,
            MatButtonModule,
            XpoDialogModule,
            MatDialogModule,
            PdfViewerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlCustomPdfViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        XpoIconModule,
                        MatIconModule,
                        XpoButtonModule,
                        MatButtonModule,
                        XpoDialogModule,
                        MatDialogModule,
                        PdfViewerModule,
                    ],
                    declarations: [XpoLtlCustomPdfViewerComponent],
                    exports: [XpoLtlCustomPdfViewerComponent],
                    entryComponents: [XpoLtlCustomPdfViewerComponent]
                }]
        }] });

var ExistingOrNewRoute;
(function (ExistingOrNewRoute) {
    ExistingOrNewRoute["Existing"] = "existing";
    ExistingOrNewRoute["New"] = "new";
})(ExistingOrNewRoute || (ExistingOrNewRoute = {}));

var XpoLtlGlobalSearchActionType;
(function (XpoLtlGlobalSearchActionType) {
    // Generic Actions
    XpoLtlGlobalSearchActionType["Select"] = "select";
    // PnD Result Actions
    XpoLtlGlobalSearchActionType["PnDStageShipment"] = "pndStageShipment";
    XpoLtlGlobalSearchActionType["PnDAssignRoute"] = "pndAssignRoute";
    XpoLtlGlobalSearchActionType["PnDMapShipment"] = "pndMapShipment";
    XpoLtlGlobalSearchActionType["PnDRouteShipment"] = "pndRouteShipment";
    XpoLtlGlobalSearchActionType["PnDAssignPickup"] = "pndAssignPickup";
    XpoLtlGlobalSearchActionType["PnDPickupDocument"] = "pnDPickupDocument";
    XpoLtlGlobalSearchActionType["PnDPickupDetailsPage"] = "pndPickupDetailsPage";
    XpoLtlGlobalSearchActionType["PnDTripDetailsPage"] = "pndTripDetailsPage";
})(XpoLtlGlobalSearchActionType || (XpoLtlGlobalSearchActionType = {}));

var GlobalSearchAppName;
(function (GlobalSearchAppName) {
    GlobalSearchAppName["CLAIMS_APP"] = "claims";
    GlobalSearchAppName["DISPUTES_APP"] = "disputes";
    GlobalSearchAppName["INVOICE_APP"] = "invoicing-workbench";
    GlobalSearchAppName["SHIPMENTS_APP"] = "cs-shipment-list";
    GlobalSearchAppName["PND_APP"] = "pnd";
    GlobalSearchAppName["SHM_APP"] = "shplist";
})(GlobalSearchAppName || (GlobalSearchAppName = {}));

var GlobalSearchResultType;
(function (GlobalSearchResultType) {
    GlobalSearchResultType["InvoiceSearchResults"] = "invoiceSearchResults";
    GlobalSearchResultType["ShipmentSearchResults"] = "shipmentSearchResults";
    GlobalSearchResultType["DisputeSearchResults"] = "disputeSearchResults";
    GlobalSearchResultType["ClaimSearchResults"] = "claimSearchResults";
    GlobalSearchResultType["DocumentsSearchResults"] = "documentSearchResults";
    GlobalSearchResultType["PnDSearchResults"] = "pndSearchResults";
    GlobalSearchResultType["PickupSearchResults"] = "pickupSearchResults";
})(GlobalSearchResultType || (GlobalSearchResultType = {}));

var StageShipmentAssignType;
(function (StageShipmentAssignType) {
    StageShipmentAssignType["None"] = "None";
    StageShipmentAssignType["Existing"] = "Existing";
    StageShipmentAssignType["PnD"] = "P&D";
    StageShipmentAssignType["Planning"] = "Planning";
})(StageShipmentAssignType || (StageShipmentAssignType = {}));

var StageShipmentStatus;
(function (StageShipmentStatus) {
    StageShipmentStatus["Staged"] = "Staged";
    StageShipmentStatus["Unstaged"] = "Unstaged";
    StageShipmentStatus["Routed"] = "Routed";
    StageShipmentStatus["NotRouted"] = "Not Routed";
})(StageShipmentStatus || (StageShipmentStatus = {}));

var StageShipmentTypeCd;
(function (StageShipmentTypeCd) {
    StageShipmentTypeCd["Stage"] = "Stage";
    StageShipmentTypeCd["Unstage"] = "Unstage";
})(StageShipmentTypeCd || (StageShipmentTypeCd = {}));

var StageShipmentWarningEnum;
(function (StageShipmentWarningEnum) {
    StageShipmentWarningEnum["CANNOT_ASSIGN"] = "Selected shipment cannot be assigned to a route";
    StageShipmentWarningEnum["CANNOT_ASSIGN_OUT_FOR_DLVRY"] = "Selected shipment is Out For Delivery and cannot be assigned to a route.";
    StageShipmentWarningEnum["HAVE_EXCEPTION"] = "Above shipments have an exception. If you stage them, they will be available for routing in ";
    StageShipmentWarningEnum["HAVE_EXCEPTION_STAGED"] = "Above shipments have an exception. If you unstage them, they will be unavailable for routing in ";
    StageShipmentWarningEnum["NO_SELECTED"] = "No selected shipments can be assigned to a route";
    StageShipmentWarningEnum["OUT_FOR_DLVRY"] = "The following shipments are Out For Delivery and cannot be assigned to a route:";
    StageShipmentWarningEnum["OUT_FOR_DLVRY_UNASSIGNED"] = "The following shipments are Out For Delivery and cannot be assigned to a route:";
    StageShipmentWarningEnum["SOME_HAVE_EXCEPTION"] = "Some of the selected shipments have an exception. If you continue they will be assigned to the selected route at the Destination SIC below.";
    StageShipmentWarningEnum["UNSELECTED_UNSTAGE"] = "Unselected shipments are unstaged and need to be selected to be assigned to a route.";
})(StageShipmentWarningEnum || (StageShipmentWarningEnum = {}));

var StageShipmentColumnName;
(function (StageShipmentColumnName) {
    StageShipmentColumnName["ProNbr"] = "proNbr";
    StageShipmentColumnName["ConsigneeName"] = "consigneeName";
    StageShipmentColumnName["Status"] = "shipmentPnDStatusCd";
    StageShipmentColumnName["Exception"] = "exception";
    StageShipmentColumnName["CurrentLocation"] = "destinationSicCd";
})(StageShipmentColumnName || (StageShipmentColumnName = {}));

var StageShipmentsFormFields;
(function (StageShipmentsFormFields) {
    StageShipmentsFormFields["AssignType"] = "assignType";
    StageShipmentsFormFields["ExistingRoute"] = "existingRoute";
    StageShipmentsFormFields["NewRouteAreaPrefix"] = "newRouteArea";
    StageShipmentsFormFields["NewRouteSuffix"] = "newRouteSuffix";
    StageShipmentsFormFields["RouteCategoryCd"] = "routeCategoryCd";
    StageShipmentsFormFields["RouteDate"] = "routeDate";
})(StageShipmentsFormFields || (StageShipmentsFormFields = {}));
var StageShipmentsNewFormFields;
(function (StageShipmentsNewFormFields) {
    StageShipmentsNewFormFields["RouteType"] = "RouteType";
    StageShipmentsNewFormFields["ExistingRouteNbr"] = "ExistingRouteNbr";
    StageShipmentsNewFormFields["NewRouteAreaPrefix"] = "NewRouteAreaPrefix";
    StageShipmentsNewFormFields["NewRouteSuffix"] = "NewRouteSuffix";
    StageShipmentsNewFormFields["RouteCategoryCd"] = "RouteCategoryCd";
    StageShipmentsNewFormFields["PndTripDate"] = "PndTripDate";
    StageShipmentsNewFormFields["DestinationSIC"] = "DestinationSIC";
})(StageShipmentsNewFormFields || (StageShipmentsNewFormFields = {}));

var StageShipmentPanelType;
(function (StageShipmentPanelType) {
    StageShipmentPanelType["assign"] = "assign";
    StageShipmentPanelType["stage"] = "stage";
    StageShipmentPanelType["unstage"] = "unstage";
})(StageShipmentPanelType || (StageShipmentPanelType = {}));
var StageShipmentDataSource;
(function (StageShipmentDataSource) {
    StageShipmentDataSource["globalSearch"] = "globalSearch";
    StageShipmentDataSource["grid"] = "grid";
})(StageShipmentDataSource || (StageShipmentDataSource = {}));
const StageShipmentButtonMap = {
    [StageShipmentPanelType.assign]: 'Assign Shipments',
    [StageShipmentPanelType.stage]: 'Stage Shipments',
    [StageShipmentPanelType.unstage]: 'Unstage Shipments',
};

class ExistingRouteType {
}

class StageShipmentParams {
}

class StageShipmentSuccessParams {
}

class StageShipmentUtils {
    static canMapAndNotDelivered(data) {
        return ((data === null || data === void 0 ? void 0 : data.hasConsignee) &&
            !(data === null || data === void 0 ? void 0 : data.geoCoordinatesGeo) &&
            (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) !== (DeliveryQualifierCd === null || DeliveryQualifierCd === void 0 ? void 0 : DeliveryQualifierCd.FINAL) &&
            (data === null || data === void 0 ? void 0 : data.billInd));
    }
    static getStageShipmentStatus(data) {
        const stageableInd = data === null || data === void 0 ? void 0 : data.stageableInd;
        const routeTypeCd = data.routeTypeCd;
        let status;
        if (stageableInd === true) {
            if (routeTypeCd === RouteTypeCd.NOT_ROUTED) {
                status = StageShipmentStatus.Unstaged;
            }
            else if (routeTypeCd === RouteTypeCd.STAGED) {
                status = StageShipmentStatus.Staged;
            }
        }
        else {
            if (routeTypeCd === RouteTypeCd.NOT_ROUTED) {
                status = StageShipmentStatus.NotRouted;
            }
            else if (routeTypeCd === RouteTypeCd.ROUTED) {
                status = StageShipmentStatus.Routed;
            }
        }
        return status;
    }
    static canStageOrUnstageShipment(shipment) {
        return StageShipmentUtils.isUnstagedShipment(shipment) || StageShipmentUtils.isStagedShipment(shipment);
    }
    static isUnstagedShipment(shipment) {
        return shipment.stageableInd === true && shipment.routeTypeCd === RouteTypeCd.NOT_ROUTED;
    }
    static isStagedShipment(shipment) {
        return shipment.stageableInd === true && shipment.routeTypeCd === RouteTypeCd.STAGED;
    }
    static isNotDispatchedNotFinalAndUnstageable(data) {
        return ((data === null || data === void 0 ? void 0 : data.statusCd) !== RouteStatusCd.DISPATCHED &&
            (data === null || data === void 0 ? void 0 : data.stageableInd) === false &&
            (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) !== DeliveryQualifierCd.FINAL &&
            (data === null || data === void 0 ? void 0 : data.billInd));
    }
    /** Case -1, cat 1 if all shipment have stageableInd = true, cat 2 if all shipment have stageableInd = false
     * cityoperations.routeTypeCd != routed and
     * cityoperations.deliveryQualifierCd is any of “Refused”, “Damaged”, “Undelivered”, “Returned”, “Attempted”, “HoldForCustoms”, “Trapped”, “PartialShort” or “AllShort”
     * this means stageableInd = true,
     * stageableInd = false always if cityoperations.routeTypeCd = routed
     */
    static stageableInd(data) {
        return (data === null || data === void 0 ? void 0 : data.routeTypeCd) === RouteTypeCd.NOT_ROUTED &&
            ((data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.REFUSED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.DAMAGED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.UNDELIVERED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.RETURNED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.ATTEMPTED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.HOLD_FOR_CUSTOMS ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.TRAPPED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.PARTIAL_SHORT ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.ALL_SHORT);
    }
    /** Case 2
     * Cat 1 if unstageable true - unstage the shipments or assign them to a planning or delivery route
     * Cat 2 if unstageable false - user can assign shipment to a planning or delivery route
     *
     *
     */
    static unstageable(data) {
        return (data === null || data === void 0 ? void 0 : data.routeTypeCd) === RouteTypeCd.STAGED &&
            ((data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.REFUSED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.DAMAGED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.UNDELIVERED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.RETURNED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.ATTEMPTED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.HOLD_FOR_CUSTOMS ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.TRAPPED ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.PARTIAL_SHORT ||
                (data === null || data === void 0 ? void 0 : data.deliveryQualifierCd) === DeliveryQualifierCd.ALL_SHORT);
    }
    /**
     * Case 3 if routable=> hide dont assign option
     * else hide all options and disable button
     *
     *
     */
    static routable(data) {
        return (data === null || data === void 0 ? void 0 : data.routeTypeCd) === RouteTypeCd.ROUTED &&
            `${data === null || data === void 0 ? void 0 : data.movementStatusCd}` !== `${MovementStatusCd.OUT_FOR_DLVRY}`;
    }
}

const moment$1 = moment$3;
class StageShipmentsService {
    constructor(cityOpsService, snackbar, locationService, serviceCentersService) {
        this.cityOpsService = cityOpsService;
        this.snackbar = snackbar;
        this.locationService = locationService;
        this.serviceCentersService = serviceCentersService;
        this.existingRouteSummariesSubject = new BehaviorSubject(undefined);
        this.existingRoutesSummaries$ = this.existingRouteSummariesSubject.asObservable();
        this.suggestedRouteNamesSubject = new BehaviorSubject(undefined);
        this.suggestedRouteNames$ = this.suggestedRouteNamesSubject.asObservable();
        this.loadingSubject = new BehaviorSubject(false);
        this.loading$ = this.loadingSubject.asObservable();
    }
    get existingRouteSummaries() {
        return this.existingRouteSummariesSubject.value;
    }
    get suggestedRouteNames() {
        return this.suggestedRouteNamesSubject.value;
    }
    fetchSuggestedRouteNames$(sicCd, planDate) {
        const path = { sicCd };
        const query = {
            planDate: moment$1(planDate).format('YYYY-MM-DD'),
            satelliteInd: true,
            zoneIndicatorCd: ZoneIndicatorCd.INCLUDE_ZONES,
        };
        return this.cityOpsService.listPnDSuggestedRouteNames(path, query).pipe(catchError((err) => {
            this.handleStageShipmentError(err);
            return of({});
        }), take(1), tap((response) => {
            this.suggestedRouteNamesSubject.next(get(response, 'suggestedRouteNames', []));
            this.existingRouteSummariesSubject.next(get(response, 'existingRouteSummaries', []));
        }), map((res) => {
            return res;
        }));
    }
    getShipmentIdsForStageAndAssignment(stageShipmentParams) {
        const shipmentList = stageShipmentParams.shipmentData;
        const shipmentIds = [];
        shipmentList.forEach((singleShipment) => {
            const pckupDate = moment$1(singleShipment.pickupDt).format('YYYY-MM-DD');
            const singleShipmentObj = {
                shipmentInstId: toString(singleShipment.shipmentInstId),
                proNumber: singleShipment.proNbr,
                pickupDate: moment$1(singleShipment.pickupDt).toDate(),
            };
            shipmentIds.push(singleShipmentObj);
        });
        return shipmentIds;
    }
    stageShipment(stageShipmentParams) {
        const shipmentIds = this.getShipmentIdsForStageAndAssignment(stageShipmentParams);
        const request = new UpdatePnDRouteStatusForShipmentsRqst();
        request.shipmentIds = shipmentIds;
        request.routeTypeCd = RouteTypeCd.STAGED;
        // request.routeTypeCd = stageShipmentParams.stageShipmentType === StageShipmentTypeCd.Stage ? RouteTypeCd.STAGED : RouteTypeCd.NOT_ROUTED;
        this.loadingSubject.next(true);
        return this.cityOpsService.updatePnDRouteStatusForShipments(request).pipe(catchError((err) => {
            return this.handleStageShipmentError(err);
        }), finalize(() => {
            this.loadingSubject.next(false);
        }));
    }
    unstageShipment(stageShipmentParams) {
        const shipmentIds = this.getShipmentIdsForStageAndAssignment(stageShipmentParams);
        const request = new UpdatePnDRouteStatusForShipmentsRqst();
        request.shipmentIds = shipmentIds;
        request.routeTypeCd = RouteTypeCd.NOT_ROUTED;
        this.loadingSubject.next(true);
        return this.cityOpsService.updatePnDRouteStatusForShipments(request).pipe(catchError((err) => {
            return this.handleStageShipmentError(err);
        }), finalize(() => {
            this.loadingSubject.next(false);
        }));
    }
    assignShipmentsToExistingRoute(stageShipmentParams) {
        const shipmentIds = this.getShipmentIdsForStageAndAssignment(stageShipmentParams);
        const request = new AssignShipmentsToRouteRqst();
        request.shipmentIds = shipmentIds;
        request.overrideTdcInd = false;
        request.forceReassignInd = true;
        request.returnWarningsAsErrorsInd = true;
        const reqParams = new AssignShipmentsToRoutePath();
        reqParams.sicCd = stageShipmentParams.terminalSicCd;
        reqParams.routeInstId = stageShipmentParams.routeInstId;
        this.loadingSubject.next(true);
        return this.cityOpsService.assignShipmentsToRoute(request, reqParams).pipe(map((resp) => {
            const matchingRoute = find(get(resp, 'tripDetail.route'), ({ route }) => {
                return (route.routePrefix === stageShipmentParams.routePrefix &&
                    route.routeSuffix === stageShipmentParams.routeSuffix);
            });
            // ROUTE object actually comes back as { route: Route } for some reason.
            return get(matchingRoute, 'route', matchingRoute);
        }), catchError((err) => {
            return this.handleStageShipmentError(err);
        }), finalize(() => {
            this.loadingSubject.next(false);
        }));
    }
    assignShipmentToNewRoute(stageShipmentParams) {
        const shipmentIds = this.getShipmentIdsForStageAndAssignment(stageShipmentParams);
        const request = Object.assign(Object.assign({}, new CreateNewRouteRqst()), { route: Object.assign(Object.assign({}, new Route()), { routePrefix: stageShipmentParams.routePrefix, routeSuffix: stageShipmentParams.routeSuffix, routeDate: stageShipmentParams.planDate, categoryCd: stageShipmentParams.categoryCd, terminalSicCd: stageShipmentParams.terminalSicCd }), shipmentList: shipmentIds, areaInstId: stageShipmentParams.areaInstId, overrideTdcInd: false, forceReassignInd: true, returnWarningsAsErrorsInd: true });
        this.loadingSubject.next(true);
        return this.cityOpsService.createNewRoute(request).pipe(map((resp) => {
            return get(resp, 'route');
        }), catchError((err) => {
            return this.handleStageShipmentError(err);
        }), finalize(() => {
            this.loadingSubject.next(false);
        }));
    }
    getShipmentCurrentLocation$(sicCd) {
        return this.serviceCentersService.getSicByCd$(sicCd).pipe(take(1), switchMap((serviceCenter) => {
            if (serviceCenter !== undefined) {
                return of(serviceCenter);
            }
            else {
                // is it a satellite SIC? if so, return the parent's data
                return this.locationService.request({ sicCd: toUpper(sicCd) }).pipe(switchMap((locReferenceResp) => {
                    const locReference = get(locReferenceResp, 'locReference', new LocationReference());
                    return of(Object.assign(Object.assign({}, new ServiceCenter()), { sicCd, locAddress: Object.assign(Object.assign({}, new LocationAddress()), { cityName: locReference.sicName, countrySubdivisionCd: locReference.sltStateAbbrv, postalCd: locReference.sltCountryCd }) }));
                }));
            }
        }), catchError(() => {
            return of(Object.assign(Object.assign({}, new ServiceCenter()), { sicCd }));
        }));
    }
    // TODO move to ngx-ltl util?
    parseErrorMessage(fault) {
        if (get(fault, 'code', '').startsWith('4')) {
            let message = get(fault, 'error.message', '');
            get(fault, 'error.moreInfo', []).forEach((moreInfo) => {
                if (!message.endsWith('.')) {
                    message += '.';
                }
                message += ` ${moreInfo.message}`;
            });
            return message;
        }
        else {
            if (has(fault, 'error.message')) {
                fault = get(fault, 'error.message');
            }
            else if (isObject(fault)) {
                const auxFault = isEmpty(fault) ? undefined : JSON.stringify(fault);
                return toString(defaultTo(auxFault, 'Unknown Error'));
            }
            return toString(defaultTo(fault, 'Unknown Error'));
        }
    }
    handleStageShipmentError(err) {
        this.snackbar.open({
            message: this.parseErrorMessage(err),
            status: 'error',
            matConfig: {
                verticalPosition: 'bottom',
                duration: 0,
            },
        });
        return throwError(err);
    }
}
StageShipmentsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentsService, deps: [{ token: i5$1.CityOperationsApiService }, { token: i3$2.XpoSnackBar }, { token: XpoLtlLocationDetailsCacheService }, { token: XpoLtlServiceCentersService }], target: i0.ɵɵFactoryTarget.Injectable });
StageShipmentsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i5$1.CityOperationsApiService }, { type: i3$2.XpoSnackBar }, { type: XpoLtlLocationDetailsCacheService }, { type: XpoLtlServiceCentersService }]; } });

const moment = moment$3;
class StageShipmentComponent {
    constructor(data, dialogRef, stageShipmentsService, configManagerService, snackBar, titleCasePipe, router, cdr) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.stageShipmentsService = stageShipmentsService;
        this.configManagerService = configManagerService;
        this.snackBar = snackBar;
        this.titleCasePipe = titleCasePipe;
        this.router = router;
        this.cdr = cdr;
        this.PLANNING_ROUTE_PREFIXES = ['LG', 'OSD', 'TRAP', 'CME'];
        this.StageShipmentType = StageShipmentTypeCd;
        this.RouteTypeCd = RouteTypeCd;
        this.StageShipmentAssignType = StageShipmentAssignType;
        this.StageShipmentColumnName = StageShipmentColumnName;
        this.StageShipmentsFormFields = StageShipmentsFormFields;
        this.characterNumberHyphenPattern = '^[0-9a-zA-Z-]$';
        this.characterNumberPattern = '^[0-9a-zA-Z]$';
        this.characterPattern = '^[a-zA-Z]$';
        this.displayedColumns = [
            StageShipmentColumnName.ProNbr,
            StageShipmentColumnName.ConsigneeName,
            StageShipmentColumnName.Status,
            StageShipmentColumnName.Exception,
            StageShipmentColumnName.CurrentLocation,
        ];
        this.defaultAssignType = StageShipmentAssignType.None;
        this.currentSic = '';
        this.newRouteAreasListSubject = new BehaviorSubject(undefined);
        this.newRouteAreasList$ = this.newRouteAreasListSubject.asObservable();
        this.existingRouteSummary = [];
        this.showSpinnerSubject = new BehaviorSubject(false);
        this.showSpinner$ = this.showSpinnerSubject.asObservable();
        this.unsubscriber = new Unsubscriber();
    }
    get newRouteAreasList() {
        return this.newRouteAreasListSubject.value;
    }
    ngOnInit() {
        var _a;
        console.log({ data: this.data });
        this.shipmentData = this.data.shipmentData[0];
        // this.isNotDispatchedAndNoStatusShipment = this.data?.shipmentData?.statusCd !== RouteStatusCd.DISPATCHED && !this.data?.shipmentData?.stageableInd;
        this.currentSic = (_a = this.shipmentData) === null || _a === void 0 ? void 0 : _a.hostDestSicCd;
        this.stageShipmentTypeCd = StageShipmentUtils.isUnstagedShipment(this.shipmentData)
            ? StageShipmentTypeCd.Stage
            : StageShipmentTypeCd.Unstage;
        this.stageShipmentStatus = StageShipmentUtils.getStageShipmentStatus(this.shipmentData);
        this.dataSource = new MatTableDataSource([this.shipmentData]);
        this.planMinDate = moment().toDate();
        this.planMaxDate = moment()
            .add(6, 'days')
            .toDate();
        this.createForm();
        this.initializeWatchers();
        this.setShipmentCurrentLocation(this.shipmentData.shipmentLocationSicCd);
        this.stageShipmentsService
            .fetchSuggestedRouteNames$(this.shipmentData.hostDestSicCd)
            .pipe(takeUntil(this.unsubscriber.done$))
            .subscribe();
    }
    handleSicChanged(sicCd) {
        this.showSpinnerSubject.next(true);
        this.currentSic = sicCd;
        this.stageShipmentsService
            .fetchSuggestedRouteNames$(this.currentSic)
            .pipe(takeUntil(this.unsubscriber.done$))
            .subscribe((res) => {
            switch (this.stageShipmentAssignTypeCtrl.value) {
                case StageShipmentAssignType.Existing:
                    this.updateExistingRoutNames();
                    break;
                case StageShipmentAssignType.PnD:
                    this.updateControlsOnAssignTypeUpdate(StageShipmentAssignType.PnD);
                    this.updateExistingRoutNames();
                    break;
                case StageShipmentAssignType.Planning:
                    this.updateControlsOnAssignTypeUpdate(StageShipmentAssignType.Planning);
                    this.updateExistingRoutNames();
                    break;
            }
            this.showSpinnerSubject.next(false);
        });
    }
    updateExistingRoutNames() {
        this.existingRouteNameCtrl.reset();
        this.existingRouteNameCtrl.markAsTouched();
        this.existingRouteNameCtrl.updateValueAndValidity();
        this.filteredExistingRouteNamesForSic$ = this.stageShipmentsService.existingRoutesSummaries$.pipe(filter((routes) => !!routes), take(1), map((routeList) => {
            return this.getFilteredExistingRouteNames('', routeList);
        }));
    }
    ngAfterViewInit() {
        this.updateFormValidity();
        this.cdr.detectChanges();
    }
    createForm() {
        this.formGroup = new FormGroup({
            [StageShipmentsFormFields.AssignType]: new FormControl(this.defaultAssignType),
            [StageShipmentsFormFields.ExistingRoute]: new FormControl('', [
                XpoLtlDynamicValidator(() => this.isAssignType(StageShipmentAssignType.Existing), Validators.required),
                XpoLtlDynamicValidator(() => this.isAssignType(StageShipmentAssignType.Existing), () => this.validateExistingRouteInput()),
            ]),
            [StageShipmentsFormFields.RouteCategoryCd]: new FormControl(),
            [StageShipmentsFormFields.RouteDate]: new FormControl(this.planMinDate),
            [StageShipmentsFormFields.NewRouteAreaPrefix]: new FormControl('', [
                XpoLtlDynamicValidator(() => this.isAssignType([StageShipmentAssignType.Planning, StageShipmentAssignType.PnD]), Validators.required),
                XpoLtlDynamicValidator(() => this.isAssignType([StageShipmentAssignType.Planning, StageShipmentAssignType.PnD]), () => this.validateNewRouteAreaInput()),
            ]),
            [StageShipmentsFormFields.NewRouteSuffix]: new FormControl(null, [
                XpoLtlDynamicValidator(() => this.isAssignType([StageShipmentAssignType.Planning, StageShipmentAssignType.PnD]), Validators.required),
            ]),
        });
        this.stageShipmentAssignTypeCtrl = this.formGroup.get(StageShipmentsFormFields.AssignType);
        this.existingRouteNameCtrl = this.formGroup.get(StageShipmentsFormFields.ExistingRoute);
        this.routeCategoryCdCtrl = this.formGroup.get(StageShipmentsFormFields.RouteCategoryCd);
        this.planDateCtrl = this.formGroup.get(StageShipmentsFormFields.RouteDate);
        this.routeAreaPrefixCtrl = this.formGroup.get(StageShipmentsFormFields.NewRouteAreaPrefix);
        this.routeSuffixCtrl = this.formGroup.get(StageShipmentsFormFields.NewRouteSuffix);
        if (this.isNotDispatchedAndNoStatusShipment) {
            this.stageShipmentAssignTypeCtrl.setValue(StageShipmentAssignType.Existing);
        }
    }
    initializeWatchers() {
        this.isAssigningRoute$ = this.stageShipmentAssignTypeCtrl.valueChanges.pipe(map(() => {
            return !this.isAssignType(StageShipmentAssignType.None);
        }), startWith(this.defaultAssignType !== StageShipmentAssignType.None));
        this.actionText$ = this.isAssigningRoute$.pipe(map((assigningRoute) => {
            return assigningRoute ? 'ASSIGN SHIPMENT' : `${this.stageShipmentTypeCd} SHIPMENT`;
        }));
        this.isExistingRouteAssignment$ = this.isAssigningRoute$.pipe(map(() => {
            return this.isAssignType(StageShipmentAssignType.Existing);
        }));
        this.isNewRouteAssignment$ = this.isAssigningRoute$.pipe(map(() => {
            return this.isAssignType([StageShipmentAssignType.Planning, StageShipmentAssignType.PnD]);
        }));
        this.isLoading$ = this.stageShipmentsService.loading$;
        this.isNewPndRouteAssignment$ = this.isAssigningRoute$.pipe(map(() => {
            return this.isAssignType(StageShipmentAssignType.PnD);
        }));
        merge(this.isExistingRouteAssignment$, this.isNewRouteAssignment$)
            .pipe(takeUntil(this.unsubscriber.done$), filter((value) => !!value), debounceTime(100))
            .subscribe(() => {
            const element = this.newRouteAreaInput || this.existingRouteInput;
            if (element) {
                element.nativeElement.focus();
            }
        });
        this.filteredNewRouteAreaNames$ = merge(this.routeAreaPrefixCtrl.valueChanges, this.newRouteAreasList$.pipe(filter((routes) => !!routes), take(1), map(() => this.routeAreaPrefixCtrl.value))).pipe(withLatestFrom(this.newRouteAreasList$), filter(() => this.isAssignType([StageShipmentAssignType.Planning, StageShipmentAssignType.PnD])), map(([value, routeList]) => {
            return this.getFilteredNewRouteAreas(routeList, value);
        }));
        this.filteredExistingRouteNamesForSic$ = merge(this.existingRouteNameCtrl.valueChanges.pipe(distinctUntilChanged()), this.stageShipmentsService.existingRoutesSummaries$.pipe(filter((routes) => !!routes), take(1), map(() => this.existingRouteNameCtrl.value))).pipe(withLatestFrom(this.stageShipmentsService.existingRoutesSummaries$), map(([value, routeList]) => {
            return this.getFilteredExistingRouteNames(value, routeList);
        }));
        this.canStageShipment$ = this.formGroup.statusChanges.pipe(map((status) => status === 'VALID'), startWith(this.formGroup.valid));
        this.stageShipmentAssignTypeCtrl.valueChanges
            .pipe(distinctUntilChanged(), takeUntil(this.unsubscriber.done$))
            .subscribe((assignType) => {
            this.updateControlsOnAssignTypeUpdate(assignType);
        });
        this.routeAreaPrefixCtrl.statusChanges.pipe(debounceTime(50), takeUntil(this.unsubscriber.done$)).subscribe(() => {
            this.updateSuffixOnPrefixUpdate();
        });
        this.planDateCtrl.valueChanges
            .pipe(skip(1), // skips initial setting of value
        distinctUntilChanged((a, b) => {
            return moment(a).format('YYYY-MM-DD') === moment(b).format('YYYY-MM-DD');
        }), takeUntil(this.unsubscriber.done$))
            .subscribe((planDate) => {
            this.updateFormValidity();
            this.stageShipmentsService.fetchSuggestedRouteNames$(this.shipmentData.hostDestSicCd, planDate).subscribe();
        });
    }
    setShipmentCurrentLocation(sicCd) {
        this.shipmentCurrentLocation$ = this.stageShipmentsService.getShipmentCurrentLocation$(sicCd).pipe(take(1), map((serviceCenter) => {
            const cityName = this.titleCasePipe.transform(get(serviceCenter, 'locAddress.cityName', ''));
            const countrySubdivisionCd = get(serviceCenter, 'locAddress.countrySubdivisionCd');
            const postalCd = get(serviceCenter, 'locAddress.postalCd');
            return [cityName, countrySubdivisionCd, postalCd].filter((v) => !!v).join(', ');
        }), shareReplay());
    }
    updateControlsOnAssignTypeUpdate(assignType) {
        this.existingRouteNameCtrl.reset();
        this.routeAreaPrefixCtrl.reset();
        this.routeSuffixCtrl.reset();
        this.planDateCtrl.reset(moment()
            .startOf('day')
            .toDate());
        this.setNewRouteAreasList(assignType);
        switch (assignType) {
            case StageShipmentAssignType.PnD:
            case StageShipmentAssignType.Existing: {
                this.routeCategoryCdCtrl.setValue(RouteCategoryCd.DELIVERY);
                break;
            }
            case StageShipmentAssignType.Planning: {
                this.routeCategoryCdCtrl.setValue(RouteCategoryCd.PLANNING);
                break;
            }
            case StageShipmentAssignType.None: {
                this.routeCategoryCdCtrl.setValue(undefined);
                break;
            }
        }
        this.updateFormValidity();
    }
    isAssignType(assignTypes) {
        const currentAssignType = this.stageShipmentAssignTypeCtrl
            ? this.stageShipmentAssignTypeCtrl.value
            : this.defaultAssignType;
        return some(castArray(assignTypes), (type) => type === currentAssignType);
    }
    getCurrentStageShipmentParams() {
        const route = this.isAssignType(StageShipmentAssignType.Existing)
            ? this.formGroup.get(StageShipmentsFormFields.ExistingRoute).value
            : `${this.formGroup.get(StageShipmentsFormFields.NewRouteAreaPrefix).value}-${this.formGroup.get(StageShipmentsFormFields.NewRouteSuffix).value}`.toUpperCase();
        const routeSuffix = route.split('-')[1];
        let routePrefix = route.split('-')[0];
        // For duplicate areas we add the /<SIC/ZoneSic> so we need to split that out.
        if (routePrefix.indexOf('/') > 0) {
            routePrefix = routePrefix.split('/')[0];
        }
        const matchingExistingRoute = find(this.stageShipmentsService.existingRouteSummaries, (existingRoute) => {
            return existingRoute.routePrefix === routePrefix && existingRoute.routeSuffix === routeSuffix;
        });
        const matchingSuggestedRoute = find(this.stageShipmentsService.suggestedRouteNames, (suggestedRouteName) => {
            return suggestedRouteName.geoArea.geoAreaName === routePrefix;
        });
        const params = {
            stageShipmentType: this.stageShipmentTypeCd,
            stageShipmentAssignType: this.stageShipmentAssignTypeCtrl.value,
            categoryCd: this.routeCategoryCdCtrl.value,
            routePrefix: routePrefix,
            routeSuffix: routeSuffix,
            routeInstId: matchingExistingRoute ? matchingExistingRoute.routeInstId : undefined,
            terminalSicCd: this.currentSic,
            shipmentData: this.shipmentData,
            areaInstId: matchingSuggestedRoute ? +matchingSuggestedRoute.geoArea.areaInstId : undefined,
            planDate: moment(this.planDateCtrl.value).format('YYYY-MM-DD'),
        };
        return params;
    }
    setNewRouteAreasList(assignType) {
        let newRouteGeoAreas = [];
        if (assignType === StageShipmentAssignType.PnD) {
            const planningRoutesPrefixMap = countBy(this.PLANNING_ROUTE_PREFIXES);
            newRouteGeoAreas = reduce(this.stageShipmentsService.suggestedRouteNames, (routeGeoAreasList, suggestedRouteName) => {
                if (!planningRoutesPrefixMap[get(suggestedRouteName, 'geoArea.geoAreaName')]) {
                    routeGeoAreasList.push(suggestedRouteName.geoArea);
                }
                return routeGeoAreasList;
            }, []);
        }
        else if (assignType === StageShipmentAssignType.Planning) {
            newRouteGeoAreas = this.PLANNING_ROUTE_PREFIXES.map((geoAreaName) => (Object.assign(Object.assign({}, new GeoArea()), { geoAreaName })));
        }
        this.newRouteAreasListSubject.next(newRouteGeoAreas);
    }
    getRouteStatus(route) {
        let routeStatus = '';
        if ((route === null || route === void 0 ? void 0 : route.statusCd) === RouteStatusCd.DISPATCHED) {
            routeStatus = (route === null || route === void 0 ? void 0 : route.cartageTripInd) ? 'Dispatched-CRTG' : 'Dispatched';
        }
        else if ((route === null || route === void 0 ? void 0 : route.statusCd) === RouteStatusCd.RETURNING) {
            routeStatus = (route === null || route === void 0 ? void 0 : route.cartageTripInd) ? 'Returning-CRTG' : 'Returning';
        }
        else {
            routeStatus = (route === null || route === void 0 ? void 0 : route.cartageTripInd) ? 'Cartage' : '';
        }
        return routeStatus;
    }
    getFilteredExistingRouteNames(filterValue, routes) {
        var _a, _b;
        const valueLower = !!filterValue ? filterValue.toLowerCase() : '';
        let isUserTyping = false;
        if (routes) {
            this.existingRouteSummary = routes;
        }
        else {
            routes = this.existingRouteSummary;
            isUserTyping = true;
        }
        let existingRoutesArr = [];
        routes === null || routes === void 0 ? void 0 : routes.forEach((route) => {
            const existingRoute = new ExistingRouteType();
            existingRoute.routeName = `${route.routePrefix}-${route.routeSuffix}`;
            existingRoute.routeStatus = this.getRouteStatus(route);
            existingRoute.divider = false;
            existingRoutesArr.push(existingRoute);
        });
        existingRoutesArr =
            filterValue !== ''
                ? existingRoutesArr.filter((route) => route.routeName.toLowerCase().includes(valueLower))
                : existingRoutesArr;
        const newOrCartageRoutes = (_a = [
            ...existingRoutesArr.filter((r) => { var _a; return !r.routeStatus || ((_a = r.routeStatus) === null || _a === void 0 ? void 0 : _a.length) === 0 || r.routeStatus === 'Cartage'; }),
        ]) === null || _a === void 0 ? void 0 : _a.sort((a, b) => a.routeName.localeCompare(b.routeName));
        const allOtherRoutes = (_b = [
            ...existingRoutesArr.filter((r) => { var _a; return ((_a = r.routeStatus) === null || _a === void 0 ? void 0 : _a.length) > 0 && r.routeStatus !== 'Cartage'; }),
        ]) === null || _b === void 0 ? void 0 : _b.sort((a, b) => a.routeName.localeCompare(b.routeName));
        if ((newOrCartageRoutes === null || newOrCartageRoutes === void 0 ? void 0 : newOrCartageRoutes.length) > 0 && (allOtherRoutes === null || allOtherRoutes === void 0 ? void 0 : allOtherRoutes.length) > 0) {
            newOrCartageRoutes[newOrCartageRoutes.length - 1].divider = true;
        }
        const routeNames = [...newOrCartageRoutes, ...allOtherRoutes];
        if (isUserTyping) {
            this.filteredExistingRouteNamesForSic$ = of(routeNames);
        }
        return routeNames;
    }
    getFilteredNewRouteAreas(newRouteAreasList, value) {
        const prefixValueLower = !!value ? value.toLowerCase() : '';
        const geoAreaKeyMap = countBy(newRouteAreasList, 'geoAreaName');
        const filteredNewRouteAreaNames = reduce(newRouteAreasList, (mappedGeoAreaNames, { areaInstId, geoAreaName, sicCd }) => {
            let mappedGeoAreaName;
            // if duplicate geo area name exists, add sic code to string
            if (!geoAreaName) {
                mappedGeoAreaName = undefined;
            }
            else if (geoAreaKeyMap[geoAreaName] > 1) {
                mappedGeoAreaName = `${geoAreaName}/${sicCd}`;
            }
            else {
                mappedGeoAreaName = geoAreaName;
            }
            const isMatchingGeoAreaName = mappedGeoAreaName && mappedGeoAreaName.toLowerCase().indexOf(prefixValueLower) === 0;
            const isPreferredGeoArea = this.shipmentData.areaInstId && this.shipmentData.areaInstId === parseInt$1(areaInstId);
            // if prefix is empty, or is matching geo area, add to array and depending on if it is a preferred
            // geo area, add it to the beginning or end of the list
            if (!value || isMatchingGeoAreaName) {
                isPreferredGeoArea
                    ? mappedGeoAreaNames.unshift(mappedGeoAreaName)
                    : mappedGeoAreaNames.push(mappedGeoAreaName);
            }
            return mappedGeoAreaNames;
        }, []);
        return filteredNewRouteAreaNames;
    }
    updateSuffixOnPrefixUpdate() {
        const area = (this.routeAreaPrefixCtrl.value || '').toUpperCase();
        const categoryCd = this.routeCategoryCdCtrl.value;
        const suggestedRoute = find(this.stageShipmentsService.suggestedRouteNames, (s) => s.categoryCd === categoryCd &&
            (s.geoArea.geoAreaName === area || `${s.geoArea.geoAreaName}/${s.geoArea.sicCd}` === area));
        this.routeSuffixCtrl.setValue(suggestedRoute ? suggestedRoute.suggestedSuffix : '1');
    }
    handleSubmit() {
        let stageAction$;
        const stageShipmentParams = this.getCurrentStageShipmentParams();
        switch (stageShipmentParams.stageShipmentAssignType) {
            case StageShipmentAssignType.None: {
                if (this.stageShipmentTypeCd === StageShipmentTypeCd.Stage) {
                    stageAction$ = this.stageShipmentsService.stageShipment(stageShipmentParams);
                }
                else {
                    stageAction$ = this.stageShipmentsService.unstageShipment(stageShipmentParams);
                }
                break;
            }
            case StageShipmentAssignType.Existing: {
                stageAction$ = this.stageShipmentsService.assignShipmentsToExistingRoute(stageShipmentParams);
                break;
            }
            case StageShipmentAssignType.PnD:
            case StageShipmentAssignType.Planning: {
                stageAction$ = this.stageShipmentsService.assignShipmentToNewRoute(stageShipmentParams);
                break;
            }
        }
        stageAction$.pipe(take(1)).subscribe((route) => {
            const formattedRouteName = !this.isAssignType(StageShipmentAssignType.None)
                ? `${stageShipmentParams.routePrefix}-${stageShipmentParams.routeSuffix}`.toUpperCase()
                : undefined;
            const stageShipmentSuccessParams = {
                shipment: this.shipmentData,
                assignType: stageShipmentParams.stageShipmentAssignType,
                routeName: formattedRouteName,
                routeStatusCd: get(route, 'statusCd', RouteStatusCd.NEW),
                routeInstId: get(route, 'routeInstId', stageShipmentParams.routeInstId),
                routeCategoryCd: get(route, 'categoryCd', stageShipmentParams.categoryCd),
                routePrefix: stageShipmentParams.routePrefix,
                routeSuffix: stageShipmentParams.routeSuffix,
                routeDate: stageShipmentParams.planDate,
            };
            this.handleStageShipmentActionSuccess(stageShipmentSuccessParams);
            this.dialogRef.close();
        });
    }
    cancel() {
        this.dialogRef.close();
    }
    handleStageShipmentActionSuccess(stageShipmentSuccessParams) {
        const performedViewActionSubject = new Subject();
        let successLinkAction; // the proper typing is not exported from core library
        const isUnstageAction = stageShipmentSuccessParams.assignType === StageShipmentAssignType.None &&
            this.stageShipmentTypeCd === StageShipmentTypeCd.Unstage;
        const currentAppName = (this.configManagerService.getSetting(ConfigManagerProperties$1.appName) || '').toLowerCase();
        let snackbar;
        if (!isUnstageAction && currentAppName === GlobalSearchAppName.PND_APP) {
            successLinkAction = {
                message: 'View',
                function: () => {
                    performedViewActionSubject.next();
                    snackbar.dismiss();
                    this.openShipmentInPnd(stageShipmentSuccessParams, false);
                },
            };
        }
        snackbar = this.snackBar.open({
            message: this.buildStageShipmentActionSuccessMessage(stageShipmentSuccessParams, isUnstageAction),
            status: 'success',
            matConfig: {
                verticalPosition: 'bottom',
                duration: 5000,
            },
            linkAction: successLinkAction,
        });
        snackbar
            .afterDismissed()
            .pipe(takeUntil(performedViewActionSubject))
            .subscribe(() => {
            this.openShipmentInPnd(stageShipmentSuccessParams, true);
        });
    }
    buildStageShipmentActionSuccessMessage(params, isUnstage) {
        let successMessage = `Shipment ${params.shipment.proNbr} has been ${isUnstage ? 'unstaged' : 'staged'}`;
        if (!this.isAssignType(StageShipmentAssignType.None)) {
            const assignType = params.routeCategoryCd === RouteCategoryCd.PLANNING
                ? StageShipmentAssignType.Planning
                : StageShipmentAssignType.PnD;
            successMessage += ` and assigned to ${assignType} Route ${params.routeName}`;
        }
        successMessage += '.';
        return successMessage;
    }
    openShipmentInPnd(stageShipmentSuccessParams, suppressRowSelection) {
        var _a;
        let stageShipmentPnDStatusCd;
        let globalSearchActionType;
        if (this.isAssignType(StageShipmentAssignType.None)) {
            globalSearchActionType = XpoLtlGlobalSearchActionType.PnDStageShipment;
            stageShipmentPnDStatusCd = ShipmentPnDStatusCd.UNASSIGNED;
        }
        else if (this.isNotDispatchedAndNoStatusShipment) {
            globalSearchActionType = XpoLtlGlobalSearchActionType.PnDRouteShipment;
            stageShipmentPnDStatusCd = (_a = stageShipmentSuccessParams === null || stageShipmentSuccessParams === void 0 ? void 0 : stageShipmentSuccessParams.shipment) === null || _a === void 0 ? void 0 : _a.shipmentPnDStatusCd;
        }
        else {
            globalSearchActionType = XpoLtlGlobalSearchActionType.PnDAssignRoute;
            stageShipmentPnDStatusCd = ShipmentPnDStatusCd.ASSIGNED;
        }
        const destinationSicCode = this.currentSic;
        const pndResult = Object.assign(Object.assign({}, new PnDSearchResult()), { consigneeName: '', destinationSicCd: destinationSicCode });
        if (!suppressRowSelection) {
            pndResult.proNbr = this.shipmentData.proNbr;
            pndResult.shipmentInstId = this.shipmentData.shipmentInstId;
            pndResult.routePrefix = stageShipmentSuccessParams.routePrefix;
            pndResult.routeSuffix = stageShipmentSuccessParams.routeSuffix;
            pndResult.routeDate = stageShipmentSuccessParams.routeDate;
            pndResult.routeInstId = stageShipmentSuccessParams.routeInstId;
            pndResult.statusCd = stageShipmentSuccessParams.routeStatusCd;
            pndResult.categoryCd = stageShipmentSuccessParams.routeCategoryCd;
            pndResult.shipmentPnDStatusCd = stageShipmentPnDStatusCd;
            pndResult.destinationSicCd = destinationSicCode;
        }
        const globalSearchItem = {
            globalSearchResultType: GlobalSearchResultType.PnDSearchResults,
            data: pndResult,
        };
        const actionPath = this.data.getActionPathFn(globalSearchItem);
        const pathAndQueryParamsArray = actionPath.split('?');
        const queryParamsMap = {
            queryId: Math.round(Math.random() * 10000),
            globalSearchActionType: globalSearchActionType,
        };
        if (pathAndQueryParamsArray.length > 1) {
            pathAndQueryParamsArray[pathAndQueryParamsArray.length - 1].split('&').reduce((params, currentParams) => {
                const keyValue = currentParams.split('=');
                params[keyValue[0]] = keyValue[1];
                return params;
            }, queryParamsMap);
        }
        this.router.navigate([`/${pathAndQueryParamsArray[1]}`], {
            queryParams: queryParamsMap,
            replaceUrl: true,
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
    // VALIDATION & FORM INPUT HANDLING RELATED METHODS
    hasErrors(formField) {
        if (!this.formGroup) {
            return false;
        }
        return !isEmpty(this.formGroup.get(formField).errors);
    }
    hasError(formField, errorKey) {
        const control = this.formGroup.get(formField);
        return control && control.enabled && control.hasError(errorKey);
    }
    updateFormValidity() {
        // updateValueAndValidity doesn't update child form controls so we need to loop
        // through each control and then validate the parent group when done
        forEach(this.formGroup.controls, (formControl) => {
            formControl.updateValueAndValidity({ onlySelf: true });
        });
        this.formGroup.updateValueAndValidity();
    }
    validateExistingRouteInput() {
        const value = this.existingRouteNameCtrl.value;
        if (!value) {
            return null;
        }
        const item = this.stageShipmentsService.existingRouteSummaries.find(({ routePrefix, routeSuffix }) => {
            const formattedRouteName = `${routePrefix}-${routeSuffix}`.toUpperCase();
            return formattedRouteName === value.toUpperCase();
        });
        return item ? null : { invalid: true };
    }
    validateNewRouteAreaInput() {
        if (!this.routeAreaPrefixCtrl || !this.routeAreaPrefixCtrl.value) {
            return null;
        }
        const prefixValue = toUpper(this.formGroup.get(StageShipmentsFormFields.NewRouteAreaPrefix).value);
        const item = find(this.newRouteAreasList, (newRouteArea) => {
            return ((newRouteArea.geoAreaName === prefixValue &&
                filter$1(this.newRouteAreasList, (geoArea) => geoArea.geoAreaName === prefixValue).length === 1) ||
                `${newRouteArea.geoAreaName}/${newRouteArea.sicCd}` === prefixValue);
        });
        return item ? null : { invalid: true };
    }
}
StageShipmentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$1.MatDialogRef }, { token: StageShipmentsService }, { token: i2$3.ConfigManagerService }, { token: i3$2.XpoSnackBar }, { token: i5.TitleCasePipe }, { token: i6$1.Router }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
StageShipmentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: StageShipmentComponent, selector: "xpo-ltl-stage-shipment", host: { classAttribute: "xpo-StageShipment" }, providers: [TitleCasePipe], viewQueries: [{ propertyName: "newRouteAreaInput", first: true, predicate: ["newRouteAreaInput"], descendants: true }, { propertyName: "existingRouteInput", first: true, predicate: ["existingRouteInput"], descendants: true }], ngImport: i0, template: "<!-- New Panel -->\n<div>\n  <!-- <xpo-ltl-stage-shipment-panel [data]=\"data\"></xpo-ltl-stage-shipment-panel> -->\n</div>\n\n<!-- Old panel -->\n<div style=\"display: none;\">\n  <h1 class=\"xpo-StageShipment__title\" mat-dialog-title>\n    <span class=\"xpo-StageShipment__title--text\">\n      <ng-container *ngIf=\"isNotDispatchedAndNoStatusShipment; else stageUnstageShipment\">\n        <div>\n          Assign Shipment\n        </div>\n      </ng-container>\n      <ng-template #stageUnstageShipment>\n        <div>\n          <span>{{ stageShipmentTypeCd === StageShipmentType.Stage ? 'Stage' : 'Unstage' }}</span>\n          the selected shipment ?\n        </div>\n      </ng-template>\n    </span>\n\n    <xpo-dialog-close-button></xpo-dialog-close-button>\n  </h1>\n\n  <div class=\"xpo-StageShipment__content\" mat-dialog-content>\n    <div class=\"xpo-StageShipment__gridData\">\n\n      <table class=\"xpo-StageShipment__gridData--table\" mat-table [dataSource]=\"dataSource\">\n        <!-- Shipment Column -->\n        <ng-container [matColumnDef]=\"StageShipmentColumnName.ProNbr\">\n          <th mat-header-cell *matHeaderCellDef>Shipment</th>\n          <td mat-cell *matCellDef=\"let shipmentData\">{{ shipmentData.proNbr | proFormatter: 10 }}</td>\n        </ng-container>\n\n        <!-- Consignee Column -->\n        <ng-container [matColumnDef]=\"StageShipmentColumnName.ConsigneeName\">\n          <th mat-header-cell *matHeaderCellDef>Consignee</th>\n          <td mat-cell *matCellDef=\"let shipmentData\">{{ shipmentData.consigneeName }}</td>\n        </ng-container>\n\n        <!-- Status Column -->\n        <ng-container [matColumnDef]=\"StageShipmentColumnName.Status\">\n          <th mat-header-cell *matHeaderCellDef>Status</th>\n          <td mat-cell *matCellDef=\"let shipmentData\">\n            {{ stageShipmentStatus }}\n          </td>\n        </ng-container>\n\n        <!-- Exception Column -->\n        <ng-container [matColumnDef]=\"StageShipmentColumnName.Exception\">\n          <th mat-header-cell *matHeaderCellDef>Exception</th>\n          <td mat-cell *matCellDef=\"let shipmentData\">\n            <div\n              *ngIf=\"shipmentData?.movementException?.remarks; else deliveryQualifierCdDisplay\"\n              class=\"xpo-StageShipment__gridData--exception\"\n            >\n              <div class=\"xpo-StageShipment__bold xpo-StageShipment__gridData--heading\">\n                <ng-container *ngTemplateOutlet=\"deliveryQualifierCdDisplay\"></ng-container>\n              </div>\n              <div *ngIf=\"shipmentData?.movementException?.remarks\">\n                {{ shipmentData.movementException.remarks }}\n              </div>\n            </div>\n          </td>\n        </ng-container>\n\n        <!-- Current Location Column -->\n        <ng-container [matColumnDef]=\"StageShipmentColumnName.CurrentLocation\">\n          <th mat-header-cell *matHeaderCellDef>Current Location</th>\n          <td mat-cell *matCellDef=\"let shipmentData\">\n            <ng-container *ngIf=\"shipmentCurrentLocation$ | async as currentLocation\">\n              <div class=\"xpo-StageShipment__gridData--currentLocation\">\n                <span>\n                  {{ currentLocation || shipmentData.shipmentLocationSicCd }}\n                </span>\n                <xpo-status-indicator\n                  [statusText]=\"shipmentData.shipmentLocationSicCd\"\n                  statusColor=\"black\"\n                  [isLabel]=\"true\"\n                ></xpo-status-indicator>\n              </div>\n            </ng-container>\n          </td>\n        </ng-container>\n\n        <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n        <tr mat-row *matRowDef=\"let row; columns: displayedColumns\"></tr>\n      </table>\n    </div>\n    <div class=\"xpo-StageShipment__info\">\n      <ng-container *ngIf=\"!isNotDispatchedAndNoStatusShipment\">\n        <p>\n          This shipment is in\n          <span class=\"xpo-StageShipment__bold\">\n            <ng-container *ngTemplateOutlet=\"deliveryQualifierCdDisplay\"></ng-container>\n          </span>\n          exception status, if you {{ stageShipmentTypeCd === StageShipmentType.Stage ? 'Stage' : 'Unstage' }} it, it will\n          be {{ stageShipmentTypeCd === StageShipmentType.Stage ? 'available' : 'unavailable' }} for routing in\n          <span class=\"xpo-StageShipment__bold\">{{ shipmentData?.hostDestSicCd }}</span\n          >.\n        </p>\n      </ng-container>\n    </div>\n\n    <div class=\"xpo-StageShipment__sic\" *ngIf=\"stageShipmentAssignTypeCtrl.value !== StageShipmentAssignType.None\">\n      <div>This shipment is available for routing at the Destination SIC here:</div>\n      <div class=\"xpo-StageShipment__sic-switcher\">\n   <!--      <mat-label>Destination Sic</mat-label> -->\n        <xpo-ltl-sic-switcher\n          #sicSwitcher\n          [sicCd]=\"currentSic\"\n          (sicChange)=\"handleSicChanged($event?.sicCd)\"\n        ></xpo-ltl-sic-switcher>\n      </div>\n    </div>\n    <div [formGroup]=\"formGroup\" class=\"xpo-StageShipment__formControls\">\n      <hr>\n      <div class=\"xpo-StageShipment__formControls--section\" class=\"xpo-StageShipment__formControls--stageAction\">\n        <mat-radio-group\n          [formControlName]=\"StageShipmentsFormFields.AssignType\"\n          class=\"xpo-StageShipment__formControl--group\"\n        >\n          <mat-radio-button\n            *ngIf=\"!isNotDispatchedAndNoStatusShipment\"\n            class=\"xpo-StageShipment__formControls--radio\"\n            [value]=\"StageShipmentAssignType.None\"\n            >Don't assign to any Route</mat-radio-button\n          >\n          <mat-radio-button class=\"xpo-StageShipment__formControls--radio\" [value]=\"StageShipmentAssignType.Existing\">\n            Existing Route</mat-radio-button\n          >\n          <mat-radio-button class=\"xpo-StageShipment__formControls--radio\" [value]=\"StageShipmentAssignType.PnD\"\n            >Create P&D Route</mat-radio-button\n          >\n          <mat-radio-button class=\"xpo-StageShipment__formControls--radio\" [value]=\"StageShipmentAssignType.Planning\">\n            Create Planning Route</mat-radio-button\n          >\n        </mat-radio-group>\n      </div>\n      <ng-container *ngIf=\"isAssigningRoute$ | async\">\n        <div class=\"xpo-StageShipment__formControls--section xpo-StageShipment__formControls--routeAssignment\">\n          <ng-container *ngIf=\"isExistingRouteAssignment$ | async\">\n            <mat-form-field\n              floatLabel=\"always\"\n              class=\"xpo-StageShipment__formControls--routeName xpo-StageShipment__formControls--control\"\n            >\n              <mat-label>Route #</mat-label>\n              <input\n                #existingRouteInput\n                maxlength=\"15\"\n                type=\"text\"\n                aria-label=\"Existing Route\"\n                matInput\n                (ngModelChange)=\"getFilteredExistingRouteNames($event)\"\n                [xpo-allow-characters]=\"characterNumberHyphenPattern | toRegex\"\n                class=\"xpo-StageShipment__uppercase \"\n                [formControlName]=\"StageShipmentsFormFields.ExistingRoute\"\n                autocomplete=\"off\"\n                [matAutocomplete]=\"existingRouteAutocomplete\"\n              />\n              <mat-autocomplete autoActiveFirstOption #existingRouteAutocomplete=\"matAutocomplete\">\n                <mat-option\n                  *ngFor=\"let existingRoute of filteredExistingRouteNamesForSic$ | async\"\n                  [value]=\"existingRoute?.routeName\"\n                >\n                  <div\n                    class=\"xpo-StageShipment__formControls--option-width\"\n                    [ngClass]=\"{\n                      'two-column-option__divider': !!existingRoute?.divider,\n                      'two-column-option': !existingRoute?.divider\n                    }\"\n                  >\n                    <div>{{ existingRoute?.routeName }}</div>\n                    <div>{{ existingRoute?.routeStatus }}</div>\n                  </div>\n                </mat-option>\n              </mat-autocomplete>\n              <mat-error *ngIf=\"hasErrors(StageShipmentsFormFields.ExistingRoute)\">\n                <div *ngIf=\"hasError(StageShipmentsFormFields.ExistingRoute, 'required')\">\n                  Required\n                </div>\n                <div *ngIf=\"hasError(StageShipmentsFormFields.ExistingRoute, 'invalid')\">Invalid</div>\n              </mat-error>\n            </mat-form-field>\n          </ng-container>\n          <ng-container *ngIf=\"isNewPndRouteAssignment$ | async\">\n            <mat-form-field\n              class=\"xpo-StageShipment__formControls--dateSelector xpo-StageShipment__formControls--control\"\n              floatLabel=\"always\"\n              xpoDatePicker\n            >\n              <mat-label>Trip Date</mat-label>\n              <input\n                matInput\n                [formControlName]=\"StageShipmentsFormFields.RouteDate\"\n                [min]=\"planMinDate\"\n                [max]=\"planMaxDate\"\n                [matDatepicker]=\"datePickerInput\"\n              />\n              <mat-datepicker-toggle matSuffix [for]=\"datePickerInput\">\n                <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>\n              </mat-datepicker-toggle>\n              <mat-datepicker #datePickerInput></mat-datepicker>\n            </mat-form-field>\n          </ng-container>\n          <ng-container *ngIf=\"isNewRouteAssignment$ | async\">\n            <mat-form-field\n              class=\"xpo-StageShipment__formControls--prefix xpo-StageShipment__formControls--control\"\n              floatLabel=\"always\"\n            >\n              <input\n                maxlength=\"9\"\n                #newRouteAreaInput\n                type=\"text\"\n                placeholder=\"Prefix\"\n                aria-label=\"Prefix\"\n                matInput\n                [xpo-allow-characters]=\"characterPattern | toRegex\"\n                autocomplete=\"off\"\n                [formControlName]=\"StageShipmentsFormFields.NewRouteAreaPrefix\"\n                [matAutocomplete]=\"newRouteAreaAutocomplete\"\n                class=\"xpo-StageShipment__uppercase\"\n              />\n              <mat-autocomplete autoActiveFirstOption #newRouteAreaAutocomplete=\"matAutocomplete\">\n                <ng-container *ngFor=\"let newRouteAreaName of filteredNewRouteAreaNames$ | async\">\n                  <ng-container *ngIf=\"!newRouteAreaName\">\n                    <mat-divider></mat-divider>\n                  </ng-container>\n                  <ng-container *ngIf=\"!!newRouteAreaName\">\n                    <mat-option [value]=\"newRouteAreaName\">{{ newRouteAreaName }}</mat-option>\n                  </ng-container>\n                </ng-container>\n              </mat-autocomplete>\n              <mat-error *ngIf=\"hasErrors(StageShipmentsFormFields.NewRouteAreaPrefix)\">\n                <div *ngIf=\"hasError(StageShipmentsFormFields.NewRouteAreaPrefix, 'required')\">Required</div>\n                <div *ngIf=\"hasError(StageShipmentsFormFields.NewRouteAreaPrefix, 'invalid')\">Invalid</div>\n              </mat-error>\n            </mat-form-field>\n            <mat-form-field\n              floatLabel=\"always\"\n              class=\"xpo-StageShipment__formControls--suffix xpo-StageShipments__input-suffix\"\n            >\n              <input\n                maxlength=\"5\"\n                type=\"text\"\n                placeholder=\"Suffix\"\n                aria-label=\"Suffix\"\n                matInput\n                [xpo-allow-characters]=\"characterNumberPattern | toRegex\"\n                [formControlName]=\"StageShipmentsFormFields.NewRouteSuffix\"\n                autocomplete=\"off\"\n                class=\"xpo-StageShipment__uppercase\"\n              />\n              <mat-error *ngIf=\"hasErrors(StageShipmentsFormFields.NewRouteSuffix)\">\n                <div *ngIf=\"hasError(StageShipmentsFormFields.NewRouteSuffix, 'required')\">Required</div>\n              </mat-error>\n            </mat-form-field>\n          </ng-container>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n\n  <div class=\"xpo-StageShipment__actions\" mat-dialog-actions>\n    <xpo-button-group>\n      <button\n        mat-flat-button\n        [disabled]=\"!(canStageShipment$ | async) || (isLoading$ | async) || (showSpinner$ | async)\"\n        (click)=\"handleSubmit()\"\n      >\n        {{ actionText$ | async | uppercase }}\n      </button>\n      <button mat-stroked-button (click)=\"cancel()\">CANCEL</button>\n    </xpo-button-group>\n  </div>\n\n  <ng-template #deliveryQualifierCdDisplay>\n    {{ shipmentData.deliveryQualifierCd | deliveryQualifierCd }}\n    <span\n      *ngIf=\"\n        (shipmentData.deliveryQualifierCd | deliveryQualifierCd) !==\n        (shipmentData.deliveryQualifierCd | deliveryQualifierCd: true)\n      \"\n    >\n      ({{ shipmentData.deliveryQualifierCd | deliveryQualifierCd: true }})\n    </span>\n    <span *ngIf=\"shipmentData.deliveryQualifierReasonCd\">\n      - {{ shipmentData.deliveryQualifierReasonCd | deliveryQualifierReasonCd }} :\n    </span>\n    <span *ngIf=\"shipmentData.movementException?.rfsdReasonCd\">\n      - {{ shipmentData.movementException.rfsdReasonCd | refusedReasonCd }} :\n    </span>\n    <span *ngIf=\"shipmentData.movementException?.undlvdReasonCd\">\n      - {{ shipmentData.movementException.undlvdReasonCd | undeliveredReasonCd }} :\n    </span>\n  </ng-template>\n  <mat-progress-spinner *ngIf=\"showSpinner$ | async\" mode=\"indeterminate\"></mat-progress-spinner>\n</div>\n", styles: [".flex--stretch{flex:1}.xpo-StageShipment__content{padding-bottom:0}.xpo-StageShipment__title--text{display:flex;align-items:center}.xpo-StageShipment__gridData{padding:8px 0}.xpo-StageShipment__gridData--table{width:100%}.xpo-StageShipment__gridData--table .mat-header-cell{background-color:#fff;height:34px}.xpo-StageShipment__gridData--table .mat-header-cell:not(:last-child),.xpo-StageShipment__gridData--table .mat-row .mat-cell:not(:last-child){border-right:1px solid #d8d8d8}.xpo-StageShipment__gridData--table td.mat-column-exception{max-width:600px}.xpo-StageShipment__gridData--table td.mat-column-consigneeName{min-width:200px}.xpo-StageShipment__gridData--heading{font-size:1.143rem;font-weight:500}.xpo-StageShipment__gridData--exception{padding:8px 0;line-height:1.429rem}.xpo-StageShipment__gridData--currentLocation{display:flex;align-items:center;line-height:1.429rem;min-width:210px}.xpo-StageShipment__gridData--currentLocation span{line-height:1.429rem;padding-right:16px}.xpo-StageShipment__gridData--currentLocation ::ng-deep .xpo-StatusIndicator-tag{font-size:.875rem}.xpo-StageShipment__info{padding-bottom:8px}.xpo-StageShipment__sic-switcher{width:385px;margin-right:30px}.xpo-StageShipment__sic-switcher ::ng-deep mat-form-field.mat-form-field-type-mat-input{margin-bottom:20px;margin-top:5px}.xpo-StageShipment__sic{display:flex;justify-content:space-between;align-items:center}.xpo-StageShipment__formControls--option-width,.xpo-StageShipment__formControls--routeName{width:280px}.xpo-StageShipment__formControls--control{padding-right:8px}.xpo-StageShipment__formControls--control ::ng-deep mat-label{font-size:1.285rem}.xpo-StageShipment__formControls--section:not(:last-of-type){padding-bottom:8px}.xpo-StageShipment__formControls--radio{padding-right:8px}.xpo-StageShipment__formControls--routeAssignment{padding-top:16px;height:96px;display:flex}.xpo-StageShipment__formControls--dateSelector ::ng-deep mat-datepicker-toggle button.mat-icon-button{height:unset!important}.xpo-StageShipment__bold{font-weight:500}.xpo-StageShipment__uppercase{text-transform:uppercase}.mat-progress-spinner{left:50%;position:absolute!important;top:50%;transform:translate(-50%,-50%);z-index:999}.two-column-option,.two-column-option__divider{display:flex;justify-content:space-between;padding:0 8px}.two-column-option__divider div:nth-child(2),.two-column-option div:nth-child(2){color:#6f6f6f}.two-column-option__divider{border-bottom:6px solid rgba(0,0,0,.12)}"], components: [{ type: i3.XpoDialogCloseButtonComponent, selector: "xpo-dialog-close-button" }, { type: i5$4.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { type: i2$7.XpoStatusIndicator, selector: "xpo-status-indicator", inputs: ["isLabel", "statusText", "statusColor"] }, { type: i5$4.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { type: i5$4.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { type: XpoLtlSicSwitcherComponent, selector: "xpo-ltl-sic-switcher", inputs: ["sicCd", "panelWidth", "sicLabel"], outputs: ["sicChange"] }, { type: i7$1.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i13.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i11.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["tabIndex", "disabled", "for", "aria-label", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i11.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { type: i11$3.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { type: i5$3.XpoButtonGroup, selector: "xpo-button-group" }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i9.MatProgressSpinner, selector: "mat-progress-spinner", inputs: ["color", "mode", "diameter", "strokeWidth", "value"], exportAs: ["matProgressSpinner"] }], directives: [{ type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i5$4.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { type: i5$4.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { type: i5$4.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { type: i5$4.MatCellDef, selector: "[matCellDef]" }, { type: i5$4.MatCell, selector: "mat-cell, td[mat-cell]" }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5$4.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { type: i5$4.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7$1.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i7.MatLabel, selector: "mat-label" }, { type: i21.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i13.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i2$2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: XpoAllowCharactersDirective, selector: "[xpo-allow-characters]", inputs: ["xpo-allow-characters"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i7.MatError, selector: "mat-error", inputs: ["id"] }, { type: i11.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { type: i7.MatSuffix, selector: "[matSuffix]" }, { type: i11.MatDatepickerToggleIcon, selector: "[matDatepickerToggleIcon]" }, { type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }], pipes: { "proFormatter": ProFormatterPipe, "async": i5.AsyncPipe, "toRegex": ToRegexPipe, "uppercase": i5.UpperCasePipe, "deliveryQualifierCd": DeliveryQualifierCdPipe, "deliveryQualifierReasonCd": DeliveryQualifierReasonCdPipe, "refusedReasonCd": RefusedReasonCdPipe, "undeliveredReasonCd": UndeliveredReasonCdPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-stage-shipment',
                    templateUrl: './stage-shipment.component.html',
                    styleUrls: ['./stage-shipment.component.scss'],
                    host: { class: 'xpo-StageShipment' },
                    providers: [TitleCasePipe],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$1.MatDialogRef }, { type: StageShipmentsService }, { type: i2$3.ConfigManagerService }, { type: i3$2.XpoSnackBar }, { type: i5.TitleCasePipe }, { type: i6$1.Router }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { newRouteAreaInput: [{
                type: ViewChild,
                args: ['newRouteAreaInput', { static: false }]
            }], existingRouteInput: [{
                type: ViewChild,
                args: ['existingRouteInput', { static: false }]
            }] } });

class StageStatusRendererComponent {
    constructor() {
        this.isWarningTemplate = new BehaviorSubject(false);
        this.statusText = new BehaviorSubject('');
        this.RouteTypeCd = RouteTypeCd;
        this.deliveryQualifierCdExpected = StageShipmentDefs.deliveryQualifierCdExpected;
    }
    agInit(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        this.loadStatus();
        return true;
    }
    refreshCells(params) {
        return this.refresh(params);
    }
    loadStatus() {
        const isShipmentNoSelectable = !this.params.data.isRowSelectable;
        const shipmentData = this.params.data.shipmentData;
        if (isShipmentNoSelectable) {
            const billInd = !!shipmentData.billInd;
            if (!billInd) {
                this.statusText.next('Unbilled');
                this.isWarningTemplate.next(true);
                return;
            }
            const movementStatusCd = shipmentData.movementStatusCd;
            if (movementStatusCd === MovementStatusCd.FINAL_DLVD) {
                this.statusText.next('-');
                this.isWarningTemplate.next(false);
                return;
            }
            if (movementStatusCd === MovementStatusCd.OUT_FOR_DLVRY) {
                this.statusText.next('Out For Delivery');
                this.isWarningTemplate.next(true);
                return;
            }
            return;
        }
        // const deliveryQualifierCd = shipmentData.deliveryQualifierCd;
        // const isDeliveryQualifierCdCdExpected = this.deliveryQualifierCdExpected.some(cd => cd === deliveryQualifierCd);
        // if (isDeliveryQualifierCdCdExpected) {
        //   const routeTypeCd = shipmentData.routeTypeCd;
        //   if (routeTypeCd === RouteTypeCd.NOT_ROUTED) {
        //     this.statusText.next('Unstaged');
        //   } else {
        //     this.statusText.next(routeTypeCd);
        //   }
        // } else {
        //   this.statusText.next('Not Routed');
        // }
        const routeTypeCd = shipmentData.routeTypeCd;
        if (routeTypeCd === RouteTypeCd.NOT_ROUTED) {
            const deliveryQualifierCd = shipmentData.deliveryQualifierCd;
            const isDeliveryQualifierCdCdExpected = this.deliveryQualifierCdExpected.some(cd => cd === deliveryQualifierCd);
            if (isDeliveryQualifierCdCdExpected) {
                this.statusText.next('Unstaged');
            }
            else {
                this.statusText.next('Not Routed');
            }
        }
        else {
            this.statusText.next(routeTypeCd);
        }
    }
}
StageStatusRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageStatusRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StageStatusRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: StageStatusRendererComponent, selector: "xpo-ltl-stage-status-renderer", ngImport: i0, template: "<ng-container *ngIf=\"isWarningTemplate | async; else plain\">\n  <div class=\"stage-status-cell routed\">\n    <svg width=\"20\" height=\"17\" viewBox=\"0 0 20 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M0.833496 16.5001H19.1668L10.0002 0.666748L0.833496 16.5001ZM10.8335 14.0001H9.16683V12.3334H10.8335V14.0001ZM10.8335 10.6667H9.16683V7.33341H10.8335V10.6667Z\" fill=\"#B71C1C\"/>\n    </svg>\n    <ng-container *ngTemplateOutlet=\"plain\"></ng-container>\n  </div>\n</ng-container>\n\n<ng-template #plain>\n  {{ statusText | async }}\n</ng-template>\n", styles: [".stage-status-cell.routed{width:100%;height:100%;color:#b71c1c}"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageStatusRendererComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-stage-status-renderer',
                    templateUrl: './stage-status-renderer.component.html',
                    styleUrls: ['./stage-status-renderer.component.scss']
                }]
        }], ctorParameters: function () { return []; } });

class StageExceptionRendererComponent {
    constructor(deliveryQualifierCdPipe) {
        this.deliveryQualifierCdPipe = deliveryQualifierCdPipe;
        this.exception = new BehaviorSubject('');
        this.movementException = new BehaviorSubject(undefined);
    }
    agInit(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        this.loadException();
        return true;
    }
    refreshCells(params) {
        return this.refresh(params);
    }
    loadException() {
        var _a, _b;
        const exception = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.exception;
        if (exception) {
            this.exception.next(exception);
            return;
        }
        const shipment = this.params.data.shipmentData;
        const deliveryQualifierCd = shipment.deliveryQualifierCd;
        if (deliveryQualifierCd) {
            const full = this.deliveryQualifierCdPipe.transform(deliveryQualifierCd);
            const abbr = this.deliveryQualifierCdPipe.transform(deliveryQualifierCd, true);
            const deliveryQualifierCdFormatted = `${full} (${abbr})`;
            this.exception.next(deliveryQualifierCdFormatted);
            const movementExceptions = shipment === null || shipment === void 0 ? void 0 : shipment.movementExceptions;
            const movementException = movementExceptions === null || movementExceptions === void 0 ? void 0 : movementExceptions.reduce((pre, cur) => {
                const sequenceNbrPre = pre.sequenceNbr;
                const sequenceNbrCur = cur.sequenceNbr;
                if (sequenceNbrCur > sequenceNbrPre) {
                    return cur;
                }
                return pre;
            }, { sequenceNbr: -1 });
            if ((movementException === null || movementException === void 0 ? void 0 : movementException.sequenceNbr) > -1) {
                this.movementException.next(movementException);
            }
            return;
        }
        const exceptionFormatted = 'Not Applicable (NA)';
        this.exception.next(exceptionFormatted);
    }
}
StageExceptionRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageExceptionRendererComponent, deps: [{ token: DeliveryQualifierCdPipe }], target: i0.ɵɵFactoryTarget.Component });
StageExceptionRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: StageExceptionRendererComponent, selector: "xpo-ltl-stage-exception-renderer", ngImport: i0, template: "<ng-container *ngIf=\"movementException | async; else singleLine\">\n  <div style=\"white-space: nowrap;\">\n    {{ exception | async }}\n  </div>\n  <div>\n    {{ (movementException | async).typeCd }}\n  </div>\n</ng-container>\n\n\n<ng-template #singleLine>\n  {{ exception | async }}\n</ng-template>\n\n", styles: [".stage-exception-multi-line{background-color:#0f0}"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageExceptionRendererComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-stage-exception-renderer',
                    templateUrl: './stage-exception-renderer.component.html',
                    styleUrls: ['./stage-exception-renderer.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: DeliveryQualifierCdPipe }]; } });

class StageCurrentLocationRendererComponent {
    constructor(serviceCentersService) {
        this.serviceCentersService = serviceCentersService;
        this.location = new BehaviorSubject('');
        this.serviceCenterData = new BehaviorSubject('');
    }
    agInit(params) {
        this.location.pipe(tap((sic) => this.loadServiceCenterData(sic))).subscribe();
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        this.loadData();
        return true;
    }
    refreshCells(params) {
        return this.refresh(params);
    }
    loadData() {
        const currentLocation = this.params.data.currentLocation;
        this.location.next(currentLocation);
    }
    loadServiceCenterData(sicCd) {
        this.serviceCentersService
            .getSicByCd$(sicCd)
            .pipe(take(1), filter((data) => !!data))
            .subscribe((serviceCenterData) => {
            const formattedServiceCenter = this.formatServiceCenterData(serviceCenterData);
            this.serviceCenterData.next(formattedServiceCenter);
        });
    }
    formatServiceCenterData(serviceCenter) {
        // cityName, countrySubdivisionCd, postalCd
        const { reference: { sicName }, locAddress: { countrySubdivisionCd, postalCd }, } = serviceCenter;
        const formattedData = `${sicName}, ${countrySubdivisionCd}, ${postalCd}`;
        return formattedData;
    }
}
StageCurrentLocationRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageCurrentLocationRendererComponent, deps: [{ token: XpoLtlServiceCentersService }], target: i0.ɵɵFactoryTarget.Component });
StageCurrentLocationRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: StageCurrentLocationRendererComponent, selector: "xpo-ltl-stage-current-location-renderer", ngImport: i0, template: "<ng-container *ngIf=\"(location | async) as locationValue\">\n  <span class=\"stage-current-location-renderer--value\">{{ serviceCenterData | async }} {{ locationValue }}</span>\n  <xpo-status-indicator\n    [statusText]=\"locationValue\"\n    statusColor=\"black\"\n    [isLabel]=\"true\"\n  ></xpo-status-indicator>\n  <!-- <div class=\"stage-current-location-renderer\">\n  </div> -->\n</ng-container>\n", styles: [".stage-current-location-renderer--value{padding-right:10px}"], components: [{ type: i2$7.XpoStatusIndicator, selector: "xpo-status-indicator", inputs: ["isLabel", "statusText", "statusColor"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageCurrentLocationRendererComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-stage-current-location-renderer',
                    templateUrl: './stage-current-location-renderer.component.html',
                    styleUrls: ['./stage-current-location-renderer.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlServiceCentersService }]; } });

const isShipmentSelectable = (shipmentData) => {
    const billInd = shipmentData.billInd;
    const movementStatusCd = shipmentData.movementStatusCd;
    const isShipmentNoSelectable = billInd === false ||
        movementStatusCd === MovementStatusCd.FINAL_DLVD ||
        movementStatusCd === MovementStatusCd.OUT_FOR_DLVRY;
    return !isShipmentNoSelectable;
};
const getViewTemplates = (isSingle) => {
    const multipleShipmentsCols = [
        Object.assign(Object.assign({}, XpoAgGridColumns.SelectionWithSelectAll), { pinned: true, lockVisible: true, suppressMovable: true, lockPosition: true }),
    ];
    return [
        new XpoAgGridBoardViewTemplate({
            id: 'stageShipmentTemplate',
            name: 'stageShipmentTemplate',
            keyField: 'shipment',
            availableColumns: [
                ...(isSingle ? [] : multipleShipmentsCols),
                {
                    headerName: 'Shipment',
                    field: 'shipment',
                    width: 75,
                    editable: false,
                },
                {
                    headerName: 'Consignee',
                    field: 'consignee',
                    width: 180,
                    editable: false,
                },
                {
                    headerName: 'Status',
                    field: 'status',
                    width: 100,
                    editable: false,
                    cellClassRules: {
                        'stage-status-cell-grid-warn': (params) => {
                            const movementStatusCd = params.data.shipmentData.movementStatusCd;
                            return !params.data.isRowSelectable && movementStatusCd !== MovementStatusCd.FINAL_DLVD;
                        },
                    },
                    cellRendererFramework: StageStatusRendererComponent,
                },
                {
                    headerName: 'Exception',
                    autoHeight: true,
                    wrapText: true,
                    field: 'exception',
                    editable: false,
                    cellRendererFramework: StageExceptionRendererComponent,
                },
                {
                    headerName: 'Current Location',
                    field: 'currentLocation',
                    autoHeight: true,
                    wrapText: true,
                    editable: false,
                    cellRendererFramework: StageCurrentLocationRendererComponent,
                },
                {
                    headerName: 'selectionIndex',
                    field: 'selectionIndex',
                    hide: true,
                    sort: 'asc',
                    sortable: true,
                    editable: false,
                },
            ],
        }),
    ];
};
const getViews = (viewTemplate) => {
    return [
        viewTemplate.createView({
            id: 'default',
            name: 'default',
            systemDefined: true,
        }),
    ];
};
const getCustomGridOptions = (selectionDispatcher) => {
    const customGridOptions = {
        suppressCsvExport: true,
        suppressExcelExport: true,
        deltaRowDataMode: true,
        suppressRowClickSelection: true,
        suppressRowDeselection: true,
        suppressCellSelection: true,
        getRowNodeId: function (data) {
            return data.id;
        },
        isRowSelectable: (node) => node.data.isRowSelectable,
        onSelectionChanged: (event) => selectionDispatcher.next(event),
        defaultColDef: {
            filter: false,
            sortable: false,
            suppressMenu: true,
            resizable: true,
            editable: true,
        },
        rowSelection: 'multiple',
        enableBrowserTooltips: true,
        enableRangeSelection: true,
        frameworkComponents: [
            XpoStringFilterComponent,
            StageCurrentLocationRendererComponent,
            StageExceptionRendererComponent,
            StageStatusRendererComponent,
        ],
    };
    return customGridOptions;
};
const deliveryQualifierCdExpected = [
    DeliveryQualifierCd.ALL_SHORT,
    DeliveryQualifierCd.ATTEMPTED,
    DeliveryQualifierCd.DAMAGED,
    DeliveryQualifierCd.HOLD_FOR_CUSTOMS,
    DeliveryQualifierCd.PARTIAL_SHORT,
    DeliveryQualifierCd.REFUSED,
    DeliveryQualifierCd.RETURNED,
    DeliveryQualifierCd.TRANSFER,
    DeliveryQualifierCd.UNDELIVERED,
];
const deliveryQualifierCdExpectedSet = new Set(deliveryQualifierCdExpected);
const StageShipmentDefs = {
    getCustomGridOptions,
    getViews,
    getViewTemplates,
    isShipmentSelectable,
    deliveryQualifierCdExpected,
    deliveryQualifierCdExpectedSet,
};

class StageShipmentService extends XpoBoardDataSource {
    constructor() {
        super();
        this.tableDataSubject = new BehaviorSubject([]);
        this.tableData$ = this.tableDataSubject.asObservable();
        this.isNoAssignRouteAvailableSubject = new BehaviorSubject(false);
        this.isNoAssignRouteAvailable$ = this.isNoAssignRouteAvailableSubject.asObservable();
        this.currentSICSubject = new BehaviorSubject('');
        this.currentSIC$ = this.currentSICSubject.asObservable();
        this.selectedDataSubject = new BehaviorSubject(undefined);
        this.selectedData$ = this.selectedDataSubject.asObservable();
        this.warningMessageSubject = new BehaviorSubject('');
        this.warningMessage$ = this.warningMessageSubject.asObservable();
        this.warningMessageNoSelectionSubject = new BehaviorSubject('');
        this.warningMessageNoSelection$ = this.warningMessageNoSelectionSubject.asObservable();
        this.panelTypeSubject = new BehaviorSubject(undefined);
        this.panelType$ = this.panelTypeSubject.asObservable();
        this.isSubmitButtonEnabledSubject = new BehaviorSubject(false);
        this.isSubmitButtonEnabled$ = this.isSubmitButtonEnabledSubject.asObservable();
        this.isExceptionShipmentsPresentSubject = new BehaviorSubject(false);
        this.isExceptionShipmentsPresent$ = this.isExceptionShipmentsPresentSubject.asObservable();
        this.shipmentAssignTypeSubject = new BehaviorSubject(undefined);
        this.shipmentAssignType$ = this.shipmentAssignTypeSubject.asObservable();
        this.shipmenDataSubject = new BehaviorSubject(undefined);
        this.shipmentData$ = this.shipmenDataSubject.asObservable();
        this.defaultAssignType = StageShipmentAssignType.None;
        this.showDontAssignRadioButtonSubject = new BehaviorSubject(false);
        this.showDontAssignRadioButton$ = this.showDontAssignRadioButtonSubject.asObservable();
        this.showAssignRadioButtonSubject = new BehaviorSubject(false);
        this.showAssignRadioButtons$ = this.showAssignRadioButtonSubject.asObservable();
        this.isListeningGridEvents = false;
        this.isLoading = new BehaviorSubject(false);
        this.isLoading$ = this.isLoading.asObservable();
        this.isStatusNotRoutedSubject = new BehaviorSubject(false);
        this.isStatusNotRouted$ = this.isStatusNotRoutedSubject.asObservable();
        this.isStatusRoutedSubject = new BehaviorSubject(false);
        this.isStatusRouted$ = this.isStatusRoutedSubject.asObservable();
        this.isStatusStagedSubject = new BehaviorSubject(false);
        this.isStatusStaged$ = this.isStatusStagedSubject.asObservable();
        this.isStatusMixedSubject = new BehaviorSubject(false);
        this.isStatusMixed$ = this.isStatusMixedSubject.asObservable();
        this.setWatchers();
    }
    get selectedData() {
        return this.selectedDataSubject.value;
    }
    get currentSIC() {
        return this.currentSICSubject.value;
    }
    get shipmentData() {
        return this.shipmenDataSubject.value;
    }
    get isSingleShipment() {
        var _a;
        return this.shipmenDataSubject.value && ((_a = this.shipmenDataSubject.value) === null || _a === void 0 ? void 0 : _a.length) === 1;
    }
    set assignType(val) {
        this.assignTypeValue = val;
    }
    get assignType() {
        return this.assignTypeValue;
    }
    analiceStatuses(shipments) {
        const isNotRouted = shipments.some((shipment) => shipment.routeTypeCd === RouteTypeCd.NOT_ROUTED);
        this.isStatusNotRoutedSubject.next(isNotRouted);
        const isRouted = shipments.some((shipment) => shipment.routeTypeCd === RouteTypeCd.ROUTED);
        this.isStatusRoutedSubject.next(isRouted);
        const isStaged = shipments.some((shipment) => shipment.routeTypeCd === RouteTypeCd.STAGED);
        this.isStatusStagedSubject.next(isStaged);
        this.calculateMixedStatuses();
    }
    setShipmentAssignType(value) {
        this.shipmentAssignTypeSubject.next(value);
    }
    setIsLoading(isLoading) {
        this.isLoading.next(isLoading);
    }
    setGridAPI(gridApi) {
        this.gridApi = gridApi;
    }
    loadShipmentData(data) {
        var _a, _b, _c;
        this.shipmenDataSubject.next(data);
        this.currentSICSubject.next(((_a = data[0]) === null || _a === void 0 ? void 0 : _a.hostDestSicCd) ? (_b = data[0]) === null || _b === void 0 ? void 0 : _b.hostDestSicCd : (_c = data[0]) === null || _c === void 0 ? void 0 : _c.destinationSicCd);
    }
    loadData(data) {
        this.setInitialLoadWatcher();
        this.tableDataSubject.next(data);
    }
    fetchData(state) {
        return this.tableData$.pipe(skipWhile((resp) => resp.length === 0), map((tableData) => {
            const data = new XpoBoardData(state, tableData, 0, 100);
            return data;
        }));
    }
    updateSelectedData(selectedData) {
        const selectedMappedData = selectedData.map((node) => node.data);
        this.selectedDataSubject.next(selectedMappedData);
    }
    isAssignType(assignTypes) {
        const currentAssignType = this.assignType ? this.assignType : this.defaultAssignType;
        return some(castArray(assignTypes), (type) => type === currentAssignType);
    }
    deselectShipments(proNbrs) {
        const deselectedNodes = [];
        this.gridApi.forEachNode((node) => {
            const proNbr = node.data.shipmentData.proNbr;
            if (proNbrs.some((pro) => pro === proNbr)) {
                node.setSelected(false);
                deselectedNodes.push(node);
            }
        });
        return of(deselectedNodes).pipe(delay(1000));
    }
    calculateMixedStatuses() {
        const statuses = [
            this.isStatusNotRoutedSubject.value,
            this.isStatusRoutedSubject.value,
            this.isStatusStagedSubject.value,
        ];
        const presentStatuses = statuses.filter((status) => status);
        const presentStatusesCount = presentStatuses.length;
        const isStatusMixed = presentStatusesCount > 1;
        this.isStatusMixedSubject.next(isStatusMixed);
    }
    setInitialLoadWatcher() {
        this.tableData$
            .pipe(skip(1), take(1), tap(() => this.disableGridEvents(false)), tap(() => this.isLoading.next(true)), delay(1000))
            .subscribe(() => {
            this.isLoading.next(false);
            const allNodes = [];
            this.gridApi.forEachNode((rowNode) => allNodes.push(rowNode.data));
            this.enableAutoSelection(true);
            this.calculatePanelElements(allNodes, true);
        });
    }
    setWatchers() {
        this.selectedDataSubject
            .pipe(filter((data) => !!data && this.isListeningGridEvents), tap(() => this.enableGridEvents(false)))
            .subscribe((selectedData) => {
            // console.log('%c EVENT FROM GRID SELECTION', 'background: #ff0; color: #000');
            // this.calculateSelectionWarning(selectedData);
            this.calculateSubmitButton(selectedData);
        });
    }
    /**
     * Keep this for calculation on change selection
     * @param data Selected shipments
     */
    // private calculateSelectionWarning(data: IStageShipmentTableModel[]): void {
    //   let selectionWarning = '';
    //   if (data.length) {
    //     const tableData = this.tableDataSubject.value;
    //     const isUnstageShipmentUnselected = tableData.some(shipment => shipment.isRowSelectable && shipment.status === RouteTypeCd.NOT_ROUTED);
    //     if (isUnstageShipmentUnselected) {
    //       selectionWarning = StageShipmentWarningEnum.UNSELECTED_UNSTAGE;
    //     }
    //   } else {
    //     selectionWarning = StageShipmentWarningEnum.NO_SELECTED;
    //   }
    //   this.warningMessageNoSelectionSubject.next(selectionWarning);
    // }
    calculateSubmitButton(data) {
        this.isSubmitButtonEnabledSubject.next(!!data.length);
    }
    calculateGenericWarnings(data) {
        const isAbleToSelect = data.some((shipment) => shipment.isRowSelectable);
        if (!isAbleToSelect) {
            this.warningMessageSubject.next(StageShipmentWarningEnum.NO_SELECTED);
            this.showDontAssignRadioButtonSubject.next(false);
            this.showAssignRadioButtonSubject.next(false);
            this.isSubmitButtonEnabledSubject.next(false);
            return;
        }
        const isExceptionShipmentsPresent = data.some((shipment) => shipment.exception);
        if (isExceptionShipmentsPresent) {
            this.isExceptionShipmentsPresentSubject.next(true);
        }
        const isSomeUnselected = data.some((shipment) => !shipment.isSelectedByDefault && shipment.isRowSelectable);
        if (isSomeUnselected) {
            this.warningMessageNoSelectionSubject.next(StageShipmentWarningEnum.UNSELECTED_UNSTAGE);
        }
    }
    calculatePanelElements(data, isAutoSelection = false) {
        this.warningMessageSubject.next('');
        if (data && data.length > 0) {
            this.isSubmitButtonEnabledSubject.next(true);
            // Rule 4
            if (this.isStatusMixedSubject.value) {
                this.calculateNoRouteTypeCd(data, isAutoSelection);
                this.calculateGenericWarnings(data);
                return;
            }
            // Rule 1
            if (this.isStatusNotRoutedSubject.value) {
                this.calculateNotRoutedData(data, isAutoSelection);
                this.calculateGenericWarnings(data);
                if (this.isSingleShipment) {
                    this.calculateSingleShipmentData();
                }
                return;
            }
            // Rule 2
            if (this.isStatusStagedSubject.value) {
                this.calculateNotRoutedStagedData(data, isAutoSelection);
                this.calculateGenericWarnings(data);
                if (this.isSingleShipment) {
                    this.calculateSingleShipmentData();
                }
                return;
            }
            // Rule 3
            if (this.isStatusRoutedSubject.value) {
                this.calculateRoutedData(data, isAutoSelection);
                this.calculateGenericWarnings(data);
                if (this.isSingleShipment) {
                    this.calculateSingleShipmentData();
                }
                return;
            }
        }
        this.isSubmitButtonEnabledSubject.next(false);
        this.showDontAssignRadioButtonSubject.next(false);
        this.showAssignRadioButtonSubject.next(false);
        this.warningMessageSubject.next(StageShipmentWarningEnum.NO_SELECTED);
    }
    calculateSingleShipmentData() {
        const expectedStatus = [MovementStatusCd.FINAL_DLVD, MovementStatusCd.OUT_FOR_DLVRY];
        const singleData = this.shipmentData[0];
        if (!!singleData &&
            ((singleData === null || singleData === void 0 ? void 0 : singleData.billInd) === false || expectedStatus.some((cd) => cd === (singleData === null || singleData === void 0 ? void 0 : singleData.movementStatusCd)))) {
            this.isSubmitButtonEnabledSubject.next(false);
            this.showAssignRadioButtonSubject.next(false);
            this.showDontAssignRadioButtonSubject.next(false);
            const warningMessage = (singleData === null || singleData === void 0 ? void 0 : singleData.movementStatusCd) === MovementStatusCd.OUT_FOR_DLVRY
                ? StageShipmentWarningEnum.CANNOT_ASSIGN_OUT_FOR_DLVRY
                : StageShipmentWarningEnum.CANNOT_ASSIGN;
            this.warningMessageSubject.next(warningMessage);
        }
    }
    calculateNotRoutedData(notRoutedArray, isAutoSelection) {
        this.warningMessageSubject.next('');
        // if part is Case 1 else part is Case 2 and case 3
        // const isProperStageableInd = notRoutedArray.every((value) => value.stageableIndicator);
        const isExpectedStatuses = !notRoutedArray.some((shipment) => !StageShipmentDefs.deliveryQualifierCdExpectedSet.has(shipment.shipmentData.deliveryQualifierCd));
        if (isExpectedStatuses) {
            // isProperStageableInd &&
            this.showDontAssignRadioButtonSubject.next(true);
            this.showAssignRadioButtonSubject.next(true);
            this.panelTypeSubject.next(StageShipmentPanelType.stage);
            this.warningMessageSubject.next(StageShipmentWarningEnum.HAVE_EXCEPTION + this.currentSIC);
        }
        else {
            this.showDontAssignRadioButtonSubject.next(false);
            this.showAssignRadioButtonSubject.next(true);
            this.panelTypeSubject.next(StageShipmentPanelType.assign);
        }
        if (notRoutedArray.some((shipment) => shipment.stageableIndicator) &&
            notRoutedArray.some((shipment) => !shipment.stageableIndicator)) {
            this.warningMessageSubject.next(StageShipmentWarningEnum.SOME_HAVE_EXCEPTION + this.currentSIC);
        }
        ////////////////////////////////
        // TODO: review approach
        ////////////////////////////////
        if (isAutoSelection) {
            this.enableGridEvents(true);
        }
        ////////////////////////////////
    }
    calculateNotRoutedStagedData(stagedArray, isAutoSelection) {
        // if part is Case 1 else part is Case 2 and case 3
        // if (stagedArray.every((value) => value.unstageableIndicator)) {
        if (stagedArray.every((value) => StageShipmentDefs.deliveryQualifierCdExpectedSet.has(value.shipmentData.deliveryQualifierCd))) {
            this.showDontAssignRadioButtonSubject.next(true);
            this.showAssignRadioButtonSubject.next(true);
            this.panelTypeSubject.next(StageShipmentPanelType.unstage);
            this.warningMessageSubject.next(StageShipmentWarningEnum.HAVE_EXCEPTION_STAGED + this.currentSICSubject.value);
        }
        else {
            this.showDontAssignRadioButtonSubject.next(false);
            this.showAssignRadioButtonSubject.next(true);
            this.panelTypeSubject.next(StageShipmentPanelType.assign);
            this.warningMessageSubject.next('');
        }
        ////////////////////////////////
        // TODO: review approach
        ////////////////////////////////
        if (isAutoSelection) {
            this.enableGridEvents(true);
        }
        ////////////////////////////////
    }
    calculateRoutedData(routedArray, isAutoSelection) {
        this.warningMessageSubject.next('');
        let outForDeliveryArray = [];
        let noOutForDeliveryArray = [];
        this.panelTypeSubject.next(StageShipmentPanelType.assign);
        outForDeliveryArray = routedArray.filter((shipment) => shipment.shipmentData.movementStatusCd === MovementStatusCd.OUT_FOR_DLVRY);
        noOutForDeliveryArray = routedArray.filter((shipment) => shipment.shipmentData.movementStatusCd !== MovementStatusCd.OUT_FOR_DLVRY);
        if (outForDeliveryArray.length === routedArray.length) {
            this.showDontAssignRadioButtonSubject.next(false);
            this.showAssignRadioButtonSubject.next(false);
            this.isSubmitButtonEnabledSubject.next(false);
        }
        if (noOutForDeliveryArray.length === routedArray.length) {
            this.showDontAssignRadioButtonSubject.next(false);
            this.showAssignRadioButtonSubject.next(true);
        }
        if (noOutForDeliveryArray.length > 0 && outForDeliveryArray.length > 0) {
            this.showDontAssignRadioButtonSubject.next(false);
            this.showAssignRadioButtonSubject.next(true);
        }
        if (outForDeliveryArray.length > 0) {
            const proNbrs = outForDeliveryArray.map((shipment) => shipment.shipment);
            const warningMessage = `${StageShipmentWarningEnum.OUT_FOR_DLVRY}${proNbrs.join(',')}`;
            this.warningMessageSubject.next(warningMessage);
        }
        ////////////////////////////////
        // TODO: review approach
        ////////////////////////////////
        if (isAutoSelection) {
            this.enableGridEvents(true);
        }
        ////////////////////////////////
    }
    calculateNoRouteTypeCd(data, isAutoSelection) {
        this.warningMessageSubject.next('');
        this.showDontAssignRadioButtonSubject.next(false);
        this.showAssignRadioButtonSubject.next(true);
        this.panelTypeSubject.next(StageShipmentPanelType.assign);
        const outForDeliveryShipments = [];
        this.gridApi.forEachNode((node) => {
            const shipment = node.data.shipmentData;
            if (shipment.movementStatusCd === MovementStatusCd.OUT_FOR_DLVRY) {
                outForDeliveryShipments.push(node.data.shipment);
            }
        });
        ////////////////////////////////
        // TODO: review approach
        ////////////////////////////////
        if (isAutoSelection) {
            this.enableGridEvents(true);
        }
        ////////////////////////////////
        const selectedNodes = this.gridApi.getSelectedNodes();
        if (!selectedNodes.length) {
            this.isSubmitButtonEnabledSubject.next(false);
            return;
        }
        this.isSubmitButtonEnabledSubject.next(true);
        if (!!outForDeliveryShipments.length) {
            const outForDeliveryShipmentsStr = outForDeliveryShipments.join(', ');
            const warningMessage = `${StageShipmentWarningEnum.OUT_FOR_DLVRY_UNASSIGNED}${outForDeliveryShipmentsStr}`;
            this.warningMessageSubject.next(warningMessage);
        }
    }
    enableGridEvents(isDelayed = true) {
        if (isDelayed) {
            this.isLoading.next(true);
            of(true)
                .pipe(delay(100))
                .subscribe(this.setIsListeningGridEvents.bind(this));
            return;
        }
        this.setIsListeningGridEvents(true);
    }
    disableGridEvents(isDelayed = false) {
        if (isDelayed) {
            this.isLoading.next(true);
            of(false)
                .pipe(delay(100))
                .subscribe(this.setIsListeningGridEvents.bind(this));
        }
        this.setIsListeningGridEvents(false);
    }
    setIsListeningGridEvents(value) {
        this.isLoading.next(false);
        this.isListeningGridEvents = value;
    }
    enableAutoSelection(isAutoSelection = false) {
        let isSomeUnselectedShipments = false;
        this.gridApi.forEachNode((node) => {
            const isSelectedByDefault = node.data.isSelectedByDefault;
            if (isSelectedByDefault && isAutoSelection) {
                node.setSelected(true);
            }
            else {
                if (!isSomeUnselectedShipments) {
                    isSomeUnselectedShipments = true;
                }
            }
        });
    }
}
StageShipmentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
StageShipmentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class StageShipmentGridComponent {
    constructor(deliveryQualifierCdPipe, refusedReasonCdPipe, undeliveredReasonCdPipe, stageShipmentService, conditioningService) {
        this.deliveryQualifierCdPipe = deliveryQualifierCdPipe;
        this.refusedReasonCdPipe = refusedReasonCdPipe;
        this.undeliveredReasonCdPipe = undeliveredReasonCdPipe;
        this.stageShipmentService = stageShipmentService;
        this.conditioningService = conditioningService;
        this.shipmentMappersMap = {
            [StageShipmentDataSource.globalSearch]: this.getMappedGlobalSearchShipment.bind(this),
            [StageShipmentDataSource.grid]: this.getMappedGridStageShipment.bind(this),
        };
        this.selectionDispatcher = new BehaviorSubject(undefined);
        this.boardOptions = {
            suppressViewSwitcher: true,
            suppressGridSettingsPopover: true,
        };
        this.customGridOptions = Object.assign({}, StageShipmentDefs.getCustomGridOptions(this.selectionDispatcher));
        this.dataSource = this.stageShipmentService;
        this.isStatusMixed$ = this.stageShipmentService.isStatusMixed$;
    }
    get isSingleShipment() {
        return this.shipments.length === 1;
    }
    ngOnInit() {
        this.viewTemplates = StageShipmentDefs.getViewTemplates(this.isSingleShipment);
        this.views = StageShipmentDefs.getViews(this.viewTemplates[0]);
    }
    onGridReady(gridEvent) {
        this.gridApiEvent = gridEvent;
        this.gridApi = gridEvent.api;
        this.stageShipmentService.setGridAPI(this.gridApi);
        this.mapData();
        this.setListeners();
    }
    mapData() {
        var _a;
        if ((_a = this.shipments) === null || _a === void 0 ? void 0 : _a.length) {
            this.isStatusMixed$.subscribe(isMixed => {
                const mappedData = this.shipments.map((shipment) => this.getMappedStageShipment(shipment, this.source, isMixed));
                this.stageShipmentService.loadData(mappedData);
            });
            this.stageShipmentService.analiceStatuses(this.shipments);
        }
    }
    getMappedStageShipment(shipment, source, isMixed) {
        const mapFn = this.shipmentMappersMap[source];
        return mapFn(shipment, isMixed);
    }
    getMappedGlobalSearchShipment(shipment, isMixed) {
        console.log({ shipment });
        const stageShipmentStatus = StageShipmentUtils.getStageShipmentStatus(shipment);
        // const isNotDispatchedAndNoStatusShipment: boolean = this.isNotDispatchedAndNoStatusShipment(shipment);
        const mappedShipment = {
            shipment: this.conditioningService.conditionProNumber(shipment.proNbr, 10),
            consignee: shipment.consigneeName,
            status: stageShipmentStatus,
            exception: this.getDeliveryQualifierCdDisplay(shipment),
            currentLocation: shipment.shipmentLocationSicCd,
            shipmentData: shipment,
            stageableIndicator: shipment.stageableInd,
            unstageableIndicator: this.getUnStageableIndicator(shipment),
            routeableIndicator: this.getRouteableIndicator(shipment),
            isRowSelectable: StageShipmentDefs.isShipmentSelectable(shipment),
            isSelectedByDefault: true,
            selectionIndex: 0,
        };
        return mappedShipment;
    }
    getMappedGridStageShipment(shipment, isMixed) {
        var _a;
        const proNbr = shipment.proNbr;
        const consigneeName = (_a = shipment['consignee']) === null || _a === void 0 ? void 0 : _a['name1'];
        const stageShipmentStatus = shipment['routeTypeCd'];
        const currentLocation = shipment['shipmentLocationSicCd'];
        const isRowSelectable = StageShipmentDefs.isShipmentSelectable(shipment);
        const mappedShipment = Object.assign({ shipment: this.conditioningService.conditionProNumber(proNbr, 10), consignee: consigneeName, status: stageShipmentStatus, exception: undefined, isException: this.getException(shipment), currentLocation, shipmentData: this.getMappedShipmentData(shipment), stageableIndicator: this.getStageableIndicator(shipment), unstageableIndicator: this.getUnStageableIndicator(shipment), routeableIndicator: this.getRouteableIndicator(shipment), isRowSelectable }, this.commonRulesCalculation(shipment, isRowSelectable, isMixed));
        return mappedShipment;
    }
    getException(shipment) {
        const deliveryQualifierCd = shipment.deliveryQualifierCd;
        return !!deliveryQualifierCd;
    }
    commonRulesCalculation(shipment, isRowSelectable, isMixed) {
        if (isRowSelectable) {
            const codes = StageShipmentDefs.deliveryQualifierCdExpected;
            let selectionIndex, isSelectedByDefault;
            if (shipment.routeTypeCd === RouteTypeCd.NOT_ROUTED && codes.some(cd => cd === shipment.deliveryQualifierCd)) {
                isSelectedByDefault = isMixed ? false : true;
                selectionIndex = -1;
            }
            else if (shipment.routeTypeCd === RouteTypeCd.NOT_ROUTED) {
                isSelectedByDefault = true;
                selectionIndex = 0;
            }
            else {
                isSelectedByDefault = true;
                selectionIndex = 1;
            }
            return { isSelectedByDefault, selectionIndex };
        }
        return { isSelectedByDefault: false, selectionIndex: -2 };
    }
    // TODO: Do we really need this method?
    // private isNotDispatchedAndNoStatusShipment(shipment: any): boolean {
    //   return shipment.statusCd !== RouteStatusCd.DISPATCHED && shipment.stageableInd;
    // }
    getDeliveryQualifierCdDisplay(shipment) {
        let deliveryQualifierCdDisplay = '';
        const { movementExceptions, deliveryQualifierCd } = shipment;
        if (this.deliveryQualifierCdPipe.transform(deliveryQualifierCd) !==
            this.deliveryQualifierCdPipe.transform(deliveryQualifierCd, true)) {
            deliveryQualifierCdDisplay = this.deliveryQualifierCdPipe.transform(deliveryQualifierCd, true);
        }
        if (deliveryQualifierCd) {
            deliveryQualifierCdDisplay = `${deliveryQualifierCdDisplay} - ${this.deliveryQualifierCdPipe.transform(deliveryQualifierCd)}`;
        }
        if (movementExceptions === null || movementExceptions === void 0 ? void 0 : movementExceptions.rfsdReasonCd) {
            deliveryQualifierCdDisplay = `${deliveryQualifierCdDisplay} - ${this.refusedReasonCdPipe.transform(movementExceptions.rfsdReasonCd)}`;
        }
        if (movementExceptions === null || movementExceptions === void 0 ? void 0 : movementExceptions.undlvdReasonCd) {
            deliveryQualifierCdDisplay = `${deliveryQualifierCdDisplay} - ${this.undeliveredReasonCdPipe.transform(movementExceptions.undlvdReasonCd)}`;
        }
        return deliveryQualifierCdDisplay;
    }
    setListeners() {
        this.selectionDispatcher.pipe(skip(1)).subscribe(this.handleGridSelectionChange.bind(this));
    }
    handleGridSelectionChange(event) {
        const selectedNodes = event.api.getSelectedNodes();
        this.stageShipmentService.updateSelectedData(selectedNodes);
    }
    getStageableIndicator(shipment) {
        return StageShipmentUtils.stageableInd(shipment);
    }
    getUnStageableIndicator(shipment) {
        return StageShipmentUtils.unstageable(shipment);
    }
    getRouteableIndicator(shipment) {
        return StageShipmentUtils.routable(shipment);
    }
    getMappedShipmentData(shipment) {
        if (!(shipment === null || shipment === void 0 ? void 0 : shipment.routeTypeCd) && !(shipment === null || shipment === void 0 ? void 0 : shipment.routeInstId)) {
            shipment['routeTypeCd'] = RouteTypeCd.NOT_ROUTED;
        }
        return shipment;
    }
}
StageShipmentGridComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentGridComponent, deps: [{ token: DeliveryQualifierCdPipe }, { token: RefusedReasonCdPipe }, { token: UndeliveredReasonCdPipe }, { token: StageShipmentService }, { token: XpoLtlConditioningService }], target: i0.ɵɵFactoryTarget.Component });
StageShipmentGridComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: StageShipmentGridComponent, selector: "xpo-ltl-stage-shipment-grid", inputs: { shipments: "shipments", source: "source" }, ngImport: i0, template: "<ng-container *ngIf=\"dataSource && customGridOptions\">\n  <div class=\"documentGrid documentGrid--{{ isSingleShipment ? 'single' : 'multiple' }}\">\n    <xpo-board\n      class=\"documentGrid__board\"\n      [dataSource]=\"dataSource\"\n      [viewTemplates]=\"viewTemplates\"\n      [views]=\"views\"\n      [boardOptions]=\"boardOptions\"\n    >\n      <xpo-applied-filters [conditionalFiltersOnly]=\"true\"></xpo-applied-filters>\n      <xpo-ag-grid-board\n        rowModelType=\"client-side\"\n        rowSelection=\"single\"\n        [sizeColumnsToFit]=\"true\"\n        (gridReady)=\"onGridReady($event)\"\n        [customGridOptions]=\"customGridOptions\"\n      >\n      </xpo-ag-grid-board>\n    </xpo-board>\n  </div>\n</ng-container>\n", styles: [":host ::ng-deep xpo-grid-bar{display:none}.documentGrid--multiple{height:175px}.documentGrid--single{height:120px}.documentGrid__board{height:100%}::ng-deep .stage-status-cell-grid-warn{background-color:#ffebee;border:1px solid #b71c1c!important}"], components: [{ type: i4$5.XpoBoard, selector: "xpo-board", inputs: ["id", "dataSource", "views", "viewTemplates", "viewDataStore", "boardOptions", "addBoardViewLabel", "enableFilterReset", "enableQueryParamStatePersistance", "hideViewSwitcher", "hideViewSettingsMenu", "preloadViewData", "applyFilterStrategy", "showRecordCounts", "persistFiltersBetweenViews"], outputs: ["boardReady", "selectionChange"] }, { type: i4$5.XpoAppliedFilters, selector: "xpo-applied-filters", inputs: ["conditionalFiltersOnly"] }, { type: i5$2.XpoAgGridBoard, selector: "xpo-ag-grid-board", inputs: ["autoSelectFirstRow", "autoSizeColumns", "enableMovableColumns", "enableCellSelection", "enableRowSelection", "enableSorting", "groupUseEntireRow", "sizeColumnsToFit", "customGridOptions", "rowSelection", "rowModelType", "selectionMode", "suppressUsingRecordCount", "columnFilters", "pagination", "paginationPageSizes", "paginationPageSizeStart", "highlightMode"], outputs: ["cellSelected", "gridReady", "gridBoardReady", "refreshPagination"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentGridComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-stage-shipment-grid',
                    templateUrl: './stage-shipment-grid.component.html',
                    styleUrls: ['./stage-shipment-grid.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: DeliveryQualifierCdPipe }, { type: RefusedReasonCdPipe }, { type: UndeliveredReasonCdPipe }, { type: StageShipmentService }, { type: XpoLtlConditioningService }]; }, propDecorators: { shipments: [{
                type: Input
            }], source: [{
                type: Input
            }] } });

var StageShipmentFormGroupName;
(function (StageShipmentFormGroupName) {
    StageShipmentFormGroupName["name"] = "stageShipmentForm";
})(StageShipmentFormGroupName || (StageShipmentFormGroupName = {}));
class StageShipmentFormComponent {
    constructor(stageShipmentService, fb, stageShipmentsService, formGroupDirective) {
        this.stageShipmentService = stageShipmentService;
        this.fb = fb;
        this.stageShipmentsService = stageShipmentsService;
        this.formGroupDirective = formGroupDirective;
        this.PLANNING_ROUTE_PREFIXES = ['LG', 'OSD', 'TRAP', 'CME'];
        this.StageShipmentAssignType = StageShipmentAssignType;
        this.StageShipmentsNewFormFields = StageShipmentsNewFormFields;
        this.characterNumberHyphenPattern = '^[0-9a-zA-Z-]$';
        this.characterNumberPattern = '^[0-9a-zA-Z]$';
        this.characterPattern = '^[a-zA-Z]$';
        this.defaultAssignType = StageShipmentAssignType.None;
        this.routeType$ = new Observable(undefined);
        this.existingRouteSummary = [];
        this.newRouteAreasListSubject = new BehaviorSubject(undefined);
        this.newRouteAreasList$ = this.newRouteAreasListSubject.asObservable();
        this.currentSic = '';
        this.showSpinnerSubject = new BehaviorSubject(false);
        this.showSpinner$ = this.showSpinnerSubject.asObservable();
        this.warningMessage = this.stageShipmentService.warningMessage$;
        this.unsubscriber = new Unsubscriber();
        this.planMinDate = moment$3().toDate();
        this.planMaxDate = moment$3()
            .add(6, 'days')
            .toDate();
        this.showDontAssignRadioButton$ = this.stageShipmentService.showDontAssignRadioButton$;
        this.showAssignRadioButtons$ = this.stageShipmentService.showAssignRadioButtons$;
        this.currentSIC$ = this.stageShipmentService.currentSIC$;
    }
    get newRouteAreasList() {
        return this.newRouteAreasListSubject.value;
    }
    get isSingleShipment() {
        return this.shipmentData.length === 1;
    }
    ngOnInit() {
        this.loadShipmentsData();
        this.initForm();
        this.initExternalWatchers();
        this.initFormWatchers();
    }
    loadShipmentsData() {
        this.shipmentData$ = this.stageShipmentService.shipmentData$;
        this.shipmentData$
            .pipe(takeUntil(this.unsubscriber.done$), filter((resp) => !!resp))
            .subscribe((shipments) => {
            this.shipmentData = shipments;
        });
        this.stageShipmentService.currentSIC$
            .pipe(takeUntil(this.unsubscriber.done$), filter((resp) => !!resp))
            .subscribe((val) => {
            this.currentSic = val;
            this.stageShipmentsService
                .fetchSuggestedRouteNames$(val)
                .pipe(takeUntil(this.unsubscriber.done$))
                .subscribe();
        });
    }
    handleSicChanged(sicCd) {
        this.showSpinnerSubject.next(true);
        this.currentSic = sicCd;
        this.stageShipmentsService
            .fetchSuggestedRouteNames$(this.currentSic)
            .pipe(takeUntil(this.unsubscriber.done$))
            .subscribe((res) => {
            switch (this.stageShipmentAssignTypeCtrl.value) {
                case StageShipmentAssignType.Existing:
                    this.updateExistingRoutNames();
                    break;
                case StageShipmentAssignType.PnD:
                    this.updateControlsOnAssignTypeUpdate(StageShipmentAssignType.PnD);
                    this.updateExistingRoutNames();
                    break;
                case StageShipmentAssignType.Planning:
                    this.updateControlsOnAssignTypeUpdate(StageShipmentAssignType.Planning);
                    this.updateExistingRoutNames();
                    break;
            }
            this.showSpinnerSubject.next(false);
        });
    }
    updateExistingRoutNames() {
        this.existingRouteNameCtrl.reset();
        this.existingRouteNameCtrl.markAsTouched();
        this.existingRouteNameCtrl.updateValueAndValidity();
        this.filteredExistingRouteNamesForSic$ = this.stageShipmentsService.existingRoutesSummaries$.pipe(filter((routes) => !!routes), take(1), map((routeList) => {
            return this.getFilteredExistingRouteNames('', routeList);
        }));
    }
    initForm() {
        this.stageShipmentForm = this.fb.group({
            [StageShipmentsNewFormFields.RouteType]: [this.defaultAssignType],
            [StageShipmentsNewFormFields.ExistingRouteNbr]: [
                '',
                [
                    XpoLtlDynamicValidator(() => this.isAssignType(StageShipmentAssignType.Existing), Validators.required),
                    XpoLtlDynamicValidator(() => this.isAssignType(StageShipmentAssignType.Existing), () => this.validateExistingRouteInput()),
                ],
            ],
            [StageShipmentsNewFormFields.RouteCategoryCd]: [null],
            [StageShipmentsNewFormFields.PndTripDate]: [this.planMinDate],
            [StageShipmentsNewFormFields.NewRouteAreaPrefix]: [
                '',
                [
                    XpoLtlDynamicValidator(() => this.isAssignType([StageShipmentAssignType.Planning, StageShipmentAssignType.PnD]), Validators.required),
                    XpoLtlDynamicValidator(() => this.isAssignType([StageShipmentAssignType.Planning, StageShipmentAssignType.PnD]), () => this.validateNewRouteAreaInput()),
                ],
            ],
            [StageShipmentsNewFormFields.NewRouteSuffix]: [
                '',
                [
                    XpoLtlDynamicValidator(() => this.isAssignType([StageShipmentAssignType.Planning, StageShipmentAssignType.PnD]), Validators.required),
                ],
            ],
        });
        this.stageShipmentAssignTypeCtrl = this.stageShipmentForm.controls[StageShipmentsNewFormFields.RouteType];
        this.existingRouteNameCtrl = this.stageShipmentForm.controls[StageShipmentsNewFormFields.ExistingRouteNbr];
        this.routeCategoryCdCtrl = this.stageShipmentForm.controls[StageShipmentsNewFormFields.RouteCategoryCd];
        this.planDateCtrl = this.stageShipmentForm.controls[StageShipmentsNewFormFields.PndTripDate];
        this.routeAreaPrefixCtrl = this.stageShipmentForm.controls[StageShipmentsNewFormFields.NewRouteAreaPrefix];
        this.routeSuffixCtrl = this.stageShipmentForm.controls[StageShipmentsNewFormFields.NewRouteSuffix];
        this.formGroupDirective.form.addControl(StageShipmentFormGroupName.name, this.stageShipmentForm);
    }
    initExternalWatchers() {
        combineLatest([this.showDontAssignRadioButton$, this.showAssignRadioButtons$]).subscribe(this.handleRadioButtonFlags.bind(this));
        this.stageShipmentAssignTypeCtrl.valueChanges.subscribe(this.handleshipmentAssingType.bind(this));
    }
    handleRadioButtonFlags([showDontAssignRadioButton, showAssignRadioButtons]) {
        if (showDontAssignRadioButton && showAssignRadioButtons) {
            this.stageShipmentAssignTypeCtrl.setValue(StageShipmentAssignType.None);
            return;
        }
        if (!showDontAssignRadioButton && showAssignRadioButtons) {
            this.stageShipmentAssignTypeCtrl.setValue(StageShipmentAssignType.Existing);
            return;
        }
        if (!showDontAssignRadioButton && !showAssignRadioButtons) {
            this.stageShipmentAssignTypeCtrl.reset(StageShipmentAssignType.None);
            return;
        }
    }
    handleshipmentAssingType(shipmentAssignType) {
        this.stageShipmentService.setShipmentAssignType(shipmentAssignType);
    }
    initFormWatchers() {
        this.routeType$ = this.stageShipmentAssignTypeCtrl.valueChanges.pipe(map((ans) => ans));
        this.isAssigningRoute$ = this.stageShipmentAssignTypeCtrl.valueChanges.pipe(map(() => {
            return !this.isAssignType(StageShipmentAssignType.None);
        }), startWith(this.defaultAssignType !== StageShipmentAssignType.None));
        this.isExistingRouteAssignment$ = this.isAssigningRoute$.pipe(map(() => {
            return this.isAssignType(StageShipmentAssignType.Existing);
        }));
        this.isNewRouteAssignment$ = this.isAssigningRoute$.pipe(map(() => {
            return this.isAssignType([StageShipmentAssignType.Planning, StageShipmentAssignType.PnD]);
        }));
        this.isLoading$ = this.stageShipmentsService.loading$;
        this.isNewPndRouteAssignment$ = this.isAssigningRoute$.pipe(map(() => {
            return this.isAssignType(StageShipmentAssignType.PnD);
        }));
        merge(this.isExistingRouteAssignment$, this.isNewRouteAssignment$)
            .pipe(takeUntil(this.unsubscriber.done$), filter((value) => !!value), debounceTime(100))
            .subscribe(() => {
            const element = this.newRouteAreaInput || this.existingRouteInput;
            if (element) {
                element.nativeElement.focus();
            }
        });
        this.filteredNewRouteAreaNames$ = merge(this.routeAreaPrefixCtrl.valueChanges, this.newRouteAreasList$.pipe(filter((routes) => !!routes), take(1), map(() => this.routeAreaPrefixCtrl.value))).pipe(withLatestFrom(this.newRouteAreasList$), filter(() => this.isAssignType([StageShipmentAssignType.Planning, StageShipmentAssignType.PnD])), map(([value, routeList]) => {
            return this.getFilteredNewRouteAreas(routeList, value);
        }));
        this.filteredExistingRouteNamesForSic$ = merge(this.existingRouteNameCtrl.valueChanges.pipe(distinctUntilChanged()), this.stageShipmentsService.existingRoutesSummaries$.pipe(filter((routes) => !!routes), take(1), map(() => this.existingRouteNameCtrl.value))).pipe(withLatestFrom(this.stageShipmentsService.existingRoutesSummaries$), map(([value, routeList]) => {
            const filteredRouteNames = this.getFilteredExistingRouteNames(value, routeList);
            // console.table(filteredRouteNames);
            return filteredRouteNames;
        }));
        this.stageShipmentAssignTypeCtrl.valueChanges
            .pipe(distinctUntilChanged(), takeUntil(this.unsubscriber.done$))
            .subscribe((assignType) => {
            this.stageShipmentService.assignType = assignType;
            this.updateControlsOnAssignTypeUpdate(assignType);
        });
        this.routeAreaPrefixCtrl.statusChanges.pipe(debounceTime(50), takeUntil(this.unsubscriber.done$)).subscribe(() => {
            this.updateSuffixOnPrefixUpdate();
        });
        this.planDateCtrl.valueChanges
            .pipe(skip(1), // skips initial setting of value
        distinctUntilChanged((a, b) => {
            return moment$3(a).format('YYYY-MM-DD') === moment$3(b).format('YYYY-MM-DD');
        }), takeUntil(this.unsubscriber.done$))
            .subscribe((planDate) => {
            this.updateFormValidity();
            this.stageShipmentsService
                .fetchSuggestedRouteNames$(this.currentSic, planDate)
                .pipe(takeUntil(this.unsubscriber.done$))
                .subscribe();
        });
    }
    updateSuffixOnPrefixUpdate() {
        const area = (this.routeAreaPrefixCtrl.value || '').toUpperCase();
        const categoryCd = this.routeCategoryCdCtrl.value;
        const suggestedRoute = find(this.stageShipmentsService.suggestedRouteNames, (s) => s.categoryCd === categoryCd &&
            (s.geoArea.geoAreaName === area || `${s.geoArea.geoAreaName}/${s.geoArea.sicCd}` === area));
        this.routeSuffixCtrl.setValue(suggestedRoute ? suggestedRoute.suggestedSuffix : '1');
    }
    updateControlsOnAssignTypeUpdate(assignType) {
        this.existingRouteNameCtrl.reset();
        this.routeAreaPrefixCtrl.reset();
        this.routeSuffixCtrl.reset();
        this.planDateCtrl.reset(moment$3()
            .startOf('day')
            .toDate());
        this.setNewRouteAreasList(assignType);
        switch (assignType) {
            case StageShipmentAssignType.PnD:
            case StageShipmentAssignType.Existing: {
                this.routeCategoryCdCtrl.setValue(RouteCategoryCd.DELIVERY);
                break;
            }
            case StageShipmentAssignType.Planning: {
                this.routeCategoryCdCtrl.setValue(RouteCategoryCd.PLANNING);
                break;
            }
            case StageShipmentAssignType.None: {
                this.routeCategoryCdCtrl.setValue(undefined);
                break;
            }
        }
        this.updateFormValidity();
    }
    isAssignType(assignTypes) {
        const currentAssignType = this.stageShipmentAssignTypeCtrl
            ? this.stageShipmentAssignTypeCtrl.value
            : this.defaultAssignType;
        return some(castArray(assignTypes), (type) => type === currentAssignType);
    }
    setNewRouteAreasList(assignType) {
        let newRouteGeoAreas = [];
        if (assignType === StageShipmentAssignType.PnD) {
            const planningRoutesPrefixMap = countBy(this.PLANNING_ROUTE_PREFIXES);
            newRouteGeoAreas = reduce(this.stageShipmentsService.suggestedRouteNames, (routeGeoAreasList, suggestedRouteName) => {
                if (!planningRoutesPrefixMap[get(suggestedRouteName, 'geoArea.geoAreaName')]) {
                    routeGeoAreasList.push(suggestedRouteName.geoArea);
                }
                return routeGeoAreasList;
            }, []);
        }
        else if (assignType === StageShipmentAssignType.Planning) {
            newRouteGeoAreas = this.PLANNING_ROUTE_PREFIXES.map((geoAreaName) => (Object.assign(Object.assign({}, new GeoArea()), { geoAreaName })));
        }
        this.newRouteAreasListSubject.next(newRouteGeoAreas);
    }
    getRouteStatus(route) {
        let routeStatus = '';
        if ((route === null || route === void 0 ? void 0 : route.statusCd) === RouteStatusCd.DISPATCHED) {
            routeStatus = (route === null || route === void 0 ? void 0 : route.cartageTripInd) ? 'Dispatched-CRTG' : 'Dispatched';
        }
        else if ((route === null || route === void 0 ? void 0 : route.statusCd) === RouteStatusCd.RETURNING) {
            routeStatus = (route === null || route === void 0 ? void 0 : route.cartageTripInd) ? 'Returning-CRTG' : 'Returning';
        }
        else {
            routeStatus = (route === null || route === void 0 ? void 0 : route.cartageTripInd) ? 'Cartage' : '';
        }
        return routeStatus;
    }
    getFilteredExistingRouteNames(filterValue, routes) {
        var _a, _b;
        const valueLower = !!filterValue ? filterValue.toLowerCase() : '';
        let isUserTyping = false;
        if (routes) {
            this.existingRouteSummary = routes;
        }
        else {
            routes = this.existingRouteSummary;
            isUserTyping = true;
        }
        let existingRoutesArr = [];
        routes === null || routes === void 0 ? void 0 : routes.forEach((route) => {
            const existingRoute = new ExistingRouteType();
            existingRoute.routeName = `${route.routePrefix}-${route.routeSuffix}`;
            existingRoute.routeStatus = this.getRouteStatus(route);
            existingRoute.divider = false;
            existingRoutesArr.push(existingRoute);
        });
        existingRoutesArr =
            filterValue !== ''
                ? existingRoutesArr.filter((route) => route.routeName.toLowerCase().includes(valueLower))
                : existingRoutesArr;
        const newOrCartageRoutes = (_a = [
            ...existingRoutesArr.filter((r) => { var _a; return !r.routeStatus || ((_a = r.routeStatus) === null || _a === void 0 ? void 0 : _a.length) === 0 || r.routeStatus === 'Cartage'; }),
        ]) === null || _a === void 0 ? void 0 : _a.sort((a, b) => a.routeName.localeCompare(b.routeName));
        const allOtherRoutes = (_b = [
            ...existingRoutesArr.filter((r) => { var _a; return ((_a = r.routeStatus) === null || _a === void 0 ? void 0 : _a.length) > 0 && r.routeStatus !== 'Cartage'; }),
        ]) === null || _b === void 0 ? void 0 : _b.sort((a, b) => a.routeName.localeCompare(b.routeName));
        if ((newOrCartageRoutes === null || newOrCartageRoutes === void 0 ? void 0 : newOrCartageRoutes.length) > 0 && (allOtherRoutes === null || allOtherRoutes === void 0 ? void 0 : allOtherRoutes.length) > 0) {
            newOrCartageRoutes[newOrCartageRoutes.length - 1].divider = true;
        }
        const routeNames = [...newOrCartageRoutes, ...allOtherRoutes];
        if (isUserTyping) {
            this.filteredExistingRouteNamesForSic$ = of(routeNames);
        }
        return routeNames;
    }
    getFilteredNewRouteAreas(newRouteAreasList, value) {
        const prefixValueLower = !!value ? value.toLowerCase() : '';
        const geoAreaKeyMap = countBy(newRouteAreasList, 'geoAreaName');
        const filteredNewRouteAreaNames = reduce(newRouteAreasList, (mappedGeoAreaNames, { areaInstId, geoAreaName, sicCd }) => {
            var _a, _b;
            let mappedGeoAreaName;
            // if duplicate geo area name exists, add sic code to string
            if (!geoAreaName) {
                mappedGeoAreaName = undefined;
            }
            else if (geoAreaKeyMap[geoAreaName] > 1) {
                mappedGeoAreaName = `${geoAreaName}/${sicCd}`;
            }
            else {
                mappedGeoAreaName = geoAreaName;
            }
            const isMatchingGeoAreaName = mappedGeoAreaName && mappedGeoAreaName.toLowerCase().indexOf(prefixValueLower) === 0;
            const isPreferredGeoArea = ((_a = this.shipmentData) === null || _a === void 0 ? void 0 : _a.areaInstId) && ((_b = this.shipmentData) === null || _b === void 0 ? void 0 : _b.areaInstId) === parseInt(areaInstId, 10);
            // if prefix is empty, or is matching geo area, add to array and depending on if it is a preferred
            // geo area, add it to the beginning or end of the list
            if (!value || isMatchingGeoAreaName) {
                isPreferredGeoArea
                    ? mappedGeoAreaNames.unshift(mappedGeoAreaName)
                    : mappedGeoAreaNames.push(mappedGeoAreaName);
            }
            return mappedGeoAreaNames;
        }, []);
        return filteredNewRouteAreaNames;
    }
    hasErrors(formField) {
        if (!this.stageShipmentForm) {
            return false;
        }
        return !!this.stageShipmentForm.get(formField).errors;
    }
    hasError(formField, errorKey) {
        const control = this.stageShipmentForm.get(formField);
        return control && control.enabled && control.hasError(errorKey);
    }
    updateFormValidity() {
        // updateValueAndValidity doesn't update child form controls so we need to loop
        // through each control and then validate the parent group when done
        forEach(this.stageShipmentForm.controls, (formControl) => {
            formControl.updateValueAndValidity({ onlySelf: true });
        });
        this.stageShipmentForm.updateValueAndValidity();
    }
    validateExistingRouteInput() {
        const value = this.existingRouteNameCtrl.value;
        if (!value) {
            return null;
        }
        const item = this.stageShipmentsService.existingRouteSummaries.find(({ routePrefix, routeSuffix }) => {
            const formattedRouteName = `${routePrefix}-${routeSuffix}`.toUpperCase();
            return formattedRouteName === value.toUpperCase();
        });
        return item ? null : { invalid: true };
    }
    validateNewRouteAreaInput() {
        if (!this.routeAreaPrefixCtrl || !this.routeAreaPrefixCtrl.value) {
            return null;
        }
        const prefixValue = toUpper(this.stageShipmentForm.get(StageShipmentsNewFormFields.NewRouteAreaPrefix).value);
        const item = find(this.newRouteAreasList, (newRouteArea) => {
            return ((newRouteArea.geoAreaName === prefixValue &&
                filter$1(this.newRouteAreasList, (geoArea) => geoArea.geoAreaName === prefixValue).length === 1) ||
                `${newRouteArea.geoAreaName}/${newRouteArea.sicCd}` === prefixValue);
        });
        return item ? null : { invalid: true };
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
}
StageShipmentFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentFormComponent, deps: [{ token: StageShipmentService }, { token: i2$2.FormBuilder }, { token: StageShipmentsService }, { token: i2$2.FormGroupDirective }], target: i0.ɵɵFactoryTarget.Component });
StageShipmentFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: StageShipmentFormComponent, selector: "xpo-ltl-stage-shipment-form", viewQueries: [{ propertyName: "newRouteAreaInput", first: true, predicate: ["newRouteAreaInput"], descendants: true }, { propertyName: "existingRouteInput", first: true, predicate: ["existingRouteInput"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"stageShipmentForm\">\n  <form [formGroup]=\"stageShipmentForm\">\n    <div class=\"stage-shipment-form__sic\" *ngIf=\"stageShipmentAssignTypeCtrl.value !== StageShipmentAssignType.None\">\n      <div class=\"stage-shipment-form__sic__text\">\n        <span>Shipments are available for routing at the Destination SIC here: </span>\n      </div>\n      <div class=\"stage-shipment-form__sic__switcher\">\n        <xpo-ltl-sic-switcher\n          #sicSwitcher\n          [sicCd]=\"currentSIC$ | async\"\n          (sicChange)=\"handleSicChanged($event?.sicCd)\"\n        ></xpo-ltl-sic-switcher>\n      </div>\n    </div>\n\n    <hr\n      *ngIf=\"(showDontAssignRadioButton$ | async) || (showAssignRadioButtons$ | async)\"\n      [ngClass]=\"{ 'hr-divider': stageShipmentAssignTypeCtrl.value !== StageShipmentAssignType.None }\"\n    />\n\n    <div>\n      <mat-radio-group\n        class=\"stage-shipment-form__routeType-options\"\n        [formControlName]=\"StageShipmentsNewFormFields.RouteType\"\n      >\n        <ng-container *ngIf=\"showDontAssignRadioButton$ | async\">\n          <mat-radio-button [value]=\"StageShipmentAssignType.None\">\n            Don't assign to any Route\n          </mat-radio-button>\n        </ng-container>\n        <ng-container *ngIf=\"showAssignRadioButtons$ | async\">\n          <mat-radio-button [value]=\"StageShipmentAssignType.Existing\">\n            Existing Route\n          </mat-radio-button>\n\n          <mat-radio-button [value]=\"StageShipmentAssignType.PnD\">\n            Create P&D Route\n          </mat-radio-button>\n\n          <mat-radio-button [value]=\"StageShipmentAssignType.Planning\">\n            Create Planning Route\n          </mat-radio-button>\n        </ng-container>\n      </mat-radio-group>\n    </div>\n\n    <ng-container *ngIf=\"routeType$ | async as routeType\">\n      <div\n        class=\"stage-shipment-form__routeType-fields\"\n        [ngClass]=\"{\n          'col-1': routeType == StageShipmentAssignType.Existing,\n          'col-2': routeType == StageShipmentAssignType.Planning,\n          'col-3': routeType == StageShipmentAssignType.PnD\n        }\"\n      >\n        <ng-container [ngSwitch]=\"routeType\">\n          <ng-container *ngSwitchCase=\"StageShipmentAssignType.None\">\n            <ng-container *ngTemplateOutlet=\"None\"></ng-container>\n          </ng-container>\n          <ng-container *ngSwitchCase=\"StageShipmentAssignType.Existing\">\n            <ng-container *ngTemplateOutlet=\"Existing\"></ng-container>\n          </ng-container>\n          <ng-container *ngSwitchCase=\"StageShipmentAssignType.PnD\">\n            <ng-container *ngTemplateOutlet=\"PnD; context: { routeType: routeType }\"></ng-container>\n          </ng-container>\n          <ng-container *ngSwitchCase=\"StageShipmentAssignType.Planning\">\n            <ng-container *ngTemplateOutlet=\"PnD; context: { routeType: routeType }\"></ng-container>\n          </ng-container>\n        </ng-container>\n      </div>\n    </ng-container>\n\n    <!-- Templates -->\n\n    <ng-template #None></ng-template>\n\n    <ng-template #Existing>\n      <mat-form-field floatLabel=\"always\" class=\"stage-shipment-form__routeName\">\n        <mat-label>Route #</mat-label>\n        <input\n          #existingRouteInput\n          matInput\n          type=\"text\"\n          autocomplete=\"off\"\n          maxlength=\"15\"\n          [formControlName]=\"StageShipmentsNewFormFields.ExistingRouteNbr\"\n          [matAutocomplete]=\"existingRouteAutocomplete\"\n        />\n        <mat-autocomplete autoActiveFirstOption #existingRouteAutocomplete=\"matAutocomplete\">\n          <mat-option\n            *ngFor=\"let existingRoute of filteredExistingRouteNamesForSic$ | async\"\n            [value]=\"existingRoute?.routeName\"\n          >\n            <div\n              class=\"stage-shipment-form__option-width\"\n              [ngClass]=\"{\n                'two-column-option__divider': !!existingRoute?.divider,\n                'two-column-option': !existingRoute?.divider\n              }\"\n            >\n              <div>{{ existingRoute?.routeName }}</div>\n              <div>{{ existingRoute?.routeStatus }}</div>\n            </div>\n          </mat-option>\n        </mat-autocomplete>\n        <mat-error *ngIf=\"hasErrors(StageShipmentsNewFormFields.ExistingRouteNbr)\">\n          <div *ngIf=\"hasError(StageShipmentsNewFormFields.ExistingRouteNbr, 'required')\">\n            Required\n          </div>\n          <div *ngIf=\"hasError(StageShipmentsNewFormFields.ExistingRouteNbr, 'invalid')\">Invalid</div>\n        </mat-error>\n      </mat-form-field>\n    </ng-template>\n\n    <ng-template #PnD let-routeType=\"routeType\">\n      <mat-form-field floatLabel=\"always\" xpoDatePicker *ngIf=\"routeType == StageShipmentAssignType.PnD\">\n        <mat-label>Trip Date</mat-label>\n        <input\n          matInput\n          [formControlName]=\"StageShipmentsNewFormFields.PndTripDate\"\n          [min]=\"planMinDate\"\n          [max]=\"planMaxDate\"\n          [matDatepicker]=\"datePickerInput\"\n        />\n        <mat-datepicker-toggle matSuffix [for]=\"datePickerInput\">\n          <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>\n        </mat-datepicker-toggle>\n        <mat-datepicker #datePickerInput></mat-datepicker>\n      </mat-form-field>\n\n      <mat-form-field floatLabel=\"always\">\n        <input\n          #newRouteAreaInput\n          maxlength=\"9\"\n          type=\"text\"\n          placeholder=\"Prefix\"\n          aria-label=\"Prefix\"\n          matInput\n          autocomplete=\"off\"\n          [xpo-allow-characters]=\"characterPattern | toRegex\"\n          [formControlName]=\"StageShipmentsNewFormFields.NewRouteAreaPrefix\"\n          [matAutocomplete]=\"newRouteAreaAutocomplete\"\n          class=\"xpo-StageShipment__uppercase\"\n        />\n        <mat-autocomplete autoActiveFirstOption #newRouteAreaAutocomplete=\"matAutocomplete\">\n          <ng-container *ngFor=\"let newRouteAreaName of filteredNewRouteAreaNames$ | async\">\n            <ng-container *ngIf=\"!newRouteAreaName\">\n              <mat-divider></mat-divider>\n            </ng-container>\n            <ng-container *ngIf=\"!!newRouteAreaName\">\n              <mat-option [value]=\"newRouteAreaName\">{{ newRouteAreaName }}</mat-option>\n            </ng-container>\n          </ng-container>\n        </mat-autocomplete>\n        <mat-error *ngIf=\"hasErrors(StageShipmentsNewFormFields.NewRouteAreaPrefix)\">\n          <div *ngIf=\"hasError(StageShipmentsNewFormFields.NewRouteAreaPrefix, 'required')\">Required</div>\n          <div *ngIf=\"hasError(StageShipmentsNewFormFields.NewRouteAreaPrefix, 'invalid')\">Invalid</div>\n        </mat-error>\n      </mat-form-field>\n\n      <mat-form-field floatLabel=\"always\">\n        <input\n          maxlength=\"5\"\n          type=\"text\"\n          placeholder=\"Suffix\"\n          aria-label=\"Suffix\"\n          matInput\n          [xpo-allow-characters]=\"characterNumberPattern | toRegex\"\n          [formControlName]=\"StageShipmentsNewFormFields.NewRouteSuffix\"\n          autocomplete=\"off\"\n          class=\"xpo-StageShipment__uppercase\"\n        />\n        <mat-error *ngIf=\"hasErrors(StageShipmentsNewFormFields.NewRouteSuffix)\">\n          <div *ngIf=\"hasError(StageShipmentsNewFormFields.NewRouteSuffix, 'required')\">Required</div>\n        </mat-error>\n      </mat-form-field>\n    </ng-template>\n  </form>\n</ng-container>\n", styles: [".flex--stretch{flex:1}.stage-shipment-form__sic{display:flex}.stage-shipment-form__sic__text{display:flex;align-items:center}.stage-shipment-form__sic__switcher{flex-grow:0;width:373px}.stage-shipment-form__routeType-options{display:flex;grid-gap:20px}.stage-shipment-form__routeType-fields{display:grid;grid-gap:15px;padding-top:15px}.stage-shipment-form__routeType-fields.col-1{grid-template-columns:180px}.stage-shipment-form__routeType-fields.col-2{grid-template-columns:110px 110px}.stage-shipment-form__routeType-fields.col-3{grid-template-columns:180px 110px 110px}.stage-shipment-form__bold{font-weight:500}.stage-shipment-form__option-width,.stage-shipment-form__routeName{width:280px}.upprCase{text-transform:uppercase}.two-column-option,.two-column-option__divider{display:flex;justify-content:space-between;padding:0 8px}.two-column-option__divider div:nth-child(2),.two-column-option div:nth-child(2){color:#6f6f6f}.two-column-option__divider{border-bottom:6px solid rgba(0,0,0,.12)}.hr-divider{margin-top:0}"], components: [{ type: XpoLtlSicSwitcherComponent, selector: "xpo-ltl-sic-switcher", inputs: ["sicCd", "panelWidth", "sicLabel"], outputs: ["sicChange"] }, { type: i7$1.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i13.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i11.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["tabIndex", "disabled", "for", "aria-label", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i11.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { type: i11$3.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i7$1.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i7.MatLabel, selector: "mat-label" }, { type: i21.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i13.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i2$2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i7.MatError, selector: "mat-error", inputs: ["id"] }, { type: i11.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { type: i7.MatSuffix, selector: "[matSuffix]" }, { type: i11.MatDatepickerToggleIcon, selector: "[matDatepickerToggleIcon]" }, { type: XpoAllowCharactersDirective, selector: "[xpo-allow-characters]", inputs: ["xpo-allow-characters"] }], pipes: { "async": i5.AsyncPipe, "toRegex": ToRegexPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentFormComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-stage-shipment-form',
                    templateUrl: './stage-shipment-form.component.html',
                    styleUrls: ['./stage-shipment-form.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: StageShipmentService }, { type: i2$2.FormBuilder }, { type: StageShipmentsService }, { type: i2$2.FormGroupDirective }]; }, propDecorators: { newRouteAreaInput: [{
                type: ViewChild,
                args: ['newRouteAreaInput', { static: false }]
            }], existingRouteInput: [{
                type: ViewChild,
                args: ['existingRouteInput', { static: false }]
            }] } });

var FORM_GROUP_NAME;
(function (FORM_GROUP_NAME) {
    FORM_GROUP_NAME["StageShipmentForm"] = "stageShipmentForm";
})(FORM_GROUP_NAME || (FORM_GROUP_NAME = {}));
class StageShipmentPanelComponent {
    constructor(data, dialogRef, stageShipmentService, fb, formGroupDirective, stageShipmentsService, configManagerService, snackBar, router) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.stageShipmentService = stageShipmentService;
        this.fb = fb;
        this.formGroupDirective = formGroupDirective;
        this.stageShipmentsService = stageShipmentsService;
        this.configManagerService = configManagerService;
        this.snackBar = snackBar;
        this.router = router;
        this.StageShipmentWarningEnum = StageShipmentWarningEnum;
        this.StageShipmentPanelType = StageShipmentPanelType;
        this.shipments = this.stageShipmentService.shipmentData$;
        this.isExceptionShipmentsPresent$ = this.stageShipmentService.isExceptionShipmentsPresent$;
        this.currentSIC$ = this.stageShipmentService.currentSIC$;
        this.panelType$ = this.stageShipmentService.panelType$; // : StageShipmentPanelType = StageShipmentPanelType.unstage;
        this.isLoading$ = this.stageShipmentService.isLoading$;
        this.isSubmitButtonDisabled = this.stageShipmentService.isSubmitButtonEnabled$.pipe(map((flag) => !flag));
        this.actionText$ = new BehaviorSubject('');
        this.warningMessage$ = this.stageShipmentService.warningMessage$;
        this.warningMessageNoSelection$ = this.stageShipmentService.warningMessageNoSelection$;
        this.errorShipments$ = new BehaviorSubject(undefined);
        this.errorShipmentsStr$ = new BehaviorSubject(undefined);
        this.unsubscriber = new Unsubscriber();
        this.defaultAssignType = StageShipmentAssignType.None;
        this.showConfirmButton = true;
        this.form = this.fb.group({});
        this.setWatchers();
        this.loadData();
    }
    ngAfterViewInit() {
        this.setFormListeners();
    }
    setFormListeners() {
        this.stageShipmentForm = this.form.controls[FORM_GROUP_NAME.StageShipmentForm];
        this.canStageShipment$ = this.stageShipmentForm.statusChanges.pipe(map((status) => status === 'VALID'), startWith(this.stageShipmentForm.valid));
    }
    setWatchers() {
        combineLatest([
            this.stageShipmentService.panelType$,
            this.stageShipmentService.shipmentAssignType$,
        ]).pipe(takeUntil(this.unsubscriber.done$), tap((data) => {
            const panelType = data[0];
            this.panelType = panelType;
        })).subscribe(this.handlePanelTypeChange.bind(this));
    }
    loadData() {
        var _a, _b;
        const { data: { shipmentData, source }, } = this;
        this.source = source;
        this.stageShipmentService.loadShipmentData(shipmentData);
        if (shipmentData.length === 1 && this.source === StageShipmentDataSource.globalSearch) {
            this.isNotDispatchedAndNoStatusShipment =
                ((_a = shipmentData[0]) === null || _a === void 0 ? void 0 : _a.statusCd) !== RouteStatusCd.DISPATCHED && !((_b = shipmentData[0]) === null || _b === void 0 ? void 0 : _b.stageableInd);
        }
    }
    handleSubmit() {
        let stageAction$;
        const stageShipmentParams = this.getCurrentStageShipmentParams();
        switch (stageShipmentParams.stageShipmentAssignType) {
            case StageShipmentAssignType.None: {
                if (this.panelType === StageShipmentPanelType.stage) {
                    stageAction$ = this.stageShipmentsService.stageShipment(stageShipmentParams);
                    this.stageShipmentTypeCd = StageShipmentTypeCd.Stage;
                }
                else {
                    stageAction$ = this.stageShipmentsService.unstageShipment(stageShipmentParams);
                    this.stageShipmentTypeCd = StageShipmentTypeCd.Unstage;
                }
                break;
            }
            case StageShipmentAssignType.Existing: {
                stageAction$ = this.stageShipmentsService.assignShipmentsToExistingRoute(stageShipmentParams);
                break;
            }
            case StageShipmentAssignType.PnD:
            case StageShipmentAssignType.Planning: {
                stageAction$ = this.stageShipmentsService.assignShipmentToNewRoute(stageShipmentParams);
                break;
            }
        }
        this.stageShipmentService.setIsLoading(true);
        stageAction$.pipe(take(1), catchError((err) => {
            this.handleError(err, stageShipmentParams);
            return throwError(err);
        }))
            .subscribe((route) => {
            this.stageShipmentService.setIsLoading(false);
            const formattedRouteName = !this.stageShipmentService.isAssignType(StageShipmentAssignType.None)
                ? `${stageShipmentParams.routePrefix}-${stageShipmentParams.routeSuffix}`.toUpperCase()
                : undefined;
            const stageShipmentSuccessParams = {
                shipmentsList: this.getSelectedShipmentsList(),
                assignType: stageShipmentParams.stageShipmentAssignType,
                routeName: formattedRouteName,
                routeStatusCd: get(route, 'statusCd', RouteStatusCd.NEW),
                routeInstId: get(route, 'routeInstId', stageShipmentParams.routeInstId),
                routeCategoryCd: get(route, 'categoryCd', stageShipmentParams.categoryCd),
                routePrefix: stageShipmentParams.routePrefix,
                routeSuffix: stageShipmentParams.routeSuffix,
                routeDate: stageShipmentParams.planDate,
            };
            this.handleStageShipmentActionSuccess(stageShipmentSuccessParams);
            this.dialogRef.close(true);
        });
    }
    handleCleanSubmit(shipments) {
        const proNbrs = shipments.map((shipment) => shipment.proNbr);
        this.stageShipmentService.setIsLoading(true);
        this.errorShipments$.next(undefined);
        this.errorShipmentsStr$.next(undefined);
        of(undefined).pipe(delay(500)).subscribe(() => {
            this.stageShipmentService.deselectShipments(proNbrs).subscribe(() => {
                this.handleSubmit();
            });
        });
    }
    cancel() {
        this.dialogRef.close(false);
    }
    handleError(error, stageShipmentParams) {
        this.stageShipmentService.setIsLoading(false);
        const errorStr = this.getErrorMessageStr(error);
        if (errorStr) {
            const shipmentsInString = this.getShipmentsInString(errorStr);
            if (shipmentsInString.length) {
                this.displayHandlingErrorDialog(shipmentsInString, stageShipmentParams);
            }
            else {
                this.dialogRef.close(true);
            }
        }
    }
    displayHandlingErrorDialog(shipments, stageShipmentParams) {
        this.errorShipments$.next(shipments);
        const errorShipmentsStr = shipments.map((shipment) => shipment.shipment).join();
        this.errorShipmentsStr$.next(errorShipmentsStr);
        const shipmentsInReq = stageShipmentParams.shipmentData;
        this.showConfirmButton = shipmentsInReq.length !== shipments.length;
    }
    getErrorMessageStr(error) {
        var _a;
        const errorObj = error.error || error;
        let errorString = '';
        if (errorObj === null || errorObj === void 0 ? void 0 : errorObj.message) {
            errorString = errorString.concat(errorObj.message);
        }
        if ((_a = errorObj === null || errorObj === void 0 ? void 0 : errorObj.moreInfo) === null || _a === void 0 ? void 0 : _a.length) {
            errorObj.moreInfo.forEach((message) => (errorString = errorString.concat(message.message || message)));
        }
        errorString = errorString.replace(/ /g, '');
        return errorString;
    }
    handlePanelTypeChange(data) {
        this.updateSubmitButtonText(data[0], data[1]);
    }
    updateSubmitButtonText(panelType, assignType) {
        let actionText = StageShipmentButtonMap[panelType];
        if (!!assignType) {
            if (assignType === StageShipmentAssignType.None) {
                if (this.panelType === StageShipmentPanelType.stage) {
                    actionText = StageShipmentButtonMap[StageShipmentPanelType.stage];
                }
                else {
                    actionText = StageShipmentButtonMap[StageShipmentPanelType.unstage];
                }
            }
            else {
                actionText = StageShipmentButtonMap[StageShipmentPanelType.assign];
            }
        }
        this.actionText$.next(actionText);
    }
    getCurrentStageShipmentParams() {
        const stageShipmentAssignTypeCtrl = this.stageShipmentForm.controls[StageShipmentsNewFormFields.RouteType];
        const routeCategoryCdCtrl = this.stageShipmentForm.controls[StageShipmentsNewFormFields.RouteCategoryCd];
        const planDateCtrl = this.stageShipmentForm.controls[StageShipmentsNewFormFields.PndTripDate];
        const route = this.stageShipmentService.isAssignType(StageShipmentAssignType.Existing)
            ? this.stageShipmentForm.get(StageShipmentsNewFormFields.ExistingRouteNbr).value
            : `${this.stageShipmentForm.get(StageShipmentsNewFormFields.NewRouteAreaPrefix).value}-${this.stageShipmentForm.get(StageShipmentsNewFormFields.NewRouteSuffix).value}`.toUpperCase();
        const routeSuffix = route.split('-')[1];
        let routePrefix = route.split('-')[0];
        // For duplicate areas we add the /<SIC/ZoneSic> so we need to split that out.
        if (routePrefix.indexOf('/') > 0) {
            routePrefix = routePrefix.split('/')[0];
        }
        const matchingExistingRoute = find(this.stageShipmentsService.existingRouteSummaries, (existingRoute) => {
            return existingRoute.routePrefix === routePrefix && existingRoute.routeSuffix === routeSuffix;
        });
        const matchingSuggestedRoute = find(this.stageShipmentsService.suggestedRouteNames, (suggestedRouteName) => {
            return suggestedRouteName.geoArea.geoAreaName === routePrefix;
        });
        const params = {
            stageShipmentType: this.stageShipmentTypeCd,
            stageShipmentAssignType: stageShipmentAssignTypeCtrl.value,
            categoryCd: routeCategoryCdCtrl.value,
            routePrefix: routePrefix,
            routeSuffix: routeSuffix,
            routeInstId: matchingExistingRoute ? matchingExistingRoute.routeInstId : undefined,
            terminalSicCd: this.stageShipmentService.currentSIC,
            shipmentData: this.getSelectedShipmentsList(),
            areaInstId: matchingSuggestedRoute ? +matchingSuggestedRoute.geoArea.areaInstId : undefined,
            planDate: moment$2(planDateCtrl.value).format('YYYY-MM-DD'),
        };
        return params;
    }
    handleStageShipmentActionSuccess(stageShipmentSuccessParams) {
        const performedViewActionSubject = new Subject();
        let successLinkAction; // the proper typing is not exported from core library
        const isUnstageAction = stageShipmentSuccessParams.assignType === StageShipmentAssignType.None &&
            this.stageShipmentTypeCd === StageShipmentTypeCd.Unstage;
        const currentAppName = (this.configManagerService.getSetting(ConfigManagerProperties$1.appName) || '').toLowerCase();
        let snackbar;
        if (!isUnstageAction && currentAppName === GlobalSearchAppName.PND_APP) {
            successLinkAction = {
                message: 'View',
                function: () => {
                    performedViewActionSubject.next();
                    snackbar.dismiss();
                    this.openShipmentInPnd(stageShipmentSuccessParams, false);
                },
            };
        }
        snackbar = this.snackBar.open({
            message: this.buildStageShipmentActionSuccessMessage(stageShipmentSuccessParams, isUnstageAction),
            status: 'success',
            matConfig: {
                verticalPosition: 'bottom',
                duration: 5000,
            },
            linkAction: successLinkAction,
        });
        snackbar
            .afterDismissed()
            .pipe(takeUntil(performedViewActionSubject))
            .subscribe(() => {
            if (!isUnstageAction && currentAppName === GlobalSearchAppName.PND_APP) {
                this.openShipmentInPnd(stageShipmentSuccessParams, true);
            }
        });
    }
    buildStageShipmentActionSuccessMessage(params, isUnstage) {
        let successMessage = '';
        if (params.shipmentsList.length === 1) {
            successMessage = `Shipment ${params.shipmentsList[0].proNbr} has been ${isUnstage ? 'unstaged' : 'staged'}`;
        }
        else {
            let shipmentListString = '';
            params.shipmentsList.forEach((singleShipment, index) => {
                if (index === 0) {
                    shipmentListString += `${singleShipment.proNbr}`;
                }
                else {
                    shipmentListString = shipmentListString + ', ' + `${singleShipment.proNbr}`;
                }
            });
            successMessage = `Shipments ${shipmentListString} has been ${isUnstage ? 'unstaged' : 'staged'}`;
        }
        if (!this.stageShipmentService.isAssignType(StageShipmentAssignType.None)) {
            const assignType = params.routeCategoryCd === RouteCategoryCd.PLANNING
                ? StageShipmentAssignType.Planning
                : StageShipmentAssignType.PnD;
            successMessage += ` and assigned to ${assignType} Route ${params.routeName}`;
        }
        successMessage += '.';
        return successMessage;
    }
    openShipmentInPnd(stageShipmentSuccessParams, suppressRowSelection) {
        var _a, _b;
        let stageShipmentPnDStatusCd;
        let globalSearchActionType;
        if (this.stageShipmentService.isAssignType(StageShipmentAssignType.None)) {
            globalSearchActionType = XpoLtlGlobalSearchActionType.PnDStageShipment;
            stageShipmentPnDStatusCd = ShipmentPnDStatusCd.UNASSIGNED;
        }
        else if (this.isNotDispatchedAndNoStatusShipment) {
            globalSearchActionType = XpoLtlGlobalSearchActionType.PnDRouteShipment;
            stageShipmentPnDStatusCd = (_a = stageShipmentSuccessParams === null || stageShipmentSuccessParams === void 0 ? void 0 : stageShipmentSuccessParams.shipmentsList[0]) === null || _a === void 0 ? void 0 : _a.shipmentPnDStatusCd;
        }
        else {
            globalSearchActionType = XpoLtlGlobalSearchActionType.PnDAssignRoute;
            stageShipmentPnDStatusCd = ShipmentPnDStatusCd.ASSIGNED;
        }
        const destinationSicCode = this.stageShipmentService.currentSIC;
        const pndResult = Object.assign(Object.assign({}, new PnDSearchResult()), { consigneeName: '', destinationSicCd: destinationSicCode });
        const shipmentData = this.getSelectedShipmentsList();
        const pndShipment = shipmentData[0];
        if (!suppressRowSelection) {
            pndResult.proNbr = pndShipment.proNbr; // TODO
            pndResult.shipmentInstId = pndShipment.shipmentInstId; // TODO
            pndResult.routePrefix = stageShipmentSuccessParams.routePrefix;
            pndResult.routeSuffix = stageShipmentSuccessParams.routeSuffix;
            pndResult.routeDate = stageShipmentSuccessParams.routeDate;
            pndResult.routeInstId = stageShipmentSuccessParams.routeInstId;
            pndResult.statusCd = stageShipmentSuccessParams.routeStatusCd;
            pndResult.categoryCd = stageShipmentSuccessParams.routeCategoryCd;
            pndResult.shipmentPnDStatusCd = stageShipmentPnDStatusCd;
            pndResult.destinationSicCd = destinationSicCode;
        }
        const globalSearchItem = {
            globalSearchResultType: GlobalSearchResultType.PnDSearchResults,
            data: pndResult,
        };
        const actionPath = (_b = this.data) === null || _b === void 0 ? void 0 : _b.getActionPathFn(globalSearchItem);
        const pathAndQueryParamsArray = actionPath === null || actionPath === void 0 ? void 0 : actionPath.split('?');
        const queryParamsMap = {
            queryId: Math.round(Math.random() * 10000),
            globalSearchActionType: globalSearchActionType,
        };
        if (!!pathAndQueryParamsArray && pathAndQueryParamsArray.length > 1) {
            pathAndQueryParamsArray[pathAndQueryParamsArray.length - 1].split('&').reduce((params, currentParams) => {
                const keyValue = currentParams.split('=');
                params[keyValue[0]] = keyValue[1];
                return params;
            }, queryParamsMap);
        }
        this.router.navigate([`/${pathAndQueryParamsArray[1]}`], {
            queryParams: queryParamsMap,
            replaceUrl: true,
        });
    }
    getSelectedShipmentsList() {
        const selectedShipmentsData = this.stageShipmentService.selectedData;
        const selectedShipmentsList = [];
        if (this.stageShipmentService.isSingleShipment) {
            selectedShipmentsList.push(this.stageShipmentService.shipmentData[0]);
        }
        else {
            if (!!selectedShipmentsData && selectedShipmentsData.length > 0) {
                selectedShipmentsData.forEach((shipment) => {
                    selectedShipmentsList.push(shipment.shipmentData);
                });
            }
        }
        return selectedShipmentsList;
    }
    getShipmentsInString(str) {
        const selectedData = this.stageShipmentService.selectedData || [];
        const shipmentsInString = [];
        selectedData.forEach((shipmentRow) => {
            const { shipment, shipmentData: { proNbr }, } = shipmentRow;
            if (str.includes(proNbr) || str.includes(shipment)) {
                shipmentsInString.push({ shipment, proNbr });
            }
        });
        return shipmentsInString;
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
}
StageShipmentPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentPanelComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$1.MatDialogRef }, { token: StageShipmentService }, { token: i2$2.FormBuilder }, { token: i2$2.FormGroupDirective }, { token: StageShipmentsService }, { token: i2$3.ConfigManagerService }, { token: i3$2.XpoSnackBar }, { token: i6$1.Router }], target: i0.ɵɵFactoryTarget.Component });
StageShipmentPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: StageShipmentPanelComponent, selector: "xpo-ltl-stage-shipment-panel", providers: [StageShipmentService, FormGroupDirective], ngImport: i0, template: "<div class=\"stage-shipment-panel__wrapper\">\n  <form [formGroup]=\"form\">\n    <div class=\"stage-shipment-panel\">\n      <!-- Header section -->\n      <div class=\"stage-shipment-panel__title\">\n        <h1>\n          <ng-container [ngSwitch]=\"panelType$ | async\">\n            <ng-container *ngSwitchCase=\"StageShipmentPanelType.assign\">\n              <ng-container *ngTemplateOutlet=\"assign\"></ng-container>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"StageShipmentPanelType.stage\">\n              <ng-container *ngTemplateOutlet=\"stage\"></ng-container>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"StageShipmentPanelType.unstage\">\n              <ng-container *ngTemplateOutlet=\"unstage\"></ng-container>\n            </ng-container>\n          </ng-container>\n        </h1>\n        <div>\n          <xpo-dialog-close-button></xpo-dialog-close-button>\n        </div>\n      </div>\n      <hr />\n      <div class=\"stage-shipment-panel__content\">\n        <!-- Grid section -->\n        <ng-container *ngIf=\"shipments | async as shipmentsValue\">\n          <xpo-ltl-stage-shipment-grid [shipments]=\"shipmentsValue\" [source]=\"source\"></xpo-ltl-stage-shipment-grid>\n        </ng-container>\n\n        <!-- <ng-container *ngIf=\"isExceptionShipmentsPresent$ | async\">\n          <br />\n          <div>{{ StageShipmentWarningEnum.HAVE_EXCEPTION }}{{ currentSIC$ | async }}</div>\n        </ng-container> -->\n\n        <ng-container *ngIf=\"warningMessage$ | async as warningMessage\">\n          <br />\n          <div>{{ warningMessage }}</div>\n        </ng-container>\n\n        <ng-container *ngIf=\"warningMessageNoSelection$ | async as warningMessageNoSelection\">\n          <br />\n          <div>{{ warningMessageNoSelection }} </div>\n        </ng-container>\n\n        <!-- Form section -->\n        <xpo-ltl-stage-shipment-form></xpo-ltl-stage-shipment-form>\n\n        <ng-container *ngIf=\"isLoading$ | async\">\n          <div class=\"stage-shipment-panel__loader__overlay\"></div>\n          <xpo-busy-loader class=\"stage-shipment-panel__loader\"></xpo-busy-loader>\n        </ng-container>\n      </div>\n    </div>\n\n    <!-- Actions -->\n    <div class=\"stage-shipment-panel__actions\" mat-dialog-actions>\n      <xpo-button-group>\n        <!-- [disabled]=\"!(canStageShipment$ | async) || (isLoading$ | async) || (showSpinner$ | async)\" -->\n        <ng-container *ngIf=\"(actionText$ | async) as actionText\">\n          <button\n            mat-flat-button\n            class=\"supper-case\"\n            (click)=\"handleSubmit()\"\n            [disabled]=\"(isSubmitButtonDisabled | async) || !(canStageShipment$ | async)\"\n          >\n            {{ actionText }}\n          </button>\n        </ng-container>\n\n        <button mat-stroked-button (click)=\"cancel()\">Cancel</button>\n      </xpo-button-group>\n    </div>\n  </form>\n\n  <ng-container *ngIf=\"errorShipments$ | async as shipments\">\n    <!-- Error dialog -->\n    <div class=\"stage-shipment-panel__wrapper__error-dialog\">\n      <div class=\"stage-shipment-panel__wrapper__error-dialog__content\">\n        <ng-container *ngIf=\"showConfirmButton; else noStageTemp\">\n          <h1>Do you want to remove the below PROs and continue to stage the rest?</h1>\n          <div>{{ errorShipmentsStr$ | async }}</div>\n        </ng-container>\n        <ng-template #noStageTemp>\n          <div>No selected PROs can be staged</div>\n        </ng-template>\n        <hr />\n        <div class=\"stage-shipment-panel__wrapper__error-dialog__content__actions\">\n          <button *ngIf=\"showConfirmButton\" mat-flat-button class=\"supper-case\" (click)=\"handleCleanSubmit(shipments)\">\n            Confirm\n          </button>\n\n          <button mat-stroked-button (click)=\"cancel()\">Cancel</button>\n        </div>\n      </div>\n\n    </div>\n  </ng-container>\n  \n</div>\n\n<!-- Title templates -->\n<ng-template #assign>\n  Assign Shipments\n</ng-template>\n\n<ng-template #stage>\n  Stage the selected Shipments?\n</ng-template>\n\n<ng-template #unstage>\n  <svg width=\"22\" height=\"19\" viewBox=\"0 0 22 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M0 19H22L11 0L0 19ZM12 16H10V14H12V16ZM12 12H10V8H12V12Z\" fill=\"#4A4A4A\" />\n  </svg>\n  Unstage the selected Shipments?\n</ng-template>\n", styles: [".stage-shipment-panel{padding:32px;width:1000px}.stage-shipment-panel__title{display:flex}.stage-shipment-panel__title h1{font-size:24px;margin:0;flex-grow:1}.stage-shipment-panel__content{position:relative}.stage-shipment-panel__loader{position:absolute;left:50%;top:50%;width:100px;transform:translate(-50%,-50%);z-index:999}.stage-shipment-panel__loader__overlay{position:absolute;top:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.38);z-index:10}.stage-shipment-panel__wrapper{position:relative}.stage-shipment-panel__wrapper__error-dialog{position:absolute;top:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.5);z-index:10;display:flex}.stage-shipment-panel__wrapper__error-dialog__content{box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);background:#fff;width:75%;margin:auto;padding:20px}.stage-shipment-panel__wrapper__error-dialog__content__actions{display:flex;grid-gap:10px}"], components: [{ type: i3.XpoDialogCloseButtonComponent, selector: "xpo-dialog-close-button" }, { type: StageShipmentGridComponent, selector: "xpo-ltl-stage-shipment-grid", inputs: ["shipments", "source"] }, { type: StageShipmentFormComponent, selector: "xpo-ltl-stage-shipment-form" }, { type: i7$2.XpoBusyLoader, selector: "xpo-busy-loader", inputs: ["slow"] }, { type: i5$3.XpoButtonGroup, selector: "xpo-button-group" }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: i5.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentPanelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-stage-shipment-panel',
                    templateUrl: './stage-shipment-panel.component.html',
                    styleUrls: ['./stage-shipment-panel.component.scss'],
                    providers: [StageShipmentService, FormGroupDirective],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$1.MatDialogRef }, { type: StageShipmentService }, { type: i2$2.FormBuilder }, { type: i2$2.FormGroupDirective }, { type: StageShipmentsService }, { type: i2$3.ConfigManagerService }, { type: i3$2.XpoSnackBar }, { type: i6$1.Router }]; } });

const frameworkComponents = {
    XpoStringFilterComponent,
    // ActionIconCellRendererComponent,
    // StatusIndicatorCellRendererComponent,
};
class StageShipmentModule {
}
StageShipmentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StageShipmentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentModule, declarations: [StageCurrentLocationRendererComponent,
        StageExceptionRendererComponent,
        StageShipmentComponent,
        StageShipmentFormComponent,
        StageShipmentGridComponent,
        StageShipmentPanelComponent,
        StageStatusRendererComponent], imports: [i1$8.AgGridModule, CommonModule,
        FormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatDatepickerModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatTableModule,
        MatTooltipModule,
        ReactiveFormsModule,
        XpoAgGridBoardModule,
        XpoAllowCharactersModule,
        XpoBusyLoaderModule,
        XpoButtonModule,
        XpoDialogModule,
        XpoIconModule,
        XpoLtlPipeModule,
        XpoLtlSicSwitcherModule,
        XpoStatusIndicatorModule], exports: [StageShipmentComponent] });
StageShipmentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentModule, imports: [[
            AgGridModule.withComponents(frameworkComponents),
            CommonModule,
            FormsModule,
            MatAutocompleteModule,
            MatButtonModule,
            MatDatepickerModule,
            MatIconModule,
            MatInputModule,
            MatListModule,
            MatNativeDateModule,
            MatProgressSpinnerModule,
            MatRadioModule,
            MatTableModule,
            MatTooltipModule,
            ReactiveFormsModule,
            XpoAgGridBoardModule,
            XpoAllowCharactersModule,
            XpoBusyLoaderModule,
            XpoButtonModule,
            XpoDialogModule,
            XpoIconModule,
            XpoLtlPipeModule,
            XpoLtlSicSwitcherModule,
            XpoStatusIndicatorModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: StageShipmentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        AgGridModule.withComponents(frameworkComponents),
                        CommonModule,
                        FormsModule,
                        MatAutocompleteModule,
                        MatButtonModule,
                        MatDatepickerModule,
                        MatIconModule,
                        MatInputModule,
                        MatListModule,
                        MatNativeDateModule,
                        MatProgressSpinnerModule,
                        MatRadioModule,
                        MatTableModule,
                        MatTooltipModule,
                        ReactiveFormsModule,
                        XpoAgGridBoardModule,
                        XpoAllowCharactersModule,
                        XpoBusyLoaderModule,
                        XpoButtonModule,
                        XpoDialogModule,
                        XpoIconModule,
                        XpoLtlPipeModule,
                        XpoLtlSicSwitcherModule,
                        XpoStatusIndicatorModule,
                    ],
                    declarations: [
                        StageCurrentLocationRendererComponent,
                        StageExceptionRendererComponent,
                        StageShipmentComponent,
                        StageShipmentFormComponent,
                        StageShipmentGridComponent,
                        StageShipmentPanelComponent,
                        StageStatusRendererComponent,
                    ],
                    exports: [StageShipmentComponent],
                    entryComponents: [
                        StageCurrentLocationRendererComponent,
                        StageExceptionRendererComponent,
                        StageShipmentComponent,
                        StageShipmentPanelComponent,
                        StageStatusRendererComponent,
                    ],
                }]
        }] });

class TrailerManifest {
    constructor(header, shipments) {
        this.header = header;
        this.shipments = shipments;
    }
}

var LoadTypeCd;
(function (LoadTypeCd) {
    LoadTypeCd["Break"] = "B";
    LoadTypeCd["Pure"] = "P";
})(LoadTypeCd || (LoadTypeCd = {}));
var LoadTypeResponse;
(function (LoadTypeResponse) {
    LoadTypeResponse["Break"] = "Break";
    LoadTypeResponse["Pure"] = "Pure/Proper";
})(LoadTypeResponse || (LoadTypeResponse = {}));

class XpoLtlShmTrackingTrailerService {
    constructor(dockOperationsService, shipmentApiService, conditioningService) {
        this.dockOperationsService = dockOperationsService;
        this.shipmentApiService = shipmentApiService;
        this.conditioningService = conditioningService;
        this.trailerManifestSubject = new BehaviorSubject(null);
        this.trailerManifest$ = this.trailerManifestSubject.asObservable();
        this.isLoadingSubject = new BehaviorSubject(false);
        this.isLoading$ = this.isLoadingSubject.asObservable();
        this._dataSearched = new BehaviorSubject(false);
        this.dataSearched$ = this._dataSearched.asObservable();
    }
    searchShipmentTrailer(dialogData) {
        this.trailerManifestSubject.next(null);
        const pathParams = new GetTrailerManifestPath();
        pathParams.requestingSicCd = dialogData.sicCd;
        const queryParams = new GetTrailerManifestQuery();
        queryParams.shiftCd = dialogData.shiftCd;
        queryParams.trailerNbr = dialogData.trailerNbr;
        const retryCount = 3;
        const retryDelay = 500;
        return this.dockOperationsService
            .getTrailerManifest(pathParams, queryParams, { loadingOverlayEnabled: false })
            .pipe(map((resp) => {
            return this.mapShipmentsFromTrailerData(resp, dialogData);
        }), retryWhen((errors) => errors.pipe(mergeMap((err, i) => (i >= retryCount - 1 ? throwError(err) : timer(retryDelay))))), switchMap((manifest) => {
            const loadedShipments = manifest.shipments;
            if (loadedShipments.length > 0) {
                const request = new ListShipmentsRqst();
                request.shipmentIds = loadedShipments.map((shipment) => ({ proNumber: shipment.parentPro }));
                request.shipmentDetailCd = [ShipmentDetailCd.SHIPMENT_PARTIES];
                return this.shipmentApiService.listShipments(request, { loadingOverlayEnabled: false }).pipe(map((response) => {
                    return response;
                }), map((response) => {
                    return new Map(response.shipmentDetails.map((shp) => [shp.shipment.proNbr, shp]));
                }), map((respMap) => {
                    loadedShipments.forEach((loadedShp) => {
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                        const shpDetail = respMap.get(loadedShp.parentPro);
                        if (shpDetail) {
                            loadedShp.parentPro = this.getParentPro((_a = shpDetail === null || shpDetail === void 0 ? void 0 : shpDetail.shipment) === null || _a === void 0 ? void 0 : _a.proNbr);
                            loadedShp.motorMoves = (_b = shpDetail === null || shpDetail === void 0 ? void 0 : shpDetail.shipment) === null || _b === void 0 ? void 0 : _b.motorizedPiecesCount;
                            loadedShp.origin = (_c = shpDetail === null || shpDetail === void 0 ? void 0 : shpDetail.shipment) === null || _c === void 0 ? void 0 : _c.originTerminalSicCd;
                            loadedShp.dest = (_d = shpDetail === null || shpDetail === void 0 ? void 0 : shpDetail.shipment) === null || _d === void 0 ? void 0 : _d.destinationTerminalSicCd;
                            const consignee = this.findConsignee(shpDetail);
                            loadedShp.consignee = consignee ? consignee.name1 : '';
                            loadedShp.address = consignee ? consignee.address : '';
                            loadedShp.city = consignee ? consignee.city : '';
                            loadedShp.weight = (_e = shpDetail === null || shpDetail === void 0 ? void 0 : shpDetail.shipment) === null || _e === void 0 ? void 0 : _e.totalWeightLbs;
                            loadedShp.cubic = (_f = shpDetail === null || shpDetail === void 0 ? void 0 : shpDetail.shipment) === null || _f === void 0 ? void 0 : _f.totalVolumeCubicFeet;
                            loadedShp.guaranteed = this.guaranteedChildPro((_g = shpDetail === null || shpDetail === void 0 ? void 0 : shpDetail.shipment) === null || _g === void 0 ? void 0 : _g.guaranteedInd);
                            loadedShp.hazmat = this.hazmatChildPro((_h = shpDetail === null || shpDetail === void 0 ? void 0 : shpDetail.shipment) === null || _h === void 0 ? void 0 : _h.hazmatInd);
                        }
                    });
                    this.trailerManifestSubject.next(manifest);
                    return manifest;
                }), catchError((err) => {
                    manifest.shipments = [];
                    this.trailerManifestSubject.next(manifest);
                    return of(manifest);
                }));
            }
            else {
                this.trailerManifestSubject.next(manifest);
                return of(manifest);
            }
        }), catchError((err) => {
            return throwError(err);
        }));
    }
    mapShipmentsFromTrailerData(response, dialogData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const trailerHeader = {
            equipment: response === null || response === void 0 ? void 0 : response.trailerNbr,
            loadType: this.getLoadTypeCd((_a = response === null || response === void 0 ? void 0 : response.trailer) === null || _a === void 0 ? void 0 : _a.brkOrProprCd),
            sealNbr: (_b = response === null || response === void 0 ? void 0 : response.trailer) === null || _b === void 0 ? void 0 : _b.sealNbr,
            currentSic: (_c = response === null || response === void 0 ? void 0 : response.equipment) === null || _c === void 0 ? void 0 : _c.currentSic,
            status: `${(_d = response === null || response === void 0 ? void 0 : response.equipment) === null || _d === void 0 ? void 0 : _d.currentSic}/${(_e = response === null || response === void 0 ? void 0 : response.trailer) === null || _e === void 0 ? void 0 : _e.currentStatus}`,
            equipmentOnTrailer: this.getEqipOnTrailer((_f = response === null || response === void 0 ? void 0 : response.trailer) === null || _f === void 0 ? void 0 : _f.liftgateInd),
            operationShift: dialogData.shiftCd,
            weightCubeBills: `${(_g = response === null || response === void 0 ? void 0 : response.totalWeight) === null || _g === void 0 ? void 0 : _g.weight}/${(_h = response === null || response === void 0 ? void 0 : response.trailer) === null || _h === void 0 ? void 0 : _h.loadedCbePercentage}/${response === null || response === void 0 ? void 0 : response.billCount}`,
            loadReleaseNbr: (_j = response === null || response === void 0 ? void 0 : response.trailer) === null || _j === void 0 ? void 0 : _j.loadedReleaseNbr,
            loadOrigin: (_k = response === null || response === void 0 ? void 0 : response.trailer) === null || _k === void 0 ? void 0 : _k.originSic,
            loadDest: (_l = response === null || response === void 0 ? void 0 : response.trailer) === null || _l === void 0 ? void 0 : _l.loadedDestination,
            reportingSic: (_m = response === null || response === void 0 ? void 0 : response.trailer) === null || _m === void 0 ? void 0 : _m.evntDoorSic,
            etaDateTime: this.getEtaDateTime(response),
            closeDateTime: (response === null || response === void 0 ? void 0 : response.trailer.currentStatus) === 'EMTY' ? null : (_o = response === null || response === void 0 ? void 0 : response.trailer) === null || _o === void 0 ? void 0 : _o.closeDateTime,
        };
        const loadedShipments = response === null || response === void 0 ? void 0 : response.loadedShipments;
        const shipmentsData = [];
        loadedShipments.forEach((shipment) => {
            if (!!shipment.proNbr) {
                shipmentsData.push(this.populateTrailerData(shipment));
            }
        });
        const finalData = new TrailerManifest(trailerHeader, shipmentsData);
        this.trailerManifestSubject.next(finalData);
        return finalData;
    }
    populateTrailerData(shipment) {
        return {
            parentPro: this.conditioningService.conditionProNumber(shipment.proNbr, 11),
            motorMoves: null,
            origin: null,
            dest: null,
            consignee: null,
            address: null,
            city: null,
            weight: null,
            cubic: null,
            guaranteed: null,
            hazmat: null,
            trailerChildPros: this.mapChildPros(shipment === null || shipment === void 0 ? void 0 : shipment.handlingUnits),
        };
    }
    findConsignee(shpDetail) {
        if (shpDetail.asMatchedParty && shpDetail.asMatchedParty.length > 0) {
            return shpDetail.asMatchedParty.find((party) => party.typeCd === MatchedPartyTypeCd.CONS);
        }
        else {
            return undefined;
        }
    }
    getParentPro(pro) {
        let proNbr = '';
        proNbr = pro.substring(1, 4) + '-' + pro.substring(5);
        return proNbr;
    }
    guaranteedChildPro(guarantee) {
        const services = [];
        if (!!guarantee) {
            services.push(ShipmentSpecialServiceCd.GUARANTEED);
        }
        return services;
    }
    hazmatChildPro(hazmat) {
        const services = [];
        if (!!hazmat) {
            services.push(ShipmentSpecialServiceCd.HAZMAT);
        }
        return services;
    }
    mapChildPros(handlingUnits) {
        const childHandlingUnits = {
            childPros: [],
        };
        if (!handlingUnits) {
            return childHandlingUnits.childPros;
        }
        forEach(handlingUnits, (handlingUnit) => {
            childHandlingUnits.childPros.push(this.populateChildPros(handlingUnit));
        });
        return childHandlingUnits.childPros;
    }
    populateChildPros(handlingUnit) {
        return {
            childPro: this.getChildPros(handlingUnit === null || handlingUnit === void 0 ? void 0 : handlingUnit.childProNbr),
            currSic: handlingUnit === null || handlingUnit === void 0 ? void 0 : handlingUnit.currentSicCd,
            currLocation: handlingUnit === null || handlingUnit === void 0 ? void 0 : handlingUnit.currentDockLocation,
            type: handlingUnit === null || handlingUnit === void 0 ? void 0 : handlingUnit.handlingMovementCd,
            pickupDate: handlingUnit === null || handlingUnit === void 0 ? void 0 : handlingUnit.pickupDate,
            weight: handlingUnit === null || handlingUnit === void 0 ? void 0 : handlingUnit.weightLbs,
            cubicChild: handlingUnit === null || handlingUnit === void 0 ? void 0 : handlingUnit.volumeCubicFeet,
        };
    }
    getChildPros(childPro) {
        let childProNbr = '';
        childProNbr = childPro.substring(1, 5) + '-' + childPro.substring(5);
        return childProNbr;
    }
    getLoadTypeCd(code) {
        if (code === LoadTypeCd.Break) {
            return LoadTypeResponse.Break;
        }
        if (code === LoadTypeCd.Pure) {
            return LoadTypeResponse.Pure;
        }
    }
    getEqipOnTrailer(resp) {
        return resp ? 'Yes' : 'No';
    }
    getEtaDateTime(resp) {
        var _a;
        const shipments = resp === null || resp === void 0 ? void 0 : resp.loadedShipments;
        return (_a = shipments.find((shp) => !!shp.etaDateTime)) === null || _a === void 0 ? void 0 : _a.etaDateTime;
    }
    clear() {
        this.trailerManifestSubject.next(null);
    }
}
XpoLtlShmTrackingTrailerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShmTrackingTrailerService, deps: [{ token: i1$c.DockOperationsApiService }, { token: i2$6.ShipmentApiService }, { token: i3$1.ConditioningService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlShmTrackingTrailerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShmTrackingTrailerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShmTrackingTrailerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$c.DockOperationsApiService }, { type: i2$6.ShipmentApiService }, { type: i3$1.ConditioningService }]; } });

class ShipmentTrackingTrailerComponent {
    constructor() { }
    set trailerManifest(value) {
        this._trailerManifest = value;
    }
    get trailerManifest() {
        return this._trailerManifest;
    }
}
ShipmentTrackingTrailerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentTrackingTrailerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ShipmentTrackingTrailerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentTrackingTrailerComponent, selector: "xpo-shipment-trailer-overview", inputs: { trailerManifest: "trailerManifest" }, ngImport: i0, template: "<ng-container *ngIf=\"trailerManifest\">\n  <div class=\"ShipmentTrackingTrailerOverview\">\n    <div class=\"ShipmentTrackingTrailerOverview__content\">\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Equipment\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.equipment }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Load Type\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.loadType }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Seal Number\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.sealNbr }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Current SIC\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.currentSic }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Status\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.status }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Equipment on Trailer\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.equipmentOnTrailer }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Operation Shift\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.operationShift }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Weight/Cube/Biils\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.weightCubeBills }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Load Release Nbr\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.loadReleaseNbr }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Load Origin\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.loadOrigin }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Load Destination\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.loadDest }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Reporting SIC\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.reportingSic }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          ETA Date/Time\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.etaDateTime | date: 'medium' }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Close Date/Time\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          {{ trailerManifest?.header.closeDateTime | date: 'medium' }}\n          <ng-content></ng-content>\n        </div>\n      </div>\n    </div>\n    <hr />\n    <div class=\"ShipmentTrackingTrailerOverview__content-info\">\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Head Load Destination\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          -\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Packaging Type\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          -\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Weight\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          -\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Cube\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          -\n          <ng-content></ng-content>\n        </div>\n      </div>\n      <div class=\"ShipmentTrackingTrailerOverview__column\">\n        <div class=\"ShipmentTrackingTrailerOverview__label\">\n          Feet\n        </div>\n        <div class=\"ShipmentTrackingTrailerOverview__value\">\n          -\n          <ng-content></ng-content>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n", styles: [".flex--stretch{flex:1}.ShipmentTrackingTrailerOverview{background-color:#fafafa}.ShipmentTrackingTrailerOverview__content{padding-top:20px}.ShipmentTrackingTrailerOverview__content,.ShipmentTrackingTrailerOverview__content-info{display:flex;flex:1 1 auto;flex-direction:row;flex-wrap:wrap;padding-left:20px}.ShipmentTrackingTrailerOverview__column{flex:0 0 15%;margin-bottom:10px}.ShipmentTrackingTrailerOverview__label{display:flex;flex:1 1 auto;flex-direction:column;color:#4a4a4a;font-size:12px;font-weight:500;letter-spacing:.25px;line-height:24px;height:auto}.ShipmentTrackingTrailerOverview__value{display:flex;flex:1 1 auto;flex-direction:column;color:#4a4a4a;font-size:14px;letter-spacing:.29px;line-height:20px;height:auto}"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "date": i5.DatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentTrackingTrailerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-shipment-trailer-overview',
                    templateUrl: './shipment-trailer-overview.component.html',
                    styleUrls: ['./shipment-trailer-overview.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { trailerManifest: [{
                type: Input
            }] } });

class SpecialServComponent {
    constructor() {
        this.marks = [];
        this.specialServicesSubject = new BehaviorSubject([]);
        this.specialServices$ = this.specialServicesSubject.asObservable();
    }
    set specialServices(services) {
        this.setSpecialServices(services);
    }
    set specialServiceMarks(value) {
        this.marks = value;
    }
    setSpecialServices(specialServices) {
        const services = specialServices.map((specialService) => ({
            code: specialService,
            icon: this.getIconMap(specialService),
        }));
        this.specialServicesSubject.next(services);
    }
    getIconMap(specialService) {
        const iconName = specialService
            .match(/[A-Z][a-z]+/g)
            .join('_')
            .toLowerCase();
        return `ss_${iconName}`;
    }
    getActiveClass(specialService) {
        var _a;
        let result = '';
        if ((_a = this.marks) === null || _a === void 0 ? void 0 : _a.length) {
            const specialServiceMark = this.getMark(specialService);
            if (specialServiceMark) {
                if (specialServiceMark.active === AppointmentStatusCd.APPOINTMENT_MISSING) {
                    result = 'active-mark active';
                }
                else if (specialServiceMark.active === AppointmentStatusCd.APPOINTMENT_PRESENT ||
                    specialServiceMark.active === AppointmentStatusCd.NO_APPOINTMENT) {
                    result = 'active-mark';
                }
            }
        }
        return result;
    }
    getMark(specialService) {
        var _a;
        return (_a = this.marks) === null || _a === void 0 ? void 0 : _a.find((ssm) => ssm.specialService === specialService);
    }
    getMarkPipeProps(specialService) {
        const specialServiceMark = this.getMark(specialService);
        return { applyMark: !!specialServiceMark, active: specialServiceMark === null || specialServiceMark === void 0 ? void 0 : specialServiceMark.active };
    }
}
SpecialServComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SpecialServComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SpecialServComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SpecialServComponent, selector: "xpo-special-services", inputs: { specialServices: "specialServices", specialServiceMarks: "specialServiceMarks" }, ngImport: i0, template: "<div class=\"SpecialServices\">\n  <xpo-icon\n    *ngFor=\"let specialService of specialServices$ | async\"\n    class=\"SpecialServices-svg\"\n    [ngClass]=\"[getActiveClass(specialService?.code)]\"\n    [iconName]=\"specialService?.icon\"\n  ></xpo-icon>\n</div>\n", styles: [".flex--stretch{flex:1}.SpecialServices{align-items:flex-start;display:flex;height:100%;justify-content:left}.SpecialServices xpo-icon{height:auto;margin-right:4px;vertical-align:middle;width:auto}.SpecialServices xpo-icon.active-mark.active :before{background-color:#d50000;border-radius:50%;content:\" \";height:10px;margin:-4px 11px;position:absolute;width:10px}.SpecialServices-svg .mat-icon{display:flex;height:16px;max-width:35px;width:unset}"], components: [{ type: i1$7.XpoIcon, selector: "xpo-icon", inputs: ["iconName"] }], directives: [{ type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SpecialServComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-special-services',
                    templateUrl: './special-services.component.html',
                    styleUrls: ['./special-services.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { specialServices: [{
                type: Input
            }], specialServiceMarks: [{
                type: Input
            }] } });

class ShipmentListSpecialServCellRendererComponent {
    constructor() { }
    agInit(params) {
        var _a, _b;
        this.params = params;
        this.specialServices = params.value;
        if (params === null || params === void 0 ? void 0 : params.getMarks) {
            this.specialServiceMarks = params.getMarks(params);
        }
        /**
         * To accommodate a special case in which you see the value in appointmentStatusCd but not in otherSpecialService
         * As a reason you will not see the Appointment Indicator on UI to fix this we add the Appointment
         * to OtherSpecialService field, that resolves this issue
         */
        if (((_a = this.specialServiceMarks) === null || _a === void 0 ? void 0 : _a.length) > 0 && !((_b = this.specialServices) === null || _b === void 0 ? void 0 : _b.includes(ShipmentSpecialServiceCd.APPOINTMENT))) {
            this.specialServices = [...this.specialServices, ShipmentSpecialServiceCd.APPOINTMENT];
        }
    }
    refresh(params) {
        this.params = params;
        this.specialServices = params.value;
        return false;
    }
}
ShipmentListSpecialServCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentListSpecialServCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ShipmentListSpecialServCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentListSpecialServCellRendererComponent, selector: "xpo-special-services-cell", ngImport: i0, template: "<ng-container *ngIf=\"specialServices && specialServices.length\">\n  <xpo-special-services\n    class=\"SpecialServicesCellRenderer\"\n    [specialServiceMarks]=\"specialServiceMarks\"\n    [specialServices]=\"specialServices\"\n  ></xpo-special-services>\n</ng-container>\n", components: [{ type: SpecialServComponent, selector: "xpo-special-services", inputs: ["specialServices", "specialServiceMarks"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentListSpecialServCellRendererComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-special-services-cell',
                    templateUrl: './special-services-cell-renderer.component.html',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return []; } });

class DisableGroupCellRenderer {
    agInit(params) {
        this.value = params.valueFormatted;
    }
    refresh(params) {
        return false;
    }
}
DisableGroupCellRenderer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DisableGroupCellRenderer, deps: [], target: i0.ɵɵFactoryTarget.Component });
DisableGroupCellRenderer.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: DisableGroupCellRenderer, selector: "xpo-disable-group-cell-renderer", ngImport: i0, template: "<span class=\"ag-cell-wrapper ag-cell-expandable ag-row-group\">\n  <span matTooltip=\"No Child PROs\" class=\"ag-group-contracted\">\n    <mat-icon class=\"material-icons\">add</mat-icon>\n  </span>\n  <span class=\"ag-group-value\">{{ value }}</span>\n</span>\n", styles: [".flex--stretch{flex:1}.ag-group-contracted .mat-icon.material-icons{color:#d8d8d8;-webkit-user-select:none;-moz-user-select:none;user-select:none}"], components: [{ type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i6.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DisableGroupCellRenderer, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-disable-group-cell-renderer',
                    templateUrl: './disable-group-cell-renderer.component.html',
                    styleUrls: ['./disable-group-cell-renderer.component.scss'],
                }]
        }] });

class XpoLtlTrailerShipmentsService extends XpoBoardDataSource {
    constructor(trailerTrackingService) {
        super();
        this.trailerTrackingService = trailerTrackingService;
    }
    fetchData(state) {
        const source = this.trailerTrackingService.trailerManifest$;
        return source.pipe(map((trailerManifest) => trailerManifest.shipments), map((loadedShipments) => {
            return this.populateTrailerXpoBoardData(state, loadedShipments);
        }));
    }
    populateTrailerXpoBoardData(state, loadedShipments) {
        return new XpoBoardData(state, loadedShipments, loadedShipments.length, 1);
    }
}
XpoLtlTrailerShipmentsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlTrailerShipmentsService, deps: [{ token: XpoLtlShmTrackingTrailerService }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlTrailerShipmentsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlTrailerShipmentsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlTrailerShipmentsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: XpoLtlShmTrackingTrailerService }]; } });

var ChildProDetailsCd;
(function (ChildProDetailsCd) {
    ChildProDetailsCd["ChildPro"] = "childPro";
    ChildProDetailsCd["CurrentSic"] = "currSic";
    ChildProDetailsCd["CurrentLocation"] = "currLocation";
    ChildProDetailsCd["Type"] = "type";
    ChildProDetailsCd["PickupDate"] = "pickupDate";
    ChildProDetailsCd["Weight"] = "weight";
    ChildProDetailsCd["CubicChild"] = "cubicChild";
})(ChildProDetailsCd || (ChildProDetailsCd = {}));
var ChildProDetailsHeader;
(function (ChildProDetailsHeader) {
    ChildProDetailsHeader["ChildProHeader"] = "PRO Nbr";
    ChildProDetailsHeader["CurrentSicHeader"] = "CURR. SIC";
    ChildProDetailsHeader["CurrentLocationHeader"] = "CURR. Location";
    ChildProDetailsHeader["TypeHeader"] = "Type";
    ChildProDetailsHeader["PickupDateHeader"] = "Pickup Date";
    ChildProDetailsHeader["WeightHeader"] = "Weight";
    ChildProDetailsHeader["CubicChildHeader"] = "Cubic";
})(ChildProDetailsHeader || (ChildProDetailsHeader = {}));

class BaseCustomGridOptions {
}
BaseCustomGridOptions.DEFAULT_GRID_OPTIONS = {
    domLayout: 'autoHeight',
    suppressCsvExport: true,
    suppressExcelExport: true,
    suppressRowClickSelection: true,
    defaultColDef: {
        suppressMenu: true,
    },
};
class ShipmentTrailerPltProComponent {
    constructor(dataSource) {
        this.dataSource = dataSource;
        this.trackingDataExistSubject = new BehaviorSubject(undefined);
        this.trackingDataExist$ = this.trackingDataExistSubject.asObservable();
        this.boardOptions = {
            suppressViewSwitcher: true,
            suppressGridSettingsPopover: true,
        };
        this.customGridOptions = Object.assign(Object.assign({}, BaseCustomGridOptions.DEFAULT_GRID_OPTIONS), { icons: {
                groupExpanded: `<mat-icon class="material-icons">remove</mat-icon>`,
                groupContracted: `<mat-icon class="material-icons">add</mat-icon>`,
            }, frameworkComponents: {
                disableGroupCellRenderer: DisableGroupCellRenderer,
                xpoAccordionGroupCellRendererComponent: XpoAccordionGroupCellRendererComponent,
            }, masterDetail: true, domLayout: 'normal', detailRowAutoHeight: true, enableRangeSelection: true, detailCellRendererParams: {
                detailGridOptions: {
                    frameworkComponents: {
                        xpoStringFilterComponent: XpoStringFilterComponent,
                        xpoNumberFilterComponent: XpoNumberFilterComponent,
                    },
                    enableRangeSelection: true,
                    headerHeight: 33,
                    getRowHeight: () => {
                        return 30;
                    },
                    columnDefs: [
                        { field: ChildProDetailsCd.ChildPro, headerName: ChildProDetailsHeader.ChildProHeader },
                        { field: ChildProDetailsCd.CurrentSic, headerName: ChildProDetailsHeader.CurrentSicHeader },
                        { field: ChildProDetailsCd.CurrentLocation, headerName: ChildProDetailsHeader.CurrentLocationHeader, resizable: true },
                        { field: ChildProDetailsCd.Type, headerName: ChildProDetailsHeader.TypeHeader },
                        { field: ChildProDetailsCd.PickupDate, headerName: ChildProDetailsHeader.PickupDateHeader },
                        { field: ChildProDetailsCd.Weight, headerName: ChildProDetailsHeader.WeightHeader },
                        { field: ChildProDetailsCd.CubicChild, headerName: ChildProDetailsHeader.CubicChildHeader },
                    ],
                    defaultColDef: {
                        flex: 1,
                        sortable: true,
                    },
                },
                getDetailRowData: (params) => {
                    params.successCallback(params.data.trailerChildPros);
                },
            } });
    }
    ngOnInit() {
        this.viewTemplates = this.getBoardViewTemplates();
        this.views = this.getBoardViews();
    }
    initFetchDataWatchers() { }
    getBoardViewTemplates() {
        return [
            new XpoAgGridBoardViewTemplate({
                id: 'trailerUnitTemplate',
                name: 'trailerUnitTemplate',
                keyField: 'parentPro',
                availableColumns: [
                    {
                        headerName: 'PRO Nbr',
                        field: 'parentPro',
                        width: 150,
                        autoHeight: true,
                        cellClass: 'cell-text-align-left',
                        valueFormatter: (params) => {
                            return params.data.parentPro;
                        },
                        cellRendererSelector: (params) => {
                            var _a;
                            const handlingUnits = (_a = params === null || params === void 0 ? void 0 : params.data) === null || _a === void 0 ? void 0 : _a.trailerChildPros;
                            if (handlingUnits) {
                                return {
                                    component: handlingUnits.length > 0 ? 'agGroupCellRenderer' : 'disableGroupCellRenderer',
                                };
                            }
                            return undefined;
                        },
                        pinned: true,
                    },
                    {
                        headerName: 'Motor Moves',
                        field: 'motorMoves',
                        width: 150,
                        autoHeight: true,
                        cellClass: 'cell-text-align-left',
                        pinned: true,
                    },
                    {
                        headerName: 'Origin',
                        field: 'origin',
                        width: 100,
                        autoHeight: true,
                        cellClass: 'cell-text-align-left',
                        pinned: true,
                    },
                    {
                        headerName: 'Dest.',
                        field: 'dest',
                        width: 100,
                        autoHeight: true,
                        cellClass: 'cell-text-align-left',
                        pinned: true,
                    },
                    {
                        headerName: 'Consignee',
                        field: 'consignee',
                        width: 250,
                        autoHeight: true,
                        cellClass: 'cell-text-align-left',
                        pinned: true,
                    },
                    {
                        headerName: 'Address',
                        field: 'address',
                        width: 250,
                        autoHeight: true,
                        cellClass: 'cell-text-align-left',
                    },
                    {
                        headerName: 'City',
                        field: 'city',
                        width: 150,
                        autoHeight: true,
                        cellClass: 'cell-text-align-left',
                    },
                    {
                        headerName: 'Wgt',
                        field: 'weight',
                        width: 100,
                        autoHeight: true,
                        cellClass: 'cell-text-align-left',
                    },
                    {
                        headerName: 'Cubic',
                        field: 'cubic',
                        width: 100,
                        autoHeight: true,
                        cellClass: 'cell-text-align-left',
                    },
                    {
                        headerName: 'G!',
                        field: 'guaranteed',
                        width: 100,
                        autoHeight: true,
                        cellRendererFramework: ShipmentListSpecialServCellRendererComponent,
                        valueGetter: (params) => get(params.data, 'guaranteed', []),
                    },
                    {
                        headerName: 'Hazmat',
                        field: 'hazmat',
                        width: 100,
                        autoHeight: true,
                        cellRendererFramework: ShipmentListSpecialServCellRendererComponent,
                        valueGetter: (params) => get(params.data, 'hazmat', []),
                    },
                ],
            }),
        ];
    }
    getBoardViews() {
        return [
            this.viewTemplates[0].createView({
                id: 'trailer-unit-view',
                templateId: 'trailerUnitTemplate',
                name: 'Trailer Unit',
                systemDefined: true,
                visible: false,
            }),
        ];
    }
    onGridReady(gridEvent) {
        this.gridApiEvent = gridEvent;
        this.gridApi = gridEvent.api;
    }
    onXpoAgGridBoardReady(gridBoardReadyEvent) {
        this.gridApi = gridBoardReadyEvent.agGridApi;
    }
}
ShipmentTrailerPltProComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentTrailerPltProComponent, deps: [{ token: XpoLtlTrailerShipmentsService }], target: i0.ɵɵFactoryTarget.Component });
ShipmentTrailerPltProComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: ShipmentTrailerPltProComponent, selector: "xpo-shipment-trailer-plt-pro", ngImport: i0, template: "<div class=\"ShipmentTrailerPltPro\">\n  <div class=\"shipment-trailer-plt-pro\">\n    <xpo-board\n      class=\"shipment-trailer-plt-pro__board\"\n      data-test=\"shipmentTrailerPltProLineItemsBoard\"\n      [dataSource]=\"dataSource\"\n      [views]=\"views\"\n      [viewTemplates]=\"viewTemplates\"\n      [boardOptions]=\"boardOptions\"\n    >\n      <xpo-ag-grid-board\n        [customGridOptions]=\"customGridOptions\"\n        (gridBoardReady)=\"onXpoAgGridBoardReady($event)\"\n        data-test=\"shipmentTrailerPltProLineItemsGrid\"\n        rowModelType=\"client-side\"\n        [sizeColumnsToFit]=\"false\"\n        [enableRowSelection]=\"false\"\n        [enableSorting]=\"true\"\n      >\n      </xpo-ag-grid-board>\n    </xpo-board>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}:host ::ng-deep xpo-grid-bar{display:none}.ShipmentTrailerPltPro{height:100%}.shipment-trailer-plt-pro{display:flex;flex-direction:column;height:100%;width:100%;padding-top:20px}.shipment-trailer-plt-pro-summary{display:flex;flex:1 1 auto;width:100%;justify-content:space-between;align-items:center}.shipment-trailer-plt-pro-summary-modified{display:flex}.shipment-trailer-plt-pro-description,.shipment-trailer-plt-pro-summary-description{padding-left:5px;font-weight:500;color:#000}.shipment-trailer-plt-pro-totals{background-color:#cfd8dc;display:flex;width:100%;justify-content:space-between;align-items:center}.shipment-trailer-plt-pro-totals-label{padding-left:5px;font-weight:500;color:#000}.shipment-trailer-plt-pro-totals-pieces{padding-right:9px;display:flex}.shipment-trailer-plt-pro_driver_measurements,.shipment-trailer-plt-pro_weights_inspection_measurements{padding-top:20px}.shipment-trailer-plt-pro__spinner{display:flex;justify-content:center;width:100%;margin-top:10%}.shipment-trailer-plt-pro__board{height:100%}.shipment-trailer-plt-pro__board .xpo-GridBar{display:none}.shipment-trailer-plt-pro__board .cell-wrap-text{white-space:normal}.shipment-trailer-plt-pro__board .cell-text-align-right{justify-content:flex-end}.shipment-trailer-plt-pro ::ng-deep .ag-details-grid.ag-details-grid-auto-height.ag-theme-material{border:1px solid #d8d8d8}"], components: [{ type: i4$5.XpoBoard, selector: "xpo-board", inputs: ["id", "dataSource", "views", "viewTemplates", "viewDataStore", "boardOptions", "addBoardViewLabel", "enableFilterReset", "enableQueryParamStatePersistance", "hideViewSwitcher", "hideViewSettingsMenu", "preloadViewData", "applyFilterStrategy", "showRecordCounts", "persistFiltersBetweenViews"], outputs: ["boardReady", "selectionChange"] }, { type: i5$2.XpoAgGridBoard, selector: "xpo-ag-grid-board", inputs: ["autoSelectFirstRow", "autoSizeColumns", "enableMovableColumns", "enableCellSelection", "enableRowSelection", "enableSorting", "groupUseEntireRow", "sizeColumnsToFit", "customGridOptions", "rowSelection", "rowModelType", "selectionMode", "suppressUsingRecordCount", "columnFilters", "pagination", "paginationPageSizes", "paginationPageSizeStart", "highlightMode"], outputs: ["cellSelected", "gridReady", "gridBoardReady", "refreshPagination"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ShipmentTrailerPltProComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-shipment-trailer-plt-pro',
                    templateUrl: './shipment-trailer-plt-pro.component.html',
                    styleUrls: ['./shipment-trailer-plt-pro.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlTrailerShipmentsService }]; } });

class XpoLtlShipmentTrackingTrailerDialogComponent {
    constructor(dialogRef, data, trackingDataService, xpoSnackBar) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.trackingDataService = trackingDataService;
        this.xpoSnackBar = xpoSnackBar;
        this.loadingDataSubject = new BehaviorSubject(true);
        this.loadingData$ = this.loadingDataSubject.asObservable();
        this.unsubscriber = new Unsubscriber();
        this.dialogData = this.data;
        this.trailerNbr = this.data.trailerNbr;
    }
    ngOnInit() {
        this.loadingDataSubject.next(true);
        this.searchShipmentTrailerData();
    }
    searchShipmentTrailerData() {
        this.trackingDataService
            .searchShipmentTrailer(this.dialogData)
            .pipe(takeUntil(this.unsubscriber.done$))
            .subscribe({
            next: (resp) => {
                this.trailerManifest = resp;
                this.loadingDataSubject.next(false);
            },
            error: (errResp) => {
                var _a;
                const errorMessage = (_a = errResp === null || errResp === void 0 ? void 0 : errResp.error) === null || _a === void 0 ? void 0 : _a.message;
                this.xpoSnackBar.open({
                    message: errorMessage,
                    status: 'error',
                    matConfig: {
                        verticalPosition: 'top',
                    },
                });
                this.dialogRef.close();
            },
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
        this.trackingDataService.clear();
    }
    get hasLoadedShipment() {
        if (this.trailerManifest && this.trailerManifest.shipments) {
            return this.trailerManifest.shipments && this.trailerManifest.shipments.length > 0;
        }
        else {
            return false;
        }
    }
    cancel() {
        this.dialogRef.close();
    }
}
XpoLtlShipmentTrackingTrailerDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentTrackingTrailerDialogComponent, deps: [{ token: i1$1.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: XpoLtlShmTrackingTrailerService }, { token: i3$2.XpoSnackBar }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlShipmentTrackingTrailerDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlShipmentTrackingTrailerDialogComponent, selector: "xpo-ltl-shipment-tracking-trailer", ngImport: i0, template: "<div xpoDialog class=\"xpo-LtlShipmentTrackingTrailerDialog\">\n  <ng-container *ngIf=\"!(loadingData$ | async); else isLoading\">\n    <h1 mat-dialog-title>\n      Trailer Manifest for {{ trailerNbr }}\n      <xpo-dialog-close-button></xpo-dialog-close-button>\n    </h1>\n\n    <div mat-dialog-content class=\"xpo-LtlShipmentTrackingTrailerDialog__content\">\n      <xpo-shipment-trailer-overview [trailerManifest]=\"trailerManifest\"></xpo-shipment-trailer-overview>\n      <xpo-empty-state *ngIf=\"!hasLoadedShipment; else shipmentInfo\">\n        <xpo-empty-state-icon>\n          <mat-icon>insert_drive_file</mat-icon>\n        </xpo-empty-state-icon>\n        <xpo-empty-state-header>No Shipment Info Found!</xpo-empty-state-header>\n      </xpo-empty-state>\n\n      <ng-template #shipmentInfo>\n        <xpo-shipment-trailer-plt-pro style=\"height: 100%;\"></xpo-shipment-trailer-plt-pro>\n      </ng-template>\n    </div>\n\n    <div mat-dialog-actions>\n      <xpo-button-group>\n        <button mat-flat-button xpoLargeButton xpoButton (click)=\"cancel()\">Close</button>\n      </xpo-button-group>\n    </div>\n  </ng-container>\n</div>\n<ng-template #isLoading>\n  <div class=\"xpo-LtlShipmentTrackingTrailerDialog__spinner\">\n    <mat-progress-spinner mode=\"indeterminate\"></mat-progress-spinner>\n  </div>\n</ng-template>\n", styles: [".flex--stretch{flex:1}.xpo-LtlShipmentTrackingTrailerDialog{display:flex;flex:1 1 auto;flex-direction:column;height:100%;width:100%}.xpo-LtlShipmentTrackingTrailerDialog .mat-dialog-container{display:flex;flex:1 1 auto;overflow:hidden;padding:16px 0}.xpo-LtlShipmentTrackingTrailerDialog .mat-dialog-content{display:flex;flex:1 1 auto;flex-direction:column;margin:0;padding:0;max-height:inherit;overflow:auto}.xpo-LtlShipmentTrackingTrailerDialog-none-found{font-weight:500;font-size:26px;color:#212121;text-align:center}.xpo-LtlShipmentTrackingTrailerDialog__header h1{display:flex;height:6rem;flex:0 0 auto;flex-direction:row;align-items:center;margin:-18px 0 0}.xpo-LtlShipmentTrackingTrailerDialog__header h1 .mat-dialog-title{flex:1 1 auto;margin:0}.xpo-LtlShipmentTrackingTrailerDialog__header h1 .mat-dialog-title .mat-icon-button{color:#9b9b9b}.xpo-LtlShipmentTrackingTrailerDialog__header h1-close{justify-self:flex-end;color:rgba(0,0,0,.54);flex:0 0 auto;align-items:center}.xpo-LtlShipmentTrackingTrailerDialog__content{width:100%}.xpo-LtlShipmentTrackingTrailerDialog__content-tab{display:flex;position:relative;flex:1 1 auto;flex-direction:column}.xpo-LtlShipmentTrackingTrailerDialog__header{display:flex;align-items:center}.xpo-LtlShipmentTrackingTrailerDialog__spinner{display:flex;justify-content:center;width:100%;margin-top:10%}"], components: [{ type: i3.XpoDialogCloseButtonComponent, selector: "xpo-dialog-close-button" }, { type: ShipmentTrackingTrailerComponent, selector: "xpo-shipment-trailer-overview", inputs: ["trailerManifest"] }, { type: i3$3.XpoEmptyState, selector: "xpo-empty-state" }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: ShipmentTrailerPltProComponent, selector: "xpo-shipment-trailer-plt-pro" }, { type: i5$3.XpoButtonGroup, selector: "xpo-button-group" }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i9.MatProgressSpinner, selector: "mat-progress-spinner", inputs: ["color", "mode", "diameter", "strokeWidth", "value"], exportAs: ["matProgressSpinner"] }], directives: [{ type: i3.XpoDialogDirective, selector: "[xpo-dialog], [xpoDialog]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i3$3.XpoEmptyStateIcon, selector: "xpo-empty-state-icon" }, { type: i3$3.XpoEmptyStateHeader, selector: "xpo-empty-state-header" }, { type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i5$3.XpoLargeButton, selector: "[xpo-large-button], [xpoLargeButton]" }, { type: i5$3.XpoButton, selector: "[xpo-button], [xpoButton]" }], pipes: { "async": i5.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentTrackingTrailerDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-shipment-tracking-trailer',
                    templateUrl: './shipment-tracking-trailer.component.html',
                    styleUrls: ['./shipment-tracking-trailer.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: XpoLtlShmTrackingTrailerService }, { type: i3$2.XpoSnackBar }]; } });

const components = [
    XpoLtlShipmentTrackingTrailerDialogComponent,
    ShipmentTrackingTrailerComponent,
    SpecialServComponent,
    ShipmentListSpecialServCellRendererComponent,
    ShipmentTrailerPltProComponent,
    DisableGroupCellRenderer,
];
class XpoLtlShipmentTrackingTrailerModule {
}
XpoLtlShipmentTrackingTrailerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentTrackingTrailerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlShipmentTrackingTrailerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentTrackingTrailerModule, declarations: [XpoLtlShipmentTrackingTrailerDialogComponent,
        ShipmentTrackingTrailerComponent,
        SpecialServComponent,
        ShipmentListSpecialServCellRendererComponent,
        ShipmentTrailerPltProComponent,
        DisableGroupCellRenderer], imports: [CommonModule,
        MatDialogModule,
        XpoDialogModule,
        DragDropModule,
        MatIconModule,
        XpoButtonModule,
        MatButtonModule,
        ConfigManagerModule,
        XpoIconModule,
        XpoBoardModule,
        XpoAgGridBoardModule,
        MatTooltipModule,
        BrowserAnimationsModule,
        MatProgressSpinnerModule,
        XpoEmptyStateModule], exports: [XpoLtlShipmentTrackingTrailerDialogComponent,
        ShipmentTrackingTrailerComponent,
        SpecialServComponent,
        DisableGroupCellRenderer,
        ShipmentListSpecialServCellRendererComponent] });
XpoLtlShipmentTrackingTrailerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentTrackingTrailerModule, providers: [
        {
            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
            useValue: { configFileUrl: './assets/config.json' },
        },
        DockOperationsApiService,
    ], imports: [[
            CommonModule,
            MatDialogModule,
            XpoDialogModule,
            DragDropModule,
            MatIconModule,
            XpoButtonModule,
            MatButtonModule,
            ConfigManagerModule,
            XpoIconModule,
            XpoBoardModule,
            XpoAgGridBoardModule,
            MatTooltipModule,
            BrowserAnimationsModule,
            MatProgressSpinnerModule,
            XpoEmptyStateModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlShipmentTrackingTrailerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...components],
                    exports: [
                        XpoLtlShipmentTrackingTrailerDialogComponent,
                        ShipmentTrackingTrailerComponent,
                        SpecialServComponent,
                        DisableGroupCellRenderer,
                        ShipmentListSpecialServCellRendererComponent,
                    ],
                    imports: [
                        CommonModule,
                        MatDialogModule,
                        XpoDialogModule,
                        DragDropModule,
                        MatIconModule,
                        XpoButtonModule,
                        MatButtonModule,
                        ConfigManagerModule,
                        XpoIconModule,
                        XpoBoardModule,
                        XpoAgGridBoardModule,
                        MatTooltipModule,
                        BrowserAnimationsModule,
                        MatProgressSpinnerModule,
                        XpoEmptyStateModule,
                    ],
                    entryComponents: [
                        XpoLtlShipmentTrackingTrailerDialogComponent,
                        SpecialServComponent,
                        ShipmentListSpecialServCellRendererComponent,
                        ShipmentTrailerPltProComponent,
                        DisableGroupCellRenderer,
                    ],
                    providers: [
                        {
                            provide: CONFIG_MANAGER_SERVICE_CONFIGURATION,
                            useValue: { configFileUrl: './assets/config.json' },
                        },
                        DockOperationsApiService,
                    ],
                }]
        }] });

class GeoLocationService {
    constructor(geoLocationApiService) {
        this.geoLocationApiService = geoLocationApiService;
    }
    listGeoPostalCodesByCity(cityName, countryCd, stateCd) {
        const queryParams = new ListGeoPostalCodesByCityQuery();
        queryParams.cityName = cityName;
        queryParams.countryCd = countryCd;
        queryParams.stateCd = stateCd;
        return this.geoLocationApiService.listGeoPostalCodesByCity(queryParams).pipe(filter((response) => response !== null && response !== undefined), map((resp) => resp.geoLocation));
    }
}
GeoLocationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: GeoLocationService, deps: [{ token: i1$d.GeoLocationApiService }], target: i0.ɵɵFactoryTarget.Injectable });
GeoLocationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: GeoLocationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: GeoLocationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$d.GeoLocationApiService }]; } });

function serviceCenterDetailsTransfomer(response) {
    const serviceCenterDetailsTransformed = {
        address: response.serviceCenter.address,
        contact: response.serviceCenter.contact,
        coordinates: response.serviceCenter.coordinates,
        customerServicePhoneNumber: response.serviceCenter.custServicePhoneNbr,
        faxNumber: response.serviceCenter.faxNbr,
        sicCode: response.serviceCenter.sicCd,
        tollFreePhoneNumber: response.serviceCenter.tollFreePhoneNbr,
    };
    return serviceCenterDetailsTransformed;
}

class ServiceCenterService {
    constructor(locationApiService, snackBarService) {
        this.locationApiService = locationApiService;
        this.snackBarService = snackBarService;
        this.serviceCenterDetailsSubject = new BehaviorSubject(undefined);
        this.serviceCenterDetails$ = this.serviceCenterDetailsSubject.asObservable();
        this.sicErrorSubject = new BehaviorSubject(false);
        this.sicError$ = this.sicErrorSubject.asObservable();
    }
    get serviceCenterDetails() {
        return this.serviceCenterDetailsSubject.value;
    }
    set serviceCenterDetails(sc) {
        this.serviceCenterDetailsSubject.next(sc);
    }
    set sicError(flag) {
        this.sicErrorSubject.next(flag);
    }
    getCustomerServiceCenterDetails(sicCd, postalCd) {
        const request = new GetCustomerServiceCenterDetailsRqst();
        if (!!sicCd) {
            request.sicCd = sicCd;
        }
        if (!!postalCd) {
            request.postalCd = postalCd;
        }
        this.locationApiService
            .getCustomerServiceCenterDetails(request)
            .pipe(map((response) => {
            return serviceCenterDetailsTransfomer(response);
        }), catchError((err) => {
            var _a, _b;
            this.snackBarService.error((_b = (_a = err === null || err === void 0 ? void 0 : err.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : 'The ZIP/postal code you entered appears to be invalid.');
            return of(null);
        }))
            .subscribe((response) => {
            if (!!response) {
                this.serviceCenterDetailsSubject.next(response);
            }
            else {
                this.sicErrorSubject.next(true);
            }
        });
    }
}
ServiceCenterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ServiceCenterService, deps: [{ token: i1$e.LocationApiService }, { token: i3$2.XpoSnackBar }], target: i0.ɵɵFactoryTarget.Injectable });
ServiceCenterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ServiceCenterService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: ServiceCenterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$e.LocationApiService }, { type: i3$2.XpoSnackBar }]; } });

class StatesUtil {
    static usStateCodes() {
        const resp = [
            {
                code: 'AL',
                label: 'Alabama',
                country: 'US',
            },
            {
                code: 'AK',
                label: 'Alaska',
                country: 'US',
            },
            {
                code: 'AZ',
                label: 'Arizona',
                country: 'US',
            },
            {
                code: 'AR',
                label: 'Arkansas',
                country: 'US',
            },
            {
                code: 'CA',
                label: 'California',
                country: 'US',
            },
            {
                code: 'CO',
                label: 'Colorado',
                country: 'US',
            },
            {
                code: 'CT',
                label: 'Connecticut',
                country: 'US',
            },
            {
                code: 'DE',
                label: 'Delaware',
                country: 'US',
            },
            {
                code: 'FL',
                label: 'Florida',
                country: 'US',
            },
            {
                code: 'GA',
                label: 'Georgia',
                country: 'US',
            },
            {
                code: 'HI',
                label: 'Hawaii',
                country: 'US',
            },
            {
                code: 'ID',
                label: 'Idaho',
                country: 'US',
            },
            {
                code: 'IL',
                label: 'Illinois',
                country: 'US',
            },
            {
                code: 'IN',
                label: 'Indiana',
                country: 'US',
            },
            {
                code: 'IA',
                label: 'Iowa',
                country: 'US',
            },
            {
                code: 'KS',
                label: 'Kansas',
                country: 'US',
            },
            {
                code: 'KY',
                label: 'Kentucky',
                country: 'US',
            },
            {
                code: 'LA',
                label: 'Louisiana',
                country: 'US',
            },
            {
                code: 'ME',
                label: 'Maine',
                country: 'US',
            },
            {
                code: 'MD',
                label: 'Maryland',
                country: 'US',
            },
            {
                code: 'MA',
                label: 'Massachusetts',
                country: 'US',
            },
            {
                code: 'MI',
                label: 'Michigan',
                country: 'US',
            },
            {
                code: 'MN',
                label: 'Minnesota',
                country: 'US',
            },
            {
                code: 'MS',
                label: 'Mississippi',
                country: 'US',
            },
            {
                code: 'MO',
                label: 'Missouri',
                country: 'US',
            },
            {
                code: 'MT',
                label: 'Montana',
                country: 'US',
            },
            {
                code: 'NE',
                label: 'Nebraska',
                country: 'US',
            },
            {
                code: 'NV',
                label: 'Nevada',
                country: 'US',
            },
            {
                code: 'NH',
                label: 'New Hampshire',
                country: 'US',
            },
            {
                code: 'NJ',
                label: 'New Jersey',
                country: 'US',
            },
            {
                code: 'NM',
                label: 'New Mexico',
                country: 'US',
            },
            {
                code: 'NY',
                label: 'New York',
                country: 'US',
            },
            {
                code: 'NC',
                label: 'North Carolina',
                country: 'US',
            },
            {
                code: 'ND',
                label: 'North Dakota',
                country: 'US',
            },
            {
                code: 'OH',
                label: 'Ohio',
                country: 'US',
            },
            {
                code: 'OK',
                label: 'Oklahoma',
                country: 'US',
            },
            {
                code: 'OR',
                label: 'Oregon',
                country: 'US',
            },
            {
                code: 'PA',
                label: 'Pennsylvania',
                country: 'US',
            },
            {
                code: 'PR',
                label: 'Puerto Rico',
                country: 'US',
            },
            {
                code: 'RI',
                label: 'Rhode Island',
                country: 'US',
            },
            {
                code: 'SC',
                label: 'South Carolina',
                country: 'US',
            },
            {
                code: 'SD',
                label: 'South Dakota',
                country: 'US',
            },
            {
                code: 'TN',
                label: 'Tennessee',
                country: 'US',
            },
            {
                code: 'TX',
                label: 'Texas',
                country: 'US',
            },
            {
                code: 'UT',
                label: 'Utah',
                country: 'US',
            },
            {
                code: 'VT',
                label: 'Vermont',
                country: 'US',
            },
            {
                code: 'VA',
                label: 'Virginia',
                country: 'US',
            },
            {
                code: 'WA',
                label: 'Washington',
                country: 'US',
            },
            {
                code: 'WV',
                label: 'West Virginia',
                country: 'US',
            },
            {
                code: 'WI',
                label: 'Wisconsin',
                country: 'US',
            },
            {
                code: 'WY',
                label: 'Wyoming',
                country: 'US',
            },
        ];
        return resp;
    }
    static caStateCodes() {
        const resp = [
            {
                code: 'AB',
                label: 'Alberta',
                country: 'CA',
            },
            {
                code: 'NB',
                label: 'New Brunswick',
                country: 'CA',
            },
            {
                code: 'NS',
                label: 'Nova Scotia',
                country: 'CA',
            },
            {
                code: 'NW',
                label: 'North West Terr.',
                country: 'CA',
            },
            {
                code: 'PE',
                label: 'Prince Edward Is.',
                country: 'CA',
            },
            {
                code: 'SK',
                label: 'Saskatchewen',
                country: 'CA',
            },
            {
                code: 'BC',
                label: 'British Columbia',
                country: 'CA',
            },
            {
                code: 'MB',
                label: 'Manitoba',
                country: 'CA',
            },
            {
                code: 'NL',
                label: 'Newfoundland/Labrador',
                country: 'CA',
            },
            {
                code: 'NU',
                label: 'Nunavut',
                country: 'CA',
            },
            {
                code: 'ON',
                label: 'Ontario',
                country: 'CA',
            },
            {
                code: 'QC',
                label: 'Quebec',
                country: 'CA',
            },
            {
                code: 'YU',
                label: 'Yukon',
                country: 'CA',
            },
        ];
        return resp;
    }
}

const ZIP_CODES_RULES = {
    US: /\b\d{5}\b/,
    CA: /[a-z]\d[a-z][\s\-]?\d[a-z]\d/i, // pattern is --> A2A 2A2  A2A-2A2 A2A2A2
};
const _ValidateZipCodeUS = (value) => {
    if (!RegExp(ZIP_CODES_RULES.US).test(value)) {
        return { zipCodeUS: true };
    }
    return null;
};
const ValidateZipCodeUS = (control) => {
    return _ValidateZipCodeUS(control.value);
};
const _ValidateZipCodeCA = (value) => {
    if (!RegExp(ZIP_CODES_RULES.CA).test(value)) {
        return { zipCodeCA: true };
    }
    return null;
};
const ValidateZipCodeCA = (control) => {
    return _ValidateZipCodeCA(control.value);
};

var SicLabelsEnum;
(function (SicLabelsEnum) {
    SicLabelsEnum["Title"] = "Title";
    SicLabelsEnum["Name"] = "Name";
    SicLabelsEnum["Email"] = "Email";
    SicLabelsEnum["FindOtherServiceCenter"] = "Find Another Service Center";
    SicLabelsEnum["EnterPostalCode"] = "Enter a postal code (US/CN) to locate nearest Service Center";
    SicLabelsEnum["LocatePostalCode"] = "If you don't know the Postal Code, you can enter the city and state locate";
    SicLabelsEnum["SicInfo"] = "Service Center Information";
    SicLabelsEnum["CustService"] = "Customer Service:";
    SicLabelsEnum["TollFree"] = "Toll-free:";
    SicLabelsEnum["Fax"] = "Fax:";
    SicLabelsEnum["SicWeather"] = "Service Center Weather";
    SicLabelsEnum["UseLinks"] = "Use the links below to determine if severe weather could affect your shipment.";
    SicLabelsEnum["FreezAreaMap"] = "Freeze Area Map";
    SicLabelsEnum["SevereWeatherInfo"] = "Severe Weather information";
    SicLabelsEnum["WeatherForeCast"] = " Weather forecast from NOAA";
})(SicLabelsEnum || (SicLabelsEnum = {}));
var FindSicFormErrors;
(function (FindSicFormErrors) {
    FindSicFormErrors["Required"] = "This field is required";
    FindSicFormErrors["NotUSZipCode"] = "That doesn't look like US zip code";
    FindSicFormErrors["NotCaZipCode"] = "That doesn't look like Canada zip code";
})(FindSicFormErrors || (FindSicFormErrors = {}));
var FindSicFormLabels;
(function (FindSicFormLabels) {
    FindSicFormLabels["PostalCode"] = "Postal Code";
    FindSicFormLabels["Locate"] = "LOCATE";
    FindSicFormLabels["City"] = "City";
    FindSicFormLabels["State"] = "State/Province";
    FindSicFormLabels["LookUp"] = "LOOK UP";
    FindSicFormLabels["SearchResults"] = "Search Results";
})(FindSicFormLabels || (FindSicFormLabels = {}));
var FindSicFormControlsEnum;
(function (FindSicFormControlsEnum) {
    FindSicFormControlsEnum["ZIP_CODE"] = "zipCode";
    FindSicFormControlsEnum["CITY_NAME"] = "cityName";
    FindSicFormControlsEnum["STATE"] = "state";
    FindSicFormControlsEnum["POSTAL_CODE_VALUE"] = "postalCodeValue";
})(FindSicFormControlsEnum || (FindSicFormControlsEnum = {}));
var FindSicRegExp;
(function (FindSicRegExp) {
    FindSicRegExp["CHARREGEXP"] = "/^[a-z]/";
    FindSicRegExp["NUMERICREGEXP"] = "/^[0-9]/";
})(FindSicRegExp || (FindSicRegExp = {}));

class XpoLtlSicFindComponent {
    constructor(serviceCenterService, fb, geoLocationService, snackBar) {
        this.serviceCenterService = serviceCenterService;
        this.fb = fb;
        this.geoLocationService = geoLocationService;
        this.snackBar = snackBar;
        this.unsubscriber = new Unsubscriber();
        this.SicLabelsEnum = SicLabelsEnum;
        this.FindSicFormErrors = FindSicFormErrors;
        this.FindSicFormLabels = FindSicFormLabels;
        this.FindSicFormControlsEnum = FindSicFormControlsEnum;
    }
    ngOnInit() {
        this.createZipCodeForm();
        this.createSearchZipCodeForm();
        this.createPostalCodeForm();
        this.stateCodesUS = StatesUtil.usStateCodes();
        this.stateCodesCA = StatesUtil.caStateCodes();
        this.initFormWatchers();
    }
    initFormWatchers() {
        this.zipCodeForm
            .get('zipCode')
            .valueChanges.pipe(takeUntil(this.unsubscriber.done$))
            .subscribe((zipCode) => {
            const zipCodeValue = this.zipCodeForm.get('zipCode').value;
            this.zipCodeForm.controls.zipCode.clearValidators();
            this.zipCodeForm.controls.zipCode.setValidators([Validators.required]);
            if (RegExp(/^[a-z]/i).test(zipCodeValue)) {
                this.zipCodeForm.controls.zipCode.setValidators(ValidateZipCodeCA);
            }
            else if (RegExp(/^[0-9]/).test(zipCodeValue)) {
                this.zipCodeForm.controls.zipCode.setValidators(ValidateZipCodeUS);
            }
            this.zipCodeForm.controls.zipCode.updateValueAndValidity({ emitEvent: false });
        });
    }
    locateZipCode() {
        var _a, _b, _c;
        if ((_a = this.zipCodeForm) === null || _a === void 0 ? void 0 : _a.valid) {
            this.searchSic(this.transformCAZipCode((_c = (_b = this.zipCodeForm) === null || _b === void 0 ? void 0 : _b.controls[FindSicFormControlsEnum.ZIP_CODE]) === null || _c === void 0 ? void 0 : _c.value));
        }
    }
    locatePostalCode() {
        var _a, _b, _c;
        if ((_a = this.postalCodeForm) === null || _a === void 0 ? void 0 : _a.valid) {
            this.searchSic(this.transformCAZipCode((_c = (_b = this.postalCodeForm) === null || _b === void 0 ? void 0 : _b.controls[FindSicFormControlsEnum.ZIP_CODE]) === null || _c === void 0 ? void 0 : _c.value));
        }
    }
    searchSic(zipCode) {
        this.serviceCenterService.getCustomerServiceCenterDetails(null, zipCode);
    }
    createZipCodeForm() {
        this.zipCodeForm = this.fb.group({
            [FindSicFormControlsEnum.ZIP_CODE]: ['', [Validators.required]],
        });
    }
    createSearchZipCodeForm() {
        this.searchZipCodeForm = this.fb.group({
            [FindSicFormControlsEnum.CITY_NAME]: ['', [Validators.required]],
            [FindSicFormControlsEnum.STATE]: ['', [Validators.required]],
        });
    }
    createPostalCodeForm() {
        this.postalCodeForm = this.fb.group({
            [FindSicFormControlsEnum.POSTAL_CODE_VALUE]: ['', [Validators.required]],
            [FindSicFormControlsEnum.ZIP_CODE]: [null],
        });
    }
    searchZipCode() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const cityName = (_b = (_a = this.searchZipCodeForm) === null || _a === void 0 ? void 0 : _a.controls[FindSicFormControlsEnum.CITY_NAME]) === null || _b === void 0 ? void 0 : _b.value;
        const countryCd = (_e = (_d = (_c = this.searchZipCodeForm) === null || _c === void 0 ? void 0 : _c.controls[FindSicFormControlsEnum.STATE]) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.country;
        const stateCd = (_h = (_g = (_f = this.searchZipCodeForm) === null || _f === void 0 ? void 0 : _f.controls[FindSicFormControlsEnum.STATE]) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.code;
        this.postalCodeOptions$ = this.geoLocationService.listGeoPostalCodesByCity(cityName, countryCd, stateCd);
        this.geoLocationService
            .listGeoPostalCodesByCity(cityName, countryCd, stateCd)
            .pipe(takeUntil(this.unsubscriber.done$))
            .subscribe((resp) => {
            this.handlePostalCodeSelection(resp[0]);
        }, (error) => {
            var _a, _b;
            this.snackBar.error((_b = (_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : 'No postal codes were found. Please refine your search and try again');
        });
    }
    handlePostalCodeSelection(postalCode) {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.zipCodeForm) === null || _a === void 0 ? void 0 : _a.controls[FindSicFormControlsEnum.ZIP_CODE]) === null || _b === void 0 ? void 0 : _b.setValue(postalCode.postalCd);
        (_d = (_c = this.postalCodeForm) === null || _c === void 0 ? void 0 : _c.controls[FindSicFormControlsEnum.ZIP_CODE]) === null || _d === void 0 ? void 0 : _d.setValue(postalCode.postalCd);
        (_f = (_e = this.postalCodeForm) === null || _e === void 0 ? void 0 : _e.controls[FindSicFormControlsEnum.POSTAL_CODE_VALUE]) === null || _f === void 0 ? void 0 : _f.setValue(`${postalCode.postalCd}-${postalCode.cityName}`);
    }
    transformCAZipCode(zipCode) {
        const CA2 = RegExp(/[a-z]\d[a-z][\s\-]\d[a-z]\d/i);
        if (CA2.test(zipCode)) {
            return zipCode.replace(/\s|-/g, '');
        }
        else {
            return zipCode;
        }
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
}
XpoLtlSicFindComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicFindComponent, deps: [{ token: ServiceCenterService }, { token: i2$2.FormBuilder }, { token: GeoLocationService }, { token: i3$2.XpoSnackBar }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlSicFindComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlSicFindComponent, selector: "xpo-ltl-service-center-find", ngImport: i0, template: "<div class=\"serviceCenter\">\n  <div class=\"serviceCenter-titleContainer\">\n    {{ SicLabelsEnum.FindOtherServiceCenter }}\n  </div>\n  <div class=\"serviceCenter-content\">\n    <div>\n      <label class=\"serviceCenter-headerLabel\">{{ SicLabelsEnum.EnterPostalCode }}</label>\n      <form [formGroup]=\"zipCodeForm\" (ngSubmit)=\"locateZipCode()\">\n        <div class=\"serviceCenter-mainRow\">\n          <div class=\"serviceCenter-inputContainer\">\n            <mat-form-field floatLabel=\"always\">\n              <mat-label>{{ FindSicFormLabels.PostalCode }}</mat-label>\n              <input id=\"postal-code-mat-input\" matInput formControlName=\"zipCode\" />\n              <mat-error *ngIf=\"zipCodeForm.get('zipCode').hasError('required')\">\n                {{ FindSicFormErrors.Required }}\n              </mat-error>\n              <mat-error *ngIf=\"zipCodeForm.get('zipCode').hasError('zipCodeUS')\">\n                {{ FindSicFormErrors.NotUSZipCode }}\n              </mat-error>\n              <mat-error *ngIf=\"zipCodeForm.get('zipCode').hasError('zipCodeCA')\">\n                {{ FindSicFormErrors.NotCaZipCode }}\n              </mat-error>\n            </mat-form-field>\n          </div>\n          <div class=\"serviceCenter-buttonContainer\">\n            <button id=\"locate-btn\" mat-raised-button [disabled]=\"!zipCodeForm.valid\">\n              {{ FindSicFormLabels.Locate }}\n            </button>\n          </div>\n        </div>\n      </form>\n    </div>\n    <div>\n      <label class=\"serviceCenter-headerLabel-city\">{{ SicLabelsEnum.LocatePostalCode }}</label>\n      <form [formGroup]=\"searchZipCodeForm\">\n        <div class=\"serviceCenter-inputContainer\">\n          <mat-form-field floatLabel=\"always\">\n            <mat-label>{{ FindSicFormLabels.City }}</mat-label>\n            <input matInput formControlName=\"cityName\" />\n            <mat-error *ngIf=\"searchZipCodeForm.get('cityName').hasError('required')\">\n              This field is required\n            </mat-error>\n          </mat-form-field>\n        </div>\n        <div class=\"serviceCenter-mainRow\">\n          <div class=\"serviceCenter-inputContainer\">\n            <mat-form-field floatLabel=\"always\">\n              <mat-label>{{ FindSicFormLabels.State }}</mat-label>\n              <mat-select xpoSelect formControlName=\"state\">\n                <mat-optgroup label=\"USA States/Territories\">\n                  <mat-option *ngFor=\"let state of stateCodesUS\" [value]=\"state\">\n                    {{ state.label }}\n                  </mat-option>\n                </mat-optgroup>\n                <mat-optgroup label=\"Canadian Provinces\">\n                  <mat-option *ngFor=\"let state of stateCodesCA\" [value]=\"state\">\n                    {{ state.label }}\n                  </mat-option>\n                </mat-optgroup>\n              </mat-select>\n            </mat-form-field>\n          </div>\n          <div class=\"serviceCenter-buttonContainer\">\n            <button id=\"lookup-btn\" (click)=\"searchZipCode()\" mat-raised-button [disabled]=\"!searchZipCodeForm.valid\">\n              {{ FindSicFormLabels.LookUp }}\n            </button>\n          </div>\n        </div>\n      </form>\n      <form\n        [formGroup]=\"postalCodeForm\"\n        (ngSubmit)=\"locatePostalCode()\"\n        *ngIf=\"postalCodeOptions$ | async as postalCodeOptions\"\n      >\n        <hr />\n        <div class=\"serviceCenter-mainRow\">\n          <div class=\"serviceCenter-inputContainer\">\n            <mat-form-field floatLabel=\"always\">\n              <mat-label>{{ FindSicFormLabels.SearchResults }}</mat-label>\n              <input\n                type=\"text\"\n                matInput\n                formControlName=\"postalCodeValue\"\n                [matAutocomplete]=\"postalCodeAutocomplete\"\n                xpoAutocomplete\n              />\n              <mat-icon matSuffix>arrow_drop_down</mat-icon>\n              <mat-autocomplete autoActiveFirstOption #postalCodeAutocomplete>\n                <mat-option\n                  *ngFor=\"let postalCode of postalCodeOptions\"\n                  [value]=\"postalCode.postalCd\"\n                  (onSelectionChange)=\"handlePostalCodeSelection(postalCode)\"\n                >\n                  {{ postalCode.postalCd }}-{{ postalCode.cityName }}\n                </mat-option>\n              </mat-autocomplete>\n              <mat-error *ngIf=\"postalCodeForm.get('postalCodeValue').hasError('required')\">\n                {{ FindSicFormErrors.Required }}\n              </mat-error>\n            </mat-form-field>\n          </div>\n          <div class=\"serviceCenter-buttonContainer\">\n            <button id=\"locate-btn\" mat-raised-button [disabled]=\"!postalCodeForm.valid\">\n              {{ FindSicFormLabels.Locate }}\n            </button>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}.serviceCenterDetails{display:flex;justify-content:center}.serviceCenterDetails-container{width:100%}.serviceCenterDetails-busy-loader__spinner{position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%,-50%);width:100px;height:100px}.service-center-panel{min-height:300px}.serviceCenter-titleContainer{height:32px;font-size:1.428rem;font-weight:500;box-shadow:inset 0 -1px 0 #d8d8d8;margin-top:16px;margin-bottom:16px}.serviceCenter-headerLabel{font-size:14px}.serviceCenter-headerLabel-city{font-weight:500;font-size:12px}.serviceCenter-mainRow{display:flex;align-items:center}.serviceCenter-inputContainer{margin-right:16px;width:50%}.serviceCenter-inputContainer mat-form-field{width:100%}.serviceCenter-buttonContainer{margin-top:2px}.serviceCenter-labelContainer{min-width:160px;padding:16px}"], components: [{ type: i7.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i4$4.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i11$1.MatOptgroup, selector: "mat-optgroup", inputs: ["disabled"], exportAs: ["matOptgroup"] }, { type: i11$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: i13.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }], directives: [{ type: i2$2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2$2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2$2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7.MatLabel, selector: "mat-label" }, { type: i21.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["id", "disabled", "required", "type", "value", "readonly", "placeholder", "errorStateMatcher", "aria-describedby"], exportAs: ["matInput"] }, { type: i2$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i7.MatError, selector: "mat-error", inputs: ["id"] }, { type: i16.XpoDisableOptionCenteringDirective, selector: "mat-select" }, { type: i16.XpoSelectDirective, selector: "[xpo-select], [xpoSelect]" }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i13.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { type: i16.XpoAutocompleteInternalActiveNavigation, selector: "[xpoAutocomplete] , [xpo-autocomplete]", inputs: ["xpoOptionHeight", "xpoPanelHeight"] }, { type: i7.MatSuffix, selector: "[matSuffix]" }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicFindComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-service-center-find',
                    templateUrl: './service-center-find.component.html',
                    styleUrls: ['./service-center-find.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: ServiceCenterService }, { type: i2$2.FormBuilder }, { type: GeoLocationService }, { type: i3$2.XpoSnackBar }]; } });

class XpoSicContactsComponent {
    constructor() {
        this.SicLabelsEnum = SicLabelsEnum;
    }
}
XpoSicContactsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoSicContactsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
XpoSicContactsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoSicContactsComponent, selector: "xpo-ltl-service-center-contacts", inputs: { serviceCenter: "serviceCenter" }, ngImport: i0, template: "<div class=\"serviceCenterContacts\" *ngIf=\"serviceCenter\">\n  <div class=\"serviceCenterContacts-dataContainer\">\n    <div class=\"serviceCenterContacts-tableCol\">\n      <div class=\"serviceCenterContacts-grid\">\n        <header>\n          <div class=\"column-medium\">{{ SicLabelsEnum.Title }}</div>\n          <div class=\"column-medium\">{{ SicLabelsEnum.Name }}</div>\n          <div class=\"column-medium\">{{ SicLabelsEnum.Email }}</div>\n        </header>\n        <div class=\"content\">\n          <div class=\"grid-single-item\" *ngFor=\"let contact of serviceCenter.contact\">\n            <div class=\"column-medium\">\n              {{ contact.contactTitle }}\n            </div>\n            <div class=\"column-medium\">\n              {{ contact.contactFullName }}\n            </div>\n            <div class=\"column-medium\">\n              <a href=\"mailto:{{ contact.email.emailAddr }}\">{{ contact.email.emailAddr }}</a>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}.serviceCenterDetails{display:flex;justify-content:center}.serviceCenterDetails-container{width:100%}.serviceCenterDetails-busy-loader__spinner{position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%,-50%);width:100px;height:100px}.service-center-panel{min-height:300px}.serviceCenterContacts-dataContainer{display:flex;font-size:14px}.serviceCenterContacts-cityCol{flex:0.2;font-weight:500;margin-top:8px}.serviceCenterContacts-tableCol{flex-grow:1}.serviceCenterContacts-grid .content .grid-single-item,.serviceCenterContacts-grid header{align-items:center;display:flex;height:30px}.serviceCenterContacts-grid .content .grid-single-item>*,.serviceCenterContacts-grid header>*{margin-right:16px}.serviceCenterContacts-grid .content .grid-single-item .column-medium,.serviceCenterContacts-grid header .column-medium{width:20px;flex-grow:1}.serviceCenterContacts-grid .content .grid-single-item .action,.serviceCenterContacts-grid header .action{display:flex;justify-content:center}.serviceCenterContacts-grid header{font-weight:500;border-bottom:1px solid #171717}.serviceCenterContacts-grid .grid-single-item:hover{background-color:#fbfbfb}.serviceCenterContacts-grid .grid-single-item mat-icon{cursor:pointer;justify-self:center}"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoSicContactsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-service-center-contacts',
                    templateUrl: './service-center-contacts.component.html',
                    styleUrls: ['./service-center-contacts.component.scss'],
                }]
        }], propDecorators: { serviceCenter: [{
                type: Input
            }] } });

var ExtUrls;
(function (ExtUrls) {
    ExtUrls["GoogleMapsBaseUrl"] = "https://www.google.com/maps?hl=en&tab=wl&q=";
    ExtUrls["LtlBasePath"] = "https://ltl.xpo.com";
    ExtUrls["WeatherServicesUrl"] = "https://ltl.xpo.com/en/ltl/weather-alert";
    ExtUrls["ForecastUrl"] = "http://forecast.weather.gov/zipcity.php?inputstring=";
    ExtUrls["ServiceMapUrl"] = "https://servicemap.ltl-xpo.com/";
})(ExtUrls || (ExtUrls = {}));

class XpoLtlSicInfoComponent {
    constructor(windowService) {
        this.windowService = windowService;
        this.ExtUrls = ExtUrls;
        this.SicLabelsEnum = SicLabelsEnum;
    }
    set serviceCenter(serviceCenter) {
        var _a, _b, _c, _d, _e, _f;
        if (serviceCenter) {
            this.serviceCenterDetails = serviceCenter;
            this.addressLastPart = `${(_b = (_a = this.serviceCenterDetails) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.stateCd} ${(_d = (_c = this.serviceCenterDetails) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.postalCd} ${(_f = (_e = this.serviceCenterDetails) === null || _e === void 0 ? void 0 : _e.address) === null || _f === void 0 ? void 0 : _f.countryCd}`;
        }
    }
    ngOnInit() {
        this.initUrls();
    }
    initUrls() {
        var _a, _b;
        this.googleMapsSCLUrl = `${ExtUrls.GoogleMapsBaseUrl}${(_b = (_a = this.serviceCenterDetails) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.addressLine2}${this.addressLastPart}`;
    }
    openTransitTimeMap() {
        var _a;
        const transitTimeMapURL = `${ExtUrls.LtlBasePath}/private/images/fastmap2000/SIC_maps/Full_PDF/map_${(_a = this.serviceCenterDetails) === null || _a === void 0 ? void 0 : _a.sicCode}_FULL.PDF`;
        this.windowService.nativeWindow.open(transitTimeMapURL, '_blank');
    }
}
XpoLtlSicInfoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicInfoComponent, deps: [{ token: XpoLtlWindowService }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlSicInfoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlSicInfoComponent, selector: "xpo-ltl-service-center-info", inputs: { serviceCenter: "serviceCenter" }, ngImport: i0, template: "<div class=\"serviceCenterInfo\" *ngIf=\"serviceCenterDetails\">\n  <div>\n    <div class=\"serviceCenterInfo-info__sc-heading\">\n      {{ SicLabelsEnum.SicInfo }}\n    </div>\n    <div class=\"serviceCenterInfo-info__city strong\">\n      {{ serviceCenterDetails.sicCode }} -\n      <span class=\"serviceCenterInfo-info__city__name\">{{\n        serviceCenterDetails.address?.cityName?.toLowerCase()\n      }}</span>\n    </div>\n    <div class=\"serviceCenterInfo-info__address\">\n      <a href=\"{{ googleMapsSCLUrl }}\" target=\"_blank\">\n        <span class=\"serviceCenterInfo-info__city__name\">{{\n          serviceCenterDetails.address?.addressLine2?.toLowerCase()\n        }}</span>\n        <span class=\"serviceCenterInfo-info__city__name\">\n          {{ serviceCenterDetails.address?.cityName?.toLowerCase() }}</span\n        >, {{ addressLastPart }}\n      </a>\n    </div>\n  </div>\n  <div>\n    <div class=\"serviceCenterInfo-infoContainer\">\n      <div class=\"box\">{{ SicLabelsEnum.CustService }}</div>\n      <div class=\"serviceCenterInfo-info\">\n        {{ serviceCenterDetails.customerServicePhoneNumber }}\n      </div>\n    </div>\n    <div class=\"serviceCenterInfo-infoContainer\">\n      <div class=\"box\">{{ SicLabelsEnum.TollFree }}</div>\n      <div class=\"serviceCenterInfo-info\">\n        {{ serviceCenterDetails.tollFreePhoneNumber }}\n      </div>\n    </div>\n    <div class=\"serviceCenterInfo-infoContainer\">\n      <div class=\"box\">{{ SicLabelsEnum.Fax }}</div>\n      <div class=\"serviceCenterInfo-info\">\n        {{ serviceCenterDetails.faxNumber }}\n      </div>\n      <div class=\"transit-map\"><a (click)=\"openTransitTimeMap()\">Transit Time Map</a></div>\n    </div>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}.serviceCenterDetails{display:flex;justify-content:center}.serviceCenterDetails-container{width:100%}.serviceCenterDetails-busy-loader__spinner{position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%,-50%);width:100px;height:100px}.service-center-panel{min-height:300px}.serviceCenterInfo{display:flex;flex-direction:column;padding:16px;margin-bottom:16px;background-color:#f6f6f6}.serviceCenterInfo .transit-map{display:flex;align-items:flex-end;flex-direction:column;width:200px;flex-grow:1}.serviceCenterInfo .transit-map a{cursor:pointer}.serviceCenterInfo-titleContainer{height:32px;font-size:1.428rem;font-weight:500;box-shadow:inset 0 -1px 0 #d8d8d8;margin-top:16px;margin-bottom:16px}.serviceCenterInfo-info{font-weight:400}.serviceCenterInfo-info__city{font-size:20px}.serviceCenterInfo-info__city__name{text-transform:capitalize}.serviceCenterInfo-info__sc-heading{font-size:14px;color:#bdbdbd}.serviceCenterInfo-info__address{font-size:14px}.serviceCenterInfo .strong{font-weight:500}.serviceCenterInfo-infoContainer{display:flex;font-weight:400;font-size:12px}.serviceCenterInfo-infoContainer .box{min-width:144px;font-weight:500;color:#212121}"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicInfoComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-service-center-info',
                    templateUrl: './service-center-info.component.html',
                    styleUrls: ['./service-center-info.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlWindowService }]; }, propDecorators: { serviceCenter: [{
                type: Input
            }] } });

class XpoLtlSicWeatherComponent {
    constructor() {
        this.ExtUrls = ExtUrls;
        this.SicLabelsEnum = SicLabelsEnum;
        this.forecastUrl = ExtUrls.ForecastUrl;
    }
    set serviceCenter(serviceCenter) {
        if (serviceCenter) {
            this.sicDetails = serviceCenter;
        }
    }
    ngOnInit() {
        this.initUrls();
    }
    initUrls() {
        var _a, _b;
        this.forecastUrl = `${this.forecastUrl}${(_b = (_a = this.sicDetails) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.postalCd}`;
    }
}
XpoLtlSicWeatherComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicWeatherComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
XpoLtlSicWeatherComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlSicWeatherComponent, selector: "xpo-ltl-service-center-weather", inputs: { serviceCenter: "serviceCenter" }, ngImport: i0, template: "<div class=\"serviceCenterWeather\" *ngIf=\"sicDetails\">\n  <div>\n    <div class=\"serviceCenterWeather-titleContainer\">\n      {{ SicLabelsEnum.SicWeather }}\n    </div>\n  </div>\n  <div>\n    <div class=\"serviceCenterWeather-dataContainer\">\n      <div class=\"serviceCenterWeather-dataContainer__city-name\">\n        {{ sicDetails?.address?.cityName | lowercase }}\n      </div>\n      <p class=\"serviceCenterWeather-dataContainer__info\">\n        <xpo-icon iconName=\"info\"></xpo-icon> <span> {{ SicLabelsEnum.UseLinks }}</span>\n      </p>\n      <div class=\"serviceCenterWeather-linksContainer\">\n        <a id=\"freeze-area-link\" class=\"cursor-pointer\" href=\"{{ ExtUrls.ServiceMapUrl }}\" target=\"_blank\">\n          {{ SicLabelsEnum.FreezAreaMap }}</a\n        >\n        <a id=\"weather-link\" class=\"cursor-pointer\" href=\"{{ ExtUrls.WeatherServicesUrl }}\" target=\"_blank\">{{\n          SicLabelsEnum.SevereWeatherInfo\n        }}</a>\n        <a id=\"forecast-link\" class=\"cursor-pointer\" href=\"{{ forecastUrl }}\" target=\"_blank\">\n          {{ SicLabelsEnum.WeatherForeCast }}\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".flex--stretch{flex:1}.serviceCenterDetails{display:flex;justify-content:center}.serviceCenterDetails-container{width:100%}.serviceCenterDetails-busy-loader__spinner{position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%,-50%);width:100px;height:100px}.service-center-panel{min-height:300px}.serviceCenterWeather-titleContainer{height:32px;font-size:1.428rem;font-weight:500;box-shadow:inset 0 -1px 0 #d8d8d8;margin-top:16px;margin-bottom:16px}.serviceCenterWeather-dataContainer__info{font-size:12px;color:#6f6f6f;font-style:italic;display:flex;align-items:center}.serviceCenterWeather-dataContainer__city-name{text-transform:capitalize;font-weight:500;font-size:16px}.serviceCenterWeather-linksContainer{display:flex;flex-direction:column;margin-top:16px}.serviceCenterWeather-linksContainer a{font-size:14px}"], components: [{ type: i1$7.XpoIcon, selector: "xpo-icon", inputs: ["iconName"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "lowercase": i5.LowerCasePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicWeatherComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-service-center-weather',
                    templateUrl: './service-center-weather.component.html',
                    styleUrls: ['./service-center-weather.component.scss'],
                }]
        }], propDecorators: { serviceCenter: [{
                type: Input
            }] } });

class XpoLtlSicDetailsComponent {
    constructor(serviceCenterService) {
        this.serviceCenterService = serviceCenterService;
    }
    set sicCodeValue(sicCode) {
        if (!!sicCode) {
            this.serviceCenterService.getCustomerServiceCenterDetails(sicCode, null);
        }
    }
    ngOnInit() {
        this.serviceCenterDetails$ = this.serviceCenterService.serviceCenterDetails$;
    }
    ngOnDestroy() {
        this.serviceCenterService.serviceCenterDetails = undefined;
        this.serviceCenterService.sicError = false;
    }
}
XpoLtlSicDetailsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicDetailsComponent, deps: [{ token: ServiceCenterService }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlSicDetailsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlSicDetailsComponent, selector: "xpo-ltl-service-center-details", inputs: { sicCodeValue: "sicCodeValue" }, ngImport: i0, template: "<div class=\"service-center-panel\">\n<div *ngIf=\"(serviceCenterDetails$ | async) as serviceCenter; else isLoading\">\n<xpo-ltl-service-center-info [serviceCenter]=\"serviceCenter\">\n</xpo-ltl-service-center-info>\n<div class=\"serviceCenterDetails\">\n  <div class=\"serviceCenterDetails-container\">\n    <div class=\"serviceCenterDetails-navsContainer\">\n      <mat-tab-group xpoAlternateTabs>\n        <mat-tab label=\"Contact\">\n          <xpo-ltl-service-center-contacts [serviceCenter]=\"serviceCenter\">\n          </xpo-ltl-service-center-contacts>\n        </mat-tab>\n        <mat-tab label=\"Weather\">\n          <xpo-ltl-service-center-weather [serviceCenter]=\"serviceCenter\">\n          </xpo-ltl-service-center-weather>\n        </mat-tab>\n        <mat-tab label=\"Find Another\">\n          <xpo-ltl-service-center-find></xpo-ltl-service-center-find>\n        </mat-tab>\n      </mat-tab-group>\n    </div>\n  </div>\n</div>\n</div>\n<ng-template #isLoading>\n  <div class=\"serviceCenterDetails-busy-loader\">\n    <div class=\"serviceCenterDetails-busy-loader__spinner\"><xpo-busy-loader></xpo-busy-loader></div>\n  </div>\n</ng-template>\n</div>", styles: [".flex--stretch{flex:1}.serviceCenterDetails{display:flex;justify-content:center}.serviceCenterDetails-container{width:100%}.serviceCenterDetails-busy-loader__spinner{position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%,-50%);width:100px;height:100px}.service-center-panel{min-height:300px}"], components: [{ type: XpoLtlSicInfoComponent, selector: "xpo-ltl-service-center-info", inputs: ["serviceCenter"] }, { type: i2$9.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { type: i2$9.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby"], exportAs: ["matTab"] }, { type: XpoSicContactsComponent, selector: "xpo-ltl-service-center-contacts", inputs: ["serviceCenter"] }, { type: XpoLtlSicWeatherComponent, selector: "xpo-ltl-service-center-weather", inputs: ["serviceCenter"] }, { type: XpoLtlSicFindComponent, selector: "xpo-ltl-service-center-find" }, { type: i7$2.XpoBusyLoader, selector: "xpo-busy-loader", inputs: ["slow"] }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i9$1.XpoAlternateTabsDirective, selector: "[xpo-alternate-tabs], [xpoAlternateTabs]" }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicDetailsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-service-center-details',
                    templateUrl: './service-center-details.component.html',
                    styleUrls: ['./service-center-details.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: ServiceCenterService }]; }, propDecorators: { sicCodeValue: [{
                type: Input
            }] } });

const materialModules = [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    XpoTabsModule,
    XpoCardModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatAutocompleteModule,
    XpoSnackBarModule,
    XpoTabsModule,
    MatDialogModule,
    XpoDialogModule,
    MatProgressSpinnerModule,
    XpoBusyLoaderModule,
    XpoIconModule,
    XpoSelectModule,
];
class UiComponentsModule {
}
UiComponentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UiComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
UiComponentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UiComponentsModule, imports: [MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatSelectModule,
        XpoTabsModule,
        XpoCardModule,
        MatTableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatAutocompleteModule,
        XpoSnackBarModule,
        XpoTabsModule,
        MatDialogModule,
        XpoDialogModule,
        MatProgressSpinnerModule,
        XpoBusyLoaderModule,
        XpoIconModule,
        XpoSelectModule], exports: [MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatSelectModule,
        XpoTabsModule,
        XpoCardModule,
        MatTableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatAutocompleteModule,
        XpoSnackBarModule,
        XpoTabsModule,
        MatDialogModule,
        XpoDialogModule,
        MatProgressSpinnerModule,
        XpoBusyLoaderModule,
        XpoIconModule,
        XpoSelectModule] });
UiComponentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UiComponentsModule, imports: [[...materialModules], MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatSelectModule,
        XpoTabsModule,
        XpoCardModule,
        MatTableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        MatAutocompleteModule,
        XpoSnackBarModule,
        XpoTabsModule,
        MatDialogModule,
        XpoDialogModule,
        MatProgressSpinnerModule,
        XpoBusyLoaderModule,
        XpoIconModule,
        XpoSelectModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: UiComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...materialModules],
                    exports: [...materialModules],
                }]
        }] });

class XpoLtlSicData {
}

class XpoLtlSicDialogComponent {
    constructor(data, dialogRef, serviceCenterService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.serviceCenterService = serviceCenterService;
        this.unsubscriber = new Unsubscriber();
        this.sicCode = data.sicCd;
    }
    onCloseClicked() {
        this.dialogRef.close();
    }
    ngOnInit() {
        this.initWatchers();
    }
    initWatchers() {
        this.serviceCenterDetails$ = this.serviceCenterService.serviceCenterDetails$;
        this.serviceCenterService.sicError$.pipe(takeUntil(this.unsubscriber.done$)).subscribe((error) => {
            if (error) {
                this.onCloseClicked();
            }
        });
    }
    ngOnDestroy() {
        this.unsubscriber.complete();
    }
}
XpoLtlSicDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicDialogComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$1.MatDialogRef }, { token: ServiceCenterService }], target: i0.ɵɵFactoryTarget.Component });
XpoLtlSicDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: XpoLtlSicDialogComponent, selector: "xpo-ltl-service-center-dialog", ngImport: i0, template: "<div xpoDialog>\n  <h1 mat-dialog-title>\n    {{(serviceCenterDetails$ | async)?.sicCode}} Service Center Details\n    <xpo-dialog-close-button></xpo-dialog-close-button>\n  </h1>\n\n  <div mat-dialog-content>\n    <xpo-ltl-service-center-details [sicCodeValue]=\"sicCode\"></xpo-ltl-service-center-details>\n  </div>\n\n  <div mat-dialog-actions>\n    <button mat-flat-button xpoLargeButton xpoButton (click)=\"onCloseClicked()\">Close</button>\n  </div>\n</div>", styles: [""], components: [{ type: i3.XpoDialogCloseButtonComponent, selector: "xpo-dialog-close-button" }, { type: XpoLtlSicDetailsComponent, selector: "xpo-ltl-service-center-details", inputs: ["sicCodeValue"] }, { type: i2$5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i3.XpoDialogDirective, selector: "[xpo-dialog], [xpoDialog]" }, { type: i1$1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i1$1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i1$1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }], pipes: { "async": i5.AsyncPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-service-center-dialog',
                    templateUrl: './service-center-dialog.component.html',
                    styleUrls: ['./service-center-dialog.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: XpoLtlSicData, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$1.MatDialogRef }, { type: ServiceCenterService }]; } });

class XpoLtlServiceCenterModule {
}
XpoLtlServiceCenterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlServiceCenterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlServiceCenterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlServiceCenterModule, declarations: [XpoLtlSicFindComponent,
        XpoLtlSicDetailsComponent,
        XpoLtlSicInfoComponent,
        XpoSicContactsComponent,
        XpoLtlSicWeatherComponent,
        XpoLtlSicDialogComponent], imports: [CommonModule, FormsModule, ReactiveFormsModule, UiComponentsModule], exports: [XpoLtlSicDetailsComponent, XpoLtlSicDialogComponent] });
XpoLtlServiceCenterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlServiceCenterModule, imports: [[CommonModule, FormsModule, ReactiveFormsModule, UiComponentsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlServiceCenterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        XpoLtlSicFindComponent,
                        XpoLtlSicDetailsComponent,
                        XpoLtlSicInfoComponent,
                        XpoSicContactsComponent,
                        XpoLtlSicWeatherComponent,
                        XpoLtlSicDialogComponent,
                    ],
                    imports: [CommonModule, FormsModule, ReactiveFormsModule, UiComponentsModule],
                    exports: [XpoLtlSicDetailsComponent, XpoLtlSicDialogComponent],
                    entryComponents: [XpoLtlSicDialogComponent, XpoLtlSicDetailsComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class XpoLtlSicDialogService {
    constructor(dialog) {
        this.dialog = dialog;
        this.unsubscriber = new Unsubscriber();
    }
    openServiceCenterDialog(dialogData) {
        let dialogRef;
        const subject = new Subject();
        dialogRef = this.dialog.open(XpoLtlSicDialogComponent, {
            data: dialogData,
            width: '650px',
            disableClose: false,
            hasBackdrop: true,
            restoreFocus: false,
        });
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this.unsubscriber.done$), take(1))
            .subscribe(() => {
            subject.next();
            subject.complete();
        });
        return subject.asObservable();
    }
}
XpoLtlSicDialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicDialogService, deps: [{ token: i1$1.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
XpoLtlSicDialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicDialogService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlSicDialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatDialog }]; } });

var SicSource;
(function (SicSource) {
    SicSource["ShipmentGrid"] = "shipmentGrid";
    SicSource["ShipmentDetails"] = "ShipmentDetails";
})(SicSource || (SicSource = {}));

var Weekday;
(function (Weekday) {
    Weekday["MONDAY"] = "monday";
    Weekday["TUESDAY"] = "tuesday";
    Weekday["WEDNESDAY"] = "wednesday";
    Weekday["THURSDAY"] = "thursday";
    Weekday["FRIDAY"] = "friday";
    Weekday["SATURDAY"] = "saturday";
    Weekday["SUNDAY"] = "sunday";
})(Weekday || (Weekday = {}));

const WEEKDAYS = [
    Weekday.MONDAY,
    Weekday.TUESDAY,
    Weekday.WEDNESDAY,
    Weekday.THURSDAY,
    Weekday.FRIDAY,
    Weekday.SATURDAY,
    Weekday.SUNDAY,
];
class WeekdayUtility {
    static getWeekdays(input) {
        if (Array.isArray(input)) {
            return Array.from(input).filter((day) => WEEKDAYS.includes(day));
        }
        const days = [];
        WEEKDAYS.forEach((weekday) => {
            if (!!input[weekday]) {
                days.push(weekday);
            }
        });
        return days;
    }
    static convertWeekdaysToObject(weekdays) {
        const weekdayObj = {};
        WEEKDAYS.forEach((weekday) => {
            !!weekdays.includes(weekday) ? (weekdayObj[weekday] = true) : (weekdayObj[weekday] = false);
        });
        return weekdayObj;
    }
}

class WeekdaySelectorComponent {
    constructor(ngControl) {
        // size:
        this.size = 'normal';
        // theme: color scheme
        this.theme = 'normal';
        // daysAllowed: it allows to make only specific days enabled for edit
        this.daysAllowed = 'all';
        this.weekdayControl = new FormControl();
        // value = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
        this.weekdays = [];
        this.weekdayOptions = [];
        this.touched = false;
        this.disabled = false;
        this.onChange = (weekdays) => { };
        this.onTouched = () => { };
        if (ngControl !== null) {
            ngControl.valueAccessor = this;
        }
    }
    ngOnInit() {
        this.initialiseWekkdayOptions();
    }
    initialiseWekkdayOptions() {
        const weekdayOptions = [];
        // generating day options for weekday selector
        WEEKDAYS.forEach((weekday) => weekdayOptions.push({
            disabled: false,
            key: weekday[0].toUpperCase(),
            value: weekday,
        }));
        switch (this.daysAllowed) {
            case 'weekday':
                // index 5 & 6 are weekend
                weekdayOptions[5].disabled = true;
                weekdayOptions[6].disabled = true;
                break;
            case 'weekend':
                weekdayOptions[0].disabled = true;
                weekdayOptions[1].disabled = true;
                weekdayOptions[2].disabled = true;
                weekdayOptions[3].disabled = true;
                weekdayOptions[4].disabled = true;
                break;
        }
        this.weekdayOptions = [...weekdayOptions];
    }
    writeValue(days) {
        this.weekdays = days;
        this.weekdayControl.patchValue(days);
    }
    registerOnChange(onChange) {
        this.onChange = onChange;
    }
    registerOnTouched(onTouched) {
        this.onTouched = onTouched;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        !!isDisabled ? this.weekdayControl.disable() : this.weekdayControl.enable();
    }
    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }
    change(weekdays) {
        this.markAsTouched();
        if (!this.disabled) {
            this.weekdays = weekdays;
            this.onChange(weekdays);
        }
    }
}
WeekdaySelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: WeekdaySelectorComponent, deps: [{ token: i2$2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
WeekdaySelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: WeekdaySelectorComponent, selector: "xpo-ltl-weekday-selector", inputs: { size: "size", theme: "theme", daysAllowed: "daysAllowed" }, ngImport: i0, template: "<div\n  class=\"xpoLtlWeekdaySelector\"\n  [ngClass]=\"{\n    'size-small': size === 'small',\n    'size-large': size === 'large',\n    'theme-grey': theme === 'grey'\n  }\"\n>\n  <mat-button-toggle-group\n    multiple=\"true\"\n    appearance=\"standard\"\n    [formControl]=\"weekdayControl\"\n    (change)=\"change(weekdayControl.value)\"\n  >\n    <mat-button-toggle\n      mat-stroked-button\n      *ngFor=\"let weekdayOption of weekdayOptions\"\n      [disabled]=\"weekdayOption.disabled\"\n      [value]=\"weekdayOption.value\"\n    >\n      {{ weekdayOption.key }}\n    </mat-button-toggle>\n  </mat-button-toggle-group>\n</div>\n", styles: [".flex--stretch{flex:1}.xpoLtlWeekdaySelector .mat-button-toggle-group.mat-button-toggle-group-appearance-standard .mat-button-toggle{border-radius:50%;width:40px;height:40px;padding:0;line-height:40px;margin-right:8px;border-width:2px;border-style:solid;font-size:16px}.xpoLtlWeekdaySelector .mat-button-toggle-group.mat-button-toggle-group-appearance-standard .mat-button-toggle.mat-button-toggle-checked{border:none}.xpoLtlWeekdaySelector .mat-button-toggle-group.mat-button-toggle-group-appearance-standard .mat-button-toggle .mat-button-toggle-button{display:flex;place-content:center;align-items:center;font-size:inherit}.xpoLtlWeekdaySelector .mat-button-toggle-group.mat-button-toggle-group-appearance-standard .mat-button-toggle .mat-button-toggle-button>.mat-button-toggle-label-content{padding:0;line-height:normal}.xpoLtlWeekdaySelector.size-small .mat-button-toggle-group.mat-button-toggle-group-appearance-standard{height:32px}.xpoLtlWeekdaySelector.size-small .mat-button-toggle-group.mat-button-toggle-group-appearance-standard .mat-button-toggle{width:32px;height:32px;line-height:32px;font-size:1rem;border-width:1px}.xpoLtlWeekdaySelector.size-large .mat-button-toggle-group.mat-button-toggle-group-appearance-standard{height:56px}.xpoLtlWeekdaySelector.size-large .mat-button-toggle-group.mat-button-toggle-group-appearance-standard .mat-button-toggle{width:56px;height:56px;line-height:56px;font-size:1.285rem;border-width:2px}.xpoLtlWeekdaySelector.theme-grey .mat-button-toggle:not(.mat-button-toggle-disabled){background-color:#fbfbfb;border-color:#d8d8d8;color:#171717}.xpoLtlWeekdaySelector.theme-grey .mat-button-toggle:not(.mat-button-toggle-disabled):hover{border-color:#171717}.xpoLtlWeekdaySelector.theme-grey .mat-button-toggle:not(.mat-button-toggle-disabled).mat-button-toggle-checked{background-color:#171717;color:#fff}.xpoLtlWeekdaySelector .mat-button-toggle-disabled{background-color:#f6f6f6;border-color:#d8d8d8;color:#d8d8d8}.xpoLtlWeekdaySelector .mat-button-toggle-disabled.mat-button-toggle-checked{background-color:#bdbdbd;color:#fff}"], components: [{ type: i2$a.MatButtonToggle, selector: "mat-button-toggle", inputs: ["disableRipple", "aria-labelledby", "tabIndex", "appearance", "checked", "disabled", "id", "name", "aria-label", "value"], outputs: ["change"], exportAs: ["matButtonToggle"] }], directives: [{ type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2$a.MatButtonToggleGroup, selector: "mat-button-toggle-group", inputs: ["appearance", "name", "vertical", "value", "multiple", "disabled"], outputs: ["valueChange", "change"], exportAs: ["matButtonToggleGroup"] }, { type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2$2.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: WeekdaySelectorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'xpo-ltl-weekday-selector',
                    templateUrl: './weekday-selector.component.html',
                    styleUrls: ['./weekday-selector.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: i2$2.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }]; }, propDecorators: { size: [{
                type: Input
            }], theme: [{
                type: Input
            }], daysAllowed: [{
                type: Input
            }] } });

class XpoLtlWeekdaySelectorModule {
}
XpoLtlWeekdaySelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlWeekdaySelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
XpoLtlWeekdaySelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlWeekdaySelectorModule, declarations: [WeekdaySelectorComponent], imports: [CommonModule, MatButtonToggleModule, FormsModule, ReactiveFormsModule], exports: [WeekdaySelectorComponent] });
XpoLtlWeekdaySelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlWeekdaySelectorModule, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: WeekdaySelectorComponent,
            multi: true,
        },
    ], imports: [[CommonModule, MatButtonToggleModule, FormsModule, ReactiveFormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: XpoLtlWeekdaySelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [WeekdaySelectorComponent],
                    imports: [CommonModule, MatButtonToggleModule, FormsModule, ReactiveFormsModule],
                    exports: [WeekdaySelectorComponent],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: WeekdaySelectorComponent,
                            multi: true,
                        },
                    ],
                }]
        }] });

/*
 * Public API Surface of ngx-ltl
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ActionIconCellRendererComponent, AsWordsPipe, AttemptReasonCdPipe, BillClassPipe, BrowserGuard, CamelCaseToHyphenPipe, ChargeToCdPipe, ClaimInternalStatusCdPipe, CommodityClassCdPipe, CurrencyCodePipe, DeliveryQualifierCdPipe, DeliveryQualifierReasonCdPipe, DisableGroupCellRenderer, DockCopyPrintComponent, DocumentCategory, DocumentDetails, DocumentsStatusGridComponent, EmployeeNamePipe, EmptyCurrencyPipe, EmptyValuePipe, EnumToArrayPipe, EquipmentPipe, ExemptReasonCdPipe, FBDSDocType, FBDSDocumentType, FbdsPrintComponent, FormStatus, FormUtils, GlobalSearchLocalStorageDataType, GlobalSearchResponseTypePipe, HandlingUnitTypeCdPipe, InvoiceTypeCdPipe, MillisToDaysPipe, MiscLineItemPaymentMethodCdPipe, MomentDatePipe, MovementExceptionTypePipe, MovementStatusPipe, NegativeCurrencyParensPipe, PastPresentFuturePipe, PhoneFormatterDirective, PhoneNumberPipe, PluralPipe, PrintShipmentComponent, PrintShipmentsComponent, PrintSource, ProFormatterPipe, RefusedReasonCdPipe, ReturnReasonCdPipe, RoundPipe, SafeHtmlPipe, SentenceCasePipe, ShipmentDetailsDetailsComponent, ShipmentInfo, ShipmentListSpecialServCellRendererComponent, ShipmentPnDStatusPipe, ShipmentReferenceService, ShipmentSpecialServiceCdPipe, ShipmentTrackingTrailerComponent, SicDatePipe, SicSource, SpecialServComponent, StageShipmentButtonMap, StageShipmentComponent, StageShipmentDataSource, StageShipmentModule, StageShipmentPanelComponent, StageShipmentPanelType, ToRegexPipe, UndeliveredReasonCdPipe, Unsubscriber, UpdateShipmentStatusCdPipe, UpdateShipmentStatusDeliveryQualifierReasonCdPipe, WEEKDAYS, Weekday, WeekdaySelectorComponent, WeekdayUtility, XpoAllowCharactersDirective, XpoAllowCharactersModule, XpoBrowserGuardModule, XpoEventKeyCode, XpoLtlAppSwitcherService, XpoLtlBaseCacheService, XpoLtlBrowserCacheService, XpoLtlConditioningService, XpoLtlCustomPdfViewerComponent, XpoLtlCustomPdfViewerModule, XpoLtlDateSelectorComponent, XpoLtlDateSelectorModule, XpoLtlDialogTitleComponent, XpoLtlDialogTitleModule, XpoLtlDialogTitleService, XpoLtlDmsUtilsModule, XpoLtlDmsUtilsRoutingModule, XpoLtlDocType, XpoLtlDocTypePipe, XpoLtlDocViewPageComponent, XpoLtlDocumentSelectorComponent, XpoLtlDocumentService, XpoLtlDocumentViewerComponent, XpoLtlDocumentViewerDialogComponent, XpoLtlDynamicValidator, XpoLtlEmailService, XpoLtlEmployeeDetailsCacheService, XpoLtlEnvironmentAndRoleGuard, XpoLtlEnvironmentAndRoleGuardModule, XpoLtlFeaturesService, XpoLtlFeedbackService, XpoLtlFormatValidationService, XpoLtlGlobalSearchComponent, XpoLtlGlobalSearchModule, XpoLtlIdleTimeoutService, XpoLtlLocationDetailsCacheService, XpoLtlLoggedInUserService, XpoLtlPdfViewerComponent, XpoLtlPipeModule, XpoLtlPrintComponent, XpoLtlPrintData, XpoLtlPrintDialogComponent, XpoLtlPrintDialogService, XpoLtlPrintDocType, XpoLtlPrintModule, XpoLtlReleaseNotesComponent, XpoLtlReleaseNotesModule, XpoLtlReleaseNotesService, XpoLtlRoleSwitcherComponent, XpoLtlRoleSwitcherModule, XpoLtlRoleSwitcherService, XpoLtlServiceCenterModule, XpoLtlServiceCentersService, XpoLtlShipmentDetailsComponent, XpoLtlShipmentDetailsDialogComponent, XpoLtlShipmentDetailsModule, XpoLtlShipmentDetailsService, XpoLtlShipmentDetailsTabs, XpoLtlShipmentSelectorComponent, XpoLtlShipmentTrackingTrailerDialogComponent, XpoLtlShipmentTrackingTrailerModule, XpoLtlSicData, XpoLtlSicDetailsComponent, XpoLtlSicDialogComponent, XpoLtlSicDialogService, XpoLtlSicSwitcherComponent, XpoLtlSicSwitcherLabelOptions, XpoLtlSicSwitcherModule, XpoLtlSicValidatorFunction, XpoLtlTimeService, XpoLtlUpdateShipmentComponent, XpoLtlUpdateShipmentStatusComponent, XpoLtlUpdateShipmentStatusDialogService, XpoLtlUpdateShipmentStatusModule, XpoLtlUserPreferencesService, XpoLtlValidationRegexPatterns, XpoLtlWeekdaySelectorModule, XpoLtlWindowService, XpoMaxNumberLengthDirective, XpoMaxNumberLengthModule, XpoPhoneFormatterModule, XpoPreventCharactersDirective, XpoPreventCharactersModule, XpoUppercaseDirective, XpoUppercaseModule, YesNoEnum, frameworkComponents$1 as frameworkComponents, isSicValidFunction, phoneValidator };
